var a0 = Object.defineProperty;
var l0 = (e, n, t) => n in e ? a0(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var Ee = (e, n, t) => (l0(e, typeof n != "symbol" ? n + "" : n, t), t);
import * as du from "vue";
import { defineComponent as re, ref as X, openBlock as _, createElementBlock as P, normalizeClass as pe, normalizeStyle as Ye, Fragment as me, createElementVNode as M, createCommentVNode as z, computed as ee, createVNode as ce, toDisplayString as de, resolveComponent as e1, resolveDirective as ns, renderList as Fe, withDirectives as po, createBlock as ie, resolveDynamicComponent as Uo, withCtx as J, renderSlot as be, createTextVNode as Ie, createStaticVNode as Xo, pushScopeId as ua, popScopeId as da, h as wt, getCurrentInstance as yn, inject as eo, onMounted as Ge, onUnmounted as to, watch as Ne, Text as s0, unref as I, withModifiers as Yn, nextTick as He, getCurrentScope as os, onScopeDispose as is, reactive as ki, withKeys as pn, cloneVNode as t1, provide as $o, watchEffect as ct, toRaw as je, isRef as u0, Transition as d0, version as c0, shallowRef as ca, isProxy as n1, shallowReadonly as Ao, Comment as o1, mergeProps as ze, toRefs as on, normalizeProps as Ui, guardReactiveProps as fa, markRaw as f0, watchSyncEffect as h0, vShow as i1, toHandlers as g0, effectScope as r1, readonly as a1, toHandlerKey as m0, camelize as l1, Teleport as p0, useSlots as v0, toRef as b0, mergeDefaults as y0, watchPostEffect as C0, customRef as x0, onBeforeUnmount as w0, onBeforeMount as $0, vModelText as k0 } from "vue";
const _0 = [
  "alert-circle",
  "alert-triangle",
  "align-right",
  "archive",
  "arrow-circle-broken-right",
  "arrow-down",
  "arrow-down-right",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "arrow-up-right",
  "award",
  "bell",
  "bookmark",
  "calendar",
  "check",
  "check-circle",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "chevron-selector-vertical",
  "clipboard",
  "clock",
  "close",
  "close-circle",
  "code-01",
  "copy",
  "database",
  "dataflow",
  "download",
  "edit",
  "edit-02",
  "equal",
  "eye",
  "file-attachment",
  "file-check",
  "file-text",
  "file-plus",
  "file-upload",
  "flag",
  "gift",
  "help-circle",
  "hourglass",
  "image",
  "inbox",
  "info",
  "layers",
  "link",
  "lightbulb",
  "loading",
  "log-out",
  "mail",
  "menu",
  "message-circle",
  "message-circle-02",
  "minus",
  "monitor",
  "more-horizontal",
  "more-vertical",
  "paperclip",
  "passport",
  "pause",
  "phone",
  "plus",
  "qr-code",
  "refresh-cw",
  "search",
  "settings",
  "share",
  "slash",
  "slash-divider",
  "slider",
  "star",
  "star-02",
  "tag",
  "toggle",
  "trash",
  "upload",
  "user",
  "user-right",
  "users",
  "users-plus",
  "graduation-hat",
  "globe",
  "pie-chart",
  "briefcase",
  "marker-pin",
  "drag-drop",
  "widget-br",
  "flex-align-top",
  "image-user",
  "grid-03",
  "widget-bl",
  "widget-tr",
  "widget-tl",
  "flex-align-bottom",
  "phone-01",
  "save",
  "palette",
  "home",
  "puzzle-piece",
  "heart-hand"
], O0 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, E0 = ["stroke"], M0 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S0 = { "clip-path": "url(#clip0_1149_4076)" }, A0 = ["stroke"], T0 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1149_4076" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), P0 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I0 = { "clip-path": "url(#clip0_216_1715)" }, D0 = ["stroke"], L0 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_216_1715" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), N0 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F0 = ["stroke"], R0 = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, B0 = ["stroke"], V0 = {
  key: 3,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j0 = ["stroke"], H0 = {
  key: 4,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z0 = { "clip-path": "url(#clip0_1284_4541)" }, q0 = ["stroke"], U0 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1284_4541" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), W0 = {
  key: 5,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K0 = ["stroke"], Y0 = {
  key: 6,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G0 = ["stroke"], Z0 = {
  key: 7,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X0 = ["stroke"], J0 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q0 = ["stroke"], e3 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t3 = ["stroke"], n3 = {
  key: 9,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o3 = ["stroke"], i3 = {
  key: 10,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r3 = ["stroke"], a3 = {
  key: 11,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, l3 = ["stroke"], s3 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, u3 = { "clip-path": "url(#clip0_216_1635)" }, d3 = ["stroke"], c3 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_216_1635" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), f3 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, h3 = ["stroke"], g3 = {
  key: 13,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m3 = ["stroke"], p3 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v3 = { "clip-path": "url(#clip0_420_4795)" }, b3 = ["stroke"], y3 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_420_4795" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), C3 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x3 = ["stroke"], w3 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $3 = ["stroke"], k3 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _3 = ["stroke"], O3 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, E3 = { "clip-path": "url(#clip0_216_305)" }, M3 = ["stroke"], S3 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_216_305" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), A3 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T3 = ["stroke"], P3 = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I3 = { "clip-path": "url(#clip0_29_265)" }, D3 = ["stroke"], L3 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_29_265" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), N3 = {
  key: 17,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F3 = ["stroke"], R3 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, B3 = ["stroke"], V3 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j3 = ["stroke"], H3 = {
  key: 19,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z3 = ["stroke"], q3 = {
  key: 20,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U3 = ["stroke"], W3 = {
  key: 21,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K3 = ["stroke"], Y3 = {
  key: 22,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, G3 = ["stroke"], Z3 = {
  key: 23,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, X3 = { "clip-path": "url(#clip0_14_151)" }, J3 = ["stroke"], Q3 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_14_151" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), e2 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, t2 = ["stroke"], n2 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, o2 = ["stroke"], i2 = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r2 = ["stroke"], a2 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, l2 = { "clip-path": "url(#clip0_623_6932)" }, s2 = ["stroke"], u2 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_623_6932" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), d2 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, c2 = { "clip-path": "url(#clip0_1278_4537)" }, f2 = ["stroke"], h2 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1278_4537" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), g2 = {
  key: 26,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, m2 = ["stroke"], p2 = {
  key: 27,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, v2 = { "clip-path": "url(#clip0_1028_3519)" }, b2 = ["stroke"], y2 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1028_3519" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), C2 = {
  key: 28,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, x2 = ["stroke"], w2 = {
  key: 29,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $2 = ["stroke"], k2 = {
  key: 30,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _2 = ["stroke"], O2 = {
  key: 31,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, E2 = ["stroke"], M2 = {
  key: 32,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S2 = { "clip-path": "url(#clip0_935_3470)" }, A2 = ["stroke"], T2 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_935_3470" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), P2 = {
  key: 33,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I2 = ["stroke"], D2 = {
  key: 34,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L2 = ["stroke"], N2 = ["stroke"], F2 = {
  key: 35,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, R2 = ["stroke"], B2 = {
  key: 36,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V2 = ["stroke"], j2 = {
  key: 37,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H2 = ["stroke"], z2 = {
  key: 38,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q2 = ["stroke"], U2 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W2 = ["stroke"], K2 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y2 = ["stroke"], G2 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z2 = ["stroke"], X2 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, J2 = ["stroke"], Q2 = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, e6 = ["stroke"], t6 = {
  key: 41,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, n6 = { "clip-path": "url(#clip0_274_1881)" }, o6 = ["stroke"], i6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_274_1881" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), r6 = {
  key: 42,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, a6 = { "clip-path": "url(#clip0_733_3458)" }, l6 = ["stroke"], s6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_733_3458" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), u6 = {
  key: 43,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d6 = ["stroke"], c6 = {
  key: 44,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, f6 = ["stroke"], h6 = {
  key: 45,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g6 = ["stroke"], m6 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p6 = { "clip-path": "url(#clip0_185_4118)" }, v6 = ["stroke"], b6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_185_4118" }, [
    /* @__PURE__ */ M("rect", {
      width: "14",
      height: "14",
      fill: "white"
    })
  ])
], -1), y6 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, C6 = { "clip-path": "url(#clip0_20_174)" }, x6 = ["stroke"], w6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_20_174" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), $6 = {
  key: 47,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, k6 = { "clip-path": "url(#clip0_289_2100)" }, _6 = ["stroke"], O6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_289_2100" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), E6 = {
  key: 48,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, M6 = { "clip-path": "url(#clip0_31_222)" }, S6 = ["stroke"], A6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_31_222" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), T6 = {
  key: 49,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P6 = { "clip-path": "url(#clip0_2326_100)" }, I6 = ["stroke"], D6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_2326_100" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), L6 = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N6 = { "clip-path": "url(#clip0_623_6937)" }, F6 = ["stroke"], R6 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_623_6937" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), B6 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, V6 = ["stroke"], j6 = {
  key: 51,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, H6 = ["stroke"], z6 = {
  key: 52,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q6 = ["stroke"], U6 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, W6 = ["stroke"], K6 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y6 = ["stroke"], G6 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Z6 = ["stroke"], X6 = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, J6 = ["stroke"], Q6 = {
  key: 55,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eg = { "clip-path": "url(#clip0_376_2459)" }, tg = ["stroke"], ng = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_376_2459" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), og = {
  key: 56,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ig = ["stroke"], rg = {
  key: 57,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ag = ["stroke"], lg = {
  key: 58,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sg = ["stroke"], ug = ["stroke"], dg = ["stroke"], cg = {
  key: 59,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fg = ["stroke"], hg = ["stroke"], gg = ["stroke"], mg = {
  key: 60,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pg = { "clip-path": "url(#clip0_123_362)" }, vg = ["stroke"], bg = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_123_362" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), yg = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cg = ["stroke"], xg = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wg = ["stroke"], $g = {
  key: 62,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kg = { "clip-path": "url(#clip0_1110_3523)" }, _g = ["stroke"], Og = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1110_3523" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Eg = {
  key: 63,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mg = { "clip-path": "url(#clip0_443_3358)" }, Sg = ["stroke"], Ag = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_443_3358" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Tg = {
  key: 0,
  width: "40",
  height: "40",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Pg = ["stroke"], Ig = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Dg = ["stroke"], Lg = {
  key: 65,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ng = ["stroke"], Fg = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Rg = { "clip-path": "url(#clip0_409_7312)" }, Bg = ["stroke"], Vg = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_409_7312" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), jg = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hg = ["stroke"], zg = {
  key: 67,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, qg = ["stroke"], Ug = {
  key: 68,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Wg = { "clip-path": "url(#clip0_193_1263)" }, Kg = ["stroke"], Yg = ["stroke"], Gg = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_193_1263" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Zg = {
  key: 69,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xg = ["stroke"], Jg = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qg = { "clip-path": "url(#clip0_623_6952)" }, em = ["stroke"], tm = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_623_6952" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), nm = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, om = ["stroke"], im = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rm = { "clip-path": "url(#clip0_143_692)" }, am = ["stroke"], lm = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_143_692" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), sm = {
  key: 71,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, um = ["stroke"], dm = {
  key: 72,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cm = { "clip-path": "url(#clip0_320_2117)" }, fm = ["stroke"], hm = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_320_2117" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), gm = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mm = { "clip-path": "url(#clip0_1123_3023)" }, pm = ["stroke"], vm = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1123_3023" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), bm = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ym = ["stroke"], Cm = {
  key: 2,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xm = ["stroke"], wm = {
  key: 74,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $m = { "clip-path": "url(#clip0_1010_3523)" }, km = ["stroke"], _m = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1010_3523" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Om = {
  key: 75,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Em = { "clip-path": "url(#clip0_1380_4541)" }, Mm = ["stroke"], Sm = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_1380_4541" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Am = {
  key: 76,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tm = ["stroke"], Pm = {
  key: 77,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Im = ["stroke"], Dm = {
  key: 78,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lm = { "clip-path": "url(#clip0_339_2098)" }, Nm = ["stroke"], Fm = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_339_2098" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Rm = {
  key: 79,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Bm = ["stroke"], Vm = {
  key: 80,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jm = ["stroke"], Hm = {
  key: 0,
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zm = { "clip-path": "url(#clip0_708_814)" }, qm = ["stroke"], Um = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_708_814" }, [
    /* @__PURE__ */ M("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1), Wm = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Km = { "clip-path": "url(#clip0_143_686)" }, Ym = ["stroke"], Gm = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_143_686" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Zm = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xm = ["stroke"], Jm = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qm = ["stroke"], e4 = {
  key: 83,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, t4 = ["stroke"], n4 = {
  key: 84,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, o4 = ["stroke"], i4 = ["stroke"], r4 = ["stroke"], a4 = ["stroke"], l4 = ["stroke"], s4 = ["stroke"], u4 = {
  key: 85,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, d4 = { "clip-path": "url(#clip0_3046_543)" }, c4 = ["stroke"], f4 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_3046_543" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), h4 = {
  key: 86,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g4 = ["stroke"], m4 = {
  key: 87,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, p4 = ["stroke"], v4 = ["stroke"], b4 = {
  key: 88,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, y4 = { "clip-path": "url(#clip0_3046_554)" }, C4 = ["stroke"], x4 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_3046_554" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), w4 = {
  key: 89,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $4 = ["fill"], k4 = {
  key: 90,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _4 = ["fill"], O4 = {
  key: 91,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, E4 = ["fill"], M4 = {
  key: 92,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, S4 = ["fill"], A4 = {
  key: 93,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, T4 = ["stroke"], P4 = {
  key: 94,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, I4 = ["stroke"], D4 = {
  key: 95,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, L4 = { "clip-path": "url(#clip0_3210_119)" }, N4 = ["stroke"], F4 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_3210_119" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), R4 = {
  key: 96,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, B4 = ["stroke"], V4 = {
  key: 97,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, j4 = ["stroke"], H4 = {
  key: 98,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, z4 = ["stroke"], q4 = {
  key: 99,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, U4 = ["stroke"], W4 = {
  key: 100,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K4 = { "clip-path": "url(#clip0_11_6)" }, Y4 = ["stroke"], G4 = ["stroke"], Z4 = ["stroke"], X4 = ["stroke"], J4 = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_11_6" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), Q4 = {
  key: 101,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ep = { "clip-path": "url(#clip0_3620_119)" }, tp = ["stroke"], np = /* @__PURE__ */ M("defs", null, [
  /* @__PURE__ */ M("clipPath", { id: "clip0_3620_119" }, [
    /* @__PURE__ */ M("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1), op = {
  key: 102,
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ip = ["stroke"], rp = {
  key: 103,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ap = { "clip-path": "url(#clip0_435_288)" }, lp = ["stroke"], sp = { id: "clip0_435_288" }, up = ["fill"], Le = /* @__PURE__ */ re({
  __name: "BaseIcon",
  props: {
    icon: {
      type: String,
      required: !0,
      validator: (e) => _0.includes(e)
    },
    size: {
      type: Number,
      default: void 0
    },
    color: {
      type: String,
      default: void 0
    },
    bgColor: {
      type: String,
      default: void 0
    },
    hoverState: {
      type: Boolean,
      default: !1
    },
    hoverColor: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const n = e, t = X(!1), o = () => {
      n.hoverState && (t.value = !0);
    }, i = () => {
      t.value = !1;
    };
    return (r, a) => (_(), P("div", {
      class: pe([
        "flex items-center justify-center",
        { "cursor-pointer": t.value, "rounded-full p-1.5": e.bgColor }
      ]),
      style: Ye({ backgroundColor: e.bgColor }),
      onMouseenter: o,
      onMouseleave: i
    }, [
      e.icon === "alert-circle" ? (_(), P(me, { key: 0 }, [
        e.size === 24 ? (_(), P("svg", O0, [
          M("path", {
            d: "M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, E0)
        ])) : (_(), P("svg", M0, [
          M("g", S0, [
            M("path", {
              d: "M8 5.33334V8.00001M8 10.6667H8.00667M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8 14.6667C4.3181 14.6667 1.33334 11.6819 1.33334 8.00001C1.33334 4.31811 4.3181 1.33334 8 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, A0)
          ]),
          T0
        ]))
      ], 64)) : z("", !0),
      e.icon === "alert-triangle" ? (_(), P(me, { key: 1 }, [
        e.size === 12 ? (_(), P("svg", P0, [
          M("g", I0, [
            M("path", {
              d: "M5.99989 4.50001V6.50001M5.99989 8.50001H6.00489M5.14489 1.93001L0.909888 9.00001C0.822572 9.15122 0.776372 9.32266 0.775883 9.49727C0.775394 9.67188 0.820634 9.84358 0.907102 9.99527C0.993569 10.147 1.11825 10.2734 1.26874 10.3619C1.41923 10.4505 1.59029 10.4981 1.76489 10.5H10.2349C10.4095 10.4981 10.5805 10.4505 10.731 10.3619C10.8815 10.2734 11.0062 10.147 11.0927 9.99527C11.1791 9.84358 11.2244 9.67188 11.2239 9.49727C11.2234 9.32266 11.1772 9.15122 11.0899 9.00001L6.85489 1.93001C6.76575 1.78306 6.64025 1.66157 6.49049 1.57725C6.34072 1.49293 6.17176 1.44864 5.99989 1.44864C5.82802 1.44864 5.65905 1.49293 5.50929 1.57725C5.35953 1.66157 5.23402 1.78306 5.14489 1.93001Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, D0)
          ]),
          L0
        ])) : (_(), P("svg", N0, [
          M("path", {
            d: "M8 6.00001V8.66668M8 11.3333H8.00667M6.86 2.57335L1.21333 12C1.09691 12.2016 1.03531 12.4302 1.03466 12.663C1.03401 12.8958 1.09433 13.1248 1.20962 13.327C1.32491 13.5293 1.49115 13.6978 1.6918 13.8159C1.89246 13.934 2.12053 13.9975 2.35333 14H13.6467C13.8795 13.9975 14.1075 13.934 14.3082 13.8159C14.5088 13.6978 14.6751 13.5293 14.7904 13.327C14.9057 13.1248 14.966 12.8958 14.9653 12.663C14.9647 12.4302 14.9031 12.2016 14.7867 12L9.14 2.57335C9.02115 2.37742 8.85381 2.21543 8.65413 2.103C8.45444 1.99058 8.22915 1.93152 8 1.93152C7.77084 1.93152 7.54555 1.99058 7.34587 2.103C7.14618 2.21543 6.97885 2.37742 6.86 2.57335Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, F0)
        ]))
      ], 64)) : z("", !0),
      e.icon === "align-right" ? (_(), P("svg", R0, [
        M("path", {
          d: "M14 14V2M2 8H11.3333M11.3333 8L6.66667 3.33333M11.3333 8L6.66667 12.6667",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, B0)
      ])) : z("", !0),
      e.icon === "archive" ? (_(), P("svg", V0, [
        M("path", {
          d: "M2.66667 5.33106C2.55733 5.32824 2.47793 5.32191 2.40655 5.30771C1.87763 5.2025 1.46416 4.78904 1.35896 4.26012C1.33334 4.13132 1.33334 3.97644 1.33334 3.66667C1.33334 3.3569 1.33334 3.20201 1.35896 3.07321C1.46416 2.54429 1.87763 2.13083 2.40655 2.02562C2.53535 2 2.69023 2 3 2H13C13.3098 2 13.4647 2 13.5935 2.02562C14.1224 2.13083 14.5358 2.54429 14.641 3.07321C14.6667 3.20201 14.6667 3.3569 14.6667 3.66667C14.6667 3.97644 14.6667 4.13132 14.641 4.26012C14.5358 4.78904 14.1224 5.2025 13.5935 5.30771C13.5221 5.32191 13.4427 5.32824 13.3333 5.33106M6.66667 8.66667H9.33334M2.66667 5.33333H13.3333V10.8C13.3333 11.9201 13.3333 12.4802 13.1153 12.908C12.9236 13.2843 12.6176 13.5903 12.2413 13.782C11.8135 14 11.2534 14 10.1333 14H5.86667C4.74656 14 4.18651 14 3.75869 13.782C3.38236 13.5903 3.0764 13.2843 2.88466 12.908C2.66667 12.4802 2.66667 11.9201 2.66667 10.8V5.33333Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, j0)
      ])) : z("", !0),
      e.icon === "arrow-circle-broken-right" ? (_(), P("svg", H0, [
        M("g", z0, [
          M("path", {
            d: "M2.22526 4.66668C3.37796 2.67401 5.53244 1.33334 8.00005 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00005 14.6667C5.53244 14.6667 3.37796 13.326 2.22526 11.3333M8 10.6667L10.6667 8.00001M10.6667 8.00001L8 5.33334M10.6667 8.00001H1.33334",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, q0)
        ]),
        U0
      ])) : z("", !0),
      e.icon === "arrow-down" ? (_(), P("svg", W0, [
        M("path", {
          d: "M8 3.33334V12.6667M8 12.6667L12.6667 8.00001M8 12.6667L3.33334 8.00001",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, K0)
      ])) : z("", !0),
      e.icon === "arrow-down-right" ? (_(), P("svg", Y0, [
        M("path", {
          d: "M4.66666 4.66666L11.3333 11.3333M11.3333 11.3333V4.66666M11.3333 11.3333H4.66666",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, G0)
      ])) : z("", !0),
      e.icon === "arrow-left" ? (_(), P("svg", Z0, [
        M("path", {
          d: "M12.6667 7.99998H3.33334M3.33334 7.99998L8 12.6666M3.33334 7.99998L8 3.33331",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, X0)
      ])) : z("", !0),
      e.icon === "arrow-right" ? (_(), P(me, { key: 8 }, [
        e.size === 14 ? (_(), P("svg", J0, [
          M("path", {
            d: "M2.91663 6.99999H11.0833M11.0833 6.99999L6.99996 2.91666M11.0833 6.99999L6.99996 11.0833",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Q0)
        ])) : (_(), P("svg", e3, [
          M("path", {
            d: "M3.33334 7.99998H12.6667M12.6667 7.99998L8 3.33331M12.6667 7.99998L8 12.6666",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, t3)
        ]))
      ], 64)) : z("", !0),
      e.icon === "arrow-up" ? (_(), P("svg", n3, [
        M("path", {
          d: "M8 12.6666V3.33331M8 3.33331L3.33334 7.99998M8 3.33331L12.6667 7.99998",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, o3)
      ])) : z("", !0),
      e.icon === "arrow-up-right" ? (_(), P("svg", i3, [
        M("path", {
          d: "M4.66666 11.3334L11.3333 4.66669M11.3333 4.66669H4.66666M11.3333 4.66669V11.3334",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, r3)
      ])) : z("", !0),
      e.icon === "award" ? (_(), P("svg", a3, [
        M("path", {
          d: "M5.726 10.0044L5 14L8 12.6842L11 14L10.274 10M12 6C12 8.20914 10.2091 10 8 10C5.79086 10 4 8.20914 4 6C4 3.79086 5.79086 2 8 2C10.2091 2 12 3.79086 12 6Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, l3)
      ])) : z("", !0),
      e.icon === "bell" ? (_(), P(me, { key: 12 }, [
        e.size === 12 ? (_(), P("svg", s3, [
          M("g", u3, [
            M("path", {
              d: "M4.67698 10.5C5.02954 10.8112 5.49266 11 5.99989 11C6.50711 11 6.97023 10.8112 7.3228 10.5M8.99989 4C8.99989 3.20435 8.68382 2.44129 8.12121 1.87868C7.5586 1.31607 6.79554 1 5.99989 1C5.20424 1 4.44118 1.31607 3.87857 1.87868C3.31596 2.44129 2.99989 3.20435 2.99989 4C2.99989 5.54509 2.61012 6.60298 2.17472 7.30271C1.80745 7.89294 1.62382 8.18805 1.63055 8.27038C1.63801 8.36154 1.65732 8.3963 1.73078 8.45079C1.79712 8.5 2.09618 8.5 2.69431 8.5H9.30546C9.90359 8.5 10.2027 8.5 10.269 8.45079C10.3425 8.3963 10.3618 8.36154 10.3692 8.27038C10.376 8.18805 10.1923 7.89294 9.82506 7.30271C9.38965 6.60298 8.99989 5.54509 8.99989 4Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, d3)
          ]),
          c3
        ])) : (_(), P("svg", f3, [
          M("path", {
            d: "M6.23612 14C6.70621 14.4149 7.3237 14.6666 8 14.6666C8.6763 14.6666 9.2938 14.4149 9.76389 14M12 5.33331C12 4.27245 11.5786 3.25503 10.8284 2.50489C10.0783 1.75474 9.06087 1.33331 8 1.33331C6.93914 1.33331 5.92172 1.75474 5.17158 2.50489C4.42143 3.25503 4 4.27245 4 5.33331C4 7.39344 3.48032 8.80395 2.89978 9.73692C2.41009 10.5239 2.16524 10.9174 2.17422 11.0272C2.18416 11.1487 2.20991 11.195 2.30785 11.2677C2.39631 11.3333 2.79506 11.3333 3.59257 11.3333H12.4074C13.2049 11.3333 13.6037 11.3333 13.6922 11.2677C13.7901 11.195 13.8158 11.1487 13.8258 11.0272C13.8348 10.9174 13.5899 10.5239 13.1002 9.73692C12.5197 8.80395 12 7.39344 12 5.33331Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, h3)
        ]))
      ], 64)) : z("", !0),
      e.icon === "bookmark" ? (_(), P("svg", g3, [
        M("path", {
          d: "M12.6667 14L8 10.6667L3.33334 14V3.33333C3.33334 2.97971 3.47381 2.64057 3.72386 2.39052C3.97391 2.14048 4.31305 2 4.66667 2H11.3333C11.687 2 12.0261 2.14048 12.2761 2.39052C12.5262 2.64057 12.6667 2.97971 12.6667 3.33333V14Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, m3)
      ])) : z("", !0),
      e.icon === "calendar" ? (_(), P(me, { key: 14 }, [
        e.size === 12 ? (_(), P("svg", p3, [
          M("g", v3, [
            M("path", {
              d: "M8 1V3M4 1V3M1.5 5H10.5M2.5 2H9.5C10.0523 2 10.5 2.44772 10.5 3V10C10.5 10.5523 10.0523 11 9.5 11H2.5C1.94772 11 1.5 10.5523 1.5 10V3C1.5 2.44772 1.94772 2 2.5 2Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, b3)
          ]),
          y3
        ])) : (_(), P("svg", C3, [
          M("path", {
            d: "M10.6667 1.33331V3.99998M5.33333 1.33331V3.99998M2 6.66665H14M3.33333 2.66665H12.6667C13.403 2.66665 14 3.2636 14 3.99998V13.3333C14 14.0697 13.403 14.6666 12.6667 14.6666H3.33333C2.59695 14.6666 2 14.0697 2 13.3333V3.99998C2 3.2636 2.59695 2.66665 3.33333 2.66665Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, x3)
        ]))
      ], 64)) : z("", !0),
      e.icon === "check" ? (_(), P(me, { key: 15 }, [
        e.size === 12 ? (_(), P("svg", w3, [
          M("path", {
            d: "M13.3333 4L6 11.3333L2.66666 8",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, $3)
        ])) : (_(), P("svg", k3, [
          M("path", {
            d: "M13.3333 4L6 11.3333L2.66666 8",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _3)
        ]))
      ], 64)) : z("", !0),
      e.icon === "check-circle" ? (_(), P(me, { key: 16 }, [
        e.size === 12 ? (_(), P("svg", O3, [
          M("g", E3, [
            M("path", {
              d: "M11 5.53999V5.99999C10.9994 7.0782 10.6503 8.12733 10.0047 8.99091C9.35908 9.85448 8.45164 10.4862 7.41768 10.7919C6.38372 11.0977 5.27863 11.0609 4.26723 10.6873C3.25584 10.3136 2.39233 9.62304 1.80548 8.71853C1.21863 7.81401 0.939896 6.74403 1.01084 5.66815C1.08178 4.59228 1.4986 3.56816 2.19914 2.74853C2.89968 1.9289 3.84639 1.35768 4.89809 1.12007C5.9498 0.882448 7.05013 0.991162 8.035 1.42999M11 1.99999L6 7.00499L4.5 5.50499",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, M3)
          ]),
          S3
        ])) : e.size === 24 ? (_(), P("svg", A3, [
          M("path", {
            d: "M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999M22 3.99999L12 14.01L9.00001 11.01",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, T3)
        ])) : (_(), P("svg", P3, [
          M("g", I3, [
            M("path", {
              d: "M14.6667 7.38668V8.00001C14.6658 9.43763 14.2003 10.8365 13.3396 11.9879C12.4788 13.1393 11.2689 13.9817 9.89023 14.3893C8.51162 14.7969 7.03817 14.7479 5.68964 14.2497C4.34112 13.7515 3.18976 12.8307 2.4073 11.6247C1.62484 10.4187 1.25319 8.99205 1.34778 7.55755C1.44237 6.12305 1.99813 4.75756 2.93218 3.66473C3.86623 2.57189 5.12852 1.81027 6.53079 1.49344C7.93306 1.17662 9.40017 1.32157 10.7133 1.90668M14.6667 2.66668L8 9.34001L6 7.34001",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, D3)
          ]),
          L3
        ]))
      ], 64)) : z("", !0),
      e.icon === "chevron-down" ? (_(), P("svg", N3, [
        M("path", {
          d: "M4 6L8 10L12 6",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, F3)
      ])) : z("", !0),
      e.icon === "chevron-left" ? (_(), P(me, { key: 18 }, [
        e.size === 24 ? (_(), P("svg", R3, [
          M("path", {
            d: "M15 18L9 12L15 6",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, B3)
        ])) : (_(), P("svg", V3, [
          M("path", {
            d: "M10 12L6 8L10 4",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, j3)
        ]))
      ], 64)) : z("", !0),
      e.icon === "chevron-right" ? (_(), P("svg", H3, [
        M("path", {
          d: "M6 12L10 8L6 4",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, z3)
      ])) : z("", !0),
      e.icon === "chevron-up" ? (_(), P("svg", q3, [
        M("path", {
          d: "M12 10L8 6L4 10",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, U3)
      ])) : z("", !0),
      e.icon === "chevron-selector-vertical" ? (_(), P("svg", W3, [
        M("path", {
          d: "M4.66666 9.99999L7.99999 13.3333L11.3333 9.99999M4.66666 5.99999L7.99999 2.66666L11.3333 5.99999",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, K3)
      ])) : z("", !0),
      e.icon === "clipboard" ? (_(), P("svg", Y3, [
        M("path", {
          d: "M10.6667 2.66668H12C12.3536 2.66668 12.6928 2.80715 12.9428 3.0572C13.1928 3.30725 13.3333 3.64639 13.3333 4.00001V13.3333C13.3333 13.687 13.1928 14.0261 12.9428 14.2762C12.6928 14.5262 12.3536 14.6667 12 14.6667H3.99999C3.64637 14.6667 3.30723 14.5262 3.05718 14.2762C2.80713 14.0261 2.66666 13.687 2.66666 13.3333V4.00001C2.66666 3.64639 2.80713 3.30725 3.05718 3.0572C3.30723 2.80715 3.64637 2.66668 3.99999 2.66668H5.33332M5.99999 1.33334H9.99999C10.3682 1.33334 10.6667 1.63182 10.6667 2.00001V3.33334C10.6667 3.70153 10.3682 4.00001 9.99999 4.00001H5.99999C5.6318 4.00001 5.33332 3.70153 5.33332 3.33334V2.00001C5.33332 1.63182 5.6318 1.33334 5.99999 1.33334Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, G3)
      ])) : z("", !0),
      e.icon === "clock" ? (_(), P("svg", Z3, [
        M("g", X3, [
          M("path", {
            d: "M8.00001 4.00001V8.00001L10.6667 9.33334M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8.00001C1.33334 4.31811 4.31811 1.33334 8.00001 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, J3)
        ]),
        Q3
      ])) : z("", !0),
      e.icon === "close" ? (_(), P(me, { key: 24 }, [
        e.size === 12 ? (_(), P("svg", e2, [
          M("path", {
            d: "M9 3L3 9M3 3L9 9",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, t2)
        ])) : e.size === 24 ? (_(), P("svg", n2, [
          M("path", {
            d: "M18 6L6 18M6 6L18 18",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, o2)
        ])) : (_(), P("svg", i2, [
          M("path", {
            d: "M12 4L4 12M4 4L12 12",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, r2)
        ]))
      ], 64)) : z("", !0),
      e.icon === "close-circle" ? (_(), P(me, { key: 25 }, [
        e.size === 12 ? (_(), P("svg", a2, [
          M("g", l2, [
            M("path", {
              d: "M7.5 4.5L4.5 7.5M4.5 4.5L7.5 7.5M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, s2)
          ]),
          u2
        ])) : (_(), P("svg", d2, [
          M("g", c2, [
            M("path", {
              d: "M10 6.00001L6.00001 10M6.00001 6.00001L10 10M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00001 14.6667C4.31811 14.6667 1.33334 11.6819 1.33334 8.00001C1.33334 4.31811 4.31811 1.33334 8.00001 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, f2)
          ]),
          h2
        ]))
      ], 64)) : z("", !0),
      e.icon === "code-01" ? (_(), P("svg", g2, [
        M("path", {
          d: "M10.6667 12L14.6667 8L10.6667 4M5.33334 4L1.33334 8L5.33334 12",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, m2)
      ])) : z("", !0),
      e.icon === "copy" ? (_(), P("svg", p2, [
        M("g", v2, [
          M("path", {
            d: "M3.33334 9.99998C2.71209 9.99998 2.40146 9.99998 2.15643 9.89849C1.82973 9.76316 1.57016 9.50359 1.43484 9.17689C1.33334 8.93186 1.33334 8.62123 1.33334 7.99998V3.46665C1.33334 2.71991 1.33334 2.34654 1.47867 2.06133C1.6065 1.81044 1.81047 1.60647 2.06136 1.47864C2.34657 1.33331 2.71994 1.33331 3.46668 1.33331H8.00001C8.62126 1.33331 8.93189 1.33331 9.17692 1.43481C9.50362 1.57013 9.76319 1.8297 9.89852 2.1564C10 2.40143 10 2.71206 10 3.33331M8.13334 14.6666H12.5333C13.2801 14.6666 13.6534 14.6666 13.9387 14.5213C14.1895 14.3935 14.3935 14.1895 14.5214 13.9386C14.6667 13.6534 14.6667 13.28 14.6667 12.5333V8.13331C14.6667 7.38658 14.6667 7.01321 14.5214 6.72799C14.3935 6.47711 14.1895 6.27314 13.9387 6.1453C13.6534 5.99998 13.2801 5.99998 12.5333 5.99998H8.13334C7.38661 5.99998 7.01324 5.99998 6.72802 6.1453C6.47714 6.27314 6.27317 6.47711 6.14533 6.72799C6.00001 7.01321 6.00001 7.38658 6.00001 8.13331V12.5333C6.00001 13.28 6.00001 13.6534 6.14533 13.9386C6.27317 14.1895 6.47714 14.3935 6.72802 14.5213C7.01324 14.6666 7.38661 14.6666 8.13334 14.6666Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, b2)
        ]),
        y2
      ])) : z("", !0),
      e.icon === "database" ? (_(), P("svg", C2, [
        M("path", {
          d: "M14 3.33331C14 4.43788 11.3137 5.33331 8 5.33331C4.68629 5.33331 2 4.43788 2 3.33331M14 3.33331C14 2.22874 11.3137 1.33331 8 1.33331C4.68629 1.33331 2 2.22874 2 3.33331M14 3.33331V12.6666C14 13.7733 11.3333 14.6666 8 14.6666C4.66667 14.6666 2 13.7733 2 12.6666V3.33331M14 7.99998C14 9.10665 11.3333 9.99998 8 9.99998C4.66667 9.99998 2 9.10665 2 7.99998",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, x2)
      ])) : z("", !0),
      e.icon === "dataflow" ? (_(), P("svg", w2, [
        M("path", {
          d: "M11.3333 13.3333H11.2C10.0799 13.3333 9.51984 13.3333 9.09202 13.1153C8.71569 12.9236 8.40973 12.6176 8.21799 12.2413C8 11.8135 8 11.2534 8 10.1333V5.86665C8 4.74654 8 4.18649 8.21799 3.75867C8.40973 3.38234 8.71569 3.07638 9.09202 2.88463C9.51984 2.66665 10.0799 2.66665 11.2 2.66665H11.3333M11.3333 13.3333C11.3333 14.0697 11.9303 14.6666 12.6667 14.6666C13.403 14.6666 14 14.0697 14 13.3333C14 12.5969 13.403 12 12.6667 12C11.9303 12 11.3333 12.5969 11.3333 13.3333ZM11.3333 2.66665C11.3333 3.40303 11.9303 3.99998 12.6667 3.99998C13.403 3.99998 14 3.40303 14 2.66665C14 1.93027 13.403 1.33331 12.6667 1.33331C11.9303 1.33331 11.3333 1.93027 11.3333 2.66665ZM4.66667 7.99998L11.3333 7.99998M4.66667 7.99998C4.66667 8.73636 4.06971 9.33331 3.33333 9.33331C2.59695 9.33331 2 8.73636 2 7.99998C2 7.2636 2.59695 6.66665 3.33333 6.66665C4.06971 6.66665 4.66667 7.2636 4.66667 7.99998ZM11.3333 7.99998C11.3333 8.73636 11.9303 9.33331 12.6667 9.33331C13.403 9.33331 14 8.73636 14 7.99998C14 7.2636 13.403 6.66665 12.6667 6.66665C11.9303 6.66665 11.3333 7.2636 11.3333 7.99998Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, $2)
      ])) : z("", !0),
      e.icon === "download" ? (_(), P("svg", k2, [
        M("path", {
          d: "M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M4.66667 6.66667L8 10M8 10L11.3333 6.66667M8 10L8 2",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, _2)
      ])) : z("", !0),
      e.icon === "edit" ? (_(), P("svg", O2, [
        M("path", {
          d: "M8 13.3333H14M11 2.33334C11.2652 2.06813 11.6249 1.91913 12 1.91913C12.1857 1.91913 12.3696 1.95571 12.5412 2.02678C12.7128 2.09785 12.8687 2.20202 13 2.33334C13.1313 2.46466 13.2355 2.62057 13.3066 2.79215C13.3776 2.96373 13.4142 3.14762 13.4142 3.33334C13.4142 3.51906 13.3776 3.70296 13.3066 3.87454C13.2355 4.04612 13.1313 4.20202 13 4.33334L4.66667 12.6667L2 13.3333L2.66667 10.6667L11 2.33334Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, E2)
      ])) : z("", !0),
      e.icon === "edit-02" ? (_(), P("svg", M2, [
        M("g", S2, [
          M("path", {
            d: "M7.33334 2.66666H4.53334C3.41324 2.66666 2.85319 2.66666 2.42536 2.88464C2.04904 3.07639 1.74308 3.38235 1.55133 3.75867C1.33334 4.1865 1.33334 4.74655 1.33334 5.86666V11.4667C1.33334 12.5868 1.33334 13.1468 1.55133 13.5746C1.74308 13.951 2.04904 14.2569 2.42536 14.4487C2.85319 14.6667 3.41324 14.6667 4.53334 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1154 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V8.66666M5.33333 10.6667H6.44969C6.77581 10.6667 6.93887 10.6667 7.09232 10.6298C7.22837 10.5972 7.35843 10.5433 7.47772 10.4702C7.61228 10.3877 7.72758 10.2724 7.95818 10.0418L14.3333 3.66666C14.8856 3.11437 14.8856 2.21894 14.3333 1.66666C13.7811 1.11437 12.8856 1.11437 12.3333 1.66665L5.95817 8.04182C5.72756 8.27242 5.61226 8.38772 5.52981 8.52228C5.4567 8.64157 5.40283 8.77163 5.37017 8.90768C5.33333 9.06113 5.33333 9.22419 5.33333 9.55031V10.6667Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, A2)
        ]),
        T2
      ])) : z("", !0),
      e.icon === "equal" ? (_(), P("svg", P2, [
        M("path", {
          d: "M3.33334 6H12.6667M3.33334 10H12.6667",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, I2)
      ])) : z("", !0),
      e.icon === "eye" ? (_(), P("svg", D2, [
        M("path", {
          d: "M1.61342 8.47543C1.52262 8.33167 1.47723 8.25979 1.45182 8.14892C1.43273 8.06565 1.43273 7.93431 1.45182 7.85104C1.47723 7.74017 1.52262 7.66829 1.61341 7.52453C2.36369 6.33654 4.59693 3.33331 8.00027 3.33331C11.4036 3.33331 13.6369 6.33654 14.3871 7.52453C14.4779 7.66829 14.5233 7.74017 14.5487 7.85104C14.5678 7.93431 14.5678 8.06565 14.5487 8.14892C14.5233 8.25979 14.4779 8.33167 14.3871 8.47543C13.6369 9.66342 11.4036 12.6666 8.00027 12.6666C4.59693 12.6666 2.36369 9.66342 1.61342 8.47543Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, L2),
        M("path", {
          d: "M8.00027 9.99998C9.10484 9.99998 10.0003 9.10455 10.0003 7.99998C10.0003 6.89541 9.10484 5.99998 8.00027 5.99998C6.8957 5.99998 6.00027 6.89541 6.00027 7.99998C6.00027 9.10455 6.8957 9.99998 8.00027 9.99998Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, N2)
      ])) : z("", !0),
      e.icon === "file-attachment" ? (_(), P("svg", F2, [
        M("path", {
          d: "M13.3333 4.66665V4.53331C13.3333 3.41321 13.3333 2.85316 13.1153 2.42533C12.9236 2.04901 12.6176 1.74305 12.2413 1.5513C11.8135 1.33331 11.2534 1.33331 10.1333 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74655 14.6666 5.86666 14.6666H8.33332M12 12V8.33331C12 7.78103 12.4477 7.33331 13 7.33331C13.5523 7.33331 14 7.78103 14 8.33331V12C14 13.1045 13.1046 14 12 14C10.8954 14 9.99999 13.1045 9.99999 12V9.33331",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, R2)
      ])) : z("", !0),
      e.icon === "file-check" ? (_(), P("svg", B2, [
        M("path", {
          d: "M9.33332 1.513V4.26669C9.33332 4.64006 9.33332 4.82675 9.40599 4.96935C9.4699 5.0948 9.57189 5.19678 9.69733 5.2607C9.83994 5.33336 10.0266 5.33336 10.4 5.33336H13.1537M5.99999 10.6666L7.33332 12L10.3333 8.99998M9.33332 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74655 14.6666 5.86666 14.6666H10.1333C11.2534 14.6666 11.8135 14.6666 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1153 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4666V5.33331L9.33332 1.33331Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, V2)
      ])) : z("", !0),
      e.icon === "file-text" ? (_(), P("svg", j2, [
        M("path", {
          d: "M9.33332 1.33331H3.99999C3.64637 1.33331 3.30723 1.47379 3.05718 1.72384C2.80713 1.97389 2.66666 2.31302 2.66666 2.66665V13.3333C2.66666 13.6869 2.80713 14.0261 3.05718 14.2761C3.30723 14.5262 3.64637 14.6666 3.99999 14.6666H12C12.3536 14.6666 12.6928 14.5262 12.9428 14.2761C13.1928 14.0261 13.3333 13.6869 13.3333 13.3333V5.33331M9.33332 1.33331L13.3333 5.33331M9.33332 1.33331L9.33332 5.33331L13.3333 5.33331M10.6667 8.66665H5.33332M10.6667 11.3333H5.33332M6.66666 5.99998H5.33332",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, H2)
      ])) : z("", !0),
      e.icon === "file-plus" ? (_(), P("svg", z2, [
        M("path", {
          d: "M13.3333 6.99998V4.53331C13.3333 3.41321 13.3333 2.85316 13.1153 2.42533C12.9236 2.04901 12.6176 1.74305 12.2413 1.5513C11.8135 1.33331 11.2534 1.33331 10.1333 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74655 14.6666 5.86666 14.6666H7.99999M9.33332 7.33331H5.33332M6.66666 9.99998H5.33332M10.6667 4.66665H5.33332M12 14V12M12 12V9.99998M12 12H9.99999M12 12H14",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, q2)
      ])) : z("", !0),
      e.icon === "file-upload" ? (_(), P(me, { key: 39 }, [
        e.size === 20 ? (_(), P("svg", U2, [
          M("path", {
            d: "M16.6667 10.4167V5.66666C16.6667 4.26653 16.6667 3.56646 16.3942 3.03168C16.1545 2.56128 15.7721 2.17882 15.3017 1.93914C14.7669 1.66666 14.0668 1.66666 12.6667 1.66666H7.33334C5.93321 1.66666 5.23315 1.66666 4.69837 1.93914C4.22796 2.17882 3.84551 2.56128 3.60583 3.03168C3.33334 3.56646 3.33334 4.26653 3.33334 5.66666V14.3333C3.33334 15.7335 3.33334 16.4335 3.60583 16.9683C3.84551 17.4387 4.22796 17.8212 4.69837 18.0608C5.23315 18.3333 5.93317 18.3333 7.33323 18.3333H10.4167M11.6667 9.16666H6.66668M8.33334 12.5H6.66668M13.3333 5.83332H6.66668M12.5 15.8333L15 18.3333M15 18.3333L17.5 15.8333M15 18.3333V13.3333",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, W2)
        ])) : (_(), P("svg", K2, [
          M("path", {
            d: "M13.3333 8.33331V4.53331C13.3333 3.41321 13.3333 2.85316 13.1153 2.42533C12.9236 2.04901 12.6176 1.74305 12.2413 1.5513C11.8135 1.33331 11.2534 1.33331 10.1333 1.33331H5.86666C4.74655 1.33331 4.1865 1.33331 3.75868 1.5513C3.38235 1.74305 3.07639 2.04901 2.88464 2.42533C2.66666 2.85316 2.66666 3.41321 2.66666 4.53331V11.4666C2.66666 12.5868 2.66666 13.1468 2.88464 13.5746C3.07639 13.951 3.38235 14.2569 3.75868 14.4487C4.1865 14.6666 4.74652 14.6666 5.86656 14.6666H8.33332M9.33332 7.33331H5.33332M6.66666 9.99998H5.33332M10.6667 4.66665H5.33332M9.99999 12.6666L12 14.6666M12 14.6666L14 12.6666M12 14.6666V10.6666",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Y2)
        ]))
      ], 64)) : z("", !0),
      e.icon === "flag" ? (_(), P(me, { key: 40 }, [
        e.size === 12 ? (_(), P("svg", G2, [
          M("path", {
            d: "M2 7.5C2 7.5 2.5 7 4 7C5.5 7 6.5 8 8 8C9.5 8 10 7.5 10 7.5V1.5C10 1.5 9.5 2 8 2C6.5 2 5.5 1 4 1C2.5 1 2 1.5 2 1.5V7.5ZM2 7.5V11",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.33",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Z2)
        ])) : e.size === 24 ? (_(), P("svg", X2, [
          M("path", {
            d: "M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, J2)
        ])) : (_(), P("svg", Q2, [
          M("path", {
            d: "M2.66669 10C2.66669 10 3.33335 9.33334 5.33335 9.33334C7.33335 9.33334 8.66669 10.6667 10.6667 10.6667C12.6667 10.6667 13.3334 10 13.3334 10V2.00001C13.3334 2.00001 12.6667 2.66668 10.6667 2.66668C8.66669 2.66668 7.33335 1.33334 5.33335 1.33334C3.33335 1.33334 2.66669 2.00001 2.66669 2.00001V10ZM2.66669 10V14.6667",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, e6)
        ]))
      ], 64)) : z("", !0),
      e.icon === "gift" ? (_(), P("svg", t6, [
        M("g", n6, [
          M("path", {
            d: "M13.3333 8.00001V14.6667H2.66665V8.00001M7.99998 14.6667V4.66668M7.99998 4.66668H4.99998C4.55795 4.66668 4.13403 4.49108 3.82147 4.17852C3.50891 3.86596 3.33331 3.44204 3.33331 3.00001C3.33331 2.55798 3.50891 2.13406 3.82147 1.8215C4.13403 1.50894 4.55795 1.33334 4.99998 1.33334C7.33331 1.33334 7.99998 4.66668 7.99998 4.66668ZM7.99998 4.66668H11C11.442 4.66668 11.8659 4.49108 12.1785 4.17852C12.4911 3.86596 12.6666 3.44204 12.6666 3.00001C12.6666 2.55798 12.4911 2.13406 12.1785 1.8215C11.8659 1.50894 11.442 1.33334 11 1.33334C8.66665 1.33334 7.99998 4.66668 7.99998 4.66668ZM1.33331 4.66668H14.6666V8.00001H1.33331V4.66668Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, o6)
        ]),
        i6
      ])) : z("", !0),
      e.icon === "help-circle" ? (_(), P("svg", r6, [
        M("g", a6, [
          M("path", {
            d: "M6.05998 6.00001C6.21672 5.55446 6.52608 5.17875 6.93328 4.93943C7.34048 4.70012 7.81924 4.61264 8.28476 4.69248C8.75028 4.77233 9.17252 5.01436 9.4767 5.3757C9.78087 5.73703 9.94735 6.19436 9.94665 6.66668C9.94665 8.00001 7.94665 8.66668 7.94665 8.66668M7.99998 11.3333H8.00665M14.6666 8.00001C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00001C1.33331 4.31811 4.31808 1.33334 7.99998 1.33334C11.6819 1.33334 14.6666 4.31811 14.6666 8.00001Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, l6)
        ]),
        s6
      ])) : z("", !0),
      e.icon === "hourglass" ? (_(), P("svg", u6, [
        M("path", {
          d: "M5.99998 12.3333H9.99998M4.39998 1.33334H11.6C11.9733 1.33334 12.16 1.33334 12.3026 1.40601C12.4281 1.46992 12.5301 1.57191 12.594 1.69735C12.6666 1.83996 12.6666 2.02664 12.6666 2.40001V3.78302C12.6666 4.10914 12.6666 4.2722 12.6298 4.42565C12.5971 4.5617 12.5433 4.69176 12.4702 4.81106C12.3877 4.94561 12.2724 5.06091 12.0418 5.29151L10.0876 7.24576C9.82355 7.50977 9.69154 7.64178 9.64208 7.794C9.59858 7.92789 9.59858 8.07213 9.64208 8.20602C9.69154 8.35824 9.82355 8.49025 10.0876 8.75426L12.0418 10.7085C12.2724 10.9391 12.3877 11.0544 12.4702 11.189C12.5433 11.3083 12.5971 11.4383 12.6298 11.5744C12.6666 11.7278 12.6666 11.8909 12.6666 12.217V13.6C12.6666 13.9734 12.6666 14.1601 12.594 14.3027C12.5301 14.4281 12.4281 14.5301 12.3026 14.594C12.16 14.6667 11.9733 14.6667 11.6 14.6667H4.39998C4.02661 14.6667 3.83993 14.6667 3.69732 14.594C3.57188 14.5301 3.46989 14.4281 3.40598 14.3027C3.33331 14.1601 3.33331 13.9734 3.33331 13.6V12.217C3.33331 11.8909 3.33331 11.7278 3.37015 11.5744C3.40282 11.4383 3.45669 11.3083 3.52979 11.189C3.61225 11.0544 3.72755 10.9391 3.95815 10.7085L5.9124 8.75426C6.17641 8.49025 6.30842 8.35824 6.35787 8.20602C6.40138 8.07213 6.40138 7.92789 6.35787 7.794C6.30842 7.64178 6.17641 7.50977 5.9124 7.24576L3.95815 5.29151C3.72755 5.06091 3.61225 4.94561 3.52979 4.81106C3.45669 4.69176 3.40282 4.5617 3.37015 4.42565C3.33331 4.2722 3.33331 4.10914 3.33331 3.78302V2.40001C3.33331 2.02664 3.33331 1.83996 3.40598 1.69735C3.46989 1.57191 3.57188 1.46992 3.69732 1.40601C3.83993 1.33334 4.02661 1.33334 4.39998 1.33334Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, d6)
      ])) : z("", !0),
      e.icon === "image" ? (_(), P("svg", c6, [
        M("path", {
          d: "M3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14ZM3.33333 14L10.6667 6.66667L14 10M6.66667 5.66667C6.66667 6.21895 6.21895 6.66667 5.66667 6.66667C5.11438 6.66667 4.66667 6.21895 4.66667 5.66667C4.66667 5.11438 5.11438 4.66667 5.66667 4.66667C6.21895 4.66667 6.66667 5.11438 6.66667 5.66667Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, f6)
      ])) : z("", !0),
      e.icon === "inbox" ? (_(), P("svg", h6, [
        M("path", {
          d: "M14.6666 7.99999H10.6666L9.33331 9.99999H6.66665L5.33331 7.99999H1.33331M14.6666 7.99999V12C14.6666 12.3536 14.5262 12.6928 14.2761 12.9428C14.0261 13.1928 13.6869 13.3333 13.3333 13.3333H2.66665C2.31302 13.3333 1.97389 13.1928 1.72384 12.9428C1.47379 12.6928 1.33331 12.3536 1.33331 12V7.99999M14.6666 7.99999L12.3666 3.40666C12.2563 3.18451 12.0861 2.99757 11.8753 2.86684C11.6645 2.73612 11.4214 2.66679 11.1733 2.66666H4.82665C4.57859 2.66679 4.33549 2.73612 4.12468 2.86684C3.91386 2.99757 3.7437 3.18451 3.63331 3.40666L1.33331 7.99999",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, g6)
      ])) : z("", !0),
      e.icon === "info" ? (_(), P(me, { key: 46 }, [
        e.size === 14 ? (_(), P("svg", m6, [
          M("g", p6, [
            M("path", {
              d: "M7.00008 9.33332V6.99999M7.00008 4.66666H7.00591M12.8334 6.99999C12.8334 10.2216 10.2217 12.8333 7.00008 12.8333C3.77842 12.8333 1.16675 10.2216 1.16675 6.99999C1.16675 3.77833 3.77842 1.16666 7.00008 1.16666C10.2217 1.16666 12.8334 3.77833 12.8334 6.99999Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, v6)
          ]),
          b6
        ])) : (_(), P("svg", y6, [
          M("g", C6, [
            M("path", {
              d: "M7.99998 10.6667V8.00001M7.99998 5.33334H8.00665M14.6666 8.00001C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00001C1.33331 4.31811 4.31808 1.33334 7.99998 1.33334C11.6819 1.33334 14.6666 4.31811 14.6666 8.00001Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, x6)
          ]),
          w6
        ]))
      ], 64)) : z("", !0),
      e.icon === "layers" ? (_(), P("svg", $6, [
        M("g", k6, [
          M("path", {
            d: "M1.33331 11.3333L7.99998 14.6666L14.6666 11.3333M1.33331 7.99998L7.99998 11.3333L14.6666 7.99998M7.99998 1.33331L1.33331 4.66665L7.99998 7.99998L14.6666 4.66665L7.99998 1.33331Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _6)
        ]),
        O6
      ])) : z("", !0),
      e.icon === "link" ? (_(), P("svg", E6, [
        M("g", M6, [
          M("path", {
            d: "M6.66668 8.66666C6.95298 9.04942 7.31825 9.36612 7.73771 9.59529C8.15717 9.82446 8.62102 9.96074 9.09778 9.99489C9.57454 10.029 10.0531 9.96024 10.5009 9.79318C10.9487 9.62613 11.3554 9.36471 11.6933 9.02666L13.6933 7.02666C14.3005 6.39799 14.6365 5.55598 14.6289 4.68199C14.6213 3.808 14.2708 2.97196 13.6527 2.35394C13.0347 1.73591 12.1987 1.38535 11.3247 1.37775C10.4507 1.37016 9.60868 1.70614 8.98001 2.31333L7.83334 3.45333M9.33334 7.33333C9.04704 6.95058 8.68177 6.63388 8.26231 6.4047C7.84285 6.17553 7.37901 6.03925 6.90224 6.00511C6.42548 5.97096 5.94695 6.03975 5.49911 6.20681C5.05127 6.37387 4.6446 6.63528 4.30668 6.97333L2.30668 8.97333C1.69948 9.602 1.3635 10.444 1.3711 11.318C1.37869 12.192 1.72926 13.028 2.34728 13.6461C2.96531 14.2641 3.80135 14.6147 4.67534 14.6222C5.54933 14.6298 6.39134 14.2939 7.02001 13.6867L8.16001 12.5467",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, S6)
        ]),
        A6
      ])) : z("", !0),
      e.icon === "lightbulb" ? (_(), P("svg", T6, [
        M("g", P6, [
          M("path", {
            d: "M6.66665 11.7724V13.3333C6.66665 14.0697 7.2636 14.6666 7.99998 14.6666C8.73636 14.6666 9.33331 14.0697 9.33331 13.3333V11.7724M7.99998 1.33331V1.99998M1.99998 7.99998H1.33331M3.66665 3.66665L3.26658 3.26658M12.3333 3.66665L12.7335 3.26658M14.6666 7.99998H14M12 7.99998C12 10.2091 10.2091 12 7.99998 12C5.79084 12 3.99998 10.2091 3.99998 7.99998C3.99998 5.79084 5.79084 3.99998 7.99998 3.99998C10.2091 3.99998 12 5.79084 12 7.99998Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, I6)
        ]),
        D6
      ])) : z("", !0),
      e.icon === "loading" ? (_(), P(me, { key: 50 }, [
        e.size === 12 ? (_(), P("svg", L6, [
          M("g", N6, [
            M("path", {
              d: "M6 1.125V2.375M6 9V11M2.875 6H1.125M10.625 6H9.875M9.22855 9.22855L8.875 8.875M9.33211 2.70789L8.625 3.415M2.46079 9.53921L3.875 8.125M2.56434 2.60434L3.625 3.665",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, F6)
          ]),
          R6
        ])) : (_(), P("svg", B6, [
          M("path", {
            d: "M8 1.5V3.16667M8 12V14.6667M3.83333 8H1.5M14.1667 8H13.1667M12.3047 12.3047L11.8333 11.8333M12.4428 3.61052L11.5 4.55333M3.28105 12.719L5.16667 10.8333M3.41912 3.47245L4.83333 4.88667",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, V6)
        ]))
      ], 64)) : z("", !0),
      e.icon === "log-out" ? (_(), P("svg", j6, [
        M("path", {
          d: "M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8L6 8",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, H6)
      ])) : z("", !0),
      e.icon === "mail" ? (_(), P("svg", z6, [
        M("path", {
          d: "M14.6666 4.00002C14.6666 3.26669 14.0666 2.66669 13.3333 2.66669H2.66665C1.93331 2.66669 1.33331 3.26669 1.33331 4.00002M14.6666 4.00002V12C14.6666 12.7334 14.0666 13.3334 13.3333 13.3334H2.66665C1.93331 13.3334 1.33331 12.7334 1.33331 12V4.00002M14.6666 4.00002L7.99998 8.66669L1.33331 4.00002",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, q6)
      ])) : z("", !0),
      e.icon === "menu" ? (_(), P(me, { key: 53 }, [
        e.size === 24 ? (_(), P("svg", U6, [
          M("path", {
            d: "M3 12H21M3 6H21M3 18H21",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, W6)
        ])) : (_(), P("svg", K6, [
          M("path", {
            d: "M2 8H14M2 4H14M2 12H14",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Y6)
        ]))
      ], 64)) : z("", !0),
      e.icon === "message-circle" ? (_(), P(me, { key: 54 }, [
        e.size === 14 ? (_(), P("svg", G6, [
          M("path", {
            d: "M12.25 6.70835C12.252 7.47827 12.0721 8.23778 11.725 8.92502C11.3134 9.74853 10.6807 10.4412 9.89768 10.9254C9.11467 11.4097 8.21231 11.6663 7.29167 11.6667C6.52174 11.6687 5.76223 11.4888 5.075 11.1417L1.75 12.25L2.85833 8.92502C2.51121 8.23778 2.33133 7.47827 2.33333 6.70835C2.33369 5.78771 2.59036 4.88535 3.07459 4.10234C3.55882 3.31933 4.25148 2.6866 5.075 2.27502C5.76223 1.92789 6.52174 1.74801 7.29167 1.75002H7.58333C8.7992 1.8171 9.94761 2.33029 10.8087 3.19135C11.6697 4.05241 12.1829 5.20081 12.25 6.41668V6.70835Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Z6)
        ])) : (_(), P("svg", X6, [
          M("path", {
            d: "M14 7.66669C14.0023 8.5466 13.7967 9.41461 13.4 10.2C12.9296 11.1412 12.2065 11.9328 11.3116 12.4862C10.4168 13.0396 9.3855 13.3329 8.33333 13.3334C7.45342 13.3356 6.58541 13.1301 5.8 12.7334L2 14L3.26667 10.2C2.86995 9.41461 2.66437 8.5466 2.66667 7.66669C2.66707 6.61452 2.96041 5.58325 3.51381 4.68839C4.06722 3.79352 4.85884 3.0704 5.8 2.60002C6.58541 2.20331 7.45342 1.99772 8.33333 2.00002H8.66667C10.0562 2.07668 11.3687 2.66319 12.3528 3.64726C13.3368 4.63132 13.9233 5.94379 14 7.33335V7.66669Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, J6)
        ]))
      ], 64)) : z("", !0),
      e.icon === "message-circle-02" ? (_(), P("svg", Q6, [
        M("g", eg, [
          M("path", {
            d: "M4.06289 7.48584C4.02145 7.2188 3.99995 6.94522 3.99995 6.66665C3.99995 3.72113 6.40348 1.33331 9.36838 1.33331C12.3333 1.33331 14.7368 3.72113 14.7368 6.66665C14.7368 7.33203 14.6141 7.96895 14.3901 8.55632C14.3435 8.6783 14.3203 8.7393 14.3097 8.78692C14.2992 8.8341 14.2952 8.8673 14.2941 8.91561C14.2929 8.96438 14.2995 9.0181 14.3128 9.12553L14.5811 11.3057C14.6102 11.5417 14.6247 11.6597 14.5855 11.7455C14.5511 11.8206 14.49 11.8803 14.414 11.913C14.3274 11.9503 14.2097 11.933 13.9745 11.8985L11.8509 11.5873C11.7401 11.571 11.6846 11.5629 11.6341 11.5632C11.5842 11.5634 11.5496 11.5671 11.5007 11.5774C11.4513 11.5878 11.3882 11.6114 11.262 11.6587C10.6731 11.8793 10.0349 12 9.36838 12C9.08958 12 8.81575 11.9789 8.54842 11.9382M5.0877 14.6666C7.0643 14.6666 8.66665 13.025 8.66665 11C8.66665 8.97494 7.0643 7.33331 5.0877 7.33331C3.1111 7.33331 1.50875 8.97494 1.50875 11C1.50875 11.407 1.5735 11.7986 1.69301 12.1645C1.74353 12.3191 1.76879 12.3964 1.77708 12.4493C1.78574 12.5044 1.78726 12.5354 1.78403 12.5911C1.78095 12.6445 1.76759 12.7048 1.74088 12.8255L1.33331 14.6666L3.32985 14.394C3.43882 14.3791 3.49331 14.3717 3.54089 14.372C3.59099 14.3723 3.61758 14.375 3.66672 14.3848C3.71338 14.3941 3.78275 14.4186 3.92149 14.4676C4.28704 14.5966 4.67938 14.6666 5.0877 14.6666Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, tg)
        ]),
        ng
      ])) : z("", !0),
      e.icon === "minus" ? (_(), P("svg", og, [
        M("path", {
          d: "M3.33331 8H12.6666",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ig)
      ])) : z("", !0),
      e.icon === "monitor" ? (_(), P("svg", rg, [
        M("path", {
          d: "M5.33331 14H10.6666M7.99998 11.3333V14M4.53331 11.3333H11.4666C12.5868 11.3333 13.1468 11.3333 13.5746 11.1153C13.951 10.9236 14.2569 10.6176 14.4487 10.2413C14.6666 9.81349 14.6666 9.25344 14.6666 8.13333V5.2C14.6666 4.0799 14.6666 3.51984 14.4487 3.09202C14.2569 2.71569 13.951 2.40973 13.5746 2.21799C13.1468 2 12.5868 2 11.4666 2H4.53331C3.41321 2 2.85316 2 2.42533 2.21799C2.04901 2.40973 1.74305 2.71569 1.5513 3.09202C1.33331 3.51984 1.33331 4.0799 1.33331 5.2V8.13333C1.33331 9.25344 1.33331 9.81349 1.5513 10.2413C1.74305 10.6176 2.04901 10.9236 2.42533 11.1153C2.85316 11.3333 3.41321 11.3333 4.53331 11.3333Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ag)
      ])) : z("", !0),
      e.icon === "more-horizontal" ? (_(), P("svg", lg, [
        M("path", {
          d: "M8.00002 8.66665C8.36821 8.66665 8.66669 8.36817 8.66669 7.99998C8.66669 7.63179 8.36821 7.33331 8.00002 7.33331C7.63183 7.33331 7.33335 7.63179 7.33335 7.99998C7.33335 8.36817 7.63183 8.66665 8.00002 8.66665Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, sg),
        M("path", {
          d: "M12.6667 8.66665C13.0349 8.66665 13.3334 8.36817 13.3334 7.99998C13.3334 7.63179 13.0349 7.33331 12.6667 7.33331C12.2985 7.33331 12 7.63179 12 7.99998C12 8.36817 12.2985 8.66665 12.6667 8.66665Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ug),
        M("path", {
          d: "M3.33335 8.66665C3.70154 8.66665 4.00002 8.36817 4.00002 7.99998C4.00002 7.63179 3.70154 7.33331 3.33335 7.33331C2.96516 7.33331 2.66669 7.63179 2.66669 7.99998C2.66669 8.36817 2.96516 8.66665 3.33335 8.66665Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, dg)
      ])) : z("", !0),
      e.icon === "more-vertical" ? (_(), P("svg", cg, [
        M("path", {
          d: "M7.99998 8.66669C8.36817 8.66669 8.66665 8.36821 8.66665 8.00002C8.66665 7.63183 8.36817 7.33335 7.99998 7.33335C7.63179 7.33335 7.33331 7.63183 7.33331 8.00002C7.33331 8.36821 7.63179 8.66669 7.99998 8.66669Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, fg),
        M("path", {
          d: "M7.99998 4.00002C8.36817 4.00002 8.66665 3.70154 8.66665 3.33335C8.66665 2.96516 8.36817 2.66669 7.99998 2.66669C7.63179 2.66669 7.33331 2.96516 7.33331 3.33335C7.33331 3.70154 7.63179 4.00002 7.99998 4.00002Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, hg),
        M("path", {
          d: "M7.99998 13.3334C8.36817 13.3334 8.66665 13.0349 8.66665 12.6667C8.66665 12.2985 8.36817 12 7.99998 12C7.63179 12 7.33331 12.2985 7.33331 12.6667C7.33331 13.0349 7.63179 13.3334 7.99998 13.3334Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, gg)
      ])) : z("", !0),
      e.icon === "paperclip" ? (_(), P("svg", mg, [
        M("g", pg, [
          M("path", {
            d: "M14.2934 7.36665L8.1667 13.4933C7.41613 14.2439 6.39815 14.6655 5.3367 14.6655C4.27524 14.6655 3.25726 14.2439 2.5067 13.4933C1.75613 12.7428 1.33447 11.7248 1.33447 10.6633C1.33447 9.60186 1.75613 8.58388 2.5067 7.83332L8.63336 1.70665C9.13374 1.20628 9.81239 0.925171 10.52 0.925171C11.2277 0.925171 11.9063 1.20628 12.4067 1.70665C12.9071 2.20703 13.1882 2.88568 13.1882 3.59332C13.1882 4.30096 12.9071 4.97961 12.4067 5.47999L6.27336 11.6067C6.02318 11.8568 5.68385 11.9974 5.33003 11.9974C4.97621 11.9974 4.63688 11.8568 4.3867 11.6067C4.13651 11.3565 3.99596 11.0171 3.99596 10.6633C3.99596 10.3095 4.13651 9.97018 4.3867 9.71999L10.0467 4.06665",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, vg)
        ]),
        bg
      ])) : z("", !0),
      e.icon === "passport" ? (_(), P(me, { key: 61 }, [
        e.size === 20 ? (_(), P("svg", yg, [
          M("path", {
            d: "M8.33331 13.3334H11.6666M7.33331 18.3334H12.6666C14.0668 18.3334 14.7668 18.3334 15.3016 18.0609C15.772 17.8212 16.1545 17.4387 16.3942 16.9683C16.6666 16.4336 16.6666 15.7335 16.6666 14.3334V5.66669C16.6666 4.26656 16.6666 3.56649 16.3942 3.03171C16.1545 2.56131 15.772 2.17885 15.3016 1.93917C14.7668 1.66669 14.0668 1.66669 12.6666 1.66669H7.33331C5.93318 1.66669 5.23312 1.66669 4.69834 1.93917C4.22793 2.17885 3.84548 2.56131 3.6058 3.03171C3.33331 3.56649 3.33331 4.26656 3.33331 5.66669V14.3334C3.33331 15.7335 3.33331 16.4336 3.6058 16.9683C3.84548 17.4387 4.22793 17.8212 4.69834 18.0609C5.23312 18.3334 5.93318 18.3334 7.33331 18.3334ZM12.5 7.50002C12.5 8.88073 11.3807 10 9.99998 10C8.61927 10 7.49998 8.88073 7.49998 7.50002C7.49998 6.11931 8.61927 5.00002 9.99998 5.00002C11.3807 5.00002 12.5 6.11931 12.5 7.50002Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Cg)
        ])) : (_(), P("svg", xg, [
          M("path", {
            d: "M6.66669 10.6666H9.33335M5.86669 14.6666H10.1334C11.2535 14.6666 11.8135 14.6666 12.2413 14.4487C12.6177 14.2569 12.9236 13.951 13.1154 13.5746C13.3334 13.1468 13.3334 12.5868 13.3334 11.4666V4.53331C13.3334 3.41321 13.3334 2.85316 13.1154 2.42533C12.9236 2.04901 12.6177 1.74305 12.2413 1.5513C11.8135 1.33331 11.2535 1.33331 10.1334 1.33331H5.86669C4.74658 1.33331 4.18653 1.33331 3.75871 1.5513C3.38238 1.74305 3.07642 2.04901 2.88467 2.42533C2.66669 2.85316 2.66669 3.41321 2.66669 4.53331V11.4666C2.66669 12.5868 2.66669 13.1468 2.88467 13.5746C3.07642 13.951 3.38238 14.2569 3.75871 14.4487C4.18653 14.6666 4.74658 14.6666 5.86669 14.6666ZM10 5.99998C10 7.10455 9.10459 7.99998 8.00002 7.99998C6.89545 7.99998 6.00002 7.10455 6.00002 5.99998C6.00002 4.89541 6.89545 3.99998 8.00002 3.99998C9.10459 3.99998 10 4.89541 10 5.99998Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, wg)
        ]))
      ], 64)) : z("", !0),
      e.icon === "pause" ? (_(), P("svg", $g, [
        M("g", kg, [
          M("path", {
            d: "M6.33331 10V6.00001M9.66665 10V6.00001M14.6666 8.00001C14.6666 11.6819 11.6819 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00001C1.33331 4.31811 4.31808 1.33334 7.99998 1.33334C11.6819 1.33334 14.6666 4.31811 14.6666 8.00001Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _g)
        ]),
        Og
      ])) : z("", !0),
      e.icon === "phone" ? (_(), P("svg", Eg, [
        M("g", Mg, [
          M("path", {
            d: "M14.6666 11.28V13.28C14.6674 13.4657 14.6294 13.6495 14.555 13.8196C14.4806 13.9897 14.3715 14.1424 14.2347 14.2679C14.0979 14.3934 13.9364 14.489 13.7605 14.5485C13.5846 14.608 13.3982 14.6301 13.2133 14.6133C11.1619 14.3904 9.19131 13.6894 7.45998 12.5667C5.84919 11.5431 4.48353 10.1775 3.45998 8.56668C2.33329 6.82748 1.63214 4.84734 1.41331 2.78668C1.39665 2.60233 1.41856 2.41652 1.47764 2.2411C1.53673 2.06567 1.63169 1.90447 1.75649 1.76776C1.88128 1.63105 2.03318 1.52182 2.2025 1.44703C2.37183 1.37224 2.55487 1.33352 2.73998 1.33335H4.73998C5.06351 1.33016 5.37717 1.44473 5.62248 1.6557C5.8678 1.86667 6.02803 2.15964 6.07331 2.48001C6.15772 3.12006 6.31428 3.7485 6.53998 4.35335C6.62967 4.59196 6.64908 4.85129 6.59591 5.1006C6.54274 5.34991 6.41922 5.57875 6.23998 5.76001L5.39331 6.60668C6.34235 8.27571 7.72428 9.65764 9.39331 10.6067L10.24 9.76001C10.4212 9.58077 10.6501 9.45725 10.8994 9.40408C11.1487 9.35091 11.408 9.37032 11.6466 9.46001C12.2515 9.68571 12.8799 9.84227 13.52 9.92668C13.8438 9.97237 14.1396 10.1355 14.351 10.385C14.5624 10.6345 14.6748 10.9531 14.6666 11.28Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Sg)
        ]),
        Ag
      ])) : z("", !0),
      e.icon === "plus" ? (_(), P(me, { key: 64 }, [
        e.size === 40 ? (_(), P("svg", Tg, [
          M("path", {
            d: "M7.99998 3.33334V12.6667M3.33331 8.00001H12.6666",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Pg)
        ])) : (_(), P("svg", Ig, [
          M("path", {
            d: "M7.99998 3.33334V12.6667M3.33331 8.00001H12.6666",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Dg)
        ]))
      ], 64)) : z("", !0),
      e.icon === "qr-code" ? (_(), P("svg", Lg, [
        M("path", {
          d: "M4.66667 8.00001H8V11.3333M2.00667 8.00001H2M5.34 11.3333H5.33333M8.00667 14H8M14.0067 8.00001H14M2 11.3333H3M10.3333 8.00001H11.6667M2 14H5.33333M8 1.33334V5.33334M11.7333 14H12.9333C13.3067 14 13.4934 14 13.636 13.9273C13.7614 13.8634 13.8634 13.7614 13.9273 13.636C14 13.4934 14 13.3067 14 12.9333V11.7333C14 11.36 14 11.1733 13.9273 11.0307C13.8634 10.9052 13.7614 10.8033 13.636 10.7393C13.4934 10.6667 13.3067 10.6667 12.9333 10.6667H11.7333C11.36 10.6667 11.1733 10.6667 11.0307 10.7393C10.9052 10.8033 10.8032 10.9052 10.7393 11.0307C10.6667 11.1733 10.6667 11.36 10.6667 11.7333V12.9333C10.6667 13.3067 10.6667 13.4934 10.7393 13.636C10.8032 13.7614 10.9052 13.8634 11.0307 13.9273C11.1733 14 11.36 14 11.7333 14ZM11.7333 5.33334H12.9333C13.3067 5.33334 13.4934 5.33334 13.636 5.26068C13.7614 5.19677 13.8634 5.09478 13.9273 4.96934C14 4.82673 14 4.64005 14 4.26668V3.06668C14 2.69331 14 2.50662 13.9273 2.36402C13.8634 2.23858 13.7614 2.13659 13.636 2.07267C13.4934 2.00001 13.3067 2.00001 12.9333 2.00001H11.7333C11.36 2.00001 11.1733 2.00001 11.0307 2.07267C10.9052 2.13659 10.8032 2.23858 10.7393 2.36402C10.6667 2.50662 10.6667 2.69331 10.6667 3.06668V4.26668C10.6667 4.64005 10.6667 4.82673 10.7393 4.96934C10.8032 5.09478 10.9052 5.19677 11.0307 5.26068C11.1733 5.33334 11.36 5.33334 11.7333 5.33334ZM3.06667 5.33334H4.26667C4.64004 5.33334 4.82672 5.33334 4.96933 5.26068C5.09477 5.19677 5.19676 5.09478 5.26067 4.96934C5.33333 4.82673 5.33333 4.64005 5.33333 4.26668V3.06668C5.33333 2.69331 5.33333 2.50662 5.26067 2.36402C5.19676 2.23858 5.09477 2.13659 4.96933 2.07267C4.82672 2.00001 4.64004 2.00001 4.26667 2.00001H3.06667C2.6933 2.00001 2.50661 2.00001 2.36401 2.07267C2.23856 2.13659 2.13658 2.23858 2.07266 2.36402C2 2.50662 2 2.69331 2 3.06668V4.26668C2 4.64005 2 4.82673 2.07266 4.96934C2.13658 5.09478 2.23856 5.19677 2.36401 5.26068C2.50661 5.33334 2.6933 5.33334 3.06667 5.33334Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Ng)
      ])) : z("", !0),
      e.icon === "refresh-cw" ? (_(), P(me, { key: 66 }, [
        e.size === 12 ? (_(), P("svg", Fg, [
          M("g", Rg, [
            M("path", {
              d: "M10.5 5C10.5 5 9.49751 3.63411 8.68308 2.81912C7.86866 2.00413 6.7432 1.5 5.5 1.5C3.01472 1.5 1 3.51472 1 6C1 8.48528 3.01472 10.5 5.5 10.5C7.55155 10.5 9.28244 9.12714 9.82412 7.25M10.5 5V2M10.5 5H7.5",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Bg)
          ]),
          Vg
        ])) : (_(), P("svg", jg, [
          M("path", {
            d: "M14 6.66667C14 6.66667 12.6633 4.84548 11.5774 3.75883C10.4915 2.67218 8.99091 2 7.33331 2C4.0196 2 1.33331 4.68629 1.33331 8C1.33331 11.3137 4.0196 14 7.33331 14C10.0687 14 12.3766 12.1695 13.0988 9.66667M14 6.66667V2.66667M14 6.66667H9.99998",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Hg)
        ]))
      ], 64)) : z("", !0),
      e.icon === "search" ? (_(), P("svg", zg, [
        M("path", {
          d: "M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, qg)
      ])) : z("", !0),
      e.icon === "settings" ? (_(), P("svg", Ug, [
        M("g", Wg, [
          M("path", {
            d: "M8.00002 9.99999C9.10459 9.99999 10 9.10456 10 7.99999C10 6.89542 9.10459 5.99999 8.00002 5.99999C6.89545 5.99999 6.00002 6.89542 6.00002 7.99999C6.00002 9.10456 6.89545 9.99999 8.00002 9.99999Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Kg),
          M("path", {
            d: "M12.9334 9.99999C12.8446 10.2011 12.8181 10.4241 12.8574 10.6404C12.8966 10.8566 12.9997 11.0562 13.1534 11.2133L13.1934 11.2533C13.3173 11.3772 13.4157 11.5242 13.4828 11.6861C13.5499 11.8479 13.5844 12.0214 13.5844 12.1967C13.5844 12.3719 13.5499 12.5454 13.4828 12.7072C13.4157 12.8691 13.3173 13.0162 13.1934 13.14C13.0695 13.264 12.9225 13.3623 12.7606 13.4294C12.5987 13.4965 12.4252 13.531 12.25 13.531C12.0748 13.531 11.9013 13.4965 11.7394 13.4294C11.5776 13.3623 11.4305 13.264 11.3067 13.14L11.2667 13.1C11.1096 12.9463 10.91 12.8432 10.6937 12.804C10.4775 12.7648 10.2544 12.7912 10.0534 12.88C9.85617 12.9645 9.68801 13.1048 9.56956 13.2837C9.45111 13.4625 9.38754 13.6721 9.38669 13.8867V14C9.38669 14.3536 9.24621 14.6928 8.99616 14.9428C8.74611 15.1928 8.40698 15.3333 8.05335 15.3333C7.69973 15.3333 7.36059 15.1928 7.11055 14.9428C6.8605 14.6928 6.72002 14.3536 6.72002 14V13.94C6.71486 13.7193 6.64343 13.5053 6.51503 13.3258C6.38662 13.1463 6.20718 13.0095 6.00002 12.9333C5.79894 12.8446 5.57589 12.8181 5.35963 12.8573C5.14336 12.8965 4.94381 12.9996 4.78669 13.1533L4.74669 13.1933C4.62286 13.3173 4.4758 13.4156 4.31394 13.4827C4.15208 13.5498 3.97857 13.5844 3.80335 13.5844C3.62813 13.5844 3.45463 13.5498 3.29277 13.4827C3.1309 13.4156 2.98385 13.3173 2.86002 13.1933C2.73605 13.0695 2.63771 12.9224 2.57061 12.7606C2.50351 12.5987 2.46897 12.4252 2.46897 12.25C2.46897 12.0748 2.50351 11.9013 2.57061 11.7394C2.63771 11.5775 2.73605 11.4305 2.86002 11.3067L2.90002 11.2667C3.05371 11.1095 3.15681 10.91 3.19602 10.6937C3.23524 10.4775 3.20876 10.2544 3.12002 10.0533C3.03551 9.85614 2.89519 9.68798 2.71633 9.56953C2.53747 9.45108 2.32788 9.38751 2.11335 9.38666H2.00002C1.6464 9.38666 1.30726 9.24618 1.05721 8.99613C0.807163 8.74608 0.666687 8.40695 0.666687 8.05332C0.666687 7.6997 0.807163 7.36056 1.05721 7.11051C1.30726 6.86047 1.6464 6.71999 2.00002 6.71999H2.06002C2.28068 6.71483 2.49469 6.6434 2.67422 6.515C2.85375 6.38659 2.9905 6.20715 3.06669 5.99999C3.15543 5.79891 3.1819 5.57586 3.14269 5.3596C3.10348 5.14333 3.00038 4.94378 2.84669 4.78666L2.80669 4.74666C2.68272 4.62283 2.58437 4.47577 2.51727 4.31391C2.45018 4.15205 2.41564 3.97854 2.41564 3.80332C2.41564 3.6281 2.45018 3.4546 2.51727 3.29274C2.58437 3.13087 2.68272 2.98382 2.80669 2.85999C2.93052 2.73602 3.07757 2.63768 3.23943 2.57058C3.4013 2.50348 3.5748 2.46894 3.75002 2.46894C3.92524 2.46894 4.09874 2.50348 4.26061 2.57058C4.42247 2.63768 4.56952 2.73602 4.69335 2.85999L4.73335 2.89999C4.89047 3.05368 5.09003 3.15678 5.30629 3.19599C5.52256 3.23521 5.74561 3.20873 5.94669 3.11999H6.00002C6.1972 3.03548 6.36537 2.89516 6.48382 2.7163C6.60227 2.53744 6.66583 2.32785 6.66669 2.11332V1.99999C6.66669 1.64637 6.80716 1.30723 7.05721 1.05718C7.30726 0.807132 7.6464 0.666656 8.00002 0.666656C8.35364 0.666656 8.69278 0.807132 8.94283 1.05718C9.19288 1.30723 9.33335 1.64637 9.33335 1.99999V2.05999C9.33421 2.27451 9.39778 2.48411 9.51623 2.66297C9.63468 2.84183 9.80284 2.98215 10 3.06666C10.2011 3.1554 10.4241 3.18187 10.6404 3.14266C10.8567 3.10345 11.0562 3.00035 11.2134 2.84666L11.2534 2.80666C11.3772 2.68269 11.5242 2.58434 11.6861 2.51724C11.848 2.45014 12.0215 2.41561 12.1967 2.41561C12.3719 2.41561 12.5454 2.45014 12.7073 2.51724C12.8691 2.58434 13.0162 2.68269 13.14 2.80666C13.264 2.93049 13.3623 3.07754 13.4294 3.2394C13.4965 3.40127 13.5311 3.57477 13.5311 3.74999C13.5311 3.92521 13.4965 4.09871 13.4294 4.26058C13.3623 4.42244 13.264 4.56949 13.14 4.69332L13.1 4.73332C12.9463 4.89044 12.8432 5.09 12.804 5.30626C12.7648 5.52253 12.7913 5.74558 12.88 5.94666V5.99999C12.9645 6.19717 13.1049 6.36533 13.2837 6.48379C13.4626 6.60224 13.6722 6.6658 13.8867 6.66666H14C14.3536 6.66666 14.6928 6.80713 14.9428 7.05718C15.1929 7.30723 15.3334 7.64637 15.3334 7.99999C15.3334 8.35361 15.1929 8.69275 14.9428 8.9428C14.6928 9.19285 14.3536 9.33332 14 9.33332H13.94C13.7255 9.33418 13.5159 9.39774 13.337 9.5162C13.1582 9.63465 13.0179 9.80281 12.9334 9.99999Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Yg)
        ]),
        Gg
      ])) : z("", !0),
      e.icon === "share" ? (_(), P("svg", Zg, [
        M("path", {
          d: "M13.8609 8.40495C14.0237 8.26545 14.105 8.1957 14.1348 8.1127C14.161 8.03985 14.161 7.96017 14.1348 7.88732C14.105 7.80432 14.0237 7.73457 13.8609 7.59507L8.21375 2.75466C7.9336 2.51453 7.79353 2.39446 7.67493 2.39152C7.57186 2.38896 7.47341 2.43425 7.40828 2.51416C7.33333 2.60612 7.33333 2.79061 7.33333 3.15959V6.0231C5.91021 6.27207 4.60773 6.99318 3.63981 8.07592C2.58455 9.25635 2.00082 10.784 2 12.3673V12.7753C2.69956 11.9326 3.573 11.251 4.56051 10.7773C5.43113 10.3596 6.37228 10.1122 7.33333 10.047V12.8404C7.33333 13.2094 7.33333 13.3939 7.40828 13.4859C7.47341 13.5658 7.57186 13.6111 7.67493 13.6085C7.79353 13.6056 7.9336 13.4855 8.21375 13.2454L13.8609 8.40495Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Xg)
      ])) : z("", !0),
      e.icon === "slash" ? (_(), P(me, { key: 70 }, [
        e.size === 12 ? (_(), P("svg", Jg, [
          M("g", Qg, [
            M("path", {
              d: "M2.465 2.465L9.535 9.535M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.33",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, em)
          ]),
          tm
        ])) : e.size === 24 ? (_(), P("svg", nm, [
          M("path", {
            d: "M4.93 4.93L19.07 19.07M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, om)
        ])) : (_(), P("svg", im, [
          M("g", rm, [
            M("path", {
              d: "M3.28665 3.28665L12.7133 12.7133M14.6666 7.99998C14.6666 11.6819 11.6819 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6819 1.33331 7.99998C1.33331 4.31808 4.31808 1.33331 7.99998 1.33331C11.6819 1.33331 14.6666 4.31808 14.6666 7.99998Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, am)
          ]),
          lm
        ]))
      ], 64)) : z("", !0),
      e.icon === "slash-divider" ? (_(), P("svg", sm, [
        M("path", {
          d: "M5 14.5L11 1.5",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round"
        }, null, 8, um)
      ])) : z("", !0),
      e.icon === "slider" ? (_(), P("svg", dm, [
        M("g", cm, [
          M("path", {
            d: "M2.66669 14V9.33333M2.66669 6.66667V2M8.00002 14V8M8.00002 5.33333V2M13.3334 14V10.6667M13.3334 8V2M0.666687 9.33333H4.66669M6.00002 5.33333H10M11.3334 10.6667H15.3334",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, fm)
        ]),
        hm
      ])) : z("", !0),
      e.icon === "star" ? (_(), P(me, { key: 73 }, [
        e.size === 12 ? (_(), P("svg", gm, [
          M("g", mm, [
            M("path", {
              d: "M6 1L7.545 4.13L11 4.635L8.5 7.07L9.09 10.51L6 8.885L2.91 10.51L3.5 7.07L1 4.635L4.455 4.13L6 1Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, pm)
          ]),
          vm
        ])) : e.size === 24 ? (_(), P("svg", bm, [
          M("path", {
            d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, ym)
        ])) : (_(), P("svg", Cm, [
          M("path", {
            d: "M7.99998 1.33331L10.06 5.50665L14.6666 6.17998L11.3333 9.42665L12.12 14.0133L7.99998 11.8466L3.87998 14.0133L4.66665 9.42665L1.33331 6.17998L5.93998 5.50665L7.99998 1.33331Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, xm)
        ]))
      ], 64)) : z("", !0),
      e.icon === "star-02" ? (_(), P("svg", wm, [
        M("g", $m, [
          M("path", {
            d: "M2.99998 14.6666V11.3333M2.99998 4.66665V1.33331M1.33331 2.99998H4.66665M1.33331 13H4.66665M8.66665 1.99998L7.51053 5.00589C7.32252 5.49471 7.22852 5.73912 7.08233 5.9447C6.95277 6.12691 6.79358 6.28611 6.61137 6.41567C6.40578 6.56185 6.16137 6.65585 5.67255 6.84386L2.66665 7.99998L5.67255 9.1561C6.16137 9.34411 6.40578 9.43811 6.61137 9.58429C6.79358 9.71385 6.95277 9.87305 7.08233 10.0553C7.22852 10.2608 7.32252 10.5053 7.51053 10.9941L8.66665 14L9.82276 10.9941C10.0108 10.5053 10.1048 10.2608 10.251 10.0553C10.3805 9.87305 10.5397 9.71385 10.7219 9.58429C10.9275 9.43811 11.1719 9.34411 11.6607 9.1561L14.6666 7.99998L11.6607 6.84386C11.1719 6.65585 10.9275 6.56185 10.7219 6.41567C10.5397 6.28611 10.3805 6.12691 10.251 5.9447C10.1048 5.73912 10.0108 5.49471 9.82276 5.00589L8.66665 1.99998Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, km)
        ]),
        _m
      ])) : z("", !0),
      e.icon === "tag" ? (_(), P("svg", Om, [
        M("g", Em, [
          M("path", {
            d: "M5.33331 5.33331H5.33998M1.33331 3.46665L1.33331 6.44966C1.33331 6.77578 1.33331 6.93884 1.37015 7.09229C1.40282 7.22834 1.45669 7.35839 1.52979 7.47769C1.61225 7.61225 1.72755 7.72755 1.95815 7.95815L7.07057 13.0706C7.8626 13.8626 8.25862 14.2586 8.71528 14.407C9.11696 14.5375 9.54966 14.5375 9.95135 14.407C10.408 14.2586 10.804 13.8626 11.5961 13.0706L13.0706 11.5961C13.8626 10.804 14.2586 10.408 14.407 9.95135C14.5375 9.54966 14.5375 9.11696 14.407 8.71528C14.2586 8.25862 13.8626 7.8626 13.0706 7.07057L7.95815 1.95815C7.72755 1.72755 7.61225 1.61225 7.47769 1.52979C7.35839 1.45669 7.22834 1.40282 7.09229 1.37015C6.93884 1.33331 6.77578 1.33331 6.44966 1.33331L3.46665 1.33331C2.71991 1.33331 2.34654 1.33331 2.06133 1.47864C1.81044 1.60647 1.60647 1.81044 1.47864 2.06133C1.33331 2.34654 1.33331 2.71991 1.33331 3.46665ZM5.66665 5.33331C5.66665 5.51741 5.51741 5.66665 5.33331 5.66665C5.14922 5.66665 4.99998 5.51741 4.99998 5.33331C4.99998 5.14922 5.14922 4.99998 5.33331 4.99998C5.51741 4.99998 5.66665 5.14922 5.66665 5.33331Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Mm)
        ]),
        Sm
      ])) : z("", !0),
      e.icon === "toggle" ? (_(), P("svg", Am, [
        M("path", {
          d: "M11.3333 11.3334H4.66665C2.8257 11.3334 1.33331 9.84097 1.33331 8.00002C1.33331 6.15907 2.8257 4.66669 4.66665 4.66669H11.3333M11.3333 11.3334C13.1743 11.3334 14.6666 9.84097 14.6666 8.00002C14.6666 6.15907 13.1743 4.66669 11.3333 4.66669M11.3333 11.3334C9.49236 11.3334 7.99998 9.84097 7.99998 8.00002C7.99998 6.15907 9.49236 4.66669 11.3333 4.66669",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Tm)
      ])) : z("", !0),
      e.icon === "trash" ? (_(), P("svg", Pm, [
        M("path", {
          d: "M2 3.99998H3.33333M3.33333 3.99998H14M3.33333 3.99998L3.33333 13.3333C3.33333 13.6869 3.47381 14.0261 3.72386 14.2761C3.97391 14.5262 4.31304 14.6666 4.66667 14.6666H11.3333C11.687 14.6666 12.0261 14.5262 12.2761 14.2761C12.5262 14.0261 12.6667 13.6869 12.6667 13.3333V3.99998M5.33333 3.99998V2.66665C5.33333 2.31302 5.47381 1.97389 5.72386 1.72384C5.97391 1.47379 6.31304 1.33331 6.66667 1.33331H9.33333C9.68696 1.33331 10.0261 1.47379 10.2761 1.72384C10.5262 1.97389 10.6667 2.31302 10.6667 2.66665V3.99998M6.66667 7.33331V11.3333M9.33333 7.33331V11.3333",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Im)
      ])) : z("", !0),
      e.icon === "upload" ? (_(), P("svg", Dm, [
        M("g", Lm, [
          M("path", {
            d: "M10.6666 10.6667L7.99997 8.00001M7.99997 8.00001L5.33331 10.6667M7.99997 8.00001L7.99997 14M13.5933 12.26C14.2435 11.9055 14.7572 11.3446 15.0532 10.6658C15.3492 9.98692 15.4108 9.22883 15.2281 8.51114C15.0454 7.79344 14.629 7.15702 14.0444 6.70231C13.4599 6.2476 12.7405 6.0005 12 6.00001H11.16C10.9582 5.2195 10.5821 4.4949 10.0599 3.88067C9.5378 3.26644 8.8832 2.77858 8.14537 2.45375C7.40754 2.12892 6.60567 1.97558 5.80005 2.00526C4.99443 2.03495 4.20602 2.24688 3.49409 2.62512C2.78216 3.00336 2.16525 3.53808 1.68972 4.18906C1.2142 4.84005 0.892434 5.59037 0.748627 6.38361C0.60482 7.17684 0.64271 7.99236 0.859449 8.76885C1.07619 9.54534 1.46613 10.2626 1.99997 10.8667",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Nm)
        ]),
        Fm
      ])) : z("", !0),
      e.icon === "user" ? (_(), P("svg", Rm, [
        M("path", {
          d: "M13.3334 14V12.6667C13.3334 11.9594 13.0524 11.2811 12.5523 10.781C12.0522 10.281 11.3739 10 10.6667 10H5.33335C4.62611 10 3.94783 10.281 3.44774 10.781C2.94764 11.2811 2.66669 11.9594 2.66669 12.6667V14M10.6667 4.66667C10.6667 6.13943 9.47278 7.33333 8.00002 7.33333C6.52726 7.33333 5.33335 6.13943 5.33335 4.66667C5.33335 3.19391 6.52726 2 8.00002 2C9.47278 2 10.6667 3.19391 10.6667 4.66667Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Bm)
      ])) : z("", !0),
      e.icon === "user-right" ? (_(), P("svg", Vm, [
        M("path", {
          d: "M12.6666 14L14.6666 12M14.6666 12L12.6666 10M14.6666 12H10.6666M7.99998 10.3333H4.99998C4.0696 10.3333 3.60442 10.3333 3.22588 10.4482C2.37362 10.7067 1.70667 11.3736 1.44814 12.2259C1.33331 12.6044 1.33331 13.0696 1.33331 14M9.66665 5C9.66665 6.65685 8.3235 8 6.66665 8C5.00979 8 3.66665 6.65685 3.66665 5C3.66665 3.34315 5.00979 2 6.66665 2C8.3235 2 9.66665 3.34315 9.66665 5Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, jm)
      ])) : z("", !0),
      e.icon === "users" ? (_(), P(me, { key: 81 }, [
        e.size === 12 ? (_(), P("svg", Hm, [
          M("g", zm, [
            M("path", {
              d: "M8.5 10.5V9.5C8.5 8.96957 8.28929 8.46086 7.91421 8.08579C7.53914 7.71071 7.03043 7.5 6.5 7.5H2.5C1.96957 7.5 1.46086 7.71071 1.08579 8.08579C0.710714 8.46086 0.5 8.96957 0.5 9.5V10.5M11.5 10.5V9.5C11.4997 9.05686 11.3522 8.62639 11.0807 8.27616C10.8092 7.92593 10.4291 7.67578 10 7.565M8 1.565C8.43021 1.67515 8.81152 1.92535 9.08382 2.27616C9.35612 2.62696 9.50392 3.05841 9.50392 3.5025C9.50392 3.94659 9.35612 4.37804 9.08382 4.72884C8.81152 5.07965 8.43021 5.32985 8 5.44M6.5 3.5C6.5 4.60457 5.60457 5.5 4.5 5.5C3.39543 5.5 2.5 4.60457 2.5 3.5C2.5 2.39543 3.39543 1.5 4.5 1.5C5.60457 1.5 6.5 2.39543 6.5 3.5Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, qm)
          ]),
          Um
        ])) : (_(), P("svg", Wm, [
          M("g", Km, [
            M("path", {
              d: "M11.3334 14V12.6667C11.3334 11.9594 11.0524 11.2811 10.5523 10.781C10.0522 10.281 9.37393 10 8.66669 10H3.33335C2.62611 10 1.94783 10.281 1.44774 10.781C0.947639 11.2811 0.666687 11.9594 0.666687 12.6667V14M15.3334 14V12.6667C15.3329 12.0758 15.1363 11.5018 14.7743 11.0349C14.4123 10.5679 13.9054 10.2344 13.3334 10.0867M10.6667 2.08667C11.2403 2.23353 11.7487 2.56713 12.1118 3.03487C12.4748 3.50261 12.6719 4.07789 12.6719 4.67C12.6719 5.26211 12.4748 5.83739 12.1118 6.30513C11.7487 6.77287 11.2403 7.10647 10.6667 7.25333M8.66669 4.66667C8.66669 6.13943 7.47278 7.33333 6.00002 7.33333C4.52726 7.33333 3.33335 6.13943 3.33335 4.66667C3.33335 3.19391 4.52726 2 6.00002 2C7.47278 2 8.66669 3.19391 8.66669 4.66667Z",
              stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Ym)
          ]),
          Gm
        ]))
      ], 64)) : z("", !0),
      e.icon === "users-plus" ? (_(), P(me, { key: 82 }, [
        e.size === 24 ? (_(), P("svg", Zm, [
          M("path", {
            d: "M19 21V15M16 18H22M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Xm)
        ])) : (_(), P("svg", Jm, [
          M("path", {
            d: "M12.6666 14V10M10.6666 12H14.6666M7.99998 10H5.33331C4.0908 10 3.46955 10 2.97949 10.203C2.32608 10.4736 1.80695 10.9928 1.5363 11.6462C1.33331 12.1362 1.33331 12.7575 1.33331 14M10.3333 2.19384C11.3106 2.58943 12 3.54754 12 4.66667C12 5.78579 11.3106 6.7439 10.3333 7.13949M8.99998 4.66667C8.99998 6.13943 7.80607 7.33333 6.33331 7.33333C4.86055 7.33333 3.66665 6.13943 3.66665 4.66667C3.66665 3.19391 4.86055 2 6.33331 2C7.80607 2 8.99998 3.19391 8.99998 4.66667Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Qm)
        ]))
      ], 64)) : z("", !0),
      e.icon === "briefcase" ? (_(), P("svg", e4, [
        M("path", {
          d: "M10.6667 4.66667C10.6667 4.04669 10.6667 3.7367 10.5985 3.48236C10.4136 2.79218 9.87449 2.25308 9.18431 2.06815C8.92997 2 8.61998 2 8 2C7.38002 2 7.07003 2 6.8157 2.06815C6.12551 2.25308 5.58642 2.79218 5.40148 3.48236C5.33334 3.7367 5.33334 4.04669 5.33334 4.66667M3.46667 14H12.5333C13.2801 14 13.6534 14 13.9387 13.8547C14.1895 13.7268 14.3935 13.5229 14.5213 13.272C14.6667 12.9868 14.6667 12.6134 14.6667 11.8667V6.8C14.6667 6.05326 14.6667 5.6799 14.5213 5.39468C14.3935 5.1438 14.1895 4.93982 13.9387 4.81199C13.6534 4.66667 13.2801 4.66667 12.5333 4.66667H3.46667C2.71993 4.66667 2.34656 4.66667 2.06135 4.81199C1.81047 4.93982 1.60649 5.1438 1.47866 5.39468C1.33334 5.6799 1.33334 6.05326 1.33334 6.8V11.8667C1.33334 12.6134 1.33334 12.9868 1.47866 13.272C1.60649 13.5229 1.81047 13.7268 2.06135 13.8547C2.34656 14 2.71993 14 3.46667 14Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, t4)
      ])) : z("", !0),
      e.icon === "drag-drop" ? (_(), P("svg", n4, [
        M("path", {
          d: "M5.49665 8.65997C5.86484 8.65997 6.16332 8.3615 6.16332 7.99331C6.16332 7.62512 5.86484 7.32664 5.49665 7.32664C5.12846 7.32664 4.82999 7.62512 4.82999 7.99331C4.82999 8.3615 5.12846 8.65997 5.49665 8.65997Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, o4),
        M("path", {
          d: "M5.49665 3.99331C5.86484 3.99331 6.16332 3.69483 6.16332 3.32664C6.16332 2.95845 5.86484 2.65997 5.49665 2.65997C5.12846 2.65997 4.82999 2.95845 4.82999 3.32664C4.82999 3.69483 5.12846 3.99331 5.49665 3.99331Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, i4),
        M("path", {
          d: "M5.49665 13.3266C5.86484 13.3266 6.16332 13.0282 6.16332 12.66C6.16332 12.2918 5.86484 11.9933 5.49665 11.9933C5.12846 11.9933 4.82999 12.2918 4.82999 12.66C4.82999 13.0282 5.12846 13.3266 5.49665 13.3266Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, r4),
        M("path", {
          d: "M10.4967 8.65997C10.8648 8.65997 11.1633 8.3615 11.1633 7.99331C11.1633 7.62512 10.8648 7.32664 10.4967 7.32664C10.1285 7.32664 9.82999 7.62512 9.82999 7.99331C9.82999 8.3615 10.1285 8.65997 10.4967 8.65997Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, a4),
        M("path", {
          d: "M10.4967 3.99331C10.8648 3.99331 11.1633 3.69483 11.1633 3.32664C11.1633 2.95845 10.8648 2.65997 10.4967 2.65997C10.1285 2.65997 9.82999 2.95845 9.82999 3.32664C9.82999 3.69483 10.1285 3.99331 10.4967 3.99331Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, l4),
        M("path", {
          d: "M10.4967 13.3266C10.8648 13.3266 11.1633 13.0282 11.1633 12.66C11.1633 12.2918 10.8648 11.9933 10.4967 11.9933C10.1285 11.9933 9.82999 12.2918 9.82999 12.66C9.82999 13.0282 10.1285 13.3266 10.4967 13.3266Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, s4)
      ])) : z("", !0),
      e.icon === "globe" ? (_(), P("svg", u4, [
        M("g", d4, [
          M("path", {
            d: "M2.05064 4.98853L4.90933 7.03042C5.05808 7.13666 5.13246 7.18979 5.2103 7.20203C5.27879 7.2128 5.34894 7.20195 5.41097 7.17098C5.48147 7.13578 5.53631 7.06266 5.64599 6.91642L6.25006 6.11099C6.28107 6.06964 6.29658 6.04896 6.31481 6.03112C6.33099 6.01528 6.34875 6.00113 6.3678 5.9889C6.38926 5.97511 6.41288 5.96462 6.46012 5.94362L9.03918 4.79737C9.14609 4.74986 9.19954 4.7261 9.23985 4.689C9.2755 4.65618 9.30357 4.61598 9.3221 4.57121C9.34305 4.52058 9.34694 4.46222 9.35472 4.34548L9.54356 1.51292M8.99998 8.99998L10.744 9.74741C10.9463 9.83413 11.0475 9.87749 11.1011 9.94951C11.1481 10.0127 11.1712 10.0905 11.1664 10.1691C11.1608 10.2587 11.0998 10.3503 10.9777 10.5335L10.1583 11.7625C10.1004 11.8493 10.0715 11.8927 10.0332 11.9242C9.99938 11.952 9.96038 11.9729 9.91845 11.9856C9.87108 12 9.8189 12 9.71455 12H8.38439C8.24615 12 8.17704 12 8.11823 11.9769C8.0663 11.9564 8.02033 11.9233 7.98453 11.8805C7.94399 11.832 7.92213 11.7664 7.87842 11.6353L7.40317 10.2096C7.37739 10.1322 7.3645 10.0935 7.3611 10.0542C7.3581 10.0194 7.36059 9.98428 7.3685 9.9502C7.37742 9.91177 7.39565 9.87531 7.43211 9.80239L7.79312 9.08037C7.86647 8.93367 7.90314 8.86032 7.95963 8.81479C8.00941 8.77465 8.06968 8.74969 8.13326 8.74286C8.20541 8.73512 8.2832 8.76105 8.4388 8.81292L8.99998 8.99998ZM14.6666 7.99998C14.6666 11.6819 11.6819 14.6666 7.99998 14.6666C4.31808 14.6666 1.33331 11.6819 1.33331 7.99998C1.33331 4.31808 4.31808 1.33331 7.99998 1.33331C11.6819 1.33331 14.6666 4.31808 14.6666 7.99998Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, c4)
        ]),
        f4
      ])) : z("", !0),
      e.icon === "graduation-hat" ? (_(), P("svg", h4, [
        M("path", {
          d: "M3.33331 6.66667V10.6741C3.33331 10.9134 3.33331 11.0331 3.36975 11.1387C3.40197 11.2321 3.45456 11.3172 3.5237 11.3878C3.60189 11.4676 3.70891 11.5211 3.92295 11.6282L7.52295 13.4282C7.69786 13.5156 7.78532 13.5593 7.87705 13.5765C7.95829 13.5918 8.04167 13.5918 8.12291 13.5765C8.21464 13.5593 8.30211 13.5156 8.47701 13.4282L12.077 11.6282C12.291 11.5211 12.3981 11.4676 12.4763 11.3878C12.5454 11.3172 12.598 11.2321 12.6302 11.1387C12.6666 11.0331 12.6666 10.9134 12.6666 10.6741V6.66667M1.33331 5.66667L7.76147 2.45259C7.84892 2.40887 7.89265 2.387 7.93851 2.3784C7.97914 2.37078 8.02082 2.37078 8.06145 2.3784C8.10731 2.387 8.15104 2.40887 8.23849 2.45259L14.6666 5.66667L8.23849 8.88075C8.15104 8.92447 8.10731 8.94634 8.06145 8.95494C8.02082 8.96256 7.97914 8.96256 7.93851 8.95494C7.89265 8.94634 7.84892 8.92447 7.76147 8.88075L1.33331 5.66667Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, g4)
      ])) : z("", !0),
      e.icon === "marker-pin" ? (_(), P("svg", m4, [
        M("path", {
          d: "M8.00002 8.66668C9.10459 8.66668 10 7.77125 10 6.66668C10 5.56211 9.10459 4.66668 8.00002 4.66668C6.89545 4.66668 6.00002 5.56211 6.00002 6.66668C6.00002 7.77125 6.89545 8.66668 8.00002 8.66668Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, p4),
        M("path", {
          d: "M8.00002 14.6667C10.6667 12 13.3334 9.61219 13.3334 6.66668C13.3334 3.72116 10.9455 1.33334 8.00002 1.33334C5.0545 1.33334 2.66669 3.72116 2.66669 6.66668C2.66669 9.61219 5.33335 12 8.00002 14.6667Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, v4)
      ])) : z("", !0),
      e.icon === "pie-chart" ? (_(), P("svg", b4, [
        M("g", y4, [
          M("path", {
            d: "M14.1402 10.5933C13.7161 11.5963 13.0528 12.4801 12.2082 13.1675C11.3636 13.8549 10.3634 14.325 9.29521 14.5365C8.22698 14.7481 7.1232 14.6948 6.08035 14.3812C5.0375 14.0676 4.08733 13.5034 3.31293 12.7378C2.53852 11.9722 1.96346 11.0285 1.63801 9.98931C1.31255 8.9501 1.24662 7.847 1.44598 6.77643C1.64534 5.70586 2.10391 4.70042 2.78161 3.84803C3.45931 2.99563 4.3355 2.32222 5.33358 1.88667M14.1594 5.44878C14.4263 6.09309 14.59 6.77425 14.6456 7.46723C14.6593 7.63843 14.6662 7.72403 14.6322 7.80114C14.6038 7.86555 14.5475 7.9265 14.4856 7.95996C14.4115 8.00001 14.3188 8.00001 14.1336 8.00001H8.53358C8.3469 8.00001 8.25356 8.00001 8.18225 7.96367C8.11953 7.93172 8.06854 7.88072 8.03658 7.818C8.00025 7.7467 8.00025 7.65336 8.00025 7.46667V1.86667C8.00025 1.68143 8.00025 1.58881 8.0403 1.51466C8.07375 1.45272 8.1347 1.39646 8.19911 1.36807C8.27622 1.33407 8.36182 1.34094 8.53302 1.35466C9.22601 1.41022 9.90716 1.57393 10.5515 1.84081C11.3603 2.17584 12.0952 2.6669 12.7143 3.28596C13.3334 3.90502 13.8244 4.63995 14.1594 5.44878Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, C4)
        ]),
        x4
      ])) : z("", !0),
      e.icon === "widget-br" ? (_(), P("svg", w4, [
        M("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM8.25 9.5C8.25 9.08579 8.58579 8.75 9 8.75H11.5C11.9142 8.75 12.25 9.08579 12.25 9.5V11.5C12.25 11.9142 11.9142 12.25 11.5 12.25H9C8.58579 12.25 8.25 11.9142 8.25 11.5V9.5ZM9.75 10.25V10.75H10.75V10.25H9.75Z",
          fill: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27"
        }, null, 8, $4)
      ])) : z("", !0),
      e.icon === "widget-bl" ? (_(), P("svg", k4, [
        M("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM3.75 9.5C3.75 9.08579 4.08579 8.75 4.5 8.75H7C7.41421 8.75 7.75 9.08579 7.75 9.5V11.5C7.75 11.9142 7.41421 12.25 7 12.25H4.5C4.08579 12.25 3.75 11.9142 3.75 11.5V9.5ZM5.25 10.25V10.75H6.25V10.25H5.25Z",
          fill: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27"
        }, null, 8, _4)
      ])) : z("", !0),
      e.icon === "widget-tr" ? (_(), P("svg", O4, [
        M("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM8.25 4.5C8.25 4.08579 8.58579 3.75 9 3.75H11.5C11.9142 3.75 12.25 4.08579 12.25 4.5V6.5C12.25 6.91421 11.9142 7.25 11.5 7.25H9C8.58579 7.25 8.25 6.91421 8.25 6.5V4.5ZM9.75 5.25V5.75H10.75V5.25H9.75Z",
          fill: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27"
        }, null, 8, E4)
      ])) : z("", !0),
      e.icon === "widget-tl" ? (_(), P("svg", M4, [
        M("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.16957 1.25H10.8304C11.3646 1.24999 11.8104 1.24998 12.1747 1.27974C12.5546 1.31078 12.9112 1.37789 13.2485 1.54973C13.7659 1.81338 14.1866 2.23408 14.4503 2.75153C14.6221 3.08879 14.6892 3.44545 14.7203 3.82533C14.75 4.18956 14.75 4.6354 14.75 5.16955V10.8305C14.75 11.3646 14.75 11.8104 14.7203 12.1747C14.6892 12.5546 14.6221 12.9112 14.4503 13.2485C14.1866 13.7659 13.7659 14.1866 13.2485 14.4503C12.9112 14.6221 12.5546 14.6892 12.1747 14.7203C11.8104 14.75 11.3646 14.75 10.8305 14.75H5.16955C4.6354 14.75 4.18956 14.75 3.82533 14.7203C3.44545 14.6892 3.08879 14.6221 2.75153 14.4503C2.23408 14.1866 1.81338 13.7659 1.54973 13.2485C1.37789 12.9112 1.31078 12.5546 1.27974 12.1747C1.24998 11.8104 1.24999 11.3646 1.25 10.8304V5.16957C1.24999 4.63541 1.24998 4.18956 1.27974 3.82533C1.31078 3.44545 1.37789 3.08879 1.54973 2.75153C1.81338 2.23408 2.23408 1.81338 2.75153 1.54973C3.08879 1.37789 3.44545 1.31078 3.82533 1.27974C4.18956 1.24998 4.63541 1.24999 5.16957 1.25ZM3.94748 2.77476C3.66036 2.79822 3.52307 2.8401 3.43251 2.88624C3.19731 3.00608 3.00608 3.19731 2.88624 3.43251C2.8401 3.52307 2.79822 3.66036 2.77476 3.94748C2.75058 4.24336 2.75 4.62757 2.75 5.2V10.8C2.75 11.3724 2.75058 11.7566 2.77476 12.0525C2.79822 12.3396 2.8401 12.4769 2.88624 12.5675C3.00608 12.8027 3.19731 12.9939 3.43251 13.1138C3.52307 13.1599 3.66036 13.2018 3.94748 13.2252C4.24336 13.2494 4.62757 13.25 5.2 13.25H10.8C11.3724 13.25 11.7566 13.2494 12.0525 13.2252C12.3396 13.2018 12.4769 13.1599 12.5675 13.1138C12.8027 12.9939 12.9939 12.8027 13.1138 12.5675C13.1599 12.4769 13.2018 12.3396 13.2252 12.0525C13.2494 11.7566 13.25 11.3724 13.25 10.8V5.2C13.25 4.62757 13.2494 4.24336 13.2252 3.94748C13.2018 3.66036 13.1599 3.52307 13.1138 3.43251C12.9939 3.19731 12.8027 3.00608 12.5675 2.88624C12.4769 2.8401 12.3396 2.79822 12.0525 2.77476C11.7566 2.75058 11.3724 2.75 10.8 2.75H5.2C4.62757 2.75 4.24336 2.75058 3.94748 2.77476ZM3.75 4.5C3.75 4.08579 4.08579 3.75 4.5 3.75H7C7.41421 3.75 7.75 4.08579 7.75 4.5V6.5C7.75 6.91421 7.41421 7.25 7 7.25H4.5C4.08579 7.25 3.75 6.91421 3.75 6.5V4.5ZM5.25 5.25V5.75H6.25V5.25H5.25Z",
          fill: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27"
        }, null, 8, S4)
      ])) : z("", !0),
      e.icon === "flex-align-top" ? (_(), P("svg", A4, [
        M("path", {
          d: "M11.6667 4.33333L4.33333 4.33333M5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, T4)
      ])) : z("", !0),
      e.icon === "flex-align-bottom" ? (_(), P("svg", P4, [
        M("path", {
          d: "M11.6667 11.7333L4.33333 11.7333M5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, I4)
      ])) : z("", !0),
      e.icon === "image-user" ? (_(), P("svg", D4, [
        M("g", L4, [
          M("path", {
            d: "M2.66666 14.5449C3.06838 14.6666 3.61097 14.6666 4.53331 14.6666H11.4666C12.389 14.6666 12.9316 14.6666 13.3333 14.5449M2.66666 14.5449C2.58053 14.5188 2.50087 14.4871 2.42533 14.4487C2.04901 14.2569 1.74305 13.951 1.5513 13.5746C1.33331 13.1468 1.33331 12.5868 1.33331 11.4666V4.53331C1.33331 3.41321 1.33331 2.85316 1.5513 2.42533C1.74305 2.04901 2.04901 1.74305 2.42533 1.5513C2.85316 1.33331 3.41321 1.33331 4.53331 1.33331H11.4666C12.5868 1.33331 13.1468 1.33331 13.5746 1.5513C13.951 1.74305 14.2569 2.04901 14.4487 2.42533C14.6666 2.85316 14.6666 3.41321 14.6666 4.53331V11.4666C14.6666 12.5868 14.6666 13.1468 14.4487 13.5746C14.2569 13.951 13.951 14.2569 13.5746 14.4487C13.4991 14.4871 13.4194 14.5188 13.3333 14.5449M2.66666 14.5449C2.66688 14.0054 2.67012 13.7199 2.71789 13.4797C2.9283 12.4219 3.75523 11.595 4.81307 11.3846C5.07067 11.3333 5.38044 11.3333 5.99998 11.3333H9.99998C10.6195 11.3333 10.9293 11.3333 11.1869 11.3846C12.2447 11.595 13.0717 12.4219 13.2821 13.4797C13.3298 13.7199 13.3331 14.0054 13.3333 14.5449M10.6666 6.33331C10.6666 7.80607 9.47274 8.99998 7.99998 8.99998C6.52722 8.99998 5.33331 7.80607 5.33331 6.33331C5.33331 4.86055 6.52722 3.66665 7.99998 3.66665C9.47274 3.66665 10.6666 4.86055 10.6666 6.33331Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, N4)
        ]),
        F4
      ])) : z("", !0),
      e.icon === "grid-03" ? (_(), P("svg", R4, [
        M("path", {
          d: "M5.33333 2H4.13333C3.3866 2 3.01323 2 2.72801 2.14532C2.47713 2.27316 2.27316 2.47713 2.14532 2.72801C2 3.01323 2 3.3866 2 4.13333V5.33333M5.33333 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V10.6667M14 5.33333V4.13333C14 3.3866 14 3.01323 13.8547 2.72801C13.7268 2.47713 13.5229 2.27316 13.272 2.14532C12.9868 2 12.6134 2 11.8667 2H10.6667M14 10.6667V11.8667C14 12.6134 14 12.9868 13.8547 13.272C13.7268 13.5229 13.5229 13.7268 13.272 13.8547C12.9868 14 12.6134 14 11.8667 14H10.6667M10.6667 8C10.6667 9.47276 9.47276 10.6667 8 10.6667C6.52724 10.6667 5.33333 9.47276 5.33333 8C5.33333 6.52724 6.52724 5.33333 8 5.33333C9.47276 5.33333 10.6667 6.52724 10.6667 8Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, B4)
      ])) : z("", !0),
      e.icon === "phone-01" ? (_(), P("svg", V4, [
        M("path", {
          d: "M7.99998 11.6666H8.00665M5.46665 14.6666H10.5333C11.2801 14.6666 11.6534 14.6666 11.9386 14.5213C12.1895 14.3935 12.3935 14.1895 12.5213 13.9386C12.6666 13.6534 12.6666 13.28 12.6666 12.5333V3.46665C12.6666 2.71991 12.6666 2.34654 12.5213 2.06133C12.3935 1.81044 12.1895 1.60647 11.9386 1.47864C11.6534 1.33331 11.28 1.33331 10.5333 1.33331H5.46665C4.71991 1.33331 4.34654 1.33331 4.06133 1.47864C3.81044 1.60647 3.60647 1.81044 3.47864 2.06133C3.33331 2.34654 3.33331 2.71991 3.33331 3.46665V12.5333C3.33331 13.28 3.33331 13.6534 3.47864 13.9386C3.60647 14.1895 3.81044 14.3935 4.06133 14.5213C4.34654 14.6666 4.71991 14.6666 5.46665 14.6666ZM8.33331 11.6666C8.33331 11.8507 8.18407 12 7.99998 12C7.81588 12 7.66665 11.8507 7.66665 11.6666C7.66665 11.4826 7.81588 11.3333 7.99998 11.3333C8.18407 11.3333 8.33331 11.4826 8.33331 11.6666Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, j4)
      ])) : z("", !0),
      e.icon === "bar-chart" ? (_(), P("svg", H4, [
        M("path", {
          d: "M6 4.66667H3.06667C2.6933 4.66667 2.50661 4.66667 2.36401 4.73933C2.23856 4.80324 2.13658 4.90523 2.07266 5.03067C2 5.17328 2 5.35997 2 5.73333V12.9333C2 13.3067 2 13.4934 2.07266 13.636C2.13658 13.7614 2.23856 13.8634 2.36401 13.9273C2.50661 14 2.6933 14 3.06667 14H6M6 14H10M6 14L6 3.06667C6 2.6933 6 2.50661 6.07266 2.36401C6.13658 2.23857 6.23857 2.13658 6.36401 2.07266C6.50661 2 6.6933 2 7.06667 2L8.93333 2C9.3067 2 9.49339 2 9.63599 2.07266C9.76144 2.13658 9.86342 2.23856 9.92734 2.36401C10 2.50661 10 2.6933 10 3.06667V14M10 7.33333H12.9333C13.3067 7.33333 13.4934 7.33333 13.636 7.406C13.7614 7.46991 13.8634 7.5719 13.9273 7.69734C14 7.83995 14 8.02663 14 8.4V12.9333C14 13.3067 14 13.4934 13.9273 13.636C13.8634 13.7614 13.7614 13.8634 13.636 13.9273C13.4934 14 13.3067 14 12.9333 14H10",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, z4)
      ])) : z("", !0),
      e.icon === "home" ? (_(), P("svg", q4, [
        M("path", {
          d: "M5.33333 11.3333H10.6667M7.34513 1.84268L2.82359 5.35943C2.52135 5.59451 2.37022 5.71205 2.26135 5.85925C2.16491 5.98964 2.09307 6.13654 2.04935 6.29272C2 6.46903 2 6.66048 2 7.04338V11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27316 13.5229 2.47713 13.7268 2.72801 13.8547C3.01323 14 3.3866 14 4.13333 14H11.8667C12.6134 14 12.9868 14 13.272 13.8547C13.5229 13.7268 13.7268 13.5229 13.8547 13.272C14 12.9868 14 12.6134 14 11.8667V7.04338C14 6.66048 14 6.46903 13.9506 6.29272C13.9069 6.13654 13.8351 5.98964 13.7386 5.85925C13.6298 5.71205 13.4787 5.59451 13.1764 5.35943L8.65487 1.84268C8.42065 1.66051 8.30354 1.56943 8.17423 1.53442C8.06013 1.50352 7.93987 1.50352 7.82577 1.53442C7.69646 1.56943 7.57935 1.66051 7.34513 1.84268Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, U4)
      ])) : z("", !0),
      e.icon === "palette" ? (_(), P("svg", W4, [
        M("g", K4, [
          M("path", {
            d: "M1.33337 7.99998C1.33337 11.6819 4.31814 14.6666 8.00004 14.6666C9.10461 14.6666 10 13.7712 10 12.6666V12.3333C10 12.0237 10 11.8689 10.0172 11.7389C10.1353 10.8415 10.8415 10.1352 11.739 10.0171C11.869 9.99998 12.0238 9.99998 12.3334 9.99998H12.6667C13.7713 9.99998 14.6667 9.10455 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00004 1.33331C4.31814 1.33331 1.33337 4.31808 1.33337 7.99998Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Y4),
          M("path", {
            d: "M4.66671 8.66665C5.0349 8.66665 5.33337 8.36817 5.33337 7.99998C5.33337 7.63179 5.0349 7.33331 4.66671 7.33331C4.29852 7.33331 4.00004 7.63179 4.00004 7.99998C4.00004 8.36817 4.29852 8.66665 4.66671 8.66665Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, G4),
          M("path", {
            d: "M10.6667 5.99998C11.0349 5.99998 11.3334 5.7015 11.3334 5.33331C11.3334 4.96512 11.0349 4.66665 10.6667 4.66665C10.2985 4.66665 10 4.96512 10 5.33331C10 5.7015 10.2985 5.99998 10.6667 5.99998Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Z4),
          M("path", {
            d: "M6.66671 5.33331C7.0349 5.33331 7.33337 5.03484 7.33337 4.66665C7.33337 4.29846 7.0349 3.99998 6.66671 3.99998C6.29852 3.99998 6.00004 4.29846 6.00004 4.66665C6.00004 5.03484 6.29852 5.33331 6.66671 5.33331Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, X4)
        ]),
        J4
      ])) : z("", !0),
      e.icon === "puzzle-piece" ? (_(), P("svg", Q4, [
        M("g", ep, [
          M("path", {
            d: "M8.00004 1.33334L10.4 3.73334C12 -0.466657 16.4667 4.00001 12.2667 5.60001L14.6667 8.00001L12.2667 10.4C10.6667 6.20001 6.20004 10.6667 10.4 12.2667L8.00004 14.6667L5.60004 12.2667C4.00004 16.4667 -0.466626 12 3.73337 10.4L1.33337 8.00001L3.73337 5.60001C5.33337 9.80001 9.80004 5.33334 5.60004 3.73334L8.00004 1.33334Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, tp)
        ]),
        np
      ])) : z("", !0),
      e.icon === "save" ? (_(), P("svg", op, [
        M("path", {
          d: "M4.08333 1.75V3.73333C4.08333 4.06003 4.08333 4.22338 4.14691 4.34816C4.20284 4.45792 4.29208 4.54716 4.40184 4.60309C4.52662 4.66667 4.68997 4.66667 5.01667 4.66667H8.98333C9.31003 4.66667 9.47338 4.66667 9.59816 4.60309C9.70792 4.54716 9.79716 4.45792 9.85309 4.34816C9.91667 4.22338 9.91667 4.06003 9.91667 3.73333V2.33333M9.91667 12.25V8.51667C9.91667 8.18997 9.91667 8.02662 9.85309 7.90184C9.79716 7.79208 9.70792 7.70284 9.59816 7.64691C9.47338 7.58333 9.31003 7.58333 8.98333 7.58333H5.01667C4.68997 7.58333 4.52662 7.58333 4.40184 7.64691C4.29208 7.70284 4.20284 7.79208 4.14691 7.90184C4.08333 8.02662 4.08333 8.18997 4.08333 8.51667V12.25M12.25 5.43987V9.45C12.25 10.4301 12.25 10.9201 12.0593 11.2945C11.8915 11.6238 11.6238 11.8915 11.2945 12.0593C10.9201 12.25 10.4301 12.25 9.45 12.25H4.55C3.56991 12.25 3.07986 12.25 2.70552 12.0593C2.37623 11.8915 2.10852 11.6238 1.94074 11.2945C1.75 10.9201 1.75 10.4301 1.75 9.45V4.55C1.75 3.56991 1.75 3.07986 1.94074 2.70552C2.10852 2.37623 2.37623 2.10852 2.70552 1.94074C3.07986 1.75 3.56991 1.75 4.55 1.75H8.56013C8.84549 1.75 8.98817 1.75 9.12244 1.78224C9.24148 1.81081 9.35528 1.85795 9.45967 1.92192C9.5774 1.99407 9.67829 2.09496 9.88007 2.29673L11.7033 4.11993C11.905 4.32171 12.0059 4.4226 12.0781 4.54033C12.142 4.64472 12.1892 4.75852 12.2178 4.87756C12.25 5.01183 12.25 5.15451 12.25 5.43987Z",
          stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ip)
      ])) : z("", !0),
      e.icon === "heart-hand" ? (_(), P("svg", rp, [
        M("g", ap, [
          M("path", {
            d: "M4 13.3914H5.7402C5.96709 13.3914 6.19259 13.4184 6.41254 13.4724L8.25126 13.9193C8.65023 14.0164 9.06585 14.0259 9.46898 13.9476L11.502 13.5521C12.039 13.4475 12.5331 13.1903 12.9202 12.8137L14.3586 11.4145C14.7694 11.0156 14.7694 10.3683 14.3586 9.96871C13.9888 9.60896 13.4032 9.56846 12.9848 9.87354L11.3084 11.0966C11.0683 11.2721 10.7762 11.3666 10.4758 11.3666H8.857L9.88738 11.3665C10.4681 11.3665 10.9386 10.9089 10.9386 10.3439V10.1394C10.9386 9.67033 10.6104 9.26131 10.1427 9.14792L8.5524 8.76116C8.29359 8.69839 8.02854 8.66667 7.7621 8.66667C7.11889 8.66667 5.9546 9.19921 5.9546 9.19921L4 10.0166M1.33334 9.73334L1.33334 13.6C1.33334 13.9734 1.33334 14.1601 1.406 14.3027C1.46991 14.4281 1.5719 14.5301 1.69734 14.594C1.83995 14.6667 2.02663 14.6667 2.4 14.6667H2.93334C3.3067 14.6667 3.49339 14.6667 3.636 14.594C3.76144 14.5301 3.86342 14.4281 3.92734 14.3027C4 14.1601 4 13.9734 4 13.6V9.73334C4 9.35997 4 9.17328 3.92734 9.03067C3.86342 8.90523 3.76144 8.80325 3.636 8.73933C3.49339 8.66667 3.3067 8.66667 2.93334 8.66667H2.4C2.02663 8.66667 1.83995 8.66667 1.69734 8.73933C1.5719 8.80325 1.46991 8.90523 1.406 9.03067C1.33334 9.17328 1.33334 9.35997 1.33334 9.73334ZM11.4609 2.39484C11.063 1.56227 10.1457 1.12119 9.25362 1.54692C8.36153 1.97264 7.98147 2.98225 8.35497 3.86855C8.58581 4.41631 9.24717 5.48 9.71873 6.21269C9.89296 6.48341 9.98008 6.61877 10.1073 6.69795C10.2165 6.76587 10.3531 6.80249 10.4816 6.79824C10.6314 6.79328 10.7745 6.71962 11.0608 6.57229C11.8355 6.17354 12.9401 5.58304 13.4139 5.22408C14.1805 4.64328 14.3704 3.57572 13.7964 2.76416C13.2225 1.9526 12.2218 1.87275 11.4609 2.39484Z",
            stroke: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, lp)
        ]),
        M("defs", null, [
          M("clipPath", sp, [
            M("rect", {
              width: "16",
              height: "16",
              fill: e.color ? t.value && e.hoverColor ? e.hoverColor : e.color : "#1C1F27"
            }, null, 8, up)
          ])
        ])
      ])) : z("", !0)
    ], 38));
  }
}), dp = { class: "ml-2" }, cp = { class: "block text-mgm-txt-xs font-normal text-foreground-default" }, bA = /* @__PURE__ */ re({
  __name: "BaseAlert",
  props: {
    open: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "default"
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  },
  setup(e) {
    const n = e, t = ee(() => n.type === "default" ? {
      background: "bg-background-subtle",
      color: "#1C1F27",
      icon: "info"
    } : n.type === "info" ? {
      background: "bg-background-brand-default",
      color: "#444CE7",
      icon: "info"
    } : n.type === "success" ? {
      background: "bg-background-success-default",
      color: "#03874C",
      icon: "check-circle"
    } : n.type === "attention" ? {
      background: "bg-background-warning-default",
      color: "#B25504",
      icon: "alert-triangle"
    } : n.type === "error" ? {
      background: "bg-background-danger-default",
      color: "#D92D20",
      icon: "slash"
    } : {
      background: "bg-background-subtle",
      color: "#1C1F27",
      icon: "info"
    });
    return (o, i) => e.open ? (_(), P("div", {
      key: 0,
      class: pe([
        "fixed bottom-6 right-6 z-[2000000] flex min-w-[343px] max-w-[400px] items-start rounded-[5px] p-3 shadow-[0px_12px_16px_-4px_rgba(28,31,39,0.08),0px_4px_6px_-2px_rgba(28,31,39,0.03)]",
        t.value.background
      ])
    }, [
      ce(Le, {
        class: "pt-px",
        color: t.value.color,
        icon: t.value.icon
      }, null, 8, ["color", "icon"]),
      M("p", dp, [
        M("span", {
          class: "block text-mgm-txt-sm font-medium",
          style: Ye({ color: t.value.color })
        }, de(e.title), 5),
        M("span", cp, de(e.description), 1)
      ])
    ], 2)) : z("", !0);
  }
}), fp = ["alt", "src"], hp = { class: "uppercase" }, gp = {
  key: 1,
  class: "flex items-center space-x-2 text-foreground-emphasis"
}, mp = { class: "flex flex-shrink-0 -space-x-1" }, pp = {
  key: 0,
  class: "flex-shrink-0"
}, vp = { key: 1 }, yA = /* @__PURE__ */ re({
  __name: "BaseAvatar",
  props: {
    type: {
      type: String,
      default: "single"
    },
    size: {
      type: String,
      default: "sd"
    },
    shape: {
      type: String,
      default: "circle"
    },
    border: {
      type: Boolean,
      default: !1
    },
    src: {
      type: String,
      default: null
    },
    fallback: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    groupAvatarsUrls: {
      type: Array,
      default: () => []
    },
    groupCustomSize: {
      type: String,
      default: "sm"
    },
    groupCustomTotalUsers: {
      type: String,
      default: null
    },
    plus: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (n, t) => {
      var r, a, l;
      const o = e1("BaseAvatar", !0), i = ns("tooltip");
      return e.type === "single" ? (_(), P("div", {
        key: 0,
        class: pe([
          "overflow-hidden",
          {
            "h-4 w-4": e.size === "2xs",
            "h-5 w-5": e.size === "xs",
            "h-6 w-6": e.size === "sm",
            "h-8 w-8": e.size === "sd",
            "h-10 w-10": e.size === "md",
            "h-12 w-12": e.size === "lg",
            "h-16 w-16": e.size === "xl",
            "h-[120px] w-[120px]": e.size === "2xl",
            "w-full": e.size === "full",
            "rounded-full": e.shape === "circle",
            "rounded-none": e.shape === "squared",
            "rounded-[5px]": e.shape === "rounded",
            "border-2 border-border-on-emphasis": e.border
          }
        ])
      }, [
        e.src ? (_(), P("img", {
          key: 0,
          class: "h-full w-full object-cover",
          alt: e.alt,
          src: e.src
        }, null, 8, fp)) : (_(), P("div", {
          key: 1,
          class: pe([
            "flex h-full w-full items-center justify-center bg-background-subtle font-semibold uppercase text-foreground-default",
            {
              "text-mgm-txt-xs": e.size === "xs" || e.size === "sm" || e.size === "sd",
              "text-mgm-txt-sm": e.size === "md" || e.size === "lg" || e.size === "xl",
              "text-mgm-dspl-xs": e.size === "2xl" || e.size === "full"
            }
          ])
        }, [
          M("span", hp, de(e.fallback), 1)
        ], 2))
      ], 2)) : e.type === "group" ? (_(), P("div", gp, [
        M("div", mp, [
          e.plus ? (_(), P("div", {
            key: 0,
            class: pe([
              "flex items-center justify-center rounded-full  bg-background-subtle text-[10px] font-semibold text-foreground-default ring-[1.5px] ring-border-on-emphasis",
              {
                "h-6 w-6": e.groupCustomSize === "sm",
                "h-8 w-8": e.groupCustomSize === "sd"
              }
            ])
          }, " + ", 2)) : z("", !0),
          (_(!0), P(me, null, Fe(e.groupAvatarsUrls, (s, u) => po((_(), ie(o, {
            key: u,
            class: "ring-2 ring-border-on-emphasis",
            src: s.url,
            size: e.groupCustomSize
          }, null, 8, ["src", "size"])), [
            [i, s.tooltip]
          ])), 128)),
          e.groupCustomTotalUsers && (parseInt(e.groupCustomTotalUsers) > ((r = e.groupAvatarsUrls) == null ? void 0 : r.length) || e.groupCustomTotalUsers === "0") ? (_(), P("div", {
            key: 1,
            class: pe([
              "flex max-w-none items-center justify-center rounded-full bg-background-subtle p-1 pr-2 text-center text-[10px] font-semibold text-foreground-default ring-2 ring-border-on-emphasis",
              {
                "h-6 w-6": e.groupCustomSize === "sm",
                "h-8 w-8": e.groupCustomSize === "sd"
              }
            ])
          }, [
            parseInt(e.groupCustomTotalUsers) > ((a = e.groupAvatarsUrls) == null ? void 0 : a.length) ? (_(), P("span", pp, " +" + de(parseInt(e.groupCustomTotalUsers) - ((l = e.groupAvatarsUrls) == null ? void 0 : l.length)), 1)) : e.groupCustomTotalUsers === "0" ? (_(), P("span", vp, de(e.groupCustomTotalUsers), 1)) : z("", !0)
          ], 2)) : z("", !0)
        ])
      ])) : z("", !0);
    };
  }
}), pl = /* @__PURE__ */ re({
  __name: "BaseBadge",
  props: {
    size: {
      type: String,
      default: "sm"
    },
    color: {
      type: String,
      default: "blue",
      // Using a validator instead of PropType to satisfy both
      // TypeScript strictness (props typing) and
      // ESLint's default return checks (color computed)
      validator: (e) => [
        "blue",
        "green",
        "grey",
        "navy",
        "purple",
        "red",
        "yellow"
      ].includes(e)
    },
    text: {
      type: [Number, String],
      default: void 0
    },
    iconType: {
      type: String,
      default: "none"
    },
    iconName: {
      type: String,
      default: void 0
    },
    link: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const n = e, t = ee(() => {
      switch (n.color) {
        case "blue":
          return {
            badge: "bg-background-brand-default-hover text-foreground-brand-default",
            icon: "#444CE7"
          };
        case "green":
          return {
            badge: "bg-background-success-default text-foreground-success-default",
            icon: "#03874C"
          };
        case "grey":
          return {
            badge: "bg-background-subtle text-foreground-default",
            icon: "#5F6C85"
          };
        case "navy":
          return { badge: "bg-[#F8F9FC] text-[#3E4784]", icon: "#3E4784" };
        case "purple":
          return { badge: "bg-[#F4F3FF] text-[#6938EF]", icon: "#6938EF" };
        case "red":
          return {
            badge: "bg-background-danger-subtle text-foreground-danger-default",
            icon: "#D92D20"
          };
        case "yellow":
          return {
            badge: "bg-background-warning-default text-foreground-warning-default",
            icon: "#B25504"
          };
        default:
          return {
            badge: "bg-background-brand-default-hover text-foreground-brand-default",
            icon: "#444CE7"
          };
      }
    });
    return (o, i) => (_(), ie(Uo(e.link ? "a" : "div"), {
      class: pe([
        "flex w-fit items-center justify-center rounded-[48px] font-medium",
        t.value.badge,
        {
          "h-4 min-w-[44px] px-1.5 py-0.5 text-mgm-txt-xs": e.size === "xs",
          "h-6 min-w-[53px] px-2 py-0.5  text-mgm-txt-sm": e.size === "sm",
          // Default
          "h-7 min-w-[57px] px-2.5 py-1 text-mgm-txt-sm": e.size === "md",
          "h-8 min-w-[61px] px-3 py-1.5 text-mgm-txt-sm": e.size === "lg"
        }
      ]),
      href: e.link,
      target: "_blank"
    }, {
      default: J(() => [
        e.iconType === "custom" ? be(o.$slots, "icon", { key: 0 }) : e.iconType === "dot" ? (_(), P(me, { key: 1 }, [
          Ie("•")
        ], 64)) : e.iconType === "icon" && e.iconName ? (_(), ie(Le, {
          key: 2,
          icon: e.iconName,
          color: t.value.icon,
          size: e.size === "lg" ? 14 : 12
        }, null, 8, ["icon", "color", "size"])) : z("", !0),
        M("span", {
          class: pe([
            "truncate",
            {
              "pl-1": e.iconType !== "none" && ["xs", "sm"].includes(e.size),
              "pl-1.5": e.iconType !== "none" && e.size === "md",
              "pl-2": e.iconType !== "none" && e.size === "lg"
            }
          ])
        }, de(e.text), 3)
      ]),
      _: 3
    }, 8, ["class", "href"]));
  }
}), bp = { class: "mb-5" }, yp = { class: "text-mgm-txt-sm font-normal" }, Cp = { class: "text-foreground-subtle" }, CA = /* @__PURE__ */ re({
  __name: "BaseBreadcrumb",
  props: {
    current: {
      type: String,
      required: !0
    },
    previous: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (n, t) => {
      const o = e1("RouterLink");
      return _(), P("nav", bp, [
        M("p", yp, [
          ce(o, {
            class: "text-foreground-default",
            to: { name: `${e.previous.route}` }
          }, {
            default: J(() => [
              Ie(de(e.previous.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          M("span", Cp, de(` / ${e.current}`), 1)
        ])
      ]);
    };
  }
}), xp = ["disabled", "type"], Fr = /* @__PURE__ */ re({
  __name: "BaseButton",
  props: {
    customColor: {
      type: String,
      default: null
    },
    customRgbColor: {
      type: String,
      default: null
    },
    danger: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: String,
      default: ""
    },
    iconPosition: {
      type: String,
      default: "left"
    },
    size: {
      type: String,
      default: "sm"
    },
    state: {
      type: String,
      // primary, secondary, tertiary
      default: "prmr"
    },
    text: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "button"
    }
  },
  setup(e) {
    const n = e, t = ee(() => n.disabled ? n.state === "scdr" ? n.danger ? "#FDA29B" : "#94A3B8" : n.state === "trtr" ? n.danger ? "#FDA29B" : "#A4BCFD" : "#FFFFFF" : n.state === "scdr" ? n.danger ? "#D92D20" : "#5F6C85" : n.state === "trtr" ? n.danger ? "#D92D20" : "#444CE7" : "#FFFFFF");
    return (o, i) => (_(), P("button", {
      class: pe([
        "box-border rounded-3xl border text-mgm-txt-sm font-medium",
        {
          "flex items-center justify-center gap-2": e.icon,
          "flex-row-reverse": e.icon && e.iconPosition === "right",
          // size
          "px-[13px] py-[7px]": e.size === "sm",
          "px-[15px] py-[9px]": e.size === "md",
          "px-[17px] py-[11px]": e.size === "lg",
          "px-[23px] py-[13px]": e.size === "xl",
          // state primary
          "text-foreground-on-emphasis shadow-[0_1px_2px_rgba(28,31,39,0.05)]": e.state === "prmr",
          "focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_3px_#C7D7FE]": e.state === "prmr" && !e.danger,
          "border-border-brand-emphasis bg-background-brand-emphasis hover:border-foreground-brand-hover hover:bg-background-brand-emphasis-hover disabled:border-background-brand-disabled disabled:bg-background-brand-disabled": e.state === "prmr" && !e.danger && !e.customColor,
          "border-border-danger-emphasis bg-background-danger-emphasis hover:border-background-danger-emphasis-hover hover:bg-background-danger-emphasis-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_3px_#FECDCA] disabled:border-background-danger-disabled disabled:bg-background-danger-disabled": e.state === "prmr" && e.danger,
          // state secondary
          "shadow-[0_1px_2px_rgba(28,31,39,0.05)]": e.state === "scdr",
          "border-border-subtle text-foreground-default bg-background-default hover:border-border-default hover:text-foreground-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_3px_#F1F5F9] disabled:border-background-subtle disabled:text-foreground-subtle": e.state === "scdr" && !e.danger,
          "border-border-danger-default text-foreground-danger-default hover:border-background-danger-disabled hover:text-background-danger-emphasis-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_3px_#FECDCA] disabled:border-background-danger-subtle disabled:text-background-danger-disabled": e.state === "scdr" && e.danger,
          // state tertiary
          "border-transparent shadow-none": e.state === "trtr",
          "text-foreground-brand-default hover:text-foreground-brand-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_3px_#C7D7FE] disabled:text-background-brand-disabled": e.state === "trtr" && !e.danger,
          " text-foreground-danger-default hover:text-background-danger-emphasis-hover focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_3px_#FECDCA] disabled:text-background-danger-disabled": e.state === "trtr" && e.danger,
          // custom color
          "hover:opacity-40": e.customColor
        }
      ]),
      style: Ye({
        borderColor: e.customColor ? e.customColor && e.disabled ? "transparent" : e.customColor : void 0,
        backgroundColor: e.customColor ? e.customColor && e.disabled ? `rgba(${e.customRgbColor}, 0.2)` : e.customColor : void 0
      }),
      disabled: e.disabled,
      type: e.type
    }, [
      e.icon ? (_(), ie(Le, {
        key: 0,
        color: t.value,
        icon: e.icon
      }, null, 8, ["color", "icon"])) : z("", !0),
      Ie(" " + de(e.text) + " ", 1),
      be(o.$slots, "default")
    ], 14, xp));
  }
}), wp = ["src"], $p = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center text-mgm-txt-xs font-medium text-foreground-brand-default"
}, kp = { class: "w-full truncate" }, _p = {
  key: 0,
  class: "truncate text-left text-mgm-txt-sm font-medium text-foreground-emphasis w-full"
}, Op = { class: "line-clamp-2" }, Ep = ["innerHTML"], xA = /* @__PURE__ */ re({
  __name: "BaseCard",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    imgUrl: {
      type: String,
      default: ""
    },
    points: {
      type: Number,
      default: void 0
    },
    badgeStatus: {
      type: Object,
      default: void 0
    },
    lockMobile: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !0
    },
    displayPoints: {
      type: Boolean,
      default: !0
    },
    containImg: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = n, o = () => {
      t("click");
    };
    return (i, r) => (_(), ie(Uo(e.clickable ? "button" : "div"), {
      class: pe([
        "relative flex w-full items-center justify-start rounded-[5px] border border-border-subtle bg-background-default px-4 py-[18px] ",
        {
          "lg:!block lg:!w-[262px]": !e.lockMobile,
          "cursor-pointer hover:shadow-[0px_4px_8px_-2px_rgba(28,31,39,0.1),0px_2px_4px_-2px_rgba(28,31,39,0.06)] focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:outline-none": e.clickable
        }
      ]),
      onClick: o
    }, {
      default: J(() => [
        M("div", {
          class: pe([
            "overflow-hidden relative h-16 w-16 shrink-0",
            { "lg:!h-40 lg:!w-full lg:rounded-none": !e.lockMobile }
          ])
        }, [
          M("img", {
            class: pe(`h-full rounded-[5px] w-full ${e.containImg ? "object-contain" : "object-cover"}`),
            src: e.imgUrl
          }, null, 10, wp),
          e.displayPoints ? (_(), P("span", $p, de(e.points), 1)) : z("", !0)
        ], 2),
        M("div", {
          class: pe([
            "flex-1 pl-4 max-w-full overflow-hidden",
            { "lg:!pl-0 lg:!pt-4": !e.lockMobile }
          ])
        }, [
          M("div", kp, [
            e.title ? (_(), P("p", _p, de(e.title), 1)) : z("", !0)
          ]),
          M("div", Op, [
            e.description ? (_(), P("p", {
              key: 0,
              class: "text-left text-mgm-txt-sm font-normal text-foreground-default",
              innerHTML: e.description
            }, null, 8, Ep)) : z("", !0)
          ]),
          e.badgeStatus && e.badgeStatus.points ? (_(), ie(pl, {
            key: 0,
            class: "mt-2",
            size: "md",
            text: e.badgeStatus.points,
            "icon-type": "icon",
            "icon-name": "star"
          }, null, 8, ["text"])) : e.badgeStatus ? (_(), ie(pl, {
            key: 1,
            class: "mt-2",
            size: "xs",
            color: e.badgeStatus.color,
            text: e.badgeStatus.text
          }, null, 8, ["color", "text"])) : z("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Mp = (e) => (ua("data-v-322720be"), e = e(), da(), e), Sp = {
  key: 0,
  class: "mx-auto max-w-[343px]"
}, Ap = /* @__PURE__ */ Xo('<div class="gradient__grey__06" data-v-322720be><div class="flex h-14 w-[255px] flex-col justify-between rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-322720be><div class="gradient__grey__05 h-3 w-24 rounded-lg" data-v-322720be></div><div class="h-3 w-[184px] rounded-lg bg-background-subtle" data-v-322720be></div></div><div class="mt-2 h-14 w-[255px] rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-322720be><div class="gradient__grey__05 h-3 w-24 rounded-lg" data-v-322720be></div></div></div>', 1), Tp = { class: "text-center text-mgm-txt-sm font-medium text-foreground-emphasis" }, Pp = {
  key: 1,
  type: "button",
  class: "relative block w-full rounded-lg border-2 border-dashed border-border-subtle p-12 text-center hover:border-border-subtle focus:outline-none focus:ring-2 focus:ring-border-default focus:ring-offset-2"
}, Ip = {
  key: 1,
  class: "mx-auto h-12 w-12 text-border-subtle",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 48 48",
  "aria-hidden": "true"
}, Dp = /* @__PURE__ */ Mp(() => /* @__PURE__ */ M("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
}, null, -1)), Lp = [
  Dp
], Np = { class: "mt-2 block text-sm font-medium text-foreground-emphasis" }, Fp = {
  key: 2,
  class: "mx-auto max-w-[263px]"
}, Rp = /* @__PURE__ */ Xo('<div class="relative flex h-14 w-[215px] rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-322720be><div class="gradient__colorful__01 mr-2 h-8 w-8 rounded-full" data-v-322720be></div><div class="h-3 w-20 rounded-lg bg-border-subtle" data-v-322720be></div><div class="absolute top-8 left-10 z-[1] flex h-14 w-[215px] justify-between rounded-lg border border-background-subtle bg-background-default py-3 px-4" data-v-322720be><div class="gradient__colorful__02 h-8 w-8 rounded-full" data-v-322720be></div><div class="flex h-full flex-col justify-between" data-v-322720be><div class="h-3 w-20 rounded-lg bg-border-subtle" data-v-322720be></div><div class="h-3 w-[143px] rounded-lg bg-border-subtle" data-v-322720be></div></div></div></div>', 1), Bp = { class: "mt-14 text-center text-mgm-txt-sm font-medium text-foreground-emphasis" }, Vp = {
  key: 3,
  class: "mx-auto h-56 w-[296px] rounded-lg border border-border-subtle bg-background-default p-8 shadow-[0_12px_16px_-4px_rgba(28,31,39,0.08),0_14px_6px_-2px_rgba(28,31,39,0.03)]"
}, jp = /* @__PURE__ */ Xo('<div class="mb-8 flex items-center justify-between" data-v-322720be><div class="gradient__grey__01 h-14 w-14 rounded-full" data-v-322720be></div><div class="flex h-11 flex-col justify-between" data-v-322720be><div class="gradient__grey__02 h-4 w-20 rounded-lg" data-v-322720be></div><div class="gradient__grey__03 h-4 w-40 rounded-lg" data-v-322720be></div></div></div><div data-v-322720be><div class="flex h-[72px] flex-col justify-between" data-v-322720be><div class="gradient__grey__04 h-4 w-[232px] rounded-lg" data-v-322720be></div><div class="gradient__grey__04 h-4 w-[232px] rounded-lg" data-v-322720be></div><div class="gradient__grey__04 h-4 w-[232px] rounded-lg" data-v-322720be></div></div></div>', 2), Hp = [
  jp
], zp = /* @__PURE__ */ re({
  __name: "BaseEmptyState",
  props: {
    type: {
      type: String,
      default: "empty-list"
    },
    text: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (n, t) => e.type === "empty-list" ? (_(), P("div", Sp, [
      Ap,
      M("p", Tp, de(e.text), 1)
    ])) : ["create-campaign", "add-element"].includes(e.type) ? (_(), P("button", Pp, [
      e.type === "add-element" ? (_(), ie(Le, {
        key: 0,
        class: "mx-auto mb-4",
        icon: "plus",
        size: 40
      })) : e.type === "create-campaign" ? (_(), P("svg", Ip, Lp)) : z("", !0),
      M("span", Np, de(e.text), 1)
    ])) : e.type === "awaiting-match" ? (_(), P("div", Fp, [
      Rp,
      M("p", Bp, de(e.text), 1)
    ])) : e.type === "no-relation-selected" ? (_(), P("div", Vp, Hp)) : z("", !0);
  }
});
const no = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [o, i] of n)
    t[o] = i;
  return t;
}, wA = /* @__PURE__ */ no(zp, [["__scopeId", "data-v-322720be"]]), qp = { class: "flex h-2 w-full items-center justify-between rounded-full bg-background-brand-default" }, Up = /* @__PURE__ */ M("div", { class: "h-full w-1 rounded-l-full bg-background-brand-emphasis" }, null, -1), Wp = /* @__PURE__ */ M("div", { class: "h-full w-1 rounded-r-full bg-[#DD2590]" }, null, -1), Kp = {
  key: 2,
  class: "h-full w-full rounded-full bg-background-brand-emphasis"
}, Yp = {
  key: 3,
  class: "h-full w-full rounded-full bg-[#DD2590]"
}, $A = /* @__PURE__ */ re({
  __name: "BaseHorizontalBarChart",
  props: {
    helpeeCount: {
      type: Number,
      required: !0
    },
    helperCount: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const n = e, t = (o) => o / (n.helpeeCount + n.helperCount) * 100;
    return (o, i) => (_(), P("div", qp, [
      e.helpeeCount === 0 && e.helperCount === 0 ? (_(), P(me, { key: 0 }, [
        Up,
        Wp
      ], 64)) : e.helpeeCount > 0 && e.helperCount > 0 ? (_(), P(me, { key: 1 }, [
        M("div", {
          class: "h-full rounded-l-full bg-background-brand-emphasis",
          style: Ye({
            width: `calc(${t(e.helperCount)}% - 1px)`
          })
        }, null, 4),
        M("div", {
          class: "h-full rounded-r-full bg-[#DD2590]",
          style: Ye({
            width: `calc(${t(e.helpeeCount)}% - 1px)`
          })
        }, null, 4)
      ], 64)) : e.helpeeCount === 0 && e.helperCount > 0 ? (_(), P("div", Kp)) : e.helpeeCount > 0 && e.helperCount === 0 ? (_(), P("div", Yp)) : z("", !0)
    ]));
  }
}), Gp = {}, Zp = { class: "mx-auto flex items-center justify-center" }, Xp = /* @__PURE__ */ Xo('<svg class="animate-spin" width="89" height="88" viewBox="0 0 89 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="40" stroke="#F1F5F9" stroke-width="8"></circle><path d="M42.5 4C65.696 4 84.5 21.6474 84.5 43.4167C84.5 48.9517 83.2844 54.2202 81.09 59" stroke="url(#paint0_linear_4454_43945)" stroke-width="8" stroke-linecap="round"></path><defs><linearGradient id="paint0_linear_4454_43945" x1="56.959" y1="7.19767" x2="81.8309" y2="44.767" gradientUnits="userSpaceOnUse"><stop stop-color="#F1F5F9"></stop><stop offset="1" stop-color="#444CE7"></stop></linearGradient></defs></svg>', 1), Jp = [
  Xp
];
function Qp(e, n) {
  return _(), P("div", Zp, Jp);
}
const kA = /* @__PURE__ */ no(Gp, [["render", Qp]]);
/*!
  * shared v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const Gn = typeof window < "u";
let Yt, vo;
if (process.env.NODE_ENV !== "production") {
  const e = Gn && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (Yt = (n) => {
    e.mark(n);
  }, vo = (n, t, o) => {
    e.measure(n, t, o), e.clearMarks(t), e.clearMarks(o);
  });
}
const ev = /\{([0-9a-zA-Z]+)\}/g;
function s1(e, ...n) {
  return n.length === 1 && Qe(n[0]) && (n = n[0]), (!n || !n.hasOwnProperty) && (n = {}), e.replace(ev, (t, o) => n.hasOwnProperty(o) ? n[o] : "");
}
const Ln = (e, n = !1) => n ? Symbol.for(e) : Symbol(e), tv = (e, n, t) => nv({ l: e, k: n, s: t }), nv = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Tt = (e) => typeof e == "number" && isFinite(e), ov = (e) => d1(e) === "[object Date]", Rr = (e) => d1(e) === "[object RegExp]", ha = (e) => Ke(e) && Object.keys(e).length === 0, Pt = Object.assign;
let cu;
const rs = () => cu || (cu = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function fu(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const iv = Object.prototype.hasOwnProperty;
function as(e, n) {
  return iv.call(e, n);
}
const Ct = Array.isArray, Mt = (e) => typeof e == "function", ke = (e) => typeof e == "string", yt = (e) => typeof e == "boolean", Qe = (e) => e !== null && typeof e == "object", u1 = Object.prototype.toString, d1 = (e) => u1.call(e), Ke = (e) => {
  if (!Qe(e))
    return !1;
  const n = Object.getPrototypeOf(e);
  return n === null || n.constructor === Object;
}, rv = (e) => e == null ? "" : Ct(e) || Ke(e) && e.toString === u1 ? JSON.stringify(e, null, 2) : String(e);
function av(e, n = "") {
  return e.reduce((t, o, i) => i === 0 ? t + o : t + n + o, "");
}
const hu = 2;
function lv(e, n = 0, t = e.length) {
  const o = e.split(/\r?\n/);
  let i = 0;
  const r = [];
  for (let a = 0; a < o.length; a++)
    if (i += o[a].length + 1, i >= n) {
      for (let l = a - hu; l <= a + hu || t > i; l++) {
        if (l < 0 || l >= o.length)
          continue;
        const s = l + 1;
        r.push(`${s}${" ".repeat(3 - String(s).length)}|  ${o[l]}`);
        const u = o[l].length;
        if (l === a) {
          const d = n - (i - u) + 1, f = Math.max(1, t > i ? u - d : t - n);
          r.push("   |  " + " ".repeat(d) + "^".repeat(f));
        } else if (l > a) {
          if (t > i) {
            const d = Math.max(Math.min(t - i, u), 1);
            r.push("   |  " + "^".repeat(d));
          }
          i += u + 1;
        }
      }
      break;
    }
  return r.join(`
`);
}
function ls(e) {
  let n = e;
  return () => ++n;
}
function Jo(e, n) {
  typeof console < "u" && (console.warn("[intlify] " + e), n && console.warn(n.stack));
}
const gu = {};
function sv(e) {
  gu[e] || (gu[e] = !0, Jo(e));
}
function uv() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(t, o) {
      const i = e.get(t);
      i && i.push(o) || e.set(t, [o]);
    },
    off(t, o) {
      const i = e.get(t);
      i && i.splice(i.indexOf(o) >>> 0, 1);
    },
    emit(t, o) {
      (e.get(t) || []).slice().map((i) => i(o)), (e.get("*") || []).slice().map((i) => i(t, o));
    }
  };
}
/*!
  * message-compiler v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const dv = /\{([0-9a-zA-Z]+)\}/g;
function cv(e, ...n) {
  return n.length === 1 && fv(n[0]) && (n = n[0]), (!n || !n.hasOwnProperty) && (n = {}), e.replace(dv, (t, o) => n.hasOwnProperty(o) ? n[o] : "");
}
const fv = (e) => e !== null && typeof e == "object", Et = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, hv = {
  // tokenizer error messages
  [Et.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [Et.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [Et.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [Et.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [Et.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [Et.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [Et.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [Et.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [Et.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [Et.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [Et.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [Et.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [Et.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [Et.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [Et.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [Et.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function c1(e, n, t = {}) {
  const { domain: o, messages: i, args: r } = t, a = cv((i || hv)[e] || "", ...r || []), l = new SyntaxError(String(a));
  return l.code = e, n && (l.location = n), l.domain = o, l;
}
/*!
  * core-base v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
function gv() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (rs().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const oo = [];
oo[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
oo[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
oo[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
oo[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
oo[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
oo[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
oo[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const mv = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function pv(e) {
  return mv.test(e);
}
function vv(e) {
  const n = e.charCodeAt(0), t = e.charCodeAt(e.length - 1);
  return n === t && (n === 34 || n === 39) ? e.slice(1, -1) : e;
}
function bv(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function yv(e) {
  const n = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : pv(n) ? vv(n) : "*" + n;
}
function Cv(e) {
  const n = [];
  let t = -1, o = 0, i = 0, r, a, l, s, u, d, f;
  const c = [];
  c[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = l : a += l;
  }, c[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (n.push(a), a = void 0);
  }, c[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    c[
      0
      /* Actions.APPEND */
    ](), i++;
  }, c[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (i > 0)
      i--, o = 4, c[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (i = 0, a === void 0 || (a = yv(a), a === !1))
        return !1;
      c[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function h() {
    const m = e[t + 1];
    if (o === 5 && m === "'" || o === 6 && m === '"')
      return t++, l = "\\" + m, c[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (t++, r = e[t], !(r === "\\" && h())) {
      if (s = bv(r), f = oo[o], u = f[s] || f.l || 8, u === 8 || (o = u[0], u[1] !== void 0 && (d = c[u[1]], d && (l = r, d() === !1))))
        return;
      if (o === 7)
        return n;
    }
}
const mu = /* @__PURE__ */ new Map();
function xv(e, n) {
  return Qe(e) ? e[n] : null;
}
function wv(e, n) {
  if (!Qe(e))
    return null;
  let t = mu.get(n);
  if (t || (t = Cv(n), t && mu.set(n, t)), !t)
    return null;
  const o = t.length;
  let i = e, r = 0;
  for (; r < o; ) {
    const a = i[t[r]];
    if (a === void 0)
      return null;
    i = a, r++;
  }
  return i;
}
const $v = (e) => e, kv = (e) => "", _v = "text", Ov = (e) => e.length === 0 ? "" : av(e), Ev = rv;
function pu(e, n) {
  return e = Math.abs(e), n === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function Mv(e) {
  const n = Tt(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Tt(e.named.count) || Tt(e.named.n)) ? Tt(e.named.count) ? e.named.count : Tt(e.named.n) ? e.named.n : n : n;
}
function Sv(e, n) {
  n.count || (n.count = e), n.n || (n.n = e);
}
function Av(e = {}) {
  const n = e.locale, t = Mv(e), o = Qe(e.pluralRules) && ke(n) && Mt(e.pluralRules[n]) ? e.pluralRules[n] : pu, i = Qe(e.pluralRules) && ke(n) && Mt(e.pluralRules[n]) ? pu : void 0, r = (p) => p[o(t, p.length, i)], a = e.list || [], l = (p) => a[p], s = e.named || {};
  Tt(e.pluralIndex) && Sv(t, s);
  const u = (p) => s[p];
  function d(p) {
    const y = Mt(e.messages) ? e.messages(p) : Qe(e.messages) ? e.messages[p] : !1;
    return y || (e.parent ? e.parent.message(p) : kv);
  }
  const f = (p) => e.modifiers ? e.modifiers[p] : $v, c = Ke(e.processor) && Mt(e.processor.normalize) ? e.processor.normalize : Ov, h = Ke(e.processor) && Mt(e.processor.interpolate) ? e.processor.interpolate : Ev, m = Ke(e.processor) && ke(e.processor.type) ? e.processor.type : _v, v = {
    list: l,
    named: u,
    plural: r,
    linked: (p, ...y) => {
      const [C, b] = y;
      let x = "text", w = "";
      y.length === 1 ? Qe(C) ? (w = C.modifier || w, x = C.type || x) : ke(C) && (w = C || w) : y.length === 2 && (ke(C) && (w = C || w), ke(b) && (x = b || x));
      const $ = d(p)(v), E = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        x === "vnode" && Ct($) && w ? $[0] : $
      );
      return w ? f(w)(E, x) : E;
    },
    message: d,
    type: m,
    interpolate: h,
    normalize: c,
    values: Pt({}, a, s)
  };
  return v;
}
let _i = null;
function Tv(e) {
  _i = e;
}
function Pv(e, n, t) {
  _i && _i.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: n,
    meta: t
  });
}
const Iv = /* @__PURE__ */ Dv(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function Dv(e) {
  return (n) => _i && _i.emit(e, n);
}
const Nt = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  __EXTEND_POINT__: 8
}, Lv = {
  [Nt.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Nt.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Nt.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Nt.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Nt.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Nt.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Nt.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function bo(e, ...n) {
  return s1(Lv[e], ...n);
}
function Nv(e, n, t) {
  return [.../* @__PURE__ */ new Set([
    t,
    ...Ct(n) ? n : Qe(n) ? Object.keys(n) : ke(n) ? [n] : [t]
  ])];
}
function f1(e, n, t) {
  const o = ke(t) ? t : ss, i = e;
  i.__localeChainCache || (i.__localeChainCache = /* @__PURE__ */ new Map());
  let r = i.__localeChainCache.get(o);
  if (!r) {
    r = [];
    let a = [t];
    for (; Ct(a); )
      a = vu(r, a, n);
    const l = Ct(n) || !Ke(n) ? n : n.default ? n.default : null;
    a = ke(l) ? [l] : l, Ct(a) && vu(r, a, !1), i.__localeChainCache.set(o, r);
  }
  return r;
}
function vu(e, n, t) {
  let o = !0;
  for (let i = 0; i < n.length && yt(o); i++) {
    const r = n[i];
    ke(r) && (o = Fv(e, n[i], t));
  }
  return o;
}
function Fv(e, n, t) {
  let o;
  const i = n.split("-");
  do {
    const r = i.join("-");
    o = Rv(e, r, t), i.splice(-1, 1);
  } while (i.length && o === !0);
  return o;
}
function Rv(e, n, t) {
  let o = !1;
  if (!e.includes(n) && (o = !0, n)) {
    o = n[n.length - 1] !== "!";
    const i = n.replace(/!/g, "");
    e.push(i), (Ct(t) || Ke(t)) && t[i] && (o = t[i]);
  }
  return o;
}
const Bv = "9.4.1", ga = -1, ss = "en-US", Br = "", bu = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Vv() {
  return {
    upper: (e, n) => n === "text" && ke(e) ? e.toUpperCase() : n === "vnode" && Qe(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, n) => n === "text" && ke(e) ? e.toLowerCase() : n === "vnode" && Qe(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, n) => n === "text" && ke(e) ? bu(e) : n === "vnode" && Qe(e) && "__v_isVNode" in e ? bu(e.children) : e
  };
}
let jv, h1;
function Hv(e) {
  h1 = e;
}
let g1;
function zv(e) {
  g1 = e;
}
let m1 = null;
const yu = (e) => {
  m1 = e;
}, qv = () => m1;
let p1 = null;
const Cu = (e) => {
  p1 = e;
}, Uv = () => p1;
let xu = 0;
function Wv(e = {}) {
  const n = Mt(e.onWarn) ? e.onWarn : Jo, t = ke(e.version) ? e.version : Bv, o = ke(e.locale) ? e.locale : ss, i = Ct(e.fallbackLocale) || Ke(e.fallbackLocale) || ke(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, r = Ke(e.messages) ? e.messages : { [o]: {} }, a = Ke(e.datetimeFormats) ? e.datetimeFormats : { [o]: {} }, l = Ke(e.numberFormats) ? e.numberFormats : { [o]: {} }, s = Pt({}, e.modifiers || {}, Vv()), u = e.pluralRules || {}, d = Mt(e.missing) ? e.missing : null, f = yt(e.missingWarn) || Rr(e.missingWarn) ? e.missingWarn : !0, c = yt(e.fallbackWarn) || Rr(e.fallbackWarn) ? e.fallbackWarn : !0, h = !!e.fallbackFormat, m = !!e.unresolving, g = Mt(e.postTranslation) ? e.postTranslation : null, v = Ke(e.processor) ? e.processor : null, p = yt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, y = !!e.escapeParameter, C = Mt(e.messageCompiler) ? e.messageCompiler : jv;
  process.env.NODE_ENV !== "production" && Mt(e.messageCompiler) && sv(bo(Nt.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const b = Mt(e.messageResolver) ? e.messageResolver : h1 || xv, x = Mt(e.localeFallbacker) ? e.localeFallbacker : g1 || Nv, w = Qe(e.fallbackContext) ? e.fallbackContext : void 0, $ = e, E = Qe($.__datetimeFormatters) ? $.__datetimeFormatters : /* @__PURE__ */ new Map(), A = Qe($.__numberFormatters) ? $.__numberFormatters : /* @__PURE__ */ new Map(), O = Qe($.__meta) ? $.__meta : {};
  xu++;
  const k = {
    version: t,
    cid: xu,
    locale: o,
    fallbackLocale: i,
    messages: r,
    modifiers: s,
    pluralRules: u,
    missing: d,
    missingWarn: f,
    fallbackWarn: c,
    fallbackFormat: h,
    unresolving: m,
    postTranslation: g,
    processor: v,
    warnHtmlMessage: p,
    escapeParameter: y,
    messageCompiler: C,
    messageResolver: b,
    localeFallbacker: x,
    fallbackContext: w,
    onWarn: n,
    __meta: O
  };
  return k.datetimeFormats = a, k.numberFormats = l, k.__datetimeFormatters = E, k.__numberFormatters = A, process.env.NODE_ENV !== "production" && (k.__v_emitter = $.__v_emitter != null ? $.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Pv(k, t, O), k;
}
function ma(e, n) {
  return e instanceof RegExp ? e.test(n) : e;
}
function v1(e, n) {
  return e instanceof RegExp ? e.test(n) : e;
}
function us(e, n, t, o, i) {
  const { missing: r, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const l = e.__v_emitter;
    l && l.emit("missing", {
      locale: t,
      key: n,
      type: i,
      groupId: `${i}:${n}`
    });
  }
  if (r !== null) {
    const l = r(e, t, n, i);
    return ke(l) ? l : n;
  } else
    return process.env.NODE_ENV !== "production" && v1(o, n) && a(bo(Nt.NOT_FOUND_KEY, { key: n, locale: t })), n;
}
function ii(e, n, t) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, t, n);
}
const b1 = Et.__EXTEND_POINT__, ir = ls(b1), ln = {
  INVALID_ARGUMENT: b1,
  INVALID_DATE_ARGUMENT: ir(),
  INVALID_ISO_DATE_ARGUMENT: ir(),
  NOT_SUPPORT_NON_STRING_MESSAGE: ir(),
  __EXTEND_POINT__: ir()
  // 22
};
function Fo(e) {
  return c1(e, null, process.env.NODE_ENV !== "production" ? { messages: Kv } : void 0);
}
const Kv = {
  [ln.INVALID_ARGUMENT]: "Invalid arguments",
  [ln.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [ln.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [ln.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message"
}, Oi = (e) => Qe(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e), wu = () => "", an = (e) => Mt(e);
function $u(e, ...n) {
  const { fallbackFormat: t, postTranslation: o, unresolving: i, messageCompiler: r, fallbackLocale: a, messages: l } = e, [s, u] = vl(...n), d = yt(u.missingWarn) ? u.missingWarn : e.missingWarn, f = yt(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, c = yt(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, h = !!u.resolvedMessage, m = ke(u.default) || yt(u.default) ? yt(u.default) ? r ? s : () => s : u.default : t ? r ? s : () => s : "", g = t || m !== "", v = ke(u.locale) ? u.locale : e.locale;
  c && Yv(u);
  let [p, y, C] = h ? [
    s,
    v,
    l[v] || {}
  ] : y1(e, s, v, a, f, d), b = p, x = s;
  if (!h && !(ke(b) || Oi(b) || an(b)) && g && (b = m, x = b), !h && (!(ke(b) || Oi(b) || an(b)) || !ke(y)))
    return i ? ga : s;
  if (process.env.NODE_ENV !== "production" && ke(b) && e.messageCompiler == null)
    return Jo(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${s}'.`), s;
  let w = !1;
  const $ = () => {
    w = !0;
  }, E = an(b) ? b : C1(e, s, y, b, x, $);
  if (w)
    return b;
  const A = Jv(e, y, C, u), O = Av(A), k = Gv(e, E, O), S = o ? o(k, s) : k;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const T = {
      timestamp: Date.now(),
      key: ke(s) ? s : an(b) ? b.key : "",
      locale: y || (an(b) ? b.locale : ""),
      format: ke(b) ? b : an(b) ? b.source : "",
      message: S
    };
    T.meta = Pt({}, e.__meta, qv() || {}), Iv(T);
  }
  return S;
}
function Yv(e) {
  Ct(e.list) ? e.list = e.list.map((n) => ke(n) ? fu(n) : n) : Qe(e.named) && Object.keys(e.named).forEach((n) => {
    ke(e.named[n]) && (e.named[n] = fu(e.named[n]));
  });
}
function y1(e, n, t, o, i, r) {
  const { messages: a, onWarn: l, messageResolver: s, localeFallbacker: u } = e, d = u(e, o, t);
  let f = {}, c, h = null, m = t, g = null;
  const v = "translate";
  for (let p = 0; p < d.length; p++) {
    if (c = g = d[p], process.env.NODE_ENV !== "production" && t !== c && ma(i, n) && l(bo(Nt.FALLBACK_TO_TRANSLATE, {
      key: n,
      target: c
    })), process.env.NODE_ENV !== "production" && t !== c) {
      const w = e.__v_emitter;
      w && w.emit("fallback", {
        type: v,
        key: n,
        from: m,
        to: g,
        groupId: `${v}:${n}`
      });
    }
    f = a[c] || {};
    let y = null, C, b;
    if (process.env.NODE_ENV !== "production" && Gn && (y = window.performance.now(), C = "intlify-message-resolve-start", b = "intlify-message-resolve-end", Yt && Yt(C)), (h = s(f, n)) === null && (h = f[n]), process.env.NODE_ENV !== "production" && Gn) {
      const w = window.performance.now(), $ = e.__v_emitter;
      $ && y && h && $.emit("message-resolve", {
        type: "message-resolve",
        key: n,
        message: h,
        time: w - y,
        groupId: `${v}:${n}`
      }), C && b && Yt && vo && (Yt(b), vo("intlify message resolve", C, b));
    }
    if (ke(h) || Oi(h) || an(h))
      break;
    const x = us(
      e,
      // eslint-disable-line @typescript-eslint/no-explicit-any
      n,
      c,
      r,
      v
    );
    x !== n && (h = x), m = g;
  }
  return [h, c, f];
}
function C1(e, n, t, o, i, r) {
  const { messageCompiler: a, warnHtmlMessage: l } = e;
  if (an(o)) {
    const c = o;
    return c.locale = c.locale || t, c.key = c.key || n, c;
  }
  if (a == null) {
    const c = () => o;
    return c.locale = t, c.key = n, c;
  }
  let s = null, u, d;
  process.env.NODE_ENV !== "production" && Gn && (s = window.performance.now(), u = "intlify-message-compilation-start", d = "intlify-message-compilation-end", Yt && Yt(u));
  const f = a(o, Zv(e, t, i, o, l, r));
  if (process.env.NODE_ENV !== "production" && Gn) {
    const c = window.performance.now(), h = e.__v_emitter;
    h && s && h.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: c - s,
      groupId: `translate:${n}`
    }), u && d && Yt && vo && (Yt(d), vo("intlify message compilation", u, d));
  }
  return f.locale = t, f.key = n, f.source = o, f;
}
function Gv(e, n, t) {
  let o = null, i, r;
  process.env.NODE_ENV !== "production" && Gn && (o = window.performance.now(), i = "intlify-message-evaluation-start", r = "intlify-message-evaluation-end", Yt && Yt(i));
  const a = n(t);
  if (process.env.NODE_ENV !== "production" && Gn) {
    const l = window.performance.now(), s = e.__v_emitter;
    s && o && s.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: l - o,
      groupId: `translate:${n.key}`
    }), i && r && Yt && vo && (Yt(r), vo("intlify message evaluation", i, r));
  }
  return a;
}
function vl(...e) {
  const [n, t, o] = e, i = {};
  if (!ke(n) && !Tt(n) && !an(n) && !Oi(n))
    throw Fo(ln.INVALID_ARGUMENT);
  const r = Tt(n) ? String(n) : (an(n), n);
  return Tt(t) ? i.plural = t : ke(t) ? i.default = t : Ke(t) && !ha(t) ? i.named = t : Ct(t) && (i.list = t), Tt(o) ? i.plural = o : ke(o) ? i.default = o : Ke(o) && Pt(i, o), [r, i];
}
function Zv(e, n, t, o, i, r) {
  return {
    locale: n,
    key: t,
    warnHtmlMessage: i,
    onError: (a) => {
      if (r && r(a), process.env.NODE_ENV !== "production") {
        const l = Xv(o), s = `Message compilation error: ${a.message}`, u = a.location && l && lv(l, a.location.start.offset, a.location.end.offset), d = e.__v_emitter;
        d && l && d.emit("compile-error", {
          message: l,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${t}`
        }), console.error(u ? `${s}
${u}` : s);
      } else
        throw a;
    },
    onCacheKey: (a) => tv(n, t, a)
  };
}
function Xv(e) {
  var n;
  if (!ke(e)) {
    if ((n = e.loc) != null && n.source)
      return e.loc.source;
  }
}
function Jv(e, n, t, o) {
  const { modifiers: i, pluralRules: r, messageResolver: a, fallbackLocale: l, fallbackWarn: s, missingWarn: u, fallbackContext: d } = e, c = {
    locale: n,
    modifiers: i,
    pluralRules: r,
    messages: (h) => {
      let m = a(t, h);
      if (m == null && d) {
        const [, , g] = y1(d, h, n, l, s, u);
        m = a(g, h);
      }
      if (ke(m) || Oi(m)) {
        let g = !1;
        const p = C1(e, h, n, m, h, () => {
          g = !0;
        });
        return g ? wu : p;
      } else
        return an(m) ? m : wu;
    }
  };
  return e.processor && (c.processor = e.processor), o.list && (c.list = o.list), o.named && (c.named = o.named), Tt(o.plural) && (c.pluralIndex = o.plural), c;
}
const ku = typeof Intl < "u", x1 = {
  dateTimeFormat: ku && typeof Intl.DateTimeFormat < "u",
  numberFormat: ku && typeof Intl.NumberFormat < "u"
};
function _u(e, ...n) {
  const { datetimeFormats: t, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: a } = e, { __datetimeFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !x1.dateTimeFormat)
    return r(bo(Nt.CANNOT_FORMAT_DATE)), Br;
  const [s, u, d, f] = bl(...n), c = yt(d.missingWarn) ? d.missingWarn : e.missingWarn, h = yt(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, m = !!d.part, g = ke(d.locale) ? d.locale : e.locale, v = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    g
  );
  if (!ke(s) || s === "")
    return new Intl.DateTimeFormat(g, f).format(u);
  let p = {}, y, C = null, b = g, x = null;
  const w = "datetime format";
  for (let A = 0; A < v.length; A++) {
    if (y = x = v[A], process.env.NODE_ENV !== "production" && g !== y && ma(h, s) && r(bo(Nt.FALLBACK_TO_DATE_FORMAT, {
      key: s,
      target: y
    })), process.env.NODE_ENV !== "production" && g !== y) {
      const O = e.__v_emitter;
      O && O.emit("fallback", {
        type: w,
        key: s,
        from: b,
        to: x,
        groupId: `${w}:${s}`
      });
    }
    if (p = t[y] || {}, C = p[s], Ke(C))
      break;
    us(e, s, y, c, w), b = x;
  }
  if (!Ke(C) || !ke(y))
    return o ? ga : s;
  let $ = `${y}__${s}`;
  ha(f) || ($ = `${$}__${JSON.stringify(f)}`);
  let E = l.get($);
  return E || (E = new Intl.DateTimeFormat(y, Pt({}, C, f)), l.set($, E)), m ? E.formatToParts(u) : E.format(u);
}
const w1 = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function bl(...e) {
  const [n, t, o, i] = e, r = {};
  let a = {}, l;
  if (ke(n)) {
    const s = n.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!s)
      throw Fo(ln.INVALID_ISO_DATE_ARGUMENT);
    const u = s[3] ? s[3].trim().startsWith("T") ? `${s[1].trim()}${s[3].trim()}` : `${s[1].trim()}T${s[3].trim()}` : s[1].trim();
    l = new Date(u);
    try {
      l.toISOString();
    } catch {
      throw Fo(ln.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ov(n)) {
    if (isNaN(n.getTime()))
      throw Fo(ln.INVALID_DATE_ARGUMENT);
    l = n;
  } else if (Tt(n))
    l = n;
  else
    throw Fo(ln.INVALID_ARGUMENT);
  return ke(t) ? r.key = t : Ke(t) && Object.keys(t).forEach((s) => {
    w1.includes(s) ? a[s] = t[s] : r[s] = t[s];
  }), ke(o) ? r.locale = o : Ke(o) && (a = o), Ke(i) && (a = i), [r.key || "", l, r, a];
}
function Ou(e, n, t) {
  const o = e;
  for (const i in t) {
    const r = `${n}__${i}`;
    o.__datetimeFormatters.has(r) && o.__datetimeFormatters.delete(r);
  }
}
function Eu(e, ...n) {
  const { numberFormats: t, unresolving: o, fallbackLocale: i, onWarn: r, localeFallbacker: a } = e, { __numberFormatters: l } = e;
  if (process.env.NODE_ENV !== "production" && !x1.numberFormat)
    return r(bo(Nt.CANNOT_FORMAT_NUMBER)), Br;
  const [s, u, d, f] = yl(...n), c = yt(d.missingWarn) ? d.missingWarn : e.missingWarn, h = yt(d.fallbackWarn) ? d.fallbackWarn : e.fallbackWarn, m = !!d.part, g = ke(d.locale) ? d.locale : e.locale, v = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    g
  );
  if (!ke(s) || s === "")
    return new Intl.NumberFormat(g, f).format(u);
  let p = {}, y, C = null, b = g, x = null;
  const w = "number format";
  for (let A = 0; A < v.length; A++) {
    if (y = x = v[A], process.env.NODE_ENV !== "production" && g !== y && ma(h, s) && r(bo(Nt.FALLBACK_TO_NUMBER_FORMAT, {
      key: s,
      target: y
    })), process.env.NODE_ENV !== "production" && g !== y) {
      const O = e.__v_emitter;
      O && O.emit("fallback", {
        type: w,
        key: s,
        from: b,
        to: x,
        groupId: `${w}:${s}`
      });
    }
    if (p = t[y] || {}, C = p[s], Ke(C))
      break;
    us(e, s, y, c, w), b = x;
  }
  if (!Ke(C) || !ke(y))
    return o ? ga : s;
  let $ = `${y}__${s}`;
  ha(f) || ($ = `${$}__${JSON.stringify(f)}`);
  let E = l.get($);
  return E || (E = new Intl.NumberFormat(y, Pt({}, C, f)), l.set($, E)), m ? E.formatToParts(u) : E.format(u);
}
const $1 = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function yl(...e) {
  const [n, t, o, i] = e, r = {};
  let a = {};
  if (!Tt(n))
    throw Fo(ln.INVALID_ARGUMENT);
  const l = n;
  return ke(t) ? r.key = t : Ke(t) && Object.keys(t).forEach((s) => {
    $1.includes(s) ? a[s] = t[s] : r[s] = t[s];
  }), ke(o) ? r.locale = o : Ke(o) && (a = o), Ke(i) && (a = i), [r.key || "", l, r, a];
}
function Mu(e, n, t) {
  const o = e;
  for (const i in t) {
    const r = `${n}__${i}`;
    o.__numberFormatters.has(r) && o.__numberFormatters.delete(r);
  }
}
gv();
/*!
  * vue-i18n v9.4.1
  * (c) 2023 kazuya kawaguchi
  * Released under the MIT License.
  */
const Qv = "9.4.1";
function e5() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (rs().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const k1 = Nt.__EXTEND_POINT__, Rn = ls(k1), Jt = {
  FALLBACK_TO_ROOT: k1,
  NOT_SUPPORTED_PRESERVE: Rn(),
  NOT_SUPPORTED_FORMATTER: Rn(),
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: Rn(),
  NOT_SUPPORTED_GET_CHOICE_INDEX: Rn(),
  COMPONENT_NAME_LEGACY_COMPATIBLE: Rn(),
  NOT_FOUND_PARENT_SCOPE: Rn(),
  IGNORE_OBJ_FLATTEN: Rn(),
  NOTICE_DROP_ALLOW_COMPOSITION: Rn()
  // 17
}, t5 = {
  [Jt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Jt.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Jt.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Jt.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Jt.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Jt.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Jt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Jt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Jt.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze"
};
function ds(e, ...n) {
  return s1(t5[e], ...n);
}
const _1 = ln.__EXTEND_POINT__, Rt = ls(_1), pt = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: _1,
  // legacy module errors
  INVALID_ARGUMENT: Rt(),
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Rt(),
  NOT_INSTALLED: Rt(),
  NOT_AVAILABLE_IN_LEGACY_MODE: Rt(),
  // directive module errors
  REQUIRED_VALUE: Rt(),
  INVALID_VALUE: Rt(),
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Rt(),
  NOT_INSTALLED_WITH_PROVIDE: Rt(),
  // unexpected error
  UNEXPECTED_ERROR: Rt(),
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Rt(),
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Rt(),
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Rt(),
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Rt(),
  // for enhancement
  __EXTEND_POINT__: Rt()
  // 37
};
function Wo(e, ...n) {
  return c1(e, null, process.env.NODE_ENV !== "production" ? { messages: n5, args: n } : void 0);
}
const n5 = {
  [pt.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [pt.INVALID_ARGUMENT]: "Invalid argument",
  [pt.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [pt.NOT_INSTALLED]: "Need to install with `app.use` function",
  [pt.UNEXPECTED_ERROR]: "Unexpected error",
  [pt.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [pt.REQUIRED_VALUE]: "Required in value: {0}",
  [pt.INVALID_VALUE]: "Invalid value",
  [pt.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [pt.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [pt.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [pt.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [pt.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [pt.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Cl = /* @__PURE__ */ Ln("__translateVNode"), xl = /* @__PURE__ */ Ln("__datetimeParts"), wl = /* @__PURE__ */ Ln("__numberParts"), $l = /* @__PURE__ */ Ln("__enableEmitter"), kl = /* @__PURE__ */ Ln("__disableEmitter"), o5 = Ln("__setPluralRules"), i5 = /* @__PURE__ */ Ln("__injectWithOption"), _l = /* @__PURE__ */ Ln("__dispose");
function Ol(e) {
  if (!Qe(e))
    return e;
  for (const n in e)
    if (as(e, n))
      if (!n.includes("."))
        Qe(e[n]) && Ol(e[n]);
      else {
        const t = n.split("."), o = t.length - 1;
        let i = e, r = !1;
        for (let a = 0; a < o; a++) {
          if (t[a] in i || (i[t[a]] = {}), !Qe(i[t[a]])) {
            process.env.NODE_ENV !== "production" && Jo(ds(Jt.IGNORE_OBJ_FLATTEN, {
              key: t[a]
            })), r = !0;
            break;
          }
          i = i[t[a]];
        }
        r || (i[t[o]] = e[n], delete e[n]), Qe(i[t[o]]) && Ol(i[t[o]]);
      }
  return e;
}
function O1(e, n) {
  const { messages: t, __i18n: o, messageResolver: i, flatJson: r } = n, a = Ke(t) ? t : Ct(o) ? {} : { [e]: {} };
  if (Ct(o) && o.forEach((l) => {
    if ("locale" in l && "resource" in l) {
      const { locale: s, resource: u } = l;
      s ? (a[s] = a[s] || {}, vi(u, a[s])) : vi(u, a);
    } else
      ke(l) && vi(JSON.parse(l), a);
  }), i == null && r)
    for (const l in a)
      as(a, l) && Ol(a[l]);
  return a;
}
const rr = (e) => !Qe(e) || Ct(e);
function vi(e, n) {
  if (rr(e) || rr(n))
    throw Wo(pt.INVALID_VALUE);
  for (const t in e)
    as(e, t) && (rr(e[t]) || rr(n[t]) ? n[t] = e[t] : vi(e[t], n[t]));
}
function E1(e) {
  return e.type;
}
function r5(e, n, t) {
  let o = Qe(n.messages) ? n.messages : {};
  "__i18nGlobal" in t && (o = O1(e.locale.value, {
    messages: o,
    __i18n: t.__i18nGlobal
  }));
  const i = Object.keys(o);
  i.length && i.forEach((r) => {
    e.mergeLocaleMessage(r, o[r]);
  });
  {
    if (Qe(n.datetimeFormats)) {
      const r = Object.keys(n.datetimeFormats);
      r.length && r.forEach((a) => {
        e.mergeDateTimeFormat(a, n.datetimeFormats[a]);
      });
    }
    if (Qe(n.numberFormats)) {
      const r = Object.keys(n.numberFormats);
      r.length && r.forEach((a) => {
        e.mergeNumberFormat(a, n.numberFormats[a]);
      });
    }
  }
}
function Su(e) {
  return ce(s0, null, e, 0);
}
const Au = "__INTLIFY_META__";
let Tu = 0;
function Pu(e) {
  return (n, t, o, i) => e(t, o, yn() || void 0, i);
}
const a5 = () => {
  const e = yn();
  let n = null;
  return e && (n = E1(e)[Au]) ? { [Au]: n } : null;
};
function l5(e = {}, n) {
  const { __root: t, __injectWithOption: o } = e, i = t === void 0;
  let r = yt(e.inheritLocale) ? e.inheritLocale : !0;
  const a = X(
    // prettier-ignore
    t && r ? t.locale.value : ke(e.locale) ? e.locale : ss
  ), l = X(
    // prettier-ignore
    t && r ? t.fallbackLocale.value : ke(e.fallbackLocale) || Ct(e.fallbackLocale) || Ke(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : a.value
  ), s = X(O1(a.value, e)), u = X(Ke(e.datetimeFormats) ? e.datetimeFormats : { [a.value]: {} }), d = X(Ke(e.numberFormats) ? e.numberFormats : { [a.value]: {} });
  let f = t ? t.missingWarn : yt(e.missingWarn) || Rr(e.missingWarn) ? e.missingWarn : !0, c = t ? t.fallbackWarn : yt(e.fallbackWarn) || Rr(e.fallbackWarn) ? e.fallbackWarn : !0, h = t ? t.fallbackRoot : yt(e.fallbackRoot) ? e.fallbackRoot : !0, m = !!e.fallbackFormat, g = Mt(e.missing) ? e.missing : null, v = Mt(e.missing) ? Pu(e.missing) : null, p = Mt(e.postTranslation) ? e.postTranslation : null, y = t ? t.warnHtmlMessage : yt(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, C = !!e.escapeParameter;
  const b = t ? t.modifiers : Ke(e.modifiers) ? e.modifiers : {};
  let x = e.pluralRules || t && t.pluralRules, w;
  w = (() => {
    i && Cu(null);
    const Q = {
      version: Qv,
      locale: a.value,
      fallbackLocale: l.value,
      messages: s.value,
      modifiers: b,
      pluralRules: x,
      missing: v === null ? void 0 : v,
      missingWarn: f,
      fallbackWarn: c,
      fallbackFormat: m,
      unresolving: !0,
      postTranslation: p === null ? void 0 : p,
      warnHtmlMessage: y,
      escapeParameter: C,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    Q.datetimeFormats = u.value, Q.numberFormats = d.value, Q.__datetimeFormatters = Ke(w) ? w.__datetimeFormatters : void 0, Q.__numberFormatters = Ke(w) ? w.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (Q.__v_emitter = Ke(w) ? w.__v_emitter : void 0);
    const le = Wv(Q);
    return i && Cu(le), le;
  })(), ii(w, a.value, l.value);
  function E() {
    return [
      a.value,
      l.value,
      s.value,
      u.value,
      d.value
    ];
  }
  const A = ee({
    get: () => a.value,
    set: (Q) => {
      a.value = Q, w.locale = a.value;
    }
  }), O = ee({
    get: () => l.value,
    set: (Q) => {
      l.value = Q, w.fallbackLocale = l.value, ii(w, a.value, Q);
    }
  }), k = ee(() => s.value), S = /* @__PURE__ */ ee(() => u.value), T = /* @__PURE__ */ ee(() => d.value);
  function L() {
    return Mt(p) ? p : null;
  }
  function F(Q) {
    p = Q, w.postTranslation = Q;
  }
  function U() {
    return g;
  }
  function W(Q) {
    Q !== null && (v = Pu(Q)), g = Q, w.missing = v;
  }
  function oe(Q, le) {
    return Q !== "translate" || !le.resolvedMessage;
  }
  const H = (Q, le, et, ot, tt, wn) => {
    E();
    let it;
    try {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && yu(a5()), i || (w.fallbackContext = t ? Uv() : void 0), it = Q(w);
    } finally {
      (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && yu(null), i || (w.fallbackContext = void 0);
    }
    if (Tt(it) && it === ga) {
      const [kt, tr] = le();
      if (process.env.NODE_ENV !== "production" && t && ke(kt) && oe(et, tr) && (h && (ma(c, kt) || v1(f, kt)) && Jo(ds(Jt.FALLBACK_TO_ROOT, {
        key: kt,
        type: et
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: nr } = w;
        nr && h && nr.emit("fallback", {
          type: et,
          key: kt,
          to: "global",
          groupId: `${et}:${kt}`
        });
      }
      return t && h ? ot(t) : tt(kt);
    } else {
      if (wn(it))
        return it;
      throw Wo(pt.UNEXPECTED_RETURN_TYPE);
    }
  };
  function B(...Q) {
    return H((le) => Reflect.apply($u, null, [le, ...Q]), () => vl(...Q), "translate", (le) => Reflect.apply(le.t, le, [...Q]), (le) => le, (le) => ke(le));
  }
  function D(...Q) {
    const [le, et, ot] = Q;
    if (ot && !Qe(ot))
      throw Wo(pt.INVALID_ARGUMENT);
    return B(le, et, Pt({ resolvedMessage: !0 }, ot || {}));
  }
  function V(...Q) {
    return H((le) => Reflect.apply(_u, null, [le, ...Q]), () => bl(...Q), "datetime format", (le) => Reflect.apply(le.d, le, [...Q]), () => Br, (le) => ke(le));
  }
  function q(...Q) {
    return H((le) => Reflect.apply(Eu, null, [le, ...Q]), () => yl(...Q), "number format", (le) => Reflect.apply(le.n, le, [...Q]), () => Br, (le) => ke(le));
  }
  function Z(Q) {
    return Q.map((le) => ke(le) || Tt(le) || yt(le) ? Su(String(le)) : le);
  }
  const R = {
    normalize: Z,
    interpolate: (Q) => Q,
    type: "vnode"
  };
  function K(...Q) {
    return H(
      (le) => {
        let et;
        const ot = le;
        try {
          ot.processor = R, et = Reflect.apply($u, null, [ot, ...Q]);
        } finally {
          ot.processor = null;
        }
        return et;
      },
      () => vl(...Q),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (le) => le[Cl](...Q),
      (le) => [Su(le)],
      (le) => Ct(le)
    );
  }
  function te(...Q) {
    return H(
      (le) => Reflect.apply(Eu, null, [le, ...Q]),
      () => yl(...Q),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (le) => le[wl](...Q),
      () => [],
      (le) => ke(le) || Ct(le)
    );
  }
  function ne(...Q) {
    return H(
      (le) => Reflect.apply(_u, null, [le, ...Q]),
      () => bl(...Q),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (le) => le[xl](...Q),
      () => [],
      (le) => ke(le) || Ct(le)
    );
  }
  function fe(Q) {
    x = Q, w.pluralRules = x;
  }
  function Ce(Q, le) {
    const et = ke(le) ? le : a.value, ot = De(et);
    return w.messageResolver(ot, Q) !== null;
  }
  function Oe(Q) {
    let le = null;
    const et = f1(w, l.value, a.value);
    for (let ot = 0; ot < et.length; ot++) {
      const tt = s.value[et[ot]] || {}, wn = w.messageResolver(tt, Q);
      if (wn != null) {
        le = wn;
        break;
      }
    }
    return le;
  }
  function Ae(Q) {
    const le = Oe(Q);
    return le ?? (t ? t.tm(Q) || {} : {});
  }
  function De(Q) {
    return s.value[Q] || {};
  }
  function qe(Q, le) {
    s.value[Q] = le, w.messages = s.value;
  }
  function $t(Q, le) {
    s.value[Q] = s.value[Q] || {}, vi(le, s.value[Q]), w.messages = s.value;
  }
  function st(Q) {
    return u.value[Q] || {};
  }
  function se(Q, le) {
    u.value[Q] = le, w.datetimeFormats = u.value, Ou(w, Q, le);
  }
  function ue(Q, le) {
    u.value[Q] = Pt(u.value[Q] || {}, le), w.datetimeFormats = u.value, Ou(w, Q, le);
  }
  function ve(Q) {
    return d.value[Q] || {};
  }
  function ye(Q, le) {
    d.value[Q] = le, w.numberFormats = d.value, Mu(w, Q, le);
  }
  function he(Q, le) {
    d.value[Q] = Pt(d.value[Q] || {}, le), w.numberFormats = d.value, Mu(w, Q, le);
  }
  Tu++, t && Gn && (Ne(t.locale, (Q) => {
    r && (a.value = Q, w.locale = Q, ii(w, a.value, l.value));
  }), Ne(t.fallbackLocale, (Q) => {
    r && (l.value = Q, w.fallbackLocale = Q, ii(w, a.value, l.value));
  }));
  const we = {
    id: Tu,
    locale: A,
    fallbackLocale: O,
    get inheritLocale() {
      return r;
    },
    set inheritLocale(Q) {
      r = Q, Q && t && (a.value = t.locale.value, l.value = t.fallbackLocale.value, ii(w, a.value, l.value));
    },
    get availableLocales() {
      return Object.keys(s.value).sort();
    },
    messages: k,
    get modifiers() {
      return b;
    },
    get pluralRules() {
      return x || {};
    },
    get isGlobal() {
      return i;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(Q) {
      f = Q, w.missingWarn = f;
    },
    get fallbackWarn() {
      return c;
    },
    set fallbackWarn(Q) {
      c = Q, w.fallbackWarn = c;
    },
    get fallbackRoot() {
      return h;
    },
    set fallbackRoot(Q) {
      h = Q;
    },
    get fallbackFormat() {
      return m;
    },
    set fallbackFormat(Q) {
      m = Q, w.fallbackFormat = m;
    },
    get warnHtmlMessage() {
      return y;
    },
    set warnHtmlMessage(Q) {
      y = Q, w.warnHtmlMessage = Q;
    },
    get escapeParameter() {
      return C;
    },
    set escapeParameter(Q) {
      C = Q, w.escapeParameter = Q;
    },
    t: B,
    getLocaleMessage: De,
    setLocaleMessage: qe,
    mergeLocaleMessage: $t,
    getPostTranslationHandler: L,
    setPostTranslationHandler: F,
    getMissingHandler: U,
    setMissingHandler: W,
    [o5]: fe
  };
  return we.datetimeFormats = S, we.numberFormats = T, we.rt = D, we.te = Ce, we.tm = Ae, we.d = V, we.n = q, we.getDateTimeFormat = st, we.setDateTimeFormat = se, we.mergeDateTimeFormat = ue, we.getNumberFormat = ve, we.setNumberFormat = ye, we.mergeNumberFormat = he, we[i5] = o, we[Cl] = K, we[xl] = ne, we[wl] = te, process.env.NODE_ENV !== "production" && (we[$l] = (Q) => {
    w.__v_emitter = Q;
  }, we[kl] = () => {
    w.__v_emitter = void 0;
  }), we;
}
const cs = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function s5({ slots: e }, n) {
  return n.length === 1 && n[0] === "default" ? (e.default ? e.default() : []).reduce((o, i) => [
    ...o,
    // prettier-ignore
    ...i.type === me ? i.children : [i]
  ], []) : n.reduce((t, o) => {
    const i = e[o];
    return i && (t[o] = i()), t;
  }, {});
}
function M1(e) {
  return me;
}
Pt({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => Tt(e) || !isNaN(e)
  }
}, cs);
function u5(e) {
  return Ct(e) && !ke(e[0]);
}
function S1(e, n, t, o) {
  const { slots: i, attrs: r } = n;
  return () => {
    const a = { part: !0 };
    let l = {};
    e.locale && (a.locale = e.locale), ke(e.format) ? a.key = e.format : Qe(e.format) && (ke(e.format.key) && (a.key = e.format.key), l = Object.keys(e.format).reduce((c, h) => t.includes(h) ? Pt({}, c, { [h]: e.format[h] }) : c, {}));
    const s = o(e.value, a, l);
    let u = [a.key];
    Ct(s) ? u = s.map((c, h) => {
      const m = i[c.type], g = m ? m({ [c.type]: c.value, index: h, parts: s }) : [c.value];
      return u5(g) && (g[0].key = `${c.type}-${h}`), g;
    }) : ke(s) && (u = [s]);
    const d = Pt({}, r), f = ke(e.tag) || Qe(e.tag) ? e.tag : M1();
    return wt(f, d, u);
  };
}
Pt({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, cs);
Pt({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, cs);
function Iu(e, n) {
}
const d5 = /* @__PURE__ */ Ln("global-vue-i18n");
function Cn(e = {}) {
  const n = yn();
  if (n == null)
    throw Wo(pt.MUST_BE_CALL_SETUP_TOP);
  if (!n.isCE && n.appContext.app != null && !n.appContext.app.__VUE_I18N_SYMBOL__)
    throw Wo(pt.NOT_INSTALLED);
  const t = c5(n), o = h5(t), i = E1(n), r = f5(e, i);
  if (r === "global")
    return r5(o, e, i), o;
  if (r === "parent") {
    let s = g5(t, n, e.__useComponent);
    return s == null && (process.env.NODE_ENV !== "production" && Jo(ds(Jt.NOT_FOUND_PARENT_SCOPE)), s = o), s;
  }
  const a = t;
  let l = a.__getInstance(n);
  if (l == null) {
    const s = Pt({}, e);
    "__i18n" in i && (s.__i18n = i.__i18n), o && (s.__root = o), l = l5(s), a.__composerExtend && (l[_l] = a.__composerExtend(l)), p5(a, n, l), a.__setInstance(n, l);
  }
  return l;
}
function c5(e) {
  {
    const n = eo(e.isCE ? d5 : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!n)
      throw Wo(e.isCE ? pt.NOT_INSTALLED_WITH_PROVIDE : pt.UNEXPECTED_ERROR);
    return n;
  }
}
function f5(e, n) {
  return ha(e) ? "__i18n" in n ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function h5(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function g5(e, n, t = !1) {
  let o = null;
  const i = n.root;
  let r = m5(n, t);
  for (; r != null; ) {
    const a = e;
    if (e.mode === "composition" && (o = a.__getInstance(r)), o != null || i === r)
      break;
    r = r.parent;
  }
  return o;
}
function m5(e, n = !1) {
  return e == null ? null : n && e.vnode.ctx || e.parent;
}
function p5(e, n, t) {
  let o = null;
  Ge(() => {
    if (process.env.NODE_ENV !== "production" && n.vnode.el) {
      n.vnode.el.__VUE_I18N__ = t, o = uv();
      const i = t;
      i[$l] && i[$l](o), o.on("*", Iu);
    }
  }, n), to(() => {
    const i = t;
    process.env.NODE_ENV !== "production" && n.vnode.el && n.vnode.el.__VUE_I18N__ && (o && o.off("*", Iu), i[kl] && i[kl](), delete n.vnode.el.__VUE_I18N__), e.__deleteInstance(n);
    const r = i[_l];
    r && (r(), delete i[_l]);
  }, n);
}
e5();
Hv(wv);
zv(f1);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = rs();
  e.__INTLIFY__ = !0, Tv(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const v5 = { class: "md:flex" }, b5 = { class: "h-40 w-40" }, y5 = {
  class: "h-40 w-40",
  viewBox: "0 0 160 160",
  xmlns: "http://www.w3.org/2000/svg"
}, C5 = ["d", "fill"], x5 = { class: "mt-4 md:ml-4 md:mt-0" }, w5 = { class: "text-mgm-txt-sm font-normal text-[#667085]" }, _A = /* @__PURE__ */ re({
  __name: "BasePieChart",
  props: {
    data: {
      type: Array,
      required: !0
    },
    locale: {
      type: String,
      default: "en"
    }
  },
  setup(e) {
    const n = e, { t } = Cn(), o = ee(() => {
      const a = n.data, l = a.reduce((d, f) => d + ((f == null ? void 0 : f.value) || 0), 0), s = 40;
      let u = 0;
      return a.map((d) => {
        const f = d != null && d.value ? d.value / l * 360 : 0, c = u, h = c + f;
        u += f;
        const [m, g] = r(80, 80, 80, c), [v, p] = r(80, 80, 80, h), [y, C] = r(80, 80, s, c), [b, x] = r(80, 80, s, h), w = f > 180 ? 1 : 0;
        return {
          ...d,
          d: `M ${m} ${g} A 80 80 0 ${w} 1 ${v} ${p} L ${b} ${x} A ${s} ${s} 0 ${w} 0 ${y} ${C} z`
        };
      });
    }), i = ee(() => n.data.reduce((a, l) => a + ((l == null ? void 0 : l.value) || 0), 0)), r = (a, l, s, u) => {
      const d = (u - 90) * (Math.PI / 180);
      return [a + s * Math.cos(d), l + s * Math.sin(d)];
    };
    return (a, l) => {
      const s = ns("tooltip");
      return _(), P("div", v5, [
        M("div", b5, [
          (_(), P("svg", y5, [
            M("g", null, [
              (_(!0), P(me, null, Fe(o.value, (u, d) => (_(), P(me, { key: d }, [
                u.value ? po((_(), P("path", {
                  key: 0,
                  class: "cursor-pointer transition-all duration-300 ease-in-out outline-none",
                  d: u.d,
                  fill: u.color,
                  stroke: "white",
                  "stroke-width": "1"
                }, null, 8, C5)), [
                  [s, {
                    content: `<span>${u.label}${e.locale === "fr" ? " " : ""}: ${(u.value / i.value * 100).toFixed(
                      1
                    )}% <span style='color:#CBD5E1;text-transform: lowercase;'>• ${u.value} ${I(t)("generic.users.name")}</span></span>`,
                    html: !0
                  }]
                ]) : z("", !0)
              ], 64))), 128))
            ])
          ]))
        ]),
        M("div", x5, [
          (_(!0), P(me, null, Fe(o.value, (u, d) => po((_(), P("div", {
            key: `legend-${d}`,
            class: "mb-1 flex cursor-pointer items-center"
          }, [
            M("div", {
              class: "mr-2 h-2 w-2 rounded-full",
              style: Ye({ backgroundColor: u.color })
            }, null, 4),
            M("span", w5, de(u.label), 1)
          ])), [
            [s, {
              content: `<span>${u.label}${a.$i18n.locale === "fr" ? " " : ""}: ${(u.value ? u.value / i.value * 100 : 0).toFixed(
                1
              )}% <span style='color:#CBD5E1;text-transform: lowercase;'>• ${u.value} ${I(t)("generic.users.name")}</span></span>`,
              html: !0
            }]
          ])), 128))
        ])
      ]);
    };
  }
}), $5 = { class: "relative w-fit" }, k5 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "126",
  height: "103",
  class: "overflow-visible",
  viewBox: "0 0 126 103",
  fill: "none"
}, _5 = /* @__PURE__ */ M("path", {
  d: "M111 99C118.535 88.9717 123 76.5054 123 62.9963C123 29.8613 96.1371 3 63 3C29.8629 3 3 29.8613 3 62.9963C3 76.5054 7.46507 88.9717 15 99",
  stroke: "#A4BCFD",
  "stroke-width": "6",
  "stroke-linecap": "round",
  "stroke-dasharray": "12 12"
}, null, -1), O5 = ["d"], E5 = { class: "absolute left-0 right-0 bottom-[14px] w-full text-center text-background-brand-disabled text-mgm-txt-xl font-normal" }, M5 = { class: "text-foreground-on-emphasis text-mgm-dspl-lg font-normal" }, OA = /* @__PURE__ */ re({
  __name: "BaseProgressRing",
  props: {
    progress: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const n = e, t = ee(() => {
      switch (n.progress) {
        case 1:
          return "M15.0819 99.1089C9.76659 92.0553 6.07408 83.9152 4.26796 75.2698C2.46183 66.6243 2.58663 57.6868 4.63345 49.0951";
        case 2:
          return "M15.0819 99.1089C9.76659 92.0553 6.07408 83.9152 4.26796 75.2698C2.46183 66.6243 2.58663 57.6868 4.63345 49.0951C6.68026 40.5035 10.5986 32.4697 16.1088 25.5672C21.6189 18.6648 28.585 13.0639 36.5096 9.1645";
        case 3:
          return "M15.0819 99.1089C7.06831 88.4746 2.81993 75.4766 3.00585 62.1623C3.19176 48.8479 7.80141 35.9737 16.1088 25.5672C24.4161 15.1608 35.9492 7.81341 48.8915 4.68234C61.8338 1.55127 75.4499 2.8144 87.5954 8.27279";
        case 4:
          return "M15.0819 99.1089C9.76659 92.0553 6.07408 83.9152 4.26796 75.2698C2.46183 66.6243 2.58663 57.6868 4.63345 49.0951C6.68026 40.5035 10.5986 32.4697 16.1088 25.5672C21.6189 18.6648 28.585 13.0639 36.5096 9.1645C44.4343 5.26509 53.1221 3.16328 61.9528 3.00914C70.7836 2.855 79.5394 4.65232 87.5954 8.27279C95.6513 11.8933 102.809 17.2476 108.556 23.9535C114.304 30.6595 118.5 38.5516 120.846 47.0666";
        default:
          return "M15.0819 99.1089C8.36477 90.195 4.2672 79.5842 3.24979 68.4692C2.23238 57.3543 4.33547 46.1759 9.32264 36.1907C14.3098 26.2054 21.9833 17.8092 31.4806 11.9458C40.9779 6.08249 51.9224 2.98448 63.0838 3.00006C74.2452 3.01564 85.181 6.1442 94.6618 12.034C104.143 17.9239 111.793 26.3415 116.752 36.3406C121.711 46.3398 123.783 57.524 122.735 68.6361C121.686 79.7481 117.559 90.3475 110.817 99.2426";
      }
    });
    return (o, i) => (_(), P("div", $5, [
      (_(), P("svg", k5, [
        _5,
        e.progress !== 0 ? (_(), P("path", {
          key: 0,
          d: t.value,
          stroke: "white",
          "stroke-width": "6",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, O5)) : z("", !0)
      ])),
      M("p", E5, [
        M("span", M5, de(e.progress), 1),
        Ie(" / 5 ")
      ])
    ]));
  }
}), S5 = ["for"], Re = /* @__PURE__ */ re({
  __name: "FieldLabel",
  props: {
    description: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  setup(e) {
    return (n, t) => (_(), P("label", {
      for: e.id,
      class: pe(["block", {
        "text-mgm-txt-sm font-medium text-foreground-emphasis": !e.error && !e.description,
        "text-mgm-txt-xs font-normal text-foreground-default": e.description,
        "text-mgm-txt-xs font-medium text-foreground-danger-default": e.error
      }])
    }, [
      Ie(de(e.label) + " ", 1),
      be(n.$slots, "default")
    ], 10, S5));
  }
}), A5 = {
  key: 0,
  class: "mb-3"
}, T5 = {
  key: 0,
  class: "flex items-start"
}, P5 = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, I5 = ["src"], D5 = {
  key: 1,
  class: "text-mgm-txt-sm font-semibold uppercase text-foreground-default"
}, L5 = { type: "button" }, N5 = ["id", "accept"], F5 = ["for"], EA = /* @__PURE__ */ re({
  __name: "FieldAvatarUploader",
  props: {
    accept: {
      type: String,
      default: "image/*"
    },
    iconCta: {
      type: String,
      default: null
    },
    cta: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: "en"
    },
    modelValue: {
      type: File,
      default: null
    },
    previewUrl: {
      type: String,
      default: void 0
    },
    fallback: {
      type: String,
      default: ""
    },
    placeholderIcon: {
      type: String,
      default: "user"
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    variant: {
      type: String,
      default: "default"
    }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = X(), o = X(""), i = n, r = (a) => {
      const l = a.target;
      if (l && l.files) {
        let s = null;
        s = l.files[0], s && (o.value = URL.createObjectURL(s)), i("update:modelValue", s), i("change", s);
      }
    };
    return (a, l) => {
      var s, u;
      return _(), P("div", {
        ref_key: "root",
        ref: t
      }, [
        e.label || e.description ? (_(), P("div", A5, [
          e.label ? (_(), P("div", T5, [
            ce(Re, {
              for: e.id,
              label: e.label
            }, null, 8, ["for", "label"]),
            e.required ? (_(), P("span", P5, " * ")) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("div", {
          class: pe(`flex w-full items-center ${e.variant === "vertical" ? "flex-col" : ""}`)
        }, [
          M("div", {
            class: pe(`flex items-center justify-center overflow-hidden rounded-full bg-background-subtle ${e.variant === "vertical" ? "mb-4 w-24 h-24" : "mr-4 h-10 w-10 "}`)
          }, [
            o.value || e.previewUrl ? (_(), P("img", {
              key: 0,
              class: "h-full w-full object-cover",
              src: o.value || e.previewUrl,
              alt: "avatar"
            }, null, 8, I5)) : e.fallback ? (_(), P("span", D5, de(e.fallback), 1)) : (_(), ie(Le, {
              key: 2,
              icon: e.placeholderIcon,
              color: "#5F6C85"
            }, null, 8, ["icon"]))
          ], 2),
          M("button", L5, [
            M("input", {
              id: e.id,
              class: "sr-only",
              accept: e.accept,
              tabindex: "-1",
              type: "file",
              onChange: r
            }, null, 40, N5),
            M("label", {
              class: "box-border cursor-pointer rounded-3xl border border-border-subtle px-[15px] py-[9px] text-mgm-txt-sm font-medium text-foreground-default shadow-[0_1px_2px_rgba(28,31,39,0.05)] hover:border-border-default hover:text-foreground-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_3px_#F1F5F9] disabled:border-background-subtle disabled:text-foreground-subtle inline-flex gap-1",
              for: e.id,
              onClick: l[0] || (l[0] = Yn(() => {
              }, ["stop"]))
            }, [
              e.iconCta ? (_(), ie(Le, {
                key: 0,
                icon: e.iconCta,
                color: "#5F6C85"
              }, null, 8, ["icon"])) : z("", !0),
              Ie(" " + de(e.cta), 1)
            ], 8, F5)
          ])
        ], 2),
        e.validation && ((s = e.validation.$errors) != null && s.length) ? (_(), ie(Re, {
          key: 1,
          class: "mt-1",
          label: (u = e.validation.$errors[0]) == null ? void 0 : u.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ], 512);
    };
  }
}), R5 = { class: "flex h-5 items-center" }, B5 = ["id", "checked", "disabled", "name", "required"], V5 = ["for"], Ei = /* @__PURE__ */ re({
  __name: "FieldCheckbox",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    id: {
      type: [String, Number],
      required: !0
    },
    label: {
      type: Boolean,
      default: !0
    },
    labelFullWidth: {
      type: Boolean,
      default: !1
    },
    customColor: {
      type: String,
      default: null
    },
    customRgbColor: {
      type: String,
      default: null
    },
    selectAll: {
      type: Boolean,
      default: !1
    },
    forceHover: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    errorState: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = X(), i = n;
    Ge(() => {
      if (t.modelValue && t.customColor && t.customRgbColor && !t.disabled) {
        let s = document.head.appendChild(
          document.createElement("style")
        );
        s.innerHTML = `#${t.id}:before {border-color: ${t.customColor}; background-color: rgba(${t.customRgbColor}, 0.2); color: ${t.customColor};`;
      }
    });
    const r = (s) => {
      if (s.target && t.customColor && t.customRgbColor) {
        let d = document.head.appendChild(
          document.createElement("style")
        );
        d.innerHTML = `#${t.id}:focus {border-color: ${t.customColor} !important; background-color: rgba(${t.customRgbColor}, 0.2) !important; box-shadow: 0px 1px 2px rgba(${t.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${t.customRgbColor}, 0.08) !important;`;
      }
    }, a = (s) => {
      const u = s.target;
      if (i("change", u.checked, t.id), i("update:modelValue", u.checked), u && t.customColor && t.customRgbColor && !t.disabled) {
        let d = document.head.appendChild(
          document.createElement("style")
        );
        d.innerHTML = `#${t.id}:before {border-color: ${t.customColor}; background-color: rgba(${t.customRgbColor}, 0.2); color: ${t.customColor};`;
      }
    }, l = () => {
      if (o.value && t.customColor && t.customRgbColor && !t.modelValue && !t.disabled) {
        let s = document.head.appendChild(
          document.createElement("style")
        );
        s.innerHTML = `#${t.id}:hover {border-color: ${t.customColor}; background-color: rgba(${t.customRgbColor}, 0.2);`;
      }
    };
    return (s, u) => {
      var d, f;
      return _(), P("fieldset", {
        ref_key: "root",
        ref: o,
        class: "relative flex items-center",
        onMouseenter: l
      }, [
        M("div", R5, [
          M("input", {
            id: `${e.id}`,
            class: pe([
              "relative box-border h-5 w-5 rounded-[5px] border border-solid border-border-default bg-background-default outline-none disabled:bg-background-subtle-hover",
              {
                "border-border-subtle   focus:border-border-brand-emphasis  focus:bg-background-brand-default focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE]": !e.customColor && !e.disabled,
                "before:border-border-brand-emphasis before:bg-background-brand-emphasis before:text-foreground-on-emphasis": !e.customColor && e.modelValue && !e.disabled,
                "before:!border-border-danger-emphasis before:!bg-background-danger-emphasis": e.errorState && e.modelValue && !e.disabled,
                "before:border-border-default before:bg-background-subtle-hover before:text-foreground-subtle": e.modelValue && e.disabled,
                "before:absolute before:bottom-0 before:left-[-1px] before:right-0 before:top-[-1px] before:flex before:h-5 before:w-5 before:items-center before:justify-center before:rounded-[5px] before:border before:border-solid before:text-[14px]": e.modelValue,
                "cursor-pointer": !e.disabled,
                "selectAll before:pb-[2px]": e.selectAll,
                "border-border-brand-emphasis bg-background-brand-default-hover": e.forceHover && !e.customColor && !e.disabled,
                "hover:border-border-brand-emphasis hover:bg-background-brand-default-hover": !e.forceHover && !e.customColor && !e.disabled
              }
            ]),
            checked: e.modelValue,
            disabled: e.disabled,
            name: `${e.id}`,
            required: e.required,
            type: "checkbox",
            onInput: a,
            onFocus: r
          }, null, 42, B5)
        ]),
        M("div", {
          class: pe(["ml-2", { "w-full": e.labelFullWidth }])
        }, [
          e.label ? (_(), P("label", {
            key: 0,
            for: `${e.id}`,
            class: "block cursor-pointer text-mgm-txt-md font-normal text-foreground-default mt-1"
          }, [
            be(s.$slots, "default"),
            e.required ? (_(), P("span", {
              key: 0,
              class: pe([
                "text-mgm-txt-sm font-medium",
                { "text-foreground-brand-default": !e.customColor }
              ]),
              style: Ye({ color: e.customColor })
            }, " * ", 6)) : z("", !0)
          ], 8, V5)) : z("", !0),
          e.validation && ((d = e.validation.$errors) != null && d.length) ? (_(), ie(Re, {
            key: 1,
            class: "mt-1",
            label: (f = e.validation.$errors[0]) == null ? void 0 : f.$message,
            error: ""
          }, null, 8, ["label"])) : z("", !0)
        ], 2)
      ], 544);
    };
  }
});
var Ra = [
  "onChange",
  "onClose",
  "onDayCreate",
  "onDestroy",
  "onKeyDown",
  "onMonthChange",
  "onOpen",
  "onParseConfig",
  "onReady",
  "onValueUpdate",
  "onYearChange",
  "onPreCalendarPosition"
], Vo = {
  _disable: [],
  allowInput: !1,
  allowInvalidPreload: !1,
  altFormat: "F j, Y",
  altInput: !1,
  altInputClass: "form-control input",
  animate: typeof window == "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
  ariaDateFormat: "F j, Y",
  autoFillDefaultTime: !0,
  clickOpens: !0,
  closeOnSelect: !0,
  conjunction: ", ",
  dateFormat: "Y-m-d",
  defaultHour: 12,
  defaultMinute: 0,
  defaultSeconds: 0,
  disable: [],
  disableMobile: !1,
  enableSeconds: !1,
  enableTime: !1,
  errorHandler: function(e) {
    return typeof console < "u" && console.warn(e);
  },
  getWeek: function(e) {
    var n = new Date(e.getTime());
    n.setHours(0, 0, 0, 0), n.setDate(n.getDate() + 3 - (n.getDay() + 6) % 7);
    var t = new Date(n.getFullYear(), 0, 4);
    return 1 + Math.round(((n.getTime() - t.getTime()) / 864e5 - 3 + (t.getDay() + 6) % 7) / 7);
  },
  hourIncrement: 1,
  ignoredFocusElements: [],
  inline: !1,
  locale: "default",
  minuteIncrement: 5,
  mode: "single",
  monthSelectorType: "dropdown",
  nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
  noCalendar: !1,
  now: /* @__PURE__ */ new Date(),
  onChange: [],
  onClose: [],
  onDayCreate: [],
  onDestroy: [],
  onKeyDown: [],
  onMonthChange: [],
  onOpen: [],
  onParseConfig: [],
  onReady: [],
  onValueUpdate: [],
  onYearChange: [],
  onPreCalendarPosition: [],
  plugins: [],
  position: "auto",
  positionElement: void 0,
  prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
  shorthandCurrentMonth: !1,
  showMonths: 1,
  static: !1,
  time_24hr: !1,
  weekNumbers: !1,
  wrap: !1
}, Mi = {
  weekdays: {
    shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    longhand: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    longhand: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  firstDayOfWeek: 0,
  ordinal: function(e) {
    var n = e % 100;
    if (n > 3 && n < 21)
      return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  rangeSeparator: " to ",
  weekAbbreviation: "Wk",
  scrollTitle: "Scroll to increment",
  toggleTitle: "Click to toggle",
  amPM: ["AM", "PM"],
  yearAriaLabel: "Year",
  monthAriaLabel: "Month",
  hourAriaLabel: "Hour",
  minuteAriaLabel: "Minute",
  time_24hr: !1
}, Vt = function(e, n) {
  return n === void 0 && (n = 2), ("000" + e).slice(n * -1);
}, Xt = function(e) {
  return e === !0 ? 1 : 0;
};
function Du(e, n) {
  var t;
  return function() {
    var o = this, i = arguments;
    clearTimeout(t), t = setTimeout(function() {
      return e.apply(o, i);
    }, n);
  };
}
var Ba = function(e) {
  return e instanceof Array ? e : [e];
};
function Lt(e, n, t) {
  if (t === !0)
    return e.classList.add(n);
  e.classList.remove(n);
}
function Ze(e, n, t) {
  var o = window.document.createElement(e);
  return n = n || "", t = t || "", o.className = n, t !== void 0 && (o.textContent = t), o;
}
function ar(e) {
  for (; e.firstChild; )
    e.removeChild(e.firstChild);
}
function A1(e, n) {
  if (n(e))
    return e;
  if (e.parentNode)
    return A1(e.parentNode, n);
}
function lr(e, n) {
  var t = Ze("div", "numInputWrapper"), o = Ze("input", "numInput " + e), i = Ze("span", "arrowUp"), r = Ze("span", "arrowDown");
  if (navigator.userAgent.indexOf("MSIE 9.0") === -1 ? o.type = "number" : (o.type = "text", o.pattern = "\\d*"), n !== void 0)
    for (var a in n)
      o.setAttribute(a, n[a]);
  return t.appendChild(o), t.appendChild(i), t.appendChild(r), t;
}
function qt(e) {
  try {
    if (typeof e.composedPath == "function") {
      var n = e.composedPath();
      return n[0];
    }
    return e.target;
  } catch {
    return e.target;
  }
}
var Va = function() {
}, Vr = function(e, n, t) {
  return t.months[n ? "shorthand" : "longhand"][e];
}, j5 = {
  D: Va,
  F: function(e, n, t) {
    e.setMonth(t.months.longhand.indexOf(n));
  },
  G: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  H: function(e, n) {
    e.setHours(parseFloat(n));
  },
  J: function(e, n) {
    e.setDate(parseFloat(n));
  },
  K: function(e, n, t) {
    e.setHours(e.getHours() % 12 + 12 * Xt(new RegExp(t.amPM[1], "i").test(n)));
  },
  M: function(e, n, t) {
    e.setMonth(t.months.shorthand.indexOf(n));
  },
  S: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  U: function(e, n) {
    return new Date(parseFloat(n) * 1e3);
  },
  W: function(e, n, t) {
    var o = parseInt(n), i = new Date(e.getFullYear(), 0, 2 + (o - 1) * 7, 0, 0, 0, 0);
    return i.setDate(i.getDate() - i.getDay() + t.firstDayOfWeek), i;
  },
  Y: function(e, n) {
    e.setFullYear(parseFloat(n));
  },
  Z: function(e, n) {
    return new Date(n);
  },
  d: function(e, n) {
    e.setDate(parseFloat(n));
  },
  h: function(e, n) {
    e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(n));
  },
  i: function(e, n) {
    e.setMinutes(parseFloat(n));
  },
  j: function(e, n) {
    e.setDate(parseFloat(n));
  },
  l: Va,
  m: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  n: function(e, n) {
    e.setMonth(parseFloat(n) - 1);
  },
  s: function(e, n) {
    e.setSeconds(parseFloat(n));
  },
  u: function(e, n) {
    return new Date(parseFloat(n));
  },
  w: Va,
  y: function(e, n) {
    e.setFullYear(2e3 + parseFloat(n));
  }
}, co = {
  D: "",
  F: "",
  G: "(\\d\\d|\\d)",
  H: "(\\d\\d|\\d)",
  J: "(\\d\\d|\\d)\\w+",
  K: "",
  M: "",
  S: "(\\d\\d|\\d)",
  U: "(.+)",
  W: "(\\d\\d|\\d)",
  Y: "(\\d{4})",
  Z: "(.+)",
  d: "(\\d\\d|\\d)",
  h: "(\\d\\d|\\d)",
  i: "(\\d\\d|\\d)",
  j: "(\\d\\d|\\d)",
  l: "",
  m: "(\\d\\d|\\d)",
  n: "(\\d\\d|\\d)",
  s: "(\\d\\d|\\d)",
  u: "(.+)",
  w: "(\\d\\d|\\d)",
  y: "(\\d{2})"
}, bi = {
  Z: function(e) {
    return e.toISOString();
  },
  D: function(e, n, t) {
    return n.weekdays.shorthand[bi.w(e, n, t)];
  },
  F: function(e, n, t) {
    return Vr(bi.n(e, n, t) - 1, !1, n);
  },
  G: function(e, n, t) {
    return Vt(bi.h(e, n, t));
  },
  H: function(e) {
    return Vt(e.getHours());
  },
  J: function(e, n) {
    return n.ordinal !== void 0 ? e.getDate() + n.ordinal(e.getDate()) : e.getDate();
  },
  K: function(e, n) {
    return n.amPM[Xt(e.getHours() > 11)];
  },
  M: function(e, n) {
    return Vr(e.getMonth(), !0, n);
  },
  S: function(e) {
    return Vt(e.getSeconds());
  },
  U: function(e) {
    return e.getTime() / 1e3;
  },
  W: function(e, n, t) {
    return t.getWeek(e);
  },
  Y: function(e) {
    return Vt(e.getFullYear(), 4);
  },
  d: function(e) {
    return Vt(e.getDate());
  },
  h: function(e) {
    return e.getHours() % 12 ? e.getHours() % 12 : 12;
  },
  i: function(e) {
    return Vt(e.getMinutes());
  },
  j: function(e) {
    return e.getDate();
  },
  l: function(e, n) {
    return n.weekdays.longhand[e.getDay()];
  },
  m: function(e) {
    return Vt(e.getMonth() + 1);
  },
  n: function(e) {
    return e.getMonth() + 1;
  },
  s: function(e) {
    return e.getSeconds();
  },
  u: function(e) {
    return e.getTime();
  },
  w: function(e) {
    return e.getDay();
  },
  y: function(e) {
    return String(e.getFullYear()).substring(2);
  }
}, T1 = function(e) {
  var n = e.config, t = n === void 0 ? Vo : n, o = e.l10n, i = o === void 0 ? Mi : o, r = e.isMobile, a = r === void 0 ? !1 : r;
  return function(l, s, u) {
    var d = u || i;
    return t.formatDate !== void 0 && !a ? t.formatDate(l, s, d) : s.split("").map(function(f, c, h) {
      return bi[f] && h[c - 1] !== "\\" ? bi[f](l, d, t) : f !== "\\" ? f : "";
    }).join("");
  };
}, El = function(e) {
  var n = e.config, t = n === void 0 ? Vo : n, o = e.l10n, i = o === void 0 ? Mi : o;
  return function(r, a, l, s) {
    if (!(r !== 0 && !r)) {
      var u = s || i, d, f = r;
      if (r instanceof Date)
        d = new Date(r.getTime());
      else if (typeof r != "string" && r.toFixed !== void 0)
        d = new Date(r);
      else if (typeof r == "string") {
        var c = a || (t || Vo).dateFormat, h = String(r).trim();
        if (h === "today")
          d = /* @__PURE__ */ new Date(), l = !0;
        else if (t && t.parseDate)
          d = t.parseDate(r, c);
        else if (/Z$/.test(h) || /GMT$/.test(h))
          d = new Date(r);
        else {
          for (var m = void 0, g = [], v = 0, p = 0, y = ""; v < c.length; v++) {
            var C = c[v], b = C === "\\", x = c[v - 1] === "\\" || b;
            if (co[C] && !x) {
              y += co[C];
              var w = new RegExp(y).exec(r);
              w && (m = !0) && g[C !== "Y" ? "push" : "unshift"]({
                fn: j5[C],
                val: w[++p]
              });
            } else
              b || (y += ".");
          }
          d = !t || !t.noCalendar ? new Date((/* @__PURE__ */ new Date()).getFullYear(), 0, 1, 0, 0, 0, 0) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)), g.forEach(function($) {
            var E = $.fn, A = $.val;
            return d = E(d, A, u) || d;
          }), d = m ? d : void 0;
        }
      }
      if (!(d instanceof Date && !isNaN(d.getTime()))) {
        t.errorHandler(new Error("Invalid date provided: " + f));
        return;
      }
      return l === !0 && d.setHours(0, 0, 0, 0), d;
    }
  };
};
function Ut(e, n, t) {
  return t === void 0 && (t = !0), t !== !1 ? new Date(e.getTime()).setHours(0, 0, 0, 0) - new Date(n.getTime()).setHours(0, 0, 0, 0) : e.getTime() - n.getTime();
}
var H5 = function(e, n, t) {
  return e > Math.min(n, t) && e < Math.max(n, t);
}, ja = function(e, n, t) {
  return e * 3600 + n * 60 + t;
}, z5 = function(e) {
  var n = Math.floor(e / 3600), t = (e - n * 3600) / 60;
  return [n, t, e - n * 3600 - t * 60];
}, q5 = {
  DAY: 864e5
};
function Ha(e) {
  var n = e.defaultHour, t = e.defaultMinute, o = e.defaultSeconds;
  if (e.minDate !== void 0) {
    var i = e.minDate.getHours(), r = e.minDate.getMinutes(), a = e.minDate.getSeconds();
    n < i && (n = i), n === i && t < r && (t = r), n === i && t === r && o < a && (o = e.minDate.getSeconds());
  }
  if (e.maxDate !== void 0) {
    var l = e.maxDate.getHours(), s = e.maxDate.getMinutes();
    n = Math.min(n, l), n === l && (t = Math.min(s, t)), n === l && t === s && (o = e.maxDate.getSeconds());
  }
  return { hours: n, minutes: t, seconds: o };
}
typeof Object.assign != "function" && (Object.assign = function(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  if (!e)
    throw TypeError("Cannot convert undefined or null to object");
  for (var o = function(l) {
    l && Object.keys(l).forEach(function(s) {
      return e[s] = l[s];
    });
  }, i = 0, r = n; i < r.length; i++) {
    var a = r[i];
    o(a);
  }
  return e;
});
var At = globalThis && globalThis.__assign || function() {
  return At = Object.assign || function(e) {
    for (var n, t = 1, o = arguments.length; t < o; t++) {
      n = arguments[t];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, At.apply(this, arguments);
}, Lu = globalThis && globalThis.__spreadArrays || function() {
  for (var e = 0, n = 0, t = arguments.length; n < t; n++)
    e += arguments[n].length;
  for (var o = Array(e), i = 0, n = 0; n < t; n++)
    for (var r = arguments[n], a = 0, l = r.length; a < l; a++, i++)
      o[i] = r[a];
  return o;
}, U5 = 300;
function W5(e, n) {
  var t = {
    config: At(At({}, Vo), ft.defaultConfig),
    l10n: Mi
  };
  t.parseDate = El({ config: t.config, l10n: t.l10n }), t._handlers = [], t.pluginElements = [], t.loadedPlugins = [], t._bind = g, t._setHoursFromDate = c, t._positionCalendar = ue, t.changeMonth = D, t.changeYear = K, t.clear = V, t.close = q, t.onMouseOver = Oe, t._createElement = Ze, t.createDay = w, t.destroy = Z, t.isEnabled = te, t.jumpToDate = y, t.updateValue = $n, t.open = De, t.redraw = he, t.set = et, t.setDate = tt, t.toggle = Kh;
  function o() {
    t.utils = {
      getDaysInMonth: function(N, j) {
        return N === void 0 && (N = t.currentMonth), j === void 0 && (j = t.currentYear), N === 1 && (j % 4 === 0 && j % 100 !== 0 || j % 400 === 0) ? 29 : t.l10n.daysInMonth[N];
      }
    };
  }
  function i() {
    t.element = t.input = e, t.isOpen = !1, $t(), se(), kt(), it(), o(), t.isMobile || x(), p(), (t.selectedDates.length || t.config.noCalendar) && (t.config.enableTime && c(t.config.noCalendar ? t.latestSelectedDateObj : void 0), $n(!1)), l();
    var N = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    !t.isMobile && N && ue(), ut("onReady");
  }
  function r() {
    var N;
    return ((N = t.calendarContainer) === null || N === void 0 ? void 0 : N.getRootNode()).activeElement || document.activeElement;
  }
  function a(N) {
    return N.bind(t);
  }
  function l() {
    var N = t.config;
    N.weekNumbers === !1 && N.showMonths === 1 || N.noCalendar !== !0 && window.requestAnimationFrame(function() {
      if (t.calendarContainer !== void 0 && (t.calendarContainer.style.visibility = "hidden", t.calendarContainer.style.display = "block"), t.daysContainer !== void 0) {
        var j = (t.days.offsetWidth + 1) * N.showMonths;
        t.daysContainer.style.width = j + "px", t.calendarContainer.style.width = j + (t.weekWrapper !== void 0 ? t.weekWrapper.offsetWidth : 0) + "px", t.calendarContainer.style.removeProperty("visibility"), t.calendarContainer.style.removeProperty("display");
      }
    });
  }
  function s(N) {
    if (t.selectedDates.length === 0) {
      var j = t.config.minDate === void 0 || Ut(/* @__PURE__ */ new Date(), t.config.minDate) >= 0 ? /* @__PURE__ */ new Date() : new Date(t.config.minDate.getTime()), G = Ha(t.config);
      j.setHours(G.hours, G.minutes, G.seconds, j.getMilliseconds()), t.selectedDates = [j], t.latestSelectedDateObj = j;
    }
    N !== void 0 && N.type !== "blur" && Zh(N);
    var ae = t._input.value;
    f(), $n(), t._input.value !== ae && t._debouncedChange();
  }
  function u(N, j) {
    return N % 12 + 12 * Xt(j === t.l10n.amPM[1]);
  }
  function d(N) {
    switch (N % 24) {
      case 0:
      case 12:
        return 12;
      default:
        return N % 12;
    }
  }
  function f() {
    if (!(t.hourElement === void 0 || t.minuteElement === void 0)) {
      var N = (parseInt(t.hourElement.value.slice(-2), 10) || 0) % 24, j = (parseInt(t.minuteElement.value, 10) || 0) % 60, G = t.secondElement !== void 0 ? (parseInt(t.secondElement.value, 10) || 0) % 60 : 0;
      t.amPM !== void 0 && (N = u(N, t.amPM.textContent));
      var ae = t.config.minTime !== void 0 || t.config.minDate && t.minDateHasTime && t.latestSelectedDateObj && Ut(t.latestSelectedDateObj, t.config.minDate, !0) === 0, ge = t.config.maxTime !== void 0 || t.config.maxDate && t.maxDateHasTime && t.latestSelectedDateObj && Ut(t.latestSelectedDateObj, t.config.maxDate, !0) === 0;
      if (t.config.maxTime !== void 0 && t.config.minTime !== void 0 && t.config.minTime > t.config.maxTime) {
        var xe = ja(t.config.minTime.getHours(), t.config.minTime.getMinutes(), t.config.minTime.getSeconds()), Pe = ja(t.config.maxTime.getHours(), t.config.maxTime.getMinutes(), t.config.maxTime.getSeconds()), _e = ja(N, j, G);
        if (_e > Pe && _e < xe) {
          var Be = z5(xe);
          N = Be[0], j = Be[1], G = Be[2];
        }
      } else {
        if (ge) {
          var $e = t.config.maxTime !== void 0 ? t.config.maxTime : t.config.maxDate;
          N = Math.min(N, $e.getHours()), N === $e.getHours() && (j = Math.min(j, $e.getMinutes())), j === $e.getMinutes() && (G = Math.min(G, $e.getSeconds()));
        }
        if (ae) {
          var Se = t.config.minTime !== void 0 ? t.config.minTime : t.config.minDate;
          N = Math.max(N, Se.getHours()), N === Se.getHours() && j < Se.getMinutes() && (j = Se.getMinutes()), j === Se.getMinutes() && (G = Math.max(G, Se.getSeconds()));
        }
      }
      h(N, j, G);
    }
  }
  function c(N) {
    var j = N || t.latestSelectedDateObj;
    j && j instanceof Date && h(j.getHours(), j.getMinutes(), j.getSeconds());
  }
  function h(N, j, G) {
    t.latestSelectedDateObj !== void 0 && t.latestSelectedDateObj.setHours(N % 24, j, G || 0, 0), !(!t.hourElement || !t.minuteElement || t.isMobile) && (t.hourElement.value = Vt(t.config.time_24hr ? N : (12 + N) % 12 + 12 * Xt(N % 12 === 0)), t.minuteElement.value = Vt(j), t.amPM !== void 0 && (t.amPM.textContent = t.l10n.amPM[Xt(N >= 12)]), t.secondElement !== void 0 && (t.secondElement.value = Vt(G)));
  }
  function m(N) {
    var j = qt(N), G = parseInt(j.value) + (N.delta || 0);
    (G / 1e3 > 1 || N.key === "Enter" && !/[^\d]/.test(G.toString())) && K(G);
  }
  function g(N, j, G, ae) {
    if (j instanceof Array)
      return j.forEach(function(ge) {
        return g(N, ge, G, ae);
      });
    if (N instanceof Array)
      return N.forEach(function(ge) {
        return g(ge, j, G, ae);
      });
    N.addEventListener(j, G, ae), t._handlers.push({
      remove: function() {
        return N.removeEventListener(j, G, ae);
      }
    });
  }
  function v() {
    ut("onChange");
  }
  function p() {
    if (t.config.wrap && ["open", "close", "toggle", "clear"].forEach(function(G) {
      Array.prototype.forEach.call(t.element.querySelectorAll("[data-" + G + "]"), function(ae) {
        return g(ae, "click", t[G]);
      });
    }), t.isMobile) {
      nr();
      return;
    }
    var N = Du(Ae, 50);
    if (t._debouncedChange = Du(v, U5), t.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent) && g(t.daysContainer, "mouseover", function(G) {
      t.config.mode === "range" && Oe(qt(G));
    }), g(t._input, "keydown", Ce), t.calendarContainer !== void 0 && g(t.calendarContainer, "keydown", Ce), !t.config.inline && !t.config.static && g(window, "resize", N), window.ontouchstart !== void 0 ? g(window.document, "touchstart", R) : g(window.document, "mousedown", R), g(window.document, "focus", R, { capture: !0 }), t.config.clickOpens === !0 && (g(t._input, "focus", t.open), g(t._input, "click", t.open)), t.daysContainer !== void 0 && (g(t.monthNav, "click", Gh), g(t.monthNav, ["keyup", "increment"], m), g(t.daysContainer, "click", Q)), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0) {
      var j = function(G) {
        return qt(G).select();
      };
      g(t.timeContainer, ["increment"], s), g(t.timeContainer, "blur", s, { capture: !0 }), g(t.timeContainer, "click", C), g([t.hourElement, t.minuteElement], ["focus", "click"], j), t.secondElement !== void 0 && g(t.secondElement, "focus", function() {
        return t.secondElement && t.secondElement.select();
      }), t.amPM !== void 0 && g(t.amPM, "click", function(G) {
        s(G);
      });
    }
    t.config.allowInput && g(t._input, "blur", fe);
  }
  function y(N, j) {
    var G = N !== void 0 ? t.parseDate(N) : t.latestSelectedDateObj || (t.config.minDate && t.config.minDate > t.now ? t.config.minDate : t.config.maxDate && t.config.maxDate < t.now ? t.config.maxDate : t.now), ae = t.currentYear, ge = t.currentMonth;
    try {
      G !== void 0 && (t.currentYear = G.getFullYear(), t.currentMonth = G.getMonth());
    } catch (xe) {
      xe.message = "Invalid date supplied: " + G, t.config.errorHandler(xe);
    }
    j && t.currentYear !== ae && (ut("onYearChange"), T()), j && (t.currentYear !== ae || t.currentMonth !== ge) && ut("onMonthChange"), t.redraw();
  }
  function C(N) {
    var j = qt(N);
    ~j.className.indexOf("arrow") && b(N, j.classList.contains("arrowUp") ? 1 : -1);
  }
  function b(N, j, G) {
    var ae = N && qt(N), ge = G || ae && ae.parentNode && ae.parentNode.firstChild, xe = Da("increment");
    xe.delta = j, ge && ge.dispatchEvent(xe);
  }
  function x() {
    var N = window.document.createDocumentFragment();
    if (t.calendarContainer = Ze("div", "flatpickr-calendar"), t.calendarContainer.tabIndex = -1, !t.config.noCalendar) {
      if (N.appendChild(U()), t.innerContainer = Ze("div", "flatpickr-innerContainer"), t.config.weekNumbers) {
        var j = B(), G = j.weekWrapper, ae = j.weekNumbers;
        t.innerContainer.appendChild(G), t.weekNumbers = ae, t.weekWrapper = G;
      }
      t.rContainer = Ze("div", "flatpickr-rContainer"), t.rContainer.appendChild(oe()), t.daysContainer || (t.daysContainer = Ze("div", "flatpickr-days"), t.daysContainer.tabIndex = -1), S(), t.rContainer.appendChild(t.daysContainer), t.innerContainer.appendChild(t.rContainer), N.appendChild(t.innerContainer);
    }
    t.config.enableTime && N.appendChild(W()), Lt(t.calendarContainer, "rangeMode", t.config.mode === "range"), Lt(t.calendarContainer, "animate", t.config.animate === !0), Lt(t.calendarContainer, "multiMonth", t.config.showMonths > 1), t.calendarContainer.appendChild(N);
    var ge = t.config.appendTo !== void 0 && t.config.appendTo.nodeType !== void 0;
    if ((t.config.inline || t.config.static) && (t.calendarContainer.classList.add(t.config.inline ? "inline" : "static"), t.config.inline && (!ge && t.element.parentNode ? t.element.parentNode.insertBefore(t.calendarContainer, t._input.nextSibling) : t.config.appendTo !== void 0 && t.config.appendTo.appendChild(t.calendarContainer)), t.config.static)) {
      var xe = Ze("div", "flatpickr-wrapper");
      t.element.parentNode && t.element.parentNode.insertBefore(xe, t.element), xe.appendChild(t.element), t.altInput && xe.appendChild(t.altInput), xe.appendChild(t.calendarContainer);
    }
    !t.config.static && !t.config.inline && (t.config.appendTo !== void 0 ? t.config.appendTo : window.document.body).appendChild(t.calendarContainer);
  }
  function w(N, j, G, ae) {
    var ge = te(j, !0), xe = Ze("span", N, j.getDate().toString());
    return xe.dateObj = j, xe.$i = ae, xe.setAttribute("aria-label", t.formatDate(j, t.config.ariaDateFormat)), N.indexOf("hidden") === -1 && Ut(j, t.now) === 0 && (t.todayDateElem = xe, xe.classList.add("today"), xe.setAttribute("aria-current", "date")), ge ? (xe.tabIndex = -1, La(j) && (xe.classList.add("selected"), t.selectedDateElem = xe, t.config.mode === "range" && (Lt(xe, "startRange", t.selectedDates[0] && Ut(j, t.selectedDates[0], !0) === 0), Lt(xe, "endRange", t.selectedDates[1] && Ut(j, t.selectedDates[1], !0) === 0), N === "nextMonthDay" && xe.classList.add("inRange")))) : xe.classList.add("flatpickr-disabled"), t.config.mode === "range" && Yh(j) && !La(j) && xe.classList.add("inRange"), t.weekNumbers && t.config.showMonths === 1 && N !== "prevMonthDay" && ae % 7 === 6 && t.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + t.config.getWeek(j) + "</span>"), ut("onDayCreate", xe), xe;
  }
  function $(N) {
    N.focus(), t.config.mode === "range" && Oe(N);
  }
  function E(N) {
    for (var j = N > 0 ? 0 : t.config.showMonths - 1, G = N > 0 ? t.config.showMonths : -1, ae = j; ae != G; ae += N)
      for (var ge = t.daysContainer.children[ae], xe = N > 0 ? 0 : ge.children.length - 1, Pe = N > 0 ? ge.children.length : -1, _e = xe; _e != Pe; _e += N) {
        var Be = ge.children[_e];
        if (Be.className.indexOf("hidden") === -1 && te(Be.dateObj))
          return Be;
      }
  }
  function A(N, j) {
    for (var G = N.className.indexOf("Month") === -1 ? N.dateObj.getMonth() : t.currentMonth, ae = j > 0 ? t.config.showMonths : -1, ge = j > 0 ? 1 : -1, xe = G - t.currentMonth; xe != ae; xe += ge)
      for (var Pe = t.daysContainer.children[xe], _e = G - t.currentMonth === xe ? N.$i + j : j < 0 ? Pe.children.length - 1 : 0, Be = Pe.children.length, $e = _e; $e >= 0 && $e < Be && $e != (j > 0 ? Be : -1); $e += ge) {
        var Se = Pe.children[$e];
        if (Se.className.indexOf("hidden") === -1 && te(Se.dateObj) && Math.abs(N.$i - $e) >= Math.abs(j))
          return $(Se);
      }
    t.changeMonth(ge), O(E(ge), 0);
  }
  function O(N, j) {
    var G = r(), ae = ne(G || document.body), ge = N !== void 0 ? N : ae ? G : t.selectedDateElem !== void 0 && ne(t.selectedDateElem) ? t.selectedDateElem : t.todayDateElem !== void 0 && ne(t.todayDateElem) ? t.todayDateElem : E(j > 0 ? 1 : -1);
    ge === void 0 ? t._input.focus() : ae ? A(ge, j) : $(ge);
  }
  function k(N, j) {
    for (var G = (new Date(N, j, 1).getDay() - t.l10n.firstDayOfWeek + 7) % 7, ae = t.utils.getDaysInMonth((j - 1 + 12) % 12, N), ge = t.utils.getDaysInMonth(j, N), xe = window.document.createDocumentFragment(), Pe = t.config.showMonths > 1, _e = Pe ? "prevMonthDay hidden" : "prevMonthDay", Be = Pe ? "nextMonthDay hidden" : "nextMonthDay", $e = ae + 1 - G, Se = 0; $e <= ae; $e++, Se++)
      xe.appendChild(w("flatpickr-day " + _e, new Date(N, j - 1, $e), $e, Se));
    for ($e = 1; $e <= ge; $e++, Se++)
      xe.appendChild(w("flatpickr-day", new Date(N, j, $e), $e, Se));
    for (var rt = ge + 1; rt <= 42 - G && (t.config.showMonths === 1 || Se % 7 !== 0); rt++, Se++)
      xe.appendChild(w("flatpickr-day " + Be, new Date(N, j + 1, rt % ge), rt, Se));
    var cn = Ze("div", "dayContainer");
    return cn.appendChild(xe), cn;
  }
  function S() {
    if (t.daysContainer !== void 0) {
      ar(t.daysContainer), t.weekNumbers && ar(t.weekNumbers);
      for (var N = document.createDocumentFragment(), j = 0; j < t.config.showMonths; j++) {
        var G = new Date(t.currentYear, t.currentMonth, 1);
        G.setMonth(t.currentMonth + j), N.appendChild(k(G.getFullYear(), G.getMonth()));
      }
      t.daysContainer.appendChild(N), t.days = t.daysContainer.firstChild, t.config.mode === "range" && t.selectedDates.length === 1 && Oe();
    }
  }
  function T() {
    if (!(t.config.showMonths > 1 || t.config.monthSelectorType !== "dropdown")) {
      var N = function(ae) {
        return t.config.minDate !== void 0 && t.currentYear === t.config.minDate.getFullYear() && ae < t.config.minDate.getMonth() ? !1 : !(t.config.maxDate !== void 0 && t.currentYear === t.config.maxDate.getFullYear() && ae > t.config.maxDate.getMonth());
      };
      t.monthsDropdownContainer.tabIndex = -1, t.monthsDropdownContainer.innerHTML = "";
      for (var j = 0; j < 12; j++)
        if (N(j)) {
          var G = Ze("option", "flatpickr-monthDropdown-month");
          G.value = new Date(t.currentYear, j).getMonth().toString(), G.textContent = Vr(j, t.config.shorthandCurrentMonth, t.l10n), G.tabIndex = -1, t.currentMonth === j && (G.selected = !0), t.monthsDropdownContainer.appendChild(G);
        }
    }
  }
  function L() {
    var N = Ze("div", "flatpickr-month"), j = window.document.createDocumentFragment(), G;
    t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? G = Ze("span", "cur-month") : (t.monthsDropdownContainer = Ze("select", "flatpickr-monthDropdown-months"), t.monthsDropdownContainer.setAttribute("aria-label", t.l10n.monthAriaLabel), g(t.monthsDropdownContainer, "change", function(Pe) {
      var _e = qt(Pe), Be = parseInt(_e.value, 10);
      t.changeMonth(Be - t.currentMonth), ut("onMonthChange");
    }), T(), G = t.monthsDropdownContainer);
    var ae = lr("cur-year", { tabindex: "-1" }), ge = ae.getElementsByTagName("input")[0];
    ge.setAttribute("aria-label", t.l10n.yearAriaLabel), t.config.minDate && ge.setAttribute("min", t.config.minDate.getFullYear().toString()), t.config.maxDate && (ge.setAttribute("max", t.config.maxDate.getFullYear().toString()), ge.disabled = !!t.config.minDate && t.config.minDate.getFullYear() === t.config.maxDate.getFullYear());
    var xe = Ze("div", "flatpickr-current-month");
    return xe.appendChild(G), xe.appendChild(ae), j.appendChild(xe), N.appendChild(j), {
      container: N,
      yearElement: ge,
      monthElement: G
    };
  }
  function F() {
    ar(t.monthNav), t.monthNav.appendChild(t.prevMonthNav), t.config.showMonths && (t.yearElements = [], t.monthElements = []);
    for (var N = t.config.showMonths; N--; ) {
      var j = L();
      t.yearElements.push(j.yearElement), t.monthElements.push(j.monthElement), t.monthNav.appendChild(j.container);
    }
    t.monthNav.appendChild(t.nextMonthNav);
  }
  function U() {
    return t.monthNav = Ze("div", "flatpickr-months"), t.yearElements = [], t.monthElements = [], t.prevMonthNav = Ze("span", "flatpickr-prev-month"), t.prevMonthNav.innerHTML = t.config.prevArrow, t.nextMonthNav = Ze("span", "flatpickr-next-month"), t.nextMonthNav.innerHTML = t.config.nextArrow, F(), Object.defineProperty(t, "_hidePrevMonthArrow", {
      get: function() {
        return t.__hidePrevMonthArrow;
      },
      set: function(N) {
        t.__hidePrevMonthArrow !== N && (Lt(t.prevMonthNav, "flatpickr-disabled", N), t.__hidePrevMonthArrow = N);
      }
    }), Object.defineProperty(t, "_hideNextMonthArrow", {
      get: function() {
        return t.__hideNextMonthArrow;
      },
      set: function(N) {
        t.__hideNextMonthArrow !== N && (Lt(t.nextMonthNav, "flatpickr-disabled", N), t.__hideNextMonthArrow = N);
      }
    }), t.currentYearElement = t.yearElements[0], or(), t.monthNav;
  }
  function W() {
    t.calendarContainer.classList.add("hasTime"), t.config.noCalendar && t.calendarContainer.classList.add("noCalendar");
    var N = Ha(t.config);
    t.timeContainer = Ze("div", "flatpickr-time"), t.timeContainer.tabIndex = -1;
    var j = Ze("span", "flatpickr-time-separator", ":"), G = lr("flatpickr-hour", {
      "aria-label": t.l10n.hourAriaLabel
    });
    t.hourElement = G.getElementsByTagName("input")[0];
    var ae = lr("flatpickr-minute", {
      "aria-label": t.l10n.minuteAriaLabel
    });
    if (t.minuteElement = ae.getElementsByTagName("input")[0], t.hourElement.tabIndex = t.minuteElement.tabIndex = -1, t.hourElement.value = Vt(t.latestSelectedDateObj ? t.latestSelectedDateObj.getHours() : t.config.time_24hr ? N.hours : d(N.hours)), t.minuteElement.value = Vt(t.latestSelectedDateObj ? t.latestSelectedDateObj.getMinutes() : N.minutes), t.hourElement.setAttribute("step", t.config.hourIncrement.toString()), t.minuteElement.setAttribute("step", t.config.minuteIncrement.toString()), t.hourElement.setAttribute("min", t.config.time_24hr ? "0" : "1"), t.hourElement.setAttribute("max", t.config.time_24hr ? "23" : "12"), t.hourElement.setAttribute("maxlength", "2"), t.minuteElement.setAttribute("min", "0"), t.minuteElement.setAttribute("max", "59"), t.minuteElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(G), t.timeContainer.appendChild(j), t.timeContainer.appendChild(ae), t.config.time_24hr && t.timeContainer.classList.add("time24hr"), t.config.enableSeconds) {
      t.timeContainer.classList.add("hasSeconds");
      var ge = lr("flatpickr-second");
      t.secondElement = ge.getElementsByTagName("input")[0], t.secondElement.value = Vt(t.latestSelectedDateObj ? t.latestSelectedDateObj.getSeconds() : N.seconds), t.secondElement.setAttribute("step", t.minuteElement.getAttribute("step")), t.secondElement.setAttribute("min", "0"), t.secondElement.setAttribute("max", "59"), t.secondElement.setAttribute("maxlength", "2"), t.timeContainer.appendChild(Ze("span", "flatpickr-time-separator", ":")), t.timeContainer.appendChild(ge);
    }
    return t.config.time_24hr || (t.amPM = Ze("span", "flatpickr-am-pm", t.l10n.amPM[Xt((t.latestSelectedDateObj ? t.hourElement.value : t.config.defaultHour) > 11)]), t.amPM.title = t.l10n.toggleTitle, t.amPM.tabIndex = -1, t.timeContainer.appendChild(t.amPM)), t.timeContainer;
  }
  function oe() {
    t.weekdayContainer ? ar(t.weekdayContainer) : t.weekdayContainer = Ze("div", "flatpickr-weekdays");
    for (var N = t.config.showMonths; N--; ) {
      var j = Ze("div", "flatpickr-weekdaycontainer");
      t.weekdayContainer.appendChild(j);
    }
    return H(), t.weekdayContainer;
  }
  function H() {
    if (t.weekdayContainer) {
      var N = t.l10n.firstDayOfWeek, j = Lu(t.l10n.weekdays.shorthand);
      N > 0 && N < j.length && (j = Lu(j.splice(N, j.length), j.splice(0, N)));
      for (var G = t.config.showMonths; G--; )
        t.weekdayContainer.children[G].innerHTML = `
      <span class='flatpickr-weekday'>
        ` + j.join("</span><span class='flatpickr-weekday'>") + `
      </span>
      `;
    }
  }
  function B() {
    t.calendarContainer.classList.add("hasWeeks");
    var N = Ze("div", "flatpickr-weekwrapper");
    N.appendChild(Ze("span", "flatpickr-weekday", t.l10n.weekAbbreviation));
    var j = Ze("div", "flatpickr-weeks");
    return N.appendChild(j), {
      weekWrapper: N,
      weekNumbers: j
    };
  }
  function D(N, j) {
    j === void 0 && (j = !0);
    var G = j ? N : N - t.currentMonth;
    G < 0 && t._hidePrevMonthArrow === !0 || G > 0 && t._hideNextMonthArrow === !0 || (t.currentMonth += G, (t.currentMonth < 0 || t.currentMonth > 11) && (t.currentYear += t.currentMonth > 11 ? 1 : -1, t.currentMonth = (t.currentMonth + 12) % 12, ut("onYearChange"), T()), S(), ut("onMonthChange"), or());
  }
  function V(N, j) {
    if (N === void 0 && (N = !0), j === void 0 && (j = !0), t.input.value = "", t.altInput !== void 0 && (t.altInput.value = ""), t.mobileInput !== void 0 && (t.mobileInput.value = ""), t.selectedDates = [], t.latestSelectedDateObj = void 0, j === !0 && (t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth()), t.config.enableTime === !0) {
      var G = Ha(t.config), ae = G.hours, ge = G.minutes, xe = G.seconds;
      h(ae, ge, xe);
    }
    t.redraw(), N && ut("onChange");
  }
  function q() {
    t.isOpen = !1, t.isMobile || (t.calendarContainer !== void 0 && t.calendarContainer.classList.remove("open"), t._input !== void 0 && t._input.classList.remove("active")), ut("onClose");
  }
  function Z() {
    t.config !== void 0 && ut("onDestroy");
    for (var N = t._handlers.length; N--; )
      t._handlers[N].remove();
    if (t._handlers = [], t.mobileInput)
      t.mobileInput.parentNode && t.mobileInput.parentNode.removeChild(t.mobileInput), t.mobileInput = void 0;
    else if (t.calendarContainer && t.calendarContainer.parentNode)
      if (t.config.static && t.calendarContainer.parentNode) {
        var j = t.calendarContainer.parentNode;
        if (j.lastChild && j.removeChild(j.lastChild), j.parentNode) {
          for (; j.firstChild; )
            j.parentNode.insertBefore(j.firstChild, j);
          j.parentNode.removeChild(j);
        }
      } else
        t.calendarContainer.parentNode.removeChild(t.calendarContainer);
    t.altInput && (t.input.type = "text", t.altInput.parentNode && t.altInput.parentNode.removeChild(t.altInput), delete t.altInput), t.input && (t.input.type = t.input._type, t.input.classList.remove("flatpickr-input"), t.input.removeAttribute("readonly")), [
      "_showTimeInput",
      "latestSelectedDateObj",
      "_hideNextMonthArrow",
      "_hidePrevMonthArrow",
      "__hideNextMonthArrow",
      "__hidePrevMonthArrow",
      "isMobile",
      "isOpen",
      "selectedDateElem",
      "minDateHasTime",
      "maxDateHasTime",
      "days",
      "daysContainer",
      "_input",
      "_positionElement",
      "innerContainer",
      "rContainer",
      "monthNav",
      "todayDateElem",
      "calendarContainer",
      "weekdayContainer",
      "prevMonthNav",
      "nextMonthNav",
      "monthsDropdownContainer",
      "currentMonthElement",
      "currentYearElement",
      "navigationCurrentMonth",
      "selectedDateElem",
      "config"
    ].forEach(function(G) {
      try {
        delete t[G];
      } catch {
      }
    });
  }
  function Y(N) {
    return t.calendarContainer.contains(N);
  }
  function R(N) {
    if (t.isOpen && !t.config.inline) {
      var j = qt(N), G = Y(j), ae = j === t.input || j === t.altInput || t.element.contains(j) || N.path && N.path.indexOf && (~N.path.indexOf(t.input) || ~N.path.indexOf(t.altInput)), ge = !ae && !G && !Y(N.relatedTarget), xe = !t.config.ignoredFocusElements.some(function(Pe) {
        return Pe.contains(j);
      });
      ge && xe && (t.config.allowInput && t.setDate(t._input.value, !1, t.config.altInput ? t.config.altFormat : t.config.dateFormat), t.timeContainer !== void 0 && t.minuteElement !== void 0 && t.hourElement !== void 0 && t.input.value !== "" && t.input.value !== void 0 && s(), t.close(), t.config && t.config.mode === "range" && t.selectedDates.length === 1 && t.clear(!1));
    }
  }
  function K(N) {
    if (!(!N || t.config.minDate && N < t.config.minDate.getFullYear() || t.config.maxDate && N > t.config.maxDate.getFullYear())) {
      var j = N, G = t.currentYear !== j;
      t.currentYear = j || t.currentYear, t.config.maxDate && t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth = Math.min(t.config.maxDate.getMonth(), t.currentMonth) : t.config.minDate && t.currentYear === t.config.minDate.getFullYear() && (t.currentMonth = Math.max(t.config.minDate.getMonth(), t.currentMonth)), G && (t.redraw(), ut("onYearChange"), T());
    }
  }
  function te(N, j) {
    var G;
    j === void 0 && (j = !0);
    var ae = t.parseDate(N, void 0, j);
    if (t.config.minDate && ae && Ut(ae, t.config.minDate, j !== void 0 ? j : !t.minDateHasTime) < 0 || t.config.maxDate && ae && Ut(ae, t.config.maxDate, j !== void 0 ? j : !t.maxDateHasTime) > 0)
      return !1;
    if (!t.config.enable && t.config.disable.length === 0)
      return !0;
    if (ae === void 0)
      return !1;
    for (var ge = !!t.config.enable, xe = (G = t.config.enable) !== null && G !== void 0 ? G : t.config.disable, Pe = 0, _e = void 0; Pe < xe.length; Pe++) {
      if (_e = xe[Pe], typeof _e == "function" && _e(ae))
        return ge;
      if (_e instanceof Date && ae !== void 0 && _e.getTime() === ae.getTime())
        return ge;
      if (typeof _e == "string") {
        var Be = t.parseDate(_e, void 0, !0);
        return Be && Be.getTime() === ae.getTime() ? ge : !ge;
      } else if (typeof _e == "object" && ae !== void 0 && _e.from && _e.to && ae.getTime() >= _e.from.getTime() && ae.getTime() <= _e.to.getTime())
        return ge;
    }
    return !ge;
  }
  function ne(N) {
    return t.daysContainer !== void 0 ? N.className.indexOf("hidden") === -1 && N.className.indexOf("flatpickr-disabled") === -1 && t.daysContainer.contains(N) : !1;
  }
  function fe(N) {
    var j = N.target === t._input, G = t._input.value.trimEnd() !== Na();
    j && G && !(N.relatedTarget && Y(N.relatedTarget)) && t.setDate(t._input.value, !0, N.target === t.altInput ? t.config.altFormat : t.config.dateFormat);
  }
  function Ce(N) {
    var j = qt(N), G = t.config.wrap ? e.contains(j) : j === t._input, ae = t.config.allowInput, ge = t.isOpen && (!ae || !G), xe = t.config.inline && G && !ae;
    if (N.keyCode === 13 && G) {
      if (ae)
        return t.setDate(t._input.value, !0, j === t.altInput ? t.config.altFormat : t.config.dateFormat), t.close(), j.blur();
      t.open();
    } else if (Y(j) || ge || xe) {
      var Pe = !!t.timeContainer && t.timeContainer.contains(j);
      switch (N.keyCode) {
        case 13:
          Pe ? (N.preventDefault(), s(), we()) : Q(N);
          break;
        case 27:
          N.preventDefault(), we();
          break;
        case 8:
        case 46:
          G && !t.config.allowInput && (N.preventDefault(), t.clear());
          break;
        case 37:
        case 39:
          if (!Pe && !G) {
            N.preventDefault();
            var _e = r();
            if (t.daysContainer !== void 0 && (ae === !1 || _e && ne(_e))) {
              var Be = N.keyCode === 39 ? 1 : -1;
              N.ctrlKey ? (N.stopPropagation(), D(Be), O(E(1), 0)) : O(void 0, Be);
            }
          } else
            t.hourElement && t.hourElement.focus();
          break;
        case 38:
        case 40:
          N.preventDefault();
          var $e = N.keyCode === 40 ? 1 : -1;
          t.daysContainer && j.$i !== void 0 || j === t.input || j === t.altInput ? N.ctrlKey ? (N.stopPropagation(), K(t.currentYear - $e), O(E(1), 0)) : Pe || O(void 0, $e * 7) : j === t.currentYearElement ? K(t.currentYear - $e) : t.config.enableTime && (!Pe && t.hourElement && t.hourElement.focus(), s(N), t._debouncedChange());
          break;
        case 9:
          if (Pe) {
            var Se = [
              t.hourElement,
              t.minuteElement,
              t.secondElement,
              t.amPM
            ].concat(t.pluginElements).filter(function(zt) {
              return zt;
            }), rt = Se.indexOf(j);
            if (rt !== -1) {
              var cn = Se[rt + (N.shiftKey ? -1 : 1)];
              N.preventDefault(), (cn || t._input).focus();
            }
          } else
            !t.config.noCalendar && t.daysContainer && t.daysContainer.contains(j) && N.shiftKey && (N.preventDefault(), t._input.focus());
          break;
      }
    }
    if (t.amPM !== void 0 && j === t.amPM)
      switch (N.key) {
        case t.l10n.amPM[0].charAt(0):
        case t.l10n.amPM[0].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[0], f(), $n();
          break;
        case t.l10n.amPM[1].charAt(0):
        case t.l10n.amPM[1].charAt(0).toLowerCase():
          t.amPM.textContent = t.l10n.amPM[1], f(), $n();
          break;
      }
    (G || Y(j)) && ut("onKeyDown", N);
  }
  function Oe(N, j) {
    if (j === void 0 && (j = "flatpickr-day"), !(t.selectedDates.length !== 1 || N && (!N.classList.contains(j) || N.classList.contains("flatpickr-disabled")))) {
      for (var G = N ? N.dateObj.getTime() : t.days.firstElementChild.dateObj.getTime(), ae = t.parseDate(t.selectedDates[0], void 0, !0).getTime(), ge = Math.min(G, t.selectedDates[0].getTime()), xe = Math.max(G, t.selectedDates[0].getTime()), Pe = !1, _e = 0, Be = 0, $e = ge; $e < xe; $e += q5.DAY)
        te(new Date($e), !0) || (Pe = Pe || $e > ge && $e < xe, $e < ae && (!_e || $e > _e) ? _e = $e : $e > ae && (!Be || $e < Be) && (Be = $e));
      var Se = Array.from(t.rContainer.querySelectorAll("*:nth-child(-n+" + t.config.showMonths + ") > ." + j));
      Se.forEach(function(rt) {
        var cn = rt.dateObj, zt = cn.getTime(), oi = _e > 0 && zt < _e || Be > 0 && zt > Be;
        if (oi) {
          rt.classList.add("notAllowed"), ["inRange", "startRange", "endRange"].forEach(function(So) {
            rt.classList.remove(So);
          });
          return;
        } else if (Pe && !oi)
          return;
        ["startRange", "inRange", "endRange", "notAllowed"].forEach(function(So) {
          rt.classList.remove(So);
        }), N !== void 0 && (N.classList.add(G <= t.selectedDates[0].getTime() ? "startRange" : "endRange"), ae < G && zt === ae ? rt.classList.add("startRange") : ae > G && zt === ae && rt.classList.add("endRange"), zt >= _e && (Be === 0 || zt <= Be) && H5(zt, ae, G) && rt.classList.add("inRange"));
      });
    }
  }
  function Ae() {
    t.isOpen && !t.config.static && !t.config.inline && ue();
  }
  function De(N, j) {
    if (j === void 0 && (j = t._positionElement), t.isMobile === !0) {
      if (N) {
        N.preventDefault();
        var G = qt(N);
        G && G.blur();
      }
      t.mobileInput !== void 0 && (t.mobileInput.focus(), t.mobileInput.click()), ut("onOpen");
      return;
    } else if (t._input.disabled || t.config.inline)
      return;
    var ae = t.isOpen;
    t.isOpen = !0, ae || (t.calendarContainer.classList.add("open"), t._input.classList.add("active"), ut("onOpen"), ue(j)), t.config.enableTime === !0 && t.config.noCalendar === !0 && t.config.allowInput === !1 && (N === void 0 || !t.timeContainer.contains(N.relatedTarget)) && setTimeout(function() {
      return t.hourElement.select();
    }, 50);
  }
  function qe(N) {
    return function(j) {
      var G = t.config["_" + N + "Date"] = t.parseDate(j, t.config.dateFormat), ae = t.config["_" + (N === "min" ? "max" : "min") + "Date"];
      G !== void 0 && (t[N === "min" ? "minDateHasTime" : "maxDateHasTime"] = G.getHours() > 0 || G.getMinutes() > 0 || G.getSeconds() > 0), t.selectedDates && (t.selectedDates = t.selectedDates.filter(function(ge) {
        return te(ge);
      }), !t.selectedDates.length && N === "min" && c(G), $n()), t.daysContainer && (he(), G !== void 0 ? t.currentYearElement[N] = G.getFullYear().toString() : t.currentYearElement.removeAttribute(N), t.currentYearElement.disabled = !!ae && G !== void 0 && ae.getFullYear() === G.getFullYear());
    };
  }
  function $t() {
    var N = [
      "wrap",
      "weekNumbers",
      "allowInput",
      "allowInvalidPreload",
      "clickOpens",
      "time_24hr",
      "enableTime",
      "noCalendar",
      "altInput",
      "shorthandCurrentMonth",
      "inline",
      "static",
      "enableSeconds",
      "disableMobile"
    ], j = At(At({}, JSON.parse(JSON.stringify(e.dataset || {}))), n), G = {};
    t.config.parseDate = j.parseDate, t.config.formatDate = j.formatDate, Object.defineProperty(t.config, "enable", {
      get: function() {
        return t.config._enable;
      },
      set: function(Se) {
        t.config._enable = wn(Se);
      }
    }), Object.defineProperty(t.config, "disable", {
      get: function() {
        return t.config._disable;
      },
      set: function(Se) {
        t.config._disable = wn(Se);
      }
    });
    var ae = j.mode === "time";
    if (!j.dateFormat && (j.enableTime || ae)) {
      var ge = ft.defaultConfig.dateFormat || Vo.dateFormat;
      G.dateFormat = j.noCalendar || ae ? "H:i" + (j.enableSeconds ? ":S" : "") : ge + " H:i" + (j.enableSeconds ? ":S" : "");
    }
    if (j.altInput && (j.enableTime || ae) && !j.altFormat) {
      var xe = ft.defaultConfig.altFormat || Vo.altFormat;
      G.altFormat = j.noCalendar || ae ? "h:i" + (j.enableSeconds ? ":S K" : " K") : xe + (" h:i" + (j.enableSeconds ? ":S" : "") + " K");
    }
    Object.defineProperty(t.config, "minDate", {
      get: function() {
        return t.config._minDate;
      },
      set: qe("min")
    }), Object.defineProperty(t.config, "maxDate", {
      get: function() {
        return t.config._maxDate;
      },
      set: qe("max")
    });
    var Pe = function(Se) {
      return function(rt) {
        t.config[Se === "min" ? "_minTime" : "_maxTime"] = t.parseDate(rt, "H:i:S");
      };
    };
    Object.defineProperty(t.config, "minTime", {
      get: function() {
        return t.config._minTime;
      },
      set: Pe("min")
    }), Object.defineProperty(t.config, "maxTime", {
      get: function() {
        return t.config._maxTime;
      },
      set: Pe("max")
    }), j.mode === "time" && (t.config.noCalendar = !0, t.config.enableTime = !0), Object.assign(t.config, G, j);
    for (var _e = 0; _e < N.length; _e++)
      t.config[N[_e]] = t.config[N[_e]] === !0 || t.config[N[_e]] === "true";
    Ra.filter(function(Se) {
      return t.config[Se] !== void 0;
    }).forEach(function(Se) {
      t.config[Se] = Ba(t.config[Se] || []).map(a);
    }), t.isMobile = !t.config.disableMobile && !t.config.inline && t.config.mode === "single" && !t.config.disable.length && !t.config.enable && !t.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    for (var _e = 0; _e < t.config.plugins.length; _e++) {
      var Be = t.config.plugins[_e](t) || {};
      for (var $e in Be)
        Ra.indexOf($e) > -1 ? t.config[$e] = Ba(Be[$e]).map(a).concat(t.config[$e]) : typeof j[$e] > "u" && (t.config[$e] = Be[$e]);
    }
    j.altInputClass || (t.config.altInputClass = st().className + " " + t.config.altInputClass), ut("onParseConfig");
  }
  function st() {
    return t.config.wrap ? e.querySelector("[data-input]") : e;
  }
  function se() {
    typeof t.config.locale != "object" && typeof ft.l10ns[t.config.locale] > "u" && t.config.errorHandler(new Error("flatpickr: invalid locale " + t.config.locale)), t.l10n = At(At({}, ft.l10ns.default), typeof t.config.locale == "object" ? t.config.locale : t.config.locale !== "default" ? ft.l10ns[t.config.locale] : void 0), co.D = "(" + t.l10n.weekdays.shorthand.join("|") + ")", co.l = "(" + t.l10n.weekdays.longhand.join("|") + ")", co.M = "(" + t.l10n.months.shorthand.join("|") + ")", co.F = "(" + t.l10n.months.longhand.join("|") + ")", co.K = "(" + t.l10n.amPM[0] + "|" + t.l10n.amPM[1] + "|" + t.l10n.amPM[0].toLowerCase() + "|" + t.l10n.amPM[1].toLowerCase() + ")";
    var N = At(At({}, n), JSON.parse(JSON.stringify(e.dataset || {})));
    N.time_24hr === void 0 && ft.defaultConfig.time_24hr === void 0 && (t.config.time_24hr = t.l10n.time_24hr), t.formatDate = T1(t), t.parseDate = El({ config: t.config, l10n: t.l10n });
  }
  function ue(N) {
    if (typeof t.config.position == "function")
      return void t.config.position(t, N);
    if (t.calendarContainer !== void 0) {
      ut("onPreCalendarPosition");
      var j = N || t._positionElement, G = Array.prototype.reduce.call(t.calendarContainer.children, function(i0, r0) {
        return i0 + r0.offsetHeight;
      }, 0), ae = t.calendarContainer.offsetWidth, ge = t.config.position.split(" "), xe = ge[0], Pe = ge.length > 1 ? ge[1] : null, _e = j.getBoundingClientRect(), Be = window.innerHeight - _e.bottom, $e = xe === "above" || xe !== "below" && Be < G && _e.top > G, Se = window.pageYOffset + _e.top + ($e ? -G - 2 : j.offsetHeight + 2);
      if (Lt(t.calendarContainer, "arrowTop", !$e), Lt(t.calendarContainer, "arrowBottom", $e), !t.config.inline) {
        var rt = window.pageXOffset + _e.left, cn = !1, zt = !1;
        Pe === "center" ? (rt -= (ae - _e.width) / 2, cn = !0) : Pe === "right" && (rt -= ae - _e.width, zt = !0), Lt(t.calendarContainer, "arrowLeft", !cn && !zt), Lt(t.calendarContainer, "arrowCenter", cn), Lt(t.calendarContainer, "arrowRight", zt);
        var oi = window.document.body.offsetWidth - (window.pageXOffset + _e.right), So = rt + ae > window.document.body.offsetWidth, Xh = oi + ae > window.document.body.offsetWidth;
        if (Lt(t.calendarContainer, "rightMost", So), !t.config.static)
          if (t.calendarContainer.style.top = Se + "px", !So)
            t.calendarContainer.style.left = rt + "px", t.calendarContainer.style.right = "auto";
          else if (!Xh)
            t.calendarContainer.style.left = "auto", t.calendarContainer.style.right = oi + "px";
          else {
            var Fa = ve();
            if (Fa === void 0)
              return;
            var Jh = window.document.body.offsetWidth, Qh = Math.max(0, Jh / 2 - ae / 2), e0 = ".flatpickr-calendar.centerMost:before", t0 = ".flatpickr-calendar.centerMost:after", n0 = Fa.cssRules.length, o0 = "{left:" + _e.left + "px;right:auto;}";
            Lt(t.calendarContainer, "rightMost", !1), Lt(t.calendarContainer, "centerMost", !0), Fa.insertRule(e0 + "," + t0 + o0, n0), t.calendarContainer.style.left = Qh + "px", t.calendarContainer.style.right = "auto";
          }
      }
    }
  }
  function ve() {
    for (var N = null, j = 0; j < document.styleSheets.length; j++) {
      var G = document.styleSheets[j];
      if (G.cssRules) {
        try {
          G.cssRules;
        } catch {
          continue;
        }
        N = G;
        break;
      }
    }
    return N ?? ye();
  }
  function ye() {
    var N = document.createElement("style");
    return document.head.appendChild(N), N.sheet;
  }
  function he() {
    t.config.noCalendar || t.isMobile || (T(), or(), S());
  }
  function we() {
    t._input.focus(), window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== void 0 ? setTimeout(t.close, 0) : t.close();
  }
  function Q(N) {
    N.preventDefault(), N.stopPropagation();
    var j = function(Se) {
      return Se.classList && Se.classList.contains("flatpickr-day") && !Se.classList.contains("flatpickr-disabled") && !Se.classList.contains("notAllowed");
    }, G = A1(qt(N), j);
    if (G !== void 0) {
      var ae = G, ge = t.latestSelectedDateObj = new Date(ae.dateObj.getTime()), xe = (ge.getMonth() < t.currentMonth || ge.getMonth() > t.currentMonth + t.config.showMonths - 1) && t.config.mode !== "range";
      if (t.selectedDateElem = ae, t.config.mode === "single")
        t.selectedDates = [ge];
      else if (t.config.mode === "multiple") {
        var Pe = La(ge);
        Pe ? t.selectedDates.splice(parseInt(Pe), 1) : t.selectedDates.push(ge);
      } else
        t.config.mode === "range" && (t.selectedDates.length === 2 && t.clear(!1, !1), t.latestSelectedDateObj = ge, t.selectedDates.push(ge), Ut(ge, t.selectedDates[0], !0) !== 0 && t.selectedDates.sort(function(Se, rt) {
          return Se.getTime() - rt.getTime();
        }));
      if (f(), xe) {
        var _e = t.currentYear !== ge.getFullYear();
        t.currentYear = ge.getFullYear(), t.currentMonth = ge.getMonth(), _e && (ut("onYearChange"), T()), ut("onMonthChange");
      }
      if (or(), S(), $n(), !xe && t.config.mode !== "range" && t.config.showMonths === 1 ? $(ae) : t.selectedDateElem !== void 0 && t.hourElement === void 0 && t.selectedDateElem && t.selectedDateElem.focus(), t.hourElement !== void 0 && t.hourElement !== void 0 && t.hourElement.focus(), t.config.closeOnSelect) {
        var Be = t.config.mode === "single" && !t.config.enableTime, $e = t.config.mode === "range" && t.selectedDates.length === 2 && !t.config.enableTime;
        (Be || $e) && we();
      }
      v();
    }
  }
  var le = {
    locale: [se, H],
    showMonths: [F, l, oe],
    minDate: [y],
    maxDate: [y],
    positionElement: [tr],
    clickOpens: [
      function() {
        t.config.clickOpens === !0 ? (g(t._input, "focus", t.open), g(t._input, "click", t.open)) : (t._input.removeEventListener("focus", t.open), t._input.removeEventListener("click", t.open));
      }
    ]
  };
  function et(N, j) {
    if (N !== null && typeof N == "object") {
      Object.assign(t.config, N);
      for (var G in N)
        le[G] !== void 0 && le[G].forEach(function(ae) {
          return ae();
        });
    } else
      t.config[N] = j, le[N] !== void 0 ? le[N].forEach(function(ae) {
        return ae();
      }) : Ra.indexOf(N) > -1 && (t.config[N] = Ba(j));
    t.redraw(), $n(!0);
  }
  function ot(N, j) {
    var G = [];
    if (N instanceof Array)
      G = N.map(function(ae) {
        return t.parseDate(ae, j);
      });
    else if (N instanceof Date || typeof N == "number")
      G = [t.parseDate(N, j)];
    else if (typeof N == "string")
      switch (t.config.mode) {
        case "single":
        case "time":
          G = [t.parseDate(N, j)];
          break;
        case "multiple":
          G = N.split(t.config.conjunction).map(function(ae) {
            return t.parseDate(ae, j);
          });
          break;
        case "range":
          G = N.split(t.l10n.rangeSeparator).map(function(ae) {
            return t.parseDate(ae, j);
          });
          break;
      }
    else
      t.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(N)));
    t.selectedDates = t.config.allowInvalidPreload ? G : G.filter(function(ae) {
      return ae instanceof Date && te(ae, !1);
    }), t.config.mode === "range" && t.selectedDates.sort(function(ae, ge) {
      return ae.getTime() - ge.getTime();
    });
  }
  function tt(N, j, G) {
    if (j === void 0 && (j = !1), G === void 0 && (G = t.config.dateFormat), N !== 0 && !N || N instanceof Array && N.length === 0)
      return t.clear(j);
    ot(N, G), t.latestSelectedDateObj = t.selectedDates[t.selectedDates.length - 1], t.redraw(), y(void 0, j), c(), t.selectedDates.length === 0 && t.clear(!1), $n(j), j && ut("onChange");
  }
  function wn(N) {
    return N.slice().map(function(j) {
      return typeof j == "string" || typeof j == "number" || j instanceof Date ? t.parseDate(j, void 0, !0) : j && typeof j == "object" && j.from && j.to ? {
        from: t.parseDate(j.from, void 0),
        to: t.parseDate(j.to, void 0)
      } : j;
    }).filter(function(j) {
      return j;
    });
  }
  function it() {
    t.selectedDates = [], t.now = t.parseDate(t.config.now) || /* @__PURE__ */ new Date();
    var N = t.config.defaultDate || ((t.input.nodeName === "INPUT" || t.input.nodeName === "TEXTAREA") && t.input.placeholder && t.input.value === t.input.placeholder ? null : t.input.value);
    N && ot(N, t.config.dateFormat), t._initialDate = t.selectedDates.length > 0 ? t.selectedDates[0] : t.config.minDate && t.config.minDate.getTime() > t.now.getTime() ? t.config.minDate : t.config.maxDate && t.config.maxDate.getTime() < t.now.getTime() ? t.config.maxDate : t.now, t.currentYear = t._initialDate.getFullYear(), t.currentMonth = t._initialDate.getMonth(), t.selectedDates.length > 0 && (t.latestSelectedDateObj = t.selectedDates[0]), t.config.minTime !== void 0 && (t.config.minTime = t.parseDate(t.config.minTime, "H:i")), t.config.maxTime !== void 0 && (t.config.maxTime = t.parseDate(t.config.maxTime, "H:i")), t.minDateHasTime = !!t.config.minDate && (t.config.minDate.getHours() > 0 || t.config.minDate.getMinutes() > 0 || t.config.minDate.getSeconds() > 0), t.maxDateHasTime = !!t.config.maxDate && (t.config.maxDate.getHours() > 0 || t.config.maxDate.getMinutes() > 0 || t.config.maxDate.getSeconds() > 0);
  }
  function kt() {
    if (t.input = st(), !t.input) {
      t.config.errorHandler(new Error("Invalid input element specified"));
      return;
    }
    t.input._type = t.input.type, t.input.type = "text", t.input.classList.add("flatpickr-input"), t._input = t.input, t.config.altInput && (t.altInput = Ze(t.input.nodeName, t.config.altInputClass), t._input = t.altInput, t.altInput.placeholder = t.input.placeholder, t.altInput.disabled = t.input.disabled, t.altInput.required = t.input.required, t.altInput.tabIndex = t.input.tabIndex, t.altInput.type = "text", t.input.setAttribute("type", "hidden"), !t.config.static && t.input.parentNode && t.input.parentNode.insertBefore(t.altInput, t.input.nextSibling)), t.config.allowInput || t._input.setAttribute("readonly", "readonly"), tr();
  }
  function tr() {
    t._positionElement = t.config.positionElement || t._input;
  }
  function nr() {
    var N = t.config.enableTime ? t.config.noCalendar ? "time" : "datetime-local" : "date";
    t.mobileInput = Ze("input", t.input.className + " flatpickr-mobile"), t.mobileInput.tabIndex = 1, t.mobileInput.type = N, t.mobileInput.disabled = t.input.disabled, t.mobileInput.required = t.input.required, t.mobileInput.placeholder = t.input.placeholder, t.mobileFormatStr = N === "datetime-local" ? "Y-m-d\\TH:i:S" : N === "date" ? "Y-m-d" : "H:i:S", t.selectedDates.length > 0 && (t.mobileInput.defaultValue = t.mobileInput.value = t.formatDate(t.selectedDates[0], t.mobileFormatStr)), t.config.minDate && (t.mobileInput.min = t.formatDate(t.config.minDate, "Y-m-d")), t.config.maxDate && (t.mobileInput.max = t.formatDate(t.config.maxDate, "Y-m-d")), t.input.getAttribute("step") && (t.mobileInput.step = String(t.input.getAttribute("step"))), t.input.type = "hidden", t.altInput !== void 0 && (t.altInput.type = "hidden");
    try {
      t.input.parentNode && t.input.parentNode.insertBefore(t.mobileInput, t.input.nextSibling);
    } catch {
    }
    g(t.mobileInput, "change", function(j) {
      t.setDate(qt(j).value, !1, t.mobileFormatStr), ut("onChange"), ut("onClose");
    });
  }
  function Kh(N) {
    if (t.isOpen === !0)
      return t.close();
    t.open(N);
  }
  function ut(N, j) {
    if (t.config !== void 0) {
      var G = t.config[N];
      if (G !== void 0 && G.length > 0)
        for (var ae = 0; G[ae] && ae < G.length; ae++)
          G[ae](t.selectedDates, t.input.value, t, j);
      N === "onChange" && (t.input.dispatchEvent(Da("change")), t.input.dispatchEvent(Da("input")));
    }
  }
  function Da(N) {
    var j = document.createEvent("Event");
    return j.initEvent(N, !0, !0), j;
  }
  function La(N) {
    for (var j = 0; j < t.selectedDates.length; j++) {
      var G = t.selectedDates[j];
      if (G instanceof Date && Ut(G, N) === 0)
        return "" + j;
    }
    return !1;
  }
  function Yh(N) {
    return t.config.mode !== "range" || t.selectedDates.length < 2 ? !1 : Ut(N, t.selectedDates[0]) >= 0 && Ut(N, t.selectedDates[1]) <= 0;
  }
  function or() {
    t.config.noCalendar || t.isMobile || !t.monthNav || (t.yearElements.forEach(function(N, j) {
      var G = new Date(t.currentYear, t.currentMonth, 1);
      G.setMonth(t.currentMonth + j), t.config.showMonths > 1 || t.config.monthSelectorType === "static" ? t.monthElements[j].textContent = Vr(G.getMonth(), t.config.shorthandCurrentMonth, t.l10n) + " " : t.monthsDropdownContainer.value = G.getMonth().toString(), N.value = G.getFullYear().toString();
    }), t._hidePrevMonthArrow = t.config.minDate !== void 0 && (t.currentYear === t.config.minDate.getFullYear() ? t.currentMonth <= t.config.minDate.getMonth() : t.currentYear < t.config.minDate.getFullYear()), t._hideNextMonthArrow = t.config.maxDate !== void 0 && (t.currentYear === t.config.maxDate.getFullYear() ? t.currentMonth + 1 > t.config.maxDate.getMonth() : t.currentYear > t.config.maxDate.getFullYear()));
  }
  function Na(N) {
    var j = N || (t.config.altInput ? t.config.altFormat : t.config.dateFormat);
    return t.selectedDates.map(function(G) {
      return t.formatDate(G, j);
    }).filter(function(G, ae, ge) {
      return t.config.mode !== "range" || t.config.enableTime || ge.indexOf(G) === ae;
    }).join(t.config.mode !== "range" ? t.config.conjunction : t.l10n.rangeSeparator);
  }
  function $n(N) {
    N === void 0 && (N = !0), t.mobileInput !== void 0 && t.mobileFormatStr && (t.mobileInput.value = t.latestSelectedDateObj !== void 0 ? t.formatDate(t.latestSelectedDateObj, t.mobileFormatStr) : ""), t.input.value = Na(t.config.dateFormat), t.altInput !== void 0 && (t.altInput.value = Na(t.config.altFormat)), N !== !1 && ut("onValueUpdate");
  }
  function Gh(N) {
    var j = qt(N), G = t.prevMonthNav.contains(j), ae = t.nextMonthNav.contains(j);
    G || ae ? D(G ? -1 : 1) : t.yearElements.indexOf(j) >= 0 ? j.select() : j.classList.contains("arrowUp") ? t.changeYear(t.currentYear + 1) : j.classList.contains("arrowDown") && t.changeYear(t.currentYear - 1);
  }
  function Zh(N) {
    N.preventDefault();
    var j = N.type === "keydown", G = qt(N), ae = G;
    t.amPM !== void 0 && G === t.amPM && (t.amPM.textContent = t.l10n.amPM[Xt(t.amPM.textContent === t.l10n.amPM[0])]);
    var ge = parseFloat(ae.getAttribute("min")), xe = parseFloat(ae.getAttribute("max")), Pe = parseFloat(ae.getAttribute("step")), _e = parseInt(ae.value, 10), Be = N.delta || (j ? N.which === 38 ? 1 : -1 : 0), $e = _e + Pe * Be;
    if (typeof ae.value < "u" && ae.value.length === 2) {
      var Se = ae === t.hourElement, rt = ae === t.minuteElement;
      $e < ge ? ($e = xe + $e + Xt(!Se) + (Xt(Se) && Xt(!t.amPM)), rt && b(void 0, -1, t.hourElement)) : $e > xe && ($e = ae === t.hourElement ? $e - xe - Xt(!t.amPM) : ge, rt && b(void 0, 1, t.hourElement)), t.amPM && Se && (Pe === 1 ? $e + _e === 23 : Math.abs($e - _e) > Pe) && (t.amPM.textContent = t.l10n.amPM[Xt(t.amPM.textContent === t.l10n.amPM[0])]), ae.value = Vt($e);
    }
  }
  return i(), t;
}
function jo(e, n) {
  for (var t = Array.prototype.slice.call(e).filter(function(a) {
    return a instanceof HTMLElement;
  }), o = [], i = 0; i < t.length; i++) {
    var r = t[i];
    try {
      if (r.getAttribute("data-fp-omit") !== null)
        continue;
      r._flatpickr !== void 0 && (r._flatpickr.destroy(), r._flatpickr = void 0), r._flatpickr = W5(r, n || {}), o.push(r._flatpickr);
    } catch (a) {
      console.error(a);
    }
  }
  return o.length === 1 ? o[0] : o;
}
typeof HTMLElement < "u" && typeof HTMLCollection < "u" && typeof NodeList < "u" && (HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function(e) {
  return jo(this, e);
}, HTMLElement.prototype.flatpickr = function(e) {
  return jo([this], e);
});
var ft = function(e, n) {
  return typeof e == "string" ? jo(window.document.querySelectorAll(e), n) : e instanceof Node ? jo([e], n) : jo(e, n);
};
ft.defaultConfig = {};
ft.l10ns = {
  en: At({}, Mi),
  default: At({}, Mi)
};
ft.localize = function(e) {
  ft.l10ns.default = At(At({}, ft.l10ns.default), e);
};
ft.setDefaults = function(e) {
  ft.defaultConfig = At(At({}, ft.defaultConfig), e);
};
ft.parseDate = El({});
ft.formatDate = T1({});
ft.compareDates = Ut;
typeof jQuery < "u" && typeof jQuery.fn < "u" && (jQuery.fn.flatpickr = function(e) {
  return jo(this, e);
});
Date.prototype.fp_incr = function(e) {
  return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof e == "string" ? parseInt(e, 10) : e));
};
typeof window < "u" && (window.flatpickr = ft);
var P1 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function K5(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ml = { exports: {} };
(function(e, n) {
  (function(t, o) {
    o(n);
  })(P1, function(t) {
    var o = typeof window < "u" && window.flatpickr !== void 0 ? window.flatpickr : {
      l10ns: {}
    }, i = {
      firstDayOfWeek: 1,
      weekdays: {
        shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
        longhand: [
          "dimanche",
          "lundi",
          "mardi",
          "mercredi",
          "jeudi",
          "vendredi",
          "samedi"
        ]
      },
      months: {
        shorthand: [
          "janv",
          "févr",
          "mars",
          "avr",
          "mai",
          "juin",
          "juil",
          "août",
          "sept",
          "oct",
          "nov",
          "déc"
        ],
        longhand: [
          "janvier",
          "février",
          "mars",
          "avril",
          "mai",
          "juin",
          "juillet",
          "août",
          "septembre",
          "octobre",
          "novembre",
          "décembre"
        ]
      },
      ordinal: function(a) {
        return a > 1 ? "" : "er";
      },
      rangeSeparator: " au ",
      weekAbbreviation: "Sem",
      scrollTitle: "Défiler pour augmenter la valeur",
      toggleTitle: "Cliquer pour basculer",
      time_24hr: !0
    };
    o.l10ns.fr = i;
    var r = o.l10ns;
    t.French = i, t.default = r, Object.defineProperty(t, "__esModule", { value: !0 });
  });
})(Ml, Ml.exports);
var Y5 = Ml.exports;
const I1 = [
  "onChange",
  "onClose",
  "onDestroy",
  "onMonthChange",
  "onOpen",
  "onYearChange"
], G5 = [
  "onValueUpdate",
  "onDayCreate",
  "onParseConfig",
  "onReady",
  "onPreCalendarPosition",
  "onKeyDown"
];
function Nu(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function Fu(e) {
  return e instanceof Array ? e : [e];
}
function za(e) {
  return e && e.length ? e : null;
}
const Ru = [...I1, ...G5], Z5 = ["locale", "showMonths"], X5 = re({
  name: "FlatPickr",
  compatConfig: {
    MODE: 3
  },
  render() {
    return wt("input", {
      type: "text",
      "data-input": !0,
      disabled: this.disabled,
      onInput: this.onInput
    });
  },
  emits: [
    "blur",
    "update:modelValue",
    ...Ru.map(Nu)
  ],
  props: {
    modelValue: {
      type: [String, Number, Date, Array, null],
      required: !0
    },
    // https://flatpickr.js.org/options/
    config: {
      type: Object,
      default: () => ({
        defaultDate: null,
        wrap: !1
      })
    },
    events: {
      type: Array,
      default: () => I1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      fp: null
      //todo make it non-reactive
    };
  },
  mounted() {
    this.fp || (this.fp = ft(this.getElem(), this.prepareConfig()), this.fpInput().addEventListener("blur", this.onBlur), this.$watch("disabled", this.watchDisabled, {
      immediate: !0
    }));
  },
  methods: {
    prepareConfig() {
      let e = Object.assign({}, this.config);
      this.events.forEach((t) => {
        let o = ft.defaultConfig[t] || [], i = (...r) => {
          this.$emit(Nu(t), ...r);
        };
        e[t] = Fu(e[t] || []).concat(o, i);
      });
      const n = this.onClose.bind(this);
      return e.onClose = Fu(e.onClose || []).concat(n), e.defaultDate = this.modelValue || e.defaultDate, e;
    },
    /**
     * Get the HTML node where flatpickr to be attached
     * Bind on parent element if wrap is true
     */
    getElem() {
      return this.config.wrap ? this.$el.parentNode : this.$el;
    },
    /**
     * Watch for value changed by date-picker itself and notify parent component
     */
    onInput(e) {
      const n = e.target;
      He().then(() => {
        this.$emit("update:modelValue", za(n.value));
      });
    },
    fpInput() {
      return this.fp.altInput || this.fp.input;
    },
    /**
     * Blur event is required by many validation libraries
     */
    onBlur(e) {
      this.$emit("blur", za(e.target.value));
    },
    /**
     * Flatpickr does not emit input event in some cases
     */
    onClose(e, n) {
      this.$emit("update:modelValue", n);
    },
    /**
     * Watch for the disabled property and sets the value to the real input.
     */
    watchDisabled(e) {
      e ? this.fpInput().setAttribute("disabled", "") : this.fpInput().removeAttribute("disabled");
    }
  },
  watch: {
    /**
     * Watch for any config changes and redraw date-picker
     */
    config: {
      deep: !0,
      handler(e) {
        if (!this.fp)
          return;
        let n = Object.assign({}, e);
        Ru.forEach((t) => {
          delete n[t];
        }), this.fp.set(n), Z5.forEach((t) => {
          typeof n[t] < "u" && this.fp.set(t, n[t]);
        });
      }
    },
    /**
     * Watch for changes from parent component and update DOM
     */
    modelValue(e) {
      var n;
      !this.$el || e === za(this.$el.value) || (n = this.fp) === null || n === void 0 || n.setDate(e, !0);
    }
  },
  beforeUnmount() {
    this.fp && (this.fpInput().removeEventListener("blur", this.onBlur), this.fp.destroy(), this.fp = null);
  }
});
const J5 = { class: "w-full" }, Q5 = {
  key: 0,
  class: "mb-1.5"
}, e9 = {
  key: 0,
  class: "flex items-start"
}, t9 = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, n9 = { class: "relative w-full" }, MA = /* @__PURE__ */ re({
  __name: "FieldDatePicker",
  props: {
    modelValue: {
      type: [Date, String],
      default: null
    },
    locale: {
      type: String,
      default: "en"
    },
    id: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    minDateToday: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e;
    ft.setDefaults({
      disableMobile: !0,
      locale: Y5.French,
      altFormat: t.locale === "fr" ? "j F, Y" : "F j, Y",
      altInput: !0,
      dateFormat: "Z",
      onChange: (r) => {
        const a = r[0].getFullYear(), l = r[0].getMonth() + 1, s = r[0].getDate(), u = `${a}-${l < 10 ? `0${l}` : l}-${s < 10 ? `0${s}` : s}T01:00:00.000Z`;
        i("update:modelValue", u);
      }
    });
    const o = X(t.modelValue || null), i = n;
    return (r, a) => {
      var l, s, u, d;
      return _(), P("div", J5, [
        e.label || e.description ? (_(), P("div", Q5, [
          e.label ? (_(), P("div", e9, [
            ce(Re, {
              for: e.id,
              label: e.label
            }, null, 8, ["for", "label"]),
            e.required ? (_(), P("span", t9, " * ")) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("div", n9, [
          ce(Le, {
            class: "absolute bottom-0 left-2.5 top-0",
            icon: "calendar",
            color: "#5F6C85"
          }),
          ce(I(X5), {
            id: `${e.id}`,
            modelValue: o.value,
            "onUpdate:modelValue": a[0] || (a[0] = (f) => o.value = f),
            config: {
              minDate: e.minDateToday ? "today" : void 0
            },
            class: pe([
              "box-border block w-full rounded-[4.16px] py-2.5 pl-9 pr-3 text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle placeholder:text-foreground-subtle",
              (s = (l = e.validation) == null ? void 0 : l.$errors) != null && s.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:ring-border-brand-emphasis"
            ]),
            placeholder: e.placeholder,
            disabled: e.disabled
          }, null, 8, ["id", "modelValue", "config", "class", "placeholder", "disabled"])
        ]),
        e.validation && ((u = e.validation.$errors) != null && u.length) ? (_(), ie(Re, {
          key: 1,
          class: "mt-[3px]",
          label: (d = e.validation.$errors[0]) == null ? void 0 : d.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ]);
    };
  }
});
var D1 = { exports: {} };
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function(e, n) {
  (function(o, i) {
    e.exports = i();
  })(typeof self < "u" ? self : P1, function() {
    return (
      /******/
      function(t) {
        var o = {};
        function i(r) {
          if (o[r])
            return o[r].exports;
          var a = o[r] = {
            /******/
            i: r,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return t[r].call(a.exports, a, a.exports, i), a.l = !0, a.exports;
        }
        return i.m = t, i.c = o, i.d = function(r, a, l) {
          i.o(r, a) || Object.defineProperty(r, a, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: l
            /******/
          });
        }, i.n = function(r) {
          var a = r && r.__esModule ? (
            /******/
            function() {
              return r.default;
            }
          ) : (
            /******/
            function() {
              return r;
            }
          );
          return i.d(a, "a", a), a;
        }, i.o = function(r, a) {
          return Object.prototype.hasOwnProperty.call(r, a);
        }, i.p = "", i(i.s = 109);
      }([
        /* 0 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var r = i(17), a = i(18), l = i(19), s = i(45), u = i(46), d = i(47), f = i(48), c = i(49), h = i(12), m = i(32), g = i(33), v = i(31), p = i(1), y = {
            Scope: p.Scope,
            create: p.create,
            find: p.find,
            query: p.query,
            register: p.register,
            Container: r.default,
            Format: a.default,
            Leaf: l.default,
            Embed: f.default,
            Scroll: s.default,
            Block: d.default,
            Inline: u.default,
            Text: c.default,
            Attributor: {
              Attribute: h.default,
              Class: m.default,
              Style: g.default,
              Store: v.default
            }
          };
          o.default = y;
        },
        /* 1 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var v = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, y) {
              p.__proto__ = y;
            } || function(p, y) {
              for (var C in y)
                y.hasOwnProperty(C) && (p[C] = y[C]);
            };
            return function(p, y) {
              v(p, y);
              function C() {
                this.constructor = p;
              }
              p.prototype = y === null ? Object.create(y) : (C.prototype = y.prototype, new C());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = (
            /** @class */
            function(v) {
              r(p, v);
              function p(y) {
                var C = this;
                return y = "[Parchment] " + y, C = v.call(this, y) || this, C.message = y, C.name = C.constructor.name, C;
              }
              return p;
            }(Error)
          );
          o.ParchmentError = a;
          var l = {}, s = {}, u = {}, d = {};
          o.DATA_KEY = "__blot";
          var f;
          (function(v) {
            v[v.TYPE = 3] = "TYPE", v[v.LEVEL = 12] = "LEVEL", v[v.ATTRIBUTE = 13] = "ATTRIBUTE", v[v.BLOT = 14] = "BLOT", v[v.INLINE = 7] = "INLINE", v[v.BLOCK = 11] = "BLOCK", v[v.BLOCK_BLOT = 10] = "BLOCK_BLOT", v[v.INLINE_BLOT = 6] = "INLINE_BLOT", v[v.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", v[v.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", v[v.ANY = 15] = "ANY";
          })(f = o.Scope || (o.Scope = {}));
          function c(v, p) {
            var y = m(v);
            if (y == null)
              throw new a("Unable to create " + v + " blot");
            var C = y, b = (
              // @ts-ignore
              v instanceof Node || v.nodeType === Node.TEXT_NODE ? v : C.create(p)
            );
            return new C(b, p);
          }
          o.create = c;
          function h(v, p) {
            return p === void 0 && (p = !1), v == null ? null : v[o.DATA_KEY] != null ? v[o.DATA_KEY].blot : p ? h(v.parentNode, p) : null;
          }
          o.find = h;
          function m(v, p) {
            p === void 0 && (p = f.ANY);
            var y;
            if (typeof v == "string")
              y = d[v] || l[v];
            else if (v instanceof Text || v.nodeType === Node.TEXT_NODE)
              y = d.text;
            else if (typeof v == "number")
              v & f.LEVEL & f.BLOCK ? y = d.block : v & f.LEVEL & f.INLINE && (y = d.inline);
            else if (v instanceof HTMLElement) {
              var C = (v.getAttribute("class") || "").split(/\s+/);
              for (var b in C)
                if (y = s[C[b]], y)
                  break;
              y = y || u[v.tagName];
            }
            return y == null ? null : p & f.LEVEL & y.scope && p & f.TYPE & y.scope ? y : null;
          }
          o.query = m;
          function g() {
            for (var v = [], p = 0; p < arguments.length; p++)
              v[p] = arguments[p];
            if (v.length > 1)
              return v.map(function(b) {
                return g(b);
              });
            var y = v[0];
            if (typeof y.blotName != "string" && typeof y.attrName != "string")
              throw new a("Invalid definition");
            if (y.blotName === "abstract")
              throw new a("Cannot register abstract class");
            if (d[y.blotName || y.attrName] = y, typeof y.keyName == "string")
              l[y.keyName] = y;
            else if (y.className != null && (s[y.className] = y), y.tagName != null) {
              Array.isArray(y.tagName) ? y.tagName = y.tagName.map(function(b) {
                return b.toUpperCase();
              }) : y.tagName = y.tagName.toUpperCase();
              var C = Array.isArray(y.tagName) ? y.tagName : [y.tagName];
              C.forEach(function(b) {
                (u[b] == null || y.className == null) && (u[b] = y);
              });
            }
            return y;
          }
          o.register = g;
        },
        /* 2 */
        /***/
        function(t, o, i) {
          var r = i(51), a = i(11), l = i(3), s = i(20), u = String.fromCharCode(0), d = function(f) {
            Array.isArray(f) ? this.ops = f : f != null && Array.isArray(f.ops) ? this.ops = f.ops : this.ops = [];
          };
          d.prototype.insert = function(f, c) {
            var h = {};
            return f.length === 0 ? this : (h.insert = f, c != null && typeof c == "object" && Object.keys(c).length > 0 && (h.attributes = c), this.push(h));
          }, d.prototype.delete = function(f) {
            return f <= 0 ? this : this.push({ delete: f });
          }, d.prototype.retain = function(f, c) {
            if (f <= 0)
              return this;
            var h = { retain: f };
            return c != null && typeof c == "object" && Object.keys(c).length > 0 && (h.attributes = c), this.push(h);
          }, d.prototype.push = function(f) {
            var c = this.ops.length, h = this.ops[c - 1];
            if (f = l(!0, {}, f), typeof h == "object") {
              if (typeof f.delete == "number" && typeof h.delete == "number")
                return this.ops[c - 1] = { delete: h.delete + f.delete }, this;
              if (typeof h.delete == "number" && f.insert != null && (c -= 1, h = this.ops[c - 1], typeof h != "object"))
                return this.ops.unshift(f), this;
              if (a(f.attributes, h.attributes)) {
                if (typeof f.insert == "string" && typeof h.insert == "string")
                  return this.ops[c - 1] = { insert: h.insert + f.insert }, typeof f.attributes == "object" && (this.ops[c - 1].attributes = f.attributes), this;
                if (typeof f.retain == "number" && typeof h.retain == "number")
                  return this.ops[c - 1] = { retain: h.retain + f.retain }, typeof f.attributes == "object" && (this.ops[c - 1].attributes = f.attributes), this;
              }
            }
            return c === this.ops.length ? this.ops.push(f) : this.ops.splice(c, 0, f), this;
          }, d.prototype.chop = function() {
            var f = this.ops[this.ops.length - 1];
            return f && f.retain && !f.attributes && this.ops.pop(), this;
          }, d.prototype.filter = function(f) {
            return this.ops.filter(f);
          }, d.prototype.forEach = function(f) {
            this.ops.forEach(f);
          }, d.prototype.map = function(f) {
            return this.ops.map(f);
          }, d.prototype.partition = function(f) {
            var c = [], h = [];
            return this.forEach(function(m) {
              var g = f(m) ? c : h;
              g.push(m);
            }), [c, h];
          }, d.prototype.reduce = function(f, c) {
            return this.ops.reduce(f, c);
          }, d.prototype.changeLength = function() {
            return this.reduce(function(f, c) {
              return c.insert ? f + s.length(c) : c.delete ? f - c.delete : f;
            }, 0);
          }, d.prototype.length = function() {
            return this.reduce(function(f, c) {
              return f + s.length(c);
            }, 0);
          }, d.prototype.slice = function(f, c) {
            f = f || 0, typeof c != "number" && (c = 1 / 0);
            for (var h = [], m = s.iterator(this.ops), g = 0; g < c && m.hasNext(); ) {
              var v;
              g < f ? v = m.next(f - g) : (v = m.next(c - g), h.push(v)), g += s.length(v);
            }
            return new d(h);
          }, d.prototype.compose = function(f) {
            var c = s.iterator(this.ops), h = s.iterator(f.ops), m = [], g = h.peek();
            if (g != null && typeof g.retain == "number" && g.attributes == null) {
              for (var v = g.retain; c.peekType() === "insert" && c.peekLength() <= v; )
                v -= c.peekLength(), m.push(c.next());
              g.retain - v > 0 && h.next(g.retain - v);
            }
            for (var p = new d(m); c.hasNext() || h.hasNext(); )
              if (h.peekType() === "insert")
                p.push(h.next());
              else if (c.peekType() === "delete")
                p.push(c.next());
              else {
                var y = Math.min(c.peekLength(), h.peekLength()), C = c.next(y), b = h.next(y);
                if (typeof b.retain == "number") {
                  var x = {};
                  typeof C.retain == "number" ? x.retain = y : x.insert = C.insert;
                  var w = s.attributes.compose(C.attributes, b.attributes, typeof C.retain == "number");
                  if (w && (x.attributes = w), p.push(x), !h.hasNext() && a(p.ops[p.ops.length - 1], x)) {
                    var $ = new d(c.rest());
                    return p.concat($).chop();
                  }
                } else
                  typeof b.delete == "number" && typeof C.retain == "number" && p.push(b);
              }
            return p.chop();
          }, d.prototype.concat = function(f) {
            var c = new d(this.ops.slice());
            return f.ops.length > 0 && (c.push(f.ops[0]), c.ops = c.ops.concat(f.ops.slice(1))), c;
          }, d.prototype.diff = function(f, c) {
            if (this.ops === f.ops)
              return new d();
            var h = [this, f].map(function(y) {
              return y.map(function(C) {
                if (C.insert != null)
                  return typeof C.insert == "string" ? C.insert : u;
                var b = y === f ? "on" : "with";
                throw new Error("diff() called " + b + " non-document");
              }).join("");
            }), m = new d(), g = r(h[0], h[1], c), v = s.iterator(this.ops), p = s.iterator(f.ops);
            return g.forEach(function(y) {
              for (var C = y[1].length; C > 0; ) {
                var b = 0;
                switch (y[0]) {
                  case r.INSERT:
                    b = Math.min(p.peekLength(), C), m.push(p.next(b));
                    break;
                  case r.DELETE:
                    b = Math.min(C, v.peekLength()), v.next(b), m.delete(b);
                    break;
                  case r.EQUAL:
                    b = Math.min(v.peekLength(), p.peekLength(), C);
                    var x = v.next(b), w = p.next(b);
                    a(x.insert, w.insert) ? m.retain(b, s.attributes.diff(x.attributes, w.attributes)) : m.push(w).delete(b);
                    break;
                }
                C -= b;
              }
            }), m.chop();
          }, d.prototype.eachLine = function(f, c) {
            c = c || `
`;
            for (var h = s.iterator(this.ops), m = new d(), g = 0; h.hasNext(); ) {
              if (h.peekType() !== "insert")
                return;
              var v = h.peek(), p = s.length(v) - h.peekLength(), y = typeof v.insert == "string" ? v.insert.indexOf(c, p) - p : -1;
              if (y < 0)
                m.push(h.next());
              else if (y > 0)
                m.push(h.next(y));
              else {
                if (f(m, h.next(1).attributes || {}, g) === !1)
                  return;
                g += 1, m = new d();
              }
            }
            m.length() > 0 && f(m, {}, g);
          }, d.prototype.transform = function(f, c) {
            if (c = !!c, typeof f == "number")
              return this.transformPosition(f, c);
            for (var h = s.iterator(this.ops), m = s.iterator(f.ops), g = new d(); h.hasNext() || m.hasNext(); )
              if (h.peekType() === "insert" && (c || m.peekType() !== "insert"))
                g.retain(s.length(h.next()));
              else if (m.peekType() === "insert")
                g.push(m.next());
              else {
                var v = Math.min(h.peekLength(), m.peekLength()), p = h.next(v), y = m.next(v);
                if (p.delete)
                  continue;
                y.delete ? g.push(y) : g.retain(v, s.attributes.transform(p.attributes, y.attributes, c));
              }
            return g.chop();
          }, d.prototype.transformPosition = function(f, c) {
            c = !!c;
            for (var h = s.iterator(this.ops), m = 0; h.hasNext() && m <= f; ) {
              var g = h.peekLength(), v = h.peekType();
              if (h.next(), v === "delete") {
                f -= Math.min(g, f - m);
                continue;
              } else
                v === "insert" && (m < f || !c) && (f += g);
              m += g;
            }
            return f;
          }, t.exports = d;
        },
        /* 3 */
        /***/
        function(t, o) {
          var i = Object.prototype.hasOwnProperty, r = Object.prototype.toString, a = Object.defineProperty, l = Object.getOwnPropertyDescriptor, s = function(h) {
            return typeof Array.isArray == "function" ? Array.isArray(h) : r.call(h) === "[object Array]";
          }, u = function(h) {
            if (!h || r.call(h) !== "[object Object]")
              return !1;
            var m = i.call(h, "constructor"), g = h.constructor && h.constructor.prototype && i.call(h.constructor.prototype, "isPrototypeOf");
            if (h.constructor && !m && !g)
              return !1;
            var v;
            for (v in h)
              ;
            return typeof v > "u" || i.call(h, v);
          }, d = function(h, m) {
            a && m.name === "__proto__" ? a(h, m.name, {
              enumerable: !0,
              configurable: !0,
              value: m.newValue,
              writable: !0
            }) : h[m.name] = m.newValue;
          }, f = function(h, m) {
            if (m === "__proto__")
              if (i.call(h, m)) {
                if (l)
                  return l(h, m).value;
              } else
                return;
            return h[m];
          };
          t.exports = function c() {
            var h, m, g, v, p, y, C = arguments[0], b = 1, x = arguments.length, w = !1;
            for (typeof C == "boolean" && (w = C, C = arguments[1] || {}, b = 2), (C == null || typeof C != "object" && typeof C != "function") && (C = {}); b < x; ++b)
              if (h = arguments[b], h != null)
                for (m in h)
                  g = f(C, m), v = f(h, m), C !== v && (w && v && (u(v) || (p = s(v))) ? (p ? (p = !1, y = g && s(g) ? g : []) : y = g && u(g) ? g : {}, d(C, { name: m, newValue: c(w, y, v) })) : typeof v < "u" && d(C, { name: m, newValue: v }));
            return C;
          };
        },
        /* 4 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.BlockEmbed = o.bubbleFormats = void 0;
          var r = function() {
            function k(S, T) {
              for (var L = 0; L < T.length; L++) {
                var F = T[L];
                F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(S, F.key, F);
              }
            }
            return function(S, T, L) {
              return T && k(S.prototype, T), L && k(S, L), S;
            };
          }(), a = function k(S, T, L) {
            S === null && (S = Function.prototype);
            var F = Object.getOwnPropertyDescriptor(S, T);
            if (F === void 0) {
              var U = Object.getPrototypeOf(S);
              return U === null ? void 0 : k(U, T, L);
            } else {
              if ("value" in F)
                return F.value;
              var W = F.get;
              return W === void 0 ? void 0 : W.call(L);
            }
          }, l = i(3), s = C(l), u = i(2), d = C(u), f = i(0), c = C(f), h = i(16), m = C(h), g = i(6), v = C(g), p = i(7), y = C(p);
          function C(k) {
            return k && k.__esModule ? k : { default: k };
          }
          function b(k, S) {
            if (!(k instanceof S))
              throw new TypeError("Cannot call a class as a function");
          }
          function x(k, S) {
            if (!k)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return S && (typeof S == "object" || typeof S == "function") ? S : k;
          }
          function w(k, S) {
            if (typeof S != "function" && S !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof S);
            k.prototype = Object.create(S && S.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(k, S) : k.__proto__ = S);
          }
          var $ = 1, E = function(k) {
            w(S, k);
            function S() {
              return b(this, S), x(this, (S.__proto__ || Object.getPrototypeOf(S)).apply(this, arguments));
            }
            return r(S, [{
              key: "attach",
              value: function() {
                a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "attach", this).call(this), this.attributes = new c.default.Attributor.Store(this.domNode);
              }
            }, {
              key: "delta",
              value: function() {
                return new d.default().insert(this.value(), (0, s.default)(this.formats(), this.attributes.values()));
              }
            }, {
              key: "format",
              value: function(L, F) {
                var U = c.default.query(L, c.default.Scope.BLOCK_ATTRIBUTE);
                U != null && this.attributes.attribute(U, F);
              }
            }, {
              key: "formatAt",
              value: function(L, F, U, W) {
                this.format(U, W);
              }
            }, {
              key: "insertAt",
              value: function(L, F, U) {
                if (typeof F == "string" && F.endsWith(`
`)) {
                  var W = c.default.create(A.blotName);
                  this.parent.insertBefore(W, L === 0 ? this : this.next), W.insertAt(0, F.slice(0, -1));
                } else
                  a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "insertAt", this).call(this, L, F, U);
              }
            }]), S;
          }(c.default.Embed);
          E.scope = c.default.Scope.BLOCK_BLOT;
          var A = function(k) {
            w(S, k);
            function S(T) {
              b(this, S);
              var L = x(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this, T));
              return L.cache = {}, L;
            }
            return r(S, [{
              key: "delta",
              value: function() {
                return this.cache.delta == null && (this.cache.delta = this.descendants(c.default.Leaf).reduce(function(L, F) {
                  return F.length() === 0 ? L : L.insert(F.value(), O(F));
                }, new d.default()).insert(`
`, O(this))), this.cache.delta;
              }
            }, {
              key: "deleteAt",
              value: function(L, F) {
                a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "deleteAt", this).call(this, L, F), this.cache = {};
              }
            }, {
              key: "formatAt",
              value: function(L, F, U, W) {
                F <= 0 || (c.default.query(U, c.default.Scope.BLOCK) ? L + F === this.length() && this.format(U, W) : a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "formatAt", this).call(this, L, Math.min(F, this.length() - L - 1), U, W), this.cache = {});
              }
            }, {
              key: "insertAt",
              value: function(L, F, U) {
                if (U != null)
                  return a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "insertAt", this).call(this, L, F, U);
                if (F.length !== 0) {
                  var W = F.split(`
`), oe = W.shift();
                  oe.length > 0 && (L < this.length() - 1 || this.children.tail == null ? a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "insertAt", this).call(this, Math.min(L, this.length() - 1), oe) : this.children.tail.insertAt(this.children.tail.length(), oe), this.cache = {});
                  var H = this;
                  W.reduce(function(B, D) {
                    return H = H.split(B, !0), H.insertAt(0, D), D.length;
                  }, L + oe.length);
                }
              }
            }, {
              key: "insertBefore",
              value: function(L, F) {
                var U = this.children.head;
                a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "insertBefore", this).call(this, L, F), U instanceof m.default && U.remove(), this.cache = {};
              }
            }, {
              key: "length",
              value: function() {
                return this.cache.length == null && (this.cache.length = a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "length", this).call(this) + $), this.cache.length;
              }
            }, {
              key: "moveChildren",
              value: function(L, F) {
                a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "moveChildren", this).call(this, L, F), this.cache = {};
              }
            }, {
              key: "optimize",
              value: function(L) {
                a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "optimize", this).call(this, L), this.cache = {};
              }
            }, {
              key: "path",
              value: function(L) {
                return a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "path", this).call(this, L, !0);
              }
            }, {
              key: "removeChild",
              value: function(L) {
                a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "removeChild", this).call(this, L), this.cache = {};
              }
            }, {
              key: "split",
              value: function(L) {
                var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (F && (L === 0 || L >= this.length() - $)) {
                  var U = this.clone();
                  return L === 0 ? (this.parent.insertBefore(U, this), this) : (this.parent.insertBefore(U, this.next), U);
                } else {
                  var W = a(S.prototype.__proto__ || Object.getPrototypeOf(S.prototype), "split", this).call(this, L, F);
                  return this.cache = {}, W;
                }
              }
            }]), S;
          }(c.default.Block);
          A.blotName = "block", A.tagName = "P", A.defaultChild = "break", A.allowedChildren = [v.default, c.default.Embed, y.default];
          function O(k) {
            var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return k == null || (typeof k.formats == "function" && (S = (0, s.default)(S, k.formats())), k.parent == null || k.parent.blotName == "scroll" || k.parent.statics.scope !== k.statics.scope) ? S : O(k.parent, S);
          }
          o.bubbleFormats = O, o.BlockEmbed = E, o.default = A;
        },
        /* 5 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.overload = o.expandConfig = void 0;
          var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
            return typeof H;
          } : function(H) {
            return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
          }, a = function() {
            function H(B, D) {
              var V = [], q = !0, Z = !1, Y = void 0;
              try {
                for (var R = B[Symbol.iterator](), K; !(q = (K = R.next()).done) && (V.push(K.value), !(D && V.length === D)); q = !0)
                  ;
              } catch (te) {
                Z = !0, Y = te;
              } finally {
                try {
                  !q && R.return && R.return();
                } finally {
                  if (Z)
                    throw Y;
                }
              }
              return V;
            }
            return function(B, D) {
              if (Array.isArray(B))
                return B;
              if (Symbol.iterator in Object(B))
                return H(B, D);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), l = function() {
            function H(B, D) {
              for (var V = 0; V < D.length; V++) {
                var q = D[V];
                q.enumerable = q.enumerable || !1, q.configurable = !0, "value" in q && (q.writable = !0), Object.defineProperty(B, q.key, q);
              }
            }
            return function(B, D, V) {
              return D && H(B.prototype, D), V && H(B, V), B;
            };
          }();
          i(50);
          var s = i(2), u = O(s), d = i(14), f = O(d), c = i(8), h = O(c), m = i(9), g = O(m), v = i(0), p = O(v), y = i(15), C = O(y), b = i(3), x = O(b), w = i(10), $ = O(w), E = i(34), A = O(E);
          function O(H) {
            return H && H.__esModule ? H : { default: H };
          }
          function k(H, B, D) {
            return B in H ? Object.defineProperty(H, B, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : H[B] = D, H;
          }
          function S(H, B) {
            if (!(H instanceof B))
              throw new TypeError("Cannot call a class as a function");
          }
          var T = (0, $.default)("quill"), L = function() {
            l(H, null, [{
              key: "debug",
              value: function(D) {
                D === !0 && (D = "log"), $.default.level(D);
              }
            }, {
              key: "find",
              value: function(D) {
                return D.__quill || p.default.find(D);
              }
            }, {
              key: "import",
              value: function(D) {
                return this.imports[D] == null && T.error("Cannot import " + D + ". Are you sure it was registered?"), this.imports[D];
              }
            }, {
              key: "register",
              value: function(D, V) {
                var q = this, Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                if (typeof D != "string") {
                  var Y = D.attrName || D.blotName;
                  typeof Y == "string" ? this.register("formats/" + Y, D, V) : Object.keys(D).forEach(function(R) {
                    q.register(R, D[R], V);
                  });
                } else
                  this.imports[D] != null && !Z && T.warn("Overwriting " + D + " with", V), this.imports[D] = V, (D.startsWith("blots/") || D.startsWith("formats/")) && V.blotName !== "abstract" ? p.default.register(V) : D.startsWith("modules") && typeof V.register == "function" && V.register();
              }
            }]);
            function H(B) {
              var D = this, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              if (S(this, H), this.options = F(B, V), this.container = this.options.container, this.container == null)
                return T.error("Invalid Quill container", B);
              this.options.debug && H.debug(this.options.debug);
              var q = this.container.innerHTML.trim();
              this.container.classList.add("ql-container"), this.container.innerHTML = "", this.container.__quill = this, this.root = this.addContainer("ql-editor"), this.root.classList.add("ql-blank"), this.root.setAttribute("data-gramm", !1), this.scrollingContainer = this.options.scrollingContainer || this.root, this.emitter = new h.default(), this.scroll = p.default.create(this.root, {
                emitter: this.emitter,
                whitelist: this.options.formats
              }), this.editor = new f.default(this.scroll), this.selection = new C.default(this.scroll, this.emitter), this.theme = new this.options.theme(this, this.options), this.keyboard = this.theme.addModule("keyboard"), this.clipboard = this.theme.addModule("clipboard"), this.history = this.theme.addModule("history"), this.theme.init(), this.emitter.on(h.default.events.EDITOR_CHANGE, function(Y) {
                Y === h.default.events.TEXT_CHANGE && D.root.classList.toggle("ql-blank", D.editor.isBlank());
              }), this.emitter.on(h.default.events.SCROLL_UPDATE, function(Y, R) {
                var K = D.selection.lastRange, te = K && K.length === 0 ? K.index : void 0;
                U.call(D, function() {
                  return D.editor.update(null, R, te);
                }, Y);
              });
              var Z = this.clipboard.convert(`<div class='ql-editor' style="white-space: normal;">` + q + "<p><br></p></div>");
              this.setContents(Z), this.history.clear(), this.options.placeholder && this.root.setAttribute("data-placeholder", this.options.placeholder), this.options.readOnly && this.disable();
            }
            return l(H, [{
              key: "addContainer",
              value: function(D) {
                var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (typeof D == "string") {
                  var q = D;
                  D = document.createElement("div"), D.classList.add(q);
                }
                return this.container.insertBefore(D, V), D;
              }
            }, {
              key: "blur",
              value: function() {
                this.selection.setRange(null);
              }
            }, {
              key: "deleteText",
              value: function(D, V, q) {
                var Z = this, Y = W(D, V, q), R = a(Y, 4);
                return D = R[0], V = R[1], q = R[3], U.call(this, function() {
                  return Z.editor.deleteText(D, V);
                }, q, D, -1 * V);
              }
            }, {
              key: "disable",
              value: function() {
                this.enable(!1);
              }
            }, {
              key: "enable",
              value: function() {
                var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                this.scroll.enable(D), this.container.classList.toggle("ql-disabled", !D);
              }
            }, {
              key: "focus",
              value: function() {
                var D = this.scrollingContainer.scrollTop;
                this.selection.focus(), this.scrollingContainer.scrollTop = D, this.scrollIntoView();
              }
            }, {
              key: "format",
              value: function(D, V) {
                var q = this, Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : h.default.sources.API;
                return U.call(this, function() {
                  var Y = q.getSelection(!0), R = new u.default();
                  if (Y == null)
                    return R;
                  if (p.default.query(D, p.default.Scope.BLOCK))
                    R = q.editor.formatLine(Y.index, Y.length, k({}, D, V));
                  else {
                    if (Y.length === 0)
                      return q.selection.format(D, V), R;
                    R = q.editor.formatText(Y.index, Y.length, k({}, D, V));
                  }
                  return q.setSelection(Y, h.default.sources.SILENT), R;
                }, Z);
              }
            }, {
              key: "formatLine",
              value: function(D, V, q, Z, Y) {
                var R = this, K = void 0, te = W(D, V, q, Z, Y), ne = a(te, 4);
                return D = ne[0], V = ne[1], K = ne[2], Y = ne[3], U.call(this, function() {
                  return R.editor.formatLine(D, V, K);
                }, Y, D, 0);
              }
            }, {
              key: "formatText",
              value: function(D, V, q, Z, Y) {
                var R = this, K = void 0, te = W(D, V, q, Z, Y), ne = a(te, 4);
                return D = ne[0], V = ne[1], K = ne[2], Y = ne[3], U.call(this, function() {
                  return R.editor.formatText(D, V, K);
                }, Y, D, 0);
              }
            }, {
              key: "getBounds",
              value: function(D) {
                var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, q = void 0;
                typeof D == "number" ? q = this.selection.getBounds(D, V) : q = this.selection.getBounds(D.index, D.length);
                var Z = this.container.getBoundingClientRect();
                return {
                  bottom: q.bottom - Z.top,
                  height: q.height,
                  left: q.left - Z.left,
                  right: q.right - Z.left,
                  top: q.top - Z.top,
                  width: q.width
                };
              }
            }, {
              key: "getContents",
              value: function() {
                var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - D, q = W(D, V), Z = a(q, 2);
                return D = Z[0], V = Z[1], this.editor.getContents(D, V);
              }
            }, {
              key: "getFormat",
              value: function() {
                var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(!0), V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return typeof D == "number" ? this.editor.getFormat(D, V) : this.editor.getFormat(D.index, D.length);
              }
            }, {
              key: "getIndex",
              value: function(D) {
                return D.offset(this.scroll);
              }
            }, {
              key: "getLength",
              value: function() {
                return this.scroll.length();
              }
            }, {
              key: "getLeaf",
              value: function(D) {
                return this.scroll.leaf(D);
              }
            }, {
              key: "getLine",
              value: function(D) {
                return this.scroll.line(D);
              }
            }, {
              key: "getLines",
              value: function() {
                var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
                return typeof D != "number" ? this.scroll.lines(D.index, D.length) : this.scroll.lines(D, V);
              }
            }, {
              key: "getModule",
              value: function(D) {
                return this.theme.modules[D];
              }
            }, {
              key: "getSelection",
              value: function() {
                var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                return D && this.focus(), this.update(), this.selection.getRange()[0];
              }
            }, {
              key: "getText",
              value: function() {
                var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - D, q = W(D, V), Z = a(q, 2);
                return D = Z[0], V = Z[1], this.editor.getText(D, V);
              }
            }, {
              key: "hasFocus",
              value: function() {
                return this.selection.hasFocus();
              }
            }, {
              key: "insertEmbed",
              value: function(D, V, q) {
                var Z = this, Y = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : H.sources.API;
                return U.call(this, function() {
                  return Z.editor.insertEmbed(D, V, q);
                }, Y, D);
              }
            }, {
              key: "insertText",
              value: function(D, V, q, Z, Y) {
                var R = this, K = void 0, te = W(D, 0, q, Z, Y), ne = a(te, 4);
                return D = ne[0], K = ne[2], Y = ne[3], U.call(this, function() {
                  return R.editor.insertText(D, V, K);
                }, Y, D, V.length);
              }
            }, {
              key: "isEnabled",
              value: function() {
                return !this.container.classList.contains("ql-disabled");
              }
            }, {
              key: "off",
              value: function() {
                return this.emitter.off.apply(this.emitter, arguments);
              }
            }, {
              key: "on",
              value: function() {
                return this.emitter.on.apply(this.emitter, arguments);
              }
            }, {
              key: "once",
              value: function() {
                return this.emitter.once.apply(this.emitter, arguments);
              }
            }, {
              key: "pasteHTML",
              value: function(D, V, q) {
                this.clipboard.dangerouslyPasteHTML(D, V, q);
              }
            }, {
              key: "removeFormat",
              value: function(D, V, q) {
                var Z = this, Y = W(D, V, q), R = a(Y, 4);
                return D = R[0], V = R[1], q = R[3], U.call(this, function() {
                  return Z.editor.removeFormat(D, V);
                }, q, D);
              }
            }, {
              key: "scrollIntoView",
              value: function() {
                this.selection.scrollIntoView(this.scrollingContainer);
              }
            }, {
              key: "setContents",
              value: function(D) {
                var V = this, q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.default.sources.API;
                return U.call(this, function() {
                  D = new u.default(D);
                  var Z = V.getLength(), Y = V.editor.deleteText(0, Z), R = V.editor.applyDelta(D), K = R.ops[R.ops.length - 1];
                  K != null && typeof K.insert == "string" && K.insert[K.insert.length - 1] === `
` && (V.editor.deleteText(V.getLength() - 1, 1), R.delete(1));
                  var te = Y.compose(R);
                  return te;
                }, q);
              }
            }, {
              key: "setSelection",
              value: function(D, V, q) {
                if (D == null)
                  this.selection.setRange(null, V || H.sources.API);
                else {
                  var Z = W(D, V, q), Y = a(Z, 4);
                  D = Y[0], V = Y[1], q = Y[3], this.selection.setRange(new y.Range(D, V), q), q !== h.default.sources.SILENT && this.selection.scrollIntoView(this.scrollingContainer);
                }
              }
            }, {
              key: "setText",
              value: function(D) {
                var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.default.sources.API, q = new u.default().insert(D);
                return this.setContents(q, V);
              }
            }, {
              key: "update",
              value: function() {
                var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : h.default.sources.USER, V = this.scroll.update(D);
                return this.selection.update(D), V;
              }
            }, {
              key: "updateContents",
              value: function(D) {
                var V = this, q = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : h.default.sources.API;
                return U.call(this, function() {
                  return D = new u.default(D), V.editor.applyDelta(D, q);
                }, q, !0);
              }
            }]), H;
          }();
          L.DEFAULTS = {
            bounds: null,
            formats: null,
            modules: {},
            placeholder: "",
            readOnly: !1,
            scrollingContainer: null,
            strict: !0,
            theme: "default"
          }, L.events = h.default.events, L.sources = h.default.sources, L.version = "1.3.7", L.imports = {
            delta: u.default,
            parchment: p.default,
            "core/module": g.default,
            "core/theme": A.default
          };
          function F(H, B) {
            if (B = (0, x.default)(!0, {
              container: H,
              modules: {
                clipboard: !0,
                keyboard: !0,
                history: !0
              }
            }, B), !B.theme || B.theme === L.DEFAULTS.theme)
              B.theme = A.default;
            else if (B.theme = L.import("themes/" + B.theme), B.theme == null)
              throw new Error("Invalid theme " + B.theme + ". Did you register it?");
            var D = (0, x.default)(!0, {}, B.theme.DEFAULTS);
            [D, B].forEach(function(Z) {
              Z.modules = Z.modules || {}, Object.keys(Z.modules).forEach(function(Y) {
                Z.modules[Y] === !0 && (Z.modules[Y] = {});
              });
            });
            var V = Object.keys(D.modules).concat(Object.keys(B.modules)), q = V.reduce(function(Z, Y) {
              var R = L.import("modules/" + Y);
              return R == null ? T.error("Cannot load " + Y + " module. Are you sure you registered it?") : Z[Y] = R.DEFAULTS || {}, Z;
            }, {});
            return B.modules != null && B.modules.toolbar && B.modules.toolbar.constructor !== Object && (B.modules.toolbar = {
              container: B.modules.toolbar
            }), B = (0, x.default)(!0, {}, L.DEFAULTS, { modules: q }, D, B), ["bounds", "container", "scrollingContainer"].forEach(function(Z) {
              typeof B[Z] == "string" && (B[Z] = document.querySelector(B[Z]));
            }), B.modules = Object.keys(B.modules).reduce(function(Z, Y) {
              return B.modules[Y] && (Z[Y] = B.modules[Y]), Z;
            }, {}), B;
          }
          function U(H, B, D, V) {
            if (this.options.strict && !this.isEnabled() && B === h.default.sources.USER)
              return new u.default();
            var q = D == null ? null : this.getSelection(), Z = this.editor.delta, Y = H();
            if (q != null && (D === !0 && (D = q.index), V == null ? q = oe(q, Y, B) : V !== 0 && (q = oe(q, D, V, B)), this.setSelection(q, h.default.sources.SILENT)), Y.length() > 0) {
              var R, K = [h.default.events.TEXT_CHANGE, Y, Z, B];
              if ((R = this.emitter).emit.apply(R, [h.default.events.EDITOR_CHANGE].concat(K)), B !== h.default.sources.SILENT) {
                var te;
                (te = this.emitter).emit.apply(te, K);
              }
            }
            return Y;
          }
          function W(H, B, D, V, q) {
            var Z = {};
            return typeof H.index == "number" && typeof H.length == "number" ? typeof B != "number" ? (q = V, V = D, D = B, B = H.length, H = H.index) : (B = H.length, H = H.index) : typeof B != "number" && (q = V, V = D, D = B, B = 0), (typeof D > "u" ? "undefined" : r(D)) === "object" ? (Z = D, q = V) : typeof D == "string" && (V != null ? Z[D] = V : q = D), q = q || h.default.sources.API, [H, B, Z, q];
          }
          function oe(H, B, D, V) {
            if (H == null)
              return null;
            var q = void 0, Z = void 0;
            if (B instanceof u.default) {
              var Y = [H.index, H.index + H.length].map(function(ne) {
                return B.transformPosition(ne, V !== h.default.sources.USER);
              }), R = a(Y, 2);
              q = R[0], Z = R[1];
            } else {
              var K = [H.index, H.index + H.length].map(function(ne) {
                return ne < B || ne === B && V === h.default.sources.USER ? ne : D >= 0 ? ne + D : Math.max(B, ne + D);
              }), te = a(K, 2);
              q = te[0], Z = te[1];
            }
            return new y.Range(q, Z - q);
          }
          o.expandConfig = F, o.overload = W, o.default = L;
        },
        /* 6 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function v(p, y) {
              for (var C = 0; C < y.length; C++) {
                var b = y[C];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(p, b.key, b);
              }
            }
            return function(p, y, C) {
              return y && v(p.prototype, y), C && v(p, C), p;
            };
          }(), a = function v(p, y, C) {
            p === null && (p = Function.prototype);
            var b = Object.getOwnPropertyDescriptor(p, y);
            if (b === void 0) {
              var x = Object.getPrototypeOf(p);
              return x === null ? void 0 : v(x, y, C);
            } else {
              if ("value" in b)
                return b.value;
              var w = b.get;
              return w === void 0 ? void 0 : w.call(C);
            }
          }, l = i(7), s = f(l), u = i(0), d = f(u);
          function f(v) {
            return v && v.__esModule ? v : { default: v };
          }
          function c(v, p) {
            if (!(v instanceof p))
              throw new TypeError("Cannot call a class as a function");
          }
          function h(v, p) {
            if (!v)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return p && (typeof p == "object" || typeof p == "function") ? p : v;
          }
          function m(v, p) {
            if (typeof p != "function" && p !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof p);
            v.prototype = Object.create(p && p.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }), p && (Object.setPrototypeOf ? Object.setPrototypeOf(v, p) : v.__proto__ = p);
          }
          var g = function(v) {
            m(p, v);
            function p() {
              return c(this, p), h(this, (p.__proto__ || Object.getPrototypeOf(p)).apply(this, arguments));
            }
            return r(p, [{
              key: "formatAt",
              value: function(C, b, x, w) {
                if (p.compare(this.statics.blotName, x) < 0 && d.default.query(x, d.default.Scope.BLOT)) {
                  var $ = this.isolate(C, b);
                  w && $.wrap(x, w);
                } else
                  a(p.prototype.__proto__ || Object.getPrototypeOf(p.prototype), "formatAt", this).call(this, C, b, x, w);
              }
            }, {
              key: "optimize",
              value: function(C) {
                if (a(p.prototype.__proto__ || Object.getPrototypeOf(p.prototype), "optimize", this).call(this, C), this.parent instanceof p && p.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                  var b = this.parent.isolate(this.offset(), this.length());
                  this.moveChildren(b), b.wrap(this);
                }
              }
            }], [{
              key: "compare",
              value: function(C, b) {
                var x = p.order.indexOf(C), w = p.order.indexOf(b);
                return x >= 0 || w >= 0 ? x - w : C === b ? 0 : C < b ? -1 : 1;
              }
            }]), p;
          }(d.default.Inline);
          g.allowedChildren = [g, d.default.Embed, s.default], g.order = [
            "cursor",
            "inline",
            // Must be lower
            "underline",
            "strike",
            "italic",
            "bold",
            "script",
            "link",
            "code"
            // Must be higher
          ], o.default = g;
        },
        /* 7 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(0), a = l(r);
          function l(c) {
            return c && c.__esModule ? c : { default: c };
          }
          function s(c, h) {
            if (!(c instanceof h))
              throw new TypeError("Cannot call a class as a function");
          }
          function u(c, h) {
            if (!c)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return h && (typeof h == "object" || typeof h == "function") ? h : c;
          }
          function d(c, h) {
            if (typeof h != "function" && h !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof h);
            c.prototype = Object.create(h && h.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), h && (Object.setPrototypeOf ? Object.setPrototypeOf(c, h) : c.__proto__ = h);
          }
          var f = function(c) {
            d(h, c);
            function h() {
              return s(this, h), u(this, (h.__proto__ || Object.getPrototypeOf(h)).apply(this, arguments));
            }
            return h;
          }(a.default.Text);
          o.default = f;
        },
        /* 8 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function y(C, b) {
              for (var x = 0; x < b.length; x++) {
                var w = b[x];
                w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(C, w.key, w);
              }
            }
            return function(C, b, x) {
              return b && y(C.prototype, b), x && y(C, x), C;
            };
          }(), a = function y(C, b, x) {
            C === null && (C = Function.prototype);
            var w = Object.getOwnPropertyDescriptor(C, b);
            if (w === void 0) {
              var $ = Object.getPrototypeOf(C);
              return $ === null ? void 0 : y($, b, x);
            } else {
              if ("value" in w)
                return w.value;
              var E = w.get;
              return E === void 0 ? void 0 : E.call(x);
            }
          }, l = i(54), s = f(l), u = i(10), d = f(u);
          function f(y) {
            return y && y.__esModule ? y : { default: y };
          }
          function c(y, C) {
            if (!(y instanceof C))
              throw new TypeError("Cannot call a class as a function");
          }
          function h(y, C) {
            if (!y)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return C && (typeof C == "object" || typeof C == "function") ? C : y;
          }
          function m(y, C) {
            if (typeof C != "function" && C !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof C);
            y.prototype = Object.create(C && C.prototype, { constructor: { value: y, enumerable: !1, writable: !0, configurable: !0 } }), C && (Object.setPrototypeOf ? Object.setPrototypeOf(y, C) : y.__proto__ = C);
          }
          var g = (0, d.default)("quill:events"), v = ["selectionchange", "mousedown", "mouseup", "click"];
          v.forEach(function(y) {
            document.addEventListener(y, function() {
              for (var C = arguments.length, b = Array(C), x = 0; x < C; x++)
                b[x] = arguments[x];
              [].slice.call(document.querySelectorAll(".ql-container")).forEach(function(w) {
                if (w.__quill && w.__quill.emitter) {
                  var $;
                  ($ = w.__quill.emitter).handleDOM.apply($, b);
                }
              });
            });
          });
          var p = function(y) {
            m(C, y);
            function C() {
              c(this, C);
              var b = h(this, (C.__proto__ || Object.getPrototypeOf(C)).call(this));
              return b.listeners = {}, b.on("error", g.error), b;
            }
            return r(C, [{
              key: "emit",
              value: function() {
                g.log.apply(g, arguments), a(C.prototype.__proto__ || Object.getPrototypeOf(C.prototype), "emit", this).apply(this, arguments);
              }
            }, {
              key: "handleDOM",
              value: function(x) {
                for (var w = arguments.length, $ = Array(w > 1 ? w - 1 : 0), E = 1; E < w; E++)
                  $[E - 1] = arguments[E];
                (this.listeners[x.type] || []).forEach(function(A) {
                  var O = A.node, k = A.handler;
                  (x.target === O || O.contains(x.target)) && k.apply(void 0, [x].concat($));
                });
              }
            }, {
              key: "listenDOM",
              value: function(x, w, $) {
                this.listeners[x] || (this.listeners[x] = []), this.listeners[x].push({ node: w, handler: $ });
              }
            }]), C;
          }(s.default);
          p.events = {
            EDITOR_CHANGE: "editor-change",
            SCROLL_BEFORE_UPDATE: "scroll-before-update",
            SCROLL_OPTIMIZE: "scroll-optimize",
            SCROLL_UPDATE: "scroll-update",
            SELECTION_CHANGE: "selection-change",
            TEXT_CHANGE: "text-change"
          }, p.sources = {
            API: "api",
            SILENT: "silent",
            USER: "user"
          }, o.default = p;
        },
        /* 9 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          function r(l, s) {
            if (!(l instanceof s))
              throw new TypeError("Cannot call a class as a function");
          }
          var a = function l(s) {
            var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            r(this, l), this.quill = s, this.options = u;
          };
          a.DEFAULTS = {}, o.default = a;
        },
        /* 10 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = ["error", "warn", "log", "info"], a = "warn";
          function l(u) {
            if (r.indexOf(u) <= r.indexOf(a)) {
              for (var d, f = arguments.length, c = Array(f > 1 ? f - 1 : 0), h = 1; h < f; h++)
                c[h - 1] = arguments[h];
              (d = console)[u].apply(d, c);
            }
          }
          function s(u) {
            return r.reduce(function(d, f) {
              return d[f] = l.bind(console, f, u), d;
            }, {});
          }
          l.level = s.level = function(u) {
            a = u;
          }, o.default = s;
        },
        /* 11 */
        /***/
        function(t, o, i) {
          var r = Array.prototype.slice, a = i(52), l = i(53), s = t.exports = function(c, h, m) {
            return m || (m = {}), c === h ? !0 : c instanceof Date && h instanceof Date ? c.getTime() === h.getTime() : !c || !h || typeof c != "object" && typeof h != "object" ? m.strict ? c === h : c == h : f(c, h, m);
          };
          function u(c) {
            return c == null;
          }
          function d(c) {
            return !(!c || typeof c != "object" || typeof c.length != "number" || typeof c.copy != "function" || typeof c.slice != "function" || c.length > 0 && typeof c[0] != "number");
          }
          function f(c, h, m) {
            var g, v;
            if (u(c) || u(h) || c.prototype !== h.prototype)
              return !1;
            if (l(c))
              return l(h) ? (c = r.call(c), h = r.call(h), s(c, h, m)) : !1;
            if (d(c)) {
              if (!d(h) || c.length !== h.length)
                return !1;
              for (g = 0; g < c.length; g++)
                if (c[g] !== h[g])
                  return !1;
              return !0;
            }
            try {
              var p = a(c), y = a(h);
            } catch {
              return !1;
            }
            if (p.length != y.length)
              return !1;
            for (p.sort(), y.sort(), g = p.length - 1; g >= 0; g--)
              if (p[g] != y[g])
                return !1;
            for (g = p.length - 1; g >= 0; g--)
              if (v = p[g], !s(c[v], h[v], m))
                return !1;
            return typeof c == typeof h;
          }
        },
        /* 12 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var r = i(1), a = (
            /** @class */
            function() {
              function l(s, u, d) {
                d === void 0 && (d = {}), this.attrName = s, this.keyName = u;
                var f = r.Scope.TYPE & r.Scope.ATTRIBUTE;
                d.scope != null ? this.scope = d.scope & r.Scope.LEVEL | f : this.scope = r.Scope.ATTRIBUTE, d.whitelist != null && (this.whitelist = d.whitelist);
              }
              return l.keys = function(s) {
                return [].map.call(s.attributes, function(u) {
                  return u.name;
                });
              }, l.prototype.add = function(s, u) {
                return this.canAdd(s, u) ? (s.setAttribute(this.keyName, u), !0) : !1;
              }, l.prototype.canAdd = function(s, u) {
                var d = r.query(s, r.Scope.BLOT & (this.scope | r.Scope.TYPE));
                return d == null ? !1 : this.whitelist == null ? !0 : typeof u == "string" ? this.whitelist.indexOf(u.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(u) > -1;
              }, l.prototype.remove = function(s) {
                s.removeAttribute(this.keyName);
              }, l.prototype.value = function(s) {
                var u = s.getAttribute(this.keyName);
                return this.canAdd(s, u) && u ? u : "";
              }, l;
            }()
          );
          o.default = a;
        },
        /* 13 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.Code = void 0;
          var r = function() {
            function E(A, O) {
              var k = [], S = !0, T = !1, L = void 0;
              try {
                for (var F = A[Symbol.iterator](), U; !(S = (U = F.next()).done) && (k.push(U.value), !(O && k.length === O)); S = !0)
                  ;
              } catch (W) {
                T = !0, L = W;
              } finally {
                try {
                  !S && F.return && F.return();
                } finally {
                  if (T)
                    throw L;
                }
              }
              return k;
            }
            return function(A, O) {
              if (Array.isArray(A))
                return A;
              if (Symbol.iterator in Object(A))
                return E(A, O);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), a = function() {
            function E(A, O) {
              for (var k = 0; k < O.length; k++) {
                var S = O[k];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(A, S.key, S);
              }
            }
            return function(A, O, k) {
              return O && E(A.prototype, O), k && E(A, k), A;
            };
          }(), l = function E(A, O, k) {
            A === null && (A = Function.prototype);
            var S = Object.getOwnPropertyDescriptor(A, O);
            if (S === void 0) {
              var T = Object.getPrototypeOf(A);
              return T === null ? void 0 : E(T, O, k);
            } else {
              if ("value" in S)
                return S.value;
              var L = S.get;
              return L === void 0 ? void 0 : L.call(k);
            }
          }, s = i(2), u = y(s), d = i(0), f = y(d), c = i(4), h = y(c), m = i(6), g = y(m), v = i(7), p = y(v);
          function y(E) {
            return E && E.__esModule ? E : { default: E };
          }
          function C(E, A) {
            if (!(E instanceof A))
              throw new TypeError("Cannot call a class as a function");
          }
          function b(E, A) {
            if (!E)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return A && (typeof A == "object" || typeof A == "function") ? A : E;
          }
          function x(E, A) {
            if (typeof A != "function" && A !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof A);
            E.prototype = Object.create(A && A.prototype, { constructor: { value: E, enumerable: !1, writable: !0, configurable: !0 } }), A && (Object.setPrototypeOf ? Object.setPrototypeOf(E, A) : E.__proto__ = A);
          }
          var w = function(E) {
            x(A, E);
            function A() {
              return C(this, A), b(this, (A.__proto__ || Object.getPrototypeOf(A)).apply(this, arguments));
            }
            return A;
          }(g.default);
          w.blotName = "code", w.tagName = "CODE";
          var $ = function(E) {
            x(A, E);
            function A() {
              return C(this, A), b(this, (A.__proto__ || Object.getPrototypeOf(A)).apply(this, arguments));
            }
            return a(A, [{
              key: "delta",
              value: function() {
                var k = this, S = this.domNode.textContent;
                return S.endsWith(`
`) && (S = S.slice(0, -1)), S.split(`
`).reduce(function(T, L) {
                  return T.insert(L).insert(`
`, k.formats());
                }, new u.default());
              }
            }, {
              key: "format",
              value: function(k, S) {
                if (!(k === this.statics.blotName && S)) {
                  var T = this.descendant(p.default, this.length() - 1), L = r(T, 1), F = L[0];
                  F != null && F.deleteAt(F.length() - 1, 1), l(A.prototype.__proto__ || Object.getPrototypeOf(A.prototype), "format", this).call(this, k, S);
                }
              }
            }, {
              key: "formatAt",
              value: function(k, S, T, L) {
                if (S !== 0 && !(f.default.query(T, f.default.Scope.BLOCK) == null || T === this.statics.blotName && L === this.statics.formats(this.domNode))) {
                  var F = this.newlineIndex(k);
                  if (!(F < 0 || F >= k + S)) {
                    var U = this.newlineIndex(k, !0) + 1, W = F - U + 1, oe = this.isolate(U, W), H = oe.next;
                    oe.format(T, L), H instanceof A && H.formatAt(0, k - U + S - W, T, L);
                  }
                }
              }
            }, {
              key: "insertAt",
              value: function(k, S, T) {
                if (T == null) {
                  var L = this.descendant(p.default, k), F = r(L, 2), U = F[0], W = F[1];
                  U.insertAt(W, S);
                }
              }
            }, {
              key: "length",
              value: function() {
                var k = this.domNode.textContent.length;
                return this.domNode.textContent.endsWith(`
`) ? k : k + 1;
              }
            }, {
              key: "newlineIndex",
              value: function(k) {
                var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (S)
                  return this.domNode.textContent.slice(0, k).lastIndexOf(`
`);
                var T = this.domNode.textContent.slice(k).indexOf(`
`);
                return T > -1 ? k + T : -1;
              }
            }, {
              key: "optimize",
              value: function(k) {
                this.domNode.textContent.endsWith(`
`) || this.appendChild(f.default.create("text", `
`)), l(A.prototype.__proto__ || Object.getPrototypeOf(A.prototype), "optimize", this).call(this, k);
                var S = this.next;
                S != null && S.prev === this && S.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === S.statics.formats(S.domNode) && (S.optimize(k), S.moveChildren(this), S.remove());
              }
            }, {
              key: "replace",
              value: function(k) {
                l(A.prototype.__proto__ || Object.getPrototypeOf(A.prototype), "replace", this).call(this, k), [].slice.call(this.domNode.querySelectorAll("*")).forEach(function(S) {
                  var T = f.default.find(S);
                  T == null ? S.parentNode.removeChild(S) : T instanceof f.default.Embed ? T.remove() : T.unwrap();
                });
              }
            }], [{
              key: "create",
              value: function(k) {
                var S = l(A.__proto__ || Object.getPrototypeOf(A), "create", this).call(this, k);
                return S.setAttribute("spellcheck", !1), S;
              }
            }, {
              key: "formats",
              value: function() {
                return !0;
              }
            }]), A;
          }(h.default);
          $.blotName = "code-block", $.tagName = "PRE", $.TAB = "  ", o.Code = w, o.default = $;
        },
        /* 14 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(H) {
            return typeof H;
          } : function(H) {
            return H && typeof Symbol == "function" && H.constructor === Symbol && H !== Symbol.prototype ? "symbol" : typeof H;
          }, a = function() {
            function H(B, D) {
              var V = [], q = !0, Z = !1, Y = void 0;
              try {
                for (var R = B[Symbol.iterator](), K; !(q = (K = R.next()).done) && (V.push(K.value), !(D && V.length === D)); q = !0)
                  ;
              } catch (te) {
                Z = !0, Y = te;
              } finally {
                try {
                  !q && R.return && R.return();
                } finally {
                  if (Z)
                    throw Y;
                }
              }
              return V;
            }
            return function(B, D) {
              if (Array.isArray(B))
                return B;
              if (Symbol.iterator in Object(B))
                return H(B, D);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), l = function() {
            function H(B, D) {
              for (var V = 0; V < D.length; V++) {
                var q = D[V];
                q.enumerable = q.enumerable || !1, q.configurable = !0, "value" in q && (q.writable = !0), Object.defineProperty(B, q.key, q);
              }
            }
            return function(B, D, V) {
              return D && H(B.prototype, D), V && H(B, V), B;
            };
          }(), s = i(2), u = S(s), d = i(20), f = S(d), c = i(0), h = S(c), m = i(13), g = S(m), v = i(24), p = S(v), y = i(4), C = S(y), b = i(16), x = S(b), w = i(21), $ = S(w), E = i(11), A = S(E), O = i(3), k = S(O);
          function S(H) {
            return H && H.__esModule ? H : { default: H };
          }
          function T(H, B, D) {
            return B in H ? Object.defineProperty(H, B, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : H[B] = D, H;
          }
          function L(H, B) {
            if (!(H instanceof B))
              throw new TypeError("Cannot call a class as a function");
          }
          var F = /^[ -~]*$/, U = function() {
            function H(B) {
              L(this, H), this.scroll = B, this.delta = this.getDelta();
            }
            return l(H, [{
              key: "applyDelta",
              value: function(D) {
                var V = this, q = !1;
                this.scroll.update();
                var Z = this.scroll.length();
                return this.scroll.batchStart(), D = oe(D), D.reduce(function(Y, R) {
                  var K = R.retain || R.delete || R.insert.length || 1, te = R.attributes || {};
                  if (R.insert != null) {
                    if (typeof R.insert == "string") {
                      var ne = R.insert;
                      ne.endsWith(`
`) && q && (q = !1, ne = ne.slice(0, -1)), Y >= Z && !ne.endsWith(`
`) && (q = !0), V.scroll.insertAt(Y, ne);
                      var fe = V.scroll.line(Y), Ce = a(fe, 2), Oe = Ce[0], Ae = Ce[1], De = (0, k.default)({}, (0, y.bubbleFormats)(Oe));
                      if (Oe instanceof C.default) {
                        var qe = Oe.descendant(h.default.Leaf, Ae), $t = a(qe, 1), st = $t[0];
                        De = (0, k.default)(De, (0, y.bubbleFormats)(st));
                      }
                      te = f.default.attributes.diff(De, te) || {};
                    } else if (r(R.insert) === "object") {
                      var se = Object.keys(R.insert)[0];
                      if (se == null)
                        return Y;
                      V.scroll.insertAt(Y, se, R.insert[se]);
                    }
                    Z += K;
                  }
                  return Object.keys(te).forEach(function(ue) {
                    V.scroll.formatAt(Y, K, ue, te[ue]);
                  }), Y + K;
                }, 0), D.reduce(function(Y, R) {
                  return typeof R.delete == "number" ? (V.scroll.deleteAt(Y, R.delete), Y) : Y + (R.retain || R.insert.length || 1);
                }, 0), this.scroll.batchEnd(), this.update(D);
              }
            }, {
              key: "deleteText",
              value: function(D, V) {
                return this.scroll.deleteAt(D, V), this.update(new u.default().retain(D).delete(V));
              }
            }, {
              key: "formatLine",
              value: function(D, V) {
                var q = this, Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return this.scroll.update(), Object.keys(Z).forEach(function(Y) {
                  if (!(q.scroll.whitelist != null && !q.scroll.whitelist[Y])) {
                    var R = q.scroll.lines(D, Math.max(V, 1)), K = V;
                    R.forEach(function(te) {
                      var ne = te.length();
                      if (!(te instanceof g.default))
                        te.format(Y, Z[Y]);
                      else {
                        var fe = D - te.offset(q.scroll), Ce = te.newlineIndex(fe + K) - fe + 1;
                        te.formatAt(fe, Ce, Y, Z[Y]);
                      }
                      K -= ne;
                    });
                  }
                }), this.scroll.optimize(), this.update(new u.default().retain(D).retain(V, (0, $.default)(Z)));
              }
            }, {
              key: "formatText",
              value: function(D, V) {
                var q = this, Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return Object.keys(Z).forEach(function(Y) {
                  q.scroll.formatAt(D, V, Y, Z[Y]);
                }), this.update(new u.default().retain(D).retain(V, (0, $.default)(Z)));
              }
            }, {
              key: "getContents",
              value: function(D, V) {
                return this.delta.slice(D, D + V);
              }
            }, {
              key: "getDelta",
              value: function() {
                return this.scroll.lines().reduce(function(D, V) {
                  return D.concat(V.delta());
                }, new u.default());
              }
            }, {
              key: "getFormat",
              value: function(D) {
                var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, q = [], Z = [];
                V === 0 ? this.scroll.path(D).forEach(function(R) {
                  var K = a(R, 1), te = K[0];
                  te instanceof C.default ? q.push(te) : te instanceof h.default.Leaf && Z.push(te);
                }) : (q = this.scroll.lines(D, V), Z = this.scroll.descendants(h.default.Leaf, D, V));
                var Y = [q, Z].map(function(R) {
                  if (R.length === 0)
                    return {};
                  for (var K = (0, y.bubbleFormats)(R.shift()); Object.keys(K).length > 0; ) {
                    var te = R.shift();
                    if (te == null)
                      return K;
                    K = W((0, y.bubbleFormats)(te), K);
                  }
                  return K;
                });
                return k.default.apply(k.default, Y);
              }
            }, {
              key: "getText",
              value: function(D, V) {
                return this.getContents(D, V).filter(function(q) {
                  return typeof q.insert == "string";
                }).map(function(q) {
                  return q.insert;
                }).join("");
              }
            }, {
              key: "insertEmbed",
              value: function(D, V, q) {
                return this.scroll.insertAt(D, V, q), this.update(new u.default().retain(D).insert(T({}, V, q)));
              }
            }, {
              key: "insertText",
              value: function(D, V) {
                var q = this, Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return V = V.replace(/\r\n/g, `
`).replace(/\r/g, `
`), this.scroll.insertAt(D, V), Object.keys(Z).forEach(function(Y) {
                  q.scroll.formatAt(D, V.length, Y, Z[Y]);
                }), this.update(new u.default().retain(D).insert(V, (0, $.default)(Z)));
              }
            }, {
              key: "isBlank",
              value: function() {
                if (this.scroll.children.length == 0)
                  return !0;
                if (this.scroll.children.length > 1)
                  return !1;
                var D = this.scroll.children.head;
                return D.statics.blotName !== C.default.blotName || D.children.length > 1 ? !1 : D.children.head instanceof x.default;
              }
            }, {
              key: "removeFormat",
              value: function(D, V) {
                var q = this.getText(D, V), Z = this.scroll.line(D + V), Y = a(Z, 2), R = Y[0], K = Y[1], te = 0, ne = new u.default();
                R != null && (R instanceof g.default ? te = R.newlineIndex(K) - K + 1 : te = R.length() - K, ne = R.delta().slice(K, K + te - 1).insert(`
`));
                var fe = this.getContents(D, V + te), Ce = fe.diff(new u.default().insert(q).concat(ne)), Oe = new u.default().retain(D).concat(Ce);
                return this.applyDelta(Oe);
              }
            }, {
              key: "update",
              value: function(D) {
                var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], q = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0, Z = this.delta;
                if (V.length === 1 && V[0].type === "characterData" && V[0].target.data.match(F) && h.default.find(V[0].target)) {
                  var Y = h.default.find(V[0].target), R = (0, y.bubbleFormats)(Y), K = Y.offset(this.scroll), te = V[0].oldValue.replace(p.default.CONTENTS, ""), ne = new u.default().insert(te), fe = new u.default().insert(Y.value()), Ce = new u.default().retain(K).concat(ne.diff(fe, q));
                  D = Ce.reduce(function(Oe, Ae) {
                    return Ae.insert ? Oe.insert(Ae.insert, R) : Oe.push(Ae);
                  }, new u.default()), this.delta = Z.compose(D);
                } else
                  this.delta = this.getDelta(), (!D || !(0, A.default)(Z.compose(D), this.delta)) && (D = Z.diff(this.delta, q));
                return D;
              }
            }]), H;
          }();
          function W(H, B) {
            return Object.keys(B).reduce(function(D, V) {
              return H[V] == null || (B[V] === H[V] ? D[V] = B[V] : Array.isArray(B[V]) ? B[V].indexOf(H[V]) < 0 && (D[V] = B[V].concat([H[V]])) : D[V] = [B[V], H[V]]), D;
            }, {});
          }
          function oe(H) {
            return H.reduce(function(B, D) {
              if (D.insert === 1) {
                var V = (0, $.default)(D.attributes);
                return delete V.image, B.insert({ image: D.attributes.image }, V);
              }
              if (D.attributes != null && (D.attributes.list === !0 || D.attributes.bullet === !0) && (D = (0, $.default)(D), D.attributes.list ? D.attributes.list = "ordered" : (D.attributes.list = "bullet", delete D.attributes.bullet)), typeof D.insert == "string") {
                var q = D.insert.replace(/\r\n/g, `
`).replace(/\r/g, `
`);
                return B.insert(q, D.attributes);
              }
              return B.push(D);
            }, new u.default());
          }
          o.default = U;
        },
        /* 15 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.Range = void 0;
          var r = function() {
            function E(A, O) {
              var k = [], S = !0, T = !1, L = void 0;
              try {
                for (var F = A[Symbol.iterator](), U; !(S = (U = F.next()).done) && (k.push(U.value), !(O && k.length === O)); S = !0)
                  ;
              } catch (W) {
                T = !0, L = W;
              } finally {
                try {
                  !S && F.return && F.return();
                } finally {
                  if (T)
                    throw L;
                }
              }
              return k;
            }
            return function(A, O) {
              if (Array.isArray(A))
                return A;
              if (Symbol.iterator in Object(A))
                return E(A, O);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), a = function() {
            function E(A, O) {
              for (var k = 0; k < O.length; k++) {
                var S = O[k];
                S.enumerable = S.enumerable || !1, S.configurable = !0, "value" in S && (S.writable = !0), Object.defineProperty(A, S.key, S);
              }
            }
            return function(A, O, k) {
              return O && E(A.prototype, O), k && E(A, k), A;
            };
          }(), l = i(0), s = p(l), u = i(21), d = p(u), f = i(11), c = p(f), h = i(8), m = p(h), g = i(10), v = p(g);
          function p(E) {
            return E && E.__esModule ? E : { default: E };
          }
          function y(E) {
            if (Array.isArray(E)) {
              for (var A = 0, O = Array(E.length); A < E.length; A++)
                O[A] = E[A];
              return O;
            } else
              return Array.from(E);
          }
          function C(E, A) {
            if (!(E instanceof A))
              throw new TypeError("Cannot call a class as a function");
          }
          var b = (0, v.default)("quill:selection"), x = function E(A) {
            var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            C(this, E), this.index = A, this.length = O;
          }, w = function() {
            function E(A, O) {
              var k = this;
              C(this, E), this.emitter = O, this.scroll = A, this.composing = !1, this.mouseDown = !1, this.root = this.scroll.domNode, this.cursor = s.default.create("cursor", this), this.lastRange = this.savedRange = new x(0, 0), this.handleComposition(), this.handleDragging(), this.emitter.listenDOM("selectionchange", document, function() {
                k.mouseDown || setTimeout(k.update.bind(k, m.default.sources.USER), 1);
              }), this.emitter.on(m.default.events.EDITOR_CHANGE, function(S, T) {
                S === m.default.events.TEXT_CHANGE && T.length() > 0 && k.update(m.default.sources.SILENT);
              }), this.emitter.on(m.default.events.SCROLL_BEFORE_UPDATE, function() {
                if (k.hasFocus()) {
                  var S = k.getNativeRange();
                  S != null && S.start.node !== k.cursor.textNode && k.emitter.once(m.default.events.SCROLL_UPDATE, function() {
                    try {
                      k.setNativeRange(S.start.node, S.start.offset, S.end.node, S.end.offset);
                    } catch {
                    }
                  });
                }
              }), this.emitter.on(m.default.events.SCROLL_OPTIMIZE, function(S, T) {
                if (T.range) {
                  var L = T.range, F = L.startNode, U = L.startOffset, W = L.endNode, oe = L.endOffset;
                  k.setNativeRange(F, U, W, oe);
                }
              }), this.update(m.default.sources.SILENT);
            }
            return a(E, [{
              key: "handleComposition",
              value: function() {
                var O = this;
                this.root.addEventListener("compositionstart", function() {
                  O.composing = !0;
                }), this.root.addEventListener("compositionend", function() {
                  if (O.composing = !1, O.cursor.parent) {
                    var k = O.cursor.restore();
                    if (!k)
                      return;
                    setTimeout(function() {
                      O.setNativeRange(k.startNode, k.startOffset, k.endNode, k.endOffset);
                    }, 1);
                  }
                });
              }
            }, {
              key: "handleDragging",
              value: function() {
                var O = this;
                this.emitter.listenDOM("mousedown", document.body, function() {
                  O.mouseDown = !0;
                }), this.emitter.listenDOM("mouseup", document.body, function() {
                  O.mouseDown = !1, O.update(m.default.sources.USER);
                });
              }
            }, {
              key: "focus",
              value: function() {
                this.hasFocus() || (this.root.focus(), this.setRange(this.savedRange));
              }
            }, {
              key: "format",
              value: function(O, k) {
                if (!(this.scroll.whitelist != null && !this.scroll.whitelist[O])) {
                  this.scroll.update();
                  var S = this.getNativeRange();
                  if (!(S == null || !S.native.collapsed || s.default.query(O, s.default.Scope.BLOCK))) {
                    if (S.start.node !== this.cursor.textNode) {
                      var T = s.default.find(S.start.node, !1);
                      if (T == null)
                        return;
                      if (T instanceof s.default.Leaf) {
                        var L = T.split(S.start.offset);
                        T.parent.insertBefore(this.cursor, L);
                      } else
                        T.insertBefore(this.cursor, S.start.node);
                      this.cursor.attach();
                    }
                    this.cursor.format(O, k), this.scroll.optimize(), this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length), this.update();
                  }
                }
              }
            }, {
              key: "getBounds",
              value: function(O) {
                var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, S = this.scroll.length();
                O = Math.min(O, S - 1), k = Math.min(O + k, S - 1) - O;
                var T = void 0, L = this.scroll.leaf(O), F = r(L, 2), U = F[0], W = F[1];
                if (U == null)
                  return null;
                var oe = U.position(W, !0), H = r(oe, 2);
                T = H[0], W = H[1];
                var B = document.createRange();
                if (k > 0) {
                  B.setStart(T, W);
                  var D = this.scroll.leaf(O + k), V = r(D, 2);
                  if (U = V[0], W = V[1], U == null)
                    return null;
                  var q = U.position(W, !0), Z = r(q, 2);
                  return T = Z[0], W = Z[1], B.setEnd(T, W), B.getBoundingClientRect();
                } else {
                  var Y = "left", R = void 0;
                  return T instanceof Text ? (W < T.data.length ? (B.setStart(T, W), B.setEnd(T, W + 1)) : (B.setStart(T, W - 1), B.setEnd(T, W), Y = "right"), R = B.getBoundingClientRect()) : (R = U.domNode.getBoundingClientRect(), W > 0 && (Y = "right")), {
                    bottom: R.top + R.height,
                    height: R.height,
                    left: R[Y],
                    right: R[Y],
                    top: R.top,
                    width: 0
                  };
                }
              }
            }, {
              key: "getNativeRange",
              value: function() {
                var O = document.getSelection();
                if (O == null || O.rangeCount <= 0)
                  return null;
                var k = O.getRangeAt(0);
                if (k == null)
                  return null;
                var S = this.normalizeNative(k);
                return b.info("getNativeRange", S), S;
              }
            }, {
              key: "getRange",
              value: function() {
                var O = this.getNativeRange();
                if (O == null)
                  return [null, null];
                var k = this.normalizedToRange(O);
                return [k, O];
              }
            }, {
              key: "hasFocus",
              value: function() {
                return document.activeElement === this.root;
              }
            }, {
              key: "normalizedToRange",
              value: function(O) {
                var k = this, S = [[O.start.node, O.start.offset]];
                O.native.collapsed || S.push([O.end.node, O.end.offset]);
                var T = S.map(function(U) {
                  var W = r(U, 2), oe = W[0], H = W[1], B = s.default.find(oe, !0), D = B.offset(k.scroll);
                  return H === 0 ? D : B instanceof s.default.Container ? D + B.length() : D + B.index(oe, H);
                }), L = Math.min(Math.max.apply(Math, y(T)), this.scroll.length() - 1), F = Math.min.apply(Math, [L].concat(y(T)));
                return new x(F, L - F);
              }
            }, {
              key: "normalizeNative",
              value: function(O) {
                if (!$(this.root, O.startContainer) || !O.collapsed && !$(this.root, O.endContainer))
                  return null;
                var k = {
                  start: { node: O.startContainer, offset: O.startOffset },
                  end: { node: O.endContainer, offset: O.endOffset },
                  native: O
                };
                return [k.start, k.end].forEach(function(S) {
                  for (var T = S.node, L = S.offset; !(T instanceof Text) && T.childNodes.length > 0; )
                    if (T.childNodes.length > L)
                      T = T.childNodes[L], L = 0;
                    else if (T.childNodes.length === L)
                      T = T.lastChild, L = T instanceof Text ? T.data.length : T.childNodes.length + 1;
                    else
                      break;
                  S.node = T, S.offset = L;
                }), k;
              }
            }, {
              key: "rangeToNative",
              value: function(O) {
                var k = this, S = O.collapsed ? [O.index] : [O.index, O.index + O.length], T = [], L = this.scroll.length();
                return S.forEach(function(F, U) {
                  F = Math.min(L - 1, F);
                  var W = void 0, oe = k.scroll.leaf(F), H = r(oe, 2), B = H[0], D = H[1], V = B.position(D, U !== 0), q = r(V, 2);
                  W = q[0], D = q[1], T.push(W, D);
                }), T.length < 2 && (T = T.concat(T)), T;
              }
            }, {
              key: "scrollIntoView",
              value: function(O) {
                var k = this.lastRange;
                if (k != null) {
                  var S = this.getBounds(k.index, k.length);
                  if (S != null) {
                    var T = this.scroll.length() - 1, L = this.scroll.line(Math.min(k.index, T)), F = r(L, 1), U = F[0], W = U;
                    if (k.length > 0) {
                      var oe = this.scroll.line(Math.min(k.index + k.length, T)), H = r(oe, 1);
                      W = H[0];
                    }
                    if (!(U == null || W == null)) {
                      var B = O.getBoundingClientRect();
                      S.top < B.top ? O.scrollTop -= B.top - S.top : S.bottom > B.bottom && (O.scrollTop += S.bottom - B.bottom);
                    }
                  }
                }
              }
            }, {
              key: "setNativeRange",
              value: function(O, k) {
                var S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : O, T = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : k, L = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
                if (b.info("setNativeRange", O, k, S, T), !(O != null && (this.root.parentNode == null || O.parentNode == null || S.parentNode == null))) {
                  var F = document.getSelection();
                  if (F != null)
                    if (O != null) {
                      this.hasFocus() || this.root.focus();
                      var U = (this.getNativeRange() || {}).native;
                      if (U == null || L || O !== U.startContainer || k !== U.startOffset || S !== U.endContainer || T !== U.endOffset) {
                        O.tagName == "BR" && (k = [].indexOf.call(O.parentNode.childNodes, O), O = O.parentNode), S.tagName == "BR" && (T = [].indexOf.call(S.parentNode.childNodes, S), S = S.parentNode);
                        var W = document.createRange();
                        W.setStart(O, k), W.setEnd(S, T), F.removeAllRanges(), F.addRange(W);
                      }
                    } else
                      F.removeAllRanges(), this.root.blur(), document.body.focus();
                }
              }
            }, {
              key: "setRange",
              value: function(O) {
                var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, S = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : m.default.sources.API;
                if (typeof k == "string" && (S = k, k = !1), b.info("setRange", O), O != null) {
                  var T = this.rangeToNative(O);
                  this.setNativeRange.apply(this, y(T).concat([k]));
                } else
                  this.setNativeRange(null);
                this.update(S);
              }
            }, {
              key: "update",
              value: function() {
                var O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : m.default.sources.USER, k = this.lastRange, S = this.getRange(), T = r(S, 2), L = T[0], F = T[1];
                if (this.lastRange = L, this.lastRange != null && (this.savedRange = this.lastRange), !(0, c.default)(k, this.lastRange)) {
                  var U;
                  !this.composing && F != null && F.native.collapsed && F.start.node !== this.cursor.textNode && this.cursor.restore();
                  var W = [m.default.events.SELECTION_CHANGE, (0, d.default)(this.lastRange), (0, d.default)(k), O];
                  if ((U = this.emitter).emit.apply(U, [m.default.events.EDITOR_CHANGE].concat(W)), O !== m.default.sources.SILENT) {
                    var oe;
                    (oe = this.emitter).emit.apply(oe, W);
                  }
                }
              }
            }]), E;
          }();
          function $(E, A) {
            try {
              A.parentNode;
            } catch {
              return !1;
            }
            return A instanceof Text && (A = A.parentNode), E.contains(A);
          }
          o.Range = x, o.default = w;
        },
        /* 16 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function m(g, v) {
              for (var p = 0; p < v.length; p++) {
                var y = v[p];
                y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(g, y.key, y);
              }
            }
            return function(g, v, p) {
              return v && m(g.prototype, v), p && m(g, p), g;
            };
          }(), a = function m(g, v, p) {
            g === null && (g = Function.prototype);
            var y = Object.getOwnPropertyDescriptor(g, v);
            if (y === void 0) {
              var C = Object.getPrototypeOf(g);
              return C === null ? void 0 : m(C, v, p);
            } else {
              if ("value" in y)
                return y.value;
              var b = y.get;
              return b === void 0 ? void 0 : b.call(p);
            }
          }, l = i(0), s = u(l);
          function u(m) {
            return m && m.__esModule ? m : { default: m };
          }
          function d(m, g) {
            if (!(m instanceof g))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(m, g) {
            if (!m)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return g && (typeof g == "object" || typeof g == "function") ? g : m;
          }
          function c(m, g) {
            if (typeof g != "function" && g !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof g);
            m.prototype = Object.create(g && g.prototype, { constructor: { value: m, enumerable: !1, writable: !0, configurable: !0 } }), g && (Object.setPrototypeOf ? Object.setPrototypeOf(m, g) : m.__proto__ = g);
          }
          var h = function(m) {
            c(g, m);
            function g() {
              return d(this, g), f(this, (g.__proto__ || Object.getPrototypeOf(g)).apply(this, arguments));
            }
            return r(g, [{
              key: "insertInto",
              value: function(p, y) {
                p.children.length === 0 ? a(g.prototype.__proto__ || Object.getPrototypeOf(g.prototype), "insertInto", this).call(this, p, y) : this.remove();
              }
            }, {
              key: "length",
              value: function() {
                return 0;
              }
            }, {
              key: "value",
              value: function() {
                return "";
              }
            }], [{
              key: "value",
              value: function() {
              }
            }]), g;
          }(s.default.Embed);
          h.blotName = "break", h.tagName = "BR", o.default = h;
        },
        /* 17 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, h) {
              c.__proto__ = h;
            } || function(c, h) {
              for (var m in h)
                h.hasOwnProperty(m) && (c[m] = h[m]);
            };
            return function(c, h) {
              f(c, h);
              function m() {
                this.constructor = c;
              }
              c.prototype = h === null ? Object.create(h) : (m.prototype = h.prototype, new m());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(44), l = i(30), s = i(1), u = (
            /** @class */
            function(f) {
              r(c, f);
              function c(h) {
                var m = f.call(this, h) || this;
                return m.build(), m;
              }
              return c.prototype.appendChild = function(h) {
                this.insertBefore(h);
              }, c.prototype.attach = function() {
                f.prototype.attach.call(this), this.children.forEach(function(h) {
                  h.attach();
                });
              }, c.prototype.build = function() {
                var h = this;
                this.children = new a.default(), [].slice.call(this.domNode.childNodes).reverse().forEach(function(m) {
                  try {
                    var g = d(m);
                    h.insertBefore(g, h.children.head || void 0);
                  } catch (v) {
                    if (v instanceof s.ParchmentError)
                      return;
                    throw v;
                  }
                });
              }, c.prototype.deleteAt = function(h, m) {
                if (h === 0 && m === this.length())
                  return this.remove();
                this.children.forEachAt(h, m, function(g, v, p) {
                  g.deleteAt(v, p);
                });
              }, c.prototype.descendant = function(h, m) {
                var g = this.children.find(m), v = g[0], p = g[1];
                return h.blotName == null && h(v) || h.blotName != null && v instanceof h ? [v, p] : v instanceof c ? v.descendant(h, p) : [null, -1];
              }, c.prototype.descendants = function(h, m, g) {
                m === void 0 && (m = 0), g === void 0 && (g = Number.MAX_VALUE);
                var v = [], p = g;
                return this.children.forEachAt(m, g, function(y, C, b) {
                  (h.blotName == null && h(y) || h.blotName != null && y instanceof h) && v.push(y), y instanceof c && (v = v.concat(y.descendants(h, C, p))), p -= b;
                }), v;
              }, c.prototype.detach = function() {
                this.children.forEach(function(h) {
                  h.detach();
                }), f.prototype.detach.call(this);
              }, c.prototype.formatAt = function(h, m, g, v) {
                this.children.forEachAt(h, m, function(p, y, C) {
                  p.formatAt(y, C, g, v);
                });
              }, c.prototype.insertAt = function(h, m, g) {
                var v = this.children.find(h), p = v[0], y = v[1];
                if (p)
                  p.insertAt(y, m, g);
                else {
                  var C = g == null ? s.create("text", m) : s.create(m, g);
                  this.appendChild(C);
                }
              }, c.prototype.insertBefore = function(h, m) {
                if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(g) {
                  return h instanceof g;
                }))
                  throw new s.ParchmentError("Cannot insert " + h.statics.blotName + " into " + this.statics.blotName);
                h.insertInto(this, m);
              }, c.prototype.length = function() {
                return this.children.reduce(function(h, m) {
                  return h + m.length();
                }, 0);
              }, c.prototype.moveChildren = function(h, m) {
                this.children.forEach(function(g) {
                  h.insertBefore(g, m);
                });
              }, c.prototype.optimize = function(h) {
                if (f.prototype.optimize.call(this, h), this.children.length === 0)
                  if (this.statics.defaultChild != null) {
                    var m = s.create(this.statics.defaultChild);
                    this.appendChild(m), m.optimize(h);
                  } else
                    this.remove();
              }, c.prototype.path = function(h, m) {
                m === void 0 && (m = !1);
                var g = this.children.find(h, m), v = g[0], p = g[1], y = [[this, h]];
                return v instanceof c ? y.concat(v.path(p, m)) : (v != null && y.push([v, p]), y);
              }, c.prototype.removeChild = function(h) {
                this.children.remove(h);
              }, c.prototype.replace = function(h) {
                h instanceof c && h.moveChildren(this), f.prototype.replace.call(this, h);
              }, c.prototype.split = function(h, m) {
                if (m === void 0 && (m = !1), !m) {
                  if (h === 0)
                    return this;
                  if (h === this.length())
                    return this.next;
                }
                var g = this.clone();
                return this.parent.insertBefore(g, this.next), this.children.forEachAt(h, this.length(), function(v, p, y) {
                  v = v.split(p, m), g.appendChild(v);
                }), g;
              }, c.prototype.unwrap = function() {
                this.moveChildren(this.parent, this.next), this.remove();
              }, c.prototype.update = function(h, m) {
                var g = this, v = [], p = [];
                h.forEach(function(y) {
                  y.target === g.domNode && y.type === "childList" && (v.push.apply(v, y.addedNodes), p.push.apply(p, y.removedNodes));
                }), p.forEach(function(y) {
                  if (!(y.parentNode != null && // @ts-ignore
                  y.tagName !== "IFRAME" && document.body.compareDocumentPosition(y) & Node.DOCUMENT_POSITION_CONTAINED_BY)) {
                    var C = s.find(y);
                    C != null && (C.domNode.parentNode == null || C.domNode.parentNode === g.domNode) && C.detach();
                  }
                }), v.filter(function(y) {
                  return y.parentNode == g.domNode;
                }).sort(function(y, C) {
                  return y === C ? 0 : y.compareDocumentPosition(C) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1;
                }).forEach(function(y) {
                  var C = null;
                  y.nextSibling != null && (C = s.find(y.nextSibling));
                  var b = d(y);
                  (b.next != C || b.next == null) && (b.parent != null && b.parent.removeChild(g), g.insertBefore(b, C || void 0));
                });
              }, c;
            }(l.default)
          );
          function d(f) {
            var c = s.find(f);
            if (c == null)
              try {
                c = s.create(f);
              } catch {
                c = s.create(s.Scope.INLINE), [].slice.call(f.childNodes).forEach(function(m) {
                  c.domNode.appendChild(m);
                }), f.parentNode && f.parentNode.replaceChild(c.domNode, f), c.attach();
              }
            return c;
          }
          o.default = u;
        },
        /* 18 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, h) {
              c.__proto__ = h;
            } || function(c, h) {
              for (var m in h)
                h.hasOwnProperty(m) && (c[m] = h[m]);
            };
            return function(c, h) {
              f(c, h);
              function m() {
                this.constructor = c;
              }
              c.prototype = h === null ? Object.create(h) : (m.prototype = h.prototype, new m());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(12), l = i(31), s = i(17), u = i(1), d = (
            /** @class */
            function(f) {
              r(c, f);
              function c(h) {
                var m = f.call(this, h) || this;
                return m.attributes = new l.default(m.domNode), m;
              }
              return c.formats = function(h) {
                if (typeof this.tagName == "string")
                  return !0;
                if (Array.isArray(this.tagName))
                  return h.tagName.toLowerCase();
              }, c.prototype.format = function(h, m) {
                var g = u.query(h);
                g instanceof a.default ? this.attributes.attribute(g, m) : m && g != null && (h !== this.statics.blotName || this.formats()[h] !== m) && this.replaceWith(h, m);
              }, c.prototype.formats = function() {
                var h = this.attributes.values(), m = this.statics.formats(this.domNode);
                return m != null && (h[this.statics.blotName] = m), h;
              }, c.prototype.replaceWith = function(h, m) {
                var g = f.prototype.replaceWith.call(this, h, m);
                return this.attributes.copy(g), g;
              }, c.prototype.update = function(h, m) {
                var g = this;
                f.prototype.update.call(this, h, m), h.some(function(v) {
                  return v.target === g.domNode && v.type === "attributes";
                }) && this.attributes.build();
              }, c.prototype.wrap = function(h, m) {
                var g = f.prototype.wrap.call(this, h, m);
                return g instanceof c && g.statics.scope === this.statics.scope && this.attributes.move(g), g;
              }, c;
            }(s.default)
          );
          o.default = d;
        },
        /* 19 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
              d.__proto__ = f;
            } || function(d, f) {
              for (var c in f)
                f.hasOwnProperty(c) && (d[c] = f[c]);
            };
            return function(d, f) {
              u(d, f);
              function c() {
                this.constructor = d;
              }
              d.prototype = f === null ? Object.create(f) : (c.prototype = f.prototype, new c());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(30), l = i(1), s = (
            /** @class */
            function(u) {
              r(d, u);
              function d() {
                return u !== null && u.apply(this, arguments) || this;
              }
              return d.value = function(f) {
                return !0;
              }, d.prototype.index = function(f, c) {
                return this.domNode === f || this.domNode.compareDocumentPosition(f) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(c, 1) : -1;
              }, d.prototype.position = function(f, c) {
                var h = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                return f > 0 && (h += 1), [this.parent.domNode, h];
              }, d.prototype.value = function() {
                var f;
                return f = {}, f[this.statics.blotName] = this.statics.value(this.domNode) || !0, f;
              }, d.scope = l.Scope.INLINE_BLOT, d;
            }(a.default)
          );
          o.default = s;
        },
        /* 20 */
        /***/
        function(t, o, i) {
          var r = i(11), a = i(3), l = {
            attributes: {
              compose: function(u, d, f) {
                typeof u != "object" && (u = {}), typeof d != "object" && (d = {});
                var c = a(!0, {}, d);
                f || (c = Object.keys(c).reduce(function(m, g) {
                  return c[g] != null && (m[g] = c[g]), m;
                }, {}));
                for (var h in u)
                  u[h] !== void 0 && d[h] === void 0 && (c[h] = u[h]);
                return Object.keys(c).length > 0 ? c : void 0;
              },
              diff: function(u, d) {
                typeof u != "object" && (u = {}), typeof d != "object" && (d = {});
                var f = Object.keys(u).concat(Object.keys(d)).reduce(function(c, h) {
                  return r(u[h], d[h]) || (c[h] = d[h] === void 0 ? null : d[h]), c;
                }, {});
                return Object.keys(f).length > 0 ? f : void 0;
              },
              transform: function(u, d, f) {
                if (typeof u != "object")
                  return d;
                if (typeof d == "object") {
                  if (!f)
                    return d;
                  var c = Object.keys(d).reduce(function(h, m) {
                    return u[m] === void 0 && (h[m] = d[m]), h;
                  }, {});
                  return Object.keys(c).length > 0 ? c : void 0;
                }
              }
            },
            iterator: function(u) {
              return new s(u);
            },
            length: function(u) {
              return typeof u.delete == "number" ? u.delete : typeof u.retain == "number" ? u.retain : typeof u.insert == "string" ? u.insert.length : 1;
            }
          };
          function s(u) {
            this.ops = u, this.index = 0, this.offset = 0;
          }
          s.prototype.hasNext = function() {
            return this.peekLength() < 1 / 0;
          }, s.prototype.next = function(u) {
            u || (u = 1 / 0);
            var d = this.ops[this.index];
            if (d) {
              var f = this.offset, c = l.length(d);
              if (u >= c - f ? (u = c - f, this.index += 1, this.offset = 0) : this.offset += u, typeof d.delete == "number")
                return { delete: u };
              var h = {};
              return d.attributes && (h.attributes = d.attributes), typeof d.retain == "number" ? h.retain = u : typeof d.insert == "string" ? h.insert = d.insert.substr(f, u) : h.insert = d.insert, h;
            } else
              return { retain: 1 / 0 };
          }, s.prototype.peek = function() {
            return this.ops[this.index];
          }, s.prototype.peekLength = function() {
            return this.ops[this.index] ? l.length(this.ops[this.index]) - this.offset : 1 / 0;
          }, s.prototype.peekType = function() {
            return this.ops[this.index] ? typeof this.ops[this.index].delete == "number" ? "delete" : typeof this.ops[this.index].retain == "number" ? "retain" : "insert" : "retain";
          }, s.prototype.rest = function() {
            if (this.hasNext()) {
              if (this.offset === 0)
                return this.ops.slice(this.index);
              var u = this.offset, d = this.index, f = this.next(), c = this.ops.slice(this.index);
              return this.offset = u, this.index = d, [f].concat(c);
            } else
              return [];
          }, t.exports = l;
        },
        /* 21 */
        /***/
        function(t, o) {
          var i = function() {
            function r(g, v) {
              return v != null && g instanceof v;
            }
            var a;
            try {
              a = Map;
            } catch {
              a = function() {
              };
            }
            var l;
            try {
              l = Set;
            } catch {
              l = function() {
              };
            }
            var s;
            try {
              s = Promise;
            } catch {
              s = function() {
              };
            }
            function u(g, v, p, y, C) {
              typeof v == "object" && (p = v.depth, y = v.prototype, C = v.includeNonEnumerable, v = v.circular);
              var b = [], x = [], w = typeof Buffer < "u";
              typeof v > "u" && (v = !0), typeof p > "u" && (p = 1 / 0);
              function $(E, A) {
                if (E === null)
                  return null;
                if (A === 0)
                  return E;
                var O, k;
                if (typeof E != "object")
                  return E;
                if (r(E, a))
                  O = new a();
                else if (r(E, l))
                  O = new l();
                else if (r(E, s))
                  O = new s(function(B, D) {
                    E.then(function(V) {
                      B($(V, A - 1));
                    }, function(V) {
                      D($(V, A - 1));
                    });
                  });
                else if (u.__isArray(E))
                  O = [];
                else if (u.__isRegExp(E))
                  O = new RegExp(E.source, m(E)), E.lastIndex && (O.lastIndex = E.lastIndex);
                else if (u.__isDate(E))
                  O = new Date(E.getTime());
                else {
                  if (w && Buffer.isBuffer(E))
                    return Buffer.allocUnsafe ? O = Buffer.allocUnsafe(E.length) : O = new Buffer(E.length), E.copy(O), O;
                  r(E, Error) ? O = Object.create(E) : typeof y > "u" ? (k = Object.getPrototypeOf(E), O = Object.create(k)) : (O = Object.create(y), k = y);
                }
                if (v) {
                  var S = b.indexOf(E);
                  if (S != -1)
                    return x[S];
                  b.push(E), x.push(O);
                }
                r(E, a) && E.forEach(function(B, D) {
                  var V = $(D, A - 1), q = $(B, A - 1);
                  O.set(V, q);
                }), r(E, l) && E.forEach(function(B) {
                  var D = $(B, A - 1);
                  O.add(D);
                });
                for (var T in E) {
                  var L;
                  k && (L = Object.getOwnPropertyDescriptor(k, T)), !(L && L.set == null) && (O[T] = $(E[T], A - 1));
                }
                if (Object.getOwnPropertySymbols)
                  for (var F = Object.getOwnPropertySymbols(E), T = 0; T < F.length; T++) {
                    var U = F[T], W = Object.getOwnPropertyDescriptor(E, U);
                    W && !W.enumerable && !C || (O[U] = $(E[U], A - 1), W.enumerable || Object.defineProperty(O, U, {
                      enumerable: !1
                    }));
                  }
                if (C)
                  for (var oe = Object.getOwnPropertyNames(E), T = 0; T < oe.length; T++) {
                    var H = oe[T], W = Object.getOwnPropertyDescriptor(E, H);
                    W && W.enumerable || (O[H] = $(E[H], A - 1), Object.defineProperty(O, H, {
                      enumerable: !1
                    }));
                  }
                return O;
              }
              return $(g, p);
            }
            u.clonePrototype = function(v) {
              if (v === null)
                return null;
              var p = function() {
              };
              return p.prototype = v, new p();
            };
            function d(g) {
              return Object.prototype.toString.call(g);
            }
            u.__objToStr = d;
            function f(g) {
              return typeof g == "object" && d(g) === "[object Date]";
            }
            u.__isDate = f;
            function c(g) {
              return typeof g == "object" && d(g) === "[object Array]";
            }
            u.__isArray = c;
            function h(g) {
              return typeof g == "object" && d(g) === "[object RegExp]";
            }
            u.__isRegExp = h;
            function m(g) {
              var v = "";
              return g.global && (v += "g"), g.ignoreCase && (v += "i"), g.multiline && (v += "m"), v;
            }
            return u.__getRegExpFlags = m, u;
          }();
          typeof t == "object" && t.exports && (t.exports = i);
        },
        /* 22 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function O(k, S) {
              var T = [], L = !0, F = !1, U = void 0;
              try {
                for (var W = k[Symbol.iterator](), oe; !(L = (oe = W.next()).done) && (T.push(oe.value), !(S && T.length === S)); L = !0)
                  ;
              } catch (H) {
                F = !0, U = H;
              } finally {
                try {
                  !L && W.return && W.return();
                } finally {
                  if (F)
                    throw U;
                }
              }
              return T;
            }
            return function(k, S) {
              if (Array.isArray(k))
                return k;
              if (Symbol.iterator in Object(k))
                return O(k, S);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), a = function() {
            function O(k, S) {
              for (var T = 0; T < S.length; T++) {
                var L = S[T];
                L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(k, L.key, L);
              }
            }
            return function(k, S, T) {
              return S && O(k.prototype, S), T && O(k, T), k;
            };
          }(), l = function O(k, S, T) {
            k === null && (k = Function.prototype);
            var L = Object.getOwnPropertyDescriptor(k, S);
            if (L === void 0) {
              var F = Object.getPrototypeOf(k);
              return F === null ? void 0 : O(F, S, T);
            } else {
              if ("value" in L)
                return L.value;
              var U = L.get;
              return U === void 0 ? void 0 : U.call(T);
            }
          }, s = i(0), u = b(s), d = i(8), f = b(d), c = i(4), h = b(c), m = i(16), g = b(m), v = i(13), p = b(v), y = i(25), C = b(y);
          function b(O) {
            return O && O.__esModule ? O : { default: O };
          }
          function x(O, k) {
            if (!(O instanceof k))
              throw new TypeError("Cannot call a class as a function");
          }
          function w(O, k) {
            if (!O)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return k && (typeof k == "object" || typeof k == "function") ? k : O;
          }
          function $(O, k) {
            if (typeof k != "function" && k !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof k);
            O.prototype = Object.create(k && k.prototype, { constructor: { value: O, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(O, k) : O.__proto__ = k);
          }
          function E(O) {
            return O instanceof h.default || O instanceof c.BlockEmbed;
          }
          var A = function(O) {
            $(k, O);
            function k(S, T) {
              x(this, k);
              var L = w(this, (k.__proto__ || Object.getPrototypeOf(k)).call(this, S));
              return L.emitter = T.emitter, Array.isArray(T.whitelist) && (L.whitelist = T.whitelist.reduce(function(F, U) {
                return F[U] = !0, F;
              }, {})), L.domNode.addEventListener("DOMNodeInserted", function() {
              }), L.optimize(), L.enable(), L;
            }
            return a(k, [{
              key: "batchStart",
              value: function() {
                this.batch = !0;
              }
            }, {
              key: "batchEnd",
              value: function() {
                this.batch = !1, this.optimize();
              }
            }, {
              key: "deleteAt",
              value: function(T, L) {
                var F = this.line(T), U = r(F, 2), W = U[0], oe = U[1], H = this.line(T + L), B = r(H, 1), D = B[0];
                if (l(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "deleteAt", this).call(this, T, L), D != null && W !== D && oe > 0) {
                  if (W instanceof c.BlockEmbed || D instanceof c.BlockEmbed) {
                    this.optimize();
                    return;
                  }
                  if (W instanceof p.default) {
                    var V = W.newlineIndex(W.length(), !0);
                    if (V > -1 && (W = W.split(V + 1), W === D)) {
                      this.optimize();
                      return;
                    }
                  } else if (D instanceof p.default) {
                    var q = D.newlineIndex(0);
                    q > -1 && D.split(q + 1);
                  }
                  var Z = D.children.head instanceof g.default ? null : D.children.head;
                  W.moveChildren(D, Z), W.remove();
                }
                this.optimize();
              }
            }, {
              key: "enable",
              value: function() {
                var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                this.domNode.setAttribute("contenteditable", T);
              }
            }, {
              key: "formatAt",
              value: function(T, L, F, U) {
                this.whitelist != null && !this.whitelist[F] || (l(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "formatAt", this).call(this, T, L, F, U), this.optimize());
              }
            }, {
              key: "insertAt",
              value: function(T, L, F) {
                if (!(F != null && this.whitelist != null && !this.whitelist[L])) {
                  if (T >= this.length())
                    if (F == null || u.default.query(L, u.default.Scope.BLOCK) == null) {
                      var U = u.default.create(this.statics.defaultChild);
                      this.appendChild(U), F == null && L.endsWith(`
`) && (L = L.slice(0, -1)), U.insertAt(0, L, F);
                    } else {
                      var W = u.default.create(L, F);
                      this.appendChild(W);
                    }
                  else
                    l(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "insertAt", this).call(this, T, L, F);
                  this.optimize();
                }
              }
            }, {
              key: "insertBefore",
              value: function(T, L) {
                if (T.statics.scope === u.default.Scope.INLINE_BLOT) {
                  var F = u.default.create(this.statics.defaultChild);
                  F.appendChild(T), T = F;
                }
                l(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "insertBefore", this).call(this, T, L);
              }
            }, {
              key: "leaf",
              value: function(T) {
                return this.path(T).pop() || [null, -1];
              }
            }, {
              key: "line",
              value: function(T) {
                return T === this.length() ? this.line(T - 1) : this.descendant(E, T);
              }
            }, {
              key: "lines",
              value: function() {
                var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE, F = function U(W, oe, H) {
                  var B = [], D = H;
                  return W.children.forEachAt(oe, H, function(V, q, Z) {
                    E(V) ? B.push(V) : V instanceof u.default.Container && (B = B.concat(U(V, q, D))), D -= Z;
                  }), B;
                };
                return F(this, T, L);
              }
            }, {
              key: "optimize",
              value: function() {
                var T = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.batch !== !0 && (l(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "optimize", this).call(this, T, L), T.length > 0 && this.emitter.emit(f.default.events.SCROLL_OPTIMIZE, T, L));
              }
            }, {
              key: "path",
              value: function(T) {
                return l(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "path", this).call(this, T).slice(1);
              }
            }, {
              key: "update",
              value: function(T) {
                if (this.batch !== !0) {
                  var L = f.default.sources.USER;
                  typeof T == "string" && (L = T), Array.isArray(T) || (T = this.observer.takeRecords()), T.length > 0 && this.emitter.emit(f.default.events.SCROLL_BEFORE_UPDATE, L, T), l(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "update", this).call(this, T.concat([])), T.length > 0 && this.emitter.emit(f.default.events.SCROLL_UPDATE, L, T);
                }
              }
            }]), k;
          }(u.default.Scroll);
          A.blotName = "scroll", A.className = "ql-editor", A.tagName = "DIV", A.defaultChild = "block", A.allowedChildren = [h.default, c.BlockEmbed, C.default], o.default = A;
        },
        /* 23 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.SHORTKEY = o.default = void 0;
          var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(R) {
            return typeof R;
          } : function(R) {
            return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
          }, a = function() {
            function R(K, te) {
              var ne = [], fe = !0, Ce = !1, Oe = void 0;
              try {
                for (var Ae = K[Symbol.iterator](), De; !(fe = (De = Ae.next()).done) && (ne.push(De.value), !(te && ne.length === te)); fe = !0)
                  ;
              } catch (qe) {
                Ce = !0, Oe = qe;
              } finally {
                try {
                  !fe && Ae.return && Ae.return();
                } finally {
                  if (Ce)
                    throw Oe;
                }
              }
              return ne;
            }
            return function(K, te) {
              if (Array.isArray(K))
                return K;
              if (Symbol.iterator in Object(K))
                return R(K, te);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), l = function() {
            function R(K, te) {
              for (var ne = 0; ne < te.length; ne++) {
                var fe = te[ne];
                fe.enumerable = fe.enumerable || !1, fe.configurable = !0, "value" in fe && (fe.writable = !0), Object.defineProperty(K, fe.key, fe);
              }
            }
            return function(K, te, ne) {
              return te && R(K.prototype, te), ne && R(K, ne), K;
            };
          }(), s = i(21), u = O(s), d = i(11), f = O(d), c = i(3), h = O(c), m = i(2), g = O(m), v = i(20), p = O(v), y = i(0), C = O(y), b = i(5), x = O(b), w = i(10), $ = O(w), E = i(9), A = O(E);
          function O(R) {
            return R && R.__esModule ? R : { default: R };
          }
          function k(R, K, te) {
            return K in R ? Object.defineProperty(R, K, { value: te, enumerable: !0, configurable: !0, writable: !0 }) : R[K] = te, R;
          }
          function S(R, K) {
            if (!(R instanceof K))
              throw new TypeError("Cannot call a class as a function");
          }
          function T(R, K) {
            if (!R)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return K && (typeof K == "object" || typeof K == "function") ? K : R;
          }
          function L(R, K) {
            if (typeof K != "function" && K !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof K);
            R.prototype = Object.create(K && K.prototype, { constructor: { value: R, enumerable: !1, writable: !0, configurable: !0 } }), K && (Object.setPrototypeOf ? Object.setPrototypeOf(R, K) : R.__proto__ = K);
          }
          var F = (0, $.default)("quill:keyboard"), U = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey", W = function(R) {
            L(K, R), l(K, null, [{
              key: "match",
              value: function(ne, fe) {
                return fe = Y(fe), ["altKey", "ctrlKey", "metaKey", "shiftKey"].some(function(Ce) {
                  return !!fe[Ce] !== ne[Ce] && fe[Ce] !== null;
                }) ? !1 : fe.key === (ne.which || ne.keyCode);
              }
            }]);
            function K(te, ne) {
              S(this, K);
              var fe = T(this, (K.__proto__ || Object.getPrototypeOf(K)).call(this, te, ne));
              return fe.bindings = {}, Object.keys(fe.options.bindings).forEach(function(Ce) {
                Ce === "list autofill" && te.scroll.whitelist != null && !te.scroll.whitelist.list || fe.options.bindings[Ce] && fe.addBinding(fe.options.bindings[Ce]);
              }), fe.addBinding({ key: K.keys.ENTER, shiftKey: null }, V), fe.addBinding({ key: K.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function() {
              }), /Firefox/i.test(navigator.userAgent) ? (fe.addBinding({ key: K.keys.BACKSPACE }, { collapsed: !0 }, H), fe.addBinding({ key: K.keys.DELETE }, { collapsed: !0 }, B)) : (fe.addBinding({ key: K.keys.BACKSPACE }, { collapsed: !0, prefix: /^.?$/ }, H), fe.addBinding({ key: K.keys.DELETE }, { collapsed: !0, suffix: /^.?$/ }, B)), fe.addBinding({ key: K.keys.BACKSPACE }, { collapsed: !1 }, D), fe.addBinding({ key: K.keys.DELETE }, { collapsed: !1 }, D), fe.addBinding({ key: K.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: !0, offset: 0 }, H), fe.listen(), fe;
            }
            return l(K, [{
              key: "addBinding",
              value: function(ne) {
                var fe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Ce = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, Oe = Y(ne);
                if (Oe == null || Oe.key == null)
                  return F.warn("Attempted to add invalid keyboard binding", Oe);
                typeof fe == "function" && (fe = { handler: fe }), typeof Ce == "function" && (Ce = { handler: Ce }), Oe = (0, h.default)(Oe, fe, Ce), this.bindings[Oe.key] = this.bindings[Oe.key] || [], this.bindings[Oe.key].push(Oe);
              }
            }, {
              key: "listen",
              value: function() {
                var ne = this;
                this.quill.root.addEventListener("keydown", function(fe) {
                  if (!fe.defaultPrevented) {
                    var Ce = fe.which || fe.keyCode, Oe = (ne.bindings[Ce] || []).filter(function(it) {
                      return K.match(fe, it);
                    });
                    if (Oe.length !== 0) {
                      var Ae = ne.quill.getSelection();
                      if (!(Ae == null || !ne.quill.hasFocus())) {
                        var De = ne.quill.getLine(Ae.index), qe = a(De, 2), $t = qe[0], st = qe[1], se = ne.quill.getLeaf(Ae.index), ue = a(se, 2), ve = ue[0], ye = ue[1], he = Ae.length === 0 ? [ve, ye] : ne.quill.getLeaf(Ae.index + Ae.length), we = a(he, 2), Q = we[0], le = we[1], et = ve instanceof C.default.Text ? ve.value().slice(0, ye) : "", ot = Q instanceof C.default.Text ? Q.value().slice(le) : "", tt = {
                          collapsed: Ae.length === 0,
                          empty: Ae.length === 0 && $t.length() <= 1,
                          format: ne.quill.getFormat(Ae),
                          offset: st,
                          prefix: et,
                          suffix: ot
                        }, wn = Oe.some(function(it) {
                          if (it.collapsed != null && it.collapsed !== tt.collapsed || it.empty != null && it.empty !== tt.empty || it.offset != null && it.offset !== tt.offset)
                            return !1;
                          if (Array.isArray(it.format)) {
                            if (it.format.every(function(kt) {
                              return tt.format[kt] == null;
                            }))
                              return !1;
                          } else if (r(it.format) === "object" && !Object.keys(it.format).every(function(kt) {
                            return it.format[kt] === !0 ? tt.format[kt] != null : it.format[kt] === !1 ? tt.format[kt] == null : (0, f.default)(it.format[kt], tt.format[kt]);
                          }))
                            return !1;
                          return it.prefix != null && !it.prefix.test(tt.prefix) || it.suffix != null && !it.suffix.test(tt.suffix) ? !1 : it.handler.call(ne, Ae, tt) !== !0;
                        });
                        wn && fe.preventDefault();
                      }
                    }
                  }
                });
              }
            }]), K;
          }(A.default);
          W.keys = {
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            DELETE: 46
          }, W.DEFAULTS = {
            bindings: {
              bold: Z("bold"),
              italic: Z("italic"),
              underline: Z("underline"),
              indent: {
                // highlight tab or tab at beginning of list, indent or blockquote
                key: W.keys.TAB,
                format: ["blockquote", "indent", "list"],
                handler: function(K, te) {
                  if (te.collapsed && te.offset !== 0)
                    return !0;
                  this.quill.format("indent", "+1", x.default.sources.USER);
                }
              },
              outdent: {
                key: W.keys.TAB,
                shiftKey: !0,
                format: ["blockquote", "indent", "list"],
                // highlight tab or tab at beginning of list, indent or blockquote
                handler: function(K, te) {
                  if (te.collapsed && te.offset !== 0)
                    return !0;
                  this.quill.format("indent", "-1", x.default.sources.USER);
                }
              },
              "outdent backspace": {
                key: W.keys.BACKSPACE,
                collapsed: !0,
                shiftKey: null,
                metaKey: null,
                ctrlKey: null,
                altKey: null,
                format: ["indent", "list"],
                offset: 0,
                handler: function(K, te) {
                  te.format.indent != null ? this.quill.format("indent", "-1", x.default.sources.USER) : te.format.list != null && this.quill.format("list", !1, x.default.sources.USER);
                }
              },
              "indent code-block": q(!0),
              "outdent code-block": q(!1),
              "remove tab": {
                key: W.keys.TAB,
                shiftKey: !0,
                collapsed: !0,
                prefix: /\t$/,
                handler: function(K) {
                  this.quill.deleteText(K.index - 1, 1, x.default.sources.USER);
                }
              },
              tab: {
                key: W.keys.TAB,
                handler: function(K) {
                  this.quill.history.cutoff();
                  var te = new g.default().retain(K.index).delete(K.length).insert("	");
                  this.quill.updateContents(te, x.default.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(K.index + 1, x.default.sources.SILENT);
                }
              },
              "list empty enter": {
                key: W.keys.ENTER,
                collapsed: !0,
                format: ["list"],
                empty: !0,
                handler: function(K, te) {
                  this.quill.format("list", !1, x.default.sources.USER), te.format.indent && this.quill.format("indent", !1, x.default.sources.USER);
                }
              },
              "checklist enter": {
                key: W.keys.ENTER,
                collapsed: !0,
                format: { list: "checked" },
                handler: function(K) {
                  var te = this.quill.getLine(K.index), ne = a(te, 2), fe = ne[0], Ce = ne[1], Oe = (0, h.default)({}, fe.formats(), { list: "checked" }), Ae = new g.default().retain(K.index).insert(`
`, Oe).retain(fe.length() - Ce - 1).retain(1, { list: "unchecked" });
                  this.quill.updateContents(Ae, x.default.sources.USER), this.quill.setSelection(K.index + 1, x.default.sources.SILENT), this.quill.scrollIntoView();
                }
              },
              "header enter": {
                key: W.keys.ENTER,
                collapsed: !0,
                format: ["header"],
                suffix: /^$/,
                handler: function(K, te) {
                  var ne = this.quill.getLine(K.index), fe = a(ne, 2), Ce = fe[0], Oe = fe[1], Ae = new g.default().retain(K.index).insert(`
`, te.format).retain(Ce.length() - Oe - 1).retain(1, { header: null });
                  this.quill.updateContents(Ae, x.default.sources.USER), this.quill.setSelection(K.index + 1, x.default.sources.SILENT), this.quill.scrollIntoView();
                }
              },
              "list autofill": {
                key: " ",
                collapsed: !0,
                format: { list: !1 },
                prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                handler: function(K, te) {
                  var ne = te.prefix.length, fe = this.quill.getLine(K.index), Ce = a(fe, 2), Oe = Ce[0], Ae = Ce[1];
                  if (Ae > ne)
                    return !0;
                  var De = void 0;
                  switch (te.prefix.trim()) {
                    case "[]":
                    case "[ ]":
                      De = "unchecked";
                      break;
                    case "[x]":
                      De = "checked";
                      break;
                    case "-":
                    case "*":
                      De = "bullet";
                      break;
                    default:
                      De = "ordered";
                  }
                  this.quill.insertText(K.index, " ", x.default.sources.USER), this.quill.history.cutoff();
                  var qe = new g.default().retain(K.index - Ae).delete(ne + 1).retain(Oe.length() - 2 - Ae).retain(1, { list: De });
                  this.quill.updateContents(qe, x.default.sources.USER), this.quill.history.cutoff(), this.quill.setSelection(K.index - ne, x.default.sources.SILENT);
                }
              },
              "code exit": {
                key: W.keys.ENTER,
                collapsed: !0,
                format: ["code-block"],
                prefix: /\n\n$/,
                suffix: /^\s+$/,
                handler: function(K) {
                  var te = this.quill.getLine(K.index), ne = a(te, 2), fe = ne[0], Ce = ne[1], Oe = new g.default().retain(K.index + fe.length() - Ce - 2).retain(1, { "code-block": null }).delete(1);
                  this.quill.updateContents(Oe, x.default.sources.USER);
                }
              },
              "embed left": oe(W.keys.LEFT, !1),
              "embed left shift": oe(W.keys.LEFT, !0),
              "embed right": oe(W.keys.RIGHT, !1),
              "embed right shift": oe(W.keys.RIGHT, !0)
            }
          };
          function oe(R, K) {
            var te, ne = R === W.keys.LEFT ? "prefix" : "suffix";
            return te = {
              key: R,
              shiftKey: K,
              altKey: null
            }, k(te, ne, /^$/), k(te, "handler", function(Ce) {
              var Oe = Ce.index;
              R === W.keys.RIGHT && (Oe += Ce.length + 1);
              var Ae = this.quill.getLeaf(Oe), De = a(Ae, 1), qe = De[0];
              return qe instanceof C.default.Embed ? (R === W.keys.LEFT ? K ? this.quill.setSelection(Ce.index - 1, Ce.length + 1, x.default.sources.USER) : this.quill.setSelection(Ce.index - 1, x.default.sources.USER) : K ? this.quill.setSelection(Ce.index, Ce.length + 1, x.default.sources.USER) : this.quill.setSelection(Ce.index + Ce.length + 1, x.default.sources.USER), !1) : !0;
            }), te;
          }
          function H(R, K) {
            if (!(R.index === 0 || this.quill.getLength() <= 1)) {
              var te = this.quill.getLine(R.index), ne = a(te, 1), fe = ne[0], Ce = {};
              if (K.offset === 0) {
                var Oe = this.quill.getLine(R.index - 1), Ae = a(Oe, 1), De = Ae[0];
                if (De != null && De.length() > 1) {
                  var qe = fe.formats(), $t = this.quill.getFormat(R.index - 1, 1);
                  Ce = p.default.attributes.diff(qe, $t) || {};
                }
              }
              var st = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(K.prefix) ? 2 : 1;
              this.quill.deleteText(R.index - st, st, x.default.sources.USER), Object.keys(Ce).length > 0 && this.quill.formatLine(R.index - st, st, Ce, x.default.sources.USER), this.quill.focus();
            }
          }
          function B(R, K) {
            var te = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(K.suffix) ? 2 : 1;
            if (!(R.index >= this.quill.getLength() - te)) {
              var ne = {}, fe = 0, Ce = this.quill.getLine(R.index), Oe = a(Ce, 1), Ae = Oe[0];
              if (K.offset >= Ae.length() - 1) {
                var De = this.quill.getLine(R.index + 1), qe = a(De, 1), $t = qe[0];
                if ($t) {
                  var st = Ae.formats(), se = this.quill.getFormat(R.index, 1);
                  ne = p.default.attributes.diff(st, se) || {}, fe = $t.length();
                }
              }
              this.quill.deleteText(R.index, te, x.default.sources.USER), Object.keys(ne).length > 0 && this.quill.formatLine(R.index + fe - 1, te, ne, x.default.sources.USER);
            }
          }
          function D(R) {
            var K = this.quill.getLines(R), te = {};
            if (K.length > 1) {
              var ne = K[0].formats(), fe = K[K.length - 1].formats();
              te = p.default.attributes.diff(fe, ne) || {};
            }
            this.quill.deleteText(R, x.default.sources.USER), Object.keys(te).length > 0 && this.quill.formatLine(R.index, 1, te, x.default.sources.USER), this.quill.setSelection(R.index, x.default.sources.SILENT), this.quill.focus();
          }
          function V(R, K) {
            var te = this;
            R.length > 0 && this.quill.scroll.deleteAt(R.index, R.length);
            var ne = Object.keys(K.format).reduce(function(fe, Ce) {
              return C.default.query(Ce, C.default.Scope.BLOCK) && !Array.isArray(K.format[Ce]) && (fe[Ce] = K.format[Ce]), fe;
            }, {});
            this.quill.insertText(R.index, `
`, ne, x.default.sources.USER), this.quill.setSelection(R.index + 1, x.default.sources.SILENT), this.quill.focus(), Object.keys(K.format).forEach(function(fe) {
              ne[fe] == null && (Array.isArray(K.format[fe]) || fe !== "link" && te.quill.format(fe, K.format[fe], x.default.sources.USER));
            });
          }
          function q(R) {
            return {
              key: W.keys.TAB,
              shiftKey: !R,
              format: { "code-block": !0 },
              handler: function(te) {
                var ne = C.default.query("code-block"), fe = te.index, Ce = te.length, Oe = this.quill.scroll.descendant(ne, fe), Ae = a(Oe, 2), De = Ae[0], qe = Ae[1];
                if (De != null) {
                  var $t = this.quill.getIndex(De), st = De.newlineIndex(qe, !0) + 1, se = De.newlineIndex($t + qe + Ce), ue = De.domNode.textContent.slice(st, se).split(`
`);
                  qe = 0, ue.forEach(function(ve, ye) {
                    R ? (De.insertAt(st + qe, ne.TAB), qe += ne.TAB.length, ye === 0 ? fe += ne.TAB.length : Ce += ne.TAB.length) : ve.startsWith(ne.TAB) && (De.deleteAt(st + qe, ne.TAB.length), qe -= ne.TAB.length, ye === 0 ? fe -= ne.TAB.length : Ce -= ne.TAB.length), qe += ve.length + 1;
                  }), this.quill.update(x.default.sources.USER), this.quill.setSelection(fe, Ce, x.default.sources.SILENT);
                }
              }
            };
          }
          function Z(R) {
            return {
              key: R[0].toUpperCase(),
              shortKey: !0,
              handler: function(te, ne) {
                this.quill.format(R, !ne.format[R], x.default.sources.USER);
              }
            };
          }
          function Y(R) {
            if (typeof R == "string" || typeof R == "number")
              return Y({ key: R });
            if ((typeof R > "u" ? "undefined" : r(R)) === "object" && (R = (0, u.default)(R, !1)), typeof R.key == "string")
              if (W.keys[R.key.toUpperCase()] != null)
                R.key = W.keys[R.key.toUpperCase()];
              else if (R.key.length === 1)
                R.key = R.key.toUpperCase().charCodeAt(0);
              else
                return null;
            return R.shortKey && (R[U] = R.shortKey, delete R.shortKey), R;
          }
          o.default = W, o.SHORTKEY = U;
        },
        /* 24 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function p(y, C) {
              var b = [], x = !0, w = !1, $ = void 0;
              try {
                for (var E = y[Symbol.iterator](), A; !(x = (A = E.next()).done) && (b.push(A.value), !(C && b.length === C)); x = !0)
                  ;
              } catch (O) {
                w = !0, $ = O;
              } finally {
                try {
                  !x && E.return && E.return();
                } finally {
                  if (w)
                    throw $;
                }
              }
              return b;
            }
            return function(y, C) {
              if (Array.isArray(y))
                return y;
              if (Symbol.iterator in Object(y))
                return p(y, C);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), a = function p(y, C, b) {
            y === null && (y = Function.prototype);
            var x = Object.getOwnPropertyDescriptor(y, C);
            if (x === void 0) {
              var w = Object.getPrototypeOf(y);
              return w === null ? void 0 : p(w, C, b);
            } else {
              if ("value" in x)
                return x.value;
              var $ = x.get;
              return $ === void 0 ? void 0 : $.call(b);
            }
          }, l = function() {
            function p(y, C) {
              for (var b = 0; b < C.length; b++) {
                var x = C[b];
                x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(y, x.key, x);
              }
            }
            return function(y, C, b) {
              return C && p(y.prototype, C), b && p(y, b), y;
            };
          }(), s = i(0), u = c(s), d = i(7), f = c(d);
          function c(p) {
            return p && p.__esModule ? p : { default: p };
          }
          function h(p, y) {
            if (!(p instanceof y))
              throw new TypeError("Cannot call a class as a function");
          }
          function m(p, y) {
            if (!p)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y && (typeof y == "object" || typeof y == "function") ? y : p;
          }
          function g(p, y) {
            if (typeof y != "function" && y !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof y);
            p.prototype = Object.create(y && y.prototype, { constructor: { value: p, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(p, y) : p.__proto__ = y);
          }
          var v = function(p) {
            g(y, p), l(y, null, [{
              key: "value",
              value: function() {
              }
            }]);
            function y(C, b) {
              h(this, y);
              var x = m(this, (y.__proto__ || Object.getPrototypeOf(y)).call(this, C));
              return x.selection = b, x.textNode = document.createTextNode(y.CONTENTS), x.domNode.appendChild(x.textNode), x._length = 0, x;
            }
            return l(y, [{
              key: "detach",
              value: function() {
                this.parent != null && this.parent.removeChild(this);
              }
            }, {
              key: "format",
              value: function(b, x) {
                if (this._length !== 0)
                  return a(y.prototype.__proto__ || Object.getPrototypeOf(y.prototype), "format", this).call(this, b, x);
                for (var w = this, $ = 0; w != null && w.statics.scope !== u.default.Scope.BLOCK_BLOT; )
                  $ += w.offset(w.parent), w = w.parent;
                w != null && (this._length = y.CONTENTS.length, w.optimize(), w.formatAt($, y.CONTENTS.length, b, x), this._length = 0);
              }
            }, {
              key: "index",
              value: function(b, x) {
                return b === this.textNode ? 0 : a(y.prototype.__proto__ || Object.getPrototypeOf(y.prototype), "index", this).call(this, b, x);
              }
            }, {
              key: "length",
              value: function() {
                return this._length;
              }
            }, {
              key: "position",
              value: function() {
                return [this.textNode, this.textNode.data.length];
              }
            }, {
              key: "remove",
              value: function() {
                a(y.prototype.__proto__ || Object.getPrototypeOf(y.prototype), "remove", this).call(this), this.parent = null;
              }
            }, {
              key: "restore",
              value: function() {
                if (!(this.selection.composing || this.parent == null)) {
                  var b = this.textNode, x = this.selection.getNativeRange(), w = void 0, $ = void 0, E = void 0;
                  if (x != null && x.start.node === b && x.end.node === b) {
                    var A = [b, x.start.offset, x.end.offset];
                    w = A[0], $ = A[1], E = A[2];
                  }
                  for (; this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode; )
                    this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                  if (this.textNode.data !== y.CONTENTS) {
                    var O = this.textNode.data.split(y.CONTENTS).join("");
                    this.next instanceof f.default ? (w = this.next.domNode, this.next.insertAt(0, O), this.textNode.data = y.CONTENTS) : (this.textNode.data = O, this.parent.insertBefore(u.default.create(this.textNode), this), this.textNode = document.createTextNode(y.CONTENTS), this.domNode.appendChild(this.textNode));
                  }
                  if (this.remove(), $ != null) {
                    var k = [$, E].map(function(T) {
                      return Math.max(0, Math.min(w.data.length, T - 1));
                    }), S = r(k, 2);
                    return $ = S[0], E = S[1], {
                      startNode: w,
                      startOffset: $,
                      endNode: w,
                      endOffset: E
                    };
                  }
                }
              }
            }, {
              key: "update",
              value: function(b, x) {
                var w = this;
                if (b.some(function(E) {
                  return E.type === "characterData" && E.target === w.textNode;
                })) {
                  var $ = this.restore();
                  $ && (x.range = $);
                }
              }
            }, {
              key: "value",
              value: function() {
                return "";
              }
            }]), y;
          }(u.default.Embed);
          v.blotName = "cursor", v.className = "ql-cursor", v.tagName = "span", v.CONTENTS = "\uFEFF", o.default = v;
        },
        /* 25 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(0), a = u(r), l = i(4), s = u(l);
          function u(m) {
            return m && m.__esModule ? m : { default: m };
          }
          function d(m, g) {
            if (!(m instanceof g))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(m, g) {
            if (!m)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return g && (typeof g == "object" || typeof g == "function") ? g : m;
          }
          function c(m, g) {
            if (typeof g != "function" && g !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof g);
            m.prototype = Object.create(g && g.prototype, { constructor: { value: m, enumerable: !1, writable: !0, configurable: !0 } }), g && (Object.setPrototypeOf ? Object.setPrototypeOf(m, g) : m.__proto__ = g);
          }
          var h = function(m) {
            c(g, m);
            function g() {
              return d(this, g), f(this, (g.__proto__ || Object.getPrototypeOf(g)).apply(this, arguments));
            }
            return g;
          }(a.default.Container);
          h.allowedChildren = [s.default, l.BlockEmbed, h], o.default = h;
        },
        /* 26 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.ColorStyle = o.ColorClass = o.ColorAttributor = void 0;
          var r = function() {
            function v(p, y) {
              for (var C = 0; C < y.length; C++) {
                var b = y[C];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(p, b.key, b);
              }
            }
            return function(p, y, C) {
              return y && v(p.prototype, y), C && v(p, C), p;
            };
          }(), a = function v(p, y, C) {
            p === null && (p = Function.prototype);
            var b = Object.getOwnPropertyDescriptor(p, y);
            if (b === void 0) {
              var x = Object.getPrototypeOf(p);
              return x === null ? void 0 : v(x, y, C);
            } else {
              if ("value" in b)
                return b.value;
              var w = b.get;
              return w === void 0 ? void 0 : w.call(C);
            }
          }, l = i(0), s = u(l);
          function u(v) {
            return v && v.__esModule ? v : { default: v };
          }
          function d(v, p) {
            if (!(v instanceof p))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(v, p) {
            if (!v)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return p && (typeof p == "object" || typeof p == "function") ? p : v;
          }
          function c(v, p) {
            if (typeof p != "function" && p !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof p);
            v.prototype = Object.create(p && p.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }), p && (Object.setPrototypeOf ? Object.setPrototypeOf(v, p) : v.__proto__ = p);
          }
          var h = function(v) {
            c(p, v);
            function p() {
              return d(this, p), f(this, (p.__proto__ || Object.getPrototypeOf(p)).apply(this, arguments));
            }
            return r(p, [{
              key: "value",
              value: function(C) {
                var b = a(p.prototype.__proto__ || Object.getPrototypeOf(p.prototype), "value", this).call(this, C);
                return b.startsWith("rgb(") ? (b = b.replace(/^[^\d]+/, "").replace(/[^\d]+$/, ""), "#" + b.split(",").map(function(x) {
                  return ("00" + parseInt(x).toString(16)).slice(-2);
                }).join("")) : b;
              }
            }]), p;
          }(s.default.Attributor.Style), m = new s.default.Attributor.Class("color", "ql-color", {
            scope: s.default.Scope.INLINE
          }), g = new h("color", "color", {
            scope: s.default.Scope.INLINE
          });
          o.ColorAttributor = h, o.ColorClass = m, o.ColorStyle = g;
        },
        /* 27 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.sanitize = o.default = void 0;
          var r = function() {
            function g(v, p) {
              for (var y = 0; y < p.length; y++) {
                var C = p[y];
                C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(v, C.key, C);
              }
            }
            return function(v, p, y) {
              return p && g(v.prototype, p), y && g(v, y), v;
            };
          }(), a = function g(v, p, y) {
            v === null && (v = Function.prototype);
            var C = Object.getOwnPropertyDescriptor(v, p);
            if (C === void 0) {
              var b = Object.getPrototypeOf(v);
              return b === null ? void 0 : g(b, p, y);
            } else {
              if ("value" in C)
                return C.value;
              var x = C.get;
              return x === void 0 ? void 0 : x.call(y);
            }
          }, l = i(6), s = u(l);
          function u(g) {
            return g && g.__esModule ? g : { default: g };
          }
          function d(g, v) {
            if (!(g instanceof v))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(g, v) {
            if (!g)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return v && (typeof v == "object" || typeof v == "function") ? v : g;
          }
          function c(g, v) {
            if (typeof v != "function" && v !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof v);
            g.prototype = Object.create(v && v.prototype, { constructor: { value: g, enumerable: !1, writable: !0, configurable: !0 } }), v && (Object.setPrototypeOf ? Object.setPrototypeOf(g, v) : g.__proto__ = v);
          }
          var h = function(g) {
            c(v, g);
            function v() {
              return d(this, v), f(this, (v.__proto__ || Object.getPrototypeOf(v)).apply(this, arguments));
            }
            return r(v, [{
              key: "format",
              value: function(y, C) {
                if (y !== this.statics.blotName || !C)
                  return a(v.prototype.__proto__ || Object.getPrototypeOf(v.prototype), "format", this).call(this, y, C);
                C = this.constructor.sanitize(C), this.domNode.setAttribute("href", C);
              }
            }], [{
              key: "create",
              value: function(y) {
                var C = a(v.__proto__ || Object.getPrototypeOf(v), "create", this).call(this, y);
                return y = this.sanitize(y), C.setAttribute("href", y), C.setAttribute("rel", "noopener noreferrer"), C.setAttribute("target", "_blank"), C;
              }
            }, {
              key: "formats",
              value: function(y) {
                return y.getAttribute("href");
              }
            }, {
              key: "sanitize",
              value: function(y) {
                return m(y, this.PROTOCOL_WHITELIST) ? y : this.SANITIZED_URL;
              }
            }]), v;
          }(s.default);
          h.blotName = "link", h.tagName = "A", h.SANITIZED_URL = "about:blank", h.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"];
          function m(g, v) {
            var p = document.createElement("a");
            p.href = g;
            var y = p.href.slice(0, p.href.indexOf(":"));
            return v.indexOf(y) > -1;
          }
          o.default = h, o.sanitize = m;
        },
        /* 28 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
            return typeof v;
          } : function(v) {
            return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
          }, a = function() {
            function v(p, y) {
              for (var C = 0; C < y.length; C++) {
                var b = y[C];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(p, b.key, b);
              }
            }
            return function(p, y, C) {
              return y && v(p.prototype, y), C && v(p, C), p;
            };
          }(), l = i(23), s = f(l), u = i(107), d = f(u);
          function f(v) {
            return v && v.__esModule ? v : { default: v };
          }
          function c(v, p) {
            if (!(v instanceof p))
              throw new TypeError("Cannot call a class as a function");
          }
          var h = 0;
          function m(v, p) {
            v.setAttribute(p, v.getAttribute(p) !== "true");
          }
          var g = function() {
            function v(p) {
              var y = this;
              c(this, v), this.select = p, this.container = document.createElement("span"), this.buildPicker(), this.select.style.display = "none", this.select.parentNode.insertBefore(this.container, this.select), this.label.addEventListener("mousedown", function() {
                y.togglePicker();
              }), this.label.addEventListener("keydown", function(C) {
                switch (C.keyCode) {
                  case s.default.keys.ENTER:
                    y.togglePicker();
                    break;
                  case s.default.keys.ESCAPE:
                    y.escape(), C.preventDefault();
                    break;
                }
              }), this.select.addEventListener("change", this.update.bind(this));
            }
            return a(v, [{
              key: "togglePicker",
              value: function() {
                this.container.classList.toggle("ql-expanded"), m(this.label, "aria-expanded"), m(this.options, "aria-hidden");
              }
            }, {
              key: "buildItem",
              value: function(y) {
                var C = this, b = document.createElement("span");
                return b.tabIndex = "0", b.setAttribute("role", "button"), b.classList.add("ql-picker-item"), y.hasAttribute("value") && b.setAttribute("data-value", y.getAttribute("value")), y.textContent && b.setAttribute("data-label", y.textContent), b.addEventListener("click", function() {
                  C.selectItem(b, !0);
                }), b.addEventListener("keydown", function(x) {
                  switch (x.keyCode) {
                    case s.default.keys.ENTER:
                      C.selectItem(b, !0), x.preventDefault();
                      break;
                    case s.default.keys.ESCAPE:
                      C.escape(), x.preventDefault();
                      break;
                  }
                }), b;
              }
            }, {
              key: "buildLabel",
              value: function() {
                var y = document.createElement("span");
                return y.classList.add("ql-picker-label"), y.innerHTML = d.default, y.tabIndex = "0", y.setAttribute("role", "button"), y.setAttribute("aria-expanded", "false"), this.container.appendChild(y), y;
              }
            }, {
              key: "buildOptions",
              value: function() {
                var y = this, C = document.createElement("span");
                C.classList.add("ql-picker-options"), C.setAttribute("aria-hidden", "true"), C.tabIndex = "-1", C.id = "ql-picker-options-" + h, h += 1, this.label.setAttribute("aria-controls", C.id), this.options = C, [].slice.call(this.select.options).forEach(function(b) {
                  var x = y.buildItem(b);
                  C.appendChild(x), b.selected === !0 && y.selectItem(x);
                }), this.container.appendChild(C);
              }
            }, {
              key: "buildPicker",
              value: function() {
                var y = this;
                [].slice.call(this.select.attributes).forEach(function(C) {
                  y.container.setAttribute(C.name, C.value);
                }), this.container.classList.add("ql-picker"), this.label = this.buildLabel(), this.buildOptions();
              }
            }, {
              key: "escape",
              value: function() {
                var y = this;
                this.close(), setTimeout(function() {
                  return y.label.focus();
                }, 1);
              }
            }, {
              key: "close",
              value: function() {
                this.container.classList.remove("ql-expanded"), this.label.setAttribute("aria-expanded", "false"), this.options.setAttribute("aria-hidden", "true");
              }
            }, {
              key: "selectItem",
              value: function(y) {
                var C = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, b = this.container.querySelector(".ql-selected");
                if (y !== b && (b != null && b.classList.remove("ql-selected"), y != null && (y.classList.add("ql-selected"), this.select.selectedIndex = [].indexOf.call(y.parentNode.children, y), y.hasAttribute("data-value") ? this.label.setAttribute("data-value", y.getAttribute("data-value")) : this.label.removeAttribute("data-value"), y.hasAttribute("data-label") ? this.label.setAttribute("data-label", y.getAttribute("data-label")) : this.label.removeAttribute("data-label"), C))) {
                  if (typeof Event == "function")
                    this.select.dispatchEvent(new Event("change"));
                  else if ((typeof Event > "u" ? "undefined" : r(Event)) === "object") {
                    var x = document.createEvent("Event");
                    x.initEvent("change", !0, !0), this.select.dispatchEvent(x);
                  }
                  this.close();
                }
              }
            }, {
              key: "update",
              value: function() {
                var y = void 0;
                if (this.select.selectedIndex > -1) {
                  var C = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
                  y = this.select.options[this.select.selectedIndex], this.selectItem(C);
                } else
                  this.selectItem(null);
                var b = y != null && y !== this.select.querySelector("option[selected]");
                this.label.classList.toggle("ql-active", b);
              }
            }]), v;
          }();
          o.default = g;
        },
        /* 29 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(0), a = F(r), l = i(5), s = F(l), u = i(4), d = F(u), f = i(16), c = F(f), h = i(25), m = F(h), g = i(24), v = F(g), p = i(35), y = F(p), C = i(6), b = F(C), x = i(22), w = F(x), $ = i(7), E = F($), A = i(55), O = F(A), k = i(42), S = F(k), T = i(23), L = F(T);
          function F(U) {
            return U && U.__esModule ? U : { default: U };
          }
          s.default.register({
            "blots/block": d.default,
            "blots/block/embed": u.BlockEmbed,
            "blots/break": c.default,
            "blots/container": m.default,
            "blots/cursor": v.default,
            "blots/embed": y.default,
            "blots/inline": b.default,
            "blots/scroll": w.default,
            "blots/text": E.default,
            "modules/clipboard": O.default,
            "modules/history": S.default,
            "modules/keyboard": L.default
          }), a.default.register(d.default, c.default, v.default, b.default, w.default, E.default), o.default = s.default;
        },
        /* 30 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var r = i(1), a = (
            /** @class */
            function() {
              function l(s) {
                this.domNode = s, this.domNode[r.DATA_KEY] = { blot: this };
              }
              return Object.defineProperty(l.prototype, "statics", {
                // Hack for accessing inherited static methods
                get: function() {
                  return this.constructor;
                },
                enumerable: !0,
                configurable: !0
              }), l.create = function(s) {
                if (this.tagName == null)
                  throw new r.ParchmentError("Blot definition missing tagName");
                var u;
                return Array.isArray(this.tagName) ? (typeof s == "string" && (s = s.toUpperCase(), parseInt(s).toString() === s && (s = parseInt(s))), typeof s == "number" ? u = document.createElement(this.tagName[s - 1]) : this.tagName.indexOf(s) > -1 ? u = document.createElement(s) : u = document.createElement(this.tagName[0])) : u = document.createElement(this.tagName), this.className && u.classList.add(this.className), u;
              }, l.prototype.attach = function() {
                this.parent != null && (this.scroll = this.parent.scroll);
              }, l.prototype.clone = function() {
                var s = this.domNode.cloneNode(!1);
                return r.create(s);
              }, l.prototype.detach = function() {
                this.parent != null && this.parent.removeChild(this), delete this.domNode[r.DATA_KEY];
              }, l.prototype.deleteAt = function(s, u) {
                var d = this.isolate(s, u);
                d.remove();
              }, l.prototype.formatAt = function(s, u, d, f) {
                var c = this.isolate(s, u);
                if (r.query(d, r.Scope.BLOT) != null && f)
                  c.wrap(d, f);
                else if (r.query(d, r.Scope.ATTRIBUTE) != null) {
                  var h = r.create(this.statics.scope);
                  c.wrap(h), h.format(d, f);
                }
              }, l.prototype.insertAt = function(s, u, d) {
                var f = d == null ? r.create("text", u) : r.create(u, d), c = this.split(s);
                this.parent.insertBefore(f, c);
              }, l.prototype.insertInto = function(s, u) {
                u === void 0 && (u = null), this.parent != null && this.parent.children.remove(this);
                var d = null;
                s.children.insertBefore(this, u), u != null && (d = u.domNode), (this.domNode.parentNode != s.domNode || this.domNode.nextSibling != d) && s.domNode.insertBefore(this.domNode, d), this.parent = s, this.attach();
              }, l.prototype.isolate = function(s, u) {
                var d = this.split(s);
                return d.split(u), d;
              }, l.prototype.length = function() {
                return 1;
              }, l.prototype.offset = function(s) {
                return s === void 0 && (s = this.parent), this.parent == null || this == s ? 0 : this.parent.children.offset(this) + this.parent.offset(s);
              }, l.prototype.optimize = function(s) {
                this.domNode[r.DATA_KEY] != null && delete this.domNode[r.DATA_KEY].mutations;
              }, l.prototype.remove = function() {
                this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
              }, l.prototype.replace = function(s) {
                s.parent != null && (s.parent.insertBefore(this, s.next), s.remove());
              }, l.prototype.replaceWith = function(s, u) {
                var d = typeof s == "string" ? r.create(s, u) : s;
                return d.replace(this), d;
              }, l.prototype.split = function(s, u) {
                return s === 0 ? this : this.next;
              }, l.prototype.update = function(s, u) {
              }, l.prototype.wrap = function(s, u) {
                var d = typeof s == "string" ? r.create(s, u) : s;
                return this.parent != null && this.parent.insertBefore(d, this.next), d.appendChild(this), d;
              }, l.blotName = "abstract", l;
            }()
          );
          o.default = a;
        },
        /* 31 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var r = i(12), a = i(32), l = i(33), s = i(1), u = (
            /** @class */
            function() {
              function d(f) {
                this.attributes = {}, this.domNode = f, this.build();
              }
              return d.prototype.attribute = function(f, c) {
                c ? f.add(this.domNode, c) && (f.value(this.domNode) != null ? this.attributes[f.attrName] = f : delete this.attributes[f.attrName]) : (f.remove(this.domNode), delete this.attributes[f.attrName]);
              }, d.prototype.build = function() {
                var f = this;
                this.attributes = {};
                var c = r.default.keys(this.domNode), h = a.default.keys(this.domNode), m = l.default.keys(this.domNode);
                c.concat(h).concat(m).forEach(function(g) {
                  var v = s.query(g, s.Scope.ATTRIBUTE);
                  v instanceof r.default && (f.attributes[v.attrName] = v);
                });
              }, d.prototype.copy = function(f) {
                var c = this;
                Object.keys(this.attributes).forEach(function(h) {
                  var m = c.attributes[h].value(c.domNode);
                  f.format(h, m);
                });
              }, d.prototype.move = function(f) {
                var c = this;
                this.copy(f), Object.keys(this.attributes).forEach(function(h) {
                  c.attributes[h].remove(c.domNode);
                }), this.attributes = {};
              }, d.prototype.values = function() {
                var f = this;
                return Object.keys(this.attributes).reduce(function(c, h) {
                  return c[h] = f.attributes[h].value(f.domNode), c;
                }, {});
              }, d;
            }()
          );
          o.default = u;
        },
        /* 32 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
              d.__proto__ = f;
            } || function(d, f) {
              for (var c in f)
                f.hasOwnProperty(c) && (d[c] = f[c]);
            };
            return function(d, f) {
              u(d, f);
              function c() {
                this.constructor = d;
              }
              d.prototype = f === null ? Object.create(f) : (c.prototype = f.prototype, new c());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(12);
          function l(u, d) {
            var f = u.getAttribute("class") || "";
            return f.split(/\s+/).filter(function(c) {
              return c.indexOf(d + "-") === 0;
            });
          }
          var s = (
            /** @class */
            function(u) {
              r(d, u);
              function d() {
                return u !== null && u.apply(this, arguments) || this;
              }
              return d.keys = function(f) {
                return (f.getAttribute("class") || "").split(/\s+/).map(function(c) {
                  return c.split("-").slice(0, -1).join("-");
                });
              }, d.prototype.add = function(f, c) {
                return this.canAdd(f, c) ? (this.remove(f), f.classList.add(this.keyName + "-" + c), !0) : !1;
              }, d.prototype.remove = function(f) {
                var c = l(f, this.keyName);
                c.forEach(function(h) {
                  f.classList.remove(h);
                }), f.classList.length === 0 && f.removeAttribute("class");
              }, d.prototype.value = function(f) {
                var c = l(f, this.keyName)[0] || "", h = c.slice(this.keyName.length + 1);
                return this.canAdd(f, h) ? h : "";
              }, d;
            }(a.default)
          );
          o.default = s;
        },
        /* 33 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
              d.__proto__ = f;
            } || function(d, f) {
              for (var c in f)
                f.hasOwnProperty(c) && (d[c] = f[c]);
            };
            return function(d, f) {
              u(d, f);
              function c() {
                this.constructor = d;
              }
              d.prototype = f === null ? Object.create(f) : (c.prototype = f.prototype, new c());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(12);
          function l(u) {
            var d = u.split("-"), f = d.slice(1).map(function(c) {
              return c[0].toUpperCase() + c.slice(1);
            }).join("");
            return d[0] + f;
          }
          var s = (
            /** @class */
            function(u) {
              r(d, u);
              function d() {
                return u !== null && u.apply(this, arguments) || this;
              }
              return d.keys = function(f) {
                return (f.getAttribute("style") || "").split(";").map(function(c) {
                  var h = c.split(":");
                  return h[0].trim();
                });
              }, d.prototype.add = function(f, c) {
                return this.canAdd(f, c) ? (f.style[l(this.keyName)] = c, !0) : !1;
              }, d.prototype.remove = function(f) {
                f.style[l(this.keyName)] = "", f.getAttribute("style") || f.removeAttribute("style");
              }, d.prototype.value = function(f) {
                var c = f.style[l(this.keyName)];
                return this.canAdd(f, c) ? c : "";
              }, d;
            }(a.default)
          );
          o.default = s;
        },
        /* 34 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function s(u, d) {
              for (var f = 0; f < d.length; f++) {
                var c = d[f];
                c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(u, c.key, c);
              }
            }
            return function(u, d, f) {
              return d && s(u.prototype, d), f && s(u, f), u;
            };
          }();
          function a(s, u) {
            if (!(s instanceof u))
              throw new TypeError("Cannot call a class as a function");
          }
          var l = function() {
            function s(u, d) {
              a(this, s), this.quill = u, this.options = d, this.modules = {};
            }
            return r(s, [{
              key: "init",
              value: function() {
                var d = this;
                Object.keys(this.options.modules).forEach(function(f) {
                  d.modules[f] == null && d.addModule(f);
                });
              }
            }, {
              key: "addModule",
              value: function(d) {
                var f = this.quill.constructor.import("modules/" + d);
                return this.modules[d] = new f(this.quill, this.options.modules[d] || {}), this.modules[d];
              }
            }]), s;
          }();
          l.DEFAULTS = {
            modules: {}
          }, l.themes = {
            default: l
          }, o.default = l;
        },
        /* 35 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function p(y, C) {
              for (var b = 0; b < C.length; b++) {
                var x = C[b];
                x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(y, x.key, x);
              }
            }
            return function(y, C, b) {
              return C && p(y.prototype, C), b && p(y, b), y;
            };
          }(), a = function p(y, C, b) {
            y === null && (y = Function.prototype);
            var x = Object.getOwnPropertyDescriptor(y, C);
            if (x === void 0) {
              var w = Object.getPrototypeOf(y);
              return w === null ? void 0 : p(w, C, b);
            } else {
              if ("value" in x)
                return x.value;
              var $ = x.get;
              return $ === void 0 ? void 0 : $.call(b);
            }
          }, l = i(0), s = f(l), u = i(7), d = f(u);
          function f(p) {
            return p && p.__esModule ? p : { default: p };
          }
          function c(p, y) {
            if (!(p instanceof y))
              throw new TypeError("Cannot call a class as a function");
          }
          function h(p, y) {
            if (!p)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y && (typeof y == "object" || typeof y == "function") ? y : p;
          }
          function m(p, y) {
            if (typeof y != "function" && y !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof y);
            p.prototype = Object.create(y && y.prototype, { constructor: { value: p, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(p, y) : p.__proto__ = y);
          }
          var g = "\uFEFF", v = function(p) {
            m(y, p);
            function y(C) {
              c(this, y);
              var b = h(this, (y.__proto__ || Object.getPrototypeOf(y)).call(this, C));
              return b.contentNode = document.createElement("span"), b.contentNode.setAttribute("contenteditable", !1), [].slice.call(b.domNode.childNodes).forEach(function(x) {
                b.contentNode.appendChild(x);
              }), b.leftGuard = document.createTextNode(g), b.rightGuard = document.createTextNode(g), b.domNode.appendChild(b.leftGuard), b.domNode.appendChild(b.contentNode), b.domNode.appendChild(b.rightGuard), b;
            }
            return r(y, [{
              key: "index",
              value: function(b, x) {
                return b === this.leftGuard ? 0 : b === this.rightGuard ? 1 : a(y.prototype.__proto__ || Object.getPrototypeOf(y.prototype), "index", this).call(this, b, x);
              }
            }, {
              key: "restore",
              value: function(b) {
                var x = void 0, w = void 0, $ = b.data.split(g).join("");
                if (b === this.leftGuard)
                  if (this.prev instanceof d.default) {
                    var E = this.prev.length();
                    this.prev.insertAt(E, $), x = {
                      startNode: this.prev.domNode,
                      startOffset: E + $.length
                    };
                  } else
                    w = document.createTextNode($), this.parent.insertBefore(s.default.create(w), this), x = {
                      startNode: w,
                      startOffset: $.length
                    };
                else
                  b === this.rightGuard && (this.next instanceof d.default ? (this.next.insertAt(0, $), x = {
                    startNode: this.next.domNode,
                    startOffset: $.length
                  }) : (w = document.createTextNode($), this.parent.insertBefore(s.default.create(w), this.next), x = {
                    startNode: w,
                    startOffset: $.length
                  }));
                return b.data = g, x;
              }
            }, {
              key: "update",
              value: function(b, x) {
                var w = this;
                b.forEach(function($) {
                  if ($.type === "characterData" && ($.target === w.leftGuard || $.target === w.rightGuard)) {
                    var E = w.restore($.target);
                    E && (x.range = E);
                  }
                });
              }
            }]), y;
          }(s.default.Embed);
          o.default = v;
        },
        /* 36 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.AlignStyle = o.AlignClass = o.AlignAttribute = void 0;
          var r = i(0), a = l(r);
          function l(c) {
            return c && c.__esModule ? c : { default: c };
          }
          var s = {
            scope: a.default.Scope.BLOCK,
            whitelist: ["right", "center", "justify"]
          }, u = new a.default.Attributor.Attribute("align", "align", s), d = new a.default.Attributor.Class("align", "ql-align", s), f = new a.default.Attributor.Style("align", "text-align", s);
          o.AlignAttribute = u, o.AlignClass = d, o.AlignStyle = f;
        },
        /* 37 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.BackgroundStyle = o.BackgroundClass = void 0;
          var r = i(0), a = s(r), l = i(26);
          function s(f) {
            return f && f.__esModule ? f : { default: f };
          }
          var u = new a.default.Attributor.Class("background", "ql-bg", {
            scope: a.default.Scope.INLINE
          }), d = new l.ColorAttributor("background", "background-color", {
            scope: a.default.Scope.INLINE
          });
          o.BackgroundClass = u, o.BackgroundStyle = d;
        },
        /* 38 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.DirectionStyle = o.DirectionClass = o.DirectionAttribute = void 0;
          var r = i(0), a = l(r);
          function l(c) {
            return c && c.__esModule ? c : { default: c };
          }
          var s = {
            scope: a.default.Scope.BLOCK,
            whitelist: ["rtl"]
          }, u = new a.default.Attributor.Attribute("direction", "dir", s), d = new a.default.Attributor.Class("direction", "ql-direction", s), f = new a.default.Attributor.Style("direction", "direction", s);
          o.DirectionAttribute = u, o.DirectionClass = d, o.DirectionStyle = f;
        },
        /* 39 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.FontClass = o.FontStyle = void 0;
          var r = function() {
            function p(y, C) {
              for (var b = 0; b < C.length; b++) {
                var x = C[b];
                x.enumerable = x.enumerable || !1, x.configurable = !0, "value" in x && (x.writable = !0), Object.defineProperty(y, x.key, x);
              }
            }
            return function(y, C, b) {
              return C && p(y.prototype, C), b && p(y, b), y;
            };
          }(), a = function p(y, C, b) {
            y === null && (y = Function.prototype);
            var x = Object.getOwnPropertyDescriptor(y, C);
            if (x === void 0) {
              var w = Object.getPrototypeOf(y);
              return w === null ? void 0 : p(w, C, b);
            } else {
              if ("value" in x)
                return x.value;
              var $ = x.get;
              return $ === void 0 ? void 0 : $.call(b);
            }
          }, l = i(0), s = u(l);
          function u(p) {
            return p && p.__esModule ? p : { default: p };
          }
          function d(p, y) {
            if (!(p instanceof y))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(p, y) {
            if (!p)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return y && (typeof y == "object" || typeof y == "function") ? y : p;
          }
          function c(p, y) {
            if (typeof y != "function" && y !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof y);
            p.prototype = Object.create(y && y.prototype, { constructor: { value: p, enumerable: !1, writable: !0, configurable: !0 } }), y && (Object.setPrototypeOf ? Object.setPrototypeOf(p, y) : p.__proto__ = y);
          }
          var h = {
            scope: s.default.Scope.INLINE,
            whitelist: ["serif", "monospace"]
          }, m = new s.default.Attributor.Class("font", "ql-font", h), g = function(p) {
            c(y, p);
            function y() {
              return d(this, y), f(this, (y.__proto__ || Object.getPrototypeOf(y)).apply(this, arguments));
            }
            return r(y, [{
              key: "value",
              value: function(b) {
                return a(y.prototype.__proto__ || Object.getPrototypeOf(y.prototype), "value", this).call(this, b).replace(/["']/g, "");
              }
            }]), y;
          }(s.default.Attributor.Style), v = new g("font", "font-family", h);
          o.FontStyle = v, o.FontClass = m;
        },
        /* 40 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.SizeStyle = o.SizeClass = void 0;
          var r = i(0), a = l(r);
          function l(d) {
            return d && d.__esModule ? d : { default: d };
          }
          var s = new a.default.Attributor.Class("size", "ql-size", {
            scope: a.default.Scope.INLINE,
            whitelist: ["small", "large", "huge"]
          }), u = new a.default.Attributor.Style("size", "font-size", {
            scope: a.default.Scope.INLINE,
            whitelist: ["10px", "18px", "32px"]
          });
          o.SizeClass = s, o.SizeStyle = u;
        },
        /* 41 */
        /***/
        function(t, o, i) {
          t.exports = {
            align: {
              "": i(76),
              center: i(77),
              right: i(78),
              justify: i(79)
            },
            background: i(80),
            blockquote: i(81),
            bold: i(82),
            clean: i(83),
            code: i(58),
            "code-block": i(58),
            color: i(84),
            direction: {
              "": i(85),
              rtl: i(86)
            },
            float: {
              center: i(87),
              full: i(88),
              left: i(89),
              right: i(90)
            },
            formula: i(91),
            header: {
              1: i(92),
              2: i(93)
            },
            italic: i(94),
            image: i(95),
            indent: {
              "+1": i(96),
              "-1": i(97)
            },
            link: i(98),
            list: {
              ordered: i(99),
              bullet: i(100),
              check: i(101)
            },
            script: {
              sub: i(102),
              super: i(103)
            },
            strike: i(104),
            underline: i(105),
            video: i(106)
          };
        },
        /* 42 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.getLastChangeIndex = o.default = void 0;
          var r = function() {
            function C(b, x) {
              for (var w = 0; w < x.length; w++) {
                var $ = x[w];
                $.enumerable = $.enumerable || !1, $.configurable = !0, "value" in $ && ($.writable = !0), Object.defineProperty(b, $.key, $);
              }
            }
            return function(b, x, w) {
              return x && C(b.prototype, x), w && C(b, w), b;
            };
          }(), a = i(0), l = c(a), s = i(5), u = c(s), d = i(9), f = c(d);
          function c(C) {
            return C && C.__esModule ? C : { default: C };
          }
          function h(C, b) {
            if (!(C instanceof b))
              throw new TypeError("Cannot call a class as a function");
          }
          function m(C, b) {
            if (!C)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b && (typeof b == "object" || typeof b == "function") ? b : C;
          }
          function g(C, b) {
            if (typeof b != "function" && b !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof b);
            C.prototype = Object.create(b && b.prototype, { constructor: { value: C, enumerable: !1, writable: !0, configurable: !0 } }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(C, b) : C.__proto__ = b);
          }
          var v = function(C) {
            g(b, C);
            function b(x, w) {
              h(this, b);
              var $ = m(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this, x, w));
              return $.lastRecorded = 0, $.ignoreChange = !1, $.clear(), $.quill.on(u.default.events.EDITOR_CHANGE, function(E, A, O, k) {
                E !== u.default.events.TEXT_CHANGE || $.ignoreChange || (!$.options.userOnly || k === u.default.sources.USER ? $.record(A, O) : $.transform(A));
              }), $.quill.keyboard.addBinding({ key: "Z", shortKey: !0 }, $.undo.bind($)), $.quill.keyboard.addBinding({ key: "Z", shortKey: !0, shiftKey: !0 }, $.redo.bind($)), /Win/i.test(navigator.platform) && $.quill.keyboard.addBinding({ key: "Y", shortKey: !0 }, $.redo.bind($)), $;
            }
            return r(b, [{
              key: "change",
              value: function(w, $) {
                if (this.stack[w].length !== 0) {
                  var E = this.stack[w].pop();
                  this.stack[$].push(E), this.lastRecorded = 0, this.ignoreChange = !0, this.quill.updateContents(E[w], u.default.sources.USER), this.ignoreChange = !1;
                  var A = y(E[w]);
                  this.quill.setSelection(A);
                }
              }
            }, {
              key: "clear",
              value: function() {
                this.stack = { undo: [], redo: [] };
              }
            }, {
              key: "cutoff",
              value: function() {
                this.lastRecorded = 0;
              }
            }, {
              key: "record",
              value: function(w, $) {
                if (w.ops.length !== 0) {
                  this.stack.redo = [];
                  var E = this.quill.getContents().diff($), A = Date.now();
                  if (this.lastRecorded + this.options.delay > A && this.stack.undo.length > 0) {
                    var O = this.stack.undo.pop();
                    E = E.compose(O.undo), w = O.redo.compose(w);
                  } else
                    this.lastRecorded = A;
                  this.stack.undo.push({
                    redo: w,
                    undo: E
                  }), this.stack.undo.length > this.options.maxStack && this.stack.undo.shift();
                }
              }
            }, {
              key: "redo",
              value: function() {
                this.change("redo", "undo");
              }
            }, {
              key: "transform",
              value: function(w) {
                this.stack.undo.forEach(function($) {
                  $.undo = w.transform($.undo, !0), $.redo = w.transform($.redo, !0);
                }), this.stack.redo.forEach(function($) {
                  $.undo = w.transform($.undo, !0), $.redo = w.transform($.redo, !0);
                });
              }
            }, {
              key: "undo",
              value: function() {
                this.change("undo", "redo");
              }
            }]), b;
          }(f.default);
          v.DEFAULTS = {
            delay: 1e3,
            maxStack: 100,
            userOnly: !1
          };
          function p(C) {
            var b = C.ops[C.ops.length - 1];
            return b == null ? !1 : b.insert != null ? typeof b.insert == "string" && b.insert.endsWith(`
`) : b.attributes != null ? Object.keys(b.attributes).some(function(x) {
              return l.default.query(x, l.default.Scope.BLOCK) != null;
            }) : !1;
          }
          function y(C) {
            var b = C.reduce(function(w, $) {
              return w += $.delete || 0, w;
            }, 0), x = C.length() - b;
            return p(C) && (x -= 1), x;
          }
          o.default = v, o.getLastChangeIndex = y;
        },
        /* 43 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.BaseTooltip = void 0;
          var r = function() {
            function V(q, Z) {
              for (var Y = 0; Y < Z.length; Y++) {
                var R = Z[Y];
                R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(q, R.key, R);
              }
            }
            return function(q, Z, Y) {
              return Z && V(q.prototype, Z), Y && V(q, Y), q;
            };
          }(), a = function V(q, Z, Y) {
            q === null && (q = Function.prototype);
            var R = Object.getOwnPropertyDescriptor(q, Z);
            if (R === void 0) {
              var K = Object.getPrototypeOf(q);
              return K === null ? void 0 : V(K, Z, Y);
            } else {
              if ("value" in R)
                return R.value;
              var te = R.get;
              return te === void 0 ? void 0 : te.call(Y);
            }
          }, l = i(3), s = A(l), u = i(2), d = A(u), f = i(8), c = A(f), h = i(23), m = A(h), g = i(34), v = A(g), p = i(59), y = A(p), C = i(60), b = A(C), x = i(28), w = A(x), $ = i(61), E = A($);
          function A(V) {
            return V && V.__esModule ? V : { default: V };
          }
          function O(V, q) {
            if (!(V instanceof q))
              throw new TypeError("Cannot call a class as a function");
          }
          function k(V, q) {
            if (!V)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return q && (typeof q == "object" || typeof q == "function") ? q : V;
          }
          function S(V, q) {
            if (typeof q != "function" && q !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof q);
            V.prototype = Object.create(q && q.prototype, { constructor: { value: V, enumerable: !1, writable: !0, configurable: !0 } }), q && (Object.setPrototypeOf ? Object.setPrototypeOf(V, q) : V.__proto__ = q);
          }
          var T = [!1, "center", "right", "justify"], L = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"], F = [!1, "serif", "monospace"], U = ["1", "2", "3", !1], W = ["small", !1, "large", "huge"], oe = function(V) {
            S(q, V);
            function q(Z, Y) {
              O(this, q);
              var R = k(this, (q.__proto__ || Object.getPrototypeOf(q)).call(this, Z, Y)), K = function te(ne) {
                if (!document.body.contains(Z.root))
                  return document.body.removeEventListener("click", te);
                R.tooltip != null && !R.tooltip.root.contains(ne.target) && document.activeElement !== R.tooltip.textbox && !R.quill.hasFocus() && R.tooltip.hide(), R.pickers != null && R.pickers.forEach(function(fe) {
                  fe.container.contains(ne.target) || fe.close();
                });
              };
              return Z.emitter.listenDOM("click", document.body, K), R;
            }
            return r(q, [{
              key: "addModule",
              value: function(Y) {
                var R = a(q.prototype.__proto__ || Object.getPrototypeOf(q.prototype), "addModule", this).call(this, Y);
                return Y === "toolbar" && this.extendToolbar(R), R;
              }
            }, {
              key: "buildButtons",
              value: function(Y, R) {
                Y.forEach(function(K) {
                  var te = K.getAttribute("class") || "";
                  te.split(/\s+/).forEach(function(ne) {
                    if (ne.startsWith("ql-") && (ne = ne.slice(3), R[ne] != null))
                      if (ne === "direction")
                        K.innerHTML = R[ne][""] + R[ne].rtl;
                      else if (typeof R[ne] == "string")
                        K.innerHTML = R[ne];
                      else {
                        var fe = K.value || "";
                        fe != null && R[ne][fe] && (K.innerHTML = R[ne][fe]);
                      }
                  });
                });
              }
            }, {
              key: "buildPickers",
              value: function(Y, R) {
                var K = this;
                this.pickers = Y.map(function(ne) {
                  if (ne.classList.contains("ql-align"))
                    return ne.querySelector("option") == null && D(ne, T), new b.default(ne, R.align);
                  if (ne.classList.contains("ql-background") || ne.classList.contains("ql-color")) {
                    var fe = ne.classList.contains("ql-background") ? "background" : "color";
                    return ne.querySelector("option") == null && D(ne, L, fe === "background" ? "#ffffff" : "#000000"), new y.default(ne, R[fe]);
                  } else
                    return ne.querySelector("option") == null && (ne.classList.contains("ql-font") ? D(ne, F) : ne.classList.contains("ql-header") ? D(ne, U) : ne.classList.contains("ql-size") && D(ne, W)), new w.default(ne);
                });
                var te = function() {
                  K.pickers.forEach(function(fe) {
                    fe.update();
                  });
                };
                this.quill.on(c.default.events.EDITOR_CHANGE, te);
              }
            }]), q;
          }(v.default);
          oe.DEFAULTS = (0, s.default)(!0, {}, v.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  formula: function() {
                    this.quill.theme.tooltip.edit("formula");
                  },
                  image: function() {
                    var q = this, Z = this.container.querySelector("input.ql-image[type=file]");
                    Z == null && (Z = document.createElement("input"), Z.setAttribute("type", "file"), Z.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon"), Z.classList.add("ql-image"), Z.addEventListener("change", function() {
                      if (Z.files != null && Z.files[0] != null) {
                        var Y = new FileReader();
                        Y.onload = function(R) {
                          var K = q.quill.getSelection(!0);
                          q.quill.updateContents(new d.default().retain(K.index).delete(K.length).insert({ image: R.target.result }), c.default.sources.USER), q.quill.setSelection(K.index + 1, c.default.sources.SILENT), Z.value = "";
                        }, Y.readAsDataURL(Z.files[0]);
                      }
                    }), this.container.appendChild(Z)), Z.click();
                  },
                  video: function() {
                    this.quill.theme.tooltip.edit("video");
                  }
                }
              }
            }
          });
          var H = function(V) {
            S(q, V);
            function q(Z, Y) {
              O(this, q);
              var R = k(this, (q.__proto__ || Object.getPrototypeOf(q)).call(this, Z, Y));
              return R.textbox = R.root.querySelector('input[type="text"]'), R.listen(), R;
            }
            return r(q, [{
              key: "listen",
              value: function() {
                var Y = this;
                this.textbox.addEventListener("keydown", function(R) {
                  m.default.match(R, "enter") ? (Y.save(), R.preventDefault()) : m.default.match(R, "escape") && (Y.cancel(), R.preventDefault());
                });
              }
            }, {
              key: "cancel",
              value: function() {
                this.hide();
              }
            }, {
              key: "edit",
              value: function() {
                var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link", R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                this.root.classList.remove("ql-hidden"), this.root.classList.add("ql-editing"), R != null ? this.textbox.value = R : Y !== this.root.getAttribute("data-mode") && (this.textbox.value = ""), this.position(this.quill.getBounds(this.quill.selection.savedRange)), this.textbox.select(), this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + Y) || ""), this.root.setAttribute("data-mode", Y);
              }
            }, {
              key: "restoreFocus",
              value: function() {
                var Y = this.quill.scrollingContainer.scrollTop;
                this.quill.focus(), this.quill.scrollingContainer.scrollTop = Y;
              }
            }, {
              key: "save",
              value: function() {
                var Y = this.textbox.value;
                switch (this.root.getAttribute("data-mode")) {
                  case "link": {
                    var R = this.quill.root.scrollTop;
                    this.linkRange ? (this.quill.formatText(this.linkRange, "link", Y, c.default.sources.USER), delete this.linkRange) : (this.restoreFocus(), this.quill.format("link", Y, c.default.sources.USER)), this.quill.root.scrollTop = R;
                    break;
                  }
                  case "video":
                    Y = B(Y);
                  case "formula": {
                    if (!Y)
                      break;
                    var K = this.quill.getSelection(!0);
                    if (K != null) {
                      var te = K.index + K.length;
                      this.quill.insertEmbed(te, this.root.getAttribute("data-mode"), Y, c.default.sources.USER), this.root.getAttribute("data-mode") === "formula" && this.quill.insertText(te + 1, " ", c.default.sources.USER), this.quill.setSelection(te + 2, c.default.sources.USER);
                    }
                    break;
                  }
                }
                this.textbox.value = "", this.hide();
              }
            }]), q;
          }(E.default);
          function B(V) {
            var q = V.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || V.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
            return q ? (q[1] || "https") + "://www.youtube.com/embed/" + q[2] + "?showinfo=0" : (q = V.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) ? (q[1] || "https") + "://player.vimeo.com/video/" + q[2] + "/" : V;
          }
          function D(V, q) {
            var Z = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            q.forEach(function(Y) {
              var R = document.createElement("option");
              Y === Z ? R.setAttribute("selected", "selected") : R.setAttribute("value", Y), V.appendChild(R);
            });
          }
          o.BaseTooltip = H, o.default = oe;
        },
        /* 44 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", { value: !0 });
          var r = (
            /** @class */
            function() {
              function a() {
                this.head = this.tail = null, this.length = 0;
              }
              return a.prototype.append = function() {
                for (var l = [], s = 0; s < arguments.length; s++)
                  l[s] = arguments[s];
                this.insertBefore(l[0], null), l.length > 1 && this.append.apply(this, l.slice(1));
              }, a.prototype.contains = function(l) {
                for (var s, u = this.iterator(); s = u(); )
                  if (s === l)
                    return !0;
                return !1;
              }, a.prototype.insertBefore = function(l, s) {
                l && (l.next = s, s != null ? (l.prev = s.prev, s.prev != null && (s.prev.next = l), s.prev = l, s === this.head && (this.head = l)) : this.tail != null ? (this.tail.next = l, l.prev = this.tail, this.tail = l) : (l.prev = null, this.head = this.tail = l), this.length += 1);
              }, a.prototype.offset = function(l) {
                for (var s = 0, u = this.head; u != null; ) {
                  if (u === l)
                    return s;
                  s += u.length(), u = u.next;
                }
                return -1;
              }, a.prototype.remove = function(l) {
                this.contains(l) && (l.prev != null && (l.prev.next = l.next), l.next != null && (l.next.prev = l.prev), l === this.head && (this.head = l.next), l === this.tail && (this.tail = l.prev), this.length -= 1);
              }, a.prototype.iterator = function(l) {
                return l === void 0 && (l = this.head), function() {
                  var s = l;
                  return l != null && (l = l.next), s;
                };
              }, a.prototype.find = function(l, s) {
                s === void 0 && (s = !1);
                for (var u, d = this.iterator(); u = d(); ) {
                  var f = u.length();
                  if (l < f || s && l === f && (u.next == null || u.next.length() !== 0))
                    return [u, l];
                  l -= f;
                }
                return [null, 0];
              }, a.prototype.forEach = function(l) {
                for (var s, u = this.iterator(); s = u(); )
                  l(s);
              }, a.prototype.forEachAt = function(l, s, u) {
                if (!(s <= 0))
                  for (var d = this.find(l), f = d[0], c = d[1], h, m = l - c, g = this.iterator(f); (h = g()) && m < l + s; ) {
                    var v = h.length();
                    l > m ? u(h, l - m, Math.min(s, m + v - l)) : u(h, 0, Math.min(v, l + s - m)), m += v;
                  }
              }, a.prototype.map = function(l) {
                return this.reduce(function(s, u) {
                  return s.push(l(u)), s;
                }, []);
              }, a.prototype.reduce = function(l, s) {
                for (var u, d = this.iterator(); u = d(); )
                  s = l(s, u);
                return s;
              }, a;
            }()
          );
          o.default = r;
        },
        /* 45 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var f = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, h) {
              c.__proto__ = h;
            } || function(c, h) {
              for (var m in h)
                h.hasOwnProperty(m) && (c[m] = h[m]);
            };
            return function(c, h) {
              f(c, h);
              function m() {
                this.constructor = c;
              }
              c.prototype = h === null ? Object.create(h) : (m.prototype = h.prototype, new m());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(17), l = i(1), s = {
            attributes: !0,
            characterData: !0,
            characterDataOldValue: !0,
            childList: !0,
            subtree: !0
          }, u = 100, d = (
            /** @class */
            function(f) {
              r(c, f);
              function c(h) {
                var m = f.call(this, h) || this;
                return m.scroll = m, m.observer = new MutationObserver(function(g) {
                  m.update(g);
                }), m.observer.observe(m.domNode, s), m.attach(), m;
              }
              return c.prototype.detach = function() {
                f.prototype.detach.call(this), this.observer.disconnect();
              }, c.prototype.deleteAt = function(h, m) {
                this.update(), h === 0 && m === this.length() ? this.children.forEach(function(g) {
                  g.remove();
                }) : f.prototype.deleteAt.call(this, h, m);
              }, c.prototype.formatAt = function(h, m, g, v) {
                this.update(), f.prototype.formatAt.call(this, h, m, g, v);
              }, c.prototype.insertAt = function(h, m, g) {
                this.update(), f.prototype.insertAt.call(this, h, m, g);
              }, c.prototype.optimize = function(h, m) {
                var g = this;
                h === void 0 && (h = []), m === void 0 && (m = {}), f.prototype.optimize.call(this, m);
                for (var v = [].slice.call(this.observer.takeRecords()); v.length > 0; )
                  h.push(v.pop());
                for (var p = function(x, w) {
                  w === void 0 && (w = !0), !(x == null || x === g) && x.domNode.parentNode != null && (x.domNode[l.DATA_KEY].mutations == null && (x.domNode[l.DATA_KEY].mutations = []), w && p(x.parent));
                }, y = function(x) {
                  // @ts-ignore
                  x.domNode[l.DATA_KEY] == null || // @ts-ignore
                  x.domNode[l.DATA_KEY].mutations == null || (x instanceof a.default && x.children.forEach(y), x.optimize(m));
                }, C = h, b = 0; C.length > 0; b += 1) {
                  if (b >= u)
                    throw new Error("[Parchment] Maximum optimize iterations reached");
                  for (C.forEach(function(x) {
                    var w = l.find(x.target, !0);
                    w != null && (w.domNode === x.target && (x.type === "childList" ? (p(l.find(x.previousSibling, !1)), [].forEach.call(x.addedNodes, function($) {
                      var E = l.find($, !1);
                      p(E, !1), E instanceof a.default && E.children.forEach(function(A) {
                        p(A, !1);
                      });
                    })) : x.type === "attributes" && p(w.prev)), p(w));
                  }), this.children.forEach(y), C = [].slice.call(this.observer.takeRecords()), v = C.slice(); v.length > 0; )
                    h.push(v.pop());
                }
              }, c.prototype.update = function(h, m) {
                var g = this;
                m === void 0 && (m = {}), h = h || this.observer.takeRecords(), h.map(function(v) {
                  var p = l.find(v.target, !0);
                  return p == null ? null : p.domNode[l.DATA_KEY].mutations == null ? (p.domNode[l.DATA_KEY].mutations = [v], p) : (p.domNode[l.DATA_KEY].mutations.push(v), null);
                }).forEach(function(v) {
                  v == null || v === g || //@ts-ignore
                  v.domNode[l.DATA_KEY] == null || v.update(v.domNode[l.DATA_KEY].mutations || [], m);
                }), this.domNode[l.DATA_KEY].mutations != null && f.prototype.update.call(this, this.domNode[l.DATA_KEY].mutations, m), this.optimize(h, m);
              }, c.blotName = "scroll", c.defaultChild = "block", c.scope = l.Scope.BLOCK_BLOT, c.tagName = "DIV", c;
            }(a.default)
          );
          o.default = d;
        },
        /* 46 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, c) {
              f.__proto__ = c;
            } || function(f, c) {
              for (var h in c)
                c.hasOwnProperty(h) && (f[h] = c[h]);
            };
            return function(f, c) {
              d(f, c);
              function h() {
                this.constructor = f;
              }
              f.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(18), l = i(1);
          function s(d, f) {
            if (Object.keys(d).length !== Object.keys(f).length)
              return !1;
            for (var c in d)
              if (d[c] !== f[c])
                return !1;
            return !0;
          }
          var u = (
            /** @class */
            function(d) {
              r(f, d);
              function f() {
                return d !== null && d.apply(this, arguments) || this;
              }
              return f.formats = function(c) {
                if (c.tagName !== f.tagName)
                  return d.formats.call(this, c);
              }, f.prototype.format = function(c, h) {
                var m = this;
                c === this.statics.blotName && !h ? (this.children.forEach(function(g) {
                  g instanceof a.default || (g = g.wrap(f.blotName, !0)), m.attributes.copy(g);
                }), this.unwrap()) : d.prototype.format.call(this, c, h);
              }, f.prototype.formatAt = function(c, h, m, g) {
                if (this.formats()[m] != null || l.query(m, l.Scope.ATTRIBUTE)) {
                  var v = this.isolate(c, h);
                  v.format(m, g);
                } else
                  d.prototype.formatAt.call(this, c, h, m, g);
              }, f.prototype.optimize = function(c) {
                d.prototype.optimize.call(this, c);
                var h = this.formats();
                if (Object.keys(h).length === 0)
                  return this.unwrap();
                var m = this.next;
                m instanceof f && m.prev === this && s(h, m.formats()) && (m.moveChildren(this), m.remove());
              }, f.blotName = "inline", f.scope = l.Scope.INLINE_BLOT, f.tagName = "SPAN", f;
            }(a.default)
          );
          o.default = u;
        },
        /* 47 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
              d.__proto__ = f;
            } || function(d, f) {
              for (var c in f)
                f.hasOwnProperty(c) && (d[c] = f[c]);
            };
            return function(d, f) {
              u(d, f);
              function c() {
                this.constructor = d;
              }
              d.prototype = f === null ? Object.create(f) : (c.prototype = f.prototype, new c());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(18), l = i(1), s = (
            /** @class */
            function(u) {
              r(d, u);
              function d() {
                return u !== null && u.apply(this, arguments) || this;
              }
              return d.formats = function(f) {
                var c = l.query(d.blotName).tagName;
                if (f.tagName !== c)
                  return u.formats.call(this, f);
              }, d.prototype.format = function(f, c) {
                l.query(f, l.Scope.BLOCK) != null && (f === this.statics.blotName && !c ? this.replaceWith(d.blotName) : u.prototype.format.call(this, f, c));
              }, d.prototype.formatAt = function(f, c, h, m) {
                l.query(h, l.Scope.BLOCK) != null ? this.format(h, m) : u.prototype.formatAt.call(this, f, c, h, m);
              }, d.prototype.insertAt = function(f, c, h) {
                if (h == null || l.query(c, l.Scope.INLINE) != null)
                  u.prototype.insertAt.call(this, f, c, h);
                else {
                  var m = this.split(f), g = l.create(c, h);
                  m.parent.insertBefore(g, m);
                }
              }, d.prototype.update = function(f, c) {
                navigator.userAgent.match(/Trident/) ? this.build() : u.prototype.update.call(this, f, c);
              }, d.blotName = "block", d.scope = l.Scope.BLOCK_BLOT, d.tagName = "P", d;
            }(a.default)
          );
          o.default = s;
        },
        /* 48 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, d) {
              u.__proto__ = d;
            } || function(u, d) {
              for (var f in d)
                d.hasOwnProperty(f) && (u[f] = d[f]);
            };
            return function(u, d) {
              s(u, d);
              function f() {
                this.constructor = u;
              }
              u.prototype = d === null ? Object.create(d) : (f.prototype = d.prototype, new f());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(19), l = (
            /** @class */
            function(s) {
              r(u, s);
              function u() {
                return s !== null && s.apply(this, arguments) || this;
              }
              return u.formats = function(d) {
              }, u.prototype.format = function(d, f) {
                s.prototype.formatAt.call(this, 0, this.length(), d, f);
              }, u.prototype.formatAt = function(d, f, c, h) {
                d === 0 && f === this.length() ? this.format(c, h) : s.prototype.formatAt.call(this, d, f, c, h);
              }, u.prototype.formats = function() {
                return this.statics.formats(this.domNode);
              }, u;
            }(a.default)
          );
          o.default = l;
        },
        /* 49 */
        /***/
        function(t, o, i) {
          var r = this && this.__extends || function() {
            var u = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, f) {
              d.__proto__ = f;
            } || function(d, f) {
              for (var c in f)
                f.hasOwnProperty(c) && (d[c] = f[c]);
            };
            return function(d, f) {
              u(d, f);
              function c() {
                this.constructor = d;
              }
              d.prototype = f === null ? Object.create(f) : (c.prototype = f.prototype, new c());
            };
          }();
          Object.defineProperty(o, "__esModule", { value: !0 });
          var a = i(19), l = i(1), s = (
            /** @class */
            function(u) {
              r(d, u);
              function d(f) {
                var c = u.call(this, f) || this;
                return c.text = c.statics.value(c.domNode), c;
              }
              return d.create = function(f) {
                return document.createTextNode(f);
              }, d.value = function(f) {
                var c = f.data;
                return c.normalize && (c = c.normalize()), c;
              }, d.prototype.deleteAt = function(f, c) {
                this.domNode.data = this.text = this.text.slice(0, f) + this.text.slice(f + c);
              }, d.prototype.index = function(f, c) {
                return this.domNode === f ? c : -1;
              }, d.prototype.insertAt = function(f, c, h) {
                h == null ? (this.text = this.text.slice(0, f) + c + this.text.slice(f), this.domNode.data = this.text) : u.prototype.insertAt.call(this, f, c, h);
              }, d.prototype.length = function() {
                return this.text.length;
              }, d.prototype.optimize = function(f) {
                u.prototype.optimize.call(this, f), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof d && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
              }, d.prototype.position = function(f, c) {
                return [this.domNode, f];
              }, d.prototype.split = function(f, c) {
                if (c === void 0 && (c = !1), !c) {
                  if (f === 0)
                    return this;
                  if (f === this.length())
                    return this.next;
                }
                var h = l.create(this.domNode.splitText(f));
                return this.parent.insertBefore(h, this.next), this.text = this.statics.value(this.domNode), h;
              }, d.prototype.update = function(f, c) {
                var h = this;
                f.some(function(m) {
                  return m.type === "characterData" && m.target === h.domNode;
                }) && (this.text = this.statics.value(this.domNode));
              }, d.prototype.value = function() {
                return this.text;
              }, d.blotName = "text", d.scope = l.Scope.INLINE_BLOT, d;
            }(a.default)
          );
          o.default = s;
        },
        /* 50 */
        /***/
        function(t, o, i) {
          var r = document.createElement("div");
          if (r.classList.toggle("test-class", !1), r.classList.contains("test-class")) {
            var a = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(l, s) {
              return arguments.length > 1 && !this.contains(l) == !s ? s : a.call(this, l);
            };
          }
          String.prototype.startsWith || (String.prototype.startsWith = function(l, s) {
            return s = s || 0, this.substr(s, l.length) === l;
          }), String.prototype.endsWith || (String.prototype.endsWith = function(l, s) {
            var u = this.toString();
            (typeof s != "number" || !isFinite(s) || Math.floor(s) !== s || s > u.length) && (s = u.length), s -= l.length;
            var d = u.indexOf(l, s);
            return d !== -1 && d === s;
          }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
            value: function(s) {
              if (this === null)
                throw new TypeError("Array.prototype.find called on null or undefined");
              if (typeof s != "function")
                throw new TypeError("predicate must be a function");
              for (var u = Object(this), d = u.length >>> 0, f = arguments[1], c, h = 0; h < d; h++)
                if (c = u[h], s.call(f, c, h, u))
                  return c;
            }
          }), document.addEventListener("DOMContentLoaded", function() {
            document.execCommand("enableObjectResizing", !1, !1), document.execCommand("autoUrlDetect", !1, !1);
          });
        },
        /* 51 */
        /***/
        function(t, o) {
          var i = -1, r = 1, a = 0;
          function l(b, x, w) {
            if (b == x)
              return b ? [[a, b]] : [];
            (w < 0 || b.length < w) && (w = null);
            var $ = f(b, x), E = b.substring(0, $);
            b = b.substring($), x = x.substring($), $ = c(b, x);
            var A = b.substring(b.length - $);
            b = b.substring(0, b.length - $), x = x.substring(0, x.length - $);
            var O = s(b, x);
            return E && O.unshift([a, E]), A && O.push([a, A]), m(O), w != null && (O = p(O, w)), O = y(O), O;
          }
          function s(b, x) {
            var w;
            if (!b)
              return [[r, x]];
            if (!x)
              return [[i, b]];
            var $ = b.length > x.length ? b : x, E = b.length > x.length ? x : b, A = $.indexOf(E);
            if (A != -1)
              return w = [
                [r, $.substring(0, A)],
                [a, E],
                [r, $.substring(A + E.length)]
              ], b.length > x.length && (w[0][0] = w[2][0] = i), w;
            if (E.length == 1)
              return [[i, b], [r, x]];
            var O = h(b, x);
            if (O) {
              var k = O[0], S = O[1], T = O[2], L = O[3], F = O[4], U = l(k, T), W = l(S, L);
              return U.concat([[a, F]], W);
            }
            return u(b, x);
          }
          function u(b, x) {
            for (var w = b.length, $ = x.length, E = Math.ceil((w + $) / 2), A = E, O = 2 * E, k = new Array(O), S = new Array(O), T = 0; T < O; T++)
              k[T] = -1, S[T] = -1;
            k[A + 1] = 0, S[A + 1] = 0;
            for (var L = w - $, F = L % 2 != 0, U = 0, W = 0, oe = 0, H = 0, B = 0; B < E; B++) {
              for (var D = -B + U; D <= B - W; D += 2) {
                var V = A + D, q;
                D == -B || D != B && k[V - 1] < k[V + 1] ? q = k[V + 1] : q = k[V - 1] + 1;
                for (var Z = q - D; q < w && Z < $ && b.charAt(q) == x.charAt(Z); )
                  q++, Z++;
                if (k[V] = q, q > w)
                  W += 2;
                else if (Z > $)
                  U += 2;
                else if (F) {
                  var Y = A + L - D;
                  if (Y >= 0 && Y < O && S[Y] != -1) {
                    var R = w - S[Y];
                    if (q >= R)
                      return d(b, x, q, Z);
                  }
                }
              }
              for (var K = -B + oe; K <= B - H; K += 2) {
                var Y = A + K, R;
                K == -B || K != B && S[Y - 1] < S[Y + 1] ? R = S[Y + 1] : R = S[Y - 1] + 1;
                for (var te = R - K; R < w && te < $ && b.charAt(w - R - 1) == x.charAt($ - te - 1); )
                  R++, te++;
                if (S[Y] = R, R > w)
                  H += 2;
                else if (te > $)
                  oe += 2;
                else if (!F) {
                  var V = A + L - K;
                  if (V >= 0 && V < O && k[V] != -1) {
                    var q = k[V], Z = A + q - V;
                    if (R = w - R, q >= R)
                      return d(b, x, q, Z);
                  }
                }
              }
            }
            return [[i, b], [r, x]];
          }
          function d(b, x, w, $) {
            var E = b.substring(0, w), A = x.substring(0, $), O = b.substring(w), k = x.substring($), S = l(E, A), T = l(O, k);
            return S.concat(T);
          }
          function f(b, x) {
            if (!b || !x || b.charAt(0) != x.charAt(0))
              return 0;
            for (var w = 0, $ = Math.min(b.length, x.length), E = $, A = 0; w < E; )
              b.substring(A, E) == x.substring(A, E) ? (w = E, A = w) : $ = E, E = Math.floor(($ - w) / 2 + w);
            return E;
          }
          function c(b, x) {
            if (!b || !x || b.charAt(b.length - 1) != x.charAt(x.length - 1))
              return 0;
            for (var w = 0, $ = Math.min(b.length, x.length), E = $, A = 0; w < E; )
              b.substring(b.length - E, b.length - A) == x.substring(x.length - E, x.length - A) ? (w = E, A = w) : $ = E, E = Math.floor(($ - w) / 2 + w);
            return E;
          }
          function h(b, x) {
            var w = b.length > x.length ? b : x, $ = b.length > x.length ? x : b;
            if (w.length < 4 || $.length * 2 < w.length)
              return null;
            function E(W, oe, H) {
              for (var B = W.substring(H, H + Math.floor(W.length / 4)), D = -1, V = "", q, Z, Y, R; (D = oe.indexOf(B, D + 1)) != -1; ) {
                var K = f(
                  W.substring(H),
                  oe.substring(D)
                ), te = c(
                  W.substring(0, H),
                  oe.substring(0, D)
                );
                V.length < te + K && (V = oe.substring(D - te, D) + oe.substring(D, D + K), q = W.substring(0, H - te), Z = W.substring(H + K), Y = oe.substring(0, D - te), R = oe.substring(D + K));
              }
              return V.length * 2 >= W.length ? [
                q,
                Z,
                Y,
                R,
                V
              ] : null;
            }
            var A = E(
              w,
              $,
              Math.ceil(w.length / 4)
            ), O = E(
              w,
              $,
              Math.ceil(w.length / 2)
            ), k;
            if (!A && !O)
              return null;
            O ? A ? k = A[4].length > O[4].length ? A : O : k = O : k = A;
            var S, T, L, F;
            b.length > x.length ? (S = k[0], T = k[1], L = k[2], F = k[3]) : (L = k[0], F = k[1], S = k[2], T = k[3]);
            var U = k[4];
            return [S, T, L, F, U];
          }
          function m(b) {
            b.push([a, ""]);
            for (var x = 0, w = 0, $ = 0, E = "", A = "", O; x < b.length; )
              switch (b[x][0]) {
                case r:
                  $++, A += b[x][1], x++;
                  break;
                case i:
                  w++, E += b[x][1], x++;
                  break;
                case a:
                  w + $ > 1 ? (w !== 0 && $ !== 0 && (O = f(A, E), O !== 0 && (x - w - $ > 0 && b[x - w - $ - 1][0] == a ? b[x - w - $ - 1][1] += A.substring(0, O) : (b.splice(0, 0, [
                    a,
                    A.substring(0, O)
                  ]), x++), A = A.substring(O), E = E.substring(O)), O = c(A, E), O !== 0 && (b[x][1] = A.substring(A.length - O) + b[x][1], A = A.substring(0, A.length - O), E = E.substring(0, E.length - O))), w === 0 ? b.splice(
                    x - $,
                    w + $,
                    [r, A]
                  ) : $ === 0 ? b.splice(
                    x - w,
                    w + $,
                    [i, E]
                  ) : b.splice(
                    x - w - $,
                    w + $,
                    [i, E],
                    [r, A]
                  ), x = x - w - $ + (w ? 1 : 0) + ($ ? 1 : 0) + 1) : x !== 0 && b[x - 1][0] == a ? (b[x - 1][1] += b[x][1], b.splice(x, 1)) : x++, $ = 0, w = 0, E = "", A = "";
                  break;
              }
            b[b.length - 1][1] === "" && b.pop();
            var k = !1;
            for (x = 1; x < b.length - 1; )
              b[x - 1][0] == a && b[x + 1][0] == a && (b[x][1].substring(b[x][1].length - b[x - 1][1].length) == b[x - 1][1] ? (b[x][1] = b[x - 1][1] + b[x][1].substring(0, b[x][1].length - b[x - 1][1].length), b[x + 1][1] = b[x - 1][1] + b[x + 1][1], b.splice(x - 1, 1), k = !0) : b[x][1].substring(0, b[x + 1][1].length) == b[x + 1][1] && (b[x - 1][1] += b[x + 1][1], b[x][1] = b[x][1].substring(b[x + 1][1].length) + b[x + 1][1], b.splice(x + 1, 1), k = !0)), x++;
            k && m(b);
          }
          var g = l;
          g.INSERT = r, g.DELETE = i, g.EQUAL = a, t.exports = g;
          function v(b, x) {
            if (x === 0)
              return [a, b];
            for (var w = 0, $ = 0; $ < b.length; $++) {
              var E = b[$];
              if (E[0] === i || E[0] === a) {
                var A = w + E[1].length;
                if (x === A)
                  return [$ + 1, b];
                if (x < A) {
                  b = b.slice();
                  var O = x - w, k = [E[0], E[1].slice(0, O)], S = [E[0], E[1].slice(O)];
                  return b.splice($, 1, k, S), [$ + 1, b];
                } else
                  w = A;
              }
            }
            throw new Error("cursor_pos is out of bounds!");
          }
          function p(b, x) {
            var w = v(b, x), $ = w[1], E = w[0], A = $[E], O = $[E + 1];
            if (A == null)
              return b;
            if (A[0] !== a)
              return b;
            if (O != null && A[1] + O[1] === O[1] + A[1])
              return $.splice(E, 2, O, A), C($, E, 2);
            if (O != null && O[1].indexOf(A[1]) === 0) {
              $.splice(E, 2, [O[0], A[1]], [0, A[1]]);
              var k = O[1].slice(A[1].length);
              return k.length > 0 && $.splice(E + 2, 0, [O[0], k]), C($, E, 3);
            } else
              return b;
          }
          function y(b) {
            for (var x = !1, w = function(O) {
              return O.charCodeAt(0) >= 56320 && O.charCodeAt(0) <= 57343;
            }, $ = function(O) {
              return O.charCodeAt(O.length - 1) >= 55296 && O.charCodeAt(O.length - 1) <= 56319;
            }, E = 2; E < b.length; E += 1)
              b[E - 2][0] === a && $(b[E - 2][1]) && b[E - 1][0] === i && w(b[E - 1][1]) && b[E][0] === r && w(b[E][1]) && (x = !0, b[E - 1][1] = b[E - 2][1].slice(-1) + b[E - 1][1], b[E][1] = b[E - 2][1].slice(-1) + b[E][1], b[E - 2][1] = b[E - 2][1].slice(0, -1));
            if (!x)
              return b;
            for (var A = [], E = 0; E < b.length; E += 1)
              b[E][1].length > 0 && A.push(b[E]);
            return A;
          }
          function C(b, x, w) {
            for (var $ = x + w - 1; $ >= 0 && $ >= x - 1; $--)
              if ($ + 1 < b.length) {
                var E = b[$], A = b[$ + 1];
                E[0] === A[1] && b.splice($, 2, [E[0], E[1] + A[1]]);
              }
            return b;
          }
        },
        /* 52 */
        /***/
        function(t, o) {
          o = t.exports = typeof Object.keys == "function" ? Object.keys : i, o.shim = i;
          function i(r) {
            var a = [];
            for (var l in r)
              a.push(l);
            return a;
          }
        },
        /* 53 */
        /***/
        function(t, o) {
          var i = function() {
            return Object.prototype.toString.call(arguments);
          }() == "[object Arguments]";
          o = t.exports = i ? r : a, o.supported = r;
          function r(l) {
            return Object.prototype.toString.call(l) == "[object Arguments]";
          }
          o.unsupported = a;
          function a(l) {
            return l && typeof l == "object" && typeof l.length == "number" && Object.prototype.hasOwnProperty.call(l, "callee") && !Object.prototype.propertyIsEnumerable.call(l, "callee") || !1;
          }
        },
        /* 54 */
        /***/
        function(t, o) {
          var i = Object.prototype.hasOwnProperty, r = "~";
          function a() {
          }
          Object.create && (a.prototype = /* @__PURE__ */ Object.create(null), new a().__proto__ || (r = !1));
          function l(u, d, f) {
            this.fn = u, this.context = d, this.once = f || !1;
          }
          function s() {
            this._events = new a(), this._eventsCount = 0;
          }
          s.prototype.eventNames = function() {
            var d = [], f, c;
            if (this._eventsCount === 0)
              return d;
            for (c in f = this._events)
              i.call(f, c) && d.push(r ? c.slice(1) : c);
            return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(f)) : d;
          }, s.prototype.listeners = function(d, f) {
            var c = r ? r + d : d, h = this._events[c];
            if (f)
              return !!h;
            if (!h)
              return [];
            if (h.fn)
              return [h.fn];
            for (var m = 0, g = h.length, v = new Array(g); m < g; m++)
              v[m] = h[m].fn;
            return v;
          }, s.prototype.emit = function(d, f, c, h, m, g) {
            var v = r ? r + d : d;
            if (!this._events[v])
              return !1;
            var p = this._events[v], y = arguments.length, C, b;
            if (p.fn) {
              switch (p.once && this.removeListener(d, p.fn, void 0, !0), y) {
                case 1:
                  return p.fn.call(p.context), !0;
                case 2:
                  return p.fn.call(p.context, f), !0;
                case 3:
                  return p.fn.call(p.context, f, c), !0;
                case 4:
                  return p.fn.call(p.context, f, c, h), !0;
                case 5:
                  return p.fn.call(p.context, f, c, h, m), !0;
                case 6:
                  return p.fn.call(p.context, f, c, h, m, g), !0;
              }
              for (b = 1, C = new Array(y - 1); b < y; b++)
                C[b - 1] = arguments[b];
              p.fn.apply(p.context, C);
            } else {
              var x = p.length, w;
              for (b = 0; b < x; b++)
                switch (p[b].once && this.removeListener(d, p[b].fn, void 0, !0), y) {
                  case 1:
                    p[b].fn.call(p[b].context);
                    break;
                  case 2:
                    p[b].fn.call(p[b].context, f);
                    break;
                  case 3:
                    p[b].fn.call(p[b].context, f, c);
                    break;
                  case 4:
                    p[b].fn.call(p[b].context, f, c, h);
                    break;
                  default:
                    if (!C)
                      for (w = 1, C = new Array(y - 1); w < y; w++)
                        C[w - 1] = arguments[w];
                    p[b].fn.apply(p[b].context, C);
                }
            }
            return !0;
          }, s.prototype.on = function(d, f, c) {
            var h = new l(f, c || this), m = r ? r + d : d;
            return this._events[m] ? this._events[m].fn ? this._events[m] = [this._events[m], h] : this._events[m].push(h) : (this._events[m] = h, this._eventsCount++), this;
          }, s.prototype.once = function(d, f, c) {
            var h = new l(f, c || this, !0), m = r ? r + d : d;
            return this._events[m] ? this._events[m].fn ? this._events[m] = [this._events[m], h] : this._events[m].push(h) : (this._events[m] = h, this._eventsCount++), this;
          }, s.prototype.removeListener = function(d, f, c, h) {
            var m = r ? r + d : d;
            if (!this._events[m])
              return this;
            if (!f)
              return --this._eventsCount === 0 ? this._events = new a() : delete this._events[m], this;
            var g = this._events[m];
            if (g.fn)
              g.fn === f && (!h || g.once) && (!c || g.context === c) && (--this._eventsCount === 0 ? this._events = new a() : delete this._events[m]);
            else {
              for (var v = 0, p = [], y = g.length; v < y; v++)
                (g[v].fn !== f || h && !g[v].once || c && g[v].context !== c) && p.push(g[v]);
              p.length ? this._events[m] = p.length === 1 ? p[0] : p : --this._eventsCount === 0 ? this._events = new a() : delete this._events[m];
            }
            return this;
          }, s.prototype.removeAllListeners = function(d) {
            var f;
            return d ? (f = r ? r + d : d, this._events[f] && (--this._eventsCount === 0 ? this._events = new a() : delete this._events[f])) : (this._events = new a(), this._eventsCount = 0), this;
          }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prototype.setMaxListeners = function() {
            return this;
          }, s.prefixed = r, s.EventEmitter = s, typeof t < "u" && (t.exports = s);
        },
        /* 55 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.matchText = o.matchSpacing = o.matchNewline = o.matchBlot = o.matchAttributor = o.default = void 0;
          var r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(se) {
            return typeof se;
          } : function(se) {
            return se && typeof Symbol == "function" && se.constructor === Symbol && se !== Symbol.prototype ? "symbol" : typeof se;
          }, a = function() {
            function se(ue, ve) {
              var ye = [], he = !0, we = !1, Q = void 0;
              try {
                for (var le = ue[Symbol.iterator](), et; !(he = (et = le.next()).done) && (ye.push(et.value), !(ve && ye.length === ve)); he = !0)
                  ;
              } catch (ot) {
                we = !0, Q = ot;
              } finally {
                try {
                  !he && le.return && le.return();
                } finally {
                  if (we)
                    throw Q;
                }
              }
              return ye;
            }
            return function(ue, ve) {
              if (Array.isArray(ue))
                return ue;
              if (Symbol.iterator in Object(ue))
                return se(ue, ve);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), l = function() {
            function se(ue, ve) {
              for (var ye = 0; ye < ve.length; ye++) {
                var he = ve[ye];
                he.enumerable = he.enumerable || !1, he.configurable = !0, "value" in he && (he.writable = !0), Object.defineProperty(ue, he.key, he);
              }
            }
            return function(ue, ve, ye) {
              return ve && se(ue.prototype, ve), ye && se(ue, ye), ue;
            };
          }(), s = i(3), u = S(s), d = i(2), f = S(d), c = i(0), h = S(c), m = i(5), g = S(m), v = i(10), p = S(v), y = i(9), C = S(y), b = i(36), x = i(37), w = i(13), $ = S(w), E = i(26), A = i(38), O = i(39), k = i(40);
          function S(se) {
            return se && se.__esModule ? se : { default: se };
          }
          function T(se, ue, ve) {
            return ue in se ? Object.defineProperty(se, ue, { value: ve, enumerable: !0, configurable: !0, writable: !0 }) : se[ue] = ve, se;
          }
          function L(se, ue) {
            if (!(se instanceof ue))
              throw new TypeError("Cannot call a class as a function");
          }
          function F(se, ue) {
            if (!se)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return ue && (typeof ue == "object" || typeof ue == "function") ? ue : se;
          }
          function U(se, ue) {
            if (typeof ue != "function" && ue !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof ue);
            se.prototype = Object.create(ue && ue.prototype, { constructor: { value: se, enumerable: !1, writable: !0, configurable: !0 } }), ue && (Object.setPrototypeOf ? Object.setPrototypeOf(se, ue) : se.__proto__ = ue);
          }
          var W = (0, p.default)("quill:clipboard"), oe = "__ql-matcher", H = [[Node.TEXT_NODE, st], [Node.TEXT_NODE, De], ["br", Ce], [Node.ELEMENT_NODE, De], [Node.ELEMENT_NODE, fe], [Node.ELEMENT_NODE, qe], [Node.ELEMENT_NODE, ne], [Node.ELEMENT_NODE, $t], ["li", Ae], ["b", te.bind(te, "bold")], ["i", te.bind(te, "italic")], ["style", Oe]], B = [b.AlignAttribute, A.DirectionAttribute].reduce(function(se, ue) {
            return se[ue.keyName] = ue, se;
          }, {}), D = [b.AlignStyle, x.BackgroundStyle, E.ColorStyle, A.DirectionStyle, O.FontStyle, k.SizeStyle].reduce(function(se, ue) {
            return se[ue.keyName] = ue, se;
          }, {}), V = function(se) {
            U(ue, se);
            function ue(ve, ye) {
              L(this, ue);
              var he = F(this, (ue.__proto__ || Object.getPrototypeOf(ue)).call(this, ve, ye));
              return he.quill.root.addEventListener("paste", he.onPaste.bind(he)), he.container = he.quill.addContainer("ql-clipboard"), he.container.setAttribute("contenteditable", !0), he.container.setAttribute("tabindex", -1), he.matchers = [], H.concat(he.options.matchers).forEach(function(we) {
                var Q = a(we, 2), le = Q[0], et = Q[1];
                !ye.matchVisual && et === qe || he.addMatcher(le, et);
              }), he;
            }
            return l(ue, [{
              key: "addMatcher",
              value: function(ye, he) {
                this.matchers.push([ye, he]);
              }
            }, {
              key: "convert",
              value: function(ye) {
                if (typeof ye == "string")
                  return this.container.innerHTML = ye.replace(/\>\r?\n +\</g, "><"), this.convert();
                var he = this.quill.getFormat(this.quill.selection.savedRange.index);
                if (he[$.default.blotName]) {
                  var we = this.container.innerText;
                  return this.container.innerHTML = "", new f.default().insert(we, T({}, $.default.blotName, he[$.default.blotName]));
                }
                var Q = this.prepareMatching(), le = a(Q, 2), et = le[0], ot = le[1], tt = K(this.container, et, ot);
                return Y(tt, `
`) && tt.ops[tt.ops.length - 1].attributes == null && (tt = tt.compose(new f.default().retain(tt.length() - 1).delete(1))), W.log("convert", this.container.innerHTML, tt), this.container.innerHTML = "", tt;
              }
            }, {
              key: "dangerouslyPasteHTML",
              value: function(ye, he) {
                var we = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : g.default.sources.API;
                if (typeof ye == "string")
                  this.quill.setContents(this.convert(ye), he), this.quill.setSelection(0, g.default.sources.SILENT);
                else {
                  var Q = this.convert(he);
                  this.quill.updateContents(new f.default().retain(ye).concat(Q), we), this.quill.setSelection(ye + Q.length(), g.default.sources.SILENT);
                }
              }
            }, {
              key: "onPaste",
              value: function(ye) {
                var he = this;
                if (!(ye.defaultPrevented || !this.quill.isEnabled())) {
                  var we = this.quill.getSelection(), Q = new f.default().retain(we.index), le = this.quill.scrollingContainer.scrollTop;
                  this.container.focus(), this.quill.selection.update(g.default.sources.SILENT), setTimeout(function() {
                    Q = Q.concat(he.convert()).delete(we.length), he.quill.updateContents(Q, g.default.sources.USER), he.quill.setSelection(Q.length() - we.length, g.default.sources.SILENT), he.quill.scrollingContainer.scrollTop = le, he.quill.focus();
                  }, 1);
                }
              }
            }, {
              key: "prepareMatching",
              value: function() {
                var ye = this, he = [], we = [];
                return this.matchers.forEach(function(Q) {
                  var le = a(Q, 2), et = le[0], ot = le[1];
                  switch (et) {
                    case Node.TEXT_NODE:
                      we.push(ot);
                      break;
                    case Node.ELEMENT_NODE:
                      he.push(ot);
                      break;
                    default:
                      [].forEach.call(ye.container.querySelectorAll(et), function(tt) {
                        tt[oe] = tt[oe] || [], tt[oe].push(ot);
                      });
                      break;
                  }
                }), [he, we];
              }
            }]), ue;
          }(C.default);
          V.DEFAULTS = {
            matchers: [],
            matchVisual: !0
          };
          function q(se, ue, ve) {
            return (typeof ue > "u" ? "undefined" : r(ue)) === "object" ? Object.keys(ue).reduce(function(ye, he) {
              return q(ye, he, ue[he]);
            }, se) : se.reduce(function(ye, he) {
              return he.attributes && he.attributes[ue] ? ye.push(he) : ye.insert(he.insert, (0, u.default)({}, T({}, ue, ve), he.attributes));
            }, new f.default());
          }
          function Z(se) {
            if (se.nodeType !== Node.ELEMENT_NODE)
              return {};
            var ue = "__ql-computed-style";
            return se[ue] || (se[ue] = window.getComputedStyle(se));
          }
          function Y(se, ue) {
            for (var ve = "", ye = se.ops.length - 1; ye >= 0 && ve.length < ue.length; --ye) {
              var he = se.ops[ye];
              if (typeof he.insert != "string")
                break;
              ve = he.insert + ve;
            }
            return ve.slice(-1 * ue.length) === ue;
          }
          function R(se) {
            if (se.childNodes.length === 0)
              return !1;
            var ue = Z(se);
            return ["block", "list-item"].indexOf(ue.display) > -1;
          }
          function K(se, ue, ve) {
            return se.nodeType === se.TEXT_NODE ? ve.reduce(function(ye, he) {
              return he(se, ye);
            }, new f.default()) : se.nodeType === se.ELEMENT_NODE ? [].reduce.call(se.childNodes || [], function(ye, he) {
              var we = K(he, ue, ve);
              return he.nodeType === se.ELEMENT_NODE && (we = ue.reduce(function(Q, le) {
                return le(he, Q);
              }, we), we = (he[oe] || []).reduce(function(Q, le) {
                return le(he, Q);
              }, we)), ye.concat(we);
            }, new f.default()) : new f.default();
          }
          function te(se, ue, ve) {
            return q(ve, se, !0);
          }
          function ne(se, ue) {
            var ve = h.default.Attributor.Attribute.keys(se), ye = h.default.Attributor.Class.keys(se), he = h.default.Attributor.Style.keys(se), we = {};
            return ve.concat(ye).concat(he).forEach(function(Q) {
              var le = h.default.query(Q, h.default.Scope.ATTRIBUTE);
              le != null && (we[le.attrName] = le.value(se), we[le.attrName]) || (le = B[Q], le != null && (le.attrName === Q || le.keyName === Q) && (we[le.attrName] = le.value(se) || void 0), le = D[Q], le != null && (le.attrName === Q || le.keyName === Q) && (le = D[Q], we[le.attrName] = le.value(se) || void 0));
            }), Object.keys(we).length > 0 && (ue = q(ue, we)), ue;
          }
          function fe(se, ue) {
            var ve = h.default.query(se);
            if (ve == null)
              return ue;
            if (ve.prototype instanceof h.default.Embed) {
              var ye = {}, he = ve.value(se);
              he != null && (ye[ve.blotName] = he, ue = new f.default().insert(ye, ve.formats(se)));
            } else
              typeof ve.formats == "function" && (ue = q(ue, ve.blotName, ve.formats(se)));
            return ue;
          }
          function Ce(se, ue) {
            return Y(ue, `
`) || ue.insert(`
`), ue;
          }
          function Oe() {
            return new f.default();
          }
          function Ae(se, ue) {
            var ve = h.default.query(se);
            if (ve == null || ve.blotName !== "list-item" || !Y(ue, `
`))
              return ue;
            for (var ye = -1, he = se.parentNode; !he.classList.contains("ql-clipboard"); )
              (h.default.query(he) || {}).blotName === "list" && (ye += 1), he = he.parentNode;
            return ye <= 0 ? ue : ue.compose(new f.default().retain(ue.length() - 1).retain(1, { indent: ye }));
          }
          function De(se, ue) {
            return Y(ue, `
`) || (R(se) || ue.length() > 0 && se.nextSibling && R(se.nextSibling)) && ue.insert(`
`), ue;
          }
          function qe(se, ue) {
            if (R(se) && se.nextElementSibling != null && !Y(ue, `

`)) {
              var ve = se.offsetHeight + parseFloat(Z(se).marginTop) + parseFloat(Z(se).marginBottom);
              se.nextElementSibling.offsetTop > se.offsetTop + ve * 1.5 && ue.insert(`
`);
            }
            return ue;
          }
          function $t(se, ue) {
            var ve = {}, ye = se.style || {};
            return ye.fontStyle && Z(se).fontStyle === "italic" && (ve.italic = !0), ye.fontWeight && (Z(se).fontWeight.startsWith("bold") || parseInt(Z(se).fontWeight) >= 700) && (ve.bold = !0), Object.keys(ve).length > 0 && (ue = q(ue, ve)), parseFloat(ye.textIndent || 0) > 0 && (ue = new f.default().insert("	").concat(ue)), ue;
          }
          function st(se, ue) {
            var ve = se.data;
            if (se.parentNode.tagName === "O:P")
              return ue.insert(ve.trim());
            if (ve.trim().length === 0 && se.parentNode.classList.contains("ql-clipboard"))
              return ue;
            if (!Z(se.parentNode).whiteSpace.startsWith("pre")) {
              var ye = function(we, Q) {
                return Q = Q.replace(/[^\u00a0]/g, ""), Q.length < 1 && we ? " " : Q;
              };
              ve = ve.replace(/\r\n/g, " ").replace(/\n/g, " "), ve = ve.replace(/\s\s+/g, ye.bind(ye, !0)), (se.previousSibling == null && R(se.parentNode) || se.previousSibling != null && R(se.previousSibling)) && (ve = ve.replace(/^\s+/, ye.bind(ye, !1))), (se.nextSibling == null && R(se.parentNode) || se.nextSibling != null && R(se.nextSibling)) && (ve = ve.replace(/\s+$/, ye.bind(ye, !1)));
            }
            return ue.insert(ve);
          }
          o.default = V, o.matchAttributor = ne, o.matchBlot = fe, o.matchNewline = De, o.matchSpacing = qe, o.matchText = st;
        },
        /* 56 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function m(g, v) {
              for (var p = 0; p < v.length; p++) {
                var y = v[p];
                y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(g, y.key, y);
              }
            }
            return function(g, v, p) {
              return v && m(g.prototype, v), p && m(g, p), g;
            };
          }(), a = function m(g, v, p) {
            g === null && (g = Function.prototype);
            var y = Object.getOwnPropertyDescriptor(g, v);
            if (y === void 0) {
              var C = Object.getPrototypeOf(g);
              return C === null ? void 0 : m(C, v, p);
            } else {
              if ("value" in y)
                return y.value;
              var b = y.get;
              return b === void 0 ? void 0 : b.call(p);
            }
          }, l = i(6), s = u(l);
          function u(m) {
            return m && m.__esModule ? m : { default: m };
          }
          function d(m, g) {
            if (!(m instanceof g))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(m, g) {
            if (!m)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return g && (typeof g == "object" || typeof g == "function") ? g : m;
          }
          function c(m, g) {
            if (typeof g != "function" && g !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof g);
            m.prototype = Object.create(g && g.prototype, { constructor: { value: m, enumerable: !1, writable: !0, configurable: !0 } }), g && (Object.setPrototypeOf ? Object.setPrototypeOf(m, g) : m.__proto__ = g);
          }
          var h = function(m) {
            c(g, m);
            function g() {
              return d(this, g), f(this, (g.__proto__ || Object.getPrototypeOf(g)).apply(this, arguments));
            }
            return r(g, [{
              key: "optimize",
              value: function(p) {
                a(g.prototype.__proto__ || Object.getPrototypeOf(g.prototype), "optimize", this).call(this, p), this.domNode.tagName !== this.statics.tagName[0] && this.replaceWith(this.statics.blotName);
              }
            }], [{
              key: "create",
              value: function() {
                return a(g.__proto__ || Object.getPrototypeOf(g), "create", this).call(this);
              }
            }, {
              key: "formats",
              value: function() {
                return !0;
              }
            }]), g;
          }(s.default);
          h.blotName = "bold", h.tagName = ["STRONG", "B"], o.default = h;
        },
        /* 57 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.addControls = o.default = void 0;
          var r = function() {
            function k(S, T) {
              var L = [], F = !0, U = !1, W = void 0;
              try {
                for (var oe = S[Symbol.iterator](), H; !(F = (H = oe.next()).done) && (L.push(H.value), !(T && L.length === T)); F = !0)
                  ;
              } catch (B) {
                U = !0, W = B;
              } finally {
                try {
                  !F && oe.return && oe.return();
                } finally {
                  if (U)
                    throw W;
                }
              }
              return L;
            }
            return function(S, T) {
              if (Array.isArray(S))
                return S;
              if (Symbol.iterator in Object(S))
                return k(S, T);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), a = function() {
            function k(S, T) {
              for (var L = 0; L < T.length; L++) {
                var F = T[L];
                F.enumerable = F.enumerable || !1, F.configurable = !0, "value" in F && (F.writable = !0), Object.defineProperty(S, F.key, F);
              }
            }
            return function(S, T, L) {
              return T && k(S.prototype, T), L && k(S, L), S;
            };
          }(), l = i(2), s = p(l), u = i(0), d = p(u), f = i(5), c = p(f), h = i(10), m = p(h), g = i(9), v = p(g);
          function p(k) {
            return k && k.__esModule ? k : { default: k };
          }
          function y(k, S, T) {
            return S in k ? Object.defineProperty(k, S, { value: T, enumerable: !0, configurable: !0, writable: !0 }) : k[S] = T, k;
          }
          function C(k, S) {
            if (!(k instanceof S))
              throw new TypeError("Cannot call a class as a function");
          }
          function b(k, S) {
            if (!k)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return S && (typeof S == "object" || typeof S == "function") ? S : k;
          }
          function x(k, S) {
            if (typeof S != "function" && S !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof S);
            k.prototype = Object.create(S && S.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(k, S) : k.__proto__ = S);
          }
          var w = (0, m.default)("quill:toolbar"), $ = function(k) {
            x(S, k);
            function S(T, L) {
              C(this, S);
              var F = b(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this, T, L));
              if (Array.isArray(F.options.container)) {
                var U = document.createElement("div");
                A(U, F.options.container), T.container.parentNode.insertBefore(U, T.container), F.container = U;
              } else
                typeof F.options.container == "string" ? F.container = document.querySelector(F.options.container) : F.container = F.options.container;
              if (!(F.container instanceof HTMLElement)) {
                var W;
                return W = w.error("Container required for toolbar", F.options), b(F, W);
              }
              return F.container.classList.add("ql-toolbar"), F.controls = [], F.handlers = {}, Object.keys(F.options.handlers).forEach(function(oe) {
                F.addHandler(oe, F.options.handlers[oe]);
              }), [].forEach.call(F.container.querySelectorAll("button, select"), function(oe) {
                F.attach(oe);
              }), F.quill.on(c.default.events.EDITOR_CHANGE, function(oe, H) {
                oe === c.default.events.SELECTION_CHANGE && F.update(H);
              }), F.quill.on(c.default.events.SCROLL_OPTIMIZE, function() {
                var oe = F.quill.selection.getRange(), H = r(oe, 1), B = H[0];
                F.update(B);
              }), F;
            }
            return a(S, [{
              key: "addHandler",
              value: function(L, F) {
                this.handlers[L] = F;
              }
            }, {
              key: "attach",
              value: function(L) {
                var F = this, U = [].find.call(L.classList, function(oe) {
                  return oe.indexOf("ql-") === 0;
                });
                if (U) {
                  if (U = U.slice(3), L.tagName === "BUTTON" && L.setAttribute("type", "button"), this.handlers[U] == null) {
                    if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[U] == null) {
                      w.warn("ignoring attaching to disabled format", U, L);
                      return;
                    }
                    if (d.default.query(U) == null) {
                      w.warn("ignoring attaching to nonexistent format", U, L);
                      return;
                    }
                  }
                  var W = L.tagName === "SELECT" ? "change" : "click";
                  L.addEventListener(W, function(oe) {
                    var H = void 0;
                    if (L.tagName === "SELECT") {
                      if (L.selectedIndex < 0)
                        return;
                      var B = L.options[L.selectedIndex];
                      B.hasAttribute("selected") ? H = !1 : H = B.value || !1;
                    } else
                      L.classList.contains("ql-active") ? H = !1 : H = L.value || !L.hasAttribute("value"), oe.preventDefault();
                    F.quill.focus();
                    var D = F.quill.selection.getRange(), V = r(D, 1), q = V[0];
                    if (F.handlers[U] != null)
                      F.handlers[U].call(F, H);
                    else if (d.default.query(U).prototype instanceof d.default.Embed) {
                      if (H = prompt("Enter " + U), !H)
                        return;
                      F.quill.updateContents(new s.default().retain(q.index).delete(q.length).insert(y({}, U, H)), c.default.sources.USER);
                    } else
                      F.quill.format(U, H, c.default.sources.USER);
                    F.update(q);
                  }), this.controls.push([U, L]);
                }
              }
            }, {
              key: "update",
              value: function(L) {
                var F = L == null ? {} : this.quill.getFormat(L);
                this.controls.forEach(function(U) {
                  var W = r(U, 2), oe = W[0], H = W[1];
                  if (H.tagName === "SELECT") {
                    var B = void 0;
                    if (L == null)
                      B = null;
                    else if (F[oe] == null)
                      B = H.querySelector("option[selected]");
                    else if (!Array.isArray(F[oe])) {
                      var D = F[oe];
                      typeof D == "string" && (D = D.replace(/\"/g, '\\"')), B = H.querySelector('option[value="' + D + '"]');
                    }
                    B == null ? (H.value = "", H.selectedIndex = -1) : B.selected = !0;
                  } else if (L == null)
                    H.classList.remove("ql-active");
                  else if (H.hasAttribute("value")) {
                    var V = F[oe] === H.getAttribute("value") || F[oe] != null && F[oe].toString() === H.getAttribute("value") || F[oe] == null && !H.getAttribute("value");
                    H.classList.toggle("ql-active", V);
                  } else
                    H.classList.toggle("ql-active", F[oe] != null);
                });
              }
            }]), S;
          }(v.default);
          $.DEFAULTS = {};
          function E(k, S, T) {
            var L = document.createElement("button");
            L.setAttribute("type", "button"), L.classList.add("ql-" + S), T != null && (L.value = T), k.appendChild(L);
          }
          function A(k, S) {
            Array.isArray(S[0]) || (S = [S]), S.forEach(function(T) {
              var L = document.createElement("span");
              L.classList.add("ql-formats"), T.forEach(function(F) {
                if (typeof F == "string")
                  E(L, F);
                else {
                  var U = Object.keys(F)[0], W = F[U];
                  Array.isArray(W) ? O(L, U, W) : E(L, U, W);
                }
              }), k.appendChild(L);
            });
          }
          function O(k, S, T) {
            var L = document.createElement("select");
            L.classList.add("ql-" + S), T.forEach(function(F) {
              var U = document.createElement("option");
              F !== !1 ? U.setAttribute("value", F) : U.setAttribute("selected", "selected"), L.appendChild(U);
            }), k.appendChild(L);
          }
          $.DEFAULTS = {
            container: null,
            handlers: {
              clean: function() {
                var S = this, T = this.quill.getSelection();
                if (T != null)
                  if (T.length == 0) {
                    var L = this.quill.getFormat();
                    Object.keys(L).forEach(function(F) {
                      d.default.query(F, d.default.Scope.INLINE) != null && S.quill.format(F, !1);
                    });
                  } else
                    this.quill.removeFormat(T, c.default.sources.USER);
              },
              direction: function(S) {
                var T = this.quill.getFormat().align;
                S === "rtl" && T == null ? this.quill.format("align", "right", c.default.sources.USER) : !S && T === "right" && this.quill.format("align", !1, c.default.sources.USER), this.quill.format("direction", S, c.default.sources.USER);
              },
              indent: function(S) {
                var T = this.quill.getSelection(), L = this.quill.getFormat(T), F = parseInt(L.indent || 0);
                if (S === "+1" || S === "-1") {
                  var U = S === "+1" ? 1 : -1;
                  L.direction === "rtl" && (U *= -1), this.quill.format("indent", F + U, c.default.sources.USER);
                }
              },
              link: function(S) {
                S === !0 && (S = prompt("Enter link URL:")), this.quill.format("link", S, c.default.sources.USER);
              },
              list: function(S) {
                var T = this.quill.getSelection(), L = this.quill.getFormat(T);
                S === "check" ? L.list === "checked" || L.list === "unchecked" ? this.quill.format("list", !1, c.default.sources.USER) : this.quill.format("list", "unchecked", c.default.sources.USER) : this.quill.format("list", S, c.default.sources.USER);
              }
            }
          }, o.default = $, o.addControls = A;
        },
        /* 58 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
        },
        /* 59 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function m(g, v) {
              for (var p = 0; p < v.length; p++) {
                var y = v[p];
                y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(g, y.key, y);
              }
            }
            return function(g, v, p) {
              return v && m(g.prototype, v), p && m(g, p), g;
            };
          }(), a = function m(g, v, p) {
            g === null && (g = Function.prototype);
            var y = Object.getOwnPropertyDescriptor(g, v);
            if (y === void 0) {
              var C = Object.getPrototypeOf(g);
              return C === null ? void 0 : m(C, v, p);
            } else {
              if ("value" in y)
                return y.value;
              var b = y.get;
              return b === void 0 ? void 0 : b.call(p);
            }
          }, l = i(28), s = u(l);
          function u(m) {
            return m && m.__esModule ? m : { default: m };
          }
          function d(m, g) {
            if (!(m instanceof g))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(m, g) {
            if (!m)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return g && (typeof g == "object" || typeof g == "function") ? g : m;
          }
          function c(m, g) {
            if (typeof g != "function" && g !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof g);
            m.prototype = Object.create(g && g.prototype, { constructor: { value: m, enumerable: !1, writable: !0, configurable: !0 } }), g && (Object.setPrototypeOf ? Object.setPrototypeOf(m, g) : m.__proto__ = g);
          }
          var h = function(m) {
            c(g, m);
            function g(v, p) {
              d(this, g);
              var y = f(this, (g.__proto__ || Object.getPrototypeOf(g)).call(this, v));
              return y.label.innerHTML = p, y.container.classList.add("ql-color-picker"), [].slice.call(y.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach(function(C) {
                C.classList.add("ql-primary");
              }), y;
            }
            return r(g, [{
              key: "buildItem",
              value: function(p) {
                var y = a(g.prototype.__proto__ || Object.getPrototypeOf(g.prototype), "buildItem", this).call(this, p);
                return y.style.backgroundColor = p.getAttribute("value") || "", y;
              }
            }, {
              key: "selectItem",
              value: function(p, y) {
                a(g.prototype.__proto__ || Object.getPrototypeOf(g.prototype), "selectItem", this).call(this, p, y);
                var C = this.label.querySelector(".ql-color-label"), b = p && p.getAttribute("data-value") || "";
                C && (C.tagName === "line" ? C.style.stroke = b : C.style.fill = b);
              }
            }]), g;
          }(s.default);
          o.default = h;
        },
        /* 60 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function m(g, v) {
              for (var p = 0; p < v.length; p++) {
                var y = v[p];
                y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(g, y.key, y);
              }
            }
            return function(g, v, p) {
              return v && m(g.prototype, v), p && m(g, p), g;
            };
          }(), a = function m(g, v, p) {
            g === null && (g = Function.prototype);
            var y = Object.getOwnPropertyDescriptor(g, v);
            if (y === void 0) {
              var C = Object.getPrototypeOf(g);
              return C === null ? void 0 : m(C, v, p);
            } else {
              if ("value" in y)
                return y.value;
              var b = y.get;
              return b === void 0 ? void 0 : b.call(p);
            }
          }, l = i(28), s = u(l);
          function u(m) {
            return m && m.__esModule ? m : { default: m };
          }
          function d(m, g) {
            if (!(m instanceof g))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(m, g) {
            if (!m)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return g && (typeof g == "object" || typeof g == "function") ? g : m;
          }
          function c(m, g) {
            if (typeof g != "function" && g !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof g);
            m.prototype = Object.create(g && g.prototype, { constructor: { value: m, enumerable: !1, writable: !0, configurable: !0 } }), g && (Object.setPrototypeOf ? Object.setPrototypeOf(m, g) : m.__proto__ = g);
          }
          var h = function(m) {
            c(g, m);
            function g(v, p) {
              d(this, g);
              var y = f(this, (g.__proto__ || Object.getPrototypeOf(g)).call(this, v));
              return y.container.classList.add("ql-icon-picker"), [].forEach.call(y.container.querySelectorAll(".ql-picker-item"), function(C) {
                C.innerHTML = p[C.getAttribute("data-value") || ""];
              }), y.defaultItem = y.container.querySelector(".ql-selected"), y.selectItem(y.defaultItem), y;
            }
            return r(g, [{
              key: "selectItem",
              value: function(p, y) {
                a(g.prototype.__proto__ || Object.getPrototypeOf(g.prototype), "selectItem", this).call(this, p, y), p = p || this.defaultItem, this.label.innerHTML = p.innerHTML;
              }
            }]), g;
          }(s.default);
          o.default = h;
        },
        /* 61 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function s(u, d) {
              for (var f = 0; f < d.length; f++) {
                var c = d[f];
                c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(u, c.key, c);
              }
            }
            return function(u, d, f) {
              return d && s(u.prototype, d), f && s(u, f), u;
            };
          }();
          function a(s, u) {
            if (!(s instanceof u))
              throw new TypeError("Cannot call a class as a function");
          }
          var l = function() {
            function s(u, d) {
              var f = this;
              a(this, s), this.quill = u, this.boundsContainer = d || document.body, this.root = u.addContainer("ql-tooltip"), this.root.innerHTML = this.constructor.TEMPLATE, this.quill.root === this.quill.scrollingContainer && this.quill.root.addEventListener("scroll", function() {
                f.root.style.marginTop = -1 * f.quill.root.scrollTop + "px";
              }), this.hide();
            }
            return r(s, [{
              key: "hide",
              value: function() {
                this.root.classList.add("ql-hidden");
              }
            }, {
              key: "position",
              value: function(d) {
                var f = d.left + d.width / 2 - this.root.offsetWidth / 2, c = d.bottom + this.quill.root.scrollTop;
                this.root.style.left = f + "px", this.root.style.top = c + "px", this.root.classList.remove("ql-flip");
                var h = this.boundsContainer.getBoundingClientRect(), m = this.root.getBoundingClientRect(), g = 0;
                if (m.right > h.right && (g = h.right - m.right, this.root.style.left = f + g + "px"), m.left < h.left && (g = h.left - m.left, this.root.style.left = f + g + "px"), m.bottom > h.bottom) {
                  var v = m.bottom - m.top, p = d.bottom - d.top + v;
                  this.root.style.top = c - p + "px", this.root.classList.add("ql-flip");
                }
                return g;
              }
            }, {
              key: "show",
              value: function() {
                this.root.classList.remove("ql-editing"), this.root.classList.remove("ql-hidden");
              }
            }]), s;
          }();
          o.default = l;
        },
        /* 62 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function O(k, S) {
              var T = [], L = !0, F = !1, U = void 0;
              try {
                for (var W = k[Symbol.iterator](), oe; !(L = (oe = W.next()).done) && (T.push(oe.value), !(S && T.length === S)); L = !0)
                  ;
              } catch (H) {
                F = !0, U = H;
              } finally {
                try {
                  !L && W.return && W.return();
                } finally {
                  if (F)
                    throw U;
                }
              }
              return T;
            }
            return function(k, S) {
              if (Array.isArray(k))
                return k;
              if (Symbol.iterator in Object(k))
                return O(k, S);
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            };
          }(), a = function O(k, S, T) {
            k === null && (k = Function.prototype);
            var L = Object.getOwnPropertyDescriptor(k, S);
            if (L === void 0) {
              var F = Object.getPrototypeOf(k);
              return F === null ? void 0 : O(F, S, T);
            } else {
              if ("value" in L)
                return L.value;
              var U = L.get;
              return U === void 0 ? void 0 : U.call(T);
            }
          }, l = function() {
            function O(k, S) {
              for (var T = 0; T < S.length; T++) {
                var L = S[T];
                L.enumerable = L.enumerable || !1, L.configurable = !0, "value" in L && (L.writable = !0), Object.defineProperty(k, L.key, L);
              }
            }
            return function(k, S, T) {
              return S && O(k.prototype, S), T && O(k, T), k;
            };
          }(), s = i(3), u = C(s), d = i(8), f = C(d), c = i(43), h = C(c), m = i(27), g = C(m), v = i(15), p = i(41), y = C(p);
          function C(O) {
            return O && O.__esModule ? O : { default: O };
          }
          function b(O, k) {
            if (!(O instanceof k))
              throw new TypeError("Cannot call a class as a function");
          }
          function x(O, k) {
            if (!O)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return k && (typeof k == "object" || typeof k == "function") ? k : O;
          }
          function w(O, k) {
            if (typeof k != "function" && k !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof k);
            O.prototype = Object.create(k && k.prototype, { constructor: { value: O, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(O, k) : O.__proto__ = k);
          }
          var $ = [[{ header: ["1", "2", "3", !1] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]], E = function(O) {
            w(k, O);
            function k(S, T) {
              b(this, k), T.modules.toolbar != null && T.modules.toolbar.container == null && (T.modules.toolbar.container = $);
              var L = x(this, (k.__proto__ || Object.getPrototypeOf(k)).call(this, S, T));
              return L.quill.container.classList.add("ql-snow"), L;
            }
            return l(k, [{
              key: "extendToolbar",
              value: function(T) {
                T.container.classList.add("ql-snow"), this.buildButtons([].slice.call(T.container.querySelectorAll("button")), y.default), this.buildPickers([].slice.call(T.container.querySelectorAll("select")), y.default), this.tooltip = new A(this.quill, this.options.bounds), T.container.querySelector(".ql-link") && this.quill.keyboard.addBinding({ key: "K", shortKey: !0 }, function(L, F) {
                  T.handlers.link.call(T, !F.format.link);
                });
              }
            }]), k;
          }(h.default);
          E.DEFAULTS = (0, u.default)(!0, {}, h.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  link: function(k) {
                    if (k) {
                      var S = this.quill.getSelection();
                      if (S == null || S.length == 0)
                        return;
                      var T = this.quill.getText(S);
                      /^\S+@\S+\.\S+$/.test(T) && T.indexOf("mailto:") !== 0 && (T = "mailto:" + T);
                      var L = this.quill.theme.tooltip;
                      L.edit("link", T);
                    } else
                      this.quill.format("link", !1);
                  }
                }
              }
            }
          });
          var A = function(O) {
            w(k, O);
            function k(S, T) {
              b(this, k);
              var L = x(this, (k.__proto__ || Object.getPrototypeOf(k)).call(this, S, T));
              return L.preview = L.root.querySelector("a.ql-preview"), L;
            }
            return l(k, [{
              key: "listen",
              value: function() {
                var T = this;
                a(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "listen", this).call(this), this.root.querySelector("a.ql-action").addEventListener("click", function(L) {
                  T.root.classList.contains("ql-editing") ? T.save() : T.edit("link", T.preview.textContent), L.preventDefault();
                }), this.root.querySelector("a.ql-remove").addEventListener("click", function(L) {
                  if (T.linkRange != null) {
                    var F = T.linkRange;
                    T.restoreFocus(), T.quill.formatText(F, "link", !1, f.default.sources.USER), delete T.linkRange;
                  }
                  L.preventDefault(), T.hide();
                }), this.quill.on(f.default.events.SELECTION_CHANGE, function(L, F, U) {
                  if (L != null) {
                    if (L.length === 0 && U === f.default.sources.USER) {
                      var W = T.quill.scroll.descendant(g.default, L.index), oe = r(W, 2), H = oe[0], B = oe[1];
                      if (H != null) {
                        T.linkRange = new v.Range(L.index - B, H.length());
                        var D = g.default.formats(H.domNode);
                        T.preview.textContent = D, T.preview.setAttribute("href", D), T.show(), T.position(T.quill.getBounds(T.linkRange));
                        return;
                      }
                    } else
                      delete T.linkRange;
                    T.hide();
                  }
                });
              }
            }, {
              key: "show",
              value: function() {
                a(k.prototype.__proto__ || Object.getPrototypeOf(k.prototype), "show", this).call(this), this.root.removeAttribute("data-mode");
              }
            }]), k;
          }(c.BaseTooltip);
          A.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join(""), o.default = E;
        },
        /* 63 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(29), a = he(r), l = i(36), s = i(38), u = i(64), d = i(65), f = he(d), c = i(66), h = he(c), m = i(67), g = he(m), v = i(37), p = i(26), y = i(39), C = i(40), b = i(56), x = he(b), w = i(68), $ = he(w), E = i(27), A = he(E), O = i(69), k = he(O), S = i(70), T = he(S), L = i(71), F = he(L), U = i(72), W = he(U), oe = i(73), H = he(oe), B = i(13), D = he(B), V = i(74), q = he(V), Z = i(75), Y = he(Z), R = i(57), K = he(R), te = i(41), ne = he(te), fe = i(28), Ce = he(fe), Oe = i(59), Ae = he(Oe), De = i(60), qe = he(De), $t = i(61), st = he($t), se = i(108), ue = he(se), ve = i(62), ye = he(ve);
          function he(we) {
            return we && we.__esModule ? we : { default: we };
          }
          a.default.register({
            "attributors/attribute/direction": s.DirectionAttribute,
            "attributors/class/align": l.AlignClass,
            "attributors/class/background": v.BackgroundClass,
            "attributors/class/color": p.ColorClass,
            "attributors/class/direction": s.DirectionClass,
            "attributors/class/font": y.FontClass,
            "attributors/class/size": C.SizeClass,
            "attributors/style/align": l.AlignStyle,
            "attributors/style/background": v.BackgroundStyle,
            "attributors/style/color": p.ColorStyle,
            "attributors/style/direction": s.DirectionStyle,
            "attributors/style/font": y.FontStyle,
            "attributors/style/size": C.SizeStyle
          }, !0), a.default.register({
            "formats/align": l.AlignClass,
            "formats/direction": s.DirectionClass,
            "formats/indent": u.IndentClass,
            "formats/background": v.BackgroundStyle,
            "formats/color": p.ColorStyle,
            "formats/font": y.FontClass,
            "formats/size": C.SizeClass,
            "formats/blockquote": f.default,
            "formats/code-block": D.default,
            "formats/header": h.default,
            "formats/list": g.default,
            "formats/bold": x.default,
            "formats/code": B.Code,
            "formats/italic": $.default,
            "formats/link": A.default,
            "formats/script": k.default,
            "formats/strike": T.default,
            "formats/underline": F.default,
            "formats/image": W.default,
            "formats/video": H.default,
            "formats/list/item": m.ListItem,
            "modules/formula": q.default,
            "modules/syntax": Y.default,
            "modules/toolbar": K.default,
            "themes/bubble": ue.default,
            "themes/snow": ye.default,
            "ui/icons": ne.default,
            "ui/picker": Ce.default,
            "ui/icon-picker": qe.default,
            "ui/color-picker": Ae.default,
            "ui/tooltip": st.default
          }, !0), o.default = a.default;
        },
        /* 64 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.IndentClass = void 0;
          var r = function() {
            function g(v, p) {
              for (var y = 0; y < p.length; y++) {
                var C = p[y];
                C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(v, C.key, C);
              }
            }
            return function(v, p, y) {
              return p && g(v.prototype, p), y && g(v, y), v;
            };
          }(), a = function g(v, p, y) {
            v === null && (v = Function.prototype);
            var C = Object.getOwnPropertyDescriptor(v, p);
            if (C === void 0) {
              var b = Object.getPrototypeOf(v);
              return b === null ? void 0 : g(b, p, y);
            } else {
              if ("value" in C)
                return C.value;
              var x = C.get;
              return x === void 0 ? void 0 : x.call(y);
            }
          }, l = i(0), s = u(l);
          function u(g) {
            return g && g.__esModule ? g : { default: g };
          }
          function d(g, v) {
            if (!(g instanceof v))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(g, v) {
            if (!g)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return v && (typeof v == "object" || typeof v == "function") ? v : g;
          }
          function c(g, v) {
            if (typeof v != "function" && v !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof v);
            g.prototype = Object.create(v && v.prototype, { constructor: { value: g, enumerable: !1, writable: !0, configurable: !0 } }), v && (Object.setPrototypeOf ? Object.setPrototypeOf(g, v) : g.__proto__ = v);
          }
          var h = function(g) {
            c(v, g);
            function v() {
              return d(this, v), f(this, (v.__proto__ || Object.getPrototypeOf(v)).apply(this, arguments));
            }
            return r(v, [{
              key: "add",
              value: function(y, C) {
                if (C === "+1" || C === "-1") {
                  var b = this.value(y) || 0;
                  C = C === "+1" ? b + 1 : b - 1;
                }
                return C === 0 ? (this.remove(y), !0) : a(v.prototype.__proto__ || Object.getPrototypeOf(v.prototype), "add", this).call(this, y, C);
              }
            }, {
              key: "canAdd",
              value: function(y, C) {
                return a(v.prototype.__proto__ || Object.getPrototypeOf(v.prototype), "canAdd", this).call(this, y, C) || a(v.prototype.__proto__ || Object.getPrototypeOf(v.prototype), "canAdd", this).call(this, y, parseInt(C));
              }
            }, {
              key: "value",
              value: function(y) {
                return parseInt(a(v.prototype.__proto__ || Object.getPrototypeOf(v.prototype), "value", this).call(this, y)) || void 0;
              }
            }]), v;
          }(s.default.Attributor.Class), m = new h("indent", "ql-indent", {
            scope: s.default.Scope.BLOCK,
            whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
          });
          o.IndentClass = m;
        },
        /* 65 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(4), a = l(r);
          function l(c) {
            return c && c.__esModule ? c : { default: c };
          }
          function s(c, h) {
            if (!(c instanceof h))
              throw new TypeError("Cannot call a class as a function");
          }
          function u(c, h) {
            if (!c)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return h && (typeof h == "object" || typeof h == "function") ? h : c;
          }
          function d(c, h) {
            if (typeof h != "function" && h !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof h);
            c.prototype = Object.create(h && h.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), h && (Object.setPrototypeOf ? Object.setPrototypeOf(c, h) : c.__proto__ = h);
          }
          var f = function(c) {
            d(h, c);
            function h() {
              return s(this, h), u(this, (h.__proto__ || Object.getPrototypeOf(h)).apply(this, arguments));
            }
            return h;
          }(a.default);
          f.blotName = "blockquote", f.tagName = "blockquote", o.default = f;
        },
        /* 66 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function h(m, g) {
              for (var v = 0; v < g.length; v++) {
                var p = g[v];
                p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(m, p.key, p);
              }
            }
            return function(m, g, v) {
              return g && h(m.prototype, g), v && h(m, v), m;
            };
          }(), a = i(4), l = s(a);
          function s(h) {
            return h && h.__esModule ? h : { default: h };
          }
          function u(h, m) {
            if (!(h instanceof m))
              throw new TypeError("Cannot call a class as a function");
          }
          function d(h, m) {
            if (!h)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return m && (typeof m == "object" || typeof m == "function") ? m : h;
          }
          function f(h, m) {
            if (typeof m != "function" && m !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof m);
            h.prototype = Object.create(m && m.prototype, { constructor: { value: h, enumerable: !1, writable: !0, configurable: !0 } }), m && (Object.setPrototypeOf ? Object.setPrototypeOf(h, m) : h.__proto__ = m);
          }
          var c = function(h) {
            f(m, h);
            function m() {
              return u(this, m), d(this, (m.__proto__ || Object.getPrototypeOf(m)).apply(this, arguments));
            }
            return r(m, null, [{
              key: "formats",
              value: function(v) {
                return this.tagName.indexOf(v.tagName) + 1;
              }
            }]), m;
          }(l.default);
          c.blotName = "header", c.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"], o.default = c;
        },
        /* 67 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.ListItem = void 0;
          var r = function() {
            function b(x, w) {
              for (var $ = 0; $ < w.length; $++) {
                var E = w[$];
                E.enumerable = E.enumerable || !1, E.configurable = !0, "value" in E && (E.writable = !0), Object.defineProperty(x, E.key, E);
              }
            }
            return function(x, w, $) {
              return w && b(x.prototype, w), $ && b(x, $), x;
            };
          }(), a = function b(x, w, $) {
            x === null && (x = Function.prototype);
            var E = Object.getOwnPropertyDescriptor(x, w);
            if (E === void 0) {
              var A = Object.getPrototypeOf(x);
              return A === null ? void 0 : b(A, w, $);
            } else {
              if ("value" in E)
                return E.value;
              var O = E.get;
              return O === void 0 ? void 0 : O.call($);
            }
          }, l = i(0), s = h(l), u = i(4), d = h(u), f = i(25), c = h(f);
          function h(b) {
            return b && b.__esModule ? b : { default: b };
          }
          function m(b, x, w) {
            return x in b ? Object.defineProperty(b, x, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : b[x] = w, b;
          }
          function g(b, x) {
            if (!(b instanceof x))
              throw new TypeError("Cannot call a class as a function");
          }
          function v(b, x) {
            if (!b)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return x && (typeof x == "object" || typeof x == "function") ? x : b;
          }
          function p(b, x) {
            if (typeof x != "function" && x !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof x);
            b.prototype = Object.create(x && x.prototype, { constructor: { value: b, enumerable: !1, writable: !0, configurable: !0 } }), x && (Object.setPrototypeOf ? Object.setPrototypeOf(b, x) : b.__proto__ = x);
          }
          var y = function(b) {
            p(x, b);
            function x() {
              return g(this, x), v(this, (x.__proto__ || Object.getPrototypeOf(x)).apply(this, arguments));
            }
            return r(x, [{
              key: "format",
              value: function($, E) {
                $ === C.blotName && !E ? this.replaceWith(s.default.create(this.statics.scope)) : a(x.prototype.__proto__ || Object.getPrototypeOf(x.prototype), "format", this).call(this, $, E);
              }
            }, {
              key: "remove",
              value: function() {
                this.prev == null && this.next == null ? this.parent.remove() : a(x.prototype.__proto__ || Object.getPrototypeOf(x.prototype), "remove", this).call(this);
              }
            }, {
              key: "replaceWith",
              value: function($, E) {
                return this.parent.isolate(this.offset(this.parent), this.length()), $ === this.parent.statics.blotName ? (this.parent.replaceWith($, E), this) : (this.parent.unwrap(), a(x.prototype.__proto__ || Object.getPrototypeOf(x.prototype), "replaceWith", this).call(this, $, E));
              }
            }], [{
              key: "formats",
              value: function($) {
                return $.tagName === this.tagName ? void 0 : a(x.__proto__ || Object.getPrototypeOf(x), "formats", this).call(this, $);
              }
            }]), x;
          }(d.default);
          y.blotName = "list-item", y.tagName = "LI";
          var C = function(b) {
            p(x, b), r(x, null, [{
              key: "create",
              value: function($) {
                var E = $ === "ordered" ? "OL" : "UL", A = a(x.__proto__ || Object.getPrototypeOf(x), "create", this).call(this, E);
                return ($ === "checked" || $ === "unchecked") && A.setAttribute("data-checked", $ === "checked"), A;
              }
            }, {
              key: "formats",
              value: function($) {
                if ($.tagName === "OL")
                  return "ordered";
                if ($.tagName === "UL")
                  return $.hasAttribute("data-checked") ? $.getAttribute("data-checked") === "true" ? "checked" : "unchecked" : "bullet";
              }
            }]);
            function x(w) {
              g(this, x);
              var $ = v(this, (x.__proto__ || Object.getPrototypeOf(x)).call(this, w)), E = function(O) {
                if (O.target.parentNode === w) {
                  var k = $.statics.formats(w), S = s.default.find(O.target);
                  k === "checked" ? S.format("list", "unchecked") : k === "unchecked" && S.format("list", "checked");
                }
              };
              return w.addEventListener("touchstart", E), w.addEventListener("mousedown", E), $;
            }
            return r(x, [{
              key: "format",
              value: function($, E) {
                this.children.length > 0 && this.children.tail.format($, E);
              }
            }, {
              key: "formats",
              value: function() {
                return m({}, this.statics.blotName, this.statics.formats(this.domNode));
              }
            }, {
              key: "insertBefore",
              value: function($, E) {
                if ($ instanceof y)
                  a(x.prototype.__proto__ || Object.getPrototypeOf(x.prototype), "insertBefore", this).call(this, $, E);
                else {
                  var A = E == null ? this.length() : E.offset(this), O = this.split(A);
                  O.parent.insertBefore($, O);
                }
              }
            }, {
              key: "optimize",
              value: function($) {
                a(x.prototype.__proto__ || Object.getPrototypeOf(x.prototype), "optimize", this).call(this, $);
                var E = this.next;
                E != null && E.prev === this && E.statics.blotName === this.statics.blotName && E.domNode.tagName === this.domNode.tagName && E.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked") && (E.moveChildren(this), E.remove());
              }
            }, {
              key: "replace",
              value: function($) {
                if ($.statics.blotName !== this.statics.blotName) {
                  var E = s.default.create(this.statics.defaultChild);
                  $.moveChildren(E), this.appendChild(E);
                }
                a(x.prototype.__proto__ || Object.getPrototypeOf(x.prototype), "replace", this).call(this, $);
              }
            }]), x;
          }(c.default);
          C.blotName = "list", C.scope = s.default.Scope.BLOCK_BLOT, C.tagName = ["OL", "UL"], C.defaultChild = "list-item", C.allowedChildren = [y], o.ListItem = y, o.default = C;
        },
        /* 68 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(56), a = l(r);
          function l(c) {
            return c && c.__esModule ? c : { default: c };
          }
          function s(c, h) {
            if (!(c instanceof h))
              throw new TypeError("Cannot call a class as a function");
          }
          function u(c, h) {
            if (!c)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return h && (typeof h == "object" || typeof h == "function") ? h : c;
          }
          function d(c, h) {
            if (typeof h != "function" && h !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof h);
            c.prototype = Object.create(h && h.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), h && (Object.setPrototypeOf ? Object.setPrototypeOf(c, h) : c.__proto__ = h);
          }
          var f = function(c) {
            d(h, c);
            function h() {
              return s(this, h), u(this, (h.__proto__ || Object.getPrototypeOf(h)).apply(this, arguments));
            }
            return h;
          }(a.default);
          f.blotName = "italic", f.tagName = ["EM", "I"], o.default = f;
        },
        /* 69 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function m(g, v) {
              for (var p = 0; p < v.length; p++) {
                var y = v[p];
                y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(g, y.key, y);
              }
            }
            return function(g, v, p) {
              return v && m(g.prototype, v), p && m(g, p), g;
            };
          }(), a = function m(g, v, p) {
            g === null && (g = Function.prototype);
            var y = Object.getOwnPropertyDescriptor(g, v);
            if (y === void 0) {
              var C = Object.getPrototypeOf(g);
              return C === null ? void 0 : m(C, v, p);
            } else {
              if ("value" in y)
                return y.value;
              var b = y.get;
              return b === void 0 ? void 0 : b.call(p);
            }
          }, l = i(6), s = u(l);
          function u(m) {
            return m && m.__esModule ? m : { default: m };
          }
          function d(m, g) {
            if (!(m instanceof g))
              throw new TypeError("Cannot call a class as a function");
          }
          function f(m, g) {
            if (!m)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return g && (typeof g == "object" || typeof g == "function") ? g : m;
          }
          function c(m, g) {
            if (typeof g != "function" && g !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof g);
            m.prototype = Object.create(g && g.prototype, { constructor: { value: m, enumerable: !1, writable: !0, configurable: !0 } }), g && (Object.setPrototypeOf ? Object.setPrototypeOf(m, g) : m.__proto__ = g);
          }
          var h = function(m) {
            c(g, m);
            function g() {
              return d(this, g), f(this, (g.__proto__ || Object.getPrototypeOf(g)).apply(this, arguments));
            }
            return r(g, null, [{
              key: "create",
              value: function(p) {
                return p === "super" ? document.createElement("sup") : p === "sub" ? document.createElement("sub") : a(g.__proto__ || Object.getPrototypeOf(g), "create", this).call(this, p);
              }
            }, {
              key: "formats",
              value: function(p) {
                if (p.tagName === "SUB")
                  return "sub";
                if (p.tagName === "SUP")
                  return "super";
              }
            }]), g;
          }(s.default);
          h.blotName = "script", h.tagName = ["SUB", "SUP"], o.default = h;
        },
        /* 70 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(6), a = l(r);
          function l(c) {
            return c && c.__esModule ? c : { default: c };
          }
          function s(c, h) {
            if (!(c instanceof h))
              throw new TypeError("Cannot call a class as a function");
          }
          function u(c, h) {
            if (!c)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return h && (typeof h == "object" || typeof h == "function") ? h : c;
          }
          function d(c, h) {
            if (typeof h != "function" && h !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof h);
            c.prototype = Object.create(h && h.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), h && (Object.setPrototypeOf ? Object.setPrototypeOf(c, h) : c.__proto__ = h);
          }
          var f = function(c) {
            d(h, c);
            function h() {
              return s(this, h), u(this, (h.__proto__ || Object.getPrototypeOf(h)).apply(this, arguments));
            }
            return h;
          }(a.default);
          f.blotName = "strike", f.tagName = "S", o.default = f;
        },
        /* 71 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = i(6), a = l(r);
          function l(c) {
            return c && c.__esModule ? c : { default: c };
          }
          function s(c, h) {
            if (!(c instanceof h))
              throw new TypeError("Cannot call a class as a function");
          }
          function u(c, h) {
            if (!c)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return h && (typeof h == "object" || typeof h == "function") ? h : c;
          }
          function d(c, h) {
            if (typeof h != "function" && h !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof h);
            c.prototype = Object.create(h && h.prototype, { constructor: { value: c, enumerable: !1, writable: !0, configurable: !0 } }), h && (Object.setPrototypeOf ? Object.setPrototypeOf(c, h) : c.__proto__ = h);
          }
          var f = function(c) {
            d(h, c);
            function h() {
              return s(this, h), u(this, (h.__proto__ || Object.getPrototypeOf(h)).apply(this, arguments));
            }
            return h;
          }(a.default);
          f.blotName = "underline", f.tagName = "U", o.default = f;
        },
        /* 72 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function v(p, y) {
              for (var C = 0; C < y.length; C++) {
                var b = y[C];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(p, b.key, b);
              }
            }
            return function(p, y, C) {
              return y && v(p.prototype, y), C && v(p, C), p;
            };
          }(), a = function v(p, y, C) {
            p === null && (p = Function.prototype);
            var b = Object.getOwnPropertyDescriptor(p, y);
            if (b === void 0) {
              var x = Object.getPrototypeOf(p);
              return x === null ? void 0 : v(x, y, C);
            } else {
              if ("value" in b)
                return b.value;
              var w = b.get;
              return w === void 0 ? void 0 : w.call(C);
            }
          }, l = i(0), s = d(l), u = i(27);
          function d(v) {
            return v && v.__esModule ? v : { default: v };
          }
          function f(v, p) {
            if (!(v instanceof p))
              throw new TypeError("Cannot call a class as a function");
          }
          function c(v, p) {
            if (!v)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return p && (typeof p == "object" || typeof p == "function") ? p : v;
          }
          function h(v, p) {
            if (typeof p != "function" && p !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof p);
            v.prototype = Object.create(p && p.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }), p && (Object.setPrototypeOf ? Object.setPrototypeOf(v, p) : v.__proto__ = p);
          }
          var m = ["alt", "height", "width"], g = function(v) {
            h(p, v);
            function p() {
              return f(this, p), c(this, (p.__proto__ || Object.getPrototypeOf(p)).apply(this, arguments));
            }
            return r(p, [{
              key: "format",
              value: function(C, b) {
                m.indexOf(C) > -1 ? b ? this.domNode.setAttribute(C, b) : this.domNode.removeAttribute(C) : a(p.prototype.__proto__ || Object.getPrototypeOf(p.prototype), "format", this).call(this, C, b);
              }
            }], [{
              key: "create",
              value: function(C) {
                var b = a(p.__proto__ || Object.getPrototypeOf(p), "create", this).call(this, C);
                return typeof C == "string" && b.setAttribute("src", this.sanitize(C)), b;
              }
            }, {
              key: "formats",
              value: function(C) {
                return m.reduce(function(b, x) {
                  return C.hasAttribute(x) && (b[x] = C.getAttribute(x)), b;
                }, {});
              }
            }, {
              key: "match",
              value: function(C) {
                return /\.(jpe?g|gif|png)$/.test(C) || /^data:image\/.+;base64/.test(C);
              }
            }, {
              key: "sanitize",
              value: function(C) {
                return (0, u.sanitize)(C, ["http", "https", "data"]) ? C : "//:0";
              }
            }, {
              key: "value",
              value: function(C) {
                return C.getAttribute("src");
              }
            }]), p;
          }(s.default.Embed);
          g.blotName = "image", g.tagName = "IMG", o.default = g;
        },
        /* 73 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          });
          var r = function() {
            function v(p, y) {
              for (var C = 0; C < y.length; C++) {
                var b = y[C];
                b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(p, b.key, b);
              }
            }
            return function(p, y, C) {
              return y && v(p.prototype, y), C && v(p, C), p;
            };
          }(), a = function v(p, y, C) {
            p === null && (p = Function.prototype);
            var b = Object.getOwnPropertyDescriptor(p, y);
            if (b === void 0) {
              var x = Object.getPrototypeOf(p);
              return x === null ? void 0 : v(x, y, C);
            } else {
              if ("value" in b)
                return b.value;
              var w = b.get;
              return w === void 0 ? void 0 : w.call(C);
            }
          }, l = i(4), s = i(27), u = d(s);
          function d(v) {
            return v && v.__esModule ? v : { default: v };
          }
          function f(v, p) {
            if (!(v instanceof p))
              throw new TypeError("Cannot call a class as a function");
          }
          function c(v, p) {
            if (!v)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return p && (typeof p == "object" || typeof p == "function") ? p : v;
          }
          function h(v, p) {
            if (typeof p != "function" && p !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof p);
            v.prototype = Object.create(p && p.prototype, { constructor: { value: v, enumerable: !1, writable: !0, configurable: !0 } }), p && (Object.setPrototypeOf ? Object.setPrototypeOf(v, p) : v.__proto__ = p);
          }
          var m = ["height", "width"], g = function(v) {
            h(p, v);
            function p() {
              return f(this, p), c(this, (p.__proto__ || Object.getPrototypeOf(p)).apply(this, arguments));
            }
            return r(p, [{
              key: "format",
              value: function(C, b) {
                m.indexOf(C) > -1 ? b ? this.domNode.setAttribute(C, b) : this.domNode.removeAttribute(C) : a(p.prototype.__proto__ || Object.getPrototypeOf(p.prototype), "format", this).call(this, C, b);
              }
            }], [{
              key: "create",
              value: function(C) {
                var b = a(p.__proto__ || Object.getPrototypeOf(p), "create", this).call(this, C);
                return b.setAttribute("frameborder", "0"), b.setAttribute("allowfullscreen", !0), b.setAttribute("src", this.sanitize(C)), b;
              }
            }, {
              key: "formats",
              value: function(C) {
                return m.reduce(function(b, x) {
                  return C.hasAttribute(x) && (b[x] = C.getAttribute(x)), b;
                }, {});
              }
            }, {
              key: "sanitize",
              value: function(C) {
                return u.default.sanitize(C);
              }
            }, {
              key: "value",
              value: function(C) {
                return C.getAttribute("src");
              }
            }]), p;
          }(l.BlockEmbed);
          g.blotName = "video", g.className = "ql-video", g.tagName = "IFRAME", o.default = g;
        },
        /* 74 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.FormulaBlot = void 0;
          var r = function() {
            function C(b, x) {
              for (var w = 0; w < x.length; w++) {
                var $ = x[w];
                $.enumerable = $.enumerable || !1, $.configurable = !0, "value" in $ && ($.writable = !0), Object.defineProperty(b, $.key, $);
              }
            }
            return function(b, x, w) {
              return x && C(b.prototype, x), w && C(b, w), b;
            };
          }(), a = function C(b, x, w) {
            b === null && (b = Function.prototype);
            var $ = Object.getOwnPropertyDescriptor(b, x);
            if ($ === void 0) {
              var E = Object.getPrototypeOf(b);
              return E === null ? void 0 : C(E, x, w);
            } else {
              if ("value" in $)
                return $.value;
              var A = $.get;
              return A === void 0 ? void 0 : A.call(w);
            }
          }, l = i(35), s = h(l), u = i(5), d = h(u), f = i(9), c = h(f);
          function h(C) {
            return C && C.__esModule ? C : { default: C };
          }
          function m(C, b) {
            if (!(C instanceof b))
              throw new TypeError("Cannot call a class as a function");
          }
          function g(C, b) {
            if (!C)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return b && (typeof b == "object" || typeof b == "function") ? b : C;
          }
          function v(C, b) {
            if (typeof b != "function" && b !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof b);
            C.prototype = Object.create(b && b.prototype, { constructor: { value: C, enumerable: !1, writable: !0, configurable: !0 } }), b && (Object.setPrototypeOf ? Object.setPrototypeOf(C, b) : C.__proto__ = b);
          }
          var p = function(C) {
            v(b, C);
            function b() {
              return m(this, b), g(this, (b.__proto__ || Object.getPrototypeOf(b)).apply(this, arguments));
            }
            return r(b, null, [{
              key: "create",
              value: function(w) {
                var $ = a(b.__proto__ || Object.getPrototypeOf(b), "create", this).call(this, w);
                return typeof w == "string" && (window.katex.render(w, $, {
                  throwOnError: !1,
                  errorColor: "#f00"
                }), $.setAttribute("data-value", w)), $;
              }
            }, {
              key: "value",
              value: function(w) {
                return w.getAttribute("data-value");
              }
            }]), b;
          }(s.default);
          p.blotName = "formula", p.className = "ql-formula", p.tagName = "SPAN";
          var y = function(C) {
            v(b, C), r(b, null, [{
              key: "register",
              value: function() {
                d.default.register(p, !0);
              }
            }]);
            function b() {
              m(this, b);
              var x = g(this, (b.__proto__ || Object.getPrototypeOf(b)).call(this));
              if (window.katex == null)
                throw new Error("Formula module requires KaTeX.");
              return x;
            }
            return b;
          }(c.default);
          o.FormulaBlot = p, o.default = y;
        },
        /* 75 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.CodeToken = o.CodeBlock = void 0;
          var r = function() {
            function w($, E) {
              for (var A = 0; A < E.length; A++) {
                var O = E[A];
                O.enumerable = O.enumerable || !1, O.configurable = !0, "value" in O && (O.writable = !0), Object.defineProperty($, O.key, O);
              }
            }
            return function($, E, A) {
              return E && w($.prototype, E), A && w($, A), $;
            };
          }(), a = function w($, E, A) {
            $ === null && ($ = Function.prototype);
            var O = Object.getOwnPropertyDescriptor($, E);
            if (O === void 0) {
              var k = Object.getPrototypeOf($);
              return k === null ? void 0 : w(k, E, A);
            } else {
              if ("value" in O)
                return O.value;
              var S = O.get;
              return S === void 0 ? void 0 : S.call(A);
            }
          }, l = i(0), s = g(l), u = i(5), d = g(u), f = i(9), c = g(f), h = i(13), m = g(h);
          function g(w) {
            return w && w.__esModule ? w : { default: w };
          }
          function v(w, $) {
            if (!(w instanceof $))
              throw new TypeError("Cannot call a class as a function");
          }
          function p(w, $) {
            if (!w)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return $ && (typeof $ == "object" || typeof $ == "function") ? $ : w;
          }
          function y(w, $) {
            if (typeof $ != "function" && $ !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof $);
            w.prototype = Object.create($ && $.prototype, { constructor: { value: w, enumerable: !1, writable: !0, configurable: !0 } }), $ && (Object.setPrototypeOf ? Object.setPrototypeOf(w, $) : w.__proto__ = $);
          }
          var C = function(w) {
            y($, w);
            function $() {
              return v(this, $), p(this, ($.__proto__ || Object.getPrototypeOf($)).apply(this, arguments));
            }
            return r($, [{
              key: "replaceWith",
              value: function(A) {
                this.domNode.textContent = this.domNode.textContent, this.attach(), a($.prototype.__proto__ || Object.getPrototypeOf($.prototype), "replaceWith", this).call(this, A);
              }
            }, {
              key: "highlight",
              value: function(A) {
                var O = this.domNode.textContent;
                this.cachedText !== O && ((O.trim().length > 0 || this.cachedText == null) && (this.domNode.innerHTML = A(O), this.domNode.normalize(), this.attach()), this.cachedText = O);
              }
            }]), $;
          }(m.default);
          C.className = "ql-syntax";
          var b = new s.default.Attributor.Class("token", "hljs", {
            scope: s.default.Scope.INLINE
          }), x = function(w) {
            y($, w), r($, null, [{
              key: "register",
              value: function() {
                d.default.register(b, !0), d.default.register(C, !0);
              }
            }]);
            function $(E, A) {
              v(this, $);
              var O = p(this, ($.__proto__ || Object.getPrototypeOf($)).call(this, E, A));
              if (typeof O.options.highlight != "function")
                throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
              var k = null;
              return O.quill.on(d.default.events.SCROLL_OPTIMIZE, function() {
                clearTimeout(k), k = setTimeout(function() {
                  O.highlight(), k = null;
                }, O.options.interval);
              }), O.highlight(), O;
            }
            return r($, [{
              key: "highlight",
              value: function() {
                var A = this;
                if (!this.quill.selection.composing) {
                  this.quill.update(d.default.sources.USER);
                  var O = this.quill.getSelection();
                  this.quill.scroll.descendants(C).forEach(function(k) {
                    k.highlight(A.options.highlight);
                  }), this.quill.update(d.default.sources.SILENT), O != null && this.quill.setSelection(O, d.default.sources.SILENT);
                }
              }
            }]), $;
          }(c.default);
          x.DEFAULTS = {
            highlight: function() {
              return window.hljs == null ? null : function(w) {
                var $ = window.hljs.highlightAuto(w);
                return $.value;
              };
            }(),
            interval: 1e3
          }, o.CodeBlock = C, o.CodeToken = b, o.default = x;
        },
        /* 76 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
        },
        /* 77 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
        },
        /* 78 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
        },
        /* 79 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
        },
        /* 80 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
        },
        /* 81 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
        },
        /* 82 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
        },
        /* 83 */
        /***/
        function(t, o) {
          t.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
        },
        /* 84 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
        },
        /* 85 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
        },
        /* 86 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
        },
        /* 87 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
        },
        /* 88 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
        },
        /* 89 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
        },
        /* 90 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
        },
        /* 91 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
        },
        /* 92 */
        /***/
        function(t, o) {
          t.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
        },
        /* 93 */
        /***/
        function(t, o) {
          t.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
        },
        /* 94 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
        },
        /* 95 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
        },
        /* 96 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
        },
        /* 97 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
        },
        /* 98 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
        },
        /* 99 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
        },
        /* 100 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
        },
        /* 101 */
        /***/
        function(t, o) {
          t.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
        },
        /* 102 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
        },
        /* 103 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
        },
        /* 104 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
        },
        /* 105 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
        },
        /* 106 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
        },
        /* 107 */
        /***/
        function(t, o) {
          t.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
        },
        /* 108 */
        /***/
        function(t, o, i) {
          Object.defineProperty(o, "__esModule", {
            value: !0
          }), o.default = o.BubbleTooltip = void 0;
          var r = function $(E, A, O) {
            E === null && (E = Function.prototype);
            var k = Object.getOwnPropertyDescriptor(E, A);
            if (k === void 0) {
              var S = Object.getPrototypeOf(E);
              return S === null ? void 0 : $(S, A, O);
            } else {
              if ("value" in k)
                return k.value;
              var T = k.get;
              return T === void 0 ? void 0 : T.call(O);
            }
          }, a = function() {
            function $(E, A) {
              for (var O = 0; O < A.length; O++) {
                var k = A[O];
                k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(E, k.key, k);
              }
            }
            return function(E, A, O) {
              return A && $(E.prototype, A), O && $(E, O), E;
            };
          }(), l = i(3), s = v(l), u = i(8), d = v(u), f = i(43), c = v(f), h = i(15), m = i(41), g = v(m);
          function v($) {
            return $ && $.__esModule ? $ : { default: $ };
          }
          function p($, E) {
            if (!($ instanceof E))
              throw new TypeError("Cannot call a class as a function");
          }
          function y($, E) {
            if (!$)
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return E && (typeof E == "object" || typeof E == "function") ? E : $;
          }
          function C($, E) {
            if (typeof E != "function" && E !== null)
              throw new TypeError("Super expression must either be null or a function, not " + typeof E);
            $.prototype = Object.create(E && E.prototype, { constructor: { value: $, enumerable: !1, writable: !0, configurable: !0 } }), E && (Object.setPrototypeOf ? Object.setPrototypeOf($, E) : $.__proto__ = E);
          }
          var b = [["bold", "italic", "link"], [{ header: 1 }, { header: 2 }, "blockquote"]], x = function($) {
            C(E, $);
            function E(A, O) {
              p(this, E), O.modules.toolbar != null && O.modules.toolbar.container == null && (O.modules.toolbar.container = b);
              var k = y(this, (E.__proto__ || Object.getPrototypeOf(E)).call(this, A, O));
              return k.quill.container.classList.add("ql-bubble"), k;
            }
            return a(E, [{
              key: "extendToolbar",
              value: function(O) {
                this.tooltip = new w(this.quill, this.options.bounds), this.tooltip.root.appendChild(O.container), this.buildButtons([].slice.call(O.container.querySelectorAll("button")), g.default), this.buildPickers([].slice.call(O.container.querySelectorAll("select")), g.default);
              }
            }]), E;
          }(c.default);
          x.DEFAULTS = (0, s.default)(!0, {}, c.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  link: function(E) {
                    E ? this.quill.theme.tooltip.edit() : this.quill.format("link", !1);
                  }
                }
              }
            }
          });
          var w = function($) {
            C(E, $);
            function E(A, O) {
              p(this, E);
              var k = y(this, (E.__proto__ || Object.getPrototypeOf(E)).call(this, A, O));
              return k.quill.on(d.default.events.EDITOR_CHANGE, function(S, T, L, F) {
                if (S === d.default.events.SELECTION_CHANGE)
                  if (T != null && T.length > 0 && F === d.default.sources.USER) {
                    k.show(), k.root.style.left = "0px", k.root.style.width = "", k.root.style.width = k.root.offsetWidth + "px";
                    var U = k.quill.getLines(T.index, T.length);
                    if (U.length === 1)
                      k.position(k.quill.getBounds(T));
                    else {
                      var W = U[U.length - 1], oe = k.quill.getIndex(W), H = Math.min(W.length() - 1, T.index + T.length - oe), B = k.quill.getBounds(new h.Range(oe, H));
                      k.position(B);
                    }
                  } else
                    document.activeElement !== k.textbox && k.quill.hasFocus() && k.hide();
              }), k;
            }
            return a(E, [{
              key: "listen",
              value: function() {
                var O = this;
                r(E.prototype.__proto__ || Object.getPrototypeOf(E.prototype), "listen", this).call(this), this.root.querySelector(".ql-close").addEventListener("click", function() {
                  O.root.classList.remove("ql-editing");
                }), this.quill.on(d.default.events.SCROLL_OPTIMIZE, function() {
                  setTimeout(function() {
                    if (!O.root.classList.contains("ql-hidden")) {
                      var k = O.quill.getSelection();
                      k != null && O.position(O.quill.getBounds(k));
                    }
                  }, 1);
                });
              }
            }, {
              key: "cancel",
              value: function() {
                this.show();
              }
            }, {
              key: "position",
              value: function(O) {
                var k = r(E.prototype.__proto__ || Object.getPrototypeOf(E.prototype), "position", this).call(this, O), S = this.root.querySelector(".ql-tooltip-arrow");
                if (S.style.marginLeft = "", k === 0)
                  return k;
                S.style.marginLeft = -1 * k - S.offsetWidth / 2 + "px";
              }
            }]), E;
          }(f.BaseTooltip);
          w.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join(""), o.BubbleTooltip = w, o.default = x;
        },
        /* 109 */
        /***/
        function(t, o, i) {
          t.exports = i(63);
        }
        /******/
      ]).default
    );
  });
})(D1);
var o9 = D1.exports;
const jr = /* @__PURE__ */ K5(o9), i9 = jr.import("blots/block");
class Wi extends i9 {
  static create(n) {
    const t = super.create(n);
    if (n === !0)
      return t;
    const o = document.createElement("img");
    return o.setAttribute("src", n), t.appendChild(o), t;
  }
  deleteAt(n, t) {
    super.deleteAt(n, t), this.cache = {};
  }
  static value(n) {
    const { src: t, custom: o } = n.dataset;
    return { src: t, custom: o };
  }
}
Wi.blotName = "imageBlot";
Wi.className = "image-uploading";
Wi.tagName = "span";
jr.register({ "formats/imageBlot": Wi });
class L1 {
  constructor(n, t) {
    this.quill = n, this.options = t, this.range = null, this.placeholderDelta = null, typeof this.options.upload != "function" && console.warn(
      "[Missing config] upload function that returns a promise is required"
    );
    var o = this.quill.getModule("toolbar");
    o && o.addHandler("image", this.selectLocalImage.bind(this)), this.handleDrop = this.handleDrop.bind(this), this.handlePaste = this.handlePaste.bind(this), this.quill.root.addEventListener("drop", this.handleDrop, !1), this.quill.root.addEventListener("paste", this.handlePaste, !1);
  }
  selectLocalImage() {
    this.quill.focus(), this.range = this.quill.getSelection(), this.fileHolder = document.createElement("input"), this.fileHolder.setAttribute("type", "file"), this.fileHolder.setAttribute("accept", "image/*"), this.fileHolder.setAttribute("style", "visibility:hidden"), this.fileHolder.onchange = this.fileChanged.bind(this), document.body.appendChild(this.fileHolder), this.fileHolder.click(), window.requestAnimationFrame(() => {
      document.body.removeChild(this.fileHolder);
    });
  }
  handleDrop(n) {
    if (n.dataTransfer && n.dataTransfer.files && n.dataTransfer.files.length) {
      if (n.stopPropagation(), n.preventDefault(), document.caretRangeFromPoint) {
        const o = document.getSelection(), i = document.caretRangeFromPoint(n.clientX, n.clientY);
        o && i && o.setBaseAndExtent(
          i.startContainer,
          i.startOffset,
          i.startContainer,
          i.startOffset
        );
      } else {
        const o = document.getSelection(), i = document.caretPositionFromPoint(n.clientX, n.clientY);
        o && i && o.setBaseAndExtent(
          i.offsetNode,
          i.offset,
          i.offsetNode,
          i.offset
        );
      }
      this.quill.focus(), this.range = this.quill.getSelection();
      let t = n.dataTransfer.files[0];
      setTimeout(() => {
        this.quill.focus(), this.range = this.quill.getSelection(), this.readAndUploadFile(t);
      }, 0);
    }
  }
  handlePaste(n) {
    let t = n.clipboardData || window.clipboardData;
    if (t && (t.items || t.files)) {
      let o = t.items || t.files;
      const i = /^image\/(jpe?g|gif|png|svg|webp)$/i;
      for (let r = 0; r < o.length; r++)
        if (i.test(o[r].type)) {
          let a = o[r].getAsFile ? o[r].getAsFile() : o[r];
          a && (this.quill.focus(), this.range = this.quill.getSelection(), n.preventDefault(), setTimeout(() => {
            this.quill.focus(), this.range = this.quill.getSelection(), this.readAndUploadFile(a);
          }, 0));
        }
    }
  }
  readAndUploadFile(n) {
    let t = !1;
    const o = new FileReader();
    o.addEventListener(
      "load",
      () => {
        if (!t) {
          let i = o.result;
          this.insertBase64Image(i);
        }
      },
      !1
    ), n && o.readAsDataURL(n), this.options.upload(n).then(
      (i) => {
        this.insertToEditor(i);
      },
      (i) => {
        t = !0, this.removeBase64Image(), console.warn(i);
      }
    );
  }
  fileChanged() {
    const n = this.fileHolder.files[0];
    this.readAndUploadFile(n);
  }
  insertBase64Image(n) {
    const t = this.range;
    this.placeholderDelta = this.quill.insertEmbed(
      t.index,
      Wi.blotName,
      `${n}`,
      "user"
    );
  }
  insertToEditor(n) {
    const t = this.range, o = this.calculatePlaceholderInsertLength();
    this.quill.deleteText(t.index, o, "user"), this.quill.insertEmbed(t.index, "image", `${n}`, "user"), t.index++, this.quill.setSelection(t, "user");
  }
  // The length of the insert delta from insertBase64Image can vary depending on what part of the line the insert occurs
  calculatePlaceholderInsertLength() {
    return this.placeholderDelta.ops.reduce((n, t) => (t.hasOwnProperty("insert") && n++, n), 0);
  }
  removeBase64Image() {
    const n = this.range, t = this.calculatePlaceholderInsertLength();
    this.quill.deleteText(n.index, t, "user");
  }
}
window.ImageUploader = L1;
const r9 = { class: "flex min-h-[256px] flex-1 flex-col" }, a9 = {
  key: 0,
  class: "mb-2"
}, l9 = {
  key: 0,
  class: "flex items-start"
}, s9 = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, SA = /* @__PURE__ */ re({
  __name: "FieldEditor",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    locale: {
      type: String,
      default: "en"
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    // Toolbar
    basic: {
      type: Boolean,
      default: !1
    },
    none: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "upload-image"],
  setup(e, { emit: n }) {
    jr.register("modules/imageUploader", L1);
    const t = e;
    let o = X(void 0);
    const i = n;
    return Ge(() => {
      He(() => {
        const r = new jr(`.js-field-editor-${t.id}`, {
          modules: {
            toolbar: !t.none && {
              container: [
                // Text edition
                ["bold", "italic"],
                [{ header: 1 }, { header: 2 }],
                // Text positioning
                [{ list: "ordered" }, { list: "bullet" }],
                [{ indent: "-1" }, { indent: "+1" }],
                // Media
                ...t.basic ? [] : [["link", "image", "video"]]
              ]
            },
            imageUploader: {
              upload: async (a) => new Promise((l, s) => {
                if (![
                  "image/jpeg",
                  "image/png",
                  "image/jpg",
                  "image/gif",
                  "image/webp"
                ].includes(a.type)) {
                  const d = t.locale === "fr" ? "Seuls les jpg, jpeg, png, gif ou webp sont autorisées" : "Only jpg, jpeg, png, gif or webp are allowed";
                  o.value = d, s(d);
                  return;
                }
                i("upload-image", a, (d, f) => {
                  d ? l(d) : f && (o.value = f, s(f));
                });
              })
            }
          },
          placeholder: t.placeholder,
          theme: "snow"
        });
        r.root.innerHTML = t.modelValue, r.on("text-change", () => {
          i("update:modelValue", r.root.innerHTML);
          const a = r.root.querySelector('img[src="undefined"]');
          a && a.remove();
        });
      });
    }), (r, a) => {
      var l, s;
      return _(), P("div", r9, [
        e.label || e.description ? (_(), P("div", a9, [
          e.label ? (_(), P("div", l9, [
            ce(Re, {
              for: e.id,
              label: e.label
            }, null, 8, ["for", "label"]),
            e.required ? (_(), P("span", s9, " * ")) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("div", {
          class: pe(`js-field-editor-${e.id} w-full flex-1 overflow-y-auto`)
        }, null, 2),
        I(o) || e.validation && ((l = e.validation.$errors) == null ? void 0 : l.length) > 0 ? (_(), ie(Re, {
          key: 1,
          class: "mt-1",
          label: I(o) ? I(o) : (s = e.validation.$errors[0]) == null ? void 0 : s.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ]);
    };
  }
});
const u9 = (e) => (ua("data-v-2b001c8b"), e = e(), da(), e), d9 = {
  key: 0,
  class: "mb-2"
}, c9 = {
  key: 0,
  class: "flex items-start"
}, f9 = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, h9 = ["id", "aria-label", "multiple", "accept"], g9 = ["for"], m9 = ["src"], p9 = { class: "mx-auto h-full w-[269px] rounded-[21px] border-2 border-border-on-emphasis p-[5px]" }, v9 = { class: "h-full rounded-[21px] bg-background-default" }, b9 = { class: "relative flex items-center px-4 py-2.5" }, y9 = { class: "h-8 w-8 overflow-hidden rounded-full border-2 border-border-on-emphasis" }, C9 = ["alt", "src"], x9 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center bg-background-subtle text-mgm-txt-xs font-semibold uppercase text-foreground-default"
}, w9 = { class: "uppercase" }, $9 = { class: "ml-1.5 max-w-[50%] truncate text-mgm-txt-xs font-medium" }, k9 = ["src"], _9 = { class: "px-4 pt-6" }, O9 = { class: "block text-mgm-txt-md font-semibold text-foreground-subtle" }, E9 = { class: "block text-mgm-txt-md font-semibold text-foreground-emphasis" }, M9 = { class: "mt-4 block text-mgm-txt-sm font-medium text-foreground-emphasis" }, S9 = /* @__PURE__ */ u9(() => /* @__PURE__ */ M("div", { class: "gradient__preview absolute bottom-0 left-0 right-0 h-[40%]" }, null, -1)), A9 = { class: "mx-auto mt-4 block text-center text-mgm-txt-sm font-normal text-foreground-default" }, T9 = { class: "font-medium text-foreground-brand-default" }, P9 = ["src"], I9 = {
  key: 2,
  class: "ml-3 max-w-[50%] text-mgm-txt-xs font-normal text-foreground-default"
}, D9 = { class: "block truncate text-mgm-txt-sm font-medium text-foreground-emphasis" }, L9 = ["src"], N9 = { class: "ml-3 max-w-[50%] text-mgm-txt-xs font-normal text-foreground-default" }, F9 = { class: "block truncate text-mgm-txt-sm font-medium text-foreground-emphasis" }, Bu = 1e3 * 1e3, N1 = /* @__PURE__ */ re({
  __name: "FieldFileUploader",
  props: {
    accept: {
      type: String,
      default: "*"
    },
    description: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: "en"
    },
    modelValue: {
      type: File,
      default: null
    },
    modelValueMultiple: {
      type: FileList,
      default: null
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    organizationDetails: {
      type: Object,
      default: null
    },
    previewCustom: {
      type: Boolean,
      default: !1
    },
    previewFull: {
      type: Boolean,
      default: !1
    },
    previewUrl: {
      type: String,
      default: void 0
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    }
  },
  emits: [
    "change",
    "update:modelValue",
    "update:modelValueMultiple"
  ],
  setup(e, { emit: n }) {
    const t = e, { t: o } = Cn(), i = X(0), r = X(!1), a = X(null), l = X(t.previewUrl), s = X([]);
    X(null);
    const u = n, d = () => {
      i.value++, r.value = !0;
    }, f = () => {
      i.value--, i.value === 0 && (r.value = !1);
    }, c = (p) => {
      p.preventDefault();
    }, h = (p) => {
      var y;
      p.preventDefault(), r.value = !1, (y = p.dataTransfer) != null && y.files && v(p.dataTransfer.files);
    }, m = (p) => {
      const y = p.target;
      y != null && y.files && v(y.files);
    }, g = (p, y) => {
      if (y.preventDefault(), y.stopPropagation(), u("update:modelValue", void 0), a.value) {
        const C = a.value.querySelector("input");
        if (C)
          if (t.multiple) {
            const b = new DataTransfer();
            if (t.modelValueMultiple)
              for (const x of t.modelValueMultiple)
                b.items.add(x);
            b.items.remove(p), C.files = b.files, s.value.splice(p, 1), u("update:modelValueMultiple", b.files);
          } else
            C.value = "";
        l.value = "";
      }
    }, v = (p) => {
      let y = null, C = null;
      if (!t.multiple)
        y = p[0], y && y.type.startsWith("image/") && (l.value = URL.createObjectURL(y)), u("update:modelValue", y);
      else {
        const b = new DataTransfer();
        if (t.modelValueMultiple)
          for (const w of t.modelValueMultiple)
            b.items.add(w);
        for (const w of p)
          b.items.add(w);
        C = b.files, p = C;
        const x = [];
        for (const w of p)
          w.type.startsWith("image/") && x.push(URL.createObjectURL(w));
        s.value = x, u("update:modelValueMultiple", C);
      }
      u("change", y || C);
    };
    return (p, y) => {
      var C, b, x, w, $, E, A, O, k, S, T, L, F, U;
      return _(), P("div", {
        ref_key: "root",
        ref: a
      }, [
        e.label || e.description ? (_(), P("div", d9, [
          e.label ? (_(), P("div", c9, [
            ce(Re, {
              for: e.id,
              label: e.label
            }, null, 8, ["for", "label"]),
            e.required ? (_(), P("span", f9, " * ")) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        l.value ? z("", !0) : (_(), P("div", {
          key: 1,
          class: pe([
            "border-box relative flex cursor-pointer flex-col items-center justify-center rounded-[5px] px-6 py-10 hover:border-border-default hover:bg-background-subtle-hover",
            (e.previewFull || e.previewCustom) && !e.multiple && (e.modelValue || e.previewUrl) ? "h-[412px]" : "h-40",
            r.value ? "border border-solid border-border-brand-emphasis bg-background-brand-default-hover" : "border-2 border-dashed border-border-subtle bg-background-default"
          ]),
          onDragenter: d,
          onDragleave: f,
          onDragover: c,
          onDrop: h
        }, [
          M("input", {
            id: e.id,
            "aria-label": e.label,
            multiple: e.multiple,
            accept: e.accept,
            class: "absolute -z-10 max-w-[1px]",
            type: "file",
            title: "",
            onChange: m
          }, null, 40, h9),
          M("label", {
            class: "h-full w-full cursor-pointer",
            for: e.id,
            onClick: y[0] || (y[0] = Yn(() => {
            }, ["stop"]))
          }, [
            (e.previewFull || e.previewCustom) && !e.multiple && (e.previewUrl || l.value) ? (_(), P("div", {
              key: 0,
              class: pe([
                "h-[304px] w-full rounded-[5px] overflow-hidden",
                { "relative bg-background-subtle pt-6": e.previewCustom }
              ])
            }, [
              e.previewFull ? (_(), P("img", {
                key: 0,
                class: "h-full w-full rounded-[5px] object-cover",
                src: l.value || e.previewUrl
              }, null, 8, m9)) : e.previewCustom ? (_(), P(me, { key: 1 }, [
                M("div", p9, [
                  M("div", v9, [
                    M("div", b9, [
                      M("div", y9, [
                        (C = e.organizationDetails) != null && C.logo ? (_(), P("img", {
                          key: 0,
                          class: "h-full w-full object-cover",
                          alt: "logo " + ((b = e.organizationDetails) == null ? void 0 : b.name),
                          src: (x = e.organizationDetails) == null ? void 0 : x.logo
                        }, null, 8, C9)) : (w = e.organizationDetails) != null && w.name ? (_(), P("div", x9, [
                          M("span", w9, de((E = ($ = e.organizationDetails) == null ? void 0 : $.name) == null ? void 0 : E.charAt(0)), 1)
                        ])) : z("", !0)
                      ]),
                      M("span", $9, de((A = e.organizationDetails) == null ? void 0 : A.name), 1),
                      ce(Le, {
                        class: "absolute bottom-0 right-6 top-0",
                        color: "#5F6C85",
                        icon: "close"
                      })
                    ]),
                    l.value || e.previewUrl ? (_(), P("img", {
                      key: 0,
                      class: "h-28 w-full object-cover",
                      src: l.value || e.previewUrl
                    }, null, 8, k9)) : z("", !0),
                    M("div", _9, [
                      M("span", O9, de(I(o)("previewCustom.title")), 1),
                      M("span", E9, de(I(o)("previewCustom.subtitle")), 1),
                      M("span", M9, de(I(o)("previewCustom.text")), 1)
                    ])
                  ])
                ]),
                S9
              ], 64)) : z("", !0)
            ], 2)) : (_(), ie(Le, {
              key: 1,
              class: "mx-auto w-fit rounded-full border-[6px] border-background-brand-default-hover",
              size: 20,
              "bg-color": "#E0EAFF",
              color: "#444CE7",
              icon: "file-upload"
            })),
            M("span", A9, [
              M("span", T9, de(I(o)("browse")), 1),
              Ie(" " + de(I(o)("drag")), 1)
            ])
          ], 8, g9)
        ], 34)),
        e.previewFull || e.previewCustom || !l.value ? z("", !0) : (_(), P(me, { key: 2 }, [
          !e.multiple && (e.modelValue || e.previewUrl) ? (_(), P("div", {
            key: 0,
            class: pe([
              "border-box relative mt-2 flex w-full items-center rounded-[5px] border p-4",
              e.validation && ((O = e.validation.$errors) != null && O.length) ? "border-border-danger-emphasis bg-background-danger-subtle" : "border-border-subtle bg-background-default"
            ])
          }, [
            l.value || e.previewUrl ? (_(), P("img", {
              key: 0,
              class: "h-10 w-10 rounded-[5px] object-cover",
              src: l.value || e.previewUrl
            }, null, 8, P9)) : (_(), P("div", {
              key: 1,
              class: pe([
                "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[5px] ",
                e.validation && ((k = e.validation.$errors) != null && k.length) ? "bg-background-danger-subtle" : "bg-background-subtle-hover"
              ])
            }, [
              ce(Le, {
                color: e.validation && ((S = e.validation.$errors) != null && S.length) ? "#D92D20" : "#5F6C85",
                icon: "file-check"
              }, null, 8, ["color"])
            ], 2)),
            e.modelValue ? (_(), P("p", I9, [
              M("span", D9, de((T = e.modelValue) == null ? void 0 : T.name), 1),
              M("span", null, de(`${(((L = e.modelValue) == null ? void 0 : L.size) / Bu).toFixed(2)} MB`), 1)
            ])) : z("", !0),
            ce(Le, {
              class: "absolute bottom-0 right-4 top-0 cursor-pointer",
              color: "#5F6C85",
              icon: "trash",
              onClick: y[1] || (y[1] = (W) => g(0, W))
            })
          ], 2)) : z("", !0),
          e.modelValueMultiple ? (_(!0), P(me, { key: 1 }, Fe(Array.from(t.modelValueMultiple), (W, oe) => {
            var H, B, D;
            return _(), P("div", {
              key: oe,
              class: pe([
                "border-box relative mt-2 flex w-full items-center rounded-[5px] border p-4",
                e.validation && ((H = e.validation.$errors) != null && H.length) ? "border-border-danger-emphasis bg-background-danger-subtle" : "border-border-subtle bg-background-default"
              ])
            }, [
              s.value[oe] ? (_(), P("img", {
                key: 0,
                class: "h-10 w-10 rounded-[5px] object-cover",
                src: s.value[oe]
              }, null, 8, L9)) : (_(), P("div", {
                key: 1,
                class: pe([
                  "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[5px] ",
                  e.validation && ((B = e.validation.$errors) != null && B.length) ? "bg-background-danger-subtle" : "bg-background-subtle-hover"
                ])
              }, [
                ce(Le, {
                  color: e.validation && ((D = e.validation.$errors) != null && D.length) ? "#D92D20" : "#5F6C85",
                  icon: "file-check"
                }, null, 8, ["color"])
              ], 2)),
              M("p", N9, [
                M("span", F9, de(W == null ? void 0 : W.name), 1),
                M("span", null, de(`${((W == null ? void 0 : W.size) / Bu).toFixed(2)} MB`), 1)
              ]),
              ce(Le, {
                class: "absolute bottom-0 right-4 top-0 cursor-pointer",
                color: "#5F6C85",
                icon: "trash",
                onClick: (V) => g(oe, V)
              }, null, 8, ["onClick"])
            ], 2);
          }), 128)) : z("", !0)
        ], 64)),
        e.validation && ((F = e.validation.$errors) != null && F.length) ? (_(), ie(Re, {
          key: 3,
          class: "mt-1",
          label: (U = e.validation.$errors[0]) == null ? void 0 : U.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ], 512);
    };
  }
});
function Vu(e) {
  const n = e;
  n.__i18n = n.__i18n || [], n.__i18n.push({
    locale: "",
    resource: {
      en: {
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Browse"]);
        },
        drag: (t) => {
          const { normalize: o } = t;
          return o(["or drag a file here"]);
        },
        previewCustom: {
          title: (t) => {
            const { normalize: o } = t;
            return o(["Any question?"]);
          },
          subtitle: (t) => {
            const { normalize: o } = t;
            return o(["Meet our ambassadors"]);
          },
          text: (t) => {
            const { normalize: o } = t;
            return o(["What is your email address? *"]);
          }
        }
      },
      fr: {
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Parcourez"]);
        },
        drag: (t) => {
          const { normalize: o } = t;
          return o(["ou faites glisser un fichier ici"]);
        },
        previewCustom: {
          title: (t) => {
            const { normalize: o } = t;
            return o(["Des questions ?"]);
          },
          subtitle: (t) => {
            const { normalize: o } = t;
            return o(["Rencontrez l’un de nos ambassadeurs"]);
          },
          text: (t) => {
            const { normalize: o } = t;
            return o(["Quelle est votre adresse e-mail ? *"]);
          }
        }
      }
    }
  });
}
typeof Vu == "function" && Vu(N1);
const AA = /* @__PURE__ */ no(N1, [["__scopeId", "data-v-2b001c8b"]]), R9 = {
  key: 0,
  class: "mb-1.5"
}, B9 = {
  key: 0,
  class: "flex items-start"
}, V9 = {
  key: 0,
  class: "inline-flex items-center rounded-l-[4.16px] border border-r-0 border-border-default bg-background-subtle-hover px-3 text-foreground-default shadow-sm sm:text-mgm-txt-sm"
}, j9 = {
  key: 2,
  class: "absolute bottom-0 left-0 top-0 flex h-full items-center"
}, H9 = ["src"], z9 = ["src"], q9 = ["id", "autocomplete", "disabled", "name", "placeholder", "required", "type"], U9 = {
  key: 5,
  class: "inline-flex items-center rounded-r-[4.16px] border border-l-0 border-border-default bg-background-subtle-hover px-3 text-foreground-default shadow-sm sm:text-mgm-txt-sm"
}, W9 = ["for"], K9 = { class: "inline-flex w-80 items-center justify-center rounded-r-[4.16px] border border-l-0 border-border-default bg-background-subtle-hover px-3 text-mgm-txt-sm text-foreground-default shadow-sm hover:bg-background-subtle focus:border-border-default focus:outline-none focus:ring-1 focus:ring-border-default" }, F1 = /* @__PURE__ */ re({
  __name: "FieldInput",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: "default"
    },
    type: {
      type: String,
      default: "text"
    },
    id: {
      type: [String, Number],
      default: null
    },
    locale: {
      type: String,
      default: "en"
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    validationDisabled: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: null
    },
    customColor: {
      type: String,
      default: null
    },
    customRgbColor: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    customIcon: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    prefix: {
      type: String,
      default: null
    },
    noRoundedBottom: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(e, { emit: n }) {
    const t = e, { t: o } = Cn(), i = X(), r = X(!1), a = n;
    Ge(() => c()), Ne(
      () => t.modelValue,
      () => {
        c();
      }
    );
    const l = (h) => {
      var g;
      const m = h.target;
      ((g = t.modelValue) == null ? void 0 : g.length) === 0 && (r.value = !1), a("blur", m.value, t.id);
    }, s = (h) => {
      const m = h.target;
      r.value = !0, a("focus", m.value, t.id);
    }, u = (h) => {
      const m = h.target;
      let g = m.value;
      t.role === "email" && (g = g.replace(/\s/g, ""), m.value = g), a("change", g, t.id), a("update:modelValue", g, t.id);
    }, d = (h) => {
      h.code == "Enter" && a("submit", t.id);
    }, f = () => {
      a("update:modelValue", "", t.id);
    }, c = () => {
      if (i.value) {
        const h = i.value.querySelector("input");
        h && (t.role === "link" ? h.value = t.modelValue.replace("https://", "") : h.value = t.modelValue);
      }
    };
    return (h, m) => {
      var g, v, p, y, C, b, x, w, $, E, A;
      return _(), P("div", {
        ref_key: "root",
        ref: i
      }, [
        e.label || e.description ? (_(), P("div", R9, [
          e.label ? (_(), P("div", B9, [
            ce(Re, {
              id: `${e.id}`,
              label: e.label
            }, null, 8, ["id", "label"]),
            e.required ? (_(), P("span", {
              key: 0,
              class: pe([
                "ml-1 text-mgm-txt-sm font-medium",
                { "text-foreground-brand-default": !e.customColor }
              ]),
              style: Ye({ color: e.customColor })
            }, " * ", 6)) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("div", {
          class: pe({
            relative: e.role === "search" || e.customIcon || e.icon,
            "relative flex rounded-[4.16px] shadow-sm": e.suffix || e.prefix || ["color-picker", "link"].includes(e.role)
          })
        }, [
          e.role === "link" ? (_(), P("span", V9, " https:// ")) : z("", !0),
          e.icon || e.role === "search" ? (_(), ie(Le, {
            key: 1,
            class: "absolute bottom-0 left-4 top-0",
            icon: e.icon ? e.icon : "search",
            color: "#5F6C85"
          }, null, 8, ["icon"])) : z("", !0),
          e.customIcon && !e.prefix ? (_(), P("div", j9, [
            M("img", {
              class: "ml-3 h-5 w-5",
              src: e.customIcon
            }, null, 8, H9)
          ])) : z("", !0),
          e.prefix ? (_(), P("div", {
            key: 3,
            class: pe(`inline-flex items-center rounded-l-[4.16px] border !border-r-0 border-border-default bg-background-subtle-hover pl-3 text-foreground-default shadow-sm text-mgm-txt-sm gap-2 ${e.customIcon ? "pr-8" : "pr-3"}`)
          }, [
            e.customIcon ? (_(), P("img", {
              key: 0,
              class: "h-auto w-5 shrink-0 block",
              src: e.customIcon
            }, null, 8, z9)) : z("", !0),
            M("span", null, de(e.prefix), 1)
          ], 2)) : z("", !0),
          M("input", {
            id: `${e.id}`,
            class: pe([
              "box-border block w-full rounded-[4.16px] py-[9px] text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle",
              (v = (g = e.validation) == null ? void 0 : g.$errors) != null && v.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default",
              e.customIcon && !e.prefix || e.icon && !e.prefix ? "px-10" : "px-2.5",
              e.customIcon && !e.prefix || e.role === "search" || e.icon && !e.prefix ? "pl-10" : "pl-2.5",
              e.customIcon && !e.prefix || e.icon && !e.prefix ? "py-2 pr-10" : "py-2 pr-2.5",
              {
                "focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:ring-border-brand-emphasis": !e.customColor && !((y = (p = e.validation) == null ? void 0 : p.$errors) != null && y.length),
                "!rounded-l-none": e.role === "link",
                "!rounded-r-none": e.suffix,
                "!rounded-b-none": e.noRoundedBottom,
                invisible: e.role === "color-picker"
              },
              {
                "!rounded-l-none": e.prefix
              }
            ]),
            style: Ye({
              borderColor: e.customColor && r.value && !((b = (C = e.validation) == null ? void 0 : C.$errors) != null && b.length) ? e.customColor : void 0,
              boxShadow: e.customColor && r.value && !((w = (x = e.validation) == null ? void 0 : x.$errors) != null && w.length) ? `0px 1px 2px rgba(${e.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${e.customRgbColor}, 0.2)` : void 0
            }),
            autocomplete: e.autocomplete,
            disabled: e.disabled,
            name: `${e.id}`,
            placeholder: e.placeholder,
            required: e.required,
            type: e.type,
            onBlur: l,
            onFocus: s,
            onInput: u,
            onKeypress: d
          }, null, 46, q9),
          e.role === "search" && r.value && (($ = e.modelValue) == null ? void 0 : $.length) > 0 ? (_(), ie(Le, {
            key: 4,
            class: "absolute bottom-0 right-4 top-0",
            color: "#444CE7",
            icon: "close",
            onClick: m[0] || (m[0] = (O) => f())
          })) : z("", !0),
          e.suffix ? (_(), P("span", U9, de(e.suffix), 1)) : z("", !0),
          e.role === "color-picker" ? (_(), P("label", {
            key: 6,
            for: `${e.id}`,
            class: "absolute flex min-h-[28px] h-full w-full"
          }, [
            M("div", {
              class: "z-10 block w-full rounded-[4.16px] rounded-r-none border border-border-default bg-background-subtle-hover px-0 py-0 shadow-sm outline-border-brand-emphasis focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:ring-border-brand-emphasis",
              style: Ye({ backgroundColor: t.modelValue })
            }, null, 4),
            M("div", K9, [
              ce(Le, {
                class: "pr-2",
                icon: "tag",
                color: "#5F6C85",
                "aria-hidden": "true"
              }),
              Ie(" " + de(I(o)("color")), 1)
            ])
          ], 8, W9)) : z("", !0)
        ], 2),
        (e.validation && ((E = e.validation.$errors) == null ? void 0 : E.length) > 0 || e.errorMessage) && !e.validationDisabled ? (_(), ie(Re, {
          key: 1,
          class: "mt-[3px]",
          label: ((A = e.validation.$errors[0]) == null ? void 0 : A.$message) || e.errorMessage,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ], 512);
    };
  }
});
function ju(e) {
  const n = e;
  n.__i18n = n.__i18n || [], n.__i18n.push({
    locale: "",
    resource: {
      en: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Pick a color"]);
        }
      },
      fr: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Choisir une couleur"]);
        }
      }
    }
  });
}
typeof ju == "function" && ju(F1);
const Y9 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], BL: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function G9(e, n) {
  var t = Array.prototype.slice.call(n);
  return t.push(Y9), e.apply(this, t);
}
function Sl(e) {
  "@babel/helpers - typeof";
  return Sl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Sl(e);
}
function Hu(e, n) {
  for (var t = 0; t < n.length; t++) {
    var o = n[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function Z9(e, n, t) {
  return n && Hu(e.prototype, n), t && Hu(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function X9(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function J9(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), n && Si(e, n);
}
function Q9(e) {
  var n = B1();
  return function() {
    var o = Ai(e), i;
    if (n) {
      var r = Ai(this).constructor;
      i = Reflect.construct(o, arguments, r);
    } else
      i = o.apply(this, arguments);
    return e8(this, i);
  };
}
function e8(e, n) {
  if (n && (Sl(n) === "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return R1(e);
}
function R1(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Al(e) {
  var n = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Al = function(o) {
    if (o === null || !t8(o))
      return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof n < "u") {
      if (n.has(o))
        return n.get(o);
      n.set(o, i);
    }
    function i() {
      return Tr(o, arguments, Ai(this).constructor);
    }
    return i.prototype = Object.create(o.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), Si(i, o);
  }, Al(e);
}
function Tr(e, n, t) {
  return B1() ? Tr = Reflect.construct : Tr = function(i, r, a) {
    var l = [null];
    l.push.apply(l, r);
    var s = Function.bind.apply(i, l), u = new s();
    return a && Si(u, a.prototype), u;
  }, Tr.apply(null, arguments);
}
function B1() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function t8(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function Si(e, n) {
  return Si = Object.setPrototypeOf || function(o, i) {
    return o.__proto__ = i, o;
  }, Si(e, n);
}
function Ai(e) {
  return Ai = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ai(e);
}
var Mn = /* @__PURE__ */ function(e) {
  J9(t, e);
  var n = Q9(t);
  function t(o) {
    var i;
    return X9(this, t), i = n.call(this, o), Object.setPrototypeOf(R1(i), t.prototype), i.name = i.constructor.name, i;
  }
  return Z9(t);
}(/* @__PURE__ */ Al(Error)), fs = 2, n8 = 17, o8 = 3, sn = "0-9０-９٠-٩۰-۹", i8 = "-‐-―−ー－", r8 = "／/", a8 = "．.", l8 = "  ­​⁠　", s8 = "()（）［］\\[\\]", u8 = "~⁓∼～", Hr = "".concat(i8).concat(r8).concat(a8).concat(l8).concat(s8).concat(u8), hs = "+＋";
function zu(e, n) {
  e = e.split("-"), n = n.split("-");
  for (var t = e[0].split("."), o = n[0].split("."), i = 0; i < 3; i++) {
    var r = Number(t[i]), a = Number(o[i]);
    if (r > a)
      return 1;
    if (a > r)
      return -1;
    if (!isNaN(r) && isNaN(a))
      return 1;
    if (isNaN(r) && !isNaN(a))
      return -1;
  }
  return e[1] && n[1] ? e[1] > n[1] ? 1 : e[1] < n[1] ? -1 : 0 : !e[1] && n[1] ? 1 : e[1] && !n[1] ? -1 : 0;
}
var d8 = {}.constructor;
function Pr(e) {
  return e != null && e.constructor === d8;
}
function Tl(e) {
  "@babel/helpers - typeof";
  return Tl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Tl(e);
}
function pa(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function qu(e, n) {
  for (var t = 0; t < n.length; t++) {
    var o = n[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function va(e, n, t) {
  return n && qu(e.prototype, n), t && qu(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var c8 = "1.2.0", f8 = "1.7.35", Uu = " ext. ", h8 = /^\d+$/, Ft = /* @__PURE__ */ function() {
  function e(n) {
    pa(this, e), v8(n), this.metadata = n, V1.call(this, n);
  }
  return va(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var o = this.countryCallingCodes()[t];
        if (o && o.length === 1 && o[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, o) {
      if (t && h8.test(t) && (o = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new Wu(this.getCountryMetadata(t), this);
      } else if (o) {
        if (!this.hasCallingCode(o))
          throw new Error("Unknown calling code: ".concat(o));
        this.numberingPlan = new Wu(this.getNumberingPlanMetadata(o), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var o = this.countryCallingCodes()[t];
      if (o)
        return o.length === 1 && o[0].length === 3 ? void 0 : o;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var o = this.getCountryCodesForCallingCode(t);
      if (o)
        return o[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var o = this.getCountryCodeForCallingCode(t);
      if (o)
        return this.getCountryMetadata(o);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[t];
        if (i)
          return i;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Wu = /* @__PURE__ */ function() {
  function e(n, t) {
    pa(this, e), this.globalMetadataObject = t, this.metadata = n, V1.call(this, t.metadata);
  }
  return va(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, o = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return o.map(function(i) {
        return new g8(i, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && Ku(this.types(), t))
        return new p8(Ku(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Uu : this.metadata[13] || Uu;
    }
  }]), e;
}(), g8 = /* @__PURE__ */ function() {
  function e(n, t) {
    pa(this, e), this._format = n, this.metadata = t;
  }
  return va(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !m8.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), m8 = /^\(?\$1\)?$/, p8 = /* @__PURE__ */ function() {
  function e(n, t) {
    pa(this, e), this.type = n, this.metadata = t;
  }
  return va(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Ku(e, n) {
  switch (n) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function v8(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Pr(e) || !Pr(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Pr(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + b8(e) + ": " + e, "."));
}
var b8 = function(n) {
  return Tl(n);
};
function gs(e, n) {
  if (n = new Ft(n), n.hasCountry(e))
    return n.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function y8(e, n) {
  return n.countries.hasOwnProperty(e);
}
function V1(e) {
  var n = e.version;
  typeof n == "number" ? (this.v1 = n === 1, this.v2 = n === 2, this.v3 = n === 3, this.v4 = n === 4) : n ? zu(n, c8) === -1 ? this.v2 = !0 : zu(n, f8) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var C8 = ";ext=", To = function(n) {
  return "([".concat(sn, "]{1,").concat(n, "})");
};
function j1(e) {
  var n = "20", t = "15", o = "9", i = "6", r = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", l = "#?", s = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", d = "[- ]+", f = "[  \\t]*", c = "(?:,{2}|;)", h = C8 + To(n), m = r + s + a + To(n) + l, g = r + u + a + To(o) + l, v = d + To(i) + "#", p = f + c + a + To(t) + l, y = f + "(?:,)+" + a + To(o) + l;
  return h + "|" + m + "|" + g + "|" + v + "|" + p + "|" + y;
}
var x8 = "[" + sn + "]{" + fs + "}", w8 = "[" + hs + "]{0,1}(?:[" + Hr + "]*[" + sn + "]){3,}[" + Hr + sn + "]*", $8 = new RegExp("^[" + hs + "]{0,1}(?:[" + Hr + "]*[" + sn + "]){1,2}$", "i"), k8 = w8 + // Phone number extensions
"(?:" + j1() + ")?", _8 = new RegExp(
  // Either a short two-digit-only phone number
  "^" + x8 + "$|^" + k8 + "$",
  "i"
);
function O8(e) {
  return e.length >= fs && _8.test(e);
}
function E8(e) {
  return $8.test(e);
}
var Yu = new RegExp("(?:" + j1() + ")$", "i");
function M8(e) {
  var n = e.search(Yu);
  if (n < 0)
    return {};
  for (var t = e.slice(0, n), o = e.match(Yu), i = 1; i < o.length; ) {
    if (o[i])
      return {
        number: t,
        ext: o[i]
      };
    i++;
  }
}
var S8 = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function A8(e) {
  return S8[e];
}
function T8(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = P8(e)) || n && e && typeof e.length == "number") {
    t && (e = t);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function P8(e, n) {
  if (e) {
    if (typeof e == "string")
      return Gu(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Gu(e, n);
  }
}
function Gu(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, o = new Array(n); t < n; t++)
    o[t] = e[t];
  return o;
}
function Zu(e) {
  for (var n = "", t = T8(e.split("")), o; !(o = t()).done; ) {
    var i = o.value;
    n += I8(i, n) || "";
  }
  return n;
}
function I8(e, n) {
  return e === "+" ? n ? void 0 : "+" : A8(e);
}
function D8(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = L8(e)) || n && e && typeof e.length == "number") {
    t && (e = t);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function L8(e, n) {
  if (e) {
    if (typeof e == "string")
      return Xu(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Xu(e, n);
  }
}
function Xu(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, o = new Array(n); t < n; t++)
    o[t] = e[t];
  return o;
}
function N8(e, n) {
  for (var t = e.slice(), o = D8(n), i; !(i = o()).done; ) {
    var r = i.value;
    e.indexOf(r) < 0 && t.push(r);
  }
  return t.sort(function(a, l) {
    return a - l;
  });
}
function ms(e, n) {
  return H1(e, void 0, n);
}
function H1(e, n, t) {
  var o = t.type(n), i = o && o.possibleLengths() || t.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  if (n === "FIXED_LINE_OR_MOBILE") {
    if (!t.type("FIXED_LINE"))
      return H1(e, "MOBILE", t);
    var r = t.type("MOBILE");
    r && (i = N8(i, r.possibleLengths()));
  } else if (n && !o)
    return "INVALID_LENGTH";
  var a = e.length, l = i[0];
  return l === a ? "IS_POSSIBLE" : l > a ? "TOO_SHORT" : i[i.length - 1] < a ? "TOO_LONG" : i.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function F8(e, n, t) {
  if (n === void 0 && (n = {}), t = new Ft(t), n.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!t.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      t.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return z1(e.phone || e.nationalNumber, t);
  if (e.countryCallingCode && t.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function z1(e, n) {
  switch (ms(e, n)) {
    case "IS_POSSIBLE":
      return !0;
    default:
      return !1;
  }
}
function Tn(e, n) {
  return e = e || "", new RegExp("^(?:" + n + ")$").test(e);
}
function R8(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = B8(e)) || n && e && typeof e.length == "number") {
    t && (e = t);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function B8(e, n) {
  if (e) {
    if (typeof e == "string")
      return Ju(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Ju(e, n);
  }
}
function Ju(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, o = new Array(n); t < n; t++)
    o[t] = e[t];
  return o;
}
var V8 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function ps(e, n, t) {
  if (n = n || {}, !(!e.country && !e.countryCallingCode)) {
    t = new Ft(t), t.selectNumberingPlan(e.country, e.countryCallingCode);
    var o = n.v2 ? e.nationalNumber : e.phone;
    if (Tn(o, t.nationalNumberPattern())) {
      if (qa(o, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || qa(o, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = R8(V8), r; !(r = i()).done; ) {
        var a = r.value;
        if (qa(o, a, t))
          return a;
      }
    }
  }
}
function qa(e, n, t) {
  return n = t.type(n), !n || !n.pattern() || n.possibleLengths() && n.possibleLengths().indexOf(e.length) < 0 ? !1 : Tn(e, n.pattern());
}
function j8(e, n, t) {
  if (n = n || {}, t = new Ft(t), t.selectNumberingPlan(e.country, e.countryCallingCode), t.hasTypes())
    return ps(e, n, t.metadata) !== void 0;
  var o = n.v2 ? e.nationalNumber : e.phone;
  return Tn(o, t.nationalNumberPattern());
}
function H8(e, n, t) {
  var o = new Ft(t), i = o.getCountryCodesForCallingCode(e);
  return i ? i.filter(function(r) {
    return z8(n, r, t);
  }) : [];
}
function z8(e, n, t) {
  var o = new Ft(t);
  return o.selectNumberingPlan(n), o.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function q8(e) {
  return e.replace(new RegExp("[".concat(Hr, "]+"), "g"), " ").trim();
}
var U8 = /(\$\d)/;
function W8(e, n, t) {
  var o = t.useInternationalFormat, i = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var r = e.replace(new RegExp(n.pattern()), o ? n.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && n.nationalPrefixFormattingRule() ? n.format().replace(U8, n.nationalPrefixFormattingRule()) : n.format()
  ));
  return o ? q8(r) : r;
}
var K8 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Y8(e, n, t) {
  var o = new Ft(t);
  if (o.selectNumberingPlan(e, n), o.defaultIDDPrefix())
    return o.defaultIDDPrefix();
  if (K8.test(o.IDDPrefix()))
    return o.IDDPrefix();
}
function G8(e) {
  var n = e.number, t = e.ext;
  if (!n)
    return "";
  if (n[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(n).concat(t ? ";ext=" + t : "");
}
function Z8(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = X8(e)) || n && e && typeof e.length == "number") {
    t && (e = t);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function X8(e, n) {
  if (e) {
    if (typeof e == "string")
      return Qu(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return Qu(e, n);
  }
}
function Qu(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, o = new Array(n); t < n; t++)
    o[t] = e[t];
  return o;
}
function ed(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function td(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ed(Object(t), !0).forEach(function(o) {
      J8(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ed(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
function J8(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
var nd = {
  formatExtension: function(n, t, o) {
    return "".concat(n).concat(o.ext()).concat(t);
  }
};
function Q8(e, n, t, o) {
  if (t ? t = td(td({}, nd), t) : t = nd, o = new Ft(o), e.country && e.country !== "001") {
    if (!o.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    o.country(e.country);
  } else if (e.countryCallingCode)
    o.selectNumberingPlan(e.countryCallingCode);
  else
    return e.phone || "";
  var i = o.countryCallingCode(), r = t.v2 ? e.nationalNumber : e.phone, a;
  switch (n) {
    case "NATIONAL":
      return r ? (a = zr(r, e.carrierCode, "NATIONAL", o, t), Ua(a, e.ext, o, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return r ? (a = zr(r, null, "INTERNATIONAL", o, t), a = "+".concat(i, " ").concat(a), Ua(a, e.ext, o, t.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(r);
    case "RFC3966":
      return G8({
        number: "+".concat(i).concat(r),
        ext: e.ext
      });
    case "IDD":
      if (!t.fromCountry)
        return;
      var l = t7(r, e.carrierCode, i, t.fromCountry, o);
      return Ua(l, e.ext, o, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(n, '"'));
  }
}
function zr(e, n, t, o, i) {
  var r = e7(o.formats(), e);
  return r ? W8(e, r, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(r.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: n,
    metadata: o
  }) : e;
}
function e7(e, n) {
  for (var t = Z8(e), o; !(o = t()).done; ) {
    var i = o.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var r = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (n.search(r) !== 0)
        continue;
    }
    if (Tn(n, i.pattern()))
      return i;
  }
}
function Ua(e, n, t, o) {
  return n ? o(e, n, t) : e;
}
function t7(e, n, t, o, i) {
  var r = gs(o, i.metadata);
  if (r === t) {
    var a = zr(e, n, "NATIONAL", i);
    return t === "1" ? t + " " + a : a;
  }
  var l = Y8(o, void 0, i.metadata);
  if (l)
    return "".concat(l, " ").concat(t, " ").concat(zr(e, null, "INTERNATIONAL", i));
}
function od(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function id(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? od(Object(t), !0).forEach(function(o) {
      n7(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : od(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
function n7(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function o7(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function rd(e, n) {
  for (var t = 0; t < n.length; t++) {
    var o = n[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function i7(e, n, t) {
  return n && rd(e.prototype, n), t && rd(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var r7 = /* @__PURE__ */ function() {
  function e(n, t, o) {
    if (o7(this, e), !n)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!t)
      throw new TypeError("`nationalNumber` not passed");
    if (!o)
      throw new TypeError("`metadata` not passed");
    var i = l7(n, o), r = i.country, a = i.countryCallingCode;
    this.country = r, this.countryCallingCode = a, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return o;
    };
  }
  return i7(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : H8(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return F8(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return j8(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new Ft(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return ps(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, o) {
      return Q8(this, t, o ? id(id({}, o), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), a7 = function(n) {
  return /^[A-Z]{2}$/.test(n);
};
function l7(e, n) {
  var t, o, i = new Ft(n);
  return a7(e) ? (t = e, i.selectNumberingPlan(t), o = i.countryCallingCode()) : o = e, {
    country: t,
    countryCallingCode: o
  };
}
var s7 = new RegExp("([" + sn + "])");
function u7(e, n, t, o) {
  if (n) {
    var i = new Ft(o);
    i.selectNumberingPlan(n, t);
    var r = new RegExp(i.IDDPrefix());
    if (e.search(r) === 0) {
      e = e.slice(e.match(r)[0].length);
      var a = e.match(s7);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return e;
    }
  }
}
function d7(e, n) {
  if (e && n.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + n.numberingPlan.nationalPrefixForParsing() + ")"), o = t.exec(e);
    if (o) {
      var i, r, a = o.length - 1, l = a > 0 && o[a];
      if (n.nationalPrefixTransformRule() && l)
        i = e.replace(t, n.nationalPrefixTransformRule()), a > 1 && (r = o[1]);
      else {
        var s = o[0];
        i = e.slice(s.length), l && (r = o[1]);
      }
      var u;
      if (l) {
        var d = e.indexOf(o[1]), f = e.slice(0, d);
        f === n.numberingPlan.nationalPrefix() && (u = n.numberingPlan.nationalPrefix());
      } else
        u = o[0];
      return {
        nationalNumber: i,
        nationalPrefix: u,
        carrierCode: r
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function Pl(e, n) {
  var t = d7(e, n), o = t.carrierCode, i = t.nationalNumber;
  if (i !== e) {
    if (!c7(e, i, n))
      return {
        nationalNumber: e
      };
    if (n.possibleLengths() && !f7(i, n))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: i,
    carrierCode: o
  };
}
function c7(e, n, t) {
  return !(Tn(e, t.nationalNumberPattern()) && !Tn(n, t.nationalNumberPattern()));
}
function f7(e, n) {
  switch (ms(e, n)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function h7(e, n, t, o) {
  var i = n ? gs(n, o) : t;
  if (e.indexOf(i) === 0) {
    o = new Ft(o), o.selectNumberingPlan(n, t);
    var r = e.slice(i.length), a = Pl(r, o), l = a.nationalNumber, s = Pl(e, o), u = s.nationalNumber;
    if (!Tn(u, o.nationalNumberPattern()) && Tn(l, o.nationalNumberPattern()) || ms(u, o) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: r
      };
  }
  return {
    number: e
  };
}
function g7(e, n, t, o) {
  if (!e)
    return {};
  var i;
  if (e[0] !== "+") {
    var r = u7(e, n, t, o);
    if (r && r !== e)
      i = !0, e = "+" + r;
    else {
      if (n || t) {
        var a = h7(e, n, t, o), l = a.countryCallingCode, s = a.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: s
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  o = new Ft(o);
  for (var u = 2; u - 1 <= o8 && u <= e.length; ) {
    var d = e.slice(1, u);
    if (o.hasCallingCode(d))
      return o.selectNumberingPlan(d), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: d,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function m7(e, n) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = p7(e)) || n && e && typeof e.length == "number") {
    t && (e = t);
    var o = 0;
    return function() {
      return o >= e.length ? { done: !0 } : { done: !1, value: e[o++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function p7(e, n) {
  if (e) {
    if (typeof e == "string")
      return ad(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return ad(e, n);
  }
}
function ad(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, o = new Array(n); t < n; t++)
    o[t] = e[t];
  return o;
}
function v7(e, n) {
  var t = n.countries, o = n.defaultCountry, i = n.metadata;
  i = new Ft(i);
  for (var r = [], a = m7(t), l; !(l = a()).done; ) {
    var s = l.value;
    if (i.country(s), i.leadingDigits()) {
      if (e && e.search(i.leadingDigits()) === 0)
        return s;
    } else if (ps({
      phone: e,
      country: s
    }, void 0, i.metadata))
      if (o) {
        if (s === o)
          return s;
        r.push(s);
      } else
        return s;
  }
  if (r.length > 0)
    return r[0];
}
var b7 = !1;
function y7(e, n) {
  var t = n.nationalNumber, o = n.defaultCountry, i = n.metadata;
  if (b7 && i.isNonGeographicCallingCode(e))
    return "001";
  var r = i.getCountryCodesForCallingCode(e);
  if (r)
    return r.length === 1 ? r[0] : v7(t, {
      countries: r,
      defaultCountry: o,
      metadata: i.metadata
    });
}
var q1 = "+", C7 = "[\\-\\.\\(\\)]?", ld = "([" + sn + "]|" + C7 + ")", x7 = "^\\" + q1 + ld + "*[" + sn + "]" + ld + "*$", w7 = new RegExp(x7, "g"), Il = sn, $7 = "[" + Il + "]+((\\-)*[" + Il + "])*", k7 = "a-zA-Z", _7 = "[" + k7 + "]+((\\-)*[" + Il + "])*", O7 = "^(" + $7 + "\\.)*" + _7 + "\\.?$", E7 = new RegExp(O7, "g"), sd = "tel:", Dl = ";phone-context=", M7 = ";isub=";
function S7(e) {
  var n = e.indexOf(Dl);
  if (n < 0)
    return null;
  var t = n + Dl.length;
  if (t >= e.length)
    return "";
  var o = e.indexOf(";", t);
  return o >= 0 ? e.substring(t, o) : e.substring(t);
}
function A7(e) {
  return e === null ? !0 : e.length === 0 ? !1 : w7.test(e) || E7.test(e);
}
function T7(e, n) {
  var t = n.extractFormattedPhoneNumber, o = S7(e);
  if (!A7(o))
    throw new Mn("NOT_A_NUMBER");
  var i;
  if (o === null)
    i = t(e) || "";
  else {
    i = "", o.charAt(0) === q1 && (i += o);
    var r = e.indexOf(sd), a;
    r >= 0 ? a = r + sd.length : a = 0;
    var l = e.indexOf(Dl);
    i += e.substring(a, l);
  }
  var s = i.indexOf(M7);
  if (s > 0 && (i = i.substring(0, s)), i !== "")
    return i;
}
var P7 = 250, I7 = new RegExp("[" + hs + sn + "]"), D7 = new RegExp("[^" + sn + "#]+$");
function L7(e, n, t) {
  if (n = n || {}, t = new Ft(t), n.defaultCountry && !t.hasCountry(n.defaultCountry))
    throw n.v2 ? new Mn("INVALID_COUNTRY") : new Error("Unknown country: ".concat(n.defaultCountry));
  var o = F7(e, n.v2, n.extract), i = o.number, r = o.ext, a = o.error;
  if (!i) {
    if (n.v2)
      throw a === "TOO_SHORT" ? new Mn("TOO_SHORT") : new Mn("NOT_A_NUMBER");
    return {};
  }
  var l = B7(i, n.defaultCountry, n.defaultCallingCode, t), s = l.country, u = l.nationalNumber, d = l.countryCallingCode, f = l.countryCallingCodeSource, c = l.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (n.v2)
      throw new Mn("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < fs) {
    if (n.v2)
      throw new Mn("TOO_SHORT");
    return {};
  }
  if (u.length > n8) {
    if (n.v2)
      throw new Mn("TOO_LONG");
    return {};
  }
  if (n.v2) {
    var h = new r7(d, u, t.metadata);
    return s && (h.country = s), c && (h.carrierCode = c), r && (h.ext = r), h.__countryCallingCodeSource = f, h;
  }
  var m = (n.extended ? t.hasSelectedNumberingPlan() : s) ? Tn(u, t.nationalNumberPattern()) : !1;
  return n.extended ? {
    country: s,
    countryCallingCode: d,
    carrierCode: c,
    valid: m,
    possible: m ? !0 : !!(n.extended === !0 && t.possibleLengths() && z1(u, t)),
    phone: u,
    ext: r
  } : m ? R7(s, u, r) : {};
}
function N7(e, n, t) {
  if (e) {
    if (e.length > P7) {
      if (t)
        throw new Mn("TOO_LONG");
      return;
    }
    if (n === !1)
      return e;
    var o = e.search(I7);
    if (!(o < 0))
      return e.slice(o).replace(D7, "");
  }
}
function F7(e, n, t) {
  var o = T7(e, {
    extractFormattedPhoneNumber: function(a) {
      return N7(a, t, n);
    }
  });
  if (!o)
    return {};
  if (!O8(o))
    return E8(o) ? {
      error: "TOO_SHORT"
    } : {};
  var i = M8(o);
  return i.ext ? i : {
    number: o
  };
}
function R7(e, n, t) {
  var o = {
    country: e,
    phone: n
  };
  return t && (o.ext = t), o;
}
function B7(e, n, t, o) {
  var i = g7(Zu(e), n, t, o.metadata), r = i.countryCallingCodeSource, a = i.countryCallingCode, l = i.number, s;
  if (a)
    o.selectNumberingPlan(a);
  else if (l && (n || t))
    o.selectNumberingPlan(n, t), n && (s = n), a = t || gs(n, o.metadata);
  else
    return {};
  if (!l)
    return {
      countryCallingCodeSource: r,
      countryCallingCode: a
    };
  var u = Pl(Zu(l), o), d = u.nationalNumber, f = u.carrierCode, c = y7(a, {
    nationalNumber: d,
    defaultCountry: n,
    metadata: o
  });
  return c && (s = c, c === "001" || o.country(s)), {
    country: s,
    countryCallingCode: a,
    countryCallingCodeSource: r,
    nationalNumber: d,
    carrierCode: f
  };
}
function ud(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function dd(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? ud(Object(t), !0).forEach(function(o) {
      V7(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ud(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
function V7(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function j7(e, n, t) {
  return L7(e, dd(dd({}, n), {}, {
    v2: !0
  }), t);
}
function cd(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function H7(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? cd(Object(t), !0).forEach(function(o) {
      z7(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : cd(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
function z7(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function q7(e, n) {
  return Y7(e) || K7(e, n) || W7(e, n) || U7();
}
function U7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W7(e, n) {
  if (e) {
    if (typeof e == "string")
      return fd(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return fd(e, n);
  }
}
function fd(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, o = new Array(n); t < n; t++)
    o[t] = e[t];
  return o;
}
function K7(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var o = [], i = !0, r = !1, a, l;
    try {
      for (t = t.call(e); !(i = (a = t.next()).done) && (o.push(a.value), !(n && o.length === n)); i = !0)
        ;
    } catch (s) {
      r = !0, l = s;
    } finally {
      try {
        !i && t.return != null && t.return();
      } finally {
        if (r)
          throw l;
      }
    }
    return o;
  }
}
function Y7(e) {
  if (Array.isArray(e))
    return e;
}
function G7(e) {
  var n = Array.prototype.slice.call(e), t = q7(n, 4), o = t[0], i = t[1], r = t[2], a = t[3], l, s, u;
  if (typeof o == "string")
    l = o;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    a ? (s = r, u = a) : (s = void 0, u = r), i && (s = H7({
      defaultCountry: i
    }, s));
  else if (Pr(i))
    r ? (s = i, u = r) : u = i;
  else
    throw new Error("Invalid second argument: ".concat(i));
  return {
    text: l,
    options: s,
    metadata: u
  };
}
function hd(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function gd(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? hd(Object(t), !0).forEach(function(o) {
      Z7(e, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : hd(Object(t)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return e;
}
function Z7(e, n, t) {
  return n in e ? Object.defineProperty(e, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[n] = t, e;
}
function X7(e, n, t) {
  n && n.defaultCountry && !y8(n.defaultCountry, t) && (n = gd(gd({}, n), {}, {
    defaultCountry: void 0
  }));
  try {
    return j7(e, n, t);
  } catch (o) {
    if (!(o instanceof Mn))
      throw o;
  }
}
function J7() {
  var e = G7(arguments), n = e.text, t = e.options, o = e.metadata;
  return X7(n, t, o);
}
function sr() {
  return G9(J7, arguments);
}
function Q7(e) {
  return os() ? (is(e), !0) : !1;
}
function U1(e) {
  return typeof e == "function" ? e() : I(e);
}
const W1 = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const eb = Object.prototype.toString, tb = (e) => eb.call(e) === "[object Object]", Ll = () => {
}, nb = /* @__PURE__ */ ob();
function ob() {
  var e, n;
  return W1 && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function di(e) {
  var n;
  const t = U1(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const K1 = W1 ? window : void 0;
function Wa(...e) {
  let n, t, o, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, o, i] = e, n = K1) : [n, t, o, i] = e, !n)
    return Ll;
  Array.isArray(t) || (t = [t]), Array.isArray(o) || (o = [o]);
  const r = [], a = () => {
    r.forEach((d) => d()), r.length = 0;
  }, l = (d, f, c, h) => (d.addEventListener(f, c, h), () => d.removeEventListener(f, c, h)), s = Ne(
    () => [di(n), U1(i)],
    ([d, f]) => {
      if (a(), !d)
        return;
      const c = tb(f) ? { ...f } : f;
      r.push(
        ...t.flatMap((h) => o.map((m) => l(d, h, m, c)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), a();
  };
  return Q7(u), u;
}
let md = !1;
function Y1(e, n, t = {}) {
  const { window: o = K1, ignore: i = [], capture: r = !0, detectIframe: a = !1 } = t;
  if (!o)
    return;
  nb && !md && (md = !0, Array.from(o.document.body.children).forEach((c) => c.addEventListener("click", Ll)), o.document.documentElement.addEventListener("click", Ll));
  let l = !0;
  const s = (c) => i.some((h) => {
    if (typeof h == "string")
      return Array.from(o.document.querySelectorAll(h)).some((m) => m === c.target || c.composedPath().includes(m));
    {
      const m = di(h);
      return m && (c.target === m || c.composedPath().includes(m));
    }
  }), d = [
    Wa(o, "click", (c) => {
      const h = di(e);
      if (!(!h || h === c.target || c.composedPath().includes(h))) {
        if (c.detail === 0 && (l = !s(c)), !l) {
          l = !0;
          return;
        }
        n(c);
      }
    }, { passive: !0, capture: r }),
    Wa(o, "pointerdown", (c) => {
      const h = di(e);
      l = !s(c) && !!(h && !c.composedPath().includes(h));
    }, { passive: !0 }),
    a && Wa(o, "blur", (c) => {
      setTimeout(() => {
        var h;
        const m = di(e);
        ((h = o.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(m != null && m.contains(o.document.activeElement)) && n(c);
      }, 0);
    })
  ].filter(Boolean);
  return () => d.forEach((c) => c());
}
const Ka = [
  {
    name: "Afghanistan",
    dialCode: "93",
    flagIcon: "🇦🇫",
    code: "AF"
  },
  {
    name: "Aland Islands",
    dialCode: "358",
    flagIcon: "🇦🇽",
    code: "AX"
  },
  {
    name: "Albania",
    dialCode: "355",
    flagIcon: "🇦🇱",
    code: "AL"
  },
  {
    name: "Algeria",
    dialCode: "213",
    flagIcon: "🇩🇿",
    code: "DZ"
  },
  {
    name: "AmericanSamoa",
    dialCode: "1684",
    flagIcon: "🇦🇸",
    code: "AS"
  },
  {
    name: "Andorra",
    dialCode: "376",
    flagIcon: "🇦🇩",
    code: "AD"
  },
  {
    name: "Angola",
    dialCode: "244",
    flagIcon: "🇦🇴",
    code: "AO"
  },
  {
    name: "Anguilla",
    dialCode: "1264",
    flagIcon: "🇦🇮",
    code: "AI"
  },
  {
    name: "Antarctica",
    dialCode: "672",
    flagIcon: "🇦🇶",
    code: "AQ"
  },
  {
    name: "Antigua and Barbuda",
    dialCode: "1268",
    flagIcon: "🇦🇬",
    code: "AG"
  },
  {
    name: "Argentina",
    dialCode: "54",
    flagIcon: "🇦🇷",
    code: "AR"
  },
  {
    name: "Armenia",
    dialCode: "374",
    flagIcon: "🇦🇲",
    code: "AM"
  },
  {
    name: "Aruba",
    dialCode: "297",
    flagIcon: "🇦🇼",
    code: "AW"
  },
  {
    name: "Australia",
    dialCode: "61",
    flagIcon: "🇦🇺",
    code: "AU"
  },
  {
    name: "Austria",
    dialCode: "43",
    flagIcon: "🇦🇹",
    code: "AT"
  },
  {
    name: "Azerbaijan",
    dialCode: "994",
    flagIcon: "🇦🇿",
    code: "AZ"
  },
  {
    name: "Bahamas",
    dialCode: "1242",
    flagIcon: "🇧🇸",
    code: "BS"
  },
  {
    name: "Bahrain",
    dialCode: "973",
    flagIcon: "🇧🇭",
    code: "BH"
  },
  {
    name: "Bangladesh",
    dialCode: "880",
    flagIcon: "🇧🇩",
    code: "BD"
  },
  {
    name: "Barbados",
    dialCode: "1246",
    flagIcon: "🇧🇧",
    code: "BB"
  },
  {
    name: "Belarus",
    dialCode: "375",
    flagIcon: "🇧🇾",
    code: "BY"
  },
  {
    name: "Belgium",
    dialCode: "32",
    flagIcon: "🇧🇪",
    code: "BE"
  },
  {
    name: "Belize",
    dialCode: "501",
    flagIcon: "🇧🇿",
    code: "BZ"
  },
  {
    name: "Benin",
    dialCode: "229",
    flagIcon: "🇧🇯",
    code: "BJ"
  },
  {
    name: "Bermuda",
    dialCode: "1441",
    flagIcon: "🇧🇲",
    code: "BM"
  },
  {
    name: "Bhutan",
    dialCode: "975",
    flagIcon: "🇧🇹",
    code: "BT"
  },
  {
    name: "Bolivia, Plurinational State of",
    dialCode: "591",
    flagIcon: "🇧🇴",
    code: "BO"
  },
  {
    name: "Bosnia and Herzegovina",
    dialCode: "387",
    flagIcon: "🇧🇦",
    code: "BA"
  },
  {
    name: "Botswana",
    dialCode: "267",
    flagIcon: "🇧🇼",
    code: "BW"
  },
  {
    name: "Brazil",
    dialCode: "55",
    flagIcon: "🇧🇷",
    code: "BR"
  },
  {
    name: "British Indian Ocean Territory",
    dialCode: "246",
    flagIcon: "🇮🇴",
    code: "IO"
  },
  {
    name: "Brunei Darussalam",
    dialCode: "673",
    flagIcon: "🇧🇳",
    code: "BN"
  },
  {
    name: "Bulgaria",
    dialCode: "359",
    flagIcon: "🇧🇬",
    code: "BG"
  },
  {
    name: "Burkina Faso",
    dialCode: "226",
    flagIcon: "🇧🇫",
    code: "BF"
  },
  {
    name: "Burundi",
    dialCode: "257",
    flagIcon: "🇧🇮",
    code: "BI"
  },
  {
    name: "Cambodia",
    dialCode: "855",
    flagIcon: "🇰🇭",
    code: "KH"
  },
  {
    name: "Cameroon",
    dialCode: "237",
    flagIcon: "🇨🇲",
    code: "CM"
  },
  {
    name: "Canada",
    dialCode: "1",
    flagIcon: "🇨🇦",
    code: "CA"
  },
  {
    name: "Cape Verde",
    dialCode: "238",
    flagIcon: "🇨🇻",
    code: "CV"
  },
  {
    name: "Cayman Islands",
    dialCode: " 345",
    flagIcon: "🇰🇾",
    code: "KY"
  },
  {
    name: "Central African Republic",
    dialCode: "236",
    flagIcon: "🇨🇫",
    code: "CF"
  },
  {
    name: "Chad",
    dialCode: "235",
    flagIcon: "🇹🇩",
    code: "TD"
  },
  {
    name: "Chile",
    dialCode: "56",
    flagIcon: "🇨🇱",
    code: "CL"
  },
  {
    name: "China",
    dialCode: "86",
    flagIcon: "🇨🇳",
    code: "CN"
  },
  {
    name: "Christmas Island",
    dialCode: "61",
    flagIcon: "🇨🇽",
    code: "CX"
  },
  {
    name: "Cocos (Keeling) Islands",
    dialCode: "61",
    flagIcon: "🇨🇨",
    code: "CC"
  },
  {
    name: "Colombia",
    dialCode: "57",
    flagIcon: "🇨🇴",
    code: "CO"
  },
  {
    name: "Comoros",
    dialCode: "269",
    flagIcon: "🇰🇲",
    code: "KM"
  },
  {
    name: "Congo",
    dialCode: "242",
    flagIcon: "🇨🇬",
    code: "CG"
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dialCode: "243",
    flagIcon: "🇨🇩",
    code: "CD"
  },
  {
    name: "Cook Islands",
    dialCode: "682",
    flagIcon: "🇨🇰",
    code: "CK"
  },
  {
    name: "Costa Rica",
    dialCode: "506",
    flagIcon: "🇨🇷",
    code: "CR"
  },
  {
    name: "Cote d'Ivoire",
    dialCode: "225",
    flagIcon: "🇨🇮",
    code: "CI"
  },
  {
    name: "Croatia",
    dialCode: "385",
    flagIcon: "🇭🇷",
    code: "HR"
  },
  {
    name: "Cuba",
    dialCode: "53",
    flagIcon: "🇨🇺",
    code: "CU"
  },
  {
    name: "Cyprus",
    dialCode: "357",
    flagIcon: "🇨🇾",
    code: "CY"
  },
  {
    name: "Czech Republic",
    dialCode: "420",
    flagIcon: "🇨🇿",
    code: "CZ"
  },
  {
    name: "Denmark",
    dialCode: "45",
    flagIcon: "🇩🇰",
    code: "DK"
  },
  {
    name: "Djibouti",
    dialCode: "253",
    flagIcon: "🇩🇯",
    code: "DJ"
  },
  {
    name: "Dominica",
    dialCode: "1767",
    flagIcon: "🇩🇲",
    code: "DM"
  },
  {
    name: "Dominican Republic",
    dialCode: "1849",
    flagIcon: "🇩🇴",
    code: "DO"
  },
  {
    name: "Ecuador",
    dialCode: "593",
    flagIcon: "🇪🇨",
    code: "EC"
  },
  {
    name: "Egypt",
    dialCode: "20",
    flagIcon: "🇪🇬",
    code: "EG"
  },
  {
    name: "El Salvador",
    dialCode: "503",
    flagIcon: "🇸🇻",
    code: "SV"
  },
  {
    name: "Equatorial Guinea",
    dialCode: "240",
    flagIcon: "🇬🇶",
    code: "GQ"
  },
  {
    name: "Eritrea",
    dialCode: "291",
    flagIcon: "🇪🇷",
    code: "ER"
  },
  {
    name: "Estonia",
    dialCode: "372",
    flagIcon: "🇪🇪",
    code: "EE"
  },
  {
    name: "Ethiopia",
    dialCode: "251",
    flagIcon: "🇪🇹",
    code: "ET"
  },
  {
    name: "Falkland Islands (Malvinas)",
    dialCode: "500",
    flagIcon: "🇫🇰",
    code: "FK"
  },
  {
    name: "Faroe Islands",
    dialCode: "298",
    flagIcon: "🇫🇴",
    code: "FO"
  },
  {
    name: "Fiji",
    dialCode: "679",
    flagIcon: "🇫🇯",
    code: "FJ"
  },
  {
    name: "Finland",
    dialCode: "358",
    flagIcon: "🇫🇮",
    code: "FI"
  },
  {
    name: "France",
    dialCode: "33",
    flagIcon: "🇫🇷",
    code: "FR"
  },
  {
    name: "French Guiana",
    dialCode: "594",
    flagIcon: "🇬🇫",
    code: "GF"
  },
  {
    name: "French Polynesia",
    dialCode: "689",
    flagIcon: "🇵🇫",
    code: "PF"
  },
  {
    name: "Gabon",
    dialCode: "241",
    flagIcon: "🇬🇦",
    code: "GA"
  },
  {
    name: "Gambia",
    dialCode: "220",
    flagIcon: "🇬🇲",
    code: "GM"
  },
  {
    name: "Georgia",
    dialCode: "995",
    flagIcon: "🇬🇪",
    code: "GE"
  },
  {
    name: "Germany",
    dialCode: "49",
    flagIcon: "🇩🇪",
    code: "DE"
  },
  {
    name: "Ghana",
    dialCode: "233",
    flagIcon: "🇬🇭",
    code: "GH"
  },
  {
    name: "Gibraltar",
    dialCode: "350",
    flagIcon: "🇬🇮",
    code: "GI"
  },
  {
    name: "Greece",
    dialCode: "30",
    flagIcon: "🇬🇷",
    code: "GR"
  },
  {
    name: "Greenland",
    dialCode: "299",
    flagIcon: "🇬🇱",
    code: "GL"
  },
  {
    name: "Grenada",
    dialCode: "1473",
    flagIcon: "🇬🇩",
    code: "GD"
  },
  {
    name: "Guadeloupe",
    dialCode: "590",
    flagIcon: "🇬🇵",
    code: "GP"
  },
  {
    name: "Guam",
    dialCode: "1671",
    flagIcon: "🇬🇺",
    code: "GU"
  },
  {
    name: "Guatemala",
    dialCode: "502",
    flagIcon: "🇬🇹",
    code: "GT"
  },
  {
    name: "Guernsey",
    dialCode: "44",
    flagIcon: "🇬🇬",
    code: "GG"
  },
  {
    name: "Guinea",
    dialCode: "224",
    flagIcon: "🇬🇳",
    code: "GN"
  },
  {
    name: "Guinea-Bissau",
    dialCode: "245",
    flagIcon: "🇬🇼",
    code: "GW"
  },
  {
    name: "Guyana",
    dialCode: "595",
    flagIcon: "🇬🇾",
    code: "GY"
  },
  {
    name: "Haiti",
    dialCode: "509",
    flagIcon: "🇭🇹",
    code: "HT"
  },
  {
    name: "Holy See (Vatican City State)",
    dialCode: "379",
    flagIcon: "🇻🇦",
    code: "VA"
  },
  {
    name: "Honduras",
    dialCode: "504",
    flagIcon: "🇭🇳",
    code: "HN"
  },
  {
    name: "Hong Kong",
    dialCode: "852",
    flagIcon: "🇭🇰",
    code: "HK"
  },
  {
    name: "Hungary",
    dialCode: "36",
    flagIcon: "🇭🇺",
    code: "HU"
  },
  {
    name: "Iceland",
    dialCode: "354",
    flagIcon: "🇮🇸",
    code: "IS"
  },
  {
    name: "India",
    dialCode: "91",
    flagIcon: "🇮🇳",
    code: "IN"
  },
  {
    name: "Indonesia",
    dialCode: "62",
    flagIcon: "🇮🇩",
    code: "ID"
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dialCode: "98",
    flagIcon: "🇮🇷",
    code: "IR"
  },
  {
    name: "Iraq",
    dialCode: "964",
    flagIcon: "🇮🇶",
    code: "IQ"
  },
  {
    name: "Ireland",
    dialCode: "353",
    flagIcon: "🇮🇪",
    code: "IE"
  },
  {
    name: "Isle of Man",
    dialCode: "44",
    flagIcon: "🇮🇲",
    code: "IM"
  },
  {
    name: "Israel",
    dialCode: "972",
    flagIcon: "🇮🇱",
    code: "IL"
  },
  {
    name: "Italy",
    dialCode: "39",
    flagIcon: "🇮🇹",
    code: "IT"
  },
  {
    name: "Jamaica",
    dialCode: "1876",
    flagIcon: "🇯🇲",
    code: "JM"
  },
  {
    name: "Japan",
    dialCode: "81",
    flagIcon: "🇯🇵",
    code: "JP"
  },
  {
    name: "Jersey",
    dialCode: "44",
    flagIcon: "🇯🇪",
    code: "JE"
  },
  {
    name: "Jordan",
    dialCode: "962",
    flagIcon: "🇯🇴",
    code: "JO"
  },
  {
    name: "Kazakhstan",
    dialCode: "77",
    flagIcon: "🇰🇿",
    code: "KZ"
  },
  {
    name: "Kenya",
    dialCode: "254",
    flagIcon: "🇰🇪",
    code: "KE"
  },
  {
    name: "Kiribati",
    dialCode: "686",
    flagIcon: "🇰🇮",
    code: "KI"
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dialCode: "850",
    flagIcon: "🇰🇵",
    code: "KP"
  },
  {
    name: "Korea, Republic of South Korea",
    dialCode: "82",
    flagIcon: "🇰🇷",
    code: "KR"
  },
  {
    name: "Kuwait",
    dialCode: "965",
    flagIcon: "🇰🇼",
    code: "KW"
  },
  {
    name: "Kyrgyzstan",
    dialCode: "996",
    flagIcon: "🇰🇬",
    code: "KG"
  },
  {
    name: "Laos",
    dialCode: "856",
    flagIcon: "🇱🇦",
    code: "LA"
  },
  {
    name: "Latvia",
    dialCode: "371",
    flagIcon: "🇱🇻",
    code: "LV"
  },
  {
    name: "Lebanon",
    dialCode: "961",
    flagIcon: "🇱🇧",
    code: "LB"
  },
  {
    name: "Lesotho",
    dialCode: "266",
    flagIcon: "🇱🇸",
    code: "LS"
  },
  {
    name: "Liberia",
    dialCode: "231",
    flagIcon: "🇱🇷",
    code: "LR"
  },
  {
    name: "Libyan Arab Jamahiriya",
    dialCode: "218",
    flagIcon: "🇱🇾",
    code: "LY"
  },
  {
    name: "Liechtenstein",
    dialCode: "423",
    flagIcon: "🇱🇮",
    code: "LI"
  },
  {
    name: "Lithuania",
    dialCode: "370",
    flagIcon: "🇱🇹",
    code: "LT"
  },
  {
    name: "Luxembourg",
    dialCode: "352",
    flagIcon: "🇱🇺",
    code: "LU"
  },
  {
    name: "Macao",
    dialCode: "853",
    flagIcon: "🇲🇴",
    code: "MO"
  },
  {
    name: "Macedonia",
    dialCode: "389",
    flagIcon: "🇲🇰",
    code: "MK"
  },
  {
    name: "Madagascar",
    dialCode: "261",
    flagIcon: "🇲🇬",
    code: "MG"
  },
  {
    name: "Malawi",
    dialCode: "265",
    flagIcon: "🇲🇼",
    code: "MW"
  },
  {
    name: "Malaysia",
    dialCode: "60",
    flagIcon: "🇲🇾",
    code: "MY"
  },
  {
    name: "Maldives",
    dialCode: "960",
    flagIcon: "🇲🇻",
    code: "MV"
  },
  {
    name: "Mali",
    dialCode: "223",
    flagIcon: "🇲🇱",
    code: "ML"
  },
  {
    name: "Malta",
    dialCode: "356",
    flagIcon: "🇲🇹",
    code: "MT"
  },
  {
    name: "Marshall Islands",
    dialCode: "692",
    flagIcon: "🇲🇭",
    code: "MH"
  },
  {
    name: "Martinique",
    dialCode: "596",
    flagIcon: "🇲🇶",
    code: "MQ"
  },
  {
    name: "Mauritania",
    dialCode: "222",
    flagIcon: "🇲🇷",
    code: "MR"
  },
  {
    name: "Mauritius",
    dialCode: "230",
    flagIcon: "🇲🇺",
    code: "MU"
  },
  {
    name: "Mayotte",
    dialCode: "262",
    flagIcon: "🇾🇹",
    code: "YT"
  },
  {
    name: "Mexico",
    dialCode: "52",
    flagIcon: "🇲🇽",
    code: "MX"
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    dialCode: "691",
    flagIcon: "🇫🇲",
    code: "FM"
  },
  {
    name: "Moldova",
    dialCode: "373",
    flagIcon: "🇲🇩",
    code: "MD"
  },
  {
    name: "Monaco",
    dialCode: "377",
    flagIcon: "🇲🇨",
    code: "MC"
  },
  {
    name: "Mongolia",
    dialCode: "976",
    flagIcon: "🇲🇳",
    code: "MN"
  },
  {
    name: "Montenegro",
    dialCode: "382",
    flagIcon: "🇲🇪",
    code: "ME"
  },
  {
    name: "Montserrat",
    dialCode: "1664",
    flagIcon: "🇲🇸",
    code: "MS"
  },
  {
    name: "Morocco",
    dialCode: "212",
    flagIcon: "🇲🇦",
    code: "MA"
  },
  {
    name: "Mozambique",
    dialCode: "258",
    flagIcon: "🇲🇿",
    code: "MZ"
  },
  {
    name: "Myanmar",
    dialCode: "95",
    flagIcon: "🇲🇲",
    code: "MM"
  },
  {
    name: "Namibia",
    dialCode: "264",
    flagIcon: "🇳🇦",
    code: "NA"
  },
  {
    name: "Nauru",
    dialCode: "674",
    flagIcon: "🇳🇷",
    code: "NR"
  },
  {
    name: "Nepal",
    dialCode: "977",
    flagIcon: "🇳🇵",
    code: "NP"
  },
  {
    name: "Netherlands",
    dialCode: "31",
    flagIcon: "🇳🇱",
    code: "NL"
  },
  {
    name: "Netherlands Antilles",
    dialCode: "599",
    flagIcon: "🇦🇳",
    code: "AN"
  },
  {
    name: "New Caledonia",
    dialCode: "687",
    flagIcon: "🇳🇨",
    code: "NC"
  },
  {
    name: "New Zealand",
    dialCode: "64",
    flagIcon: "🇳🇿",
    code: "NZ"
  },
  {
    name: "Nicaragua",
    dialCode: "505",
    flagIcon: "🇳🇮",
    code: "NI"
  },
  {
    name: "Niger",
    dialCode: "227",
    flagIcon: "🇳🇪",
    code: "NE"
  },
  {
    name: "Nigeria",
    dialCode: "234",
    flagIcon: "🇳🇬",
    code: "NG"
  },
  {
    name: "Niue",
    dialCode: "683",
    flagIcon: "🇳🇺",
    code: "NU"
  },
  {
    name: "Norfolk Island",
    dialCode: "672",
    flagIcon: "🇳🇫",
    code: "NF"
  },
  {
    name: "Northern Mariana Islands",
    dialCode: "1670",
    flagIcon: "🇲🇵",
    code: "MP"
  },
  {
    name: "Norway",
    dialCode: "47",
    flagIcon: "🇳🇴",
    code: "NO"
  },
  {
    name: "Oman",
    dialCode: "968",
    flagIcon: "🇴🇲",
    code: "OM"
  },
  {
    name: "Pakistan",
    dialCode: "92",
    flagIcon: "🇵🇰",
    code: "PK"
  },
  {
    name: "Palau",
    dialCode: "680",
    flagIcon: "🇵🇼",
    code: "PW"
  },
  {
    name: "Palestinian Territory, Occupied",
    dialCode: "970",
    flagIcon: "🇵🇸",
    code: "PS"
  },
  {
    name: "Panama",
    dialCode: "507",
    flagIcon: "🇵🇦",
    code: "PA"
  },
  {
    name: "Papua New Guinea",
    dialCode: "675",
    flagIcon: "🇵🇬",
    code: "PG"
  },
  {
    name: "Paraguay",
    dialCode: "595",
    flagIcon: "🇵🇾",
    code: "PY"
  },
  {
    name: "Peru",
    dialCode: "51",
    flagIcon: "🇵🇪",
    code: "PE"
  },
  {
    name: "Philippines",
    dialCode: "63",
    flagIcon: "🇵🇭",
    code: "PH"
  },
  {
    name: "Pitcairn",
    dialCode: "872",
    flagIcon: "🇵🇳",
    code: "PN"
  },
  {
    name: "Poland",
    dialCode: "48",
    flagIcon: "🇵🇱",
    code: "PL"
  },
  {
    name: "Portugal",
    dialCode: "351",
    flagIcon: "🇵🇹",
    code: "PT"
  },
  {
    name: "Puerto Rico",
    dialCode: "1939",
    flagIcon: "🇵🇷",
    code: "PR"
  },
  {
    name: "Qatar",
    dialCode: "974",
    flagIcon: "🇶🇦",
    code: "QA"
  },
  {
    name: "Romania",
    dialCode: "40",
    flagIcon: "🇷🇴",
    code: "RO"
  },
  {
    name: "Russia",
    dialCode: "7",
    flagIcon: "🇷🇺",
    code: "RU"
  },
  {
    name: "Rwanda",
    dialCode: "250",
    flagIcon: "🇷🇼",
    code: "RW"
  },
  {
    name: "Reunion",
    dialCode: "262",
    flagIcon: "🇷🇪",
    code: "RE"
  },
  {
    name: "Saint Barthelemy",
    dialCode: "590",
    flagIcon: "🇧🇱",
    code: "BL"
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dialCode: "290",
    flagIcon: "🇸🇭",
    code: "SH"
  },
  {
    name: "Saint Kitts and Nevis",
    dialCode: "1869",
    flagIcon: "🇰🇳",
    code: "KN"
  },
  {
    name: "Saint Lucia",
    dialCode: "1758",
    flagIcon: "🇱🇨",
    code: "LC"
  },
  {
    name: "Saint Martin",
    dialCode: "590",
    flagIcon: "🇲🇫",
    code: "MF"
  },
  {
    name: "Saint Pierre and Miquelon",
    dialCode: "508",
    flagIcon: "🇵🇲",
    code: "PM"
  },
  {
    name: "Saint Vincent and the Grenadines",
    dialCode: "1784",
    flagIcon: "🇻🇨",
    code: "VC"
  },
  {
    name: "Samoa",
    dialCode: "685",
    flagIcon: "🇼🇸",
    code: "WS"
  },
  {
    name: "San Marino",
    dialCode: "378",
    flagIcon: "🇸🇲",
    code: "SM"
  },
  {
    name: "Sao Tome and Principe",
    dialCode: "239",
    flagIcon: "🇸🇹",
    code: "ST"
  },
  {
    name: "Saudi Arabia",
    dialCode: "966",
    flagIcon: "🇸🇦",
    code: "SA"
  },
  {
    name: "Senegal",
    dialCode: "221",
    flagIcon: "🇸🇳",
    code: "SN"
  },
  {
    name: "Serbia",
    dialCode: "381",
    flagIcon: "🇷🇸",
    code: "RS"
  },
  {
    name: "Seychelles",
    dialCode: "248",
    flagIcon: "🇸🇨",
    code: "SC"
  },
  {
    name: "Sierra Leone",
    dialCode: "232",
    flagIcon: "🇸🇱",
    code: "SL"
  },
  {
    name: "Singapore",
    dialCode: "65",
    flagIcon: "🇸🇬",
    code: "SG"
  },
  {
    name: "Slovakia",
    dialCode: "421",
    flagIcon: "🇸🇰",
    code: "SK"
  },
  {
    name: "Slovenia",
    dialCode: "386",
    flagIcon: "🇸🇮",
    code: "SI"
  },
  {
    name: "Solomon Islands",
    dialCode: "677",
    flagIcon: "🇸🇧",
    code: "SB"
  },
  {
    name: "Somalia",
    dialCode: "252",
    flagIcon: "🇸🇴",
    code: "SO"
  },
  {
    name: "South Africa",
    dialCode: "27",
    flagIcon: "🇿🇦",
    code: "ZA"
  },
  {
    name: "South Sudan",
    dialCode: "211",
    flagIcon: "🇸🇸",
    code: "SS"
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dialCode: "500",
    flagIcon: "🇬🇸",
    code: "GS"
  },
  {
    name: "Spain",
    dialCode: "34",
    flagIcon: "🇪🇸",
    code: "ES"
  },
  {
    name: "Sri Lanka",
    dialCode: "94",
    flagIcon: "🇱🇰",
    code: "LK"
  },
  {
    name: "Sudan",
    dialCode: "249",
    flagIcon: "🇸🇩",
    code: "SD"
  },
  {
    name: "Suriname",
    dialCode: "597",
    flagIcon: "🇸🇷",
    code: "SR"
  },
  {
    name: "Svalbard and Jan Mayen",
    dialCode: "47",
    flagIcon: "🇸🇯",
    code: "SJ"
  },
  {
    name: "Swaziland",
    dialCode: "268",
    flagIcon: "🇸🇿",
    code: "SZ"
  },
  {
    name: "Sweden",
    dialCode: "46",
    flagIcon: "🇸🇪",
    code: "SE"
  },
  {
    name: "Switzerland",
    dialCode: "41",
    flagIcon: "🇨🇭",
    code: "CH"
  },
  {
    name: "Syrian Arab Republic",
    dialCode: "963",
    flagIcon: "🇸🇾",
    code: "SY"
  },
  {
    name: "Taiwan",
    dialCode: "886",
    flagIcon: "🇹🇼",
    code: "TW"
  },
  {
    name: "Tajikistan",
    dialCode: "992",
    flagIcon: "🇹🇯",
    code: "TJ"
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    dialCode: "255",
    flagIcon: "🇹🇿",
    code: "TZ"
  },
  {
    name: "Thailand",
    dialCode: "66",
    flagIcon: "🇹🇭",
    code: "TH"
  },
  {
    name: "Timor-Leste",
    dialCode: "670",
    flagIcon: "🇹🇱",
    code: "TL"
  },
  {
    name: "Togo",
    dialCode: "228",
    flagIcon: "🇹🇬",
    code: "TG"
  },
  {
    name: "Tokelau",
    dialCode: "690",
    flagIcon: "🇹🇰",
    code: "TK"
  },
  {
    name: "Tonga",
    dialCode: "676",
    flagIcon: "🇹🇴",
    code: "TO"
  },
  {
    name: "Trinidad and Tobago",
    dialCode: "1868",
    flagIcon: "🇹🇹",
    code: "TT"
  },
  {
    name: "Tunisia",
    dialCode: "216",
    flagIcon: "🇹🇳",
    code: "TN"
  },
  {
    name: "Turkey",
    dialCode: "90",
    flagIcon: "🇹🇷",
    code: "TR"
  },
  {
    name: "Turkmenistan",
    dialCode: "993",
    flagIcon: "🇹🇲",
    code: "TM"
  },
  {
    name: "Turks and Caicos Islands",
    dialCode: "1649",
    flagIcon: "🇹🇨",
    code: "TC"
  },
  {
    name: "Tuvalu",
    dialCode: "688",
    flagIcon: "🇹🇻",
    code: "TV"
  },
  {
    name: "Uganda",
    dialCode: "256",
    flagIcon: "🇺🇬",
    code: "UG"
  },
  {
    name: "Ukraine",
    dialCode: "380",
    flagIcon: "🇺🇦",
    code: "UA"
  },
  {
    name: "United Arab Emirates",
    dialCode: "971",
    flagIcon: "🇦🇪",
    code: "AE"
  },
  {
    name: "United Kingdom",
    dialCode: "44",
    flagIcon: "🇬🇧",
    code: "GB"
  },
  {
    name: "United States",
    dialCode: "1",
    flagIcon: "🇺🇸",
    code: "US"
  },
  {
    name: "Uruguay",
    dialCode: "598",
    flagIcon: "🇺🇾",
    code: "UY"
  },
  {
    name: "Uzbekistan",
    dialCode: "998",
    flagIcon: "🇺🇿",
    code: "UZ"
  },
  {
    name: "Vanuatu",
    dialCode: "678",
    flagIcon: "🇻🇺",
    code: "VU"
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dialCode: "58",
    flagIcon: "🇻🇪",
    code: "VE"
  },
  {
    name: "Vietnam",
    dialCode: "84",
    flagIcon: "🇻🇳",
    code: "VN"
  },
  {
    name: "Virgin Islands, British",
    dialCode: "1284",
    flagIcon: "🇻🇬",
    code: "VG"
  },
  {
    name: "Virgin Islands, U.S.",
    dialCode: "1340",
    flagIcon: "🇻🇮",
    code: "VI"
  },
  {
    name: "Wallis and Futuna",
    dialCode: "681",
    flagIcon: "🇼🇫",
    code: "WF"
  },
  {
    name: "Yemen",
    dialCode: "967",
    flagIcon: "🇾🇪",
    code: "YE"
  },
  {
    name: "Zambia",
    dialCode: "260",
    flagIcon: "🇿🇲",
    code: "ZM"
  },
  {
    name: "Zimbabwe",
    dialCode: "263",
    flagIcon: "🇿🇼",
    code: "ZW"
  }
], ib = {
  key: 0,
  class: "mb-1.5"
}, rb = {
  key: 0,
  class: "flex items-start"
}, ab = { class: "relative rounded-[4.16px] shadow-[0px_1px_2px_rgba(28,31,39,0.05)]" }, lb = { class: "w-4" }, sb = ["onClick", "onMouseenter", "onMouseleave"], ub = ["id", "value", "disabled", "name", "placeholder", "required"], db = /* @__PURE__ */ re({
  __name: "FieldPhoneNumber",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    id: {
      type: [String, Number],
      default: null
    },
    locale: {
      type: String,
      default: "en"
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    validationDisabled: {
      type: Boolean,
      default: !1
    },
    errorMessage: {
      type: String,
      default: null
    },
    customColor: {
      type: String,
      default: null
    },
    customRgbColor: {
      type: String,
      default: null
    }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(e, { emit: n }) {
    const t = e;
    Cn();
    const o = X(), i = X(null), r = ki(/* @__PURE__ */ new Map()), a = X(!1), l = Ka.find(
      (w) => w.code === "FR"
    ), s = ki({
      code: (l == null ? void 0 : l.code) || "",
      flagIcon: (l == null ? void 0 : l.flagIcon) || "",
      name: (l == null ? void 0 : l.name) || "",
      dialCode: (l == null ? void 0 : l.dialCode) || ""
    }), u = X(!1), d = ee(() => s), f = ee(() => {
      if (t.modelValue) {
        const w = sr(t.modelValue);
        return (w == null ? void 0 : w.formatNational()) || t.modelValue;
      }
      return t.modelValue || "";
    }), c = n;
    Ge(() => x()), Ne(
      () => t.modelValue,
      (w) => {
        if (w) {
          const $ = sr(w);
          if ($ && $.country) {
            const E = Ka.find(
              (A) => A.code === $.country
            );
            E && (s.code = E.code, s.flagIcon = E.flagIcon, s.name = E.name, s.dialCode = E.dialCode);
          }
        }
      },
      { immediate: !0 }
    );
    const h = (w) => {
      r.set(w, !0);
    }, m = (w) => {
      r.set(w, !1);
    }, g = (w) => {
      var E;
      const $ = w.target;
      ((E = t.modelValue) == null ? void 0 : E.length) === 0 && (a.value = !1), c("blur", $.value, t.id);
    }, v = (w) => {
      const $ = w.target;
      a.value = !0, c("focus", $.value, t.id);
    }, p = (w) => {
      let E = w.target.value;
      const A = sr(
        E,
        s.code
      );
      A && (E = A.number), c("change", E, t.id), c(
        "update:modelValue",
        (A == null ? void 0 : A.formatInternational()) || E,
        t.id
      );
    }, y = (w) => {
      ["+", "-", "e", "E"].includes(w.key) && w.preventDefault(), w.code == "Enter" && c("submit", t.id);
    }, C = () => {
      u.value = !u.value;
    }, b = (w) => {
      s.code = w.code, s.flagIcon = w.flagIcon, s.name = w.name, s.dialCode = w.dialCode, u.value = !1, x();
    }, x = () => {
      if (o.value) {
        const w = o.value.querySelector("input");
        if (w)
          if (s.code) {
            const $ = sr(
              w.value,
              s.code
            );
            c("update:modelValue", $ == null ? void 0 : $.number, t.id), w.value = ($ == null ? void 0 : $.formatNational()) || w.value;
          } else
            w.value = t.modelValue || "";
      }
    };
    return Y1(i, (w) => {
      w.stopPropagation(), u.value && (u.value = !1);
    }), (w, $) => {
      var E, A, O, k, S, T, L, F, U, W;
      return _(), P("div", {
        ref_key: "root",
        ref: o
      }, [
        e.label || e.description ? (_(), P("div", ib, [
          e.label ? (_(), P("div", rb, [
            ce(Re, {
              id: `${e.id}`,
              label: e.label
            }, null, 8, ["id", "label"]),
            e.required ? (_(), P("span", {
              key: 0,
              class: pe([
                "ml-1 text-mgm-txt-sm font-medium",
                { "text-foreground-brand-default": !e.customColor }
              ]),
              style: Ye({ color: e.customColor })
            }, " * ", 6)) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("div", ab, [
          M("div", {
            class: "flex items-center justify-center absolute top-0 bottom-0 px-3 left-0 font-normal text-mgm-txt-sm text-foreground-subtle",
            onClick: C
          }, [
            M("div", lb, de(d.value.flagIcon), 1),
            ce(Le, {
              class: "ml-1 mr-2.5",
              icon: u.value ? "chevron-up" : "chevron-down",
              color: "#5F6C85"
            }, null, 8, ["icon"]),
            Ie(" " + de(`+${d.value.dialCode}`), 1)
          ]),
          u.value ? (_(), P("div", {
            key: 0,
            ref_key: "dropdownRef",
            ref: i,
            class: "absolute z-10 rounded-b-[4.16px] py-1 right-0 left-0 h-48 overflow-auto mt-8 border-[0.83px] border-border-default bg-background-default text-mgm-txt-sm text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0"
          }, [
            (_(!0), P(me, null, Fe(I(Ka), (oe) => (_(), P("li", {
              class: pe([
                "truncate  cursor-pointer select-none list-none py-1 pl-3 pr-9",
                r.get(oe.code) ? "text-foreground-on-emphasis" : "text-foreground-emphasis",
                ,
                r.get(oe.code) && !e.customColor ? "bg-background-brand-emphasis" : "bg-background-default"
              ]),
              style: Ye({
                backgroundColor: r.get(oe.code) && e.customColor ? e.customColor : void 0
              }),
              key: oe.code,
              onClick: (H) => b(oe),
              onMouseenter: (H) => h(oe.code),
              onMouseleave: (H) => m(oe.code)
            }, de(`${oe.flagIcon} ${oe.name} +${oe.dialCode}`), 47, sb))), 128))
          ], 512)) : z("", !0),
          M("input", {
            id: `${e.id}`,
            class: pe([
              "box-border block w-full pr-2.5 py-2 pl-[100px]  rounded-[4.16px] text-mgm-txt-sm font-normal text-foreground-emphasis outline-0 placeholder:text-foreground-subtle",
              (A = (E = e.validation) == null ? void 0 : E.$errors) != null && A.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default",
              {
                "focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:ring-border-brand-emphasis": !e.customColor && !((k = (O = e.validation) == null ? void 0 : O.$errors) != null && k.length)
              }
            ]),
            style: Ye({
              borderColor: e.customColor && a.value && !((T = (S = e.validation) == null ? void 0 : S.$errors) != null && T.length) ? e.customColor : void 0,
              boxShadow: e.customColor && a.value && !((F = (L = e.validation) == null ? void 0 : L.$errors) != null && F.length) ? `0px 1px 2px rgba(${e.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${e.customRgbColor}, 0.2)` : void 0
            }),
            value: f.value,
            autocomplete: "tel-national",
            disabled: e.disabled,
            name: `${e.id}`,
            placeholder: e.placeholder,
            required: e.required,
            type: "tel-national",
            onBlur: g,
            onFocus: v,
            onInput: p,
            onKeypress: y
          }, null, 46, ub)
        ]),
        (e.validation && ((U = e.validation.$errors) == null ? void 0 : U.length) > 0 || e.errorMessage) && !e.validationDisabled ? (_(), ie(Re, {
          key: 1,
          class: "mt-[3px]",
          label: ((W = e.validation.$errors[0]) == null ? void 0 : W.$message) || e.errorMessage,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ], 512);
    };
  }
});
function pd(e) {
  const n = e;
  n.__i18n = n.__i18n || [], n.__i18n.push({
    locale: "",
    resource: {
      en: {
        country: (t) => {
          const { normalize: o } = t;
          return o(["Country"]);
        },
        color: (t) => {
          const { normalize: o } = t;
          return o(["Pick a color"]);
        }
      },
      fr: {
        country: (t) => {
          const { normalize: o } = t;
          return o(["Pays"]);
        },
        color: (t) => {
          const { normalize: o } = t;
          return o(["Choisir une couleur"]);
        }
      }
    }
  });
}
typeof pd == "function" && pd(db);
const cb = ["onClick", "onKeyup"], fb = ["id", "checked", "disabled", "name", "required", "onInput"], hb = ["for"], gb = ["for"], mb = ["innerHTML"], TA = /* @__PURE__ */ re({
  __name: "FieldRadio",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, o = (i) => {
      t("update:modelValue", i);
    };
    return (i, r) => {
      var l, s;
      const a = ns("tooltip");
      return _(), P(me, null, [
        (_(!0), P(me, null, Fe(e.options, (u, d) => (_(), P("div", {
          key: u.value,
          tabindex: "0",
          class: pe([
            "flex cursor-pointer w-fit",
            e.type !== "default" && e.modelValue === u.value ? "border-border-brand-emphasis bg-background-brand-default" : "border-border-default bg-background-default",
            {
              "rounded-[5px] border-[1px] px-4 focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:ring-border-brand-emphasis": e.type !== "default",
              "py-2": e.type === "simple",
              "py-3": e.type === "expanded",
              "mb-2": e.type === "default",
              "items-center": !u.description
            }
          ]),
          onClick: (f) => o(u.value),
          onKeyup: [
            pn((f) => o(u.value), ["enter"]),
            pn((f) => o(u.value), ["space"])
          ]
        }, [
          M("input", {
            id: u.value,
            tabindex: "-1",
            class: pe([
              "h-4 w-4 shrink-0 cursor-pointer rounded border-border-subtle text-foreground-brand-default accent-background-brand-emphasis",
              { "mt-0.5": u.description },
              { "mt-1": e.type === "default" }
            ]),
            checked: e.modelValue === u.value,
            disabled: e.disabled,
            name: u.value,
            required: e.required,
            type: "radio",
            onInput: (f) => o(u.value)
          }, null, 42, fb),
          u.label || u.description ? (_(), P("label", {
            key: 0,
            for: u.value,
            class: pe([
              "cursor-pointer ml-3",
              e.type === "expanded" ? "ml-3" : "ml-2",
              u.inlineDescription ? "flex gap-2" : ""
            ])
          }, [
            u.label ? (_(), P("span", {
              key: 0,
              for: e.id,
              class: "flex text-mgm-txt-sm font-medium text-foreground-emphasis"
            }, [
              Ie(de(u.label) + " ", 1),
              u.tooltip ? po((_(), ie(Le, {
                key: 0,
                class: "ml-2",
                color: "#5F6C85",
                icon: "help-circle"
              }, null, 512)), [
                [a, u.tooltip]
              ]) : z("", !0)
            ], 8, gb)) : z("", !0),
            u.description ? (_(), P("span", {
              key: 1,
              class: "block text-mgm-txt-sm font-normal text-foreground-default",
              innerHTML: u.description
            }, null, 8, mb)) : z("", !0)
          ], 10, hb)) : z("", !0)
        ], 42, cb))), 128)),
        e.validation && ((l = e.validation.$errors) != null && l.length) ? (_(), ie(Re, {
          key: 0,
          class: "mt-[3px]",
          label: (s = e.validation.$errors[0]) == null ? void 0 : s.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ], 64);
    };
  }
}), pb = {
  key: 0,
  class: "mb-1.5"
}, vb = {
  key: 0,
  class: "flex items-start"
}, bb = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, yb = { class: "grid grid-cols-2 gap-2" }, Cb = ["onClick"], xb = { class: "text-mgm-dspl-md" }, PA = /* @__PURE__ */ re({
  __name: "FieldRating",
  props: {
    modelValue: {
      type: Number,
      default: null
    },
    id: {
      type: [String, Number],
      default: null
    },
    ratings: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, o = (i) => {
      t("update:modelValue", i);
    };
    return (i, r) => {
      var a, l;
      return _(), P("div", null, [
        e.label || e.description ? (_(), P("div", pb, [
          e.label ? (_(), P("div", vb, [
            ce(Re, {
              for: e.id,
              label: e.label
            }, null, 8, ["for", "label"]),
            e.required ? (_(), P("span", bb, " * ")) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("div", yb, [
          (_(!0), P(me, null, Fe(e.ratings, (s) => (_(), P("div", {
            key: s.value,
            class: pe([{
              "border-border-brand-emphasis bg-background-brand-default-hover ": e.modelValue == s.value,
              "border-border-default ": e.modelValue != s.value
            }, "flex flex-1 cursor-pointer flex-col content-center items-center justify-center rounded-[5px] border py-2 text-mgm-txt-sm"]),
            "data-cy": "btn-rate",
            onClick: (u) => o(s.value)
          }, [
            M("span", xb, de(s.emoji), 1),
            Ie(" " + de(i.$t(s.label)), 1)
          ], 10, Cb))), 128))
        ]),
        e.validation && ((a = e.validation.$errors) != null && a.length) ? (_(), ie(Re, {
          key: 1,
          class: "mt-[3px]",
          label: (l = e.validation.$errors[0]) == null ? void 0 : l.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ]);
    };
  }
});
function bt(e, n, ...t) {
  if (e in n) {
    let i = n[e];
    return typeof i == "function" ? i(...t) : i;
  }
  let o = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(o, bt), o;
}
var yo = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(yo || {}), wb = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(wb || {});
function Dt({ visible: e = !0, features: n = 0, ourProps: t, theirProps: o, ...i }) {
  var r;
  let a = Z1(o, t), l = Object.assign(i, { props: a });
  if (e || n & 2 && a.static)
    return Ya(l);
  if (n & 1) {
    let s = (r = a.unmount) == null || r ? 0 : 1;
    return bt(s, { 0() {
      return null;
    }, 1() {
      return Ya({ ...i, props: { ...a, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Ya(l);
}
function Ya({ props: e, attrs: n, slots: t, slot: o, name: i }) {
  var r, a;
  let { as: l, ...s } = Ki(e, ["unmount", "static"]), u = (r = t.default) == null ? void 0 : r.call(t, o), d = {};
  if (o) {
    let f = !1, c = [];
    for (let [h, m] of Object.entries(o))
      typeof m == "boolean" && (f = !0), m === !0 && c.push(h);
    f && (d["data-headlessui-state"] = c.join(" "));
  }
  if (l === "template") {
    if (u = G1(u ?? []), Object.keys(s).length > 0 || Object.keys(n).length > 0) {
      let [f, ...c] = u ?? [];
      if (!$b(f) || c.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${i} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(s).concat(Object.keys(n)).map((g) => g.trim()).filter((g, v, p) => p.indexOf(g) === v).sort((g, v) => g.localeCompare(v)).map((g) => `  - ${g}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((g) => `  - ${g}`).join(`
`)].join(`
`));
      let h = Z1((a = f.props) != null ? a : {}, s), m = t1(f, h);
      for (let g in h)
        g.startsWith("on") && (m.props || (m.props = {}), m.props[g] = h[g]);
      return m;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return wt(l, Object.assign({}, s, d), { default: () => u });
}
function G1(e) {
  return e.flatMap((n) => n.type === me ? G1(n.children) : [n]);
}
function Z1(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let n = {}, t = {};
  for (let o of e)
    for (let i in o)
      i.startsWith("on") && typeof o[i] == "function" ? (t[i] != null || (t[i] = []), t[i].push(o[i])) : n[i] = o[i];
  if (n.disabled || n["aria-disabled"])
    return Object.assign(n, Object.fromEntries(Object.keys(t).map((o) => [o, void 0])));
  for (let o in t)
    Object.assign(n, { [o](i, ...r) {
      let a = t[o];
      for (let l of a) {
        if (i instanceof Event && i.defaultPrevented)
          return;
        l(i, ...r);
      }
    } });
  return n;
}
function vs(e) {
  let n = Object.assign({}, e);
  for (let t in n)
    n[t] === void 0 && delete n[t];
  return n;
}
function Ki(e, n = []) {
  let t = Object.assign({}, e);
  for (let o of n)
    o in t && delete t[o];
  return t;
}
function $b(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
let kb = 0;
function _b() {
  return ++kb;
}
function rn() {
  return _b();
}
var We = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(We || {});
function Ob(e) {
  throw new Error("Unexpected object: " + e);
}
var Xe = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Xe || {});
function X1(e, n) {
  let t = n.resolveItems();
  if (t.length <= 0)
    return null;
  let o = n.resolveActiveIndex(), i = o ?? -1, r = (() => {
    switch (e.focus) {
      case 0:
        return t.findIndex((a) => !n.resolveDisabled(a));
      case 1: {
        let a = t.slice().reverse().findIndex((l, s, u) => i !== -1 && u.length - s - 1 >= i ? !1 : !n.resolveDisabled(l));
        return a === -1 ? a : t.length - 1 - a;
      }
      case 2:
        return t.findIndex((a, l) => l <= i ? !1 : !n.resolveDisabled(a));
      case 3: {
        let a = t.slice().reverse().findIndex((l) => !n.resolveDisabled(l));
        return a === -1 ? a : t.length - 1 - a;
      }
      case 4:
        return t.findIndex((a) => n.resolveId(a) === e.id);
      case 5:
        return null;
      default:
        Ob(e);
    }
  })();
  return r === -1 ? o : r;
}
function Te(e) {
  var n;
  return e == null || e.value == null ? null : (n = e.value.$el) != null ? n : e.value;
}
let J1 = Symbol("Context");
var Pn = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Pn || {});
function Q1() {
  return eo(J1, null);
}
function ef(e) {
  $o(J1, e);
}
function vd(e, n) {
  if (e)
    return e;
  let t = n ?? "button";
  if (typeof t == "string" && t.toLowerCase() === "button")
    return "button";
}
function bs(e, n) {
  let t = X(vd(e.value.type, e.value.as));
  return Ge(() => {
    t.value = vd(e.value.type, e.value.as);
  }), ct(() => {
    var o;
    t.value || Te(n) && Te(n) instanceof HTMLButtonElement && !((o = Te(n)) != null && o.hasAttribute("type")) && (t.value = "button");
  }), t;
}
var Eb = Object.defineProperty, Mb = (e, n, t) => n in e ? Eb(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, bd = (e, n, t) => (Mb(e, typeof n != "symbol" ? n + "" : n, t), t);
class Sb {
  constructor() {
    bd(this, "current", this.detect()), bd(this, "currentId", 0);
  }
  set(n) {
    this.current !== n && (this.currentId = 0, this.current = n);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}
let ys = new Sb();
function Cs(e) {
  if (ys.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let n = Te(e);
    if (n)
      return n.ownerDocument;
  }
  return document;
}
function Ab({ container: e, accept: n, walk: t, enabled: o }) {
  ct(() => {
    let i = e.value;
    if (!i || o !== void 0 && !o.value)
      return;
    let r = Cs(e);
    if (!r)
      return;
    let a = Object.assign((s) => n(s), { acceptNode: n }), l = r.createTreeWalker(i, NodeFilter.SHOW_ELEMENT, a, !1);
    for (; l.nextNode(); )
      t(l.currentNode);
  });
}
let yd = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Tb = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Tb || {}), Pb = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Pb || {}), Ib = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Ib || {}), xs = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(xs || {});
function tf(e, n = 0) {
  var t;
  return e === ((t = Cs(e)) == null ? void 0 : t.body) ? !1 : bt(n, { 0() {
    return e.matches(yd);
  }, 1() {
    let o = e;
    for (; o !== null; ) {
      if (o.matches(yd))
        return !0;
      o = o.parentElement;
    }
    return !1;
  } });
}
var Db = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Db || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function nf(e, n = (t) => t) {
  return e.slice().sort((t, o) => {
    let i = n(t), r = n(o);
    if (i === null || r === null)
      return 0;
    let a = i.compareDocumentPosition(r);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function ur(e, n, t) {
  ys.isServer || ct((o) => {
    document.addEventListener(e, n, t), o(() => document.removeEventListener(e, n, t));
  });
}
function Lb(e, n, t) {
  ys.isServer || ct((o) => {
    window.addEventListener(e, n, t), o(() => window.removeEventListener(e, n, t));
  });
}
function of(e, n, t = ee(() => !0)) {
  function o(r, a) {
    if (!t.value || r.defaultPrevented)
      return;
    let l = a(r);
    if (l === null || !l.getRootNode().contains(l))
      return;
    let s = function u(d) {
      return typeof d == "function" ? u(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e);
    for (let u of s) {
      if (u === null)
        continue;
      let d = u instanceof HTMLElement ? u : Te(u);
      if (d != null && d.contains(l) || r.composed && r.composedPath().includes(d))
        return;
    }
    return !tf(l, xs.Loose) && l.tabIndex !== -1 && r.preventDefault(), n(r, l);
  }
  let i = X(null);
  ur("pointerdown", (r) => {
    var a, l;
    t.value && (i.value = ((l = (a = r.composedPath) == null ? void 0 : a.call(r)) == null ? void 0 : l[0]) || r.target);
  }, !0), ur("mousedown", (r) => {
    var a, l;
    t.value && (i.value = ((l = (a = r.composedPath) == null ? void 0 : a.call(r)) == null ? void 0 : l[0]) || r.target);
  }, !0), ur("click", (r) => {
    i.value && (o(r, () => i.value), i.value = null);
  }, !0), ur("touchend", (r) => o(r, () => r.target instanceof HTMLElement ? r.target : null), !0), Lb("blur", (r) => o(r, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var ba = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(ba || {});
let ws = re({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: n, attrs: t }) {
  return () => {
    let { features: o, ...i } = e, r = { "aria-hidden": (o & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return Dt({ ourProps: r, theirProps: i, slot: {}, attrs: t, slots: n, name: "Hidden" });
  };
} });
function $s(e = {}, n = null, t = []) {
  for (let [o, i] of Object.entries(e))
    af(t, rf(n, o), i);
  return t;
}
function rf(e, n) {
  return e ? e + "[" + n + "]" : n;
}
function af(e, n, t) {
  if (Array.isArray(t))
    for (let [o, i] of t.entries())
      af(e, rf(n, o.toString()), i);
  else
    t instanceof Date ? e.push([n, t.toISOString()]) : typeof t == "boolean" ? e.push([n, t ? "1" : "0"]) : typeof t == "string" ? e.push([n, t]) : typeof t == "number" ? e.push([n, `${t}`]) : t == null ? e.push([n, ""]) : $s(t, n, e);
}
function Nb(e) {
  var n, t;
  let o = (n = e == null ? void 0 : e.form) != null ? n : e.closest("form");
  if (o) {
    for (let i of o.elements)
      if (i !== e && (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image")) {
        i.click();
        return;
      }
    (t = o.requestSubmit) == null || t.call(o);
  }
}
function ks(e, n, t) {
  let o = X(t == null ? void 0 : t.value), i = ee(() => e.value !== void 0);
  return [ee(() => i.value ? e.value : o.value), function(r) {
    return i.value || (o.value = r), n == null ? void 0 : n(r);
  }];
}
function Cd(e) {
  return [e.screenX, e.screenY];
}
function lf() {
  let e = X([-1, -1]);
  return { wasMoved(n) {
    let t = Cd(n);
    return e.value[0] === t[0] && e.value[1] === t[1] ? !1 : (e.value = t, !0);
  }, update(n) {
    e.value = Cd(n);
  } };
}
function Fb() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Rb() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Bb() {
  return Fb() || Rb();
}
function Vb(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((n) => setTimeout(() => {
    throw n;
  }));
}
function sf() {
  let e = [], n = { addEventListener(t, o, i, r) {
    return t.addEventListener(o, i, r), n.add(() => t.removeEventListener(o, i, r));
  }, requestAnimationFrame(...t) {
    let o = requestAnimationFrame(...t);
    n.add(() => cancelAnimationFrame(o));
  }, nextFrame(...t) {
    n.requestAnimationFrame(() => {
      n.requestAnimationFrame(...t);
    });
  }, setTimeout(...t) {
    let o = setTimeout(...t);
    n.add(() => clearTimeout(o));
  }, microTask(...t) {
    let o = { current: !0 };
    return Vb(() => {
      o.current && t[0]();
    }), n.add(() => {
      o.current = !1;
    });
  }, style(t, o, i) {
    let r = t.style.getPropertyValue(o);
    return Object.assign(t.style, { [o]: i }), this.add(() => {
      Object.assign(t.style, { [o]: r });
    });
  }, group(t) {
    let o = sf();
    return t(o), this.add(() => o.dispose());
  }, add(t) {
    return e.push(t), () => {
      let o = e.indexOf(t);
      if (o >= 0)
        for (let i of e.splice(o, 1))
          i();
    };
  }, dispose() {
    for (let t of e.splice(0))
      t();
  } };
  return n;
}
function jb(e, n) {
  return e === n;
}
var Hb = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Hb || {}), zb = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(zb || {}), qb = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(qb || {});
let uf = Symbol("ComboboxContext");
function Qo(e) {
  let n = eo(uf, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Qo), t;
  }
  return n;
}
let Ub = re({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => jb }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: n, attrs: t, emit: o }) {
  let i = X(1), r = X(null), a = X(null), l = X(null), s = X(null), u = X({ static: !1, hold: !1 }), d = X([]), f = X(null), c = X(1), h = X(!1);
  function m(A = (O) => O) {
    let O = f.value !== null ? d.value[f.value] : null, k = nf(A(d.value.slice()), (T) => Te(T.dataRef.domRef)), S = O ? k.indexOf(O) : null;
    return S === -1 && (S = null), { options: k, activeOptionIndex: S };
  }
  let g = ee(() => e.multiple ? 1 : 0), v = ee(() => e.nullable), [p, y] = ks(ee(() => e.modelValue), (A) => o("update:modelValue", A), ee(() => e.defaultValue)), C = ee(() => p.value === void 0 ? bt(g.value, { 1: [], 0: void 0 }) : p.value), b = null, x = null, w = { comboboxState: i, value: C, mode: g, compare(A, O) {
    if (typeof e.by == "string") {
      let k = e.by;
      return (A == null ? void 0 : A[k]) === (O == null ? void 0 : O[k]);
    }
    return e.by(A, O);
  }, defaultValue: ee(() => e.defaultValue), nullable: v, inputRef: a, labelRef: r, buttonRef: l, optionsRef: s, disabled: ee(() => e.disabled), options: d, change(A) {
    y(A);
  }, activeOptionIndex: ee(() => {
    if (h.value && f.value === null && d.value.length > 0) {
      let A = d.value.findIndex((O) => !O.dataRef.disabled);
      A !== -1 && (f.value = A);
    }
    return f.value;
  }), activationTrigger: c, optionsPropsRef: u, closeCombobox() {
    h.value = !1, !e.disabled && i.value !== 1 && (i.value = 1, f.value = null);
  }, openCombobox() {
    if (h.value = !0, e.disabled || i.value === 0)
      return;
    let A = d.value.findIndex((O) => {
      let k = je(O.dataRef.value);
      return bt(g.value, { 0: () => w.compare(je(w.value.value), je(k)), 1: () => je(w.value.value).some((S) => w.compare(je(S), je(k))) });
    });
    A !== -1 && (f.value = A), i.value = 0;
  }, goToOption(A, O, k) {
    h.value = !1, b !== null && cancelAnimationFrame(b), b = requestAnimationFrame(() => {
      if (e.disabled || s.value && !u.value.static && i.value === 1)
        return;
      let S = m();
      if (S.activeOptionIndex === null) {
        let L = S.options.findIndex((F) => !F.dataRef.disabled);
        L !== -1 && (S.activeOptionIndex = L);
      }
      let T = X1(A === Xe.Specific ? { focus: Xe.Specific, id: O } : { focus: A }, { resolveItems: () => S.options, resolveActiveIndex: () => S.activeOptionIndex, resolveId: (L) => L.id, resolveDisabled: (L) => L.dataRef.disabled });
      f.value = T, c.value = k ?? 1, d.value = S.options;
    });
  }, selectOption(A) {
    let O = d.value.find((S) => S.id === A);
    if (!O)
      return;
    let { dataRef: k } = O;
    y(bt(g.value, { 0: () => k.value, 1: () => {
      let S = je(w.value.value).slice(), T = je(k.value), L = S.findIndex((F) => w.compare(T, je(F)));
      return L === -1 ? S.push(T) : S.splice(L, 1), S;
    } }));
  }, selectActiveOption() {
    if (w.activeOptionIndex.value === null)
      return;
    let { dataRef: A, id: O } = d.value[w.activeOptionIndex.value];
    y(bt(g.value, { 0: () => A.value, 1: () => {
      let k = je(w.value.value).slice(), S = je(A.value), T = k.findIndex((L) => w.compare(S, je(L)));
      return T === -1 ? k.push(S) : k.splice(T, 1), k;
    } })), w.goToOption(Xe.Specific, O);
  }, registerOption(A, O) {
    x && cancelAnimationFrame(x);
    let k = { id: A, dataRef: O }, S = m((T) => (T.push(k), T));
    if (f.value === null) {
      let T = O.value.value;
      bt(g.value, { 0: () => w.compare(je(w.value.value), je(T)), 1: () => je(w.value.value).some((L) => w.compare(je(L), je(T))) }) && (S.activeOptionIndex = S.options.indexOf(k));
    }
    d.value = S.options, f.value = S.activeOptionIndex, c.value = 1, S.options.some((T) => !Te(T.dataRef.domRef)) && (x = requestAnimationFrame(() => {
      let T = m();
      d.value = T.options, f.value = T.activeOptionIndex;
    }));
  }, unregisterOption(A) {
    var O;
    w.activeOptionIndex.value !== null && ((O = w.options.value[w.activeOptionIndex.value]) == null ? void 0 : O.id) === A && (h.value = !0);
    let k = m((S) => {
      let T = S.findIndex((L) => L.id === A);
      return T !== -1 && S.splice(T, 1), S;
    });
    d.value = k.options, f.value = k.activeOptionIndex, c.value = 1;
  } };
  of([a, l, s], () => w.closeCombobox(), ee(() => i.value === 0)), $o(uf, w), ef(ee(() => bt(i.value, { 0: Pn.Open, 1: Pn.Closed })));
  let $ = ee(() => w.activeOptionIndex.value === null ? null : d.value[w.activeOptionIndex.value].dataRef.value), E = ee(() => {
    var A;
    return (A = Te(a)) == null ? void 0 : A.closest("form");
  });
  return Ge(() => {
    Ne([E], () => {
      if (!E.value || e.defaultValue === void 0)
        return;
      function A() {
        w.change(e.defaultValue);
      }
      return E.value.addEventListener("reset", A), () => {
        var O;
        (O = E.value) == null || O.removeEventListener("reset", A);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: A, disabled: O, form: k, ...S } = e, T = { open: i.value === 0, disabled: O, activeIndex: w.activeOptionIndex.value, activeOption: $.value, value: C.value };
    return wt(me, [...A != null && C.value != null ? $s({ [A]: C.value }).map(([L, F]) => wt(ws, vs({ features: ba.Hidden, key: L, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: k, name: L, value: F }))) : [], Dt({ theirProps: { ...t, ...Ki(S, ["modelValue", "defaultValue", "nullable", "multiple", "onUpdate:modelValue", "by"]) }, ourProps: {}, slot: T, slots: n, attrs: t, name: "Combobox" })]);
  };
} });
re({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-combobox-label-${rn()}` } }, setup(e, { attrs: n, slots: t }) {
  let o = Qo("ComboboxLabel");
  function i() {
    var r;
    (r = Te(o.inputRef)) == null || r.focus({ preventScroll: !0 });
  }
  return () => {
    let r = { open: o.comboboxState.value === 0, disabled: o.disabled.value }, { id: a, ...l } = e, s = { id: a, ref: o.labelRef, onClick: i };
    return Dt({ ourProps: s, theirProps: l, slot: r, attrs: n, slots: t, name: "ComboboxLabel" });
  };
} });
let Wb = re({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-combobox-button-${rn()}` } }, setup(e, { attrs: n, slots: t, expose: o }) {
  let i = Qo("ComboboxButton");
  o({ el: i.buttonRef, $el: i.buttonRef });
  function r(s) {
    i.disabled.value || (i.comboboxState.value === 0 ? i.closeCombobox() : (s.preventDefault(), i.openCombobox()), He(() => {
      var u;
      return (u = Te(i.inputRef)) == null ? void 0 : u.focus({ preventScroll: !0 });
    }));
  }
  function a(s) {
    switch (s.key) {
      case We.ArrowDown:
        s.preventDefault(), s.stopPropagation(), i.comboboxState.value === 1 && i.openCombobox(), He(() => {
          var u;
          return (u = i.inputRef.value) == null ? void 0 : u.focus({ preventScroll: !0 });
        });
        return;
      case We.ArrowUp:
        s.preventDefault(), s.stopPropagation(), i.comboboxState.value === 1 && (i.openCombobox(), He(() => {
          i.value.value || i.goToOption(Xe.Last);
        })), He(() => {
          var u;
          return (u = i.inputRef.value) == null ? void 0 : u.focus({ preventScroll: !0 });
        });
        return;
      case We.Escape:
        if (i.comboboxState.value !== 0)
          return;
        s.preventDefault(), i.optionsRef.value && !i.optionsPropsRef.value.static && s.stopPropagation(), i.closeCombobox(), He(() => {
          var u;
          return (u = i.inputRef.value) == null ? void 0 : u.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let l = bs(ee(() => ({ as: e.as, type: n.type })), i.buttonRef);
  return () => {
    var s, u;
    let d = { open: i.comboboxState.value === 0, disabled: i.disabled.value, value: i.value.value }, { id: f, ...c } = e, h = { ref: i.buttonRef, id: f, type: l.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (s = Te(i.optionsRef)) == null ? void 0 : s.id, "aria-expanded": i.comboboxState.value === 0, "aria-labelledby": i.labelRef.value ? [(u = Te(i.labelRef)) == null ? void 0 : u.id, f].join(" ") : void 0, disabled: i.disabled.value === !0 ? !0 : void 0, onKeydown: a, onClick: r };
    return Dt({ ourProps: h, theirProps: c, slot: d, attrs: n, slots: t, name: "ComboboxButton" });
  };
} }), Kb = re({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: () => `headlessui-combobox-input-${rn()}` } }, emits: { change: (e) => !0 }, setup(e, { emit: n, attrs: t, slots: o, expose: i }) {
  let r = Qo("ComboboxInput"), a = ee(() => Cs(Te(r.inputRef))), l = { value: !1 };
  i({ el: r.inputRef, $el: r.inputRef });
  function s() {
    r.change(null);
    let p = Te(r.optionsRef);
    p && (p.scrollTop = 0), r.goToOption(Xe.Nothing);
  }
  let u = ee(() => {
    var p;
    let y = r.value.value;
    return Te(r.inputRef) ? typeof e.displayValue < "u" && y !== void 0 ? (p = e.displayValue(y)) != null ? p : "" : typeof y == "string" ? y : "" : "";
  });
  Ge(() => {
    Ne([u, r.comboboxState, a], ([p, y], [C, b]) => {
      if (l.value)
        return;
      let x = Te(r.inputRef);
      x && ((b === 0 && y === 1 || p !== C) && (x.value = p), requestAnimationFrame(() => {
        var w;
        if (l.value || !x || ((w = a.value) == null ? void 0 : w.activeElement) !== x)
          return;
        let { selectionStart: $, selectionEnd: E } = x;
        Math.abs((E ?? 0) - ($ ?? 0)) === 0 && $ === 0 && x.setSelectionRange(x.value.length, x.value.length);
      }));
    }, { immediate: !0 }), Ne([r.comboboxState], ([p], [y]) => {
      if (p === 0 && y === 1) {
        if (l.value)
          return;
        let C = Te(r.inputRef);
        if (!C)
          return;
        let b = C.value, { selectionStart: x, selectionEnd: w, selectionDirection: $ } = C;
        C.value = "", C.value = b, $ !== null ? C.setSelectionRange(x, w, $) : C.setSelectionRange(x, w);
      }
    });
  });
  let d = X(!1);
  function f() {
    d.value = !0;
  }
  function c() {
    sf().nextFrame(() => {
      d.value = !1;
    });
  }
  function h(p) {
    switch (l.value = !0, p.key) {
      case We.Enter:
        if (l.value = !1, r.comboboxState.value !== 0 || d.value)
          return;
        if (p.preventDefault(), p.stopPropagation(), r.activeOptionIndex.value === null) {
          r.closeCombobox();
          return;
        }
        r.selectActiveOption(), r.mode.value === 0 && r.closeCombobox();
        break;
      case We.ArrowDown:
        return l.value = !1, p.preventDefault(), p.stopPropagation(), bt(r.comboboxState.value, { 0: () => r.goToOption(Xe.Next), 1: () => r.openCombobox() });
      case We.ArrowUp:
        return l.value = !1, p.preventDefault(), p.stopPropagation(), bt(r.comboboxState.value, { 0: () => r.goToOption(Xe.Previous), 1: () => {
          r.openCombobox(), He(() => {
            r.value.value || r.goToOption(Xe.Last);
          });
        } });
      case We.Home:
        if (p.shiftKey)
          break;
        return l.value = !1, p.preventDefault(), p.stopPropagation(), r.goToOption(Xe.First);
      case We.PageUp:
        return l.value = !1, p.preventDefault(), p.stopPropagation(), r.goToOption(Xe.First);
      case We.End:
        if (p.shiftKey)
          break;
        return l.value = !1, p.preventDefault(), p.stopPropagation(), r.goToOption(Xe.Last);
      case We.PageDown:
        return l.value = !1, p.preventDefault(), p.stopPropagation(), r.goToOption(Xe.Last);
      case We.Escape:
        if (l.value = !1, r.comboboxState.value !== 0)
          return;
        p.preventDefault(), r.optionsRef.value && !r.optionsPropsRef.value.static && p.stopPropagation(), r.nullable.value && r.mode.value === 0 && r.value.value === null && s(), r.closeCombobox();
        break;
      case We.Tab:
        if (l.value = !1, r.comboboxState.value !== 0)
          return;
        r.mode.value === 0 && r.selectActiveOption(), r.closeCombobox();
        break;
    }
  }
  function m(p) {
    n("change", p), r.nullable.value && r.mode.value === 0 && p.target.value === "" && s(), r.openCombobox();
  }
  function g() {
    l.value = !1;
  }
  let v = ee(() => {
    var p, y, C, b;
    return (b = (C = (y = e.defaultValue) != null ? y : r.defaultValue.value !== void 0 ? (p = e.displayValue) == null ? void 0 : p.call(e, r.defaultValue.value) : null) != null ? C : r.defaultValue.value) != null ? b : "";
  });
  return () => {
    var p, y, C, b, x, w;
    let $ = { open: r.comboboxState.value === 0 }, { id: E, displayValue: A, onChange: O, ...k } = e, S = { "aria-controls": (p = r.optionsRef.value) == null ? void 0 : p.id, "aria-expanded": r.comboboxState.value === 0, "aria-activedescendant": r.activeOptionIndex.value === null || (y = r.options.value[r.activeOptionIndex.value]) == null ? void 0 : y.id, "aria-labelledby": (x = (C = Te(r.labelRef)) == null ? void 0 : C.id) != null ? x : (b = Te(r.buttonRef)) == null ? void 0 : b.id, "aria-autocomplete": "list", id: E, onCompositionstart: f, onCompositionend: c, onKeydown: h, onInput: m, onBlur: g, role: "combobox", type: (w = t.type) != null ? w : "text", tabIndex: 0, ref: r.inputRef, defaultValue: v.value, disabled: r.disabled.value === !0 ? !0 : void 0 };
    return Dt({ ourProps: S, theirProps: k, slot: $, attrs: t, slots: o, features: yo.RenderStrategy | yo.Static, name: "ComboboxInput" });
  };
} }), Yb = re({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: n, slots: t, expose: o }) {
  let i = Qo("ComboboxOptions"), r = `headlessui-combobox-options-${rn()}`;
  o({ el: i.optionsRef, $el: i.optionsRef }), ct(() => {
    i.optionsPropsRef.value.static = e.static;
  }), ct(() => {
    i.optionsPropsRef.value.hold = e.hold;
  });
  let a = Q1(), l = ee(() => a !== null ? (a.value & Pn.Open) === Pn.Open : i.comboboxState.value === 0);
  return Ab({ container: ee(() => Te(i.optionsRef)), enabled: ee(() => i.comboboxState.value === 0), accept(s) {
    return s.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : s.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(s) {
    s.setAttribute("role", "none");
  } }), () => {
    var s, u, d;
    let f = { open: i.comboboxState.value === 0 }, c = { "aria-labelledby": (d = (s = Te(i.labelRef)) == null ? void 0 : s.id) != null ? d : (u = Te(i.buttonRef)) == null ? void 0 : u.id, id: r, ref: i.optionsRef, role: "listbox", "aria-multiselectable": i.mode.value === 1 ? !0 : void 0 }, h = Ki(e, ["hold"]);
    return Dt({ ourProps: c, theirProps: h, slot: f, attrs: n, slots: t, features: yo.RenderStrategy | yo.Static, visible: l.value, name: "ComboboxOptions" });
  };
} }), Gb = re({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 } }, setup(e, { slots: n, attrs: t, expose: o }) {
  let i = Qo("ComboboxOption"), r = `headlessui-combobox-option-${rn()}`, a = X(null);
  o({ el: a, $el: a });
  let l = ee(() => i.activeOptionIndex.value !== null ? i.options.value[i.activeOptionIndex.value].id === r : !1), s = ee(() => bt(i.mode.value, { 0: () => i.compare(je(i.value.value), je(e.value)), 1: () => je(i.value.value).some((v) => i.compare(je(v), je(e.value))) })), u = ee(() => ({ disabled: e.disabled, value: e.value, domRef: a }));
  Ge(() => i.registerOption(r, u)), to(() => i.unregisterOption(r)), ct(() => {
    i.comboboxState.value === 0 && l.value && i.activationTrigger.value !== 0 && He(() => {
      var v, p;
      return (p = (v = Te(a)) == null ? void 0 : v.scrollIntoView) == null ? void 0 : p.call(v, { block: "nearest" });
    });
  });
  function d(v) {
    if (e.disabled)
      return v.preventDefault();
    i.selectOption(r), i.mode.value === 0 && i.closeCombobox(), Bb() || requestAnimationFrame(() => {
      var p;
      return (p = Te(i.inputRef)) == null ? void 0 : p.focus();
    });
  }
  function f() {
    if (e.disabled)
      return i.goToOption(Xe.Nothing);
    i.goToOption(Xe.Specific, r);
  }
  let c = lf();
  function h(v) {
    c.update(v);
  }
  function m(v) {
    c.wasMoved(v) && (e.disabled || l.value || i.goToOption(Xe.Specific, r, 0));
  }
  function g(v) {
    c.wasMoved(v) && (e.disabled || l.value && (i.optionsPropsRef.value.hold || i.goToOption(Xe.Nothing)));
  }
  return () => {
    let { disabled: v } = e, p = { active: l.value, selected: s.value, disabled: v }, y = { id: r, ref: a, role: "option", tabIndex: v === !0 ? void 0 : -1, "aria-disabled": v === !0 ? !0 : void 0, "aria-selected": s.value, disabled: void 0, onClick: d, onFocus: f, onPointerenter: h, onMouseenter: h, onPointermove: m, onMousemove: m, onPointerleave: g, onMouseleave: g };
    return Dt({ ourProps: y, theirProps: e, slot: p, attrs: t, slots: n, name: "ComboboxOption" });
  };
} }), df = Symbol("DescriptionContext");
function Zb() {
  let e = eo(df, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function Xb({ slot: e = X({}), name: n = "Description", props: t = {} } = {}) {
  let o = X([]);
  function i(r) {
    return o.value.push(r), () => {
      let a = o.value.indexOf(r);
      a !== -1 && o.value.splice(a, 1);
    };
  }
  return $o(df, { register: i, slot: e, name: n, props: t }), ee(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
re({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: () => `headlessui-description-${rn()}` } }, setup(e, { attrs: n, slots: t }) {
  let o = Zb();
  return Ge(() => to(o.register(e.id))), () => {
    let { name: i = "Description", slot: r = X({}), props: a = {} } = o, { id: l, ...s } = e, u = { ...Object.entries(a).reduce((d, [f, c]) => Object.assign(d, { [f]: I(c) }), {}), id: l };
    return Dt({ ourProps: u, theirProps: s, slot: r.value, attrs: n, slots: t, name: i });
  };
} });
let xd = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function wd(e) {
  var n, t;
  let o = (n = e.innerText) != null ? n : "", i = e.cloneNode(!0);
  if (!(i instanceof HTMLElement))
    return o;
  let r = !1;
  for (let l of i.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    l.remove(), r = !0;
  let a = r ? (t = i.innerText) != null ? t : "" : o;
  return xd.test(a) && (a = a.replace(xd, "")), a;
}
function Jb(e) {
  let n = e.getAttribute("aria-label");
  if (typeof n == "string")
    return n.trim();
  let t = e.getAttribute("aria-labelledby");
  if (t) {
    let o = t.split(" ").map((i) => {
      let r = document.getElementById(i);
      if (r) {
        let a = r.getAttribute("aria-label");
        return typeof a == "string" ? a.trim() : wd(r).trim();
      }
      return null;
    }).filter(Boolean);
    if (o.length > 0)
      return o.join(", ");
  }
  return wd(e).trim();
}
function Qb(e) {
  let n = X(""), t = X("");
  return () => {
    let o = Te(e);
    if (!o)
      return "";
    let i = o.innerText;
    if (n.value === i)
      return t.value;
    let r = Jb(o).trim().toLowerCase();
    return n.value = i, t.value = r, r;
  };
}
function ey(e, n) {
  return e === n;
}
var ty = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(ty || {}), ny = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(ny || {}), oy = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(oy || {});
function iy(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let cf = Symbol("ListboxContext");
function Yi(e) {
  let n = eo(cf, null);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Yi), t;
  }
  return n;
}
let ry = re({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => ey }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: n, attrs: t, emit: o }) {
  let i = X(1), r = X(null), a = X(null), l = X(null), s = X([]), u = X(""), d = X(null), f = X(1);
  function c(C = (b) => b) {
    let b = d.value !== null ? s.value[d.value] : null, x = nf(C(s.value.slice()), ($) => Te($.dataRef.domRef)), w = b ? x.indexOf(b) : null;
    return w === -1 && (w = null), { options: x, activeOptionIndex: w };
  }
  let h = ee(() => e.multiple ? 1 : 0), [m, g] = ks(ee(() => e.modelValue), (C) => o("update:modelValue", C), ee(() => e.defaultValue)), v = ee(() => m.value === void 0 ? bt(h.value, { 1: [], 0: void 0 }) : m.value), p = { listboxState: i, value: v, mode: h, compare(C, b) {
    if (typeof e.by == "string") {
      let x = e.by;
      return (C == null ? void 0 : C[x]) === (b == null ? void 0 : b[x]);
    }
    return e.by(C, b);
  }, orientation: ee(() => e.horizontal ? "horizontal" : "vertical"), labelRef: r, buttonRef: a, optionsRef: l, disabled: ee(() => e.disabled), options: s, searchQuery: u, activeOptionIndex: d, activationTrigger: f, closeListbox() {
    e.disabled || i.value !== 1 && (i.value = 1, d.value = null);
  }, openListbox() {
    e.disabled || i.value !== 0 && (i.value = 0);
  }, goToOption(C, b, x) {
    if (e.disabled || i.value === 1)
      return;
    let w = c(), $ = X1(C === Xe.Specific ? { focus: Xe.Specific, id: b } : { focus: C }, { resolveItems: () => w.options, resolveActiveIndex: () => w.activeOptionIndex, resolveId: (E) => E.id, resolveDisabled: (E) => E.dataRef.disabled });
    u.value = "", d.value = $, f.value = x ?? 1, s.value = w.options;
  }, search(C) {
    if (e.disabled || i.value === 1)
      return;
    let b = u.value !== "" ? 0 : 1;
    u.value += C.toLowerCase();
    let x = (d.value !== null ? s.value.slice(d.value + b).concat(s.value.slice(0, d.value + b)) : s.value).find(($) => $.dataRef.textValue.startsWith(u.value) && !$.dataRef.disabled), w = x ? s.value.indexOf(x) : -1;
    w === -1 || w === d.value || (d.value = w, f.value = 1);
  }, clearSearch() {
    e.disabled || i.value !== 1 && u.value !== "" && (u.value = "");
  }, registerOption(C, b) {
    let x = c((w) => [...w, { id: C, dataRef: b }]);
    s.value = x.options, d.value = x.activeOptionIndex;
  }, unregisterOption(C) {
    let b = c((x) => {
      let w = x.findIndex(($) => $.id === C);
      return w !== -1 && x.splice(w, 1), x;
    });
    s.value = b.options, d.value = b.activeOptionIndex, f.value = 1;
  }, theirOnChange(C) {
    e.disabled || g(C);
  }, select(C) {
    e.disabled || g(bt(h.value, { 0: () => C, 1: () => {
      let b = je(p.value.value).slice(), x = je(C), w = b.findIndex(($) => p.compare(x, je($)));
      return w === -1 ? b.push(x) : b.splice(w, 1), b;
    } }));
  } };
  of([a, l], (C, b) => {
    var x;
    p.closeListbox(), tf(b, xs.Loose) || (C.preventDefault(), (x = Te(a)) == null || x.focus());
  }, ee(() => i.value === 0)), $o(cf, p), ef(ee(() => bt(i.value, { 0: Pn.Open, 1: Pn.Closed })));
  let y = ee(() => {
    var C;
    return (C = Te(a)) == null ? void 0 : C.closest("form");
  });
  return Ge(() => {
    Ne([y], () => {
      if (!y.value || e.defaultValue === void 0)
        return;
      function C() {
        p.theirOnChange(e.defaultValue);
      }
      return y.value.addEventListener("reset", C), () => {
        var b;
        (b = y.value) == null || b.removeEventListener("reset", C);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: C, modelValue: b, disabled: x, form: w, ...$ } = e, E = { open: i.value === 0, disabled: x, value: v.value };
    return wt(me, [...C != null && v.value != null ? $s({ [C]: v.value }).map(([A, O]) => wt(ws, vs({ features: ba.Hidden, key: A, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: w, name: A, value: O }))) : [], Dt({ ourProps: {}, theirProps: { ...t, ...Ki($, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: E, slots: n, attrs: t, name: "Listbox" })]);
  };
} });
re({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: () => `headlessui-listbox-label-${rn()}` } }, setup(e, { attrs: n, slots: t }) {
  let o = Yi("ListboxLabel");
  function i() {
    var r;
    (r = Te(o.buttonRef)) == null || r.focus({ preventScroll: !0 });
  }
  return () => {
    let r = { open: o.listboxState.value === 0, disabled: o.disabled.value }, { id: a, ...l } = e, s = { id: a, ref: o.labelRef, onClick: i };
    return Dt({ ourProps: s, theirProps: l, slot: r, attrs: n, slots: t, name: "ListboxLabel" });
  };
} });
let ay = re({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: () => `headlessui-listbox-button-${rn()}` } }, setup(e, { attrs: n, slots: t, expose: o }) {
  let i = Yi("ListboxButton");
  o({ el: i.buttonRef, $el: i.buttonRef });
  function r(u) {
    switch (u.key) {
      case We.Space:
      case We.Enter:
      case We.ArrowDown:
        u.preventDefault(), i.openListbox(), He(() => {
          var d;
          (d = Te(i.optionsRef)) == null || d.focus({ preventScroll: !0 }), i.value.value || i.goToOption(Xe.First);
        });
        break;
      case We.ArrowUp:
        u.preventDefault(), i.openListbox(), He(() => {
          var d;
          (d = Te(i.optionsRef)) == null || d.focus({ preventScroll: !0 }), i.value.value || i.goToOption(Xe.Last);
        });
        break;
    }
  }
  function a(u) {
    switch (u.key) {
      case We.Space:
        u.preventDefault();
        break;
    }
  }
  function l(u) {
    i.disabled.value || (i.listboxState.value === 0 ? (i.closeListbox(), He(() => {
      var d;
      return (d = Te(i.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })) : (u.preventDefault(), i.openListbox(), iy(() => {
      var d;
      return (d = Te(i.optionsRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    })));
  }
  let s = bs(ee(() => ({ as: e.as, type: n.type })), i.buttonRef);
  return () => {
    var u, d;
    let f = { open: i.listboxState.value === 0, disabled: i.disabled.value, value: i.value.value }, { id: c, ...h } = e, m = { ref: i.buttonRef, id: c, type: s.value, "aria-haspopup": "listbox", "aria-controls": (u = Te(i.optionsRef)) == null ? void 0 : u.id, "aria-expanded": i.listboxState.value === 0, "aria-labelledby": i.labelRef.value ? [(d = Te(i.labelRef)) == null ? void 0 : d.id, c].join(" ") : void 0, disabled: i.disabled.value === !0 ? !0 : void 0, onKeydown: r, onKeyup: a, onClick: l };
    return Dt({ ourProps: m, theirProps: h, slot: f, attrs: n, slots: t, name: "ListboxButton" });
  };
} }), ly = re({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: () => `headlessui-listbox-options-${rn()}` } }, setup(e, { attrs: n, slots: t, expose: o }) {
  let i = Yi("ListboxOptions"), r = X(null);
  o({ el: i.optionsRef, $el: i.optionsRef });
  function a(u) {
    switch (r.value && clearTimeout(r.value), u.key) {
      case We.Space:
        if (i.searchQuery.value !== "")
          return u.preventDefault(), u.stopPropagation(), i.search(u.key);
      case We.Enter:
        if (u.preventDefault(), u.stopPropagation(), i.activeOptionIndex.value !== null) {
          let d = i.options.value[i.activeOptionIndex.value];
          i.select(d.dataRef.value);
        }
        i.mode.value === 0 && (i.closeListbox(), He(() => {
          var d;
          return (d = Te(i.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        }));
        break;
      case bt(i.orientation.value, { vertical: We.ArrowDown, horizontal: We.ArrowRight }):
        return u.preventDefault(), u.stopPropagation(), i.goToOption(Xe.Next);
      case bt(i.orientation.value, { vertical: We.ArrowUp, horizontal: We.ArrowLeft }):
        return u.preventDefault(), u.stopPropagation(), i.goToOption(Xe.Previous);
      case We.Home:
      case We.PageUp:
        return u.preventDefault(), u.stopPropagation(), i.goToOption(Xe.First);
      case We.End:
      case We.PageDown:
        return u.preventDefault(), u.stopPropagation(), i.goToOption(Xe.Last);
      case We.Escape:
        u.preventDefault(), u.stopPropagation(), i.closeListbox(), He(() => {
          var d;
          return (d = Te(i.buttonRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        break;
      case We.Tab:
        u.preventDefault(), u.stopPropagation();
        break;
      default:
        u.key.length === 1 && (i.search(u.key), r.value = setTimeout(() => i.clearSearch(), 350));
        break;
    }
  }
  let l = Q1(), s = ee(() => l !== null ? (l.value & Pn.Open) === Pn.Open : i.listboxState.value === 0);
  return () => {
    var u, d, f, c;
    let h = { open: i.listboxState.value === 0 }, { id: m, ...g } = e, v = { "aria-activedescendant": i.activeOptionIndex.value === null || (u = i.options.value[i.activeOptionIndex.value]) == null ? void 0 : u.id, "aria-multiselectable": i.mode.value === 1 ? !0 : void 0, "aria-labelledby": (c = (d = Te(i.labelRef)) == null ? void 0 : d.id) != null ? c : (f = Te(i.buttonRef)) == null ? void 0 : f.id, "aria-orientation": i.orientation.value, id: m, onKeydown: a, role: "listbox", tabIndex: 0, ref: i.optionsRef };
    return Dt({ ourProps: v, theirProps: g, slot: h, attrs: n, slots: t, features: yo.RenderStrategy | yo.Static, visible: s.value, name: "ListboxOptions" });
  };
} }), sy = re({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: () => `headlessui-listbox.option-${rn()}` } }, setup(e, { slots: n, attrs: t, expose: o }) {
  let i = Yi("ListboxOption"), r = X(null);
  o({ el: r, $el: r });
  let a = ee(() => i.activeOptionIndex.value !== null ? i.options.value[i.activeOptionIndex.value].id === e.id : !1), l = ee(() => bt(i.mode.value, { 0: () => i.compare(je(i.value.value), je(e.value)), 1: () => je(i.value.value).some((p) => i.compare(je(p), je(e.value))) })), s = ee(() => bt(i.mode.value, { 1: () => {
    var p;
    let y = je(i.value.value);
    return ((p = i.options.value.find((C) => y.some((b) => i.compare(je(b), je(C.dataRef.value))))) == null ? void 0 : p.id) === e.id;
  }, 0: () => l.value })), u = Qb(r), d = ee(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return u();
  }, domRef: r }));
  Ge(() => i.registerOption(e.id, d)), to(() => i.unregisterOption(e.id)), Ge(() => {
    Ne([i.listboxState, l], () => {
      i.listboxState.value === 0 && l.value && bt(i.mode.value, { 1: () => {
        s.value && i.goToOption(Xe.Specific, e.id);
      }, 0: () => {
        i.goToOption(Xe.Specific, e.id);
      } });
    }, { immediate: !0 });
  }), ct(() => {
    i.listboxState.value === 0 && a.value && i.activationTrigger.value !== 0 && He(() => {
      var p, y;
      return (y = (p = Te(r)) == null ? void 0 : p.scrollIntoView) == null ? void 0 : y.call(p, { block: "nearest" });
    });
  });
  function f(p) {
    if (e.disabled)
      return p.preventDefault();
    i.select(e.value), i.mode.value === 0 && (i.closeListbox(), He(() => {
      var y;
      return (y = Te(i.buttonRef)) == null ? void 0 : y.focus({ preventScroll: !0 });
    }));
  }
  function c() {
    if (e.disabled)
      return i.goToOption(Xe.Nothing);
    i.goToOption(Xe.Specific, e.id);
  }
  let h = lf();
  function m(p) {
    h.update(p);
  }
  function g(p) {
    h.wasMoved(p) && (e.disabled || a.value || i.goToOption(Xe.Specific, e.id, 0));
  }
  function v(p) {
    h.wasMoved(p) && (e.disabled || a.value && i.goToOption(Xe.Nothing));
  }
  return () => {
    let { disabled: p } = e, y = { active: a.value, selected: l.value, disabled: p }, { id: C, value: b, disabled: x, ...w } = e, $ = { id: C, ref: r, role: "option", tabIndex: p === !0 ? void 0 : -1, "aria-disabled": p === !0 ? !0 : void 0, "aria-selected": l.value, disabled: void 0, onClick: f, onFocus: c, onPointerenter: m, onMouseenter: m, onPointermove: g, onMousemove: g, onPointerleave: v, onMouseleave: v };
    return Dt({ ourProps: $, theirProps: w, slot: y, attrs: t, slots: n, name: "ListboxOption" });
  };
} }), ff = Symbol("LabelContext");
function hf() {
  let e = eo(ff, null);
  if (e === null) {
    let n = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, hf), n;
  }
  return e;
}
function uy({ slot: e = {}, name: n = "Label", props: t = {} } = {}) {
  let o = X([]);
  function i(r) {
    return o.value.push(r), () => {
      let a = o.value.indexOf(r);
      a !== -1 && o.value.splice(a, 1);
    };
  }
  return $o(ff, { register: i, slot: e, name: n, props: t }), ee(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
re({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: () => `headlessui-label-${rn()}` } }, setup(e, { slots: n, attrs: t }) {
  let o = hf();
  return Ge(() => to(o.register(e.id))), () => {
    let { name: i = "Label", slot: r = {}, props: a = {} } = o, { id: l, passive: s, ...u } = e, d = { ...Object.entries(a).reduce((f, [c, h]) => Object.assign(f, { [c]: I(h) }), {}), id: l };
    return s && (delete d.onClick, delete d.htmlFor, delete u.onClick), Dt({ ourProps: d, theirProps: u, slot: r, attrs: t, slots: n, name: i });
  };
} });
let gf = Symbol("GroupContext"), dy = re({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: n, attrs: t }) {
  let o = X(null), i = uy({ name: "SwitchLabel", props: { htmlFor: ee(() => {
    var a;
    return (a = o.value) == null ? void 0 : a.id;
  }), onClick(a) {
    o.value && (a.currentTarget.tagName === "LABEL" && a.preventDefault(), o.value.click(), o.value.focus({ preventScroll: !0 }));
  } } }), r = Xb({ name: "SwitchDescription" });
  return $o(gf, { switchRef: o, labelledby: i, describedby: r }), () => Dt({ theirProps: e, ourProps: {}, slot: {}, slots: n, attrs: t, name: "SwitchGroup" });
} }), cy = re({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: () => `headlessui-switch-${rn()}` } }, inheritAttrs: !1, setup(e, { emit: n, attrs: t, slots: o, expose: i }) {
  let r = eo(gf, null), [a, l] = ks(ee(() => e.modelValue), (v) => n("update:modelValue", v), ee(() => e.defaultChecked));
  function s() {
    l(!a.value);
  }
  let u = X(null), d = r === null ? u : r.switchRef, f = bs(ee(() => ({ as: e.as, type: t.type })), d);
  i({ el: d, $el: d });
  function c(v) {
    v.preventDefault(), s();
  }
  function h(v) {
    v.key === We.Space ? (v.preventDefault(), s()) : v.key === We.Enter && Nb(v.currentTarget);
  }
  function m(v) {
    v.preventDefault();
  }
  let g = ee(() => {
    var v, p;
    return (p = (v = Te(d)) == null ? void 0 : v.closest) == null ? void 0 : p.call(v, "form");
  });
  return Ge(() => {
    Ne([g], () => {
      if (!g.value || e.defaultChecked === void 0)
        return;
      function v() {
        l(e.defaultChecked);
      }
      return g.value.addEventListener("reset", v), () => {
        var p;
        (p = g.value) == null || p.removeEventListener("reset", v);
      };
    }, { immediate: !0 });
  }), () => {
    let { id: v, name: p, value: y, form: C, ...b } = e, x = { checked: a.value }, w = { id: v, ref: d, role: "switch", type: f.value, tabIndex: 0, "aria-checked": a.value, "aria-labelledby": r == null ? void 0 : r.labelledby.value, "aria-describedby": r == null ? void 0 : r.describedby.value, onClick: c, onKeyup: h, onKeypress: m };
    return wt(me, [p != null && a.value != null ? wt(ws, vs({ features: ba.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: a.value, form: C, name: p, value: y })) : null, Dt({ ourProps: w, theirProps: { ...t, ...Ki(b, ["modelValue", "defaultChecked"]) }, slot: x, attrs: t, slots: o, name: "Switch" })]);
  };
} });
const fy = {
  key: 0,
  class: "mb-3"
}, hy = {
  key: 0,
  class: "flex items-start"
}, gy = {
  key: 0,
  class: "ml-1 inline-block align-top text-mgm-txt-sm font-medium text-foreground-brand-default"
}, my = {
  key: 1,
  class: "flex items-center"
}, py = { class: "relative mt-1" }, vy = ["onClick"], by = ["src"], yy = {
  key: 1,
  class: "absolute inset-y-0 right-0 flex items-center pr-4"
}, Cy = { class: "items-center px-3 py-2 sm:flex sm:justify-between" }, xy = { class: "flex items-center" }, wy = ["src"], $y = { class: "block text-mgm-txt-sm font-medium text-foreground-emphasis" }, ky = /* @__PURE__ */ re({
  __name: "FieldSearch",
  props: {
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: Array,
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    createOption: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    selectionDisplayType: {
      type: String,
      default: "top-badge"
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    locale: {
      type: String,
      default: "en"
    },
    deleteTextButton: {
      type: String,
      default: "generic.delete"
    }
  },
  emits: ["create-option", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, { t: o } = Cn({ useScope: "global" }), i = X(""), r = ee({
      get() {
        return t.options.filter((f) => {
          if (f.value)
            return t.modelValue.includes(f.value);
        });
      },
      set(f) {
        l(
          "update:modelValue",
          f.map((c) => c.value)
        );
      }
    }), a = ee(
      () => i.value ? [
        ...t.options.filter((f) => {
          if (f.label)
            return f.label.toLowerCase().includes(i.value.toLowerCase());
        }),
        ...!t.options.find(
          (f) => f.label && f.label.toLowerCase() === i.value.toLowerCase()
        ) && t.createOption ? [
          {
            label: `${o("create")} "${i.value}"`,
            value: i.value
          }
        ] : []
      ] : t.options
    ), l = n, s = (f) => {
      t.options.find((c) => c.value === (f == null ? void 0 : f.value)) || (l("create-option", f.value), l("update:modelValue", [...t.modelValue, f.value]));
    }, u = (f) => f.label, d = (f) => {
      const c = [...t.modelValue].filter((h) => h !== f.value);
      l("update:modelValue", c);
    };
    return (f, c) => {
      var h, m;
      return _(), P("div", null, [
        e.label || e.description ? (_(), P("div", fy, [
          e.label ? (_(), P("div", hy, [
            ce(Re, {
              for: e.id,
              label: e.label
            }, null, 8, ["for", "label"]),
            e.required ? (_(), P("span", gy, " * ")) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        e.selectionDisplayType === "top-badge" ? (_(), P("div", my, [
          (_(!0), P(me, null, Fe(r.value, (g) => (_(), ie(pl, {
            key: g.value,
            "data-cy": "selected-option",
            class: "mr-3 mt-1 flex-row-reverse",
            text: g.label,
            "icon-type": "custom"
          }, {
            icon: J(() => [
              ce(Le, {
                class: "ml-1 cursor-pointer",
                size: 12,
                color: "#444CE7",
                icon: "close",
                onClick: (v) => d(g)
              }, null, 8, ["onClick"])
            ]),
            _: 2
          }, 1032, ["text"]))), 128))
        ])) : z("", !0),
        ce(I(Ub), {
          modelValue: r.value,
          "onUpdate:modelValue": c[1] || (c[1] = (g) => r.value = g),
          multiple: "",
          as: "div"
        }, {
          default: J(() => {
            var g;
            return [
              M("div", py, [
                ce(Le, {
                  class: "absolute inset-y-0 left-0 flex h-10 w-10 items-center rounded-r-md focus:outline-none",
                  color: "#E2E8F0",
                  icon: "search"
                }),
                ce(I(Kb), {
                  class: "w-full rounded-md border border-border-subtle bg-background-default py-2 pl-10 pr-10 shadow-sm focus:border-border-default focus:outline-none focus:ring-1 focus:ring-border-default sm:text-mgm-txt-sm",
                  "display-value": u,
                  onChange: c[0] || (c[0] = (v) => i.value = v.target.value)
                }),
                ce(I(Wb), {
                  class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none",
                  "data-cy": "btn-select"
                }, {
                  default: J(() => [
                    ce(Le, {
                      icon: "chevron-selector-vertical",
                      color: "#E2E8F0",
                      "aria-hidden": "true"
                    })
                  ]),
                  _: 1
                }),
                ((g = a.value) == null ? void 0 : g.length) > 0 ? (_(), ie(I(Yb), {
                  key: 0,
                  class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-background-default py-1 text-base shadow-lg ring-1 ring-foreground-emphasis ring-opacity-5 focus:outline-none sm:text-mgm-txt-sm"
                }, {
                  default: J(() => [
                    (_(!0), P(me, null, Fe(a.value, (v) => (_(), ie(I(Gb), {
                      key: `${v.value}`,
                      value: v,
                      as: "template"
                    }, {
                      default: J(({ active: p, selected: y }) => [
                        M("li", {
                          class: pe([
                            "relative cursor-default select-none py-2 pl-3 pr-9",
                            { "flex capitalize": v.icon },
                            p ? "bg-background-brand-emphasis text-foreground-on-emphasis" : "text-foreground-emphasis"
                          ]),
                          onClick: (C) => s(v)
                        }, [
                          v.icon ? (_(), P("img", {
                            key: 0,
                            class: "mr-3 h-6 w-6",
                            src: v.icon
                          }, null, 8, by)) : z("", !0),
                          M("span", {
                            class: pe(["block truncate", y && "font-semibold"])
                          }, de(v.label), 3),
                          y ? (_(), P("span", yy, [
                            ce(Le, {
                              "aria-hidden": "true",
                              icon: "check",
                              color: p ? "#FFFFFF" : "#444CE7"
                            }, null, 8, ["color"])
                          ])) : z("", !0)
                        ], 10, vy)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 1
                })) : z("", !0)
              ])
            ];
          }),
          _: 1
        }, 8, ["modelValue"]),
        e.validation && ((h = e.validation.$errors) != null && h.length) ? (_(), ie(Re, {
          key: 2,
          class: "mt-1",
          label: (m = e.validation.$errors[0]) == null ? void 0 : m.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0),
        e.selectionDisplayType === "bottom-card" ? (_(!0), P(me, { key: 3 }, Fe(r.value, (g) => (_(), P("div", {
          key: g.value,
          class: "relative mt-4 flex justify-between rounded-md bg-background-subtle-hover capitalize",
          "data-cy": "input-selected"
        }, [
          M("div", Cy, [
            M("div", xy, [
              M("img", {
                class: "mr-3 h-6 w-6",
                src: g.icon
              }, null, 8, wy),
              M("span", $y, de(g.label), 1)
            ]),
            g.label != "phone" ? (_(), ie(Fr, {
              key: 0,
              class: "absolute right-0 top-0 bottom-0",
              state: "trtr",
              text: I(o)(e.deleteTextButton),
              "data-cy": "btn-remove-selected",
              danger: "",
              onClick: (v) => d(g)
            }, null, 8, ["text", "onClick"])) : z("", !0)
          ])
        ]))), 128)) : z("", !0)
      ]);
    };
  }
});
function $d(e) {
  const n = e;
  n.__i18n = n.__i18n || [], n.__i18n.push({
    locale: "",
    resource: {
      en: {
        create: (t) => {
          const { normalize: o } = t;
          return o(["Create"]);
        },
        delete: (t) => {
          const { normalize: o } = t;
          return o(["Delete"]);
        }
      },
      fr: {
        create: (t) => {
          const { normalize: o } = t;
          return o(["Créer"]);
        },
        browse: (t) => {
          const { normalize: o } = t;
          return o(["Supprimer"]);
        }
      }
    }
  });
}
typeof $d == "function" && $d(ky);
const _y = {
  key: 0,
  class: "mb-1.5"
}, Oy = {
  key: 0,
  class: "flex items-start"
}, Ey = { class: "relative" }, My = {
  key: 0,
  class: "absolute inset-y-0 right-0 flex items-center pr-4"
}, IA = /* @__PURE__ */ re({
  __name: "FieldSelect",
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    modelValue: {
      type: [String, Number, Array],
      default: null
    },
    options: {
      type: Object,
      default: void 0
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    maxHeight: {
      type: String,
      default: ""
    },
    customColor: {
      type: String,
      default: null
    },
    customRgbColor: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    },
    darkMode: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["blur", "change", "focus", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = X(!1), i = t.multiple ? X(t.modelValue || []) : X(
      t.modelValue || void 0
    ), r = X(""), a = n;
    Ne(
      i,
      async (d) => {
        var f, c;
        if (Array.isArray(d))
          r.value = (f = t.options) == null ? void 0 : f.filter((h) => d.includes(h == null ? void 0 : h.value)).map((h) => h == null ? void 0 : h.label).join(", ");
        else {
          const h = (c = t.options) == null ? void 0 : c.find((m) => d === m.value);
          h && (r.value = h.label);
        }
        a("update:modelValue", d ?? void 0);
      },
      { immediate: !0 }
    ), Ne(i, (d, f) => {
      d !== f && a("change", t.id, d);
    }), Ne(
      () => t.modelValue,
      (d) => {
        i.value = d ?? void 0, d == null && (r.value = "");
      }
    );
    const l = (d) => {
      const f = d.target;
      o.value = !1, a("blur", f.value, t.id);
    }, s = (d) => {
      const f = d.target;
      o.value = !0, a("focus", f.value, t.id);
    }, u = () => {
      a("change", t.id, i.value);
    };
    return Ge(() => {
      var d, f;
      if (t.modelValue === null || t.modelValue === void 0)
        i.value = void 0;
      else if (t.multiple)
        r.value = (f = t.modelValue) == null ? void 0 : f.map((c) => {
          var m;
          const h = (m = t.options) == null ? void 0 : m.find(
            (g) => g.value === (c == null ? void 0 : c.toString())
          );
          return h == null ? void 0 : h.label;
        }).join(", ");
      else {
        i.value = t.modelValue;
        const c = (d = t.options) == null ? void 0 : d.find(
          (h) => {
            var m;
            return h.value === ((m = t.modelValue) == null ? void 0 : m.toString());
          }
        );
        r.value = c == null ? void 0 : c.label;
      }
    }), (d, f) => (_(), ie(I(ry), {
      modelValue: I(i),
      "onUpdate:modelValue": f[0] || (f[0] = (c) => u0(i) ? i.value = c : null),
      multiple: e.multiple,
      as: "div"
    }, {
      default: J(() => {
        var c, h, m;
        return [
          e.label || e.description ? (_(), P("div", _y, [
            e.label ? (_(), P("div", Oy, [
              ce(Re, {
                id: `${e.id}`,
                label: e.label
              }, null, 8, ["id", "label"]),
              e.required ? (_(), P("span", {
                key: 0,
                class: pe([
                  "ml-1 text-mgm-txt-sm font-medium",
                  { "text-foreground-brand-default": !e.customColor }
                ]),
                style: Ye({ color: e.customColor })
              }, " * ", 6)) : z("", !0)
            ])) : z("", !0),
            e.description ? (_(), ie(Re, {
              key: 1,
              label: e.description,
              description: ""
            }, null, 8, ["label"])) : z("", !0)
          ])) : z("", !0),
          M("div", Ey, [
            ce(I(ay), {
              "data-cy": "btn-select",
              class: pe([
                "relative min-h-[38px] w-full text-mgm-txt-sm font-normal cursor-pointer rounded-md border bg-background-default py-2 pl-3 pr-10 text-left text-foreground-emphasis shadow-sm focus:outline-none focus:ring-1 sm:text-sm",
                {
                  "border-border-subtle focus:border-border-default focus:ring-border-default": !e.customColor,
                  "border-border-danger-emphasis focus:border-border-danger-emphasis focus:ring-border-danger-emphasis": e.validation && ((c = e.validation.$errors) == null ? void 0 : c.length)
                },
                {
                  "!bg-white/10 !border-white/20 !text-white": e.darkMode
                }
              ]),
              style: Ye({
                borderColor: e.customColor && o.value ? e.customColor : void 0,
                boxShadow: e.customColor && o.value ? `0px 1px 2px rgba(${e.customRgbColor}, 0.05), 0px 0px 0px 2px rgba(${e.customRgbColor}, 0.2)` : void 0
              }),
              onBlur: l,
              onFocus: s
            }, {
              default: J(() => [
                M("span", {
                  "data-cy": "input-selected",
                  class: pe([
                    "block",
                    {
                      truncate: !e.multiple,
                      "text-foreground-subtle": !r.value && e.placeholder
                    }
                  ])
                }, de(r.value || e.placeholder), 3),
                ce(Le, {
                  class: "pointer-events-none absolute inset-y-0 right-2 flex items-center",
                  icon: "chevron-selector-vertical",
                  color: "#E2E8F0",
                  "aria-hidden": "true"
                })
              ]),
              _: 1
            }, 8, ["class", "style"]),
            ce(d0, {
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: J(() => [
                ce(I(ly), {
                  class: pe([
                    "absolute z-10 mt-1  w-full overflow-auto rounded-md bg-background-default py-1 text-base shadow-lg ring-1 ring-foreground-emphasis ring-opacity-5 focus:outline-none sm:text-sm",
                    e.maxHeight ? e.maxHeight : "max-h-60"
                  ])
                }, {
                  default: J(() => [
                    (_(!0), P(me, null, Fe(e.options, (g, v) => (_(), ie(I(sy), {
                      key: v,
                      as: "template",
                      value: g.value,
                      onSelect: u
                    }, {
                      default: J(({ active: p, selected: y }) => [
                        M("li", {
                          class: pe([
                            p ? "text-foreground-on-emphasis" : "text-foreground-emphasis",
                            "relative cursor-pointer select-none list-none py-2 pl-3 pr-9",
                            {
                              "bg-background-brand-emphasis": p && !e.customColor
                            }
                          ]),
                          style: Ye({
                            backgroundColor: p && e.customColor ? e.customColor : void 0
                          })
                        }, [
                          M("span", {
                            class: pe([
                              "block truncate textforeground-emphasis text-mgm-txt-sm",
                              y ? "font-semibold" : "font-normal"
                            ])
                          }, de(g.label), 3),
                          y ? (_(), P("span", My, [
                            ce(Le, {
                              "aria-hidden": "true",
                              icon: "check",
                              color: p ? "#FFFFFF" : e.customColor ? e.customColor : "#444CE7"
                            }, null, 8, ["color"])
                          ])) : z("", !0)
                        ], 6)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ]),
          e.validation && ((h = e.validation.$errors) == null ? void 0 : h.length) > 0 ? (_(), ie(Re, {
            key: 1,
            class: "mt-[3px]",
            label: (m = e.validation.$errors[0]) == null ? void 0 : m.$message,
            error: ""
          }, null, 8, ["label"])) : z("", !0)
        ];
      }),
      _: 1
    }, 8, ["modelValue", "multiple"]));
  }
}), Sy = { class: "sm:col-span-8" }, Ay = { class: "relative mt-2 flex items-center rounded-[5px] bg-background-subtle px-4 py-[18px] text-mgm-txt-sm font-normal text-foreground-default" }, Ty = { class: "block w-[416px] truncate text-mgm-txt-sm font-medium text-foreground-emphasis" }, Py = {
  key: 0,
  class: "border-x border-border-default px-3 py-[9px]"
}, Iy = { class: "block w-[416px] truncate text-mgm-txt-sm font-medium text-foreground-emphasis" }, Dy = /* @__PURE__ */ re({
  __name: "FieldSelector",
  props: {
    modelValue: {
      type: Array,
      default: null
    },
    items: {
      type: Array,
      required: !0
    },
    type: {
      type: String,
      default: "challenge"
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: "en"
    },
    icon: {
      type: String,
      default: ""
    },
    hasAllItemsSelector: {
      type: Boolean,
      default: !0
    },
    // Placeholders
    searchPlaceholder: {
      type: String,
      default: ""
    },
    selectedPlaceholder: {
      type: String,
      default: ""
    },
    allItemsSelectorPlaceholder: {
      type: String,
      default: ""
    },
    selectedPlaceholderAll: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, { t: o } = Cn(), i = X(!0), r = X(null), a = X(!1), l = X(""), s = ee(() => t.items.filter((g) => g.type === "checkbox")), u = ee(() => l.value ? t.items.filter((g) => g.name.toLowerCase().includes(l.value.toLowerCase()) && g.type !== "heading") : t.items), d = ee(() => {
      var g, v;
      return ((g = t.modelValue) == null ? void 0 : g.length) === ((v = s.value) == null ? void 0 : v.length) && t.hasAllItemsSelector;
    });
    Ge(() => {
      d.value || (i.value = !1);
    });
    const f = n, c = async (g) => {
      g ? (f(
        "update:modelValue",
        s.value.map((v) => v.id)
      ), i.value = !0) : (f("update:modelValue", []), i.value = !1);
    }, h = async (g, v) => {
      g && i.value ? (f("update:modelValue", [v]), i.value = !1) : g ? f("update:modelValue", [...t.modelValue, v]) : f(
        "update:modelValue",
        t.modelValue.filter((p) => p !== v)
      );
    }, m = () => {
      a.value = !a.value;
    };
    return Y1(r, (g) => {
      g.stopPropagation(), a.value && (a.value = !1);
    }), (g, v) => {
      var p, y, C;
      return _(), P("div", Sy, [
        e.title ? (_(), ie(Re, {
          key: 0,
          class: "mb-px",
          label: e.title
        }, null, 8, ["label"])) : z("", !0),
        e.description ? (_(), ie(Re, {
          key: 1,
          label: e.description,
          class: "mb-1.5",
          description: ""
        }, null, 8, ["label"])) : z("", !0),
        M("div", Ay, [
          e.icon ? (_(), ie(Le, {
            key: 0,
            class: "mr-2",
            color: "#5F6C85",
            icon: e.icon
          }, null, 8, ["icon"])) : z("", !0),
          Ie(" " + de(I(o)("from")) + " ", 1),
          M("button", {
            type: "button",
            class: "mx-2 flex min-w-fit items-center font-medium text-foreground-emphasis",
            onClick: m
          }, [
            Ie(de(d.value ? e.selectedPlaceholderAll : `${(p = e.modelValue) == null ? void 0 : p.length} ${I(o)(
              `${e.selectedPlaceholder}.${((y = e.modelValue) == null ? void 0 : y.length) !== 1 ? "plural" : "singular"}`
            )}`) + " ", 1),
            ce(Le, {
              class: "ml-1",
              icon: a.value ? "chevron-up" : "chevron-down"
            }, null, 8, ["icon"])
          ]),
          a.value ? (_(), P("div", {
            key: 1,
            ref_key: "menuRef",
            ref: r,
            class: "absolute bottom-10 left-0 z-10 w-[480px] rounded-b-[4.16px] border-border-default bg-background-default shadow-[0px_4px_6px_-2px_rgba(28,31,39,0.03),0px_12px_16px_-4px_rgba(28,31,39,0.08)]"
          }, [
            ce(F1, {
              modelValue: l.value,
              "onUpdate:modelValue": v[0] || (v[0] = (b) => l.value = b),
              role: "search",
              locale: g.$i18n.locale,
              placeholder: `${I(o)("search")} ${e.searchPlaceholder}...`,
              "no-rounded-bottom": ""
            }, null, 8, ["modelValue", "locale", "placeholder"]),
            !((C = l.value) != null && C.length) && e.hasAllItemsSelector ? (_(), ie(Ei, {
              key: 0,
              id: "allItems",
              class: "border-x border-border-default px-3 py-[9px]",
              "model-value": d.value && i.value,
              "onUpdate:modelValue": c
            }, {
              default: J(() => [
                M("span", Ty, de(e.allItemsSelectorPlaceholder), 1)
              ]),
              _: 1
            }, 8, ["model-value"])) : z("", !0),
            (_(!0), P(me, null, Fe(u.value, (b) => (_(), P(me, {
              key: b.id
            }, [
              b.type === "heading" ? (_(), P("div", Py, de(b.name), 1)) : b.type === "checkbox" ? (_(), ie(Ei, {
                key: 1,
                id: b.id,
                class: "border-x border-border-default px-3 py-[9px] last-of-type:rounded-b-[4.16px]",
                "model-value": e.modelValue.includes(b.id) && !i.value,
                onChange: h
              }, {
                default: J(() => [
                  M("span", Iy, de(b.name), 1)
                ]),
                _: 2
              }, 1032, ["id", "model-value"])) : z("", !0)
            ], 64))), 128))
          ], 512)) : z("", !0),
          Ie(" " + de(I(o)(`access.${e.type}`)), 1)
        ])
      ]);
    };
  }
});
function kd(e) {
  const n = e;
  n.__i18n = n.__i18n || [], n.__i18n.push({
    locale: "",
    resource: {
      en: {
        access: {
          challenge: (t) => {
            const { normalize: o } = t;
            return o(["will have access to this challenge"]);
          },
          reward: (t) => {
            const { normalize: o } = t;
            return o(["will have access to this reward"]);
          }
        },
        from: (t) => {
          const { normalize: o } = t;
          return o(["Ambassadors from"]);
        },
        search: (t) => {
          const { normalize: o } = t;
          return o(["Search"]);
        },
        selectedCampaign: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["selected campaign"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["selected campaigns"]);
          }
        },
        selectedTag: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["selected tag"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["selected tags"]);
          }
        }
      },
      fr: {
        access: {
          challenge: (t) => {
            const { normalize: o } = t;
            return o(["auront accès à ce challenge"]);
          },
          reward: (t) => {
            const { normalize: o } = t;
            return o(["auront accès à cette récompense"]);
          }
        },
        from: (t) => {
          const { normalize: o } = t;
          return o(["Ambassadeurs de"]);
        },
        search: (t) => {
          const { normalize: o } = t;
          return o(["Recherchez"]);
        },
        selectedCampaign: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["campagne sélectionnée"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["campagnes sélectionnées"]);
          }
        },
        selectedTag: {
          singular: (t) => {
            const { normalize: o } = t;
            return o(["tag sélectionné"]);
          },
          plural: (t) => {
            const { normalize: o } = t;
            return o(["tags sélectionnés"]);
          }
        }
      }
    }
  });
}
typeof kd == "function" && kd(Dy);
const Ly = ["onClick"], DA = /* @__PURE__ */ re({
  __name: "FieldTabs",
  props: {
    modelValue: {
      type: String,
      default: null
    },
    tabs: {
      type: Array,
      required: !0
    },
    type: {
      type: String,
      default: "button"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, o = (i) => {
      t("update:modelValue", i);
    };
    return (i, r) => (_(), P("div", {
      class: pe([
        "flex select-none",
        {
          "items-center": e.type === "button",
          "items-start": e.type === "underline"
        }
      ])
    }, [
      (_(!0), P(me, null, Fe(e.tabs, (a) => (_(), P("button", {
        key: a.value,
        class: pe([
          "cursor-pointer whitespace-nowrap text-mgm-txt-sm font-normal",
          {
            hidden: a.hidden,
            // default
            "text-foreground-default": e.modelValue != a.value,
            // type === 'button'
            /// default
            "flex h-8 min-w-[48px] items-center justify-center rounded-[48px] px-6": e.type === "button",
            "hover:bg-background-subtle-hover": e.type === "button" && e.modelValue != a.value,
            /// active
            "bg-background-brand-default-hover text-foreground-brand-default": e.type === "button" && e.modelValue === a.value,
            // type === 'underline'
            /// default
            "mr-4 hover:text-foreground-emphasis focus:text-foreground-emphasis": e.type === "underline",
            /// active
            "text-foreground-emphasis": e.type === "underline" && e.modelValue === a.value
          }
        ]),
        onClick: (l) => o(a.value)
      }, [
        M("span", {
          class: pe({ "mb-2.5 block px-1": e.type === "underline" })
        }, de(a.label), 3),
        e.type === "underline" ? (_(), P("div", {
          key: 0,
          class: pe([
            e.modelValue === a.value ? "h-[3px] w-full rounded-t-[3px] bg-background-brand-emphasis" : "hidden"
          ])
        }, null, 2)) : z("", !0)
      ], 10, Ly))), 128))
    ], 2));
  }
}), Ny = {
  key: 0,
  class: "mb-1.5"
}, Fy = {
  key: 0,
  class: "flex items-start"
}, Ry = {
  key: 0,
  class: "ml-1 text-mgm-txt-sm font-medium text-foreground-brand-default"
}, By = ["id", "autocomplete", "disabled", "name", "placeholder", "required", "rows"], Vy = /* @__PURE__ */ re({
  __name: "FieldTextarea",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    id: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    rows: {
      type: Number,
      default: 4
    },
    autocomplete: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    validation: {
      type: Object,
      default: null
    }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(e, { emit: n }) {
    const t = e, o = X(), i = X(!1), r = n;
    Ge(() => d()), Ne(
      () => t.modelValue,
      () => {
        d();
      }
    );
    const a = (f) => {
      const c = f.target;
      i.value = !0, r("focus", c.value, t.id);
    }, l = (f) => {
      const c = f.target;
      i.value = !1, r("blur", c.value, t.id);
    }, s = (f) => {
      let h = f.target.value;
      r("change", h, t.id), r("update:modelValue", h, t.id);
    }, u = (f) => {
      f.code == "Enter" && r("submit", t.id);
    }, d = () => {
      if (o.value) {
        const f = o.value.querySelector("textarea");
        f && (f.value = t.modelValue);
      }
    };
    return (f, c) => {
      var h, m, g, v;
      return _(), P("div", {
        ref_key: "root",
        ref: o
      }, [
        e.label || e.description ? (_(), P("div", Ny, [
          e.label ? (_(), P("div", Fy, [
            ce(Re, {
              id: `${e.id}`,
              label: e.label
            }, null, 8, ["id", "label"]),
            e.required ? (_(), P("span", Ry, " * ")) : z("", !0)
          ])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("textarea", {
          id: `${e.id}`,
          class: pe(["box-border block max-h-60 w-full rounded-[4.16px] px-2.5 py-[9px] text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle", [
            (m = (h = e.validation) == null ? void 0 : h.$errors) != null && m.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:border-border-brand-emphasis"
          ]]),
          autocomplete: e.autocomplete,
          disabled: e.disabled,
          name: `${e.id}`,
          placeholder: e.placeholder,
          required: e.required,
          rows: e.rows,
          onBlur: l,
          onFocus: a,
          onInput: s,
          onKeypress: u
        }, null, 42, By),
        e.validation && ((g = e.validation.$errors) != null && g.length) ? (_(), ie(Re, {
          key: 1,
          class: "mt-1",
          label: (v = e.validation.$errors[0]) == null ? void 0 : v.$message,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ], 512);
    };
  }
}), jy = { key: 0 }, LA = /* @__PURE__ */ re({
  __name: "FieldToggle",
  props: {
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    id: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = X(t.modelValue), i = n;
    return Ne(o, async (r) => {
      i("change", r, t.id), i("update:modelValue", r);
    }), Ne(
      () => t.modelValue,
      (r) => o.value = r
    ), (r, a) => (_(), ie(I(dy), {
      as: "div",
      class: pe({ "flex w-full items-start justify-between": e.label || e.description })
    }, {
      default: J(() => [
        e.label || e.description ? (_(), P("div", jy, [
          e.label ? (_(), ie(Re, {
            key: 0,
            id: `${e.id}`,
            label: e.label
          }, null, 8, ["id", "label"])) : z("", !0),
          e.description ? (_(), ie(Re, {
            key: 1,
            label: e.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        ce(I(cy), {
          modelValue: o.value,
          "onUpdate:modelValue": a[0] || (a[0] = (l) => o.value = l),
          class: pe([
            o.value ? "bg-background-brand-emphasis" : e.disabled ? "bg-background-subtle" : "bg-border-subtle",
            e.disabled ? "cursor-not-allowed" : "cursor-pointer",
            "relative ml-4 inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-border-default focus:ring-offset-2"
          ]),
          disabled: e.disabled
        }, {
          default: J(() => [
            M("span", {
              "aria-hidden": "true",
              class: pe([
                o.value ? "translate-x-5" : "translate-x-0",
                "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-background-default shadow ring-0 transition duration-200 ease-in-out"
              ])
            }, null, 2)
          ]),
          _: 1
        }, 8, ["modelValue", "class", "disabled"])
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
function Hy(e, n) {
  e.indexOf(n) === -1 && e.push(n);
}
const mf = (e, n, t) => Math.min(Math.max(t, e), n), Qt = {
  duration: 0.3,
  delay: 0,
  endDelay: 0,
  repeat: 0,
  easing: "ease"
}, Ti = (e) => typeof e == "number", Ho = (e) => Array.isArray(e) && !Ti(e[0]), zy = (e, n, t) => {
  const o = n - e;
  return ((t - e) % o + o) % o + e;
};
function qy(e, n) {
  return Ho(e) ? e[zy(0, e.length, n)] : e;
}
const pf = (e, n, t) => -t * e + t * n + e, vf = () => {
}, Un = (e) => e, _s = (e, n, t) => n - e === 0 ? 1 : (t - e) / (n - e);
function bf(e, n) {
  const t = e[e.length - 1];
  for (let o = 1; o <= n; o++) {
    const i = _s(0, n, o);
    e.push(pf(t, 1, i));
  }
}
function Uy(e) {
  const n = [0];
  return bf(n, e - 1), n;
}
function Wy(e, n = Uy(e.length), t = Un) {
  const o = e.length, i = o - n.length;
  return i > 0 && bf(n, i), (r) => {
    let a = 0;
    for (; a < o - 2 && !(r < n[a + 1]); a++)
      ;
    let l = mf(0, 1, _s(n[a], n[a + 1], r));
    return l = qy(t, a)(l), pf(e[a], e[a + 1], l);
  };
}
const yf = (e) => Array.isArray(e) && Ti(e[0]), Nl = (e) => typeof e == "object" && !!e.createAnimation, Ko = (e) => typeof e == "function", Ky = (e) => typeof e == "string", yi = {
  ms: (e) => e * 1e3,
  s: (e) => e / 1e3
}, Cf = (e, n, t) => (((1 - 3 * t + 3 * n) * e + (3 * t - 6 * n)) * e + 3 * n) * e, Yy = 1e-7, Gy = 12;
function Zy(e, n, t, o, i) {
  let r, a, l = 0;
  do
    a = n + (t - n) / 2, r = Cf(a, o, i) - e, r > 0 ? t = a : n = a;
  while (Math.abs(r) > Yy && ++l < Gy);
  return a;
}
function ci(e, n, t, o) {
  if (e === n && t === o)
    return Un;
  const i = (r) => Zy(r, 0, 1, e, t);
  return (r) => r === 0 || r === 1 ? r : Cf(i(r), n, o);
}
const Xy = (e, n = "end") => (t) => {
  t = n === "end" ? Math.min(t, 0.999) : Math.max(t, 1e-3);
  const o = t * e, i = n === "end" ? Math.floor(o) : Math.ceil(o);
  return mf(0, 1, i / e);
}, Jy = {
  ease: ci(0.25, 0.1, 0.25, 1),
  "ease-in": ci(0.42, 0, 1, 1),
  "ease-in-out": ci(0.42, 0, 0.58, 1),
  "ease-out": ci(0, 0, 0.58, 1)
}, Qy = /\((.*?)\)/;
function Fl(e) {
  if (Ko(e))
    return e;
  if (yf(e))
    return ci(...e);
  const n = Jy[e];
  if (n)
    return n;
  if (e.startsWith("steps")) {
    const t = Qy.exec(e);
    if (t) {
      const o = t[1].split(",");
      return Xy(parseFloat(o[0]), o[1].trim());
    }
  }
  return Un;
}
let xf = class {
  constructor(n, t = [0, 1], { easing: o, duration: i = Qt.duration, delay: r = Qt.delay, endDelay: a = Qt.endDelay, repeat: l = Qt.repeat, offset: s, direction: u = "normal", autoplay: d = !0 } = {}) {
    if (this.startTime = null, this.rate = 1, this.t = 0, this.cancelTimestamp = null, this.easing = Un, this.duration = 0, this.totalDuration = 0, this.repeat = 0, this.playState = "idle", this.finished = new Promise((c, h) => {
      this.resolve = c, this.reject = h;
    }), o = o || Qt.easing, Nl(o)) {
      const c = o.createAnimation(t);
      o = c.easing, t = c.keyframes || t, i = c.duration || i;
    }
    this.repeat = l, this.easing = Ho(o) ? Un : Fl(o), this.updateDuration(i);
    const f = Wy(t, s, Ho(o) ? o.map(Fl) : Un);
    this.tick = (c) => {
      var h;
      r = r;
      let m = 0;
      this.pauseTime !== void 0 ? m = this.pauseTime : m = (c - this.startTime) * this.rate, this.t = m, m /= 1e3, m = Math.max(m - r, 0), this.playState === "finished" && this.pauseTime === void 0 && (m = this.totalDuration);
      const g = m / this.duration;
      let v = Math.floor(g), p = g % 1;
      !p && g >= 1 && (p = 1), p === 1 && v--;
      const y = v % 2;
      (u === "reverse" || u === "alternate" && y || u === "alternate-reverse" && !y) && (p = 1 - p);
      const C = m >= this.totalDuration ? 1 : Math.min(p, 1), b = f(this.easing(C));
      n(b), this.pauseTime === void 0 && (this.playState === "finished" || m >= this.totalDuration + a) ? (this.playState = "finished", (h = this.resolve) === null || h === void 0 || h.call(this, b)) : this.playState !== "idle" && (this.frameRequestId = requestAnimationFrame(this.tick));
    }, d && this.play();
  }
  play() {
    const n = performance.now();
    this.playState = "running", this.pauseTime !== void 0 ? this.startTime = n - this.pauseTime : this.startTime || (this.startTime = n), this.cancelTimestamp = this.startTime, this.pauseTime = void 0, this.frameRequestId = requestAnimationFrame(this.tick);
  }
  pause() {
    this.playState = "paused", this.pauseTime = this.t;
  }
  finish() {
    this.playState = "finished", this.tick(0);
  }
  stop() {
    var n;
    this.playState = "idle", this.frameRequestId !== void 0 && cancelAnimationFrame(this.frameRequestId), (n = this.reject) === null || n === void 0 || n.call(this, !1);
  }
  cancel() {
    this.stop(), this.tick(this.cancelTimestamp);
  }
  reverse() {
    this.rate *= -1;
  }
  commitStyles() {
  }
  updateDuration(n) {
    this.duration = n, this.totalDuration = n * (this.repeat + 1);
  }
  get currentTime() {
    return this.t;
  }
  set currentTime(n) {
    this.pauseTime !== void 0 || this.rate === 0 ? this.pauseTime = n : this.startTime = performance.now() - n / this.rate;
  }
  get playbackRate() {
    return this.rate;
  }
  set playbackRate(n) {
    this.rate = n;
  }
};
var Rl = function() {
};
process.env.NODE_ENV !== "production" && (Rl = function(e, n) {
  if (!e)
    throw new Error(n);
});
class eC {
  setAnimation(n) {
    this.animation = n, n == null || n.finished.then(() => this.clearAnimation()).catch(() => {
    });
  }
  clearAnimation() {
    this.animation = this.generator = void 0;
  }
}
const Ga = /* @__PURE__ */ new WeakMap();
function wf(e) {
  return Ga.has(e) || Ga.set(e, {
    transforms: [],
    values: /* @__PURE__ */ new Map()
  }), Ga.get(e);
}
function tC(e, n) {
  return e.has(n) || e.set(n, new eC()), e.get(n);
}
const nC = ["", "X", "Y", "Z"], oC = ["translate", "scale", "rotate", "skew"], qr = {
  x: "translateX",
  y: "translateY",
  z: "translateZ"
}, _d = {
  syntax: "<angle>",
  initialValue: "0deg",
  toDefaultUnit: (e) => e + "deg"
}, iC = {
  translate: {
    syntax: "<length-percentage>",
    initialValue: "0px",
    toDefaultUnit: (e) => e + "px"
  },
  rotate: _d,
  scale: {
    syntax: "<number>",
    initialValue: 1,
    toDefaultUnit: Un
  },
  skew: _d
}, Pi = /* @__PURE__ */ new Map(), Os = (e) => `--motion-${e}`, Ur = ["x", "y", "z"];
oC.forEach((e) => {
  nC.forEach((n) => {
    Ur.push(e + n), Pi.set(Os(e + n), iC[e]);
  });
});
const rC = (e, n) => Ur.indexOf(e) - Ur.indexOf(n), aC = new Set(Ur), $f = (e) => aC.has(e), lC = (e, n) => {
  qr[n] && (n = qr[n]);
  const { transforms: t } = wf(e);
  Hy(t, n), e.style.transform = sC(t);
}, sC = (e) => e.sort(rC).reduce(uC, "").trim(), uC = (e, n) => `${e} ${n}(var(${Os(n)}))`, Bl = (e) => e.startsWith("--"), Od = /* @__PURE__ */ new Set();
function dC(e) {
  if (!Od.has(e)) {
    Od.add(e);
    try {
      const { syntax: n, initialValue: t } = Pi.has(e) ? Pi.get(e) : {};
      CSS.registerProperty({
        name: e,
        inherits: !1,
        syntax: n,
        initialValue: t
      });
    } catch {
    }
  }
}
const Za = (e, n) => document.createElement("div").animate(e, n), Ed = {
  cssRegisterProperty: () => typeof CSS < "u" && Object.hasOwnProperty.call(CSS, "registerProperty"),
  waapi: () => Object.hasOwnProperty.call(Element.prototype, "animate"),
  partialKeyframes: () => {
    try {
      Za({ opacity: [1] });
    } catch {
      return !1;
    }
    return !0;
  },
  finished: () => !!Za({ opacity: [0, 1] }, { duration: 1e-3 }).finished,
  linearEasing: () => {
    try {
      Za({ opacity: 0 }, { easing: "linear(0, 1)" });
    } catch {
      return !1;
    }
    return !0;
  }
}, Xa = {}, Ro = {};
for (const e in Ed)
  Ro[e] = () => (Xa[e] === void 0 && (Xa[e] = Ed[e]()), Xa[e]);
const cC = 0.015, fC = (e, n) => {
  let t = "";
  const o = Math.round(n / cC);
  for (let i = 0; i < o; i++)
    t += e(_s(0, o - 1, i)) + ", ";
  return t.substring(0, t.length - 2);
}, Md = (e, n) => Ko(e) ? Ro.linearEasing() ? `linear(${fC(e, n)})` : Qt.easing : yf(e) ? hC(e) : e, hC = ([e, n, t, o]) => `cubic-bezier(${e}, ${n}, ${t}, ${o})`;
function gC(e, n) {
  for (let t = 0; t < e.length; t++)
    e[t] === null && (e[t] = t ? e[t - 1] : n());
  return e;
}
const mC = (e) => Array.isArray(e) ? e : [e];
function Vl(e) {
  return qr[e] && (e = qr[e]), $f(e) ? Os(e) : e;
}
const dr = {
  get: (e, n) => {
    n = Vl(n);
    let t = Bl(n) ? e.style.getPropertyValue(n) : getComputedStyle(e)[n];
    if (!t && t !== 0) {
      const o = Pi.get(n);
      o && (t = o.initialValue);
    }
    return t;
  },
  set: (e, n, t) => {
    n = Vl(n), Bl(n) ? e.style.setProperty(n, t) : e.style[n] = t;
  }
};
function kf(e, n = !0) {
  if (!(!e || e.playState === "finished"))
    try {
      e.stop ? e.stop() : (n && e.commitStyles(), e.cancel());
    } catch {
    }
}
function pC(e, n) {
  var t;
  let o = (n == null ? void 0 : n.toDefaultUnit) || Un;
  const i = e[e.length - 1];
  if (Ky(i)) {
    const r = ((t = i.match(/(-?[\d.]+)([a-z%]*)/)) === null || t === void 0 ? void 0 : t[2]) || "";
    r && (o = (a) => a + r);
  }
  return o;
}
function vC() {
  return window.__MOTION_DEV_TOOLS_RECORD;
}
function bC(e, n, t, o = {}, i) {
  const r = vC(), a = o.record !== !1 && r;
  let l, { duration: s = Qt.duration, delay: u = Qt.delay, endDelay: d = Qt.endDelay, repeat: f = Qt.repeat, easing: c = Qt.easing, persist: h = !1, direction: m, offset: g, allowWebkitAcceleration: v = !1, autoplay: p = !0 } = o;
  const y = wf(e), C = $f(n);
  let b = Ro.waapi();
  C && lC(e, n);
  const x = Vl(n), w = tC(y.values, x), $ = Pi.get(x);
  return kf(w.animation, !(Nl(c) && w.generator) && o.record !== !1), () => {
    const E = () => {
      var k, S;
      return (S = (k = dr.get(e, x)) !== null && k !== void 0 ? k : $ == null ? void 0 : $.initialValue) !== null && S !== void 0 ? S : 0;
    };
    let A = gC(mC(t), E);
    const O = pC(A, $);
    if (Nl(c)) {
      const k = c.createAnimation(A, n !== "opacity", E, x, w);
      c = k.easing, A = k.keyframes || A, s = k.duration || s;
    }
    if (Bl(x) && (Ro.cssRegisterProperty() ? dC(x) : b = !1), C && !Ro.linearEasing() && (Ko(c) || Ho(c) && c.some(Ko)) && (b = !1), b) {
      $ && (A = A.map((T) => Ti(T) ? $.toDefaultUnit(T) : T)), A.length === 1 && (!Ro.partialKeyframes() || a) && A.unshift(E());
      const k = {
        delay: yi.ms(u),
        duration: yi.ms(s),
        endDelay: yi.ms(d),
        easing: Ho(c) ? void 0 : Md(c, s),
        direction: m,
        iterations: f + 1,
        fill: "both"
      };
      l = e.animate({
        [x]: A,
        offset: g,
        easing: Ho(c) ? c.map((T) => Md(T, s)) : void 0
      }, k), l.finished || (l.finished = new Promise((T, L) => {
        l.onfinish = T, l.oncancel = L;
      }));
      const S = A[A.length - 1];
      l.finished.then(() => {
        h || (dr.set(e, x, S), l.cancel());
      }).catch(vf), v || (l.playbackRate = 1.000001);
    } else if (i && C)
      A = A.map((k) => typeof k == "string" ? parseFloat(k) : k), A.length === 1 && A.unshift(parseFloat(E())), l = new i((k) => {
        dr.set(e, x, O ? O(k) : k);
      }, A, Object.assign(Object.assign({}, o), {
        duration: s,
        easing: c
      }));
    else {
      const k = A[A.length - 1];
      dr.set(e, x, $ && Ti(k) ? $.toDefaultUnit(k) : k);
    }
    return a && r(e, n, A, {
      duration: s,
      delay: u,
      easing: c,
      repeat: f,
      offset: g
    }, "motion-one"), w.setAnimation(l), l && !p && l.pause(), l;
  };
}
const yC = (e, n) => (
  /**
   * TODO: Make test for this
   * Always return a new object otherwise delay is overwritten by results of stagger
   * and this results in no stagger
   */
  e[n] ? Object.assign(Object.assign({}, e), e[n]) : Object.assign({}, e)
);
function CC(e, n) {
  var t;
  return typeof e == "string" ? n ? ((t = n[e]) !== null && t !== void 0 || (n[e] = document.querySelectorAll(e)), e = n[e]) : e = document.querySelectorAll(e) : e instanceof Element && (e = [e]), Array.from(e || []);
}
const xC = (e) => e(), _f = (e, n, t = Qt.duration) => new Proxy({
  animations: e.map(xC).filter(Boolean),
  duration: t,
  options: n
}, $C), wC = (e) => e.animations[0], $C = {
  get: (e, n) => {
    const t = wC(e);
    switch (n) {
      case "duration":
        return e.duration;
      case "currentTime":
        return yi.s((t == null ? void 0 : t[n]) || 0);
      case "playbackRate":
      case "playState":
        return t == null ? void 0 : t[n];
      case "finished":
        return e.finished || (e.finished = Promise.all(e.animations.map(kC)).catch(vf)), e.finished;
      case "stop":
        return () => {
          e.animations.forEach((o) => kf(o));
        };
      case "forEachNative":
        return (o) => {
          e.animations.forEach((i) => o(i, e));
        };
      default:
        return typeof (t == null ? void 0 : t[n]) > "u" ? void 0 : () => e.animations.forEach((o) => o[n]());
    }
  },
  set: (e, n, t) => {
    switch (n) {
      case "currentTime":
        t = yi.ms(t);
      case "playbackRate":
        for (let o = 0; o < e.animations.length; o++)
          e.animations[o][n] = t;
        return !0;
    }
    return !1;
  }
}, kC = (e) => e.finished;
function _C(e = 0.1, { start: n = 0, from: t = 0, easing: o } = {}) {
  return (i, r) => {
    const a = Ti(t) ? t : OC(t, r), l = Math.abs(a - i);
    let s = e * l;
    if (o) {
      const u = r * e;
      s = Fl(o)(s / u) * u;
    }
    return n + s;
  };
}
function OC(e, n) {
  if (e === "first")
    return 0;
  {
    const t = n - 1;
    return e === "last" ? t : t / 2;
  }
}
function EC(e, n, t) {
  return Ko(e) ? e(n, t) : e;
}
function MC(e) {
  return function(t, o, i = {}) {
    t = CC(t);
    const r = t.length;
    Rl(!!r, "No valid element provided."), Rl(!!o, "No keyframes defined.");
    const a = [];
    for (let l = 0; l < r; l++) {
      const s = t[l];
      for (const u in o) {
        const d = yC(i, u);
        d.delay = EC(d.delay, l, r);
        const f = bC(s, u, o[u], d, e);
        a.push(f);
      }
    }
    return _f(
      a,
      i,
      /**
       * TODO:
       * If easing is set to spring or glide, duration will be dynamically
       * generated. Ideally we would dynamically generate this from
       * animation.effect.getComputedTiming().duration but this isn't
       * supported in iOS13 or our number polyfill. Perhaps it's possible
       * to Proxy animations returned from animateStyle that has duration
       * as a getter.
       */
      i.duration
    );
  };
}
const SC = MC(xf);
function AC(e, n = {}) {
  return _f([
    () => {
      const t = new xf(e, [0, 1], n);
      return t.finished.catch(() => {
      }), t;
    }
  ], n, n.duration);
}
function TC(e, n, t) {
  return (Ko(e) ? AC : SC)(e, n, t);
}
const PC = { class: "flex gap-2 items-end" }, IC = { class: "flex-1" }, DC = { class: "w-full h-full absolute top-0 left-0" }, LC = ["key:"], NC = { class: "py-3 px-4 bg-background-emphasis shadow-sm absolute rounded-lg top-[10%] left-4 text-mgm-txt-sm hidden group-hover:block z-40" }, FC = { class: "text-border-default text-mgm-txt-sm whitespace-nowrap" }, RC = { class: "text-white text-mgm-txt-sm whitespace-nowrap" }, BC = { class: "w-full flex items-center justify-between mt-2" }, FA = /* @__PURE__ */ re({
  __name: "BarChart",
  props: {
    class: {},
    data: {},
    height: {},
    step: {}
  },
  setup(e) {
    const n = e, t = Math.max(...n.data.map((r) => r.value)), o = (r) => r / t * 100, i = Math.ceil(t / n.step);
    return Ge(() => {
      TC(
        ".bar-chart",
        {
          opacity: [0, 1],
          height: [
            0,
            (r) => r.getBoundingClientRect().height
          ]
        },
        { delay: _C(0.1), easing: "ease-in-out", duration: 1 }
      );
    }), (r, a) => (_(), P("div", PC, [
      M("div", {
        class: "relative h-full w-12 text-right flex flex-col-reverse justify-between bottom-0 mb-[15px]",
        style: Ye({
          height: `${o((I(i) - 1) * r.step) * r.height / 100 + 20}px`
        })
      }, [
        (_(!0), P(me, null, Fe(I(i), (l, s) => (_(), P("span", {
          key: r.step + s,
          class: "text-right text-mgm-txt-sm text-foreground-subtle",
          style: Ye({ bottom: `calc(${o(s * r.step)}% - 8px)` })
        }, de(s * r.step), 5))), 128))
      ], 4),
      M("div", IC, [
        M("div", {
          class: pe(["w-full border-b border-border-subtle flex justify-between items-end relative", r.class]),
          style: Ye({ height: `${r.height}px` })
        }, [
          M("div", DC, [
            (_(!0), P(me, null, Fe(I(i), (l, s) => (_(), P("div", {
              key: "stepbar" + s,
              class: "w-full h-[1px] absolute bg-border-subtle",
              style: Ye({ bottom: `${o(s * r.step)}%` })
            }, null, 4))), 128))
          ]),
          (_(!0), P(me, null, Fe(r.data, (l) => (_(), P("div", {
            "key:": l.value,
            class: pe(`w-6 ${l.value !== 0 ? "bg-background-brand-emphasis" : "bg-transparent"} rounded-t group relative bar-chart`),
            style: Ye({
              height: `${l.value !== 0 ? o(l.value) : 10}%`
            })
          }, [
            M("div", NC, [
              M("p", FC, de(l.hover.title), 1),
              M("p", RC, de(l.hover.value), 1)
            ])
          ], 14, LC))), 256))
        ], 6),
        M("div", BC, [
          (_(!0), P(me, null, Fe(r.data, (l) => (_(), P("span", {
            key: l.legend,
            class: "text-mgm-txt-xs text-foreground-subtle"
          }, de(l.legend), 1))), 128))
        ])
      ])
    ]));
  }
});
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Gi(e) {
  return e + 0.5 | 0;
}
const Hn = (e, n, t) => Math.max(Math.min(e, t), n);
function fi(e) {
  return Hn(Gi(e * 2.55), 0, 255);
}
function Wn(e) {
  return Hn(Gi(e * 255), 0, 255);
}
function Sn(e) {
  return Hn(Gi(e / 2.55) / 100, 0, 1);
}
function Sd(e) {
  return Hn(Gi(e * 100), 0, 100);
}
const Zt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, jl = [..."0123456789ABCDEF"], VC = (e) => jl[e & 15], jC = (e) => jl[(e & 240) >> 4] + jl[e & 15], cr = (e) => (e & 240) >> 4 === (e & 15), HC = (e) => cr(e.r) && cr(e.g) && cr(e.b) && cr(e.a);
function zC(e) {
  var n = e.length, t;
  return e[0] === "#" && (n === 4 || n === 5 ? t = {
    r: 255 & Zt[e[1]] * 17,
    g: 255 & Zt[e[2]] * 17,
    b: 255 & Zt[e[3]] * 17,
    a: n === 5 ? Zt[e[4]] * 17 : 255
  } : (n === 7 || n === 9) && (t = {
    r: Zt[e[1]] << 4 | Zt[e[2]],
    g: Zt[e[3]] << 4 | Zt[e[4]],
    b: Zt[e[5]] << 4 | Zt[e[6]],
    a: n === 9 ? Zt[e[7]] << 4 | Zt[e[8]] : 255
  })), t;
}
const qC = (e, n) => e < 255 ? n(e) : "";
function UC(e) {
  var n = HC(e) ? VC : jC;
  return e ? "#" + n(e.r) + n(e.g) + n(e.b) + qC(e.a, n) : void 0;
}
const WC = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Of(e, n, t) {
  const o = n * Math.min(t, 1 - t), i = (r, a = (r + e / 30) % 12) => t - o * Math.max(Math.min(a - 3, 9 - a, 1), -1);
  return [i(0), i(8), i(4)];
}
function KC(e, n, t) {
  const o = (i, r = (i + e / 60) % 6) => t - t * n * Math.max(Math.min(r, 4 - r, 1), 0);
  return [o(5), o(3), o(1)];
}
function YC(e, n, t) {
  const o = Of(e, 1, 0.5);
  let i;
  for (n + t > 1 && (i = 1 / (n + t), n *= i, t *= i), i = 0; i < 3; i++)
    o[i] *= 1 - n - t, o[i] += n;
  return o;
}
function GC(e, n, t, o, i) {
  return e === i ? (n - t) / o + (n < t ? 6 : 0) : n === i ? (t - e) / o + 2 : (e - n) / o + 4;
}
function Es(e) {
  const t = e.r / 255, o = e.g / 255, i = e.b / 255, r = Math.max(t, o, i), a = Math.min(t, o, i), l = (r + a) / 2;
  let s, u, d;
  return r !== a && (d = r - a, u = l > 0.5 ? d / (2 - r - a) : d / (r + a), s = GC(t, o, i, d, r), s = s * 60 + 0.5), [s | 0, u || 0, l];
}
function Ms(e, n, t, o) {
  return (Array.isArray(n) ? e(n[0], n[1], n[2]) : e(n, t, o)).map(Wn);
}
function Ss(e, n, t) {
  return Ms(Of, e, n, t);
}
function ZC(e, n, t) {
  return Ms(YC, e, n, t);
}
function XC(e, n, t) {
  return Ms(KC, e, n, t);
}
function Ef(e) {
  return (e % 360 + 360) % 360;
}
function JC(e) {
  const n = WC.exec(e);
  let t = 255, o;
  if (!n)
    return;
  n[5] !== o && (t = n[6] ? fi(+n[5]) : Wn(+n[5]));
  const i = Ef(+n[2]), r = +n[3] / 100, a = +n[4] / 100;
  return n[1] === "hwb" ? o = ZC(i, r, a) : n[1] === "hsv" ? o = XC(i, r, a) : o = Ss(i, r, a), {
    r: o[0],
    g: o[1],
    b: o[2],
    a: t
  };
}
function QC(e, n) {
  var t = Es(e);
  t[0] = Ef(t[0] + n), t = Ss(t), e.r = t[0], e.g = t[1], e.b = t[2];
}
function ex(e) {
  if (!e)
    return;
  const n = Es(e), t = n[0], o = Sd(n[1]), i = Sd(n[2]);
  return e.a < 255 ? `hsla(${t}, ${o}%, ${i}%, ${Sn(e.a)})` : `hsl(${t}, ${o}%, ${i}%)`;
}
const Ad = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Td = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function tx() {
  const e = {}, n = Object.keys(Td), t = Object.keys(Ad);
  let o, i, r, a, l;
  for (o = 0; o < n.length; o++) {
    for (a = l = n[o], i = 0; i < t.length; i++)
      r = t[i], l = l.replace(r, Ad[r]);
    r = parseInt(Td[a], 16), e[l] = [r >> 16 & 255, r >> 8 & 255, r & 255];
  }
  return e;
}
let fr;
function nx(e) {
  fr || (fr = tx(), fr.transparent = [0, 0, 0, 0]);
  const n = fr[e.toLowerCase()];
  return n && {
    r: n[0],
    g: n[1],
    b: n[2],
    a: n.length === 4 ? n[3] : 255
  };
}
const ox = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function ix(e) {
  const n = ox.exec(e);
  let t = 255, o, i, r;
  if (n) {
    if (n[7] !== o) {
      const a = +n[7];
      t = n[8] ? fi(a) : Hn(a * 255, 0, 255);
    }
    return o = +n[1], i = +n[3], r = +n[5], o = 255 & (n[2] ? fi(o) : Hn(o, 0, 255)), i = 255 & (n[4] ? fi(i) : Hn(i, 0, 255)), r = 255 & (n[6] ? fi(r) : Hn(r, 0, 255)), {
      r: o,
      g: i,
      b: r,
      a: t
    };
  }
}
function rx(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${Sn(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Ja = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, Po = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function ax(e, n, t) {
  const o = Po(Sn(e.r)), i = Po(Sn(e.g)), r = Po(Sn(e.b));
  return {
    r: Wn(Ja(o + t * (Po(Sn(n.r)) - o))),
    g: Wn(Ja(i + t * (Po(Sn(n.g)) - i))),
    b: Wn(Ja(r + t * (Po(Sn(n.b)) - r))),
    a: e.a + t * (n.a - e.a)
  };
}
function hr(e, n, t) {
  if (e) {
    let o = Es(e);
    o[n] = Math.max(0, Math.min(o[n] + o[n] * t, n === 0 ? 360 : 1)), o = Ss(o), e.r = o[0], e.g = o[1], e.b = o[2];
  }
}
function Mf(e, n) {
  return e && Object.assign(n || {}, e);
}
function Pd(e) {
  var n = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (n = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (n.a = Wn(e[3]))) : (n = Mf(e, { r: 0, g: 0, b: 0, a: 1 }), n.a = Wn(n.a)), n;
}
function lx(e) {
  return e.charAt(0) === "r" ? ix(e) : JC(e);
}
class Ii {
  constructor(n) {
    if (n instanceof Ii)
      return n;
    const t = typeof n;
    let o;
    t === "object" ? o = Pd(n) : t === "string" && (o = zC(n) || nx(n) || lx(n)), this._rgb = o, this._valid = !!o;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var n = Mf(this._rgb);
    return n && (n.a = Sn(n.a)), n;
  }
  set rgb(n) {
    this._rgb = Pd(n);
  }
  rgbString() {
    return this._valid ? rx(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? UC(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? ex(this._rgb) : void 0;
  }
  mix(n, t) {
    if (n) {
      const o = this.rgb, i = n.rgb;
      let r;
      const a = t === r ? 0.5 : t, l = 2 * a - 1, s = o.a - i.a, u = ((l * s === -1 ? l : (l + s) / (1 + l * s)) + 1) / 2;
      r = 1 - u, o.r = 255 & u * o.r + r * i.r + 0.5, o.g = 255 & u * o.g + r * i.g + 0.5, o.b = 255 & u * o.b + r * i.b + 0.5, o.a = a * o.a + (1 - a) * i.a, this.rgb = o;
    }
    return this;
  }
  interpolate(n, t) {
    return n && (this._rgb = ax(this._rgb, n._rgb, t)), this;
  }
  clone() {
    return new Ii(this.rgb);
  }
  alpha(n) {
    return this._rgb.a = Wn(n), this;
  }
  clearer(n) {
    const t = this._rgb;
    return t.a *= 1 - n, this;
  }
  greyscale() {
    const n = this._rgb, t = Gi(n.r * 0.3 + n.g * 0.59 + n.b * 0.11);
    return n.r = n.g = n.b = t, this;
  }
  opaquer(n) {
    const t = this._rgb;
    return t.a *= 1 + n, this;
  }
  negate() {
    const n = this._rgb;
    return n.r = 255 - n.r, n.g = 255 - n.g, n.b = 255 - n.b, this;
  }
  lighten(n) {
    return hr(this._rgb, 2, n), this;
  }
  darken(n) {
    return hr(this._rgb, 2, -n), this;
  }
  saturate(n) {
    return hr(this._rgb, 1, n), this;
  }
  desaturate(n) {
    return hr(this._rgb, 1, -n), this;
  }
  rotate(n) {
    return QC(this._rgb, n), this;
  }
}
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function kn() {
}
const sx = (() => {
  let e = 0;
  return () => e++;
})();
function lt(e) {
  return e == null;
}
function dt(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const n = Object.prototype.toString.call(e);
  return n.slice(0, 7) === "[object" && n.slice(-6) === "Array]";
}
function Ue(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function _t(e) {
  return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function Wt(e, n) {
  return _t(e) ? e : n;
}
function Je(e, n) {
  return typeof e > "u" ? n : e;
}
const ux = (e, n) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : +e / n, Sf = (e, n) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * n : +e;
function at(e, n, t) {
  if (e && typeof e.call == "function")
    return e.apply(t, n);
}
function nt(e, n, t, o) {
  let i, r, a;
  if (dt(e))
    if (r = e.length, o)
      for (i = r - 1; i >= 0; i--)
        n.call(t, e[i], i);
    else
      for (i = 0; i < r; i++)
        n.call(t, e[i], i);
  else if (Ue(e))
    for (a = Object.keys(e), r = a.length, i = 0; i < r; i++)
      n.call(t, e[a[i]], a[i]);
}
function Wr(e, n) {
  let t, o, i, r;
  if (!e || !n || e.length !== n.length)
    return !1;
  for (t = 0, o = e.length; t < o; ++t)
    if (i = e[t], r = n[t], i.datasetIndex !== r.datasetIndex || i.index !== r.index)
      return !1;
  return !0;
}
function Kr(e) {
  if (dt(e))
    return e.map(Kr);
  if (Ue(e)) {
    const n = /* @__PURE__ */ Object.create(null), t = Object.keys(e), o = t.length;
    let i = 0;
    for (; i < o; ++i)
      n[t[i]] = Kr(e[t[i]]);
    return n;
  }
  return e;
}
function Af(e) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(e) === -1;
}
function dx(e, n, t, o) {
  if (!Af(e))
    return;
  const i = n[e], r = t[e];
  Ue(i) && Ue(r) ? Di(i, r, o) : n[e] = Kr(r);
}
function Di(e, n, t) {
  const o = dt(n) ? n : [
    n
  ], i = o.length;
  if (!Ue(e))
    return e;
  t = t || {};
  const r = t.merger || dx;
  let a;
  for (let l = 0; l < i; ++l) {
    if (a = o[l], !Ue(a))
      continue;
    const s = Object.keys(a);
    for (let u = 0, d = s.length; u < d; ++u)
      r(s[u], e, a, t);
  }
  return e;
}
function Ci(e, n) {
  return Di(e, n, {
    merger: cx
  });
}
function cx(e, n, t) {
  if (!Af(e))
    return;
  const o = n[e], i = t[e];
  Ue(o) && Ue(i) ? Ci(o, i) : Object.prototype.hasOwnProperty.call(n, e) || (n[e] = Kr(i));
}
const Id = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (e) => e,
  // default resolvers
  x: (e) => e.x,
  y: (e) => e.y
};
function fx(e) {
  const n = e.split("."), t = [];
  let o = "";
  for (const i of n)
    o += i, o.endsWith("\\") ? o = o.slice(0, -1) + "." : (t.push(o), o = "");
  return t;
}
function hx(e) {
  const n = fx(e);
  return (t) => {
    for (const o of n) {
      if (o === "")
        break;
      t = t && t[o];
    }
    return t;
  };
}
function Li(e, n) {
  return (Id[n] || (Id[n] = hx(n)))(e);
}
function As(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const Yr = (e) => typeof e < "u", Zn = (e) => typeof e == "function", Dd = (e, n) => {
  if (e.size !== n.size)
    return !1;
  for (const t of e)
    if (!n.has(t))
      return !1;
  return !0;
};
function gx(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const mt = Math.PI, ht = 2 * mt, Gr = Number.POSITIVE_INFINITY, mx = mt / 180, vt = mt / 2, ro = mt / 4, Ld = mt * 2 / 3, zn = Math.log10, Zr = Math.sign;
function Ir(e, n, t) {
  return Math.abs(e - n) < t;
}
function Nd(e) {
  const n = Math.round(e);
  e = Ir(e, n, e / 1e3) ? n : e;
  const t = Math.pow(10, Math.floor(zn(e))), o = e / t;
  return (o <= 1 ? 1 : o <= 2 ? 2 : o <= 5 ? 5 : 10) * t;
}
function px(e) {
  const n = [], t = Math.sqrt(e);
  let o;
  for (o = 1; o < t; o++)
    e % o === 0 && (n.push(o), n.push(e / o));
  return t === (t | 0) && n.push(t), n.sort((i, r) => i - r).pop(), n;
}
function vx(e) {
  return typeof e == "symbol" || typeof e == "object" && e !== null && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
function Xr(e) {
  return !vx(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
function bx(e, n) {
  const t = Math.round(e);
  return t - n <= e && t + n >= e;
}
function Tf(e, n, t) {
  let o, i, r;
  for (o = 0, i = e.length; o < i; o++)
    r = e[o][t], isNaN(r) || (n.min = Math.min(n.min, r), n.max = Math.max(n.max, r));
}
function mn(e) {
  return e * (mt / 180);
}
function Ts(e) {
  return e * (180 / mt);
}
function Fd(e) {
  if (!_t(e))
    return;
  let n = 1, t = 0;
  for (; Math.round(e * n) / n !== e; )
    n *= 10, t++;
  return t;
}
function Pf(e, n) {
  const t = n.x - e.x, o = n.y - e.y, i = Math.sqrt(t * t + o * o);
  let r = Math.atan2(o, t);
  return r < -0.5 * mt && (r += ht), {
    angle: r,
    distance: i
  };
}
function yx(e, n) {
  return Math.sqrt(Math.pow(n.x - e.x, 2) + Math.pow(n.y - e.y, 2));
}
function gn(e) {
  return (e % ht + ht) % ht;
}
function Jr(e, n, t, o) {
  const i = gn(e), r = gn(n), a = gn(t), l = gn(r - i), s = gn(a - i), u = gn(i - r), d = gn(i - a);
  return i === r || i === a || o && r === a || l > s && u < d;
}
function Ht(e, n, t) {
  return Math.max(n, Math.min(t, e));
}
function Cx(e) {
  return Ht(e, -32768, 32767);
}
function fo(e, n, t, o = 1e-6) {
  return e >= Math.min(n, t) - o && e <= Math.max(n, t) + o;
}
function Ps(e, n, t) {
  t = t || ((a) => e[a] < n);
  let o = e.length - 1, i = 0, r;
  for (; o - i > 1; )
    r = i + o >> 1, t(r) ? i = r : o = r;
  return {
    lo: i,
    hi: o
  };
}
const Hl = (e, n, t, o) => Ps(e, t, o ? (i) => {
  const r = e[i][n];
  return r < t || r === t && e[i + 1][n] === t;
} : (i) => e[i][n] < t), xx = (e, n, t) => Ps(e, t, (o) => e[o][n] >= t);
function wx(e, n, t) {
  let o = 0, i = e.length;
  for (; o < i && e[o] < n; )
    o++;
  for (; i > o && e[i - 1] > t; )
    i--;
  return o > 0 || i < e.length ? e.slice(o, i) : e;
}
const If = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function $x(e, n) {
  if (e._chartjs) {
    e._chartjs.listeners.push(n);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        n
      ]
    }
  }), If.forEach((t) => {
    const o = "_onData" + As(t), i = e[t];
    Object.defineProperty(e, t, {
      configurable: !0,
      enumerable: !1,
      value(...r) {
        const a = i.apply(this, r);
        return e._chartjs.listeners.forEach((l) => {
          typeof l[o] == "function" && l[o](...r);
        }), a;
      }
    });
  });
}
function Rd(e, n) {
  const t = e._chartjs;
  if (!t)
    return;
  const o = t.listeners, i = o.indexOf(n);
  i !== -1 && o.splice(i, 1), !(o.length > 0) && (If.forEach((r) => {
    delete e[r];
  }), delete e._chartjs);
}
function kx(e) {
  const n = new Set(e);
  return n.size === e.length ? e : Array.from(n);
}
const Df = function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
}();
function Lf(e, n) {
  let t = [], o = !1;
  return function(...i) {
    t = i, o || (o = !0, Df.call(window, () => {
      o = !1, e.apply(n, t);
    }));
  };
}
function _x(e, n) {
  let t;
  return function(...o) {
    return n ? (clearTimeout(t), t = setTimeout(e, n, o)) : e.apply(this, o), n;
  };
}
const Is = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", St = (e, n, t) => e === "start" ? n : e === "end" ? t : (n + t) / 2, Ox = (e, n, t, o) => e === (o ? "left" : "right") ? t : e === "center" ? (n + t) / 2 : n, gr = (e) => e === 0 || e === 1, Bd = (e, n, t) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - n) * ht / t)), Vd = (e, n, t) => Math.pow(2, -10 * e) * Math.sin((e - n) * ht / t) + 1, xi = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * vt) + 1,
  easeOutSine: (e) => Math.sin(e * vt),
  easeInOutSine: (e) => -0.5 * (Math.cos(mt * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => gr(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => gr(e) ? e : Bd(e, 0.075, 0.3),
  easeOutElastic: (e) => gr(e) ? e : Vd(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return gr(e) ? e : e < 0.5 ? 0.5 * Bd(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * Vd(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let n = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((n *= 1.525) + 1) * e - n)) : 0.5 * ((e -= 2) * e * (((n *= 1.525) + 1) * e + n) + 2);
  },
  easeInBounce: (e) => 1 - xi.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? xi.easeInBounce(e * 2) * 0.5 : xi.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
function Nf(e) {
  if (e && typeof e == "object") {
    const n = e.toString();
    return n === "[object CanvasPattern]" || n === "[object CanvasGradient]";
  }
  return !1;
}
function jd(e) {
  return Nf(e) ? e : new Ii(e);
}
function Qa(e) {
  return Nf(e) ? e : new Ii(e).saturate(0.5).darken(0.1).hexString();
}
const Ex = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], Mx = [
  "color",
  "borderColor",
  "backgroundColor"
];
function Sx(e) {
  e.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), e.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (n) => n !== "onProgress" && n !== "onComplete" && n !== "fn"
  }), e.set("animations", {
    colors: {
      type: "color",
      properties: Mx
    },
    numbers: {
      type: "number",
      properties: Ex
    }
  }), e.describe("animations", {
    _fallback: "animation"
  }), e.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (n) => n | 0
        }
      }
    }
  });
}
function Ax(e) {
  e.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const Hd = /* @__PURE__ */ new Map();
function Tx(e, n) {
  n = n || {};
  const t = e + JSON.stringify(n);
  let o = Hd.get(t);
  return o || (o = new Intl.NumberFormat(e, n), Hd.set(t, o)), o;
}
function ya(e, n, t) {
  return Tx(n, t).format(e);
}
const Ff = {
  values(e) {
    return dt(e) ? e : "" + e;
  },
  numeric(e, n, t) {
    if (e === 0)
      return "0";
    const o = this.chart.options.locale;
    let i, r = e;
    if (t.length > 1) {
      const u = Math.max(Math.abs(t[0].value), Math.abs(t[t.length - 1].value));
      (u < 1e-4 || u > 1e15) && (i = "scientific"), r = Px(e, t);
    }
    const a = zn(Math.abs(r)), l = isNaN(a) ? 1 : Math.max(Math.min(-1 * Math.floor(a), 20), 0), s = {
      notation: i,
      minimumFractionDigits: l,
      maximumFractionDigits: l
    };
    return Object.assign(s, this.options.ticks.format), ya(e, o, s);
  },
  logarithmic(e, n, t) {
    if (e === 0)
      return "0";
    const o = t[n].significand || e / Math.pow(10, Math.floor(zn(e)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(o) || n > 0.8 * t.length ? Ff.numeric.call(this, e, n, t) : "";
  }
};
function Px(e, n) {
  let t = n.length > 3 ? n[2].value - n[1].value : n[1].value - n[0].value;
  return Math.abs(t) >= 1 && e !== Math.floor(e) && (t = e - Math.floor(e)), t;
}
var Ca = {
  formatters: Ff
};
function Ix(e) {
  e.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (n, t) => t.lineWidth,
      tickColor: (n, t) => t.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ca.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
    _fallback: !1,
    _scriptable: (n) => !n.startsWith("before") && !n.startsWith("after") && n !== "callback" && n !== "parser",
    _indexable: (n) => n !== "borderDash" && n !== "tickBorderDash" && n !== "dash"
  }), e.describe("scales", {
    _fallback: "scale"
  }), e.describe("scale.ticks", {
    _scriptable: (n) => n !== "backdropPadding" && n !== "callback",
    _indexable: (n) => n !== "backdropPadding"
  });
}
const Co = /* @__PURE__ */ Object.create(null), zl = /* @__PURE__ */ Object.create(null);
function wi(e, n) {
  if (!n)
    return e;
  const t = n.split(".");
  for (let o = 0, i = t.length; o < i; ++o) {
    const r = t[o];
    e = e[r] || (e[r] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function el(e, n, t) {
  return typeof n == "string" ? Di(wi(e, n), t) : Di(wi(e, ""), n);
}
class Dx {
  constructor(n, t) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (o) => o.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (o, i) => Qa(i.backgroundColor), this.hoverBorderColor = (o, i) => Qa(i.borderColor), this.hoverColor = (o, i) => Qa(i.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(n), this.apply(t);
  }
  set(n, t) {
    return el(this, n, t);
  }
  get(n) {
    return wi(this, n);
  }
  describe(n, t) {
    return el(zl, n, t);
  }
  override(n, t) {
    return el(Co, n, t);
  }
  route(n, t, o, i) {
    const r = wi(this, n), a = wi(this, o), l = "_" + t;
    Object.defineProperties(r, {
      [l]: {
        value: r[t],
        writable: !0
      },
      [t]: {
        enumerable: !0,
        get() {
          const s = this[l], u = a[i];
          return Ue(s) ? Object.assign({}, u, s) : Je(s, u);
        },
        set(s) {
          this[l] = s;
        }
      }
    });
  }
  apply(n) {
    n.forEach((t) => t(this));
  }
}
var gt = /* @__PURE__ */ new Dx({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  Sx,
  Ax,
  Ix
]);
function Lx(e) {
  return !e || lt(e.size) || lt(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function Qr(e, n, t, o, i) {
  let r = n[i];
  return r || (r = n[i] = e.measureText(i).width, t.push(i)), r > o && (o = r), o;
}
function Nx(e, n, t, o) {
  o = o || {};
  let i = o.data = o.data || {}, r = o.garbageCollect = o.garbageCollect || [];
  o.font !== n && (i = o.data = {}, r = o.garbageCollect = [], o.font = n), e.save(), e.font = n;
  let a = 0;
  const l = t.length;
  let s, u, d, f, c;
  for (s = 0; s < l; s++)
    if (f = t[s], f != null && !dt(f))
      a = Qr(e, i, r, a, f);
    else if (dt(f))
      for (u = 0, d = f.length; u < d; u++)
        c = f[u], c != null && !dt(c) && (a = Qr(e, i, r, a, c));
  e.restore();
  const h = r.length / 2;
  if (h > t.length) {
    for (s = 0; s < h; s++)
      delete i[r[s]];
    r.splice(0, h);
  }
  return a;
}
function ao(e, n, t) {
  const o = e.currentDevicePixelRatio, i = t !== 0 ? Math.max(t / 2, 0.5) : 0;
  return Math.round((n - i) * o) / o + i;
}
function zd(e, n) {
  !n && !e || (n = n || e.getContext("2d"), n.save(), n.resetTransform(), n.clearRect(0, 0, e.width, e.height), n.restore());
}
function qd(e, n, t, o) {
  Rf(e, n, t, o, null);
}
function Rf(e, n, t, o, i) {
  let r, a, l, s, u, d, f, c;
  const h = n.pointStyle, m = n.rotation, g = n.radius;
  let v = (m || 0) * mx;
  if (h && typeof h == "object" && (r = h.toString(), r === "[object HTMLImageElement]" || r === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(t, o), e.rotate(v), e.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), h) {
      default:
        i ? e.ellipse(t, o, i / 2, g, 0, 0, ht) : e.arc(t, o, g, 0, ht), e.closePath();
        break;
      case "triangle":
        d = i ? i / 2 : g, e.moveTo(t + Math.sin(v) * d, o - Math.cos(v) * g), v += Ld, e.lineTo(t + Math.sin(v) * d, o - Math.cos(v) * g), v += Ld, e.lineTo(t + Math.sin(v) * d, o - Math.cos(v) * g), e.closePath();
        break;
      case "rectRounded":
        u = g * 0.516, s = g - u, a = Math.cos(v + ro) * s, f = Math.cos(v + ro) * (i ? i / 2 - u : s), l = Math.sin(v + ro) * s, c = Math.sin(v + ro) * (i ? i / 2 - u : s), e.arc(t - f, o - l, u, v - mt, v - vt), e.arc(t + c, o - a, u, v - vt, v), e.arc(t + f, o + l, u, v, v + vt), e.arc(t - c, o + a, u, v + vt, v + mt), e.closePath();
        break;
      case "rect":
        if (!m) {
          s = Math.SQRT1_2 * g, d = i ? i / 2 : s, e.rect(t - d, o - s, 2 * d, 2 * s);
          break;
        }
        v += ro;
      case "rectRot":
        f = Math.cos(v) * (i ? i / 2 : g), a = Math.cos(v) * g, l = Math.sin(v) * g, c = Math.sin(v) * (i ? i / 2 : g), e.moveTo(t - f, o - l), e.lineTo(t + c, o - a), e.lineTo(t + f, o + l), e.lineTo(t - c, o + a), e.closePath();
        break;
      case "crossRot":
        v += ro;
      case "cross":
        f = Math.cos(v) * (i ? i / 2 : g), a = Math.cos(v) * g, l = Math.sin(v) * g, c = Math.sin(v) * (i ? i / 2 : g), e.moveTo(t - f, o - l), e.lineTo(t + f, o + l), e.moveTo(t + c, o - a), e.lineTo(t - c, o + a);
        break;
      case "star":
        f = Math.cos(v) * (i ? i / 2 : g), a = Math.cos(v) * g, l = Math.sin(v) * g, c = Math.sin(v) * (i ? i / 2 : g), e.moveTo(t - f, o - l), e.lineTo(t + f, o + l), e.moveTo(t + c, o - a), e.lineTo(t - c, o + a), v += ro, f = Math.cos(v) * (i ? i / 2 : g), a = Math.cos(v) * g, l = Math.sin(v) * g, c = Math.sin(v) * (i ? i / 2 : g), e.moveTo(t - f, o - l), e.lineTo(t + f, o + l), e.moveTo(t + c, o - a), e.lineTo(t - c, o + a);
        break;
      case "line":
        a = i ? i / 2 : Math.cos(v) * g, l = Math.sin(v) * g, e.moveTo(t - a, o - l), e.lineTo(t + a, o + l);
        break;
      case "dash":
        e.moveTo(t, o), e.lineTo(t + Math.cos(v) * (i ? i / 2 : g), o + Math.sin(v) * g);
        break;
      case !1:
        e.closePath();
        break;
    }
    e.fill(), n.borderWidth > 0 && e.stroke();
  }
}
function Bo(e, n, t) {
  return t = t || 0.5, !n || e && e.x > n.left - t && e.x < n.right + t && e.y > n.top - t && e.y < n.bottom + t;
}
function Ds(e, n) {
  e.save(), e.beginPath(), e.rect(n.left, n.top, n.right - n.left, n.bottom - n.top), e.clip();
}
function Ls(e) {
  e.restore();
}
function Fx(e, n) {
  n.translation && e.translate(n.translation[0], n.translation[1]), lt(n.rotation) || e.rotate(n.rotation), n.color && (e.fillStyle = n.color), n.textAlign && (e.textAlign = n.textAlign), n.textBaseline && (e.textBaseline = n.textBaseline);
}
function Rx(e, n, t, o, i) {
  if (i.strikethrough || i.underline) {
    const r = e.measureText(o), a = n - r.actualBoundingBoxLeft, l = n + r.actualBoundingBoxRight, s = t - r.actualBoundingBoxAscent, u = t + r.actualBoundingBoxDescent, d = i.strikethrough ? (s + u) / 2 : u;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = i.decorationWidth || 2, e.moveTo(a, d), e.lineTo(l, d), e.stroke();
  }
}
function Bx(e, n) {
  const t = e.fillStyle;
  e.fillStyle = n.color, e.fillRect(n.left, n.top, n.width, n.height), e.fillStyle = t;
}
function xo(e, n, t, o, i, r = {}) {
  const a = dt(n) ? n : [
    n
  ], l = r.strokeWidth > 0 && r.strokeColor !== "";
  let s, u;
  for (e.save(), e.font = i.string, Fx(e, r), s = 0; s < a.length; ++s)
    u = a[s], r.backdrop && Bx(e, r.backdrop), l && (r.strokeColor && (e.strokeStyle = r.strokeColor), lt(r.strokeWidth) || (e.lineWidth = r.strokeWidth), e.strokeText(u, t, o, r.maxWidth)), e.fillText(u, t, o, r.maxWidth), Rx(e, t, o, u, r), o += Number(i.lineHeight);
  e.restore();
}
function Ni(e, n) {
  const { x: t, y: o, w: i, h: r, radius: a } = n;
  e.arc(t + a.topLeft, o + a.topLeft, a.topLeft, 1.5 * mt, mt, !0), e.lineTo(t, o + r - a.bottomLeft), e.arc(t + a.bottomLeft, o + r - a.bottomLeft, a.bottomLeft, mt, vt, !0), e.lineTo(t + i - a.bottomRight, o + r), e.arc(t + i - a.bottomRight, o + r - a.bottomRight, a.bottomRight, vt, 0, !0), e.lineTo(t + i, o + a.topRight), e.arc(t + i - a.topRight, o + a.topRight, a.topRight, 0, -vt, !0), e.lineTo(t + a.topLeft, o);
}
const Vx = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, jx = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function Hx(e, n) {
  const t = ("" + e).match(Vx);
  if (!t || t[1] === "normal")
    return n * 1.2;
  switch (e = +t[2], t[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return n * e;
}
const zx = (e) => +e || 0;
function Ns(e, n) {
  const t = {}, o = Ue(n), i = o ? Object.keys(n) : n, r = Ue(e) ? o ? (a) => Je(e[a], e[n[a]]) : (a) => e[a] : () => e;
  for (const a of i)
    t[a] = zx(r(a));
  return t;
}
function Bf(e) {
  return Ns(e, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function go(e) {
  return Ns(e, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function It(e) {
  const n = Bf(e);
  return n.width = n.left + n.right, n.height = n.top + n.bottom, n;
}
function xt(e, n) {
  e = e || {}, n = n || gt.font;
  let t = Je(e.size, n.size);
  typeof t == "string" && (t = parseInt(t, 10));
  let o = Je(e.style, n.style);
  o && !("" + o).match(jx) && (console.warn('Invalid font style specified: "' + o + '"'), o = void 0);
  const i = {
    family: Je(e.family, n.family),
    lineHeight: Hx(Je(e.lineHeight, n.lineHeight), t),
    size: t,
    style: o,
    weight: Je(e.weight, n.weight),
    string: ""
  };
  return i.string = Lx(i), i;
}
function mr(e, n, t, o) {
  let i = !0, r, a, l;
  for (r = 0, a = e.length; r < a; ++r)
    if (l = e[r], l !== void 0 && (n !== void 0 && typeof l == "function" && (l = l(n), i = !1), t !== void 0 && dt(l) && (l = l[t % l.length], i = !1), l !== void 0))
      return o && !i && (o.cacheable = !1), l;
}
function qx(e, n, t) {
  const { min: o, max: i } = e, r = Sf(n, (i - o) / 2), a = (l, s) => t && l === 0 ? 0 : l + s;
  return {
    min: a(o, -Math.abs(r)),
    max: a(i, r)
  };
}
function ko(e, n) {
  return Object.assign(Object.create(e), n);
}
function Fs(e, n = [
  ""
], t, o, i = () => e[0]) {
  const r = t || e;
  typeof o > "u" && (o = zf("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: r,
    _fallback: o,
    _getTarget: i,
    override: (l) => Fs([
      l,
      ...e
    ], n, r, o)
  };
  return new Proxy(a, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(l, s) {
      return delete l[s], delete l._keys, delete e[0][s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(l, s) {
      return jf(l, s, () => Jx(s, n, e, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(l, s) {
      return Reflect.getOwnPropertyDescriptor(l._scopes[0], s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(l, s) {
      return Wd(l).includes(s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(l) {
      return Wd(l);
    },
    /**
    * A trap for setting property values.
    */
    set(l, s, u) {
      const d = l._storage || (l._storage = i());
      return l[s] = d[s] = u, delete l._keys, !0;
    }
  });
}
function Yo(e, n, t, o) {
  const i = {
    _cacheable: !1,
    _proxy: e,
    _context: n,
    _subProxy: t,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: Vf(e, o),
    setContext: (r) => Yo(e, r, t, o),
    override: (r) => Yo(e.override(r), n, t, o)
  };
  return new Proxy(i, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(r, a) {
      return delete r[a], delete e[a], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(r, a, l) {
      return jf(r, a, () => Wx(r, a, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(r, a) {
      return r._descriptors.allKeys ? Reflect.has(e, a) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(e, a);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    /**
    * A trap for the in operator.
    */
    has(r, a) {
      return Reflect.has(e, a);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    /**
    * A trap for setting property values.
    */
    set(r, a, l) {
      return e[a] = l, delete r[a], !0;
    }
  });
}
function Vf(e, n = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: t = n.scriptable, _indexable: o = n.indexable, _allKeys: i = n.allKeys } = e;
  return {
    allKeys: i,
    scriptable: t,
    indexable: o,
    isScriptable: Zn(t) ? t : () => t,
    isIndexable: Zn(o) ? o : () => o
  };
}
const Ux = (e, n) => e ? e + As(n) : n, Rs = (e, n) => Ue(n) && e !== "adapters" && (Object.getPrototypeOf(n) === null || n.constructor === Object);
function jf(e, n, t) {
  if (Object.prototype.hasOwnProperty.call(e, n) || n === "constructor")
    return e[n];
  const o = t();
  return e[n] = o, o;
}
function Wx(e, n, t) {
  const { _proxy: o, _context: i, _subProxy: r, _descriptors: a } = e;
  let l = o[n];
  return Zn(l) && a.isScriptable(n) && (l = Kx(n, l, e, t)), dt(l) && l.length && (l = Yx(n, l, e, a.isIndexable)), Rs(n, l) && (l = Yo(l, i, r && r[n], a)), l;
}
function Kx(e, n, t, o) {
  const { _proxy: i, _context: r, _subProxy: a, _stack: l } = t;
  if (l.has(e))
    throw new Error("Recursion detected: " + Array.from(l).join("->") + "->" + e);
  l.add(e);
  let s = n(r, a || o);
  return l.delete(e), Rs(e, s) && (s = Bs(i._scopes, i, e, s)), s;
}
function Yx(e, n, t, o) {
  const { _proxy: i, _context: r, _subProxy: a, _descriptors: l } = t;
  if (typeof r.index < "u" && o(e))
    return n[r.index % n.length];
  if (Ue(n[0])) {
    const s = n, u = i._scopes.filter((d) => d !== s);
    n = [];
    for (const d of s) {
      const f = Bs(u, i, e, d);
      n.push(Yo(f, r, a && a[e], l));
    }
  }
  return n;
}
function Hf(e, n, t) {
  return Zn(e) ? e(n, t) : e;
}
const Gx = (e, n) => e === !0 ? n : typeof e == "string" ? Li(n, e) : void 0;
function Zx(e, n, t, o, i) {
  for (const r of n) {
    const a = Gx(t, r);
    if (a) {
      e.add(a);
      const l = Hf(a._fallback, t, i);
      if (typeof l < "u" && l !== t && l !== o)
        return l;
    } else if (a === !1 && typeof o < "u" && t !== o)
      return null;
  }
  return !1;
}
function Bs(e, n, t, o) {
  const i = n._rootScopes, r = Hf(n._fallback, t, o), a = [
    ...e,
    ...i
  ], l = /* @__PURE__ */ new Set();
  l.add(o);
  let s = Ud(l, a, t, r || t, o);
  return s === null || typeof r < "u" && r !== t && (s = Ud(l, a, r, s, o), s === null) ? !1 : Fs(Array.from(l), [
    ""
  ], i, r, () => Xx(n, t, o));
}
function Ud(e, n, t, o, i) {
  for (; t; )
    t = Zx(e, n, t, o, i);
  return t;
}
function Xx(e, n, t) {
  const o = e._getTarget();
  n in o || (o[n] = {});
  const i = o[n];
  return dt(i) && Ue(t) ? t : i || {};
}
function Jx(e, n, t, o) {
  let i;
  for (const r of n)
    if (i = zf(Ux(r, e), t), typeof i < "u")
      return Rs(e, i) ? Bs(t, o, e, i) : i;
}
function zf(e, n) {
  for (const t of n) {
    if (!t)
      continue;
    const o = t[e];
    if (typeof o < "u")
      return o;
  }
}
function Wd(e) {
  let n = e._keys;
  return n || (n = e._keys = Qx(e._scopes)), n;
}
function Qx(e) {
  const n = /* @__PURE__ */ new Set();
  for (const t of e)
    for (const o of Object.keys(t).filter((i) => !i.startsWith("_")))
      n.add(o);
  return Array.from(n);
}
function Vs() {
  return typeof window < "u" && typeof document < "u";
}
function js(e) {
  let n = e.parentNode;
  return n && n.toString() === "[object ShadowRoot]" && (n = n.host), n;
}
function ea(e, n, t) {
  let o;
  return typeof e == "string" ? (o = parseInt(e, 10), e.indexOf("%") !== -1 && (o = o / 100 * n.parentNode[t])) : o = e, o;
}
const xa = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function ew(e, n) {
  return xa(e).getPropertyValue(n);
}
const tw = [
  "top",
  "right",
  "bottom",
  "left"
];
function mo(e, n, t) {
  const o = {};
  t = t ? "-" + t : "";
  for (let i = 0; i < 4; i++) {
    const r = tw[i];
    o[r] = parseFloat(e[n + "-" + r + t]) || 0;
  }
  return o.width = o.left + o.right, o.height = o.top + o.bottom, o;
}
const nw = (e, n, t) => (e > 0 || n > 0) && (!t || !t.shadowRoot);
function ow(e, n) {
  const t = e.touches, o = t && t.length ? t[0] : e, { offsetX: i, offsetY: r } = o;
  let a = !1, l, s;
  if (nw(i, r, e.target))
    l = i, s = r;
  else {
    const u = n.getBoundingClientRect();
    l = o.clientX - u.left, s = o.clientY - u.top, a = !0;
  }
  return {
    x: l,
    y: s,
    box: a
  };
}
function uo(e, n) {
  if ("native" in e)
    return e;
  const { canvas: t, currentDevicePixelRatio: o } = n, i = xa(t), r = i.boxSizing === "border-box", a = mo(i, "padding"), l = mo(i, "border", "width"), { x: s, y: u, box: d } = ow(e, t), f = a.left + (d && l.left), c = a.top + (d && l.top);
  let { width: h, height: m } = n;
  return r && (h -= a.width + l.width, m -= a.height + l.height), {
    x: Math.round((s - f) / h * t.width / o),
    y: Math.round((u - c) / m * t.height / o)
  };
}
function iw(e, n, t) {
  let o, i;
  if (n === void 0 || t === void 0) {
    const r = e && js(e);
    if (!r)
      n = e.clientWidth, t = e.clientHeight;
    else {
      const a = r.getBoundingClientRect(), l = xa(r), s = mo(l, "border", "width"), u = mo(l, "padding");
      n = a.width - u.width - s.width, t = a.height - u.height - s.height, o = ea(l.maxWidth, r, "clientWidth"), i = ea(l.maxHeight, r, "clientHeight");
    }
  }
  return {
    width: n,
    height: t,
    maxWidth: o || Gr,
    maxHeight: i || Gr
  };
}
const pr = (e) => Math.round(e * 10) / 10;
function rw(e, n, t, o) {
  const i = xa(e), r = mo(i, "margin"), a = ea(i.maxWidth, e, "clientWidth") || Gr, l = ea(i.maxHeight, e, "clientHeight") || Gr, s = iw(e, n, t);
  let { width: u, height: d } = s;
  if (i.boxSizing === "content-box") {
    const c = mo(i, "border", "width"), h = mo(i, "padding");
    u -= h.width + c.width, d -= h.height + c.height;
  }
  return u = Math.max(0, u - r.width), d = Math.max(0, o ? u / o : d - r.height), u = pr(Math.min(u, a, s.maxWidth)), d = pr(Math.min(d, l, s.maxHeight)), u && !d && (d = pr(u / 2)), (n !== void 0 || t !== void 0) && o && s.height && d > s.height && (d = s.height, u = pr(Math.floor(d * o))), {
    width: u,
    height: d
  };
}
function Kd(e, n, t) {
  const o = n || 1, i = Math.floor(e.height * o), r = Math.floor(e.width * o);
  e.height = Math.floor(e.height), e.width = Math.floor(e.width);
  const a = e.canvas;
  return a.style && (t || !a.style.height && !a.style.width) && (a.style.height = `${e.height}px`, a.style.width = `${e.width}px`), e.currentDevicePixelRatio !== o || a.height !== i || a.width !== r ? (e.currentDevicePixelRatio = o, a.height = i, a.width = r, e.ctx.setTransform(o, 0, 0, o, 0, 0), !0) : !1;
}
const aw = function() {
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    };
    Vs() && (window.addEventListener("test", null, n), window.removeEventListener("test", null, n));
  } catch {
  }
  return e;
}();
function Yd(e, n) {
  const t = ew(e, n), o = t && t.match(/^(\d+)(\.\d+)?px$/);
  return o ? +o[1] : void 0;
}
const lw = function(e, n) {
  return {
    x(t) {
      return e + e + n - t;
    },
    setWidth(t) {
      n = t;
    },
    textAlign(t) {
      return t === "center" ? t : t === "right" ? "left" : "right";
    },
    xPlus(t, o) {
      return t - o;
    },
    leftForLtr(t, o) {
      return t - o;
    }
  };
}, sw = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, n) {
      return e + n;
    },
    leftForLtr(e, n) {
      return e;
    }
  };
};
function zo(e, n, t) {
  return e ? lw(n, t) : sw();
}
function qf(e, n) {
  let t, o;
  (n === "ltr" || n === "rtl") && (t = e.canvas.style, o = [
    t.getPropertyValue("direction"),
    t.getPropertyPriority("direction")
  ], t.setProperty("direction", n, "important"), e.prevTextDirection = o);
}
function Uf(e, n) {
  n !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", n[0], n[1]));
}
function vr(e, n, t) {
  return e.options.clip ? e[t] : n[t];
}
function uw(e, n) {
  const { xScale: t, yScale: o } = e;
  return t && o ? {
    left: vr(t, n, "left"),
    right: vr(t, n, "right"),
    top: vr(o, n, "top"),
    bottom: vr(o, n, "bottom")
  } : n;
}
function dw(e, n) {
  const t = n._clip;
  if (t.disabled)
    return !1;
  const o = uw(n, e.chartArea);
  return {
    left: t.left === !1 ? 0 : o.left - (t.left === !0 ? 0 : t.left),
    right: t.right === !1 ? e.width : o.right + (t.right === !0 ? 0 : t.right),
    top: t.top === !1 ? 0 : o.top - (t.top === !0 ? 0 : t.top),
    bottom: t.bottom === !1 ? e.height : o.bottom + (t.bottom === !0 ? 0 : t.bottom)
  };
}
/*!
 * Chart.js v4.4.9
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class cw {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(n, t, o, i) {
    const r = t.listeners[i], a = t.duration;
    r.forEach((l) => l({
      chart: n,
      initial: t.initial,
      numSteps: a,
      currentStep: Math.min(o - t.start, a)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = Df.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(n = Date.now()) {
    let t = 0;
    this._charts.forEach((o, i) => {
      if (!o.running || !o.items.length)
        return;
      const r = o.items;
      let a = r.length - 1, l = !1, s;
      for (; a >= 0; --a)
        s = r[a], s._active ? (s._total > o.duration && (o.duration = s._total), s.tick(n), l = !0) : (r[a] = r[r.length - 1], r.pop());
      l && (i.draw(), this._notify(i, o, n, "progress")), r.length || (o.running = !1, this._notify(i, o, n, "complete"), o.initial = !1), t += r.length;
    }), this._lastDate = n, t === 0 && (this._running = !1);
  }
  _getAnims(n) {
    const t = this._charts;
    let o = t.get(n);
    return o || (o = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, t.set(n, o)), o;
  }
  listen(n, t, o) {
    this._getAnims(n).listeners[t].push(o);
  }
  add(n, t) {
    !t || !t.length || this._getAnims(n).items.push(...t);
  }
  has(n) {
    return this._getAnims(n).items.length > 0;
  }
  start(n) {
    const t = this._charts.get(n);
    t && (t.running = !0, t.start = Date.now(), t.duration = t.items.reduce((o, i) => Math.max(o, i._duration), 0), this._refresh());
  }
  running(n) {
    if (!this._running)
      return !1;
    const t = this._charts.get(n);
    return !(!t || !t.running || !t.items.length);
  }
  stop(n) {
    const t = this._charts.get(n);
    if (!t || !t.items.length)
      return;
    const o = t.items;
    let i = o.length - 1;
    for (; i >= 0; --i)
      o[i].cancel();
    t.items = [], this._notify(n, t, Date.now(), "complete");
  }
  remove(n) {
    return this._charts.delete(n);
  }
}
var On = /* @__PURE__ */ new cw();
const Gd = "transparent", fw = {
  boolean(e, n, t) {
    return t > 0.5 ? n : e;
  },
  color(e, n, t) {
    const o = jd(e || Gd), i = o.valid && jd(n || Gd);
    return i && i.valid ? i.mix(o, t).hexString() : n;
  },
  number(e, n, t) {
    return e + (n - e) * t;
  }
};
class hw {
  constructor(n, t, o, i) {
    const r = t[o];
    i = mr([
      n.to,
      i,
      r,
      n.from
    ]);
    const a = mr([
      n.from,
      r,
      i
    ]);
    this._active = !0, this._fn = n.fn || fw[n.type || typeof a], this._easing = xi[n.easing] || xi.linear, this._start = Math.floor(Date.now() + (n.delay || 0)), this._duration = this._total = Math.floor(n.duration), this._loop = !!n.loop, this._target = t, this._prop = o, this._from = a, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(n, t, o) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], r = o - this._start, a = this._duration - r;
      this._start = o, this._duration = Math.floor(Math.max(a, n.duration)), this._total += r, this._loop = !!n.loop, this._to = mr([
        n.to,
        t,
        i,
        n.from
      ]), this._from = mr([
        n.from,
        i,
        t
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(n) {
    const t = n - this._start, o = this._duration, i = this._prop, r = this._from, a = this._loop, l = this._to;
    let s;
    if (this._active = r !== l && (a || t < o), !this._active) {
      this._target[i] = l, this._notify(!0);
      return;
    }
    if (t < 0) {
      this._target[i] = r;
      return;
    }
    s = t / o % 2, s = a && s > 1 ? 2 - s : s, s = this._easing(Math.min(1, Math.max(0, s))), this._target[i] = this._fn(r, l, s);
  }
  wait() {
    const n = this._promises || (this._promises = []);
    return new Promise((t, o) => {
      n.push({
        res: t,
        rej: o
      });
    });
  }
  _notify(n) {
    const t = n ? "res" : "rej", o = this._promises || [];
    for (let i = 0; i < o.length; i++)
      o[i][t]();
  }
}
class Wf {
  constructor(n, t) {
    this._chart = n, this._properties = /* @__PURE__ */ new Map(), this.configure(t);
  }
  configure(n) {
    if (!Ue(n))
      return;
    const t = Object.keys(gt.animation), o = this._properties;
    Object.getOwnPropertyNames(n).forEach((i) => {
      const r = n[i];
      if (!Ue(r))
        return;
      const a = {};
      for (const l of t)
        a[l] = r[l];
      (dt(r.properties) && r.properties || [
        i
      ]).forEach((l) => {
        (l === i || !o.has(l)) && o.set(l, a);
      });
    });
  }
  _animateOptions(n, t) {
    const o = t.options, i = mw(n, o);
    if (!i)
      return [];
    const r = this._createAnimations(i, o);
    return o.$shared && gw(n.options.$animations, o).then(() => {
      n.options = o;
    }, () => {
    }), r;
  }
  _createAnimations(n, t) {
    const o = this._properties, i = [], r = n.$animations || (n.$animations = {}), a = Object.keys(t), l = Date.now();
    let s;
    for (s = a.length - 1; s >= 0; --s) {
      const u = a[s];
      if (u.charAt(0) === "$")
        continue;
      if (u === "options") {
        i.push(...this._animateOptions(n, t));
        continue;
      }
      const d = t[u];
      let f = r[u];
      const c = o.get(u);
      if (f)
        if (c && f.active()) {
          f.update(c, d, l);
          continue;
        } else
          f.cancel();
      if (!c || !c.duration) {
        n[u] = d;
        continue;
      }
      r[u] = f = new hw(c, n, u, d), i.push(f);
    }
    return i;
  }
  update(n, t) {
    if (this._properties.size === 0) {
      Object.assign(n, t);
      return;
    }
    const o = this._createAnimations(n, t);
    if (o.length)
      return On.add(this._chart, o), !0;
  }
}
function gw(e, n) {
  const t = [], o = Object.keys(n);
  for (let i = 0; i < o.length; i++) {
    const r = e[o[i]];
    r && r.active() && t.push(r.wait());
  }
  return Promise.all(t);
}
function mw(e, n) {
  if (!n)
    return;
  let t = e.options;
  if (!t) {
    e.options = n;
    return;
  }
  return t.$shared && (e.options = t = Object.assign({}, t, {
    $shared: !1,
    $animations: {}
  })), t;
}
function Zd(e, n) {
  const t = e && e.options || {}, o = t.reverse, i = t.min === void 0 ? n : 0, r = t.max === void 0 ? n : 0;
  return {
    start: o ? r : i,
    end: o ? i : r
  };
}
function pw(e, n, t) {
  if (t === !1)
    return !1;
  const o = Zd(e, t), i = Zd(n, t);
  return {
    top: i.end,
    right: o.end,
    bottom: i.start,
    left: o.start
  };
}
function vw(e) {
  let n, t, o, i;
  return Ue(e) ? (n = e.top, t = e.right, o = e.bottom, i = e.left) : n = t = o = i = e, {
    top: n,
    right: t,
    bottom: o,
    left: i,
    disabled: e === !1
  };
}
function Kf(e, n) {
  const t = [], o = e._getSortedDatasetMetas(n);
  let i, r;
  for (i = 0, r = o.length; i < r; ++i)
    t.push(o[i].index);
  return t;
}
function Xd(e, n, t, o = {}) {
  const i = e.keys, r = o.mode === "single";
  let a, l, s, u;
  if (n === null)
    return;
  let d = !1;
  for (a = 0, l = i.length; a < l; ++a) {
    if (s = +i[a], s === t) {
      if (d = !0, o.all)
        continue;
      break;
    }
    u = e.values[s], _t(u) && (r || n === 0 || Zr(n) === Zr(u)) && (n += u);
  }
  return !d && !o.all ? 0 : n;
}
function bw(e, n) {
  const { iScale: t, vScale: o } = n, i = t.axis === "x" ? "x" : "y", r = o.axis === "x" ? "x" : "y", a = Object.keys(e), l = new Array(a.length);
  let s, u, d;
  for (s = 0, u = a.length; s < u; ++s)
    d = a[s], l[s] = {
      [i]: d,
      [r]: e[d]
    };
  return l;
}
function tl(e, n) {
  const t = e && e.options.stacked;
  return t || t === void 0 && n.stack !== void 0;
}
function yw(e, n, t) {
  return `${e.id}.${n.id}.${t.stack || t.type}`;
}
function Cw(e) {
  const { min: n, max: t, minDefined: o, maxDefined: i } = e.getUserBounds();
  return {
    min: o ? n : Number.NEGATIVE_INFINITY,
    max: i ? t : Number.POSITIVE_INFINITY
  };
}
function xw(e, n, t) {
  const o = e[n] || (e[n] = {});
  return o[t] || (o[t] = {});
}
function Jd(e, n, t, o) {
  for (const i of n.getMatchingVisibleMetas(o).reverse()) {
    const r = e[i.index];
    if (t && r > 0 || !t && r < 0)
      return i.index;
  }
  return null;
}
function Qd(e, n) {
  const { chart: t, _cachedMeta: o } = e, i = t._stacks || (t._stacks = {}), { iScale: r, vScale: a, index: l } = o, s = r.axis, u = a.axis, d = yw(r, a, o), f = n.length;
  let c;
  for (let h = 0; h < f; ++h) {
    const m = n[h], { [s]: g, [u]: v } = m, p = m._stacks || (m._stacks = {});
    c = p[u] = xw(i, d, g), c[l] = v, c._top = Jd(c, a, !0, o.type), c._bottom = Jd(c, a, !1, o.type);
    const y = c._visualValues || (c._visualValues = {});
    y[l] = v;
  }
}
function nl(e, n) {
  const t = e.scales;
  return Object.keys(t).filter((o) => t[o].axis === n).shift();
}
function ww(e, n) {
  return ko(e, {
    active: !1,
    dataset: void 0,
    datasetIndex: n,
    index: n,
    mode: "default",
    type: "dataset"
  });
}
function $w(e, n, t) {
  return ko(e, {
    active: !1,
    dataIndex: n,
    parsed: void 0,
    raw: void 0,
    element: t,
    index: n,
    mode: "default",
    type: "data"
  });
}
function ri(e, n) {
  const t = e.controller.index, o = e.vScale && e.vScale.axis;
  if (o) {
    n = n || e._parsed;
    for (const i of n) {
      const r = i._stacks;
      if (!r || r[o] === void 0 || r[o][t] === void 0)
        return;
      delete r[o][t], r[o]._visualValues !== void 0 && r[o]._visualValues[t] !== void 0 && delete r[o]._visualValues[t];
    }
  }
}
const ol = (e) => e === "reset" || e === "none", ec = (e, n) => n ? e : Object.assign({}, e), kw = (e, n, t) => e && !n.hidden && n._stacked && {
  keys: Kf(t, !0),
  values: null
};
class $i {
  constructor(n, t) {
    this.chart = n, this._ctx = n.ctx, this.index = t, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const n = this._cachedMeta;
    this.configure(), this.linkScales(), n._stacked = tl(n.vScale, n), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(n) {
    this.index !== n && ri(this._cachedMeta), this.index = n;
  }
  linkScales() {
    const n = this.chart, t = this._cachedMeta, o = this.getDataset(), i = (f, c, h, m) => f === "x" ? c : f === "r" ? m : h, r = t.xAxisID = Je(o.xAxisID, nl(n, "x")), a = t.yAxisID = Je(o.yAxisID, nl(n, "y")), l = t.rAxisID = Je(o.rAxisID, nl(n, "r")), s = t.indexAxis, u = t.iAxisID = i(s, r, a, l), d = t.vAxisID = i(s, a, r, l);
    t.xScale = this.getScaleForId(r), t.yScale = this.getScaleForId(a), t.rScale = this.getScaleForId(l), t.iScale = this.getScaleForId(u), t.vScale = this.getScaleForId(d);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(n) {
    return this.chart.scales[n];
  }
  _getOtherScale(n) {
    const t = this._cachedMeta;
    return n === t.iScale ? t.vScale : t.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const n = this._cachedMeta;
    this._data && Rd(this._data, this), n._stacked && ri(n);
  }
  _dataCheck() {
    const n = this.getDataset(), t = n.data || (n.data = []), o = this._data;
    if (Ue(t)) {
      const i = this._cachedMeta;
      this._data = bw(t, i);
    } else if (o !== t) {
      if (o) {
        Rd(o, this);
        const i = this._cachedMeta;
        ri(i), i._parsed = [];
      }
      t && Object.isExtensible(t) && $x(t, this), this._syncList = [], this._data = t;
    }
  }
  addElements() {
    const n = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (n.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(n) {
    const t = this._cachedMeta, o = this.getDataset();
    let i = !1;
    this._dataCheck();
    const r = t._stacked;
    t._stacked = tl(t.vScale, t), t.stack !== o.stack && (i = !0, ri(t), t.stack = o.stack), this._resyncElements(n), (i || r !== t._stacked) && (Qd(this, t._parsed), t._stacked = tl(t.vScale, t));
  }
  configure() {
    const n = this.chart.config, t = n.datasetScopeKeys(this._type), o = n.getOptionScopes(this.getDataset(), t, !0);
    this.options = n.createResolver(o, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(n, t) {
    const { _cachedMeta: o, _data: i } = this, { iScale: r, _stacked: a } = o, l = r.axis;
    let s = n === 0 && t === i.length ? !0 : o._sorted, u = n > 0 && o._parsed[n - 1], d, f, c;
    if (this._parsing === !1)
      o._parsed = i, o._sorted = !0, c = i;
    else {
      dt(i[n]) ? c = this.parseArrayData(o, i, n, t) : Ue(i[n]) ? c = this.parseObjectData(o, i, n, t) : c = this.parsePrimitiveData(o, i, n, t);
      const h = () => f[l] === null || u && f[l] < u[l];
      for (d = 0; d < t; ++d)
        o._parsed[d + n] = f = c[d], s && (h() && (s = !1), u = f);
      o._sorted = s;
    }
    a && Qd(this, c);
  }
  parsePrimitiveData(n, t, o, i) {
    const { iScale: r, vScale: a } = n, l = r.axis, s = a.axis, u = r.getLabels(), d = r === a, f = new Array(i);
    let c, h, m;
    for (c = 0, h = i; c < h; ++c)
      m = c + o, f[c] = {
        [l]: d || r.parse(u[m], m),
        [s]: a.parse(t[m], m)
      };
    return f;
  }
  parseArrayData(n, t, o, i) {
    const { xScale: r, yScale: a } = n, l = new Array(i);
    let s, u, d, f;
    for (s = 0, u = i; s < u; ++s)
      d = s + o, f = t[d], l[s] = {
        x: r.parse(f[0], d),
        y: a.parse(f[1], d)
      };
    return l;
  }
  parseObjectData(n, t, o, i) {
    const { xScale: r, yScale: a } = n, { xAxisKey: l = "x", yAxisKey: s = "y" } = this._parsing, u = new Array(i);
    let d, f, c, h;
    for (d = 0, f = i; d < f; ++d)
      c = d + o, h = t[c], u[d] = {
        x: r.parse(Li(h, l), c),
        y: a.parse(Li(h, s), c)
      };
    return u;
  }
  getParsed(n) {
    return this._cachedMeta._parsed[n];
  }
  getDataElement(n) {
    return this._cachedMeta.data[n];
  }
  applyStack(n, t, o) {
    const i = this.chart, r = this._cachedMeta, a = t[n.axis], l = {
      keys: Kf(i, !0),
      values: t._stacks[n.axis]._visualValues
    };
    return Xd(l, a, r.index, {
      mode: o
    });
  }
  updateRangeFromParsed(n, t, o, i) {
    const r = o[t.axis];
    let a = r === null ? NaN : r;
    const l = i && o._stacks[t.axis];
    i && l && (i.values = l, a = Xd(i, r, this._cachedMeta.index)), n.min = Math.min(n.min, a), n.max = Math.max(n.max, a);
  }
  getMinMax(n, t) {
    const o = this._cachedMeta, i = o._parsed, r = o._sorted && n === o.iScale, a = i.length, l = this._getOtherScale(n), s = kw(t, o, this.chart), u = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: d, max: f } = Cw(l);
    let c, h;
    function m() {
      h = i[c];
      const g = h[l.axis];
      return !_t(h[n.axis]) || d > g || f < g;
    }
    for (c = 0; c < a && !(!m() && (this.updateRangeFromParsed(u, n, h, s), r)); ++c)
      ;
    if (r) {
      for (c = a - 1; c >= 0; --c)
        if (!m()) {
          this.updateRangeFromParsed(u, n, h, s);
          break;
        }
    }
    return u;
  }
  getAllParsedValues(n) {
    const t = this._cachedMeta._parsed, o = [];
    let i, r, a;
    for (i = 0, r = t.length; i < r; ++i)
      a = t[i][n.axis], _t(a) && o.push(a);
    return o;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(n) {
    const t = this._cachedMeta, o = t.iScale, i = t.vScale, r = this.getParsed(n);
    return {
      label: o ? "" + o.getLabelForValue(r[o.axis]) : "",
      value: i ? "" + i.getLabelForValue(r[i.axis]) : ""
    };
  }
  _update(n) {
    const t = this._cachedMeta;
    this.update(n || "default"), t._clip = vw(Je(this.options.clip, pw(t.xScale, t.yScale, this.getMaxOverflow())));
  }
  update(n) {
  }
  draw() {
    const n = this._ctx, t = this.chart, o = this._cachedMeta, i = o.data || [], r = t.chartArea, a = [], l = this._drawStart || 0, s = this._drawCount || i.length - l, u = this.options.drawActiveElementsOnTop;
    let d;
    for (o.dataset && o.dataset.draw(n, r, l, s), d = l; d < l + s; ++d) {
      const f = i[d];
      f.hidden || (f.active && u ? a.push(f) : f.draw(n, r));
    }
    for (d = 0; d < a.length; ++d)
      a[d].draw(n, r);
  }
  getStyle(n, t) {
    const o = t ? "active" : "default";
    return n === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(o) : this.resolveDataElementOptions(n || 0, o);
  }
  getContext(n, t, o) {
    const i = this.getDataset();
    let r;
    if (n >= 0 && n < this._cachedMeta.data.length) {
      const a = this._cachedMeta.data[n];
      r = a.$context || (a.$context = $w(this.getContext(), n, a)), r.parsed = this.getParsed(n), r.raw = i.data[n], r.index = r.dataIndex = n;
    } else
      r = this.$context || (this.$context = ww(this.chart.getContext(), this.index)), r.dataset = i, r.index = r.datasetIndex = this.index;
    return r.active = !!t, r.mode = o, r;
  }
  resolveDatasetElementOptions(n) {
    return this._resolveElementOptions(this.datasetElementType.id, n);
  }
  resolveDataElementOptions(n, t) {
    return this._resolveElementOptions(this.dataElementType.id, t, n);
  }
  _resolveElementOptions(n, t = "default", o) {
    const i = t === "active", r = this._cachedDataOpts, a = n + "-" + t, l = r[a], s = this.enableOptionSharing && Yr(o);
    if (l)
      return ec(l, s);
    const u = this.chart.config, d = u.datasetElementScopeKeys(this._type, n), f = i ? [
      `${n}Hover`,
      "hover",
      n,
      ""
    ] : [
      n,
      ""
    ], c = u.getOptionScopes(this.getDataset(), d), h = Object.keys(gt.elements[n]), m = () => this.getContext(o, i, t), g = u.resolveNamedOptions(c, h, m, f);
    return g.$shared && (g.$shared = s, r[a] = Object.freeze(ec(g, s))), g;
  }
  _resolveAnimations(n, t, o) {
    const i = this.chart, r = this._cachedDataOpts, a = `animation-${t}`, l = r[a];
    if (l)
      return l;
    let s;
    if (i.options.animation !== !1) {
      const d = this.chart.config, f = d.datasetAnimationScopeKeys(this._type, t), c = d.getOptionScopes(this.getDataset(), f);
      s = d.createResolver(c, this.getContext(n, o, t));
    }
    const u = new Wf(i, s && s.animations);
    return s && s._cacheable && (r[a] = Object.freeze(u)), u;
  }
  getSharedOptions(n) {
    if (n.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, n));
  }
  includeOptions(n, t) {
    return !t || ol(n) || this.chart._animationsDisabled;
  }
  _getSharedOptions(n, t) {
    const o = this.resolveDataElementOptions(n, t), i = this._sharedOptions, r = this.getSharedOptions(o), a = this.includeOptions(t, r) || r !== i;
    return this.updateSharedOptions(r, t, o), {
      sharedOptions: r,
      includeOptions: a
    };
  }
  updateElement(n, t, o, i) {
    ol(i) ? Object.assign(n, o) : this._resolveAnimations(t, i).update(n, o);
  }
  updateSharedOptions(n, t, o) {
    n && !ol(t) && this._resolveAnimations(void 0, t).update(n, o);
  }
  _setStyle(n, t, o, i) {
    n.active = i;
    const r = this.getStyle(t, i);
    this._resolveAnimations(t, o, i).update(n, {
      options: !i && this.getSharedOptions(r) || r
    });
  }
  removeHoverStyle(n, t, o) {
    this._setStyle(n, o, "active", !1);
  }
  setHoverStyle(n, t, o) {
    this._setStyle(n, o, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const n = this._cachedMeta.dataset;
    n && this._setStyle(n, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const n = this._cachedMeta.dataset;
    n && this._setStyle(n, void 0, "active", !0);
  }
  _resyncElements(n) {
    const t = this._data, o = this._cachedMeta.data;
    for (const [l, s, u] of this._syncList)
      this[l](s, u);
    this._syncList = [];
    const i = o.length, r = t.length, a = Math.min(r, i);
    a && this.parse(0, a), r > i ? this._insertElements(i, r - i, n) : r < i && this._removeElements(r, i - r);
  }
  _insertElements(n, t, o = !0) {
    const i = this._cachedMeta, r = i.data, a = n + t;
    let l;
    const s = (u) => {
      for (u.length += t, l = u.length - 1; l >= a; l--)
        u[l] = u[l - t];
    };
    for (s(r), l = n; l < a; ++l)
      r[l] = new this.dataElementType();
    this._parsing && s(i._parsed), this.parse(n, t), o && this.updateElements(r, n, t, "reset");
  }
  updateElements(n, t, o, i) {
  }
  _removeElements(n, t) {
    const o = this._cachedMeta;
    if (this._parsing) {
      const i = o._parsed.splice(n, t);
      o._stacked && ri(o, i);
    }
    o.data.splice(n, t);
  }
  _sync(n) {
    if (this._parsing)
      this._syncList.push(n);
    else {
      const [t, o, i] = n;
      this[t](o, i);
    }
    this.chart._dataChanges.push([
      this.index,
      ...n
    ]);
  }
  _onDataPush() {
    const n = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - n,
      n
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(n, t) {
    t && this._sync([
      "_removeElements",
      n,
      t
    ]);
    const o = arguments.length - 2;
    o && this._sync([
      "_insertElements",
      n,
      o
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
Ee($i, "defaults", {}), Ee($i, "datasetElementType", null), Ee($i, "dataElementType", null);
function _w(e, n, t) {
  let o = 1, i = 1, r = 0, a = 0;
  if (n < ht) {
    const l = e, s = l + n, u = Math.cos(l), d = Math.sin(l), f = Math.cos(s), c = Math.sin(s), h = (C, b, x) => Jr(C, l, s, !0) ? 1 : Math.max(b, b * t, x, x * t), m = (C, b, x) => Jr(C, l, s, !0) ? -1 : Math.min(b, b * t, x, x * t), g = h(0, u, f), v = h(vt, d, c), p = m(mt, u, f), y = m(mt + vt, d, c);
    o = (g - p) / 2, i = (v - y) / 2, r = -(g + p) / 2, a = -(v + y) / 2;
  }
  return {
    ratioX: o,
    ratioY: i,
    offsetX: r,
    offsetY: a
  };
}
class hi extends $i {
  constructor(n, t) {
    super(n, t), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(n, t) {
    const o = this.getDataset().data, i = this._cachedMeta;
    if (this._parsing === !1)
      i._parsed = o;
    else {
      let r = (s) => +o[s];
      if (Ue(o[n])) {
        const { key: s = "value" } = this._parsing;
        r = (u) => +Li(o[u], s);
      }
      let a, l;
      for (a = n, l = n + t; a < l; ++a)
        i._parsed[a] = r(a);
    }
  }
  _getRotation() {
    return mn(this.options.rotation - 90);
  }
  _getCircumference() {
    return mn(this.options.circumference);
  }
  _getRotationExtents() {
    let n = ht, t = -ht;
    for (let o = 0; o < this.chart.data.datasets.length; ++o)
      if (this.chart.isDatasetVisible(o) && this.chart.getDatasetMeta(o).type === this._type) {
        const i = this.chart.getDatasetMeta(o).controller, r = i._getRotation(), a = i._getCircumference();
        n = Math.min(n, r), t = Math.max(t, r + a);
      }
    return {
      rotation: n,
      circumference: t - n
    };
  }
  update(n) {
    const t = this.chart, { chartArea: o } = t, i = this._cachedMeta, r = i.data, a = this.getMaxBorderWidth() + this.getMaxOffset(r) + this.options.spacing, l = Math.max((Math.min(o.width, o.height) - a) / 2, 0), s = Math.min(ux(this.options.cutout, l), 1), u = this._getRingWeight(this.index), { circumference: d, rotation: f } = this._getRotationExtents(), { ratioX: c, ratioY: h, offsetX: m, offsetY: g } = _w(f, d, s), v = (o.width - a) / c, p = (o.height - a) / h, y = Math.max(Math.min(v, p) / 2, 0), C = Sf(this.options.radius, y), b = Math.max(C * s, 0), x = (C - b) / this._getVisibleDatasetWeightTotal();
    this.offsetX = m * C, this.offsetY = g * C, i.total = this.calculateTotal(), this.outerRadius = C - x * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - x * u, 0), this.updateElements(r, 0, r.length, n);
  }
  _circumference(n, t) {
    const o = this.options, i = this._cachedMeta, r = this._getCircumference();
    return t && o.animation.animateRotate || !this.chart.getDataVisibility(n) || i._parsed[n] === null || i.data[n].hidden ? 0 : this.calculateCircumference(i._parsed[n] * r / ht);
  }
  updateElements(n, t, o, i) {
    const r = i === "reset", a = this.chart, l = a.chartArea, u = a.options.animation, d = (l.left + l.right) / 2, f = (l.top + l.bottom) / 2, c = r && u.animateScale, h = c ? 0 : this.innerRadius, m = c ? 0 : this.outerRadius, { sharedOptions: g, includeOptions: v } = this._getSharedOptions(t, i);
    let p = this._getRotation(), y;
    for (y = 0; y < t; ++y)
      p += this._circumference(y, r);
    for (y = t; y < t + o; ++y) {
      const C = this._circumference(y, r), b = n[y], x = {
        x: d + this.offsetX,
        y: f + this.offsetY,
        startAngle: p,
        endAngle: p + C,
        circumference: C,
        outerRadius: m,
        innerRadius: h
      };
      v && (x.options = g || this.resolveDataElementOptions(y, b.active ? "active" : i)), p += C, this.updateElement(b, y, x, i);
    }
  }
  calculateTotal() {
    const n = this._cachedMeta, t = n.data;
    let o = 0, i;
    for (i = 0; i < t.length; i++) {
      const r = n._parsed[i];
      r !== null && !isNaN(r) && this.chart.getDataVisibility(i) && !t[i].hidden && (o += Math.abs(r));
    }
    return o;
  }
  calculateCircumference(n) {
    const t = this._cachedMeta.total;
    return t > 0 && !isNaN(n) ? ht * (Math.abs(n) / t) : 0;
  }
  getLabelAndValue(n) {
    const t = this._cachedMeta, o = this.chart, i = o.data.labels || [], r = ya(t._parsed[n], o.options.locale);
    return {
      label: i[n] || "",
      value: r
    };
  }
  getMaxBorderWidth(n) {
    let t = 0;
    const o = this.chart;
    let i, r, a, l, s;
    if (!n) {
      for (i = 0, r = o.data.datasets.length; i < r; ++i)
        if (o.isDatasetVisible(i)) {
          a = o.getDatasetMeta(i), n = a.data, l = a.controller;
          break;
        }
    }
    if (!n)
      return 0;
    for (i = 0, r = n.length; i < r; ++i)
      s = l.resolveDataElementOptions(i), s.borderAlign !== "inner" && (t = Math.max(t, s.borderWidth || 0, s.hoverBorderWidth || 0));
    return t;
  }
  getMaxOffset(n) {
    let t = 0;
    for (let o = 0, i = n.length; o < i; ++o) {
      const r = this.resolveDataElementOptions(o);
      t = Math.max(t, r.offset || 0, r.hoverOffset || 0);
    }
    return t;
  }
  _getRingWeightOffset(n) {
    let t = 0;
    for (let o = 0; o < n; ++o)
      this.chart.isDatasetVisible(o) && (t += this._getRingWeight(o));
    return t;
  }
  _getRingWeight(n) {
    return Math.max(Je(this.chart.data.datasets[n].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
Ee(hi, "id", "doughnut"), Ee(hi, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), Ee(hi, "descriptors", {
  _scriptable: (n) => n !== "spacing",
  _indexable: (n) => n !== "spacing" && !n.startsWith("borderDash") && !n.startsWith("hoverBorderDash")
}), Ee(hi, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(n) {
          const t = n.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: o, color: i } } = n.legend.options;
            return t.labels.map((r, a) => {
              const s = n.getDatasetMeta(0).controller.getStyle(a);
              return {
                text: r,
                fillStyle: s.backgroundColor,
                strokeStyle: s.borderColor,
                fontColor: i,
                lineWidth: s.borderWidth,
                pointStyle: o,
                hidden: !n.getDataVisibility(a),
                index: a
              };
            });
          }
          return [];
        }
      },
      onClick(n, t, o) {
        o.chart.toggleDataVisibility(t.index), o.chart.update();
      }
    }
  }
});
function lo() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Hs {
  constructor(n) {
    Ee(this, "options");
    this.options = n || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(n) {
    Object.assign(Hs.prototype, n);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return lo();
  }
  parse() {
    return lo();
  }
  format() {
    return lo();
  }
  add() {
    return lo();
  }
  diff() {
    return lo();
  }
  startOf() {
    return lo();
  }
  endOf() {
    return lo();
  }
}
var Ow = {
  _date: Hs
};
function Ew(e, n, t, o) {
  const { controller: i, data: r, _sorted: a } = e, l = i._cachedMeta.iScale, s = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null;
  if (l && n === l.axis && n !== "r" && a && r.length) {
    const u = l._reversePixels ? xx : Hl;
    if (o) {
      if (i._sharedOptions) {
        const d = r[0], f = typeof d.getRange == "function" && d.getRange(n);
        if (f) {
          const c = u(r, n, t - f), h = u(r, n, t + f);
          return {
            lo: c.lo,
            hi: h.hi
          };
        }
      }
    } else {
      const d = u(r, n, t);
      if (s) {
        const { vScale: f } = i._cachedMeta, { _parsed: c } = e, h = c.slice(0, d.lo + 1).reverse().findIndex((g) => !lt(g[f.axis]));
        d.lo -= Math.max(0, h);
        const m = c.slice(d.hi).findIndex((g) => !lt(g[f.axis]));
        d.hi += Math.max(0, m);
      }
      return d;
    }
  }
  return {
    lo: 0,
    hi: r.length - 1
  };
}
function Zi(e, n, t, o, i) {
  const r = e.getSortedVisibleDatasetMetas(), a = t[n];
  for (let l = 0, s = r.length; l < s; ++l) {
    const { index: u, data: d } = r[l], { lo: f, hi: c } = Ew(r[l], n, a, i);
    for (let h = f; h <= c; ++h) {
      const m = d[h];
      m.skip || o(m, u, h);
    }
  }
}
function Mw(e) {
  const n = e.indexOf("x") !== -1, t = e.indexOf("y") !== -1;
  return function(o, i) {
    const r = n ? Math.abs(o.x - i.x) : 0, a = t ? Math.abs(o.y - i.y) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(a, 2));
  };
}
function il(e, n, t, o, i) {
  const r = [];
  return !i && !e.isPointInArea(n) || Zi(e, t, n, function(l, s, u) {
    !i && !Bo(l, e.chartArea, 0) || l.inRange(n.x, n.y, o) && r.push({
      element: l,
      datasetIndex: s,
      index: u
    });
  }, !0), r;
}
function Sw(e, n, t, o) {
  let i = [];
  function r(a, l, s) {
    const { startAngle: u, endAngle: d } = a.getProps([
      "startAngle",
      "endAngle"
    ], o), { angle: f } = Pf(a, {
      x: n.x,
      y: n.y
    });
    Jr(f, u, d) && i.push({
      element: a,
      datasetIndex: l,
      index: s
    });
  }
  return Zi(e, t, n, r), i;
}
function Aw(e, n, t, o, i, r) {
  let a = [];
  const l = Mw(t);
  let s = Number.POSITIVE_INFINITY;
  function u(d, f, c) {
    const h = d.inRange(n.x, n.y, i);
    if (o && !h)
      return;
    const m = d.getCenterPoint(i);
    if (!(!!r || e.isPointInArea(m)) && !h)
      return;
    const v = l(n, m);
    v < s ? (a = [
      {
        element: d,
        datasetIndex: f,
        index: c
      }
    ], s = v) : v === s && a.push({
      element: d,
      datasetIndex: f,
      index: c
    });
  }
  return Zi(e, t, n, u), a;
}
function rl(e, n, t, o, i, r) {
  return !r && !e.isPointInArea(n) ? [] : t === "r" && !o ? Sw(e, n, t, i) : Aw(e, n, t, o, i, r);
}
function tc(e, n, t, o, i) {
  const r = [], a = t === "x" ? "inXRange" : "inYRange";
  let l = !1;
  return Zi(e, t, n, (s, u, d) => {
    s[a] && s[a](n[t], i) && (r.push({
      element: s,
      datasetIndex: u,
      index: d
    }), l = l || s.inRange(n.x, n.y, i));
  }), o && !l ? [] : r;
}
var Tw = {
  evaluateInteractionItems: Zi,
  modes: {
    index(e, n, t, o) {
      const i = uo(n, e), r = t.axis || "x", a = t.includeInvisible || !1, l = t.intersect ? il(e, i, r, o, a) : rl(e, i, r, !1, o, a), s = [];
      return l.length ? (e.getSortedVisibleDatasetMetas().forEach((u) => {
        const d = l[0].index, f = u.data[d];
        f && !f.skip && s.push({
          element: f,
          datasetIndex: u.index,
          index: d
        });
      }), s) : [];
    },
    dataset(e, n, t, o) {
      const i = uo(n, e), r = t.axis || "xy", a = t.includeInvisible || !1;
      let l = t.intersect ? il(e, i, r, o, a) : rl(e, i, r, !1, o, a);
      if (l.length > 0) {
        const s = l[0].datasetIndex, u = e.getDatasetMeta(s).data;
        l = [];
        for (let d = 0; d < u.length; ++d)
          l.push({
            element: u[d],
            datasetIndex: s,
            index: d
          });
      }
      return l;
    },
    point(e, n, t, o) {
      const i = uo(n, e), r = t.axis || "xy", a = t.includeInvisible || !1;
      return il(e, i, r, o, a);
    },
    nearest(e, n, t, o) {
      const i = uo(n, e), r = t.axis || "xy", a = t.includeInvisible || !1;
      return rl(e, i, r, t.intersect, o, a);
    },
    x(e, n, t, o) {
      const i = uo(n, e);
      return tc(e, i, "x", t.intersect, o);
    },
    y(e, n, t, o) {
      const i = uo(n, e);
      return tc(e, i, "y", t.intersect, o);
    }
  }
};
const Yf = [
  "left",
  "top",
  "right",
  "bottom"
];
function ai(e, n) {
  return e.filter((t) => t.pos === n);
}
function nc(e, n) {
  return e.filter((t) => Yf.indexOf(t.pos) === -1 && t.box.axis === n);
}
function li(e, n) {
  return e.sort((t, o) => {
    const i = n ? o : t, r = n ? t : o;
    return i.weight === r.weight ? i.index - r.index : i.weight - r.weight;
  });
}
function Pw(e) {
  const n = [];
  let t, o, i, r, a, l;
  for (t = 0, o = (e || []).length; t < o; ++t)
    i = e[t], { position: r, options: { stack: a, stackWeight: l = 1 } } = i, n.push({
      index: t,
      box: i,
      pos: r,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: a && r + a,
      stackWeight: l
    });
  return n;
}
function Iw(e) {
  const n = {};
  for (const t of e) {
    const { stack: o, pos: i, stackWeight: r } = t;
    if (!o || !Yf.includes(i))
      continue;
    const a = n[o] || (n[o] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    a.count++, a.weight += r;
  }
  return n;
}
function Dw(e, n) {
  const t = Iw(e), { vBoxMaxWidth: o, hBoxMaxHeight: i } = n;
  let r, a, l;
  for (r = 0, a = e.length; r < a; ++r) {
    l = e[r];
    const { fullSize: s } = l.box, u = t[l.stack], d = u && l.stackWeight / u.weight;
    l.horizontal ? (l.width = d ? d * o : s && n.availableWidth, l.height = i) : (l.width = o, l.height = d ? d * i : s && n.availableHeight);
  }
  return t;
}
function Lw(e) {
  const n = Pw(e), t = li(n.filter((u) => u.box.fullSize), !0), o = li(ai(n, "left"), !0), i = li(ai(n, "right")), r = li(ai(n, "top"), !0), a = li(ai(n, "bottom")), l = nc(n, "x"), s = nc(n, "y");
  return {
    fullSize: t,
    leftAndTop: o.concat(r),
    rightAndBottom: i.concat(s).concat(a).concat(l),
    chartArea: ai(n, "chartArea"),
    vertical: o.concat(i).concat(s),
    horizontal: r.concat(a).concat(l)
  };
}
function oc(e, n, t, o) {
  return Math.max(e[t], n[t]) + Math.max(e[o], n[o]);
}
function Gf(e, n) {
  e.top = Math.max(e.top, n.top), e.left = Math.max(e.left, n.left), e.bottom = Math.max(e.bottom, n.bottom), e.right = Math.max(e.right, n.right);
}
function Nw(e, n, t, o) {
  const { pos: i, box: r } = t, a = e.maxPadding;
  if (!Ue(i)) {
    t.size && (e[i] -= t.size);
    const f = o[t.stack] || {
      size: 0,
      count: 1
    };
    f.size = Math.max(f.size, t.horizontal ? r.height : r.width), t.size = f.size / f.count, e[i] += t.size;
  }
  r.getPadding && Gf(a, r.getPadding());
  const l = Math.max(0, n.outerWidth - oc(a, e, "left", "right")), s = Math.max(0, n.outerHeight - oc(a, e, "top", "bottom")), u = l !== e.w, d = s !== e.h;
  return e.w = l, e.h = s, t.horizontal ? {
    same: u,
    other: d
  } : {
    same: d,
    other: u
  };
}
function Fw(e) {
  const n = e.maxPadding;
  function t(o) {
    const i = Math.max(n[o] - e[o], 0);
    return e[o] += i, i;
  }
  e.y += t("top"), e.x += t("left"), t("right"), t("bottom");
}
function Rw(e, n) {
  const t = n.maxPadding;
  function o(i) {
    const r = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return i.forEach((a) => {
      r[a] = Math.max(n[a], t[a]);
    }), r;
  }
  return o(e ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function gi(e, n, t, o) {
  const i = [];
  let r, a, l, s, u, d;
  for (r = 0, a = e.length, u = 0; r < a; ++r) {
    l = e[r], s = l.box, s.update(l.width || n.w, l.height || n.h, Rw(l.horizontal, n));
    const { same: f, other: c } = Nw(n, t, l, o);
    u |= f && i.length, d = d || c, s.fullSize || i.push(l);
  }
  return u && gi(i, n, t, o) || d;
}
function br(e, n, t, o, i) {
  e.top = t, e.left = n, e.right = n + o, e.bottom = t + i, e.width = o, e.height = i;
}
function ic(e, n, t, o) {
  const i = t.padding;
  let { x: r, y: a } = n;
  for (const l of e) {
    const s = l.box, u = o[l.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, d = l.stackWeight / u.weight || 1;
    if (l.horizontal) {
      const f = n.w * d, c = u.size || s.height;
      Yr(u.start) && (a = u.start), s.fullSize ? br(s, i.left, a, t.outerWidth - i.right - i.left, c) : br(s, n.left + u.placed, a, f, c), u.start = a, u.placed += f, a = s.bottom;
    } else {
      const f = n.h * d, c = u.size || s.width;
      Yr(u.start) && (r = u.start), s.fullSize ? br(s, r, i.top, c, t.outerHeight - i.bottom - i.top) : br(s, r, n.top + u.placed, c, f), u.start = r, u.placed += f, r = s.right;
    }
  }
  n.x = r, n.y = a;
}
var en = {
  addBox(e, n) {
    e.boxes || (e.boxes = []), n.fullSize = n.fullSize || !1, n.position = n.position || "top", n.weight = n.weight || 0, n._layers = n._layers || function() {
      return [
        {
          z: 0,
          draw(t) {
            n.draw(t);
          }
        }
      ];
    }, e.boxes.push(n);
  },
  removeBox(e, n) {
    const t = e.boxes ? e.boxes.indexOf(n) : -1;
    t !== -1 && e.boxes.splice(t, 1);
  },
  configure(e, n, t) {
    n.fullSize = t.fullSize, n.position = t.position, n.weight = t.weight;
  },
  update(e, n, t, o) {
    if (!e)
      return;
    const i = It(e.options.layout.padding), r = Math.max(n - i.width, 0), a = Math.max(t - i.height, 0), l = Lw(e.boxes), s = l.vertical, u = l.horizontal;
    nt(e.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const d = s.reduce((g, v) => v.box.options && v.box.options.display === !1 ? g : g + 1, 0) || 1, f = Object.freeze({
      outerWidth: n,
      outerHeight: t,
      padding: i,
      availableWidth: r,
      availableHeight: a,
      vBoxMaxWidth: r / 2 / d,
      hBoxMaxHeight: a / 2
    }), c = Object.assign({}, i);
    Gf(c, It(o));
    const h = Object.assign({
      maxPadding: c,
      w: r,
      h: a,
      x: i.left,
      y: i.top
    }, i), m = Dw(s.concat(u), f);
    gi(l.fullSize, h, f, m), gi(s, h, f, m), gi(u, h, f, m) && gi(s, h, f, m), Fw(h), ic(l.leftAndTop, h, f, m), h.x += h.w, h.y += h.h, ic(l.rightAndBottom, h, f, m), e.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, nt(l.chartArea, (g) => {
      const v = g.box;
      Object.assign(v, e.chartArea), v.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Zf {
  acquireContext(n, t) {
  }
  releaseContext(n) {
    return !1;
  }
  addEventListener(n, t, o) {
  }
  removeEventListener(n, t, o) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(n, t, o, i) {
    return t = Math.max(0, t || n.width), o = o || n.height, {
      width: t,
      height: Math.max(0, i ? Math.floor(t / i) : o)
    };
  }
  isAttached(n) {
    return !0;
  }
  updateConfig(n) {
  }
}
class Bw extends Zf {
  acquireContext(n) {
    return n && n.getContext && n.getContext("2d") || null;
  }
  updateConfig(n) {
    n.options.animation = !1;
  }
}
const Dr = "$chartjs", Vw = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, rc = (e) => e === null || e === "";
function jw(e, n) {
  const t = e.style, o = e.getAttribute("height"), i = e.getAttribute("width");
  if (e[Dr] = {
    initial: {
      height: o,
      width: i,
      style: {
        display: t.display,
        height: t.height,
        width: t.width
      }
    }
  }, t.display = t.display || "block", t.boxSizing = t.boxSizing || "border-box", rc(i)) {
    const r = Yd(e, "width");
    r !== void 0 && (e.width = r);
  }
  if (rc(o))
    if (e.style.height === "")
      e.height = e.width / (n || 2);
    else {
      const r = Yd(e, "height");
      r !== void 0 && (e.height = r);
    }
  return e;
}
const Xf = aw ? {
  passive: !0
} : !1;
function Hw(e, n, t) {
  e && e.addEventListener(n, t, Xf);
}
function zw(e, n, t) {
  e && e.canvas && e.canvas.removeEventListener(n, t, Xf);
}
function qw(e, n) {
  const t = Vw[e.type] || e.type, { x: o, y: i } = uo(e, n);
  return {
    type: t,
    chart: n,
    native: e,
    x: o !== void 0 ? o : null,
    y: i !== void 0 ? i : null
  };
}
function ta(e, n) {
  for (const t of e)
    if (t === n || t.contains(n))
      return !0;
}
function Uw(e, n, t) {
  const o = e.canvas, i = new MutationObserver((r) => {
    let a = !1;
    for (const l of r)
      a = a || ta(l.addedNodes, o), a = a && !ta(l.removedNodes, o);
    a && t();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
function Ww(e, n, t) {
  const o = e.canvas, i = new MutationObserver((r) => {
    let a = !1;
    for (const l of r)
      a = a || ta(l.removedNodes, o), a = a && !ta(l.addedNodes, o);
    a && t();
  });
  return i.observe(document, {
    childList: !0,
    subtree: !0
  }), i;
}
const Fi = /* @__PURE__ */ new Map();
let ac = 0;
function Jf() {
  const e = window.devicePixelRatio;
  e !== ac && (ac = e, Fi.forEach((n, t) => {
    t.currentDevicePixelRatio !== e && n();
  }));
}
function Kw(e, n) {
  Fi.size || window.addEventListener("resize", Jf), Fi.set(e, n);
}
function Yw(e) {
  Fi.delete(e), Fi.size || window.removeEventListener("resize", Jf);
}
function Gw(e, n, t) {
  const o = e.canvas, i = o && js(o);
  if (!i)
    return;
  const r = Lf((l, s) => {
    const u = i.clientWidth;
    t(l, s), u < i.clientWidth && t();
  }, window), a = new ResizeObserver((l) => {
    const s = l[0], u = s.contentRect.width, d = s.contentRect.height;
    u === 0 && d === 0 || r(u, d);
  });
  return a.observe(i), Kw(e, r), a;
}
function al(e, n, t) {
  t && t.disconnect(), n === "resize" && Yw(e);
}
function Zw(e, n, t) {
  const o = e.canvas, i = Lf((r) => {
    e.ctx !== null && t(qw(r, e));
  }, e);
  return Hw(o, n, i), i;
}
class Xw extends Zf {
  acquireContext(n, t) {
    const o = n && n.getContext && n.getContext("2d");
    return o && o.canvas === n ? (jw(n, t), o) : null;
  }
  releaseContext(n) {
    const t = n.canvas;
    if (!t[Dr])
      return !1;
    const o = t[Dr].initial;
    [
      "height",
      "width"
    ].forEach((r) => {
      const a = o[r];
      lt(a) ? t.removeAttribute(r) : t.setAttribute(r, a);
    });
    const i = o.style || {};
    return Object.keys(i).forEach((r) => {
      t.style[r] = i[r];
    }), t.width = t.width, delete t[Dr], !0;
  }
  addEventListener(n, t, o) {
    this.removeEventListener(n, t);
    const i = n.$proxies || (n.$proxies = {}), a = {
      attach: Uw,
      detach: Ww,
      resize: Gw
    }[t] || Zw;
    i[t] = a(n, t, o);
  }
  removeEventListener(n, t) {
    const o = n.$proxies || (n.$proxies = {}), i = o[t];
    if (!i)
      return;
    ({
      attach: al,
      detach: al,
      resize: al
    }[t] || zw)(n, t, i), o[t] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(n, t, o, i) {
    return rw(n, t, o, i);
  }
  isAttached(n) {
    const t = n && js(n);
    return !!(t && t.isConnected);
  }
}
function Jw(e) {
  return !Vs() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? Bw : Xw;
}
var Ar;
let _o = (Ar = class {
  constructor() {
    Ee(this, "x");
    Ee(this, "y");
    Ee(this, "active", !1);
    Ee(this, "options");
    Ee(this, "$animations");
  }
  tooltipPosition(n) {
    const { x: t, y: o } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: t,
      y: o
    };
  }
  hasValue() {
    return Xr(this.x) && Xr(this.y);
  }
  getProps(n, t) {
    const o = this.$animations;
    if (!t || !o)
      return this;
    const i = {};
    return n.forEach((r) => {
      i[r] = o[r] && o[r].active() ? o[r]._to : this[r];
    }), i;
  }
}, Ee(Ar, "defaults", {}), Ee(Ar, "defaultRoutes"), Ar);
function Qw(e, n) {
  const t = e.options.ticks, o = e$(e), i = Math.min(t.maxTicksLimit || o, o), r = t.major.enabled ? n$(n) : [], a = r.length, l = r[0], s = r[a - 1], u = [];
  if (a > i)
    return o$(n, u, r, a / i), u;
  const d = t$(r, n, i);
  if (a > 0) {
    let f, c;
    const h = a > 1 ? Math.round((s - l) / (a - 1)) : null;
    for (yr(n, u, d, lt(h) ? 0 : l - h, l), f = 0, c = a - 1; f < c; f++)
      yr(n, u, d, r[f], r[f + 1]);
    return yr(n, u, d, s, lt(h) ? n.length : s + h), u;
  }
  return yr(n, u, d), u;
}
function e$(e) {
  const n = e.options.offset, t = e._tickSize(), o = e._length / t + (n ? 0 : 1), i = e._maxLength / t;
  return Math.floor(Math.min(o, i));
}
function t$(e, n, t) {
  const o = i$(e), i = n.length / t;
  if (!o)
    return Math.max(i, 1);
  const r = px(o);
  for (let a = 0, l = r.length - 1; a < l; a++) {
    const s = r[a];
    if (s > i)
      return s;
  }
  return Math.max(i, 1);
}
function n$(e) {
  const n = [];
  let t, o;
  for (t = 0, o = e.length; t < o; t++)
    e[t].major && n.push(t);
  return n;
}
function o$(e, n, t, o) {
  let i = 0, r = t[0], a;
  for (o = Math.ceil(o), a = 0; a < e.length; a++)
    a === r && (n.push(e[a]), i++, r = t[i * o]);
}
function yr(e, n, t, o, i) {
  const r = Je(o, 0), a = Math.min(Je(i, e.length), e.length);
  let l = 0, s, u, d;
  for (t = Math.ceil(t), i && (s = i - o, t = s / Math.floor(s / t)), d = r; d < 0; )
    l++, d = Math.round(r + l * t);
  for (u = Math.max(r, 0); u < a; u++)
    u === d && (n.push(e[u]), l++, d = Math.round(r + l * t));
}
function i$(e) {
  const n = e.length;
  let t, o;
  if (n < 2)
    return !1;
  for (o = e[0], t = 1; t < n; ++t)
    if (e[t] - e[t - 1] !== o)
      return !1;
  return o;
}
const r$ = (e) => e === "left" ? "right" : e === "right" ? "left" : e, lc = (e, n, t) => n === "top" || n === "left" ? e[n] + t : e[n] - t, sc = (e, n) => Math.min(n || e, e);
function uc(e, n) {
  const t = [], o = e.length / n, i = e.length;
  let r = 0;
  for (; r < i; r += o)
    t.push(e[Math.floor(r)]);
  return t;
}
function a$(e, n, t) {
  const o = e.ticks.length, i = Math.min(n, o - 1), r = e._startPixel, a = e._endPixel, l = 1e-6;
  let s = e.getPixelForTick(i), u;
  if (!(t && (o === 1 ? u = Math.max(s - r, a - s) : n === 0 ? u = (e.getPixelForTick(1) - s) / 2 : u = (s - e.getPixelForTick(i - 1)) / 2, s += i < n ? u : -u, s < r - l || s > a + l)))
    return s;
}
function l$(e, n) {
  nt(e, (t) => {
    const o = t.gc, i = o.length / 2;
    let r;
    if (i > n) {
      for (r = 0; r < i; ++r)
        delete t.data[o[r]];
      o.splice(0, i);
    }
  });
}
function si(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function dc(e, n) {
  if (!e.display)
    return 0;
  const t = xt(e.font, n), o = It(e.padding);
  return (dt(e.text) ? e.text.length : 1) * t.lineHeight + o.height;
}
function s$(e, n) {
  return ko(e, {
    scale: n,
    type: "scale"
  });
}
function u$(e, n, t) {
  return ko(e, {
    tick: t,
    index: n,
    type: "tick"
  });
}
function d$(e, n, t) {
  let o = Is(e);
  return (t && n !== "right" || !t && n === "right") && (o = r$(o)), o;
}
function c$(e, n, t, o) {
  const { top: i, left: r, bottom: a, right: l, chart: s } = e, { chartArea: u, scales: d } = s;
  let f = 0, c, h, m;
  const g = a - i, v = l - r;
  if (e.isHorizontal()) {
    if (h = St(o, r, l), Ue(t)) {
      const p = Object.keys(t)[0], y = t[p];
      m = d[p].getPixelForValue(y) + g - n;
    } else
      t === "center" ? m = (u.bottom + u.top) / 2 + g - n : m = lc(e, t, n);
    c = l - r;
  } else {
    if (Ue(t)) {
      const p = Object.keys(t)[0], y = t[p];
      h = d[p].getPixelForValue(y) - v + n;
    } else
      t === "center" ? h = (u.left + u.right) / 2 - v + n : h = lc(e, t, n);
    m = St(o, a, i), f = t === "left" ? -vt : vt;
  }
  return {
    titleX: h,
    titleY: m,
    maxWidth: c,
    rotation: f
  };
}
class Oo extends _o {
  constructor(n) {
    super(), this.id = n.id, this.type = n.type, this.options = void 0, this.ctx = n.ctx, this.chart = n.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(n) {
    this.options = n.setContext(this.getContext()), this.axis = n.axis, this._userMin = this.parse(n.min), this._userMax = this.parse(n.max), this._suggestedMin = this.parse(n.suggestedMin), this._suggestedMax = this.parse(n.suggestedMax);
  }
  parse(n, t) {
    return n;
  }
  getUserBounds() {
    let { _userMin: n, _userMax: t, _suggestedMin: o, _suggestedMax: i } = this;
    return n = Wt(n, Number.POSITIVE_INFINITY), t = Wt(t, Number.NEGATIVE_INFINITY), o = Wt(o, Number.POSITIVE_INFINITY), i = Wt(i, Number.NEGATIVE_INFINITY), {
      min: Wt(n, o),
      max: Wt(t, i),
      minDefined: _t(n),
      maxDefined: _t(t)
    };
  }
  getMinMax(n) {
    let { min: t, max: o, minDefined: i, maxDefined: r } = this.getUserBounds(), a;
    if (i && r)
      return {
        min: t,
        max: o
      };
    const l = this.getMatchingVisibleMetas();
    for (let s = 0, u = l.length; s < u; ++s)
      a = l[s].controller.getMinMax(this, n), i || (t = Math.min(t, a.min)), r || (o = Math.max(o, a.max));
    return t = r && t > o ? o : t, o = i && t > o ? t : o, {
      min: Wt(t, Wt(o, t)),
      max: Wt(o, Wt(t, o))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const n = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? n.xLabels : n.yLabels) || n.labels || [];
  }
  getLabelItems(n = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(n));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    at(this.options.beforeUpdate, [
      this
    ]);
  }
  update(n, t, o) {
    const { beginAtZero: i, grace: r, ticks: a } = this.options, l = a.sampleSize;
    this.beforeUpdate(), this.maxWidth = n, this.maxHeight = t, this._margins = o = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, o), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + o.left + o.right : this.height + o.top + o.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = qx(this, r, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const s = l < this.ticks.length;
    this._convertTicksToLabels(s ? uc(this.ticks, l) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = Qw(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), s && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let n = this.options.reverse, t, o;
    this.isHorizontal() ? (t = this.left, o = this.right) : (t = this.top, o = this.bottom, n = !n), this._startPixel = t, this._endPixel = o, this._reversePixels = n, this._length = o - t, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    at(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    at(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    at(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(n) {
    this.chart.notifyPlugins(n, this.getContext()), at(this.options[n], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    at(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(n) {
    const t = this.options.ticks;
    let o, i, r;
    for (o = 0, i = n.length; o < i; o++)
      r = n[o], r.label = at(t.callback, [
        r.value,
        o,
        n
      ], this);
  }
  afterTickToLabelConversion() {
    at(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    at(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const n = this.options, t = n.ticks, o = sc(this.ticks.length, n.ticks.maxTicksLimit), i = t.minRotation || 0, r = t.maxRotation;
    let a = i, l, s, u;
    if (!this._isVisible() || !t.display || i >= r || o <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const d = this._getLabelSizes(), f = d.widest.width, c = d.highest.height, h = Ht(this.chart.width - f, 0, this.maxWidth);
    l = n.offset ? this.maxWidth / o : h / (o - 1), f + 6 > l && (l = h / (o - (n.offset ? 0.5 : 1)), s = this.maxHeight - si(n.grid) - t.padding - dc(n.title, this.chart.options.font), u = Math.sqrt(f * f + c * c), a = Ts(Math.min(Math.asin(Ht((d.highest.height + 6) / l, -1, 1)), Math.asin(Ht(s / u, -1, 1)) - Math.asin(Ht(c / u, -1, 1)))), a = Math.max(i, Math.min(r, a))), this.labelRotation = a;
  }
  afterCalculateLabelRotation() {
    at(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    at(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const n = {
      width: 0,
      height: 0
    }, { chart: t, options: { ticks: o, title: i, grid: r } } = this, a = this._isVisible(), l = this.isHorizontal();
    if (a) {
      const s = dc(i, t.options.font);
      if (l ? (n.width = this.maxWidth, n.height = si(r) + s) : (n.height = this.maxHeight, n.width = si(r) + s), o.display && this.ticks.length) {
        const { first: u, last: d, widest: f, highest: c } = this._getLabelSizes(), h = o.padding * 2, m = mn(this.labelRotation), g = Math.cos(m), v = Math.sin(m);
        if (l) {
          const p = o.mirror ? 0 : v * f.width + g * c.height;
          n.height = Math.min(this.maxHeight, n.height + p + h);
        } else {
          const p = o.mirror ? 0 : g * f.width + v * c.height;
          n.width = Math.min(this.maxWidth, n.width + p + h);
        }
        this._calculatePadding(u, d, v, g);
      }
    }
    this._handleMargins(), l ? (this.width = this._length = t.width - this._margins.left - this._margins.right, this.height = n.height) : (this.width = n.width, this.height = this._length = t.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(n, t, o, i) {
    const { ticks: { align: r, padding: a }, position: l } = this.options, s = this.labelRotation !== 0, u = l !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const d = this.getPixelForTick(0) - this.left, f = this.right - this.getPixelForTick(this.ticks.length - 1);
      let c = 0, h = 0;
      s ? u ? (c = i * n.width, h = o * t.height) : (c = o * n.height, h = i * t.width) : r === "start" ? h = t.width : r === "end" ? c = n.width : r !== "inner" && (c = n.width / 2, h = t.width / 2), this.paddingLeft = Math.max((c - d + a) * this.width / (this.width - d), 0), this.paddingRight = Math.max((h - f + a) * this.width / (this.width - f), 0);
    } else {
      let d = t.height / 2, f = n.height / 2;
      r === "start" ? (d = 0, f = n.height) : r === "end" && (d = t.height, f = 0), this.paddingTop = d + a, this.paddingBottom = f + a;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    at(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: n, position: t } = this.options;
    return t === "top" || t === "bottom" || n === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(n) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(n);
    let t, o;
    for (t = 0, o = n.length; t < o; t++)
      lt(n[t].label) && (n.splice(t, 1), o--, t--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let n = this._labelSizes;
    if (!n) {
      const t = this.options.ticks.sampleSize;
      let o = this.ticks;
      t < o.length && (o = uc(o, t)), this._labelSizes = n = this._computeLabelSizes(o, o.length, this.options.ticks.maxTicksLimit);
    }
    return n;
  }
  _computeLabelSizes(n, t, o) {
    const { ctx: i, _longestTextCache: r } = this, a = [], l = [], s = Math.floor(t / sc(t, o));
    let u = 0, d = 0, f, c, h, m, g, v, p, y, C, b, x;
    for (f = 0; f < t; f += s) {
      if (m = n[f].label, g = this._resolveTickFontOptions(f), i.font = v = g.string, p = r[v] = r[v] || {
        data: {},
        gc: []
      }, y = g.lineHeight, C = b = 0, !lt(m) && !dt(m))
        C = Qr(i, p.data, p.gc, C, m), b = y;
      else if (dt(m))
        for (c = 0, h = m.length; c < h; ++c)
          x = m[c], !lt(x) && !dt(x) && (C = Qr(i, p.data, p.gc, C, x), b += y);
      a.push(C), l.push(b), u = Math.max(C, u), d = Math.max(b, d);
    }
    l$(r, t);
    const w = a.indexOf(u), $ = l.indexOf(d), E = (A) => ({
      width: a[A] || 0,
      height: l[A] || 0
    });
    return {
      first: E(0),
      last: E(t - 1),
      widest: E(w),
      highest: E($),
      widths: a,
      heights: l
    };
  }
  getLabelForValue(n) {
    return n;
  }
  getPixelForValue(n, t) {
    return NaN;
  }
  getValueForPixel(n) {
  }
  getPixelForTick(n) {
    const t = this.ticks;
    return n < 0 || n > t.length - 1 ? null : this.getPixelForValue(t[n].value);
  }
  getPixelForDecimal(n) {
    this._reversePixels && (n = 1 - n);
    const t = this._startPixel + n * this._length;
    return Cx(this._alignToPixels ? ao(this.chart, t, 0) : t);
  }
  getDecimalForPixel(n) {
    const t = (n - this._startPixel) / this._length;
    return this._reversePixels ? 1 - t : t;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: n, max: t } = this;
    return n < 0 && t < 0 ? t : n > 0 && t > 0 ? n : 0;
  }
  getContext(n) {
    const t = this.ticks || [];
    if (n >= 0 && n < t.length) {
      const o = t[n];
      return o.$context || (o.$context = u$(this.getContext(), n, o));
    }
    return this.$context || (this.$context = s$(this.chart.getContext(), this));
  }
  _tickSize() {
    const n = this.options.ticks, t = mn(this.labelRotation), o = Math.abs(Math.cos(t)), i = Math.abs(Math.sin(t)), r = this._getLabelSizes(), a = n.autoSkipPadding || 0, l = r ? r.widest.width + a : 0, s = r ? r.highest.height + a : 0;
    return this.isHorizontal() ? s * o > l * i ? l / o : s / i : s * i < l * o ? s / o : l / i;
  }
  _isVisible() {
    const n = this.options.display;
    return n !== "auto" ? !!n : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(n) {
    const t = this.axis, o = this.chart, i = this.options, { grid: r, position: a, border: l } = i, s = r.offset, u = this.isHorizontal(), f = this.ticks.length + (s ? 1 : 0), c = si(r), h = [], m = l.setContext(this.getContext()), g = m.display ? m.width : 0, v = g / 2, p = function(U) {
      return ao(o, U, g);
    };
    let y, C, b, x, w, $, E, A, O, k, S, T;
    if (a === "top")
      y = p(this.bottom), $ = this.bottom - c, A = y - v, k = p(n.top) + v, T = n.bottom;
    else if (a === "bottom")
      y = p(this.top), k = n.top, T = p(n.bottom) - v, $ = y + v, A = this.top + c;
    else if (a === "left")
      y = p(this.right), w = this.right - c, E = y - v, O = p(n.left) + v, S = n.right;
    else if (a === "right")
      y = p(this.left), O = n.left, S = p(n.right) - v, w = y + v, E = this.left + c;
    else if (t === "x") {
      if (a === "center")
        y = p((n.top + n.bottom) / 2 + 0.5);
      else if (Ue(a)) {
        const U = Object.keys(a)[0], W = a[U];
        y = p(this.chart.scales[U].getPixelForValue(W));
      }
      k = n.top, T = n.bottom, $ = y + v, A = $ + c;
    } else if (t === "y") {
      if (a === "center")
        y = p((n.left + n.right) / 2);
      else if (Ue(a)) {
        const U = Object.keys(a)[0], W = a[U];
        y = p(this.chart.scales[U].getPixelForValue(W));
      }
      w = y - v, E = w - c, O = n.left, S = n.right;
    }
    const L = Je(i.ticks.maxTicksLimit, f), F = Math.max(1, Math.ceil(f / L));
    for (C = 0; C < f; C += F) {
      const U = this.getContext(C), W = r.setContext(U), oe = l.setContext(U), H = W.lineWidth, B = W.color, D = oe.dash || [], V = oe.dashOffset, q = W.tickWidth, Z = W.tickColor, Y = W.tickBorderDash || [], R = W.tickBorderDashOffset;
      b = a$(this, C, s), b !== void 0 && (x = ao(o, b, H), u ? w = E = O = S = x : $ = A = k = T = x, h.push({
        tx1: w,
        ty1: $,
        tx2: E,
        ty2: A,
        x1: O,
        y1: k,
        x2: S,
        y2: T,
        width: H,
        color: B,
        borderDash: D,
        borderDashOffset: V,
        tickWidth: q,
        tickColor: Z,
        tickBorderDash: Y,
        tickBorderDashOffset: R
      }));
    }
    return this._ticksLength = f, this._borderValue = y, h;
  }
  _computeLabelItems(n) {
    const t = this.axis, o = this.options, { position: i, ticks: r } = o, a = this.isHorizontal(), l = this.ticks, { align: s, crossAlign: u, padding: d, mirror: f } = r, c = si(o.grid), h = c + d, m = f ? -d : h, g = -mn(this.labelRotation), v = [];
    let p, y, C, b, x, w, $, E, A, O, k, S, T = "middle";
    if (i === "top")
      w = this.bottom - m, $ = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      w = this.top + m, $ = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const F = this._getYAxisLabelAlignment(c);
      $ = F.textAlign, x = F.x;
    } else if (i === "right") {
      const F = this._getYAxisLabelAlignment(c);
      $ = F.textAlign, x = F.x;
    } else if (t === "x") {
      if (i === "center")
        w = (n.top + n.bottom) / 2 + h;
      else if (Ue(i)) {
        const F = Object.keys(i)[0], U = i[F];
        w = this.chart.scales[F].getPixelForValue(U) + h;
      }
      $ = this._getXAxisLabelAlignment();
    } else if (t === "y") {
      if (i === "center")
        x = (n.left + n.right) / 2 - h;
      else if (Ue(i)) {
        const F = Object.keys(i)[0], U = i[F];
        x = this.chart.scales[F].getPixelForValue(U);
      }
      $ = this._getYAxisLabelAlignment(c).textAlign;
    }
    t === "y" && (s === "start" ? T = "top" : s === "end" && (T = "bottom"));
    const L = this._getLabelSizes();
    for (p = 0, y = l.length; p < y; ++p) {
      C = l[p], b = C.label;
      const F = r.setContext(this.getContext(p));
      E = this.getPixelForTick(p) + r.labelOffset, A = this._resolveTickFontOptions(p), O = A.lineHeight, k = dt(b) ? b.length : 1;
      const U = k / 2, W = F.color, oe = F.textStrokeColor, H = F.textStrokeWidth;
      let B = $;
      a ? (x = E, $ === "inner" && (p === y - 1 ? B = this.options.reverse ? "left" : "right" : p === 0 ? B = this.options.reverse ? "right" : "left" : B = "center"), i === "top" ? u === "near" || g !== 0 ? S = -k * O + O / 2 : u === "center" ? S = -L.highest.height / 2 - U * O + O : S = -L.highest.height + O / 2 : u === "near" || g !== 0 ? S = O / 2 : u === "center" ? S = L.highest.height / 2 - U * O : S = L.highest.height - k * O, f && (S *= -1), g !== 0 && !F.showLabelBackdrop && (x += O / 2 * Math.sin(g))) : (w = E, S = (1 - k) * O / 2);
      let D;
      if (F.showLabelBackdrop) {
        const V = It(F.backdropPadding), q = L.heights[p], Z = L.widths[p];
        let Y = S - V.top, R = 0 - V.left;
        switch (T) {
          case "middle":
            Y -= q / 2;
            break;
          case "bottom":
            Y -= q;
            break;
        }
        switch ($) {
          case "center":
            R -= Z / 2;
            break;
          case "right":
            R -= Z;
            break;
          case "inner":
            p === y - 1 ? R -= Z : p > 0 && (R -= Z / 2);
            break;
        }
        D = {
          left: R,
          top: Y,
          width: Z + V.width,
          height: q + V.height,
          color: F.backdropColor
        };
      }
      v.push({
        label: b,
        font: A,
        textOffset: S,
        options: {
          rotation: g,
          color: W,
          strokeColor: oe,
          strokeWidth: H,
          textAlign: B,
          textBaseline: T,
          translation: [
            x,
            w
          ],
          backdrop: D
        }
      });
    }
    return v;
  }
  _getXAxisLabelAlignment() {
    const { position: n, ticks: t } = this.options;
    if (-mn(this.labelRotation))
      return n === "top" ? "left" : "right";
    let i = "center";
    return t.align === "start" ? i = "left" : t.align === "end" ? i = "right" : t.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(n) {
    const { position: t, ticks: { crossAlign: o, mirror: i, padding: r } } = this.options, a = this._getLabelSizes(), l = n + r, s = a.widest.width;
    let u, d;
    return t === "left" ? i ? (d = this.right + r, o === "near" ? u = "left" : o === "center" ? (u = "center", d += s / 2) : (u = "right", d += s)) : (d = this.right - l, o === "near" ? u = "right" : o === "center" ? (u = "center", d -= s / 2) : (u = "left", d = this.left)) : t === "right" ? i ? (d = this.left + r, o === "near" ? u = "right" : o === "center" ? (u = "center", d -= s / 2) : (u = "left", d -= s)) : (d = this.left + l, o === "near" ? u = "left" : o === "center" ? (u = "center", d += s / 2) : (u = "right", d = this.right)) : u = "right", {
      textAlign: u,
      x: d
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const n = this.chart, t = this.options.position;
    if (t === "left" || t === "right")
      return {
        top: 0,
        left: this.left,
        bottom: n.height,
        right: this.right
      };
    if (t === "top" || t === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: n.width
      };
  }
  drawBackground() {
    const { ctx: n, options: { backgroundColor: t }, left: o, top: i, width: r, height: a } = this;
    t && (n.save(), n.fillStyle = t, n.fillRect(o, i, r, a), n.restore());
  }
  getLineWidthForValue(n) {
    const t = this.options.grid;
    if (!this._isVisible() || !t.display)
      return 0;
    const i = this.ticks.findIndex((r) => r.value === n);
    return i >= 0 ? t.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(n) {
    const t = this.options.grid, o = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(n));
    let r, a;
    const l = (s, u, d) => {
      !d.width || !d.color || (o.save(), o.lineWidth = d.width, o.strokeStyle = d.color, o.setLineDash(d.borderDash || []), o.lineDashOffset = d.borderDashOffset, o.beginPath(), o.moveTo(s.x, s.y), o.lineTo(u.x, u.y), o.stroke(), o.restore());
    };
    if (t.display)
      for (r = 0, a = i.length; r < a; ++r) {
        const s = i[r];
        t.drawOnChartArea && l({
          x: s.x1,
          y: s.y1
        }, {
          x: s.x2,
          y: s.y2
        }, s), t.drawTicks && l({
          x: s.tx1,
          y: s.ty1
        }, {
          x: s.tx2,
          y: s.ty2
        }, {
          color: s.tickColor,
          width: s.tickWidth,
          borderDash: s.tickBorderDash,
          borderDashOffset: s.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: n, ctx: t, options: { border: o, grid: i } } = this, r = o.setContext(this.getContext()), a = o.display ? r.width : 0;
    if (!a)
      return;
    const l = i.setContext(this.getContext(0)).lineWidth, s = this._borderValue;
    let u, d, f, c;
    this.isHorizontal() ? (u = ao(n, this.left, a) - a / 2, d = ao(n, this.right, l) + l / 2, f = c = s) : (f = ao(n, this.top, a) - a / 2, c = ao(n, this.bottom, l) + l / 2, u = d = s), t.save(), t.lineWidth = r.width, t.strokeStyle = r.color, t.beginPath(), t.moveTo(u, f), t.lineTo(d, c), t.stroke(), t.restore();
  }
  drawLabels(n) {
    if (!this.options.ticks.display)
      return;
    const o = this.ctx, i = this._computeLabelArea();
    i && Ds(o, i);
    const r = this.getLabelItems(n);
    for (const a of r) {
      const l = a.options, s = a.font, u = a.label, d = a.textOffset;
      xo(o, u, 0, d, s, l);
    }
    i && Ls(o);
  }
  drawTitle() {
    const { ctx: n, options: { position: t, title: o, reverse: i } } = this;
    if (!o.display)
      return;
    const r = xt(o.font), a = It(o.padding), l = o.align;
    let s = r.lineHeight / 2;
    t === "bottom" || t === "center" || Ue(t) ? (s += a.bottom, dt(o.text) && (s += r.lineHeight * (o.text.length - 1))) : s += a.top;
    const { titleX: u, titleY: d, maxWidth: f, rotation: c } = c$(this, s, t, l);
    xo(n, o.text, 0, 0, r, {
      color: o.color,
      maxWidth: f,
      rotation: c,
      textAlign: d$(l, t, i),
      textBaseline: "middle",
      translation: [
        u,
        d
      ]
    });
  }
  draw(n) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(n), this.drawBorder(), this.drawTitle(), this.drawLabels(n));
  }
  _layers() {
    const n = this.options, t = n.ticks && n.ticks.z || 0, o = Je(n.grid && n.grid.z, -1), i = Je(n.border && n.border.z, 0);
    return !this._isVisible() || this.draw !== Oo.prototype.draw ? [
      {
        z: t,
        draw: (r) => {
          this.draw(r);
        }
      }
    ] : [
      {
        z: o,
        draw: (r) => {
          this.drawBackground(), this.drawGrid(r), this.drawTitle();
        }
      },
      {
        z: i,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: t,
        draw: (r) => {
          this.drawLabels(r);
        }
      }
    ];
  }
  getMatchingVisibleMetas(n) {
    const t = this.chart.getSortedVisibleDatasetMetas(), o = this.axis + "AxisID", i = [];
    let r, a;
    for (r = 0, a = t.length; r < a; ++r) {
      const l = t[r];
      l[o] === this.id && (!n || l.type === n) && i.push(l);
    }
    return i;
  }
  _resolveTickFontOptions(n) {
    const t = this.options.ticks.setContext(this.getContext(n));
    return xt(t.font);
  }
  _maxDigits() {
    const n = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / n;
  }
}
class Cr {
  constructor(n, t, o) {
    this.type = n, this.scope = t, this.override = o, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(n) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, n.prototype);
  }
  register(n) {
    const t = Object.getPrototypeOf(n);
    let o;
    g$(t) && (o = this.register(t));
    const i = this.items, r = n.id, a = this.scope + "." + r;
    if (!r)
      throw new Error("class does not have id: " + n);
    return r in i || (i[r] = n, f$(n, a, o), this.override && gt.override(n.id, n.overrides)), a;
  }
  get(n) {
    return this.items[n];
  }
  unregister(n) {
    const t = this.items, o = n.id, i = this.scope;
    o in t && delete t[o], i && o in gt[i] && (delete gt[i][o], this.override && delete Co[o]);
  }
}
function f$(e, n, t) {
  const o = Di(/* @__PURE__ */ Object.create(null), [
    t ? gt.get(t) : {},
    gt.get(n),
    e.defaults
  ]);
  gt.set(n, o), e.defaultRoutes && h$(n, e.defaultRoutes), e.descriptors && gt.describe(n, e.descriptors);
}
function h$(e, n) {
  Object.keys(n).forEach((t) => {
    const o = t.split("."), i = o.pop(), r = [
      e
    ].concat(o).join("."), a = n[t].split("."), l = a.pop(), s = a.join(".");
    gt.route(r, i, s, l);
  });
}
function g$(e) {
  return "id" in e && "defaults" in e;
}
class m$ {
  constructor() {
    this.controllers = new Cr($i, "datasets", !0), this.elements = new Cr(_o, "elements"), this.plugins = new Cr(Object, "plugins"), this.scales = new Cr(Oo, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...n) {
    this._each("register", n);
  }
  remove(...n) {
    this._each("unregister", n);
  }
  addControllers(...n) {
    this._each("register", n, this.controllers);
  }
  addElements(...n) {
    this._each("register", n, this.elements);
  }
  addPlugins(...n) {
    this._each("register", n, this.plugins);
  }
  addScales(...n) {
    this._each("register", n, this.scales);
  }
  getController(n) {
    return this._get(n, this.controllers, "controller");
  }
  getElement(n) {
    return this._get(n, this.elements, "element");
  }
  getPlugin(n) {
    return this._get(n, this.plugins, "plugin");
  }
  getScale(n) {
    return this._get(n, this.scales, "scale");
  }
  removeControllers(...n) {
    this._each("unregister", n, this.controllers);
  }
  removeElements(...n) {
    this._each("unregister", n, this.elements);
  }
  removePlugins(...n) {
    this._each("unregister", n, this.plugins);
  }
  removeScales(...n) {
    this._each("unregister", n, this.scales);
  }
  _each(n, t, o) {
    [
      ...t
    ].forEach((i) => {
      const r = o || this._getRegistryForType(i);
      o || r.isForType(i) || r === this.plugins && i.id ? this._exec(n, r, i) : nt(i, (a) => {
        const l = o || this._getRegistryForType(a);
        this._exec(n, l, a);
      });
    });
  }
  _exec(n, t, o) {
    const i = As(n);
    at(o["before" + i], [], o), t[n](o), at(o["after" + i], [], o);
  }
  _getRegistryForType(n) {
    for (let t = 0; t < this._typedRegistries.length; t++) {
      const o = this._typedRegistries[t];
      if (o.isForType(n))
        return o;
    }
    return this.plugins;
  }
  _get(n, t, o) {
    const i = t.get(n);
    if (i === void 0)
      throw new Error('"' + n + '" is not a registered ' + o + ".");
    return i;
  }
}
var hn = /* @__PURE__ */ new m$();
class p$ {
  constructor() {
    this._init = [];
  }
  notify(n, t, o, i) {
    t === "beforeInit" && (this._init = this._createDescriptors(n, !0), this._notify(this._init, n, "install"));
    const r = i ? this._descriptors(n).filter(i) : this._descriptors(n), a = this._notify(r, n, t, o);
    return t === "afterDestroy" && (this._notify(r, n, "stop"), this._notify(this._init, n, "uninstall")), a;
  }
  _notify(n, t, o, i) {
    i = i || {};
    for (const r of n) {
      const a = r.plugin, l = a[o], s = [
        t,
        i,
        r.options
      ];
      if (at(l, s, a) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    lt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(n) {
    if (this._cache)
      return this._cache;
    const t = this._cache = this._createDescriptors(n);
    return this._notifyStateChanges(n), t;
  }
  _createDescriptors(n, t) {
    const o = n && n.config, i = Je(o.options && o.options.plugins, {}), r = v$(o);
    return i === !1 && !t ? [] : y$(n, r, i, t);
  }
  _notifyStateChanges(n) {
    const t = this._oldCache || [], o = this._cache, i = (r, a) => r.filter((l) => !a.some((s) => l.plugin.id === s.plugin.id));
    this._notify(i(t, o), n, "stop"), this._notify(i(o, t), n, "start");
  }
}
function v$(e) {
  const n = {}, t = [], o = Object.keys(hn.plugins.items);
  for (let r = 0; r < o.length; r++)
    t.push(hn.getPlugin(o[r]));
  const i = e.plugins || [];
  for (let r = 0; r < i.length; r++) {
    const a = i[r];
    t.indexOf(a) === -1 && (t.push(a), n[a.id] = !0);
  }
  return {
    plugins: t,
    localIds: n
  };
}
function b$(e, n) {
  return !n && e === !1 ? null : e === !0 ? {} : e;
}
function y$(e, { plugins: n, localIds: t }, o, i) {
  const r = [], a = e.getContext();
  for (const l of n) {
    const s = l.id, u = b$(o[s], i);
    u !== null && r.push({
      plugin: l,
      options: C$(e.config, {
        plugin: l,
        local: t[s]
      }, u, a)
    });
  }
  return r;
}
function C$(e, { plugin: n, local: t }, o, i) {
  const r = e.pluginScopeKeys(n), a = e.getOptionScopes(o, r);
  return t && n.defaults && a.push(n.defaults), e.createResolver(a, i, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function ql(e, n) {
  const t = gt.datasets[e] || {};
  return ((n.datasets || {})[e] || {}).indexAxis || n.indexAxis || t.indexAxis || "x";
}
function x$(e, n) {
  let t = e;
  return e === "_index_" ? t = n : e === "_value_" && (t = n === "x" ? "y" : "x"), t;
}
function w$(e, n) {
  return e === n ? "_index_" : "_value_";
}
function cc(e) {
  if (e === "x" || e === "y" || e === "r")
    return e;
}
function $$(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Ul(e, ...n) {
  if (cc(e))
    return e;
  for (const t of n) {
    const o = t.axis || $$(t.position) || e.length > 1 && cc(e[0].toLowerCase());
    if (o)
      return o;
  }
  throw new Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function fc(e, n, t) {
  if (t[n + "AxisID"] === e)
    return {
      axis: n
    };
}
function k$(e, n) {
  if (n.data && n.data.datasets) {
    const t = n.data.datasets.filter((o) => o.xAxisID === e || o.yAxisID === e);
    if (t.length)
      return fc(e, "x", t[0]) || fc(e, "y", t[0]);
  }
  return {};
}
function _$(e, n) {
  const t = Co[e.type] || {
    scales: {}
  }, o = n.scales || {}, i = ql(e.type, n), r = /* @__PURE__ */ Object.create(null);
  return Object.keys(o).forEach((a) => {
    const l = o[a];
    if (!Ue(l))
      return console.error(`Invalid scale configuration for scale: ${a}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${a}`);
    const s = Ul(a, l, k$(a, e), gt.scales[l.type]), u = w$(s, i), d = t.scales || {};
    r[a] = Ci(/* @__PURE__ */ Object.create(null), [
      {
        axis: s
      },
      l,
      d[s],
      d[u]
    ]);
  }), e.data.datasets.forEach((a) => {
    const l = a.type || e.type, s = a.indexAxis || ql(l, n), d = (Co[l] || {}).scales || {};
    Object.keys(d).forEach((f) => {
      const c = x$(f, s), h = a[c + "AxisID"] || c;
      r[h] = r[h] || /* @__PURE__ */ Object.create(null), Ci(r[h], [
        {
          axis: c
        },
        o[h],
        d[f]
      ]);
    });
  }), Object.keys(r).forEach((a) => {
    const l = r[a];
    Ci(l, [
      gt.scales[l.type],
      gt.scale
    ]);
  }), r;
}
function Qf(e) {
  const n = e.options || (e.options = {});
  n.plugins = Je(n.plugins, {}), n.scales = _$(e, n);
}
function eh(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function O$(e) {
  return e = e || {}, e.data = eh(e.data), Qf(e), e;
}
const hc = /* @__PURE__ */ new Map(), th = /* @__PURE__ */ new Set();
function xr(e, n) {
  let t = hc.get(e);
  return t || (t = n(), hc.set(e, t), th.add(t)), t;
}
const ui = (e, n, t) => {
  const o = Li(n, t);
  o !== void 0 && e.add(o);
};
class E$ {
  constructor(n) {
    this._config = O$(n), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(n) {
    this._config.type = n;
  }
  get data() {
    return this._config.data;
  }
  set data(n) {
    this._config.data = eh(n);
  }
  get options() {
    return this._config.options;
  }
  set options(n) {
    this._config.options = n;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const n = this._config;
    this.clearCache(), Qf(n);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(n) {
    return xr(n, () => [
      [
        `datasets.${n}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(n, t) {
    return xr(`${n}.transition.${t}`, () => [
      [
        `datasets.${n}.transitions.${t}`,
        `transitions.${t}`
      ],
      [
        `datasets.${n}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(n, t) {
    return xr(`${n}-${t}`, () => [
      [
        `datasets.${n}.elements.${t}`,
        `datasets.${n}`,
        `elements.${t}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(n) {
    const t = n.id, o = this.type;
    return xr(`${o}-plugin-${t}`, () => [
      [
        `plugins.${t}`,
        ...n.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(n, t) {
    const o = this._scopeCache;
    let i = o.get(n);
    return (!i || t) && (i = /* @__PURE__ */ new Map(), o.set(n, i)), i;
  }
  getOptionScopes(n, t, o) {
    const { options: i, type: r } = this, a = this._cachedScopes(n, o), l = a.get(t);
    if (l)
      return l;
    const s = /* @__PURE__ */ new Set();
    t.forEach((d) => {
      n && (s.add(n), d.forEach((f) => ui(s, n, f))), d.forEach((f) => ui(s, i, f)), d.forEach((f) => ui(s, Co[r] || {}, f)), d.forEach((f) => ui(s, gt, f)), d.forEach((f) => ui(s, zl, f));
    });
    const u = Array.from(s);
    return u.length === 0 && u.push(/* @__PURE__ */ Object.create(null)), th.has(t) && a.set(t, u), u;
  }
  chartOptionScopes() {
    const { options: n, type: t } = this;
    return [
      n,
      Co[t] || {},
      gt.datasets[t] || {},
      {
        type: t
      },
      gt,
      zl
    ];
  }
  resolveNamedOptions(n, t, o, i = [
    ""
  ]) {
    const r = {
      $shared: !0
    }, { resolver: a, subPrefixes: l } = gc(this._resolverCache, n, i);
    let s = a;
    if (S$(a, t)) {
      r.$shared = !1, o = Zn(o) ? o() : o;
      const u = this.createResolver(n, o, l);
      s = Yo(a, o, u);
    }
    for (const u of t)
      r[u] = s[u];
    return r;
  }
  createResolver(n, t, o = [
    ""
  ], i) {
    const { resolver: r } = gc(this._resolverCache, n, o);
    return Ue(t) ? Yo(r, t, void 0, i) : r;
  }
}
function gc(e, n, t) {
  let o = e.get(n);
  o || (o = /* @__PURE__ */ new Map(), e.set(n, o));
  const i = t.join();
  let r = o.get(i);
  return r || (r = {
    resolver: Fs(n, t),
    subPrefixes: t.filter((l) => !l.toLowerCase().includes("hover"))
  }, o.set(i, r)), r;
}
const M$ = (e) => Ue(e) && Object.getOwnPropertyNames(e).some((n) => Zn(e[n]));
function S$(e, n) {
  const { isScriptable: t, isIndexable: o } = Vf(e);
  for (const i of n) {
    const r = t(i), a = o(i), l = (a || r) && e[i];
    if (r && (Zn(l) || M$(l)) || a && dt(l))
      return !0;
  }
  return !1;
}
var A$ = "4.4.9";
const T$ = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function mc(e, n) {
  return e === "top" || e === "bottom" || T$.indexOf(e) === -1 && n === "x";
}
function pc(e, n) {
  return function(t, o) {
    return t[e] === o[e] ? t[n] - o[n] : t[e] - o[e];
  };
}
function vc(e) {
  const n = e.chart, t = n.options.animation;
  n.notifyPlugins("afterRender"), at(t && t.onComplete, [
    e
  ], n);
}
function P$(e) {
  const n = e.chart, t = n.options.animation;
  at(t && t.onProgress, [
    e
  ], n);
}
function nh(e) {
  return Vs() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Lr = {}, bc = (e) => {
  const n = nh(e);
  return Object.values(Lr).filter((t) => t.canvas === n).pop();
};
function I$(e, n, t) {
  const o = Object.keys(e);
  for (const i of o) {
    const r = +i;
    if (r >= n) {
      const a = e[i];
      delete e[i], (t > 0 || r > n) && (e[r + t] = a);
    }
  }
}
function D$(e, n, t, o) {
  return !t || e.type === "mouseout" ? null : o ? n : e;
}
var Vn;
let wa = (Vn = class {
  static register(...n) {
    hn.add(...n), yc();
  }
  static unregister(...n) {
    hn.remove(...n), yc();
  }
  constructor(n, t) {
    const o = this.config = new E$(t), i = nh(n), r = bc(i);
    if (r)
      throw new Error("Canvas is already in use. Chart with ID '" + r.id + "' must be destroyed before the canvas with ID '" + r.canvas.id + "' can be reused.");
    const a = o.createResolver(o.chartOptionScopes(), this.getContext());
    this.platform = new (o.platform || Jw(i))(), this.platform.updateConfig(o);
    const l = this.platform.acquireContext(i, a.aspectRatio), s = l && l.canvas, u = s && s.height, d = s && s.width;
    if (this.id = sx(), this.ctx = l, this.canvas = s, this.width = d, this.height = u, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new p$(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = _x((f) => this.update(f), a.resizeDelay || 0), this._dataChanges = [], Lr[this.id] = this, !l || !s) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    On.listen(this, "complete", vc), On.listen(this, "progress", P$), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: n, maintainAspectRatio: t }, width: o, height: i, _aspectRatio: r } = this;
    return lt(n) ? t && r ? r : i ? o / i : null : n;
  }
  get data() {
    return this.config.data;
  }
  set data(n) {
    this.config.data = n;
  }
  get options() {
    return this._options;
  }
  set options(n) {
    this.config.options = n;
  }
  get registry() {
    return hn;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : Kd(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return zd(this.canvas, this.ctx), this;
  }
  stop() {
    return On.stop(this), this;
  }
  resize(n, t) {
    On.running(this) ? this._resizeBeforeDraw = {
      width: n,
      height: t
    } : this._resize(n, t);
  }
  _resize(n, t) {
    const o = this.options, i = this.canvas, r = o.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(i, n, t, r), l = o.devicePixelRatio || this.platform.getDevicePixelRatio(), s = this.width ? "resize" : "attach";
    this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, Kd(this, l, !0) && (this.notifyPlugins("resize", {
      size: a
    }), at(o.onResize, [
      this,
      a
    ], this), this.attached && this._doResize(s) && this.render());
  }
  ensureScalesHaveIDs() {
    const t = this.options.scales || {};
    nt(t, (o, i) => {
      o.id = i;
    });
  }
  buildOrUpdateScales() {
    const n = this.options, t = n.scales, o = this.scales, i = Object.keys(o).reduce((a, l) => (a[l] = !1, a), {});
    let r = [];
    t && (r = r.concat(Object.keys(t).map((a) => {
      const l = t[a], s = Ul(a, l), u = s === "r", d = s === "x";
      return {
        options: l,
        dposition: u ? "chartArea" : d ? "bottom" : "left",
        dtype: u ? "radialLinear" : d ? "category" : "linear"
      };
    }))), nt(r, (a) => {
      const l = a.options, s = l.id, u = Ul(s, l), d = Je(l.type, a.dtype);
      (l.position === void 0 || mc(l.position, u) !== mc(a.dposition)) && (l.position = a.dposition), i[s] = !0;
      let f = null;
      if (s in o && o[s].type === d)
        f = o[s];
      else {
        const c = hn.getScale(d);
        f = new c({
          id: s,
          type: d,
          ctx: this.ctx,
          chart: this
        }), o[f.id] = f;
      }
      f.init(l, n);
    }), nt(i, (a, l) => {
      a || delete o[l];
    }), nt(o, (a) => {
      en.configure(this, a, a.options), en.addBox(this, a);
    });
  }
  _updateMetasets() {
    const n = this._metasets, t = this.data.datasets.length, o = n.length;
    if (n.sort((i, r) => i.index - r.index), o > t) {
      for (let i = t; i < o; ++i)
        this._destroyDatasetMeta(i);
      n.splice(t, o - t);
    }
    this._sortedMetasets = n.slice(0).sort(pc("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: n, data: { datasets: t } } = this;
    n.length > t.length && delete this._stacks, n.forEach((o, i) => {
      t.filter((r) => r === o._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const n = [], t = this.data.datasets;
    let o, i;
    for (this._removeUnreferencedMetasets(), o = 0, i = t.length; o < i; o++) {
      const r = t[o];
      let a = this.getDatasetMeta(o);
      const l = r.type || this.config.type;
      if (a.type && a.type !== l && (this._destroyDatasetMeta(o), a = this.getDatasetMeta(o)), a.type = l, a.indexAxis = r.indexAxis || ql(l, this.options), a.order = r.order || 0, a.index = o, a.label = "" + r.label, a.visible = this.isDatasetVisible(o), a.controller)
        a.controller.updateIndex(o), a.controller.linkScales();
      else {
        const s = hn.getController(l), { datasetElementType: u, dataElementType: d } = gt.datasets[l];
        Object.assign(s, {
          dataElementType: hn.getElement(d),
          datasetElementType: u && hn.getElement(u)
        }), a.controller = new s(this, o), n.push(a.controller);
      }
    }
    return this._updateMetasets(), n;
  }
  _resetElements() {
    nt(this.data.datasets, (n, t) => {
      this.getDatasetMeta(t).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(n) {
    const t = this.config;
    t.update();
    const o = this._options = t.createResolver(t.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !o.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: n,
      cancelable: !0
    }) === !1)
      return;
    const r = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let a = 0;
    for (let u = 0, d = this.data.datasets.length; u < d; u++) {
      const { controller: f } = this.getDatasetMeta(u), c = !i && r.indexOf(f) === -1;
      f.buildOrUpdateElements(c), a = Math.max(+f.getMaxOverflow(), a);
    }
    a = this._minPadding = o.layout.autoPadding ? a : 0, this._updateLayout(a), i || nt(r, (u) => {
      u.reset();
    }), this._updateDatasets(n), this.notifyPlugins("afterUpdate", {
      mode: n
    }), this._layers.sort(pc("z", "_idx"));
    const { _active: l, _lastEvent: s } = this;
    s ? this._eventHandler(s, !0) : l.length && this._updateHoverStyles(l, l, !0), this.render();
  }
  _updateScales() {
    nt(this.scales, (n) => {
      en.removeBox(this, n);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const n = this.options, t = new Set(Object.keys(this._listeners)), o = new Set(n.events);
    (!Dd(t, o) || !!this._responsiveListeners !== n.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: n } = this, t = this._getUniformDataChanges() || [];
    for (const { method: o, start: i, count: r } of t) {
      const a = o === "_removeElements" ? -r : r;
      I$(n, i, a);
    }
  }
  _getUniformDataChanges() {
    const n = this._dataChanges;
    if (!n || !n.length)
      return;
    this._dataChanges = [];
    const t = this.data.datasets.length, o = (r) => new Set(n.filter((a) => a[0] === r).map((a, l) => l + "," + a.splice(1).join(","))), i = o(0);
    for (let r = 1; r < t; r++)
      if (!Dd(i, o(r)))
        return;
    return Array.from(i).map((r) => r.split(",")).map((r) => ({
      method: r[1],
      start: +r[2],
      count: +r[3]
    }));
  }
  _updateLayout(n) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    en.update(this, this.width, this.height, n);
    const t = this.chartArea, o = t.width <= 0 || t.height <= 0;
    this._layers = [], nt(this.boxes, (i) => {
      o && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, r) => {
      i._idx = r;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(n) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: n,
      cancelable: !0
    }) !== !1) {
      for (let t = 0, o = this.data.datasets.length; t < o; ++t)
        this.getDatasetMeta(t).controller.configure();
      for (let t = 0, o = this.data.datasets.length; t < o; ++t)
        this._updateDataset(t, Zn(n) ? n({
          datasetIndex: t
        }) : n);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: n
      });
    }
  }
  _updateDataset(n, t) {
    const o = this.getDatasetMeta(n), i = {
      meta: o,
      index: n,
      mode: t,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (o.controller._update(t), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (On.has(this) ? this.attached && !On.running(this) && On.start(this) : (this.draw(), vc({
      chart: this
    })));
  }
  draw() {
    let n;
    if (this._resizeBeforeDraw) {
      const { width: o, height: i } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(o, i);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this._layers;
    for (n = 0; n < t.length && t[n].z <= 0; ++n)
      t[n].draw(this.chartArea);
    for (this._drawDatasets(); n < t.length; ++n)
      t[n].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(n) {
    const t = this._sortedMetasets, o = [];
    let i, r;
    for (i = 0, r = t.length; i < r; ++i) {
      const a = t[i];
      (!n || a.visible) && o.push(a);
    }
    return o;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this.getSortedVisibleDatasetMetas();
    for (let t = n.length - 1; t >= 0; --t)
      this._drawDataset(n[t]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(n) {
    const t = this.ctx, o = {
      meta: n,
      index: n.index,
      cancelable: !0
    }, i = dw(this, n);
    this.notifyPlugins("beforeDatasetDraw", o) !== !1 && (i && Ds(t, i), n.controller.draw(), i && Ls(t), o.cancelable = !1, this.notifyPlugins("afterDatasetDraw", o));
  }
  isPointInArea(n) {
    return Bo(n, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(n, t, o, i) {
    const r = Tw.modes[t];
    return typeof r == "function" ? r(this, n, o, i) : [];
  }
  getDatasetMeta(n) {
    const t = this.data.datasets[n], o = this._metasets;
    let i = o.filter((r) => r && r._dataset === t).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: t && t.order || 0,
      index: n,
      _dataset: t,
      _parsed: [],
      _sorted: !1
    }, o.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = ko(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(n) {
    const t = this.data.datasets[n];
    if (!t)
      return !1;
    const o = this.getDatasetMeta(n);
    return typeof o.hidden == "boolean" ? !o.hidden : !t.hidden;
  }
  setDatasetVisibility(n, t) {
    const o = this.getDatasetMeta(n);
    o.hidden = !t;
  }
  toggleDataVisibility(n) {
    this._hiddenIndices[n] = !this._hiddenIndices[n];
  }
  getDataVisibility(n) {
    return !this._hiddenIndices[n];
  }
  _updateVisibility(n, t, o) {
    const i = o ? "show" : "hide", r = this.getDatasetMeta(n), a = r.controller._resolveAnimations(void 0, i);
    Yr(t) ? (r.data[t].hidden = !o, this.update()) : (this.setDatasetVisibility(n, o), a.update(r, {
      visible: o
    }), this.update((l) => l.datasetIndex === n ? i : void 0));
  }
  hide(n, t) {
    this._updateVisibility(n, t, !1);
  }
  show(n, t) {
    this._updateVisibility(n, t, !0);
  }
  _destroyDatasetMeta(n) {
    const t = this._metasets[n];
    t && t.controller && t.controller._destroy(), delete this._metasets[n];
  }
  _stop() {
    let n, t;
    for (this.stop(), On.remove(this), n = 0, t = this.data.datasets.length; n < t; ++n)
      this._destroyDatasetMeta(n);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: n, ctx: t } = this;
    this._stop(), this.config.clearCache(), n && (this.unbindEvents(), zd(n, t), this.platform.releaseContext(t), this.canvas = null, this.ctx = null), delete Lr[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...n) {
    return this.canvas.toDataURL(...n);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const n = this._listeners, t = this.platform, o = (r, a) => {
      t.addEventListener(this, r, a), n[r] = a;
    }, i = (r, a, l) => {
      r.offsetX = a, r.offsetY = l, this._eventHandler(r);
    };
    nt(this.options.events, (r) => o(r, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const n = this._responsiveListeners, t = this.platform, o = (s, u) => {
      t.addEventListener(this, s, u), n[s] = u;
    }, i = (s, u) => {
      n[s] && (t.removeEventListener(this, s, u), delete n[s]);
    }, r = (s, u) => {
      this.canvas && this.resize(s, u);
    };
    let a;
    const l = () => {
      i("attach", l), this.attached = !0, this.resize(), o("resize", r), o("detach", a);
    };
    a = () => {
      this.attached = !1, i("resize", r), this._stop(), this._resize(0, 0), o("attach", l);
    }, t.isAttached(this.canvas) ? l() : a();
  }
  unbindEvents() {
    nt(this._listeners, (n, t) => {
      this.platform.removeEventListener(this, t, n);
    }), this._listeners = {}, nt(this._responsiveListeners, (n, t) => {
      this.platform.removeEventListener(this, t, n);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(n, t, o) {
    const i = o ? "set" : "remove";
    let r, a, l, s;
    for (t === "dataset" && (r = this.getDatasetMeta(n[0].datasetIndex), r.controller["_" + i + "DatasetHoverStyle"]()), l = 0, s = n.length; l < s; ++l) {
      a = n[l];
      const u = a && this.getDatasetMeta(a.datasetIndex).controller;
      u && u[i + "HoverStyle"](a.element, a.datasetIndex, a.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(n) {
    const t = this._active || [], o = n.map(({ datasetIndex: r, index: a }) => {
      const l = this.getDatasetMeta(r);
      if (!l)
        throw new Error("No dataset found at index " + r);
      return {
        datasetIndex: r,
        element: l.data[a],
        index: a
      };
    });
    !Wr(o, t) && (this._active = o, this._lastEvent = null, this._updateHoverStyles(o, t));
  }
  notifyPlugins(n, t, o) {
    return this._plugins.notify(this, n, t, o);
  }
  isPluginEnabled(n) {
    return this._plugins._cache.filter((t) => t.plugin.id === n).length === 1;
  }
  _updateHoverStyles(n, t, o) {
    const i = this.options.hover, r = (s, u) => s.filter((d) => !u.some((f) => d.datasetIndex === f.datasetIndex && d.index === f.index)), a = r(t, n), l = o ? n : r(n, t);
    a.length && this.updateHoverStyle(a, i.mode, !1), l.length && i.mode && this.updateHoverStyle(l, i.mode, !0);
  }
  _eventHandler(n, t) {
    const o = {
      event: n,
      replay: t,
      cancelable: !0,
      inChartArea: this.isPointInArea(n)
    }, i = (a) => (a.options.events || this.options.events).includes(n.native.type);
    if (this.notifyPlugins("beforeEvent", o, i) === !1)
      return;
    const r = this._handleEvent(n, t, o.inChartArea);
    return o.cancelable = !1, this.notifyPlugins("afterEvent", o, i), (r || o.changed) && this.render(), this;
  }
  _handleEvent(n, t, o) {
    const { _active: i = [], options: r } = this, a = t, l = this._getActiveElements(n, i, o, a), s = gx(n), u = D$(n, this._lastEvent, o, s);
    o && (this._lastEvent = null, at(r.onHover, [
      n,
      l,
      this
    ], this), s && at(r.onClick, [
      n,
      l,
      this
    ], this));
    const d = !Wr(l, i);
    return (d || t) && (this._active = l, this._updateHoverStyles(l, i, t)), this._lastEvent = u, d;
  }
  _getActiveElements(n, t, o, i) {
    if (n.type === "mouseout")
      return [];
    if (!o)
      return t;
    const r = this.options.hover;
    return this.getElementsAtEventForMode(n, r.mode, r, i);
  }
}, Ee(Vn, "defaults", gt), Ee(Vn, "instances", Lr), Ee(Vn, "overrides", Co), Ee(Vn, "registry", hn), Ee(Vn, "version", A$), Ee(Vn, "getChart", bc), Vn);
function yc() {
  return nt(wa.instances, (e) => e._plugins.invalidate());
}
function L$(e, n, t) {
  const { startAngle: o, pixelMargin: i, x: r, y: a, outerRadius: l, innerRadius: s } = n;
  let u = i / l;
  e.beginPath(), e.arc(r, a, l, o - u, t + u), s > i ? (u = i / s, e.arc(r, a, s, t + u, o - u, !0)) : e.arc(r, a, i, t + vt, o - vt), e.closePath(), e.clip();
}
function N$(e) {
  return Ns(e, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function F$(e, n, t, o) {
  const i = N$(e.options.borderRadius), r = (t - n) / 2, a = Math.min(r, o * n / 2), l = (s) => {
    const u = (t - Math.min(r, s)) * o / 2;
    return Ht(s, 0, Math.min(r, u));
  };
  return {
    outerStart: l(i.outerStart),
    outerEnd: l(i.outerEnd),
    innerStart: Ht(i.innerStart, 0, a),
    innerEnd: Ht(i.innerEnd, 0, a)
  };
}
function Io(e, n, t, o) {
  return {
    x: t + e * Math.cos(n),
    y: o + e * Math.sin(n)
  };
}
function na(e, n, t, o, i, r) {
  const { x: a, y: l, startAngle: s, pixelMargin: u, innerRadius: d } = n, f = Math.max(n.outerRadius + o + t - u, 0), c = d > 0 ? d + o + t + u : 0;
  let h = 0;
  const m = i - s;
  if (o) {
    const F = d > 0 ? d - o : 0, U = f > 0 ? f - o : 0, W = (F + U) / 2, oe = W !== 0 ? m * W / (W + o) : m;
    h = (m - oe) / 2;
  }
  const g = Math.max(1e-3, m * f - t / mt) / f, v = (m - g) / 2, p = s + v + h, y = i - v - h, { outerStart: C, outerEnd: b, innerStart: x, innerEnd: w } = F$(n, c, f, y - p), $ = f - C, E = f - b, A = p + C / $, O = y - b / E, k = c + x, S = c + w, T = p + x / k, L = y - w / S;
  if (e.beginPath(), r) {
    const F = (A + O) / 2;
    if (e.arc(a, l, f, A, F), e.arc(a, l, f, F, O), b > 0) {
      const H = Io(E, O, a, l);
      e.arc(H.x, H.y, b, O, y + vt);
    }
    const U = Io(S, y, a, l);
    if (e.lineTo(U.x, U.y), w > 0) {
      const H = Io(S, L, a, l);
      e.arc(H.x, H.y, w, y + vt, L + Math.PI);
    }
    const W = (y - w / c + (p + x / c)) / 2;
    if (e.arc(a, l, c, y - w / c, W, !0), e.arc(a, l, c, W, p + x / c, !0), x > 0) {
      const H = Io(k, T, a, l);
      e.arc(H.x, H.y, x, T + Math.PI, p - vt);
    }
    const oe = Io($, p, a, l);
    if (e.lineTo(oe.x, oe.y), C > 0) {
      const H = Io($, A, a, l);
      e.arc(H.x, H.y, C, p - vt, A);
    }
  } else {
    e.moveTo(a, l);
    const F = Math.cos(A) * f + a, U = Math.sin(A) * f + l;
    e.lineTo(F, U);
    const W = Math.cos(O) * f + a, oe = Math.sin(O) * f + l;
    e.lineTo(W, oe);
  }
  e.closePath();
}
function R$(e, n, t, o, i) {
  const { fullCircles: r, startAngle: a, circumference: l } = n;
  let s = n.endAngle;
  if (r) {
    na(e, n, t, o, s, i);
    for (let u = 0; u < r; ++u)
      e.fill();
    isNaN(l) || (s = a + (l % ht || ht));
  }
  return na(e, n, t, o, s, i), e.fill(), s;
}
function B$(e, n, t, o, i) {
  const { fullCircles: r, startAngle: a, circumference: l, options: s } = n, { borderWidth: u, borderJoinStyle: d, borderDash: f, borderDashOffset: c } = s, h = s.borderAlign === "inner";
  if (!u)
    return;
  e.setLineDash(f || []), e.lineDashOffset = c, h ? (e.lineWidth = u * 2, e.lineJoin = d || "round") : (e.lineWidth = u, e.lineJoin = d || "bevel");
  let m = n.endAngle;
  if (r) {
    na(e, n, t, o, m, i);
    for (let g = 0; g < r; ++g)
      e.stroke();
    isNaN(l) || (m = a + (l % ht || ht));
  }
  h && L$(e, n, m), r || (na(e, n, t, o, m, i), e.stroke());
}
class mi extends _o {
  constructor(t) {
    super();
    Ee(this, "circumference");
    Ee(this, "endAngle");
    Ee(this, "fullCircles");
    Ee(this, "innerRadius");
    Ee(this, "outerRadius");
    Ee(this, "pixelMargin");
    Ee(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, o, i) {
    const r = this.getProps([
      "x",
      "y"
    ], i), { angle: a, distance: l } = Pf(r, {
      x: t,
      y: o
    }), { startAngle: s, endAngle: u, innerRadius: d, outerRadius: f, circumference: c } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], i), h = (this.options.spacing + this.options.borderWidth) / 2, m = Je(c, u - s), g = Jr(a, s, u) && s !== u, v = m >= ht || g, p = fo(l, d + h, f + h);
    return v && p;
  }
  getCenterPoint(t) {
    const { x: o, y: i, startAngle: r, endAngle: a, innerRadius: l, outerRadius: s } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], t), { offset: u, spacing: d } = this.options, f = (r + a) / 2, c = (l + s + d + u) / 2;
    return {
      x: o + Math.cos(f) * c,
      y: i + Math.sin(f) * c
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: o, circumference: i } = this, r = (o.offset || 0) / 4, a = (o.spacing || 0) / 2, l = o.circular;
    if (this.pixelMargin = o.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = i > ht ? Math.floor(i / ht) : 0, i === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    const s = (this.startAngle + this.endAngle) / 2;
    t.translate(Math.cos(s) * r, Math.sin(s) * r);
    const u = 1 - Math.sin(Math.min(mt, i || 0)), d = r * u;
    t.fillStyle = o.backgroundColor, t.strokeStyle = o.borderColor, R$(t, this, d, a, l), B$(t, this, d, a, l), t.restore();
  }
}
Ee(mi, "id", "arc"), Ee(mi, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), Ee(mi, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), Ee(mi, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash"
});
function oh(e, n) {
  const { x: t, y: o, base: i, width: r, height: a } = e.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], n);
  let l, s, u, d, f;
  return e.horizontal ? (f = a / 2, l = Math.min(t, i), s = Math.max(t, i), u = o - f, d = o + f) : (f = r / 2, l = t - f, s = t + f, u = Math.min(o, i), d = Math.max(o, i)), {
    left: l,
    top: u,
    right: s,
    bottom: d
  };
}
function qn(e, n, t, o) {
  return e ? 0 : Ht(n, t, o);
}
function V$(e, n, t) {
  const o = e.options.borderWidth, i = e.borderSkipped, r = Bf(o);
  return {
    t: qn(i.top, r.top, 0, t),
    r: qn(i.right, r.right, 0, n),
    b: qn(i.bottom, r.bottom, 0, t),
    l: qn(i.left, r.left, 0, n)
  };
}
function j$(e, n, t) {
  const { enableBorderRadius: o } = e.getProps([
    "enableBorderRadius"
  ]), i = e.options.borderRadius, r = go(i), a = Math.min(n, t), l = e.borderSkipped, s = o || Ue(i);
  return {
    topLeft: qn(!s || l.top || l.left, r.topLeft, 0, a),
    topRight: qn(!s || l.top || l.right, r.topRight, 0, a),
    bottomLeft: qn(!s || l.bottom || l.left, r.bottomLeft, 0, a),
    bottomRight: qn(!s || l.bottom || l.right, r.bottomRight, 0, a)
  };
}
function H$(e) {
  const n = oh(e), t = n.right - n.left, o = n.bottom - n.top, i = V$(e, t / 2, o / 2), r = j$(e, t / 2, o / 2);
  return {
    outer: {
      x: n.left,
      y: n.top,
      w: t,
      h: o,
      radius: r
    },
    inner: {
      x: n.left + i.l,
      y: n.top + i.t,
      w: t - i.l - i.r,
      h: o - i.t - i.b,
      radius: {
        topLeft: Math.max(0, r.topLeft - Math.max(i.t, i.l)),
        topRight: Math.max(0, r.topRight - Math.max(i.t, i.r)),
        bottomLeft: Math.max(0, r.bottomLeft - Math.max(i.b, i.l)),
        bottomRight: Math.max(0, r.bottomRight - Math.max(i.b, i.r))
      }
    }
  };
}
function ll(e, n, t, o) {
  const i = n === null, r = t === null, l = e && !(i && r) && oh(e, o);
  return l && (i || fo(n, l.left, l.right)) && (r || fo(t, l.top, l.bottom));
}
function z$(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function q$(e, n) {
  e.rect(n.x, n.y, n.w, n.h);
}
function sl(e, n, t = {}) {
  const o = e.x !== t.x ? -n : 0, i = e.y !== t.y ? -n : 0, r = (e.x + e.w !== t.x + t.w ? n : 0) - o, a = (e.y + e.h !== t.y + t.h ? n : 0) - i;
  return {
    x: e.x + o,
    y: e.y + i,
    w: e.w + r,
    h: e.h + a,
    radius: e.radius
  };
}
class Nr extends _o {
  constructor(n) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, n && Object.assign(this, n);
  }
  draw(n) {
    const { inflateAmount: t, options: { borderColor: o, backgroundColor: i } } = this, { inner: r, outer: a } = H$(this), l = z$(a.radius) ? Ni : q$;
    n.save(), (a.w !== r.w || a.h !== r.h) && (n.beginPath(), l(n, sl(a, t, r)), n.clip(), l(n, sl(r, -t, a)), n.fillStyle = o, n.fill("evenodd")), n.beginPath(), l(n, sl(r, t)), n.fillStyle = i, n.fill(), n.restore();
  }
  inRange(n, t, o) {
    return ll(this, n, t, o);
  }
  inXRange(n, t) {
    return ll(this, n, null, t);
  }
  inYRange(n, t) {
    return ll(this, null, n, t);
  }
  getCenterPoint(n) {
    const { x: t, y: o, base: i, horizontal: r } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], n);
    return {
      x: r ? (t + i) / 2 : t,
      y: r ? o : (o + i) / 2
    };
  }
  getRange(n) {
    return n === "x" ? this.width / 2 : this.height / 2;
  }
}
Ee(Nr, "id", "bar"), Ee(Nr, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), Ee(Nr, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const Cc = (e, n) => {
  let { boxHeight: t = n, boxWidth: o = n } = e;
  return e.usePointStyle && (t = Math.min(t, n), o = e.pointStyleWidth || Math.min(o, n)), {
    boxWidth: o,
    boxHeight: t,
    itemHeight: Math.max(n, t)
  };
}, U$ = (e, n) => e !== null && n !== null && e.datasetIndex === n.datasetIndex && e.index === n.index;
class xc extends _o {
  constructor(n) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = n.chart, this.options = n.options, this.ctx = n.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(n, t, o) {
    this.maxWidth = n, this.maxHeight = t, this._margins = o, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const n = this.options.labels || {};
    let t = at(n.generateLabels, [
      this.chart
    ], this) || [];
    n.filter && (t = t.filter((o) => n.filter(o, this.chart.data))), n.sort && (t = t.sort((o, i) => n.sort(o, i, this.chart.data))), this.options.reverse && t.reverse(), this.legendItems = t;
  }
  fit() {
    const { options: n, ctx: t } = this;
    if (!n.display) {
      this.width = this.height = 0;
      return;
    }
    const o = n.labels, i = xt(o.font), r = i.size, a = this._computeTitleHeight(), { boxWidth: l, itemHeight: s } = Cc(o, r);
    let u, d;
    t.font = i.string, this.isHorizontal() ? (u = this.maxWidth, d = this._fitRows(a, r, l, s) + 10) : (d = this.maxHeight, u = this._fitCols(a, i, l, s) + 10), this.width = Math.min(u, n.maxWidth || this.maxWidth), this.height = Math.min(d, n.maxHeight || this.maxHeight);
  }
  _fitRows(n, t, o, i) {
    const { ctx: r, maxWidth: a, options: { labels: { padding: l } } } = this, s = this.legendHitBoxes = [], u = this.lineWidths = [
      0
    ], d = i + l;
    let f = n;
    r.textAlign = "left", r.textBaseline = "middle";
    let c = -1, h = -d;
    return this.legendItems.forEach((m, g) => {
      const v = o + t / 2 + r.measureText(m.text).width;
      (g === 0 || u[u.length - 1] + v + 2 * l > a) && (f += d, u[u.length - (g > 0 ? 0 : 1)] = 0, h += d, c++), s[g] = {
        left: 0,
        top: h,
        row: c,
        width: v,
        height: i
      }, u[u.length - 1] += v + l;
    }), f;
  }
  _fitCols(n, t, o, i) {
    const { ctx: r, maxHeight: a, options: { labels: { padding: l } } } = this, s = this.legendHitBoxes = [], u = this.columnSizes = [], d = a - n;
    let f = l, c = 0, h = 0, m = 0, g = 0;
    return this.legendItems.forEach((v, p) => {
      const { itemWidth: y, itemHeight: C } = W$(o, t, r, v, i);
      p > 0 && h + C + 2 * l > d && (f += c + l, u.push({
        width: c,
        height: h
      }), m += c + l, g++, c = h = 0), s[p] = {
        left: m,
        top: h,
        col: g,
        width: y,
        height: C
      }, c = Math.max(c, y), h += C + l;
    }), f += c, u.push({
      width: c,
      height: h
    }), f;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const n = this._computeTitleHeight(), { legendHitBoxes: t, options: { align: o, labels: { padding: i }, rtl: r } } = this, a = zo(r, this.left, this.width);
    if (this.isHorizontal()) {
      let l = 0, s = St(o, this.left + i, this.right - this.lineWidths[l]);
      for (const u of t)
        l !== u.row && (l = u.row, s = St(o, this.left + i, this.right - this.lineWidths[l])), u.top += this.top + n + i, u.left = a.leftForLtr(a.x(s), u.width), s += u.width + i;
    } else {
      let l = 0, s = St(o, this.top + n + i, this.bottom - this.columnSizes[l].height);
      for (const u of t)
        u.col !== l && (l = u.col, s = St(o, this.top + n + i, this.bottom - this.columnSizes[l].height)), u.top = s, u.left += this.left + i, u.left = a.leftForLtr(a.x(u.left), u.width), s += u.height + i;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const n = this.ctx;
      Ds(n, this), this._draw(), Ls(n);
    }
  }
  _draw() {
    const { options: n, columnSizes: t, lineWidths: o, ctx: i } = this, { align: r, labels: a } = n, l = gt.color, s = zo(n.rtl, this.left, this.width), u = xt(a.font), { padding: d } = a, f = u.size, c = f / 2;
    let h;
    this.drawTitle(), i.textAlign = s.textAlign("left"), i.textBaseline = "middle", i.lineWidth = 0.5, i.font = u.string;
    const { boxWidth: m, boxHeight: g, itemHeight: v } = Cc(a, f), p = function(w, $, E) {
      if (isNaN(m) || m <= 0 || isNaN(g) || g < 0)
        return;
      i.save();
      const A = Je(E.lineWidth, 1);
      if (i.fillStyle = Je(E.fillStyle, l), i.lineCap = Je(E.lineCap, "butt"), i.lineDashOffset = Je(E.lineDashOffset, 0), i.lineJoin = Je(E.lineJoin, "miter"), i.lineWidth = A, i.strokeStyle = Je(E.strokeStyle, l), i.setLineDash(Je(E.lineDash, [])), a.usePointStyle) {
        const O = {
          radius: g * Math.SQRT2 / 2,
          pointStyle: E.pointStyle,
          rotation: E.rotation,
          borderWidth: A
        }, k = s.xPlus(w, m / 2), S = $ + c;
        Rf(i, O, k, S, a.pointStyleWidth && m);
      } else {
        const O = $ + Math.max((f - g) / 2, 0), k = s.leftForLtr(w, m), S = go(E.borderRadius);
        i.beginPath(), Object.values(S).some((T) => T !== 0) ? Ni(i, {
          x: k,
          y: O,
          w: m,
          h: g,
          radius: S
        }) : i.rect(k, O, m, g), i.fill(), A !== 0 && i.stroke();
      }
      i.restore();
    }, y = function(w, $, E) {
      xo(i, E.text, w, $ + v / 2, u, {
        strikethrough: E.hidden,
        textAlign: s.textAlign(E.textAlign)
      });
    }, C = this.isHorizontal(), b = this._computeTitleHeight();
    C ? h = {
      x: St(r, this.left + d, this.right - o[0]),
      y: this.top + d + b,
      line: 0
    } : h = {
      x: this.left + d,
      y: St(r, this.top + b + d, this.bottom - t[0].height),
      line: 0
    }, qf(this.ctx, n.textDirection);
    const x = v + d;
    this.legendItems.forEach((w, $) => {
      i.strokeStyle = w.fontColor, i.fillStyle = w.fontColor;
      const E = i.measureText(w.text).width, A = s.textAlign(w.textAlign || (w.textAlign = a.textAlign)), O = m + c + E;
      let k = h.x, S = h.y;
      s.setWidth(this.width), C ? $ > 0 && k + O + d > this.right && (S = h.y += x, h.line++, k = h.x = St(r, this.left + d, this.right - o[h.line])) : $ > 0 && S + x > this.bottom && (k = h.x = k + t[h.line].width + d, h.line++, S = h.y = St(r, this.top + b + d, this.bottom - t[h.line].height));
      const T = s.x(k);
      if (p(T, S, w), k = Ox(A, k + m + c, C ? k + O : this.right, n.rtl), y(s.x(k), S, w), C)
        h.x += O + d;
      else if (typeof w.text != "string") {
        const L = u.lineHeight;
        h.y += ih(w, L) + d;
      } else
        h.y += x;
    }), Uf(this.ctx, n.textDirection);
  }
  drawTitle() {
    const n = this.options, t = n.title, o = xt(t.font), i = It(t.padding);
    if (!t.display)
      return;
    const r = zo(n.rtl, this.left, this.width), a = this.ctx, l = t.position, s = o.size / 2, u = i.top + s;
    let d, f = this.left, c = this.width;
    if (this.isHorizontal())
      c = Math.max(...this.lineWidths), d = this.top + u, f = St(n.align, f, this.right - c);
    else {
      const m = this.columnSizes.reduce((g, v) => Math.max(g, v.height), 0);
      d = u + St(n.align, this.top, this.bottom - m - n.labels.padding - this._computeTitleHeight());
    }
    const h = St(l, f, f + c);
    a.textAlign = r.textAlign(Is(l)), a.textBaseline = "middle", a.strokeStyle = t.color, a.fillStyle = t.color, a.font = o.string, xo(a, t.text, h, d, o);
  }
  _computeTitleHeight() {
    const n = this.options.title, t = xt(n.font), o = It(n.padding);
    return n.display ? t.lineHeight + o.height : 0;
  }
  _getLegendItemAt(n, t) {
    let o, i, r;
    if (fo(n, this.left, this.right) && fo(t, this.top, this.bottom)) {
      for (r = this.legendHitBoxes, o = 0; o < r.length; ++o)
        if (i = r[o], fo(n, i.left, i.left + i.width) && fo(t, i.top, i.top + i.height))
          return this.legendItems[o];
    }
    return null;
  }
  handleEvent(n) {
    const t = this.options;
    if (!G$(n.type, t))
      return;
    const o = this._getLegendItemAt(n.x, n.y);
    if (n.type === "mousemove" || n.type === "mouseout") {
      const i = this._hoveredItem, r = U$(i, o);
      i && !r && at(t.onLeave, [
        n,
        i,
        this
      ], this), this._hoveredItem = o, o && !r && at(t.onHover, [
        n,
        o,
        this
      ], this);
    } else
      o && at(t.onClick, [
        n,
        o,
        this
      ], this);
  }
}
function W$(e, n, t, o, i) {
  const r = K$(o, e, n, t), a = Y$(i, o, n.lineHeight);
  return {
    itemWidth: r,
    itemHeight: a
  };
}
function K$(e, n, t, o) {
  let i = e.text;
  return i && typeof i != "string" && (i = i.reduce((r, a) => r.length > a.length ? r : a)), n + t.size / 2 + o.measureText(i).width;
}
function Y$(e, n, t) {
  let o = e;
  return typeof n.text != "string" && (o = ih(n, t)), o;
}
function ih(e, n) {
  const t = e.text ? e.text.length : 0;
  return n * t;
}
function G$(e, n) {
  return !!((e === "mousemove" || e === "mouseout") && (n.onHover || n.onLeave) || n.onClick && (e === "click" || e === "mouseup"));
}
var Z$ = {
  id: "legend",
  _element: xc,
  start(e, n, t) {
    const o = e.legend = new xc({
      ctx: e.ctx,
      options: t,
      chart: e
    });
    en.configure(e, o, t), en.addBox(e, o);
  },
  stop(e) {
    en.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, n, t) {
    const o = e.legend;
    en.configure(e, o, t), o.options = t;
  },
  afterUpdate(e) {
    const n = e.legend;
    n.buildLabels(), n.adjustHitBoxes();
  },
  afterEvent(e, n) {
    n.replay || e.legend.handleEvent(n.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, n, t) {
      const o = n.datasetIndex, i = t.chart;
      i.isDatasetVisible(o) ? (i.hide(o), n.hidden = !0) : (i.show(o), n.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const n = e.data.datasets, { labels: { usePointStyle: t, pointStyle: o, textAlign: i, color: r, useBorderRadius: a, borderRadius: l } } = e.legend.options;
        return e._getSortedDatasetMetas().map((s) => {
          const u = s.controller.getStyle(t ? 0 : void 0), d = It(u.borderWidth);
          return {
            text: n[s.index].label,
            fillStyle: u.backgroundColor,
            fontColor: r,
            hidden: !s.visible,
            lineCap: u.borderCapStyle,
            lineDash: u.borderDash,
            lineDashOffset: u.borderDashOffset,
            lineJoin: u.borderJoinStyle,
            lineWidth: (d.width + d.height) / 4,
            strokeStyle: u.borderColor,
            pointStyle: o || u.pointStyle,
            rotation: u.rotation,
            textAlign: i || u.textAlign,
            borderRadius: a && (l || u.borderRadius),
            datasetIndex: s.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(e)
    }
  }
};
class rh extends _o {
  constructor(n) {
    super(), this.chart = n.chart, this.options = n.options, this.ctx = n.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(n, t) {
    const o = this.options;
    if (this.left = 0, this.top = 0, !o.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = n, this.height = this.bottom = t;
    const i = dt(o.text) ? o.text.length : 1;
    this._padding = It(o.padding);
    const r = i * xt(o.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = r : this.width = r;
  }
  isHorizontal() {
    const n = this.options.position;
    return n === "top" || n === "bottom";
  }
  _drawArgs(n) {
    const { top: t, left: o, bottom: i, right: r, options: a } = this, l = a.align;
    let s = 0, u, d, f;
    return this.isHorizontal() ? (d = St(l, o, r), f = t + n, u = r - o) : (a.position === "left" ? (d = o + n, f = St(l, i, t), s = mt * -0.5) : (d = r - n, f = St(l, t, i), s = mt * 0.5), u = i - t), {
      titleX: d,
      titleY: f,
      maxWidth: u,
      rotation: s
    };
  }
  draw() {
    const n = this.ctx, t = this.options;
    if (!t.display)
      return;
    const o = xt(t.font), r = o.lineHeight / 2 + this._padding.top, { titleX: a, titleY: l, maxWidth: s, rotation: u } = this._drawArgs(r);
    xo(n, t.text, 0, 0, o, {
      color: t.color,
      maxWidth: s,
      rotation: u,
      textAlign: Is(t.align),
      textBaseline: "middle",
      translation: [
        a,
        l
      ]
    });
  }
}
function X$(e, n) {
  const t = new rh({
    ctx: e.ctx,
    options: n,
    chart: e
  });
  en.configure(e, t, n), en.addBox(e, t), e.titleBlock = t;
}
var J$ = {
  id: "title",
  _element: rh,
  start(e, n, t) {
    X$(e, t);
  },
  stop(e) {
    const n = e.titleBlock;
    en.removeBox(e, n), delete e.titleBlock;
  },
  beforeUpdate(e, n, t) {
    const o = e.titleBlock;
    en.configure(e, o, t), o.options = t;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const pi = {
  average(e) {
    if (!e.length)
      return !1;
    let n, t, o = /* @__PURE__ */ new Set(), i = 0, r = 0;
    for (n = 0, t = e.length; n < t; ++n) {
      const l = e[n].element;
      if (l && l.hasValue()) {
        const s = l.tooltipPosition();
        o.add(s.x), i += s.y, ++r;
      }
    }
    return r === 0 || o.size === 0 ? !1 : {
      x: [
        ...o
      ].reduce((l, s) => l + s) / o.size,
      y: i / r
    };
  },
  nearest(e, n) {
    if (!e.length)
      return !1;
    let t = n.x, o = n.y, i = Number.POSITIVE_INFINITY, r, a, l;
    for (r = 0, a = e.length; r < a; ++r) {
      const s = e[r].element;
      if (s && s.hasValue()) {
        const u = s.getCenterPoint(), d = yx(n, u);
        d < i && (i = d, l = s);
      }
    }
    if (l) {
      const s = l.tooltipPosition();
      t = s.x, o = s.y;
    }
    return {
      x: t,
      y: o
    };
  }
};
function fn(e, n) {
  return n && (dt(n) ? Array.prototype.push.apply(e, n) : e.push(n)), e;
}
function En(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function Q$(e, n) {
  const { element: t, datasetIndex: o, index: i } = n, r = e.getDatasetMeta(o).controller, { label: a, value: l } = r.getLabelAndValue(i);
  return {
    chart: e,
    label: a,
    parsed: r.getParsed(i),
    raw: e.data.datasets[o].data[i],
    formattedValue: l,
    dataset: r.getDataset(),
    dataIndex: i,
    datasetIndex: o,
    element: t
  };
}
function wc(e, n) {
  const t = e.chart.ctx, { body: o, footer: i, title: r } = e, { boxWidth: a, boxHeight: l } = n, s = xt(n.bodyFont), u = xt(n.titleFont), d = xt(n.footerFont), f = r.length, c = i.length, h = o.length, m = It(n.padding);
  let g = m.height, v = 0, p = o.reduce((b, x) => b + x.before.length + x.lines.length + x.after.length, 0);
  if (p += e.beforeBody.length + e.afterBody.length, f && (g += f * u.lineHeight + (f - 1) * n.titleSpacing + n.titleMarginBottom), p) {
    const b = n.displayColors ? Math.max(l, s.lineHeight) : s.lineHeight;
    g += h * b + (p - h) * s.lineHeight + (p - 1) * n.bodySpacing;
  }
  c && (g += n.footerMarginTop + c * d.lineHeight + (c - 1) * n.footerSpacing);
  let y = 0;
  const C = function(b) {
    v = Math.max(v, t.measureText(b).width + y);
  };
  return t.save(), t.font = u.string, nt(e.title, C), t.font = s.string, nt(e.beforeBody.concat(e.afterBody), C), y = n.displayColors ? a + 2 + n.boxPadding : 0, nt(o, (b) => {
    nt(b.before, C), nt(b.lines, C), nt(b.after, C);
  }), y = 0, t.font = d.string, nt(e.footer, C), t.restore(), v += m.width, {
    width: v,
    height: g
  };
}
function ek(e, n) {
  const { y: t, height: o } = n;
  return t < o / 2 ? "top" : t > e.height - o / 2 ? "bottom" : "center";
}
function tk(e, n, t, o) {
  const { x: i, width: r } = o, a = t.caretSize + t.caretPadding;
  if (e === "left" && i + r + a > n.width || e === "right" && i - r - a < 0)
    return !0;
}
function nk(e, n, t, o) {
  const { x: i, width: r } = t, { width: a, chartArea: { left: l, right: s } } = e;
  let u = "center";
  return o === "center" ? u = i <= (l + s) / 2 ? "left" : "right" : i <= r / 2 ? u = "left" : i >= a - r / 2 && (u = "right"), tk(u, e, n, t) && (u = "center"), u;
}
function $c(e, n, t) {
  const o = t.yAlign || n.yAlign || ek(e, t);
  return {
    xAlign: t.xAlign || n.xAlign || nk(e, n, t, o),
    yAlign: o
  };
}
function ok(e, n) {
  let { x: t, width: o } = e;
  return n === "right" ? t -= o : n === "center" && (t -= o / 2), t;
}
function ik(e, n, t) {
  let { y: o, height: i } = e;
  return n === "top" ? o += t : n === "bottom" ? o -= i + t : o -= i / 2, o;
}
function kc(e, n, t, o) {
  const { caretSize: i, caretPadding: r, cornerRadius: a } = e, { xAlign: l, yAlign: s } = t, u = i + r, { topLeft: d, topRight: f, bottomLeft: c, bottomRight: h } = go(a);
  let m = ok(n, l);
  const g = ik(n, s, u);
  return s === "center" ? l === "left" ? m += u : l === "right" && (m -= u) : l === "left" ? m -= Math.max(d, c) + i : l === "right" && (m += Math.max(f, h) + i), {
    x: Ht(m, 0, o.width - n.width),
    y: Ht(g, 0, o.height - n.height)
  };
}
function wr(e, n, t) {
  const o = It(t.padding);
  return n === "center" ? e.x + e.width / 2 : n === "right" ? e.x + e.width - o.right : e.x + o.left;
}
function _c(e) {
  return fn([], En(e));
}
function rk(e, n, t) {
  return ko(e, {
    tooltip: n,
    tooltipItems: t,
    type: "tooltip"
  });
}
function Oc(e, n) {
  const t = n && n.dataset && n.dataset.tooltip && n.dataset.tooltip.callbacks;
  return t ? e.override(t) : e;
}
const ah = {
  beforeTitle: kn,
  title(e) {
    if (e.length > 0) {
      const n = e[0], t = n.chart.data.labels, o = t ? t.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return n.dataset.label || "";
      if (n.label)
        return n.label;
      if (o > 0 && n.dataIndex < o)
        return t[n.dataIndex];
    }
    return "";
  },
  afterTitle: kn,
  beforeBody: kn,
  beforeLabel: kn,
  label(e) {
    if (this && this.options && this.options.mode === "dataset")
      return e.label + ": " + e.formattedValue || e.formattedValue;
    let n = e.dataset.label || "";
    n && (n += ": ");
    const t = e.formattedValue;
    return lt(t) || (n += t), n;
  },
  labelColor(e) {
    const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      borderColor: t.borderColor,
      backgroundColor: t.backgroundColor,
      borderWidth: t.borderWidth,
      borderDash: t.borderDash,
      borderDashOffset: t.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(e) {
    const t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
    return {
      pointStyle: t.pointStyle,
      rotation: t.rotation
    };
  },
  afterLabel: kn,
  afterBody: kn,
  beforeFooter: kn,
  footer: kn,
  afterFooter: kn
};
function Bt(e, n, t, o) {
  const i = e[n].call(t, o);
  return typeof i > "u" ? ah[n].call(t, o) : i;
}
class Wl extends _o {
  constructor(n) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = n.chart, this.options = n.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(n) {
    this.options = n, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const n = this._cachedAnimations;
    if (n)
      return n;
    const t = this.chart, o = this.options.setContext(this.getContext()), i = o.enabled && t.options.animation && o.animations, r = new Wf(this.chart, i);
    return i._cacheable && (this._cachedAnimations = Object.freeze(r)), r;
  }
  getContext() {
    return this.$context || (this.$context = rk(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(n, t) {
    const { callbacks: o } = t, i = Bt(o, "beforeTitle", this, n), r = Bt(o, "title", this, n), a = Bt(o, "afterTitle", this, n);
    let l = [];
    return l = fn(l, En(i)), l = fn(l, En(r)), l = fn(l, En(a)), l;
  }
  getBeforeBody(n, t) {
    return _c(Bt(t.callbacks, "beforeBody", this, n));
  }
  getBody(n, t) {
    const { callbacks: o } = t, i = [];
    return nt(n, (r) => {
      const a = {
        before: [],
        lines: [],
        after: []
      }, l = Oc(o, r);
      fn(a.before, En(Bt(l, "beforeLabel", this, r))), fn(a.lines, Bt(l, "label", this, r)), fn(a.after, En(Bt(l, "afterLabel", this, r))), i.push(a);
    }), i;
  }
  getAfterBody(n, t) {
    return _c(Bt(t.callbacks, "afterBody", this, n));
  }
  getFooter(n, t) {
    const { callbacks: o } = t, i = Bt(o, "beforeFooter", this, n), r = Bt(o, "footer", this, n), a = Bt(o, "afterFooter", this, n);
    let l = [];
    return l = fn(l, En(i)), l = fn(l, En(r)), l = fn(l, En(a)), l;
  }
  _createItems(n) {
    const t = this._active, o = this.chart.data, i = [], r = [], a = [];
    let l = [], s, u;
    for (s = 0, u = t.length; s < u; ++s)
      l.push(Q$(this.chart, t[s]));
    return n.filter && (l = l.filter((d, f, c) => n.filter(d, f, c, o))), n.itemSort && (l = l.sort((d, f) => n.itemSort(d, f, o))), nt(l, (d) => {
      const f = Oc(n.callbacks, d);
      i.push(Bt(f, "labelColor", this, d)), r.push(Bt(f, "labelPointStyle", this, d)), a.push(Bt(f, "labelTextColor", this, d));
    }), this.labelColors = i, this.labelPointStyles = r, this.labelTextColors = a, this.dataPoints = l, l;
  }
  update(n, t) {
    const o = this.options.setContext(this.getContext()), i = this._active;
    let r, a = [];
    if (!i.length)
      this.opacity !== 0 && (r = {
        opacity: 0
      });
    else {
      const l = pi[o.position].call(this, i, this._eventPosition);
      a = this._createItems(o), this.title = this.getTitle(a, o), this.beforeBody = this.getBeforeBody(a, o), this.body = this.getBody(a, o), this.afterBody = this.getAfterBody(a, o), this.footer = this.getFooter(a, o);
      const s = this._size = wc(this, o), u = Object.assign({}, l, s), d = $c(this.chart, o, u), f = kc(o, u, d, this.chart);
      this.xAlign = d.xAlign, this.yAlign = d.yAlign, r = {
        opacity: 1,
        x: f.x,
        y: f.y,
        width: s.width,
        height: s.height,
        caretX: l.x,
        caretY: l.y
      };
    }
    this._tooltipItems = a, this.$context = void 0, r && this._resolveAnimations().update(this, r), n && o.external && o.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: t
    });
  }
  drawCaret(n, t, o, i) {
    const r = this.getCaretPosition(n, o, i);
    t.lineTo(r.x1, r.y1), t.lineTo(r.x2, r.y2), t.lineTo(r.x3, r.y3);
  }
  getCaretPosition(n, t, o) {
    const { xAlign: i, yAlign: r } = this, { caretSize: a, cornerRadius: l } = o, { topLeft: s, topRight: u, bottomLeft: d, bottomRight: f } = go(l), { x: c, y: h } = n, { width: m, height: g } = t;
    let v, p, y, C, b, x;
    return r === "center" ? (b = h + g / 2, i === "left" ? (v = c, p = v - a, C = b + a, x = b - a) : (v = c + m, p = v + a, C = b - a, x = b + a), y = v) : (i === "left" ? p = c + Math.max(s, d) + a : i === "right" ? p = c + m - Math.max(u, f) - a : p = this.caretX, r === "top" ? (C = h, b = C - a, v = p - a, y = p + a) : (C = h + g, b = C + a, v = p + a, y = p - a), x = C), {
      x1: v,
      x2: p,
      x3: y,
      y1: C,
      y2: b,
      y3: x
    };
  }
  drawTitle(n, t, o) {
    const i = this.title, r = i.length;
    let a, l, s;
    if (r) {
      const u = zo(o.rtl, this.x, this.width);
      for (n.x = wr(this, o.titleAlign, o), t.textAlign = u.textAlign(o.titleAlign), t.textBaseline = "middle", a = xt(o.titleFont), l = o.titleSpacing, t.fillStyle = o.titleColor, t.font = a.string, s = 0; s < r; ++s)
        t.fillText(i[s], u.x(n.x), n.y + a.lineHeight / 2), n.y += a.lineHeight + l, s + 1 === r && (n.y += o.titleMarginBottom - l);
    }
  }
  _drawColorBox(n, t, o, i, r) {
    const a = this.labelColors[o], l = this.labelPointStyles[o], { boxHeight: s, boxWidth: u } = r, d = xt(r.bodyFont), f = wr(this, "left", r), c = i.x(f), h = s < d.lineHeight ? (d.lineHeight - s) / 2 : 0, m = t.y + h;
    if (r.usePointStyle) {
      const g = {
        radius: Math.min(u, s) / 2,
        pointStyle: l.pointStyle,
        rotation: l.rotation,
        borderWidth: 1
      }, v = i.leftForLtr(c, u) + u / 2, p = m + s / 2;
      n.strokeStyle = r.multiKeyBackground, n.fillStyle = r.multiKeyBackground, qd(n, g, v, p), n.strokeStyle = a.borderColor, n.fillStyle = a.backgroundColor, qd(n, g, v, p);
    } else {
      n.lineWidth = Ue(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, n.strokeStyle = a.borderColor, n.setLineDash(a.borderDash || []), n.lineDashOffset = a.borderDashOffset || 0;
      const g = i.leftForLtr(c, u), v = i.leftForLtr(i.xPlus(c, 1), u - 2), p = go(a.borderRadius);
      Object.values(p).some((y) => y !== 0) ? (n.beginPath(), n.fillStyle = r.multiKeyBackground, Ni(n, {
        x: g,
        y: m,
        w: u,
        h: s,
        radius: p
      }), n.fill(), n.stroke(), n.fillStyle = a.backgroundColor, n.beginPath(), Ni(n, {
        x: v,
        y: m + 1,
        w: u - 2,
        h: s - 2,
        radius: p
      }), n.fill()) : (n.fillStyle = r.multiKeyBackground, n.fillRect(g, m, u, s), n.strokeRect(g, m, u, s), n.fillStyle = a.backgroundColor, n.fillRect(v, m + 1, u - 2, s - 2));
    }
    n.fillStyle = this.labelTextColors[o];
  }
  drawBody(n, t, o) {
    const { body: i } = this, { bodySpacing: r, bodyAlign: a, displayColors: l, boxHeight: s, boxWidth: u, boxPadding: d } = o, f = xt(o.bodyFont);
    let c = f.lineHeight, h = 0;
    const m = zo(o.rtl, this.x, this.width), g = function(E) {
      t.fillText(E, m.x(n.x + h), n.y + c / 2), n.y += c + r;
    }, v = m.textAlign(a);
    let p, y, C, b, x, w, $;
    for (t.textAlign = a, t.textBaseline = "middle", t.font = f.string, n.x = wr(this, v, o), t.fillStyle = o.bodyColor, nt(this.beforeBody, g), h = l && v !== "right" ? a === "center" ? u / 2 + d : u + 2 + d : 0, b = 0, w = i.length; b < w; ++b) {
      for (p = i[b], y = this.labelTextColors[b], t.fillStyle = y, nt(p.before, g), C = p.lines, l && C.length && (this._drawColorBox(t, n, b, m, o), c = Math.max(f.lineHeight, s)), x = 0, $ = C.length; x < $; ++x)
        g(C[x]), c = f.lineHeight;
      nt(p.after, g);
    }
    h = 0, c = f.lineHeight, nt(this.afterBody, g), n.y -= r;
  }
  drawFooter(n, t, o) {
    const i = this.footer, r = i.length;
    let a, l;
    if (r) {
      const s = zo(o.rtl, this.x, this.width);
      for (n.x = wr(this, o.footerAlign, o), n.y += o.footerMarginTop, t.textAlign = s.textAlign(o.footerAlign), t.textBaseline = "middle", a = xt(o.footerFont), t.fillStyle = o.footerColor, t.font = a.string, l = 0; l < r; ++l)
        t.fillText(i[l], s.x(n.x), n.y + a.lineHeight / 2), n.y += a.lineHeight + o.footerSpacing;
    }
  }
  drawBackground(n, t, o, i) {
    const { xAlign: r, yAlign: a } = this, { x: l, y: s } = n, { width: u, height: d } = o, { topLeft: f, topRight: c, bottomLeft: h, bottomRight: m } = go(i.cornerRadius);
    t.fillStyle = i.backgroundColor, t.strokeStyle = i.borderColor, t.lineWidth = i.borderWidth, t.beginPath(), t.moveTo(l + f, s), a === "top" && this.drawCaret(n, t, o, i), t.lineTo(l + u - c, s), t.quadraticCurveTo(l + u, s, l + u, s + c), a === "center" && r === "right" && this.drawCaret(n, t, o, i), t.lineTo(l + u, s + d - m), t.quadraticCurveTo(l + u, s + d, l + u - m, s + d), a === "bottom" && this.drawCaret(n, t, o, i), t.lineTo(l + h, s + d), t.quadraticCurveTo(l, s + d, l, s + d - h), a === "center" && r === "left" && this.drawCaret(n, t, o, i), t.lineTo(l, s + f), t.quadraticCurveTo(l, s, l + f, s), t.closePath(), t.fill(), i.borderWidth > 0 && t.stroke();
  }
  _updateAnimationTarget(n) {
    const t = this.chart, o = this.$animations, i = o && o.x, r = o && o.y;
    if (i || r) {
      const a = pi[n.position].call(this, this._active, this._eventPosition);
      if (!a)
        return;
      const l = this._size = wc(this, n), s = Object.assign({}, a, this._size), u = $c(t, n, s), d = kc(n, s, u, t);
      (i._to !== d.x || r._to !== d.y) && (this.xAlign = u.xAlign, this.yAlign = u.yAlign, this.width = l.width, this.height = l.height, this.caretX = a.x, this.caretY = a.y, this._resolveAnimations().update(this, d));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(n) {
    const t = this.options.setContext(this.getContext());
    let o = this.opacity;
    if (!o)
      return;
    this._updateAnimationTarget(t);
    const i = {
      width: this.width,
      height: this.height
    }, r = {
      x: this.x,
      y: this.y
    };
    o = Math.abs(o) < 1e-3 ? 0 : o;
    const a = It(t.padding), l = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    t.enabled && l && (n.save(), n.globalAlpha = o, this.drawBackground(r, n, i, t), qf(n, t.textDirection), r.y += a.top, this.drawTitle(r, n, t), this.drawBody(r, n, t), this.drawFooter(r, n, t), Uf(n, t.textDirection), n.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(n, t) {
    const o = this._active, i = n.map(({ datasetIndex: l, index: s }) => {
      const u = this.chart.getDatasetMeta(l);
      if (!u)
        throw new Error("Cannot find a dataset at index " + l);
      return {
        datasetIndex: l,
        element: u.data[s],
        index: s
      };
    }), r = !Wr(o, i), a = this._positionChanged(i, t);
    (r || a) && (this._active = i, this._eventPosition = t, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(n, t, o = !0) {
    if (t && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const i = this.options, r = this._active || [], a = this._getActiveElements(n, r, t, o), l = this._positionChanged(a, n), s = t || !Wr(a, r) || l;
    return s && (this._active = a, (i.enabled || i.external) && (this._eventPosition = {
      x: n.x,
      y: n.y
    }, this.update(!0, t))), s;
  }
  _getActiveElements(n, t, o, i) {
    const r = this.options;
    if (n.type === "mouseout")
      return [];
    if (!i)
      return t.filter((l) => this.chart.data.datasets[l.datasetIndex] && this.chart.getDatasetMeta(l.datasetIndex).controller.getParsed(l.index) !== void 0);
    const a = this.chart.getElementsAtEventForMode(n, r.mode, r, o);
    return r.reverse && a.reverse(), a;
  }
  _positionChanged(n, t) {
    const { caretX: o, caretY: i, options: r } = this, a = pi[r.position].call(this, n, t);
    return a !== !1 && (o !== a.x || i !== a.y);
  }
}
Ee(Wl, "positioners", pi);
var ak = {
  id: "tooltip",
  _element: Wl,
  positioners: pi,
  afterInit(e, n, t) {
    t && (e.tooltip = new Wl({
      chart: e,
      options: t
    }));
  },
  beforeUpdate(e, n, t) {
    e.tooltip && e.tooltip.initialize(t);
  },
  reset(e, n, t) {
    e.tooltip && e.tooltip.initialize(t);
  },
  afterDraw(e) {
    const n = e.tooltip;
    if (n && n._willRender()) {
      const t = {
        tooltip: n
      };
      if (e.notifyPlugins("beforeTooltipDraw", {
        ...t,
        cancelable: !0
      }) === !1)
        return;
      n.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", t);
    }
  },
  afterEvent(e, n) {
    if (e.tooltip) {
      const t = n.replay;
      e.tooltip.handleEvent(n.event, t, n.inChartArea) && (n.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, n) => n.bodyFont.size,
    boxWidth: (e, n) => n.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: ah
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const lk = (e, n, t, o) => (typeof n == "string" ? (t = e.push(n) - 1, o.unshift({
  index: t,
  label: n
})) : isNaN(n) && (t = null), t);
function sk(e, n, t, o) {
  const i = e.indexOf(n);
  if (i === -1)
    return lk(e, n, t, o);
  const r = e.lastIndexOf(n);
  return i !== r ? t : i;
}
const uk = (e, n) => e === null ? null : Ht(Math.round(e), 0, n);
function Ec(e) {
  const n = this.getLabels();
  return e >= 0 && e < n.length ? n[e] : e;
}
class Kl extends Oo {
  constructor(n) {
    super(n), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(n) {
    const t = this._addedLabels;
    if (t.length) {
      const o = this.getLabels();
      for (const { index: i, label: r } of t)
        o[i] === r && o.splice(i, 1);
      this._addedLabels = [];
    }
    super.init(n);
  }
  parse(n, t) {
    if (lt(n))
      return null;
    const o = this.getLabels();
    return t = isFinite(t) && o[t] === n ? t : sk(o, n, Je(t, n), this._addedLabels), uk(t, o.length - 1);
  }
  determineDataLimits() {
    const { minDefined: n, maxDefined: t } = this.getUserBounds();
    let { min: o, max: i } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (n || (o = 0), t || (i = this.getLabels().length - 1)), this.min = o, this.max = i;
  }
  buildTicks() {
    const n = this.min, t = this.max, o = this.options.offset, i = [];
    let r = this.getLabels();
    r = n === 0 && t === r.length - 1 ? r : r.slice(n, t + 1), this._valueRange = Math.max(r.length - (o ? 0 : 1), 1), this._startValue = this.min - (o ? 0.5 : 0);
    for (let a = n; a <= t; a++)
      i.push({
        value: a
      });
    return i;
  }
  getLabelForValue(n) {
    return Ec.call(this, n);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(n) {
    return typeof n != "number" && (n = this.parse(n)), n === null ? NaN : this.getPixelForDecimal((n - this._startValue) / this._valueRange);
  }
  getPixelForTick(n) {
    const t = this.ticks;
    return n < 0 || n > t.length - 1 ? null : this.getPixelForValue(t[n].value);
  }
  getValueForPixel(n) {
    return Math.round(this._startValue + this.getDecimalForPixel(n) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
Ee(Kl, "id", "category"), Ee(Kl, "defaults", {
  ticks: {
    callback: Ec
  }
});
function dk(e, n) {
  const t = [], { bounds: i, step: r, min: a, max: l, precision: s, count: u, maxTicks: d, maxDigits: f, includeBounds: c } = e, h = r || 1, m = d - 1, { min: g, max: v } = n, p = !lt(a), y = !lt(l), C = !lt(u), b = (v - g) / (f + 1);
  let x = Nd((v - g) / m / h) * h, w, $, E, A;
  if (x < 1e-14 && !p && !y)
    return [
      {
        value: g
      },
      {
        value: v
      }
    ];
  A = Math.ceil(v / x) - Math.floor(g / x), A > m && (x = Nd(A * x / m / h) * h), lt(s) || (w = Math.pow(10, s), x = Math.ceil(x * w) / w), i === "ticks" ? ($ = Math.floor(g / x) * x, E = Math.ceil(v / x) * x) : ($ = g, E = v), p && y && r && bx((l - a) / r, x / 1e3) ? (A = Math.round(Math.min((l - a) / x, d)), x = (l - a) / A, $ = a, E = l) : C ? ($ = p ? a : $, E = y ? l : E, A = u - 1, x = (E - $) / A) : (A = (E - $) / x, Ir(A, Math.round(A), x / 1e3) ? A = Math.round(A) : A = Math.ceil(A));
  const O = Math.max(Fd(x), Fd($));
  w = Math.pow(10, lt(s) ? O : s), $ = Math.round($ * w) / w, E = Math.round(E * w) / w;
  let k = 0;
  for (p && (c && $ !== a ? (t.push({
    value: a
  }), $ < a && k++, Ir(Math.round(($ + k * x) * w) / w, a, Mc(a, b, e)) && k++) : $ < a && k++); k < A; ++k) {
    const S = Math.round(($ + k * x) * w) / w;
    if (y && S > l)
      break;
    t.push({
      value: S
    });
  }
  return y && c && E !== l ? t.length && Ir(t[t.length - 1].value, l, Mc(l, b, e)) ? t[t.length - 1].value = l : t.push({
    value: l
  }) : (!y || E === l) && t.push({
    value: E
  }), t;
}
function Mc(e, n, { horizontal: t, minRotation: o }) {
  const i = mn(o), r = (t ? Math.sin(i) : Math.cos(i)) || 1e-3, a = 0.75 * n * ("" + e).length;
  return Math.min(n / r, a);
}
class oa extends Oo {
  constructor(n) {
    super(n), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(n, t) {
    return lt(n) || (typeof n == "number" || n instanceof Number) && !isFinite(+n) ? null : +n;
  }
  handleTickRangeOptions() {
    const { beginAtZero: n } = this.options, { minDefined: t, maxDefined: o } = this.getUserBounds();
    let { min: i, max: r } = this;
    const a = (s) => i = t ? i : s, l = (s) => r = o ? r : s;
    if (n) {
      const s = Zr(i), u = Zr(r);
      s < 0 && u < 0 ? l(0) : s > 0 && u > 0 && a(0);
    }
    if (i === r) {
      let s = r === 0 ? 1 : Math.abs(r * 0.05);
      l(r + s), n || a(i - s);
    }
    this.min = i, this.max = r;
  }
  getTickLimit() {
    const n = this.options.ticks;
    let { maxTicksLimit: t, stepSize: o } = n, i;
    return o ? (i = Math.ceil(this.max / o) - Math.floor(this.min / o) + 1, i > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${o} would result generating up to ${i} ticks. Limiting to 1000.`), i = 1e3)) : (i = this.computeTickLimit(), t = t || 11), t && (i = Math.min(t, i)), i;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const n = this.options, t = n.ticks;
    let o = this.getTickLimit();
    o = Math.max(2, o);
    const i = {
      maxTicks: o,
      bounds: n.bounds,
      min: n.min,
      max: n.max,
      precision: t.precision,
      step: t.stepSize,
      count: t.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: t.minRotation || 0,
      includeBounds: t.includeBounds !== !1
    }, r = this._range || this, a = dk(i, r);
    return n.bounds === "ticks" && Tf(a, this, "value"), n.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  configure() {
    const n = this.ticks;
    let t = this.min, o = this.max;
    if (super.configure(), this.options.offset && n.length) {
      const i = (o - t) / Math.max(n.length - 1, 1) / 2;
      t -= i, o += i;
    }
    this._startValue = t, this._endValue = o, this._valueRange = o - t;
  }
  getLabelForValue(n) {
    return ya(n, this.chart.options.locale, this.options.ticks.format);
  }
}
class Yl extends oa {
  determineDataLimits() {
    const { min: n, max: t } = this.getMinMax(!0);
    this.min = _t(n) ? n : 0, this.max = _t(t) ? t : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const n = this.isHorizontal(), t = n ? this.width : this.height, o = mn(this.options.ticks.minRotation), i = (n ? Math.sin(o) : Math.cos(o)) || 1e-3, r = this._resolveTickFontOptions(0);
    return Math.ceil(t / Math.min(40, r.lineHeight / i));
  }
  getPixelForValue(n) {
    return n === null ? NaN : this.getPixelForDecimal((n - this._startValue) / this._valueRange);
  }
  getValueForPixel(n) {
    return this._startValue + this.getDecimalForPixel(n) * this._valueRange;
  }
}
Ee(Yl, "id", "linear"), Ee(Yl, "defaults", {
  ticks: {
    callback: Ca.formatters.numeric
  }
});
const Ri = (e) => Math.floor(zn(e)), so = (e, n) => Math.pow(10, Ri(e) + n);
function Sc(e) {
  return e / Math.pow(10, Ri(e)) === 1;
}
function Ac(e, n, t) {
  const o = Math.pow(10, t), i = Math.floor(e / o);
  return Math.ceil(n / o) - i;
}
function ck(e, n) {
  const t = n - e;
  let o = Ri(t);
  for (; Ac(e, n, o) > 10; )
    o++;
  for (; Ac(e, n, o) < 10; )
    o--;
  return Math.min(o, Ri(e));
}
function fk(e, { min: n, max: t }) {
  n = Wt(e.min, n);
  const o = [], i = Ri(n);
  let r = ck(n, t), a = r < 0 ? Math.pow(10, Math.abs(r)) : 1;
  const l = Math.pow(10, r), s = i > r ? Math.pow(10, i) : 0, u = Math.round((n - s) * a) / a, d = Math.floor((n - s) / l / 10) * l * 10;
  let f = Math.floor((u - d) / Math.pow(10, r)), c = Wt(e.min, Math.round((s + d + f * Math.pow(10, r)) * a) / a);
  for (; c < t; )
    o.push({
      value: c,
      major: Sc(c),
      significand: f
    }), f >= 10 ? f = f < 15 ? 15 : 20 : f++, f >= 20 && (r++, f = 2, a = r >= 0 ? 1 : a), c = Math.round((s + d + f * Math.pow(10, r)) * a) / a;
  const h = Wt(e.max, c);
  return o.push({
    value: h,
    major: Sc(h),
    significand: f
  }), o;
}
class Tc extends Oo {
  constructor(n) {
    super(n), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(n, t) {
    const o = oa.prototype.parse.apply(this, [
      n,
      t
    ]);
    if (o === 0) {
      this._zero = !0;
      return;
    }
    return _t(o) && o > 0 ? o : null;
  }
  determineDataLimits() {
    const { min: n, max: t } = this.getMinMax(!0);
    this.min = _t(n) ? Math.max(0, n) : null, this.max = _t(t) ? Math.max(0, t) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !_t(this._userMin) && (this.min = n === so(this.min, 0) ? so(this.min, -1) : so(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: n, maxDefined: t } = this.getUserBounds();
    let o = this.min, i = this.max;
    const r = (l) => o = n ? o : l, a = (l) => i = t ? i : l;
    o === i && (o <= 0 ? (r(1), a(10)) : (r(so(o, -1)), a(so(i, 1)))), o <= 0 && r(so(i, -1)), i <= 0 && a(so(o, 1)), this.min = o, this.max = i;
  }
  buildTicks() {
    const n = this.options, t = {
      min: this._userMin,
      max: this._userMax
    }, o = fk(t, this);
    return n.bounds === "ticks" && Tf(o, this, "value"), n.reverse ? (o.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), o;
  }
  getLabelForValue(n) {
    return n === void 0 ? "0" : ya(n, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const n = this.min;
    super.configure(), this._startValue = zn(n), this._valueRange = zn(this.max) - zn(n);
  }
  getPixelForValue(n) {
    return (n === void 0 || n === 0) && (n = this.min), n === null || isNaN(n) ? NaN : this.getPixelForDecimal(n === this.min ? 0 : (zn(n) - this._startValue) / this._valueRange);
  }
  getValueForPixel(n) {
    const t = this.getDecimalForPixel(n);
    return Math.pow(10, this._startValue + t * this._valueRange);
  }
}
Ee(Tc, "id", "logarithmic"), Ee(Tc, "defaults", {
  ticks: {
    callback: Ca.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Gl(e) {
  const n = e.ticks;
  if (n.display && e.display) {
    const t = It(n.backdropPadding);
    return Je(n.font && n.font.size, gt.font.size) + t.height;
  }
  return 0;
}
function hk(e, n, t) {
  return t = dt(t) ? t : [
    t
  ], {
    w: Nx(e, n.string, t),
    h: t.length * n.lineHeight
  };
}
function Pc(e, n, t, o, i) {
  return e === o || e === i ? {
    start: n - t / 2,
    end: n + t / 2
  } : e < o || e > i ? {
    start: n - t,
    end: n
  } : {
    start: n,
    end: n + t
  };
}
function gk(e) {
  const n = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, t = Object.assign({}, n), o = [], i = [], r = e._pointLabels.length, a = e.options.pointLabels, l = a.centerPointLabels ? mt / r : 0;
  for (let s = 0; s < r; s++) {
    const u = a.setContext(e.getPointLabelContext(s));
    i[s] = u.padding;
    const d = e.getPointPosition(s, e.drawingArea + i[s], l), f = xt(u.font), c = hk(e.ctx, f, e._pointLabels[s]);
    o[s] = c;
    const h = gn(e.getIndexAngle(s) + l), m = Math.round(Ts(h)), g = Pc(m, d.x, c.w, 0, 180), v = Pc(m, d.y, c.h, 90, 270);
    mk(t, n, h, g, v);
  }
  e.setCenterPoint(n.l - t.l, t.r - n.r, n.t - t.t, t.b - n.b), e._pointLabelItems = bk(e, o, i);
}
function mk(e, n, t, o, i) {
  const r = Math.abs(Math.sin(t)), a = Math.abs(Math.cos(t));
  let l = 0, s = 0;
  o.start < n.l ? (l = (n.l - o.start) / r, e.l = Math.min(e.l, n.l - l)) : o.end > n.r && (l = (o.end - n.r) / r, e.r = Math.max(e.r, n.r + l)), i.start < n.t ? (s = (n.t - i.start) / a, e.t = Math.min(e.t, n.t - s)) : i.end > n.b && (s = (i.end - n.b) / a, e.b = Math.max(e.b, n.b + s));
}
function pk(e, n, t) {
  const o = e.drawingArea, { extra: i, additionalAngle: r, padding: a, size: l } = t, s = e.getPointPosition(n, o + i + a, r), u = Math.round(Ts(gn(s.angle + vt))), d = xk(s.y, l.h, u), f = yk(u), c = Ck(s.x, l.w, f);
  return {
    visible: !0,
    x: s.x,
    y: d,
    textAlign: f,
    left: c,
    top: d,
    right: c + l.w,
    bottom: d + l.h
  };
}
function vk(e, n) {
  if (!n)
    return !0;
  const { left: t, top: o, right: i, bottom: r } = e;
  return !(Bo({
    x: t,
    y: o
  }, n) || Bo({
    x: t,
    y: r
  }, n) || Bo({
    x: i,
    y: o
  }, n) || Bo({
    x: i,
    y: r
  }, n));
}
function bk(e, n, t) {
  const o = [], i = e._pointLabels.length, r = e.options, { centerPointLabels: a, display: l } = r.pointLabels, s = {
    extra: Gl(r) / 2,
    additionalAngle: a ? mt / i : 0
  };
  let u;
  for (let d = 0; d < i; d++) {
    s.padding = t[d], s.size = n[d];
    const f = pk(e, d, s);
    o.push(f), l === "auto" && (f.visible = vk(f, u), f.visible && (u = f));
  }
  return o;
}
function yk(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function Ck(e, n, t) {
  return t === "right" ? e -= n : t === "center" && (e -= n / 2), e;
}
function xk(e, n, t) {
  return t === 90 || t === 270 ? e -= n / 2 : (t > 270 || t < 90) && (e -= n), e;
}
function wk(e, n, t) {
  const { left: o, top: i, right: r, bottom: a } = t, { backdropColor: l } = n;
  if (!lt(l)) {
    const s = go(n.borderRadius), u = It(n.backdropPadding);
    e.fillStyle = l;
    const d = o - u.left, f = i - u.top, c = r - o + u.width, h = a - i + u.height;
    Object.values(s).some((m) => m !== 0) ? (e.beginPath(), Ni(e, {
      x: d,
      y: f,
      w: c,
      h,
      radius: s
    }), e.fill()) : e.fillRect(d, f, c, h);
  }
}
function $k(e, n) {
  const { ctx: t, options: { pointLabels: o } } = e;
  for (let i = n - 1; i >= 0; i--) {
    const r = e._pointLabelItems[i];
    if (!r.visible)
      continue;
    const a = o.setContext(e.getPointLabelContext(i));
    wk(t, a, r);
    const l = xt(a.font), { x: s, y: u, textAlign: d } = r;
    xo(t, e._pointLabels[i], s, u + l.lineHeight / 2, l, {
      color: a.color,
      textAlign: d,
      textBaseline: "middle"
    });
  }
}
function lh(e, n, t, o) {
  const { ctx: i } = e;
  if (t)
    i.arc(e.xCenter, e.yCenter, n, 0, ht);
  else {
    let r = e.getPointPosition(0, n);
    i.moveTo(r.x, r.y);
    for (let a = 1; a < o; a++)
      r = e.getPointPosition(a, n), i.lineTo(r.x, r.y);
  }
}
function kk(e, n, t, o, i) {
  const r = e.ctx, a = n.circular, { color: l, lineWidth: s } = n;
  !a && !o || !l || !s || t < 0 || (r.save(), r.strokeStyle = l, r.lineWidth = s, r.setLineDash(i.dash || []), r.lineDashOffset = i.dashOffset, r.beginPath(), lh(e, t, a, o), r.closePath(), r.stroke(), r.restore());
}
function _k(e, n, t) {
  return ko(e, {
    label: t,
    index: n,
    type: "pointLabel"
  });
}
class $r extends oa {
  constructor(n) {
    super(n), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const n = this._padding = It(Gl(this.options) / 2), t = this.width = this.maxWidth - n.width, o = this.height = this.maxHeight - n.height;
    this.xCenter = Math.floor(this.left + t / 2 + n.left), this.yCenter = Math.floor(this.top + o / 2 + n.top), this.drawingArea = Math.floor(Math.min(t, o) / 2);
  }
  determineDataLimits() {
    const { min: n, max: t } = this.getMinMax(!1);
    this.min = _t(n) && !isNaN(n) ? n : 0, this.max = _t(t) && !isNaN(t) ? t : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Gl(this.options));
  }
  generateTickLabels(n) {
    oa.prototype.generateTickLabels.call(this, n), this._pointLabels = this.getLabels().map((t, o) => {
      const i = at(this.options.pointLabels.callback, [
        t,
        o
      ], this);
      return i || i === 0 ? i : "";
    }).filter((t, o) => this.chart.getDataVisibility(o));
  }
  fit() {
    const n = this.options;
    n.display && n.pointLabels.display ? gk(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(n, t, o, i) {
    this.xCenter += Math.floor((n - t) / 2), this.yCenter += Math.floor((o - i) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(n, t, o, i));
  }
  getIndexAngle(n) {
    const t = ht / (this._pointLabels.length || 1), o = this.options.startAngle || 0;
    return gn(n * t + mn(o));
  }
  getDistanceFromCenterForValue(n) {
    if (lt(n))
      return NaN;
    const t = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - n) * t : (n - this.min) * t;
  }
  getValueForDistanceFromCenter(n) {
    if (lt(n))
      return NaN;
    const t = n / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - t : this.min + t;
  }
  getPointLabelContext(n) {
    const t = this._pointLabels || [];
    if (n >= 0 && n < t.length) {
      const o = t[n];
      return _k(this.getContext(), n, o);
    }
  }
  getPointPosition(n, t, o = 0) {
    const i = this.getIndexAngle(n) - vt + o;
    return {
      x: Math.cos(i) * t + this.xCenter,
      y: Math.sin(i) * t + this.yCenter,
      angle: i
    };
  }
  getPointPositionForValue(n, t) {
    return this.getPointPosition(n, this.getDistanceFromCenterForValue(t));
  }
  getBasePosition(n) {
    return this.getPointPositionForValue(n || 0, this.getBaseValue());
  }
  getPointLabelPosition(n) {
    const { left: t, top: o, right: i, bottom: r } = this._pointLabelItems[n];
    return {
      left: t,
      top: o,
      right: i,
      bottom: r
    };
  }
  drawBackground() {
    const { backgroundColor: n, grid: { circular: t } } = this.options;
    if (n) {
      const o = this.ctx;
      o.save(), o.beginPath(), lh(this, this.getDistanceFromCenterForValue(this._endValue), t, this._pointLabels.length), o.closePath(), o.fillStyle = n, o.fill(), o.restore();
    }
  }
  drawGrid() {
    const n = this.ctx, t = this.options, { angleLines: o, grid: i, border: r } = t, a = this._pointLabels.length;
    let l, s, u;
    if (t.pointLabels.display && $k(this, a), i.display && this.ticks.forEach((d, f) => {
      if (f !== 0 || f === 0 && this.min < 0) {
        s = this.getDistanceFromCenterForValue(d.value);
        const c = this.getContext(f), h = i.setContext(c), m = r.setContext(c);
        kk(this, h, s, a, m);
      }
    }), o.display) {
      for (n.save(), l = a - 1; l >= 0; l--) {
        const d = o.setContext(this.getPointLabelContext(l)), { color: f, lineWidth: c } = d;
        !c || !f || (n.lineWidth = c, n.strokeStyle = f, n.setLineDash(d.borderDash), n.lineDashOffset = d.borderDashOffset, s = this.getDistanceFromCenterForValue(t.reverse ? this.min : this.max), u = this.getPointPosition(l, s), n.beginPath(), n.moveTo(this.xCenter, this.yCenter), n.lineTo(u.x, u.y), n.stroke());
      }
      n.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const n = this.ctx, t = this.options, o = t.ticks;
    if (!o.display)
      return;
    const i = this.getIndexAngle(0);
    let r, a;
    n.save(), n.translate(this.xCenter, this.yCenter), n.rotate(i), n.textAlign = "center", n.textBaseline = "middle", this.ticks.forEach((l, s) => {
      if (s === 0 && this.min >= 0 && !t.reverse)
        return;
      const u = o.setContext(this.getContext(s)), d = xt(u.font);
      if (r = this.getDistanceFromCenterForValue(this.ticks[s].value), u.showLabelBackdrop) {
        n.font = d.string, a = n.measureText(l.label).width, n.fillStyle = u.backdropColor;
        const f = It(u.backdropPadding);
        n.fillRect(-a / 2 - f.left, -r - d.size / 2 - f.top, a + f.width, d.size + f.height);
      }
      xo(n, l.label, 0, -r, d, {
        color: u.color,
        strokeColor: u.textStrokeColor,
        strokeWidth: u.textStrokeWidth
      });
    }), n.restore();
  }
  drawTitle() {
  }
}
Ee($r, "id", "radialLinear"), Ee($r, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Ca.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(n) {
      return n;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), Ee($r, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), Ee($r, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const $a = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, jt = /* @__PURE__ */ Object.keys($a);
function Ic(e, n) {
  return e - n;
}
function Dc(e, n) {
  if (lt(n))
    return null;
  const t = e._adapter, { parser: o, round: i, isoWeekday: r } = e._parseOpts;
  let a = n;
  return typeof o == "function" && (a = o(a)), _t(a) || (a = typeof o == "string" ? t.parse(a, o) : t.parse(a)), a === null ? null : (i && (a = i === "week" && (Xr(r) || r === !0) ? t.startOf(a, "isoWeek", r) : t.startOf(a, i)), +a);
}
function Lc(e, n, t, o) {
  const i = jt.length;
  for (let r = jt.indexOf(e); r < i - 1; ++r) {
    const a = $a[jt[r]], l = a.steps ? a.steps : Number.MAX_SAFE_INTEGER;
    if (a.common && Math.ceil((t - n) / (l * a.size)) <= o)
      return jt[r];
  }
  return jt[i - 1];
}
function Ok(e, n, t, o, i) {
  for (let r = jt.length - 1; r >= jt.indexOf(t); r--) {
    const a = jt[r];
    if ($a[a].common && e._adapter.diff(i, o, a) >= n - 1)
      return a;
  }
  return jt[t ? jt.indexOf(t) : 0];
}
function Ek(e) {
  for (let n = jt.indexOf(e) + 1, t = jt.length; n < t; ++n)
    if ($a[jt[n]].common)
      return jt[n];
}
function Nc(e, n, t) {
  if (!t)
    e[n] = !0;
  else if (t.length) {
    const { lo: o, hi: i } = Ps(t, n), r = t[o] >= n ? t[o] : t[i];
    e[r] = !0;
  }
}
function Mk(e, n, t, o) {
  const i = e._adapter, r = +i.startOf(n[0].value, o), a = n[n.length - 1].value;
  let l, s;
  for (l = r; l <= a; l = +i.add(l, 1, o))
    s = t[l], s >= 0 && (n[s].major = !0);
  return n;
}
function Fc(e, n, t) {
  const o = [], i = {}, r = n.length;
  let a, l;
  for (a = 0; a < r; ++a)
    l = n[a], i[l] = a, o.push({
      value: l,
      major: !1
    });
  return r === 0 || !t ? o : Mk(e, o, i, t);
}
class ia extends Oo {
  constructor(n) {
    super(n), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(n, t = {}) {
    const o = n.time || (n.time = {}), i = this._adapter = new Ow._date(n.adapters.date);
    i.init(t), Ci(o.displayFormats, i.formats()), this._parseOpts = {
      parser: o.parser,
      round: o.round,
      isoWeekday: o.isoWeekday
    }, super.init(n), this._normalized = t.normalized;
  }
  parse(n, t) {
    return n === void 0 ? null : Dc(this, n);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const n = this.options, t = this._adapter, o = n.time.unit || "day";
    let { min: i, max: r, minDefined: a, maxDefined: l } = this.getUserBounds();
    function s(u) {
      !a && !isNaN(u.min) && (i = Math.min(i, u.min)), !l && !isNaN(u.max) && (r = Math.max(r, u.max));
    }
    (!a || !l) && (s(this._getLabelBounds()), (n.bounds !== "ticks" || n.ticks.source !== "labels") && s(this.getMinMax(!1))), i = _t(i) && !isNaN(i) ? i : +t.startOf(Date.now(), o), r = _t(r) && !isNaN(r) ? r : +t.endOf(Date.now(), o) + 1, this.min = Math.min(i, r - 1), this.max = Math.max(i + 1, r);
  }
  _getLabelBounds() {
    const n = this.getLabelTimestamps();
    let t = Number.POSITIVE_INFINITY, o = Number.NEGATIVE_INFINITY;
    return n.length && (t = n[0], o = n[n.length - 1]), {
      min: t,
      max: o
    };
  }
  buildTicks() {
    const n = this.options, t = n.time, o = n.ticks, i = o.source === "labels" ? this.getLabelTimestamps() : this._generate();
    n.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const r = this.min, a = this.max, l = wx(i, r, a);
    return this._unit = t.unit || (o.autoSkip ? Lc(t.minUnit, this.min, this.max, this._getLabelCapacity(r)) : Ok(this, l.length, t.minUnit, this.min, this.max)), this._majorUnit = !o.major.enabled || this._unit === "year" ? void 0 : Ek(this._unit), this.initOffsets(i), n.reverse && l.reverse(), Fc(this, l, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((n) => +n.value));
  }
  initOffsets(n = []) {
    let t = 0, o = 0, i, r;
    this.options.offset && n.length && (i = this.getDecimalForValue(n[0]), n.length === 1 ? t = 1 - i : t = (this.getDecimalForValue(n[1]) - i) / 2, r = this.getDecimalForValue(n[n.length - 1]), n.length === 1 ? o = r : o = (r - this.getDecimalForValue(n[n.length - 2])) / 2);
    const a = n.length < 3 ? 0.5 : 0.25;
    t = Ht(t, 0, a), o = Ht(o, 0, a), this._offsets = {
      start: t,
      end: o,
      factor: 1 / (t + 1 + o)
    };
  }
  _generate() {
    const n = this._adapter, t = this.min, o = this.max, i = this.options, r = i.time, a = r.unit || Lc(r.minUnit, t, o, this._getLabelCapacity(t)), l = Je(i.ticks.stepSize, 1), s = a === "week" ? r.isoWeekday : !1, u = Xr(s) || s === !0, d = {};
    let f = t, c, h;
    if (u && (f = +n.startOf(f, "isoWeek", s)), f = +n.startOf(f, u ? "day" : a), n.diff(o, t, a) > 1e5 * l)
      throw new Error(t + " and " + o + " are too far apart with stepSize of " + l + " " + a);
    const m = i.ticks.source === "data" && this.getDataTimestamps();
    for (c = f, h = 0; c < o; c = +n.add(c, l, a), h++)
      Nc(d, c, m);
    return (c === o || i.bounds === "ticks" || h === 1) && Nc(d, c, m), Object.keys(d).sort(Ic).map((g) => +g);
  }
  getLabelForValue(n) {
    const t = this._adapter, o = this.options.time;
    return o.tooltipFormat ? t.format(n, o.tooltipFormat) : t.format(n, o.displayFormats.datetime);
  }
  format(n, t) {
    const i = this.options.time.displayFormats, r = this._unit, a = t || i[r];
    return this._adapter.format(n, a);
  }
  _tickFormatFunction(n, t, o, i) {
    const r = this.options, a = r.ticks.callback;
    if (a)
      return at(a, [
        n,
        t,
        o
      ], this);
    const l = r.time.displayFormats, s = this._unit, u = this._majorUnit, d = s && l[s], f = u && l[u], c = o[t], h = u && f && c && c.major;
    return this._adapter.format(n, i || (h ? f : d));
  }
  generateTickLabels(n) {
    let t, o, i;
    for (t = 0, o = n.length; t < o; ++t)
      i = n[t], i.label = this._tickFormatFunction(i.value, t, n);
  }
  getDecimalForValue(n) {
    return n === null ? NaN : (n - this.min) / (this.max - this.min);
  }
  getPixelForValue(n) {
    const t = this._offsets, o = this.getDecimalForValue(n);
    return this.getPixelForDecimal((t.start + o) * t.factor);
  }
  getValueForPixel(n) {
    const t = this._offsets, o = this.getDecimalForPixel(n) / t.factor - t.end;
    return this.min + o * (this.max - this.min);
  }
  _getLabelSize(n) {
    const t = this.options.ticks, o = this.ctx.measureText(n).width, i = mn(this.isHorizontal() ? t.maxRotation : t.minRotation), r = Math.cos(i), a = Math.sin(i), l = this._resolveTickFontOptions(0).size;
    return {
      w: o * r + l * a,
      h: o * a + l * r
    };
  }
  _getLabelCapacity(n) {
    const t = this.options.time, o = t.displayFormats, i = o[t.unit] || o.millisecond, r = this._tickFormatFunction(n, 0, Fc(this, [
      n
    ], this._majorUnit), i), a = this._getLabelSize(r), l = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
    return l > 0 ? l : 1;
  }
  getDataTimestamps() {
    let n = this._cache.data || [], t, o;
    if (n.length)
      return n;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (t = 0, o = i.length; t < o; ++t)
      n = n.concat(i[t].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(n);
  }
  getLabelTimestamps() {
    const n = this._cache.labels || [];
    let t, o;
    if (n.length)
      return n;
    const i = this.getLabels();
    for (t = 0, o = i.length; t < o; ++t)
      n.push(Dc(this, i[t]));
    return this._cache.labels = this._normalized ? n : this.normalize(n);
  }
  normalize(n) {
    return kx(n.sort(Ic));
  }
}
Ee(ia, "id", "time"), Ee(ia, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function kr(e, n, t) {
  let o = 0, i = e.length - 1, r, a, l, s;
  t ? (n >= e[o].pos && n <= e[i].pos && ({ lo: o, hi: i } = Hl(e, "pos", n)), { pos: r, time: l } = e[o], { pos: a, time: s } = e[i]) : (n >= e[o].time && n <= e[i].time && ({ lo: o, hi: i } = Hl(e, "time", n)), { time: r, pos: l } = e[o], { time: a, pos: s } = e[i]);
  const u = a - r;
  return u ? l + (s - l) * (n - r) / u : l;
}
class Rc extends ia {
  constructor(n) {
    super(n), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const n = this._getTimestampsForTable(), t = this._table = this.buildLookupTable(n);
    this._minPos = kr(t, this.min), this._tableRange = kr(t, this.max) - this._minPos, super.initOffsets(n);
  }
  buildLookupTable(n) {
    const { min: t, max: o } = this, i = [], r = [];
    let a, l, s, u, d;
    for (a = 0, l = n.length; a < l; ++a)
      u = n[a], u >= t && u <= o && i.push(u);
    if (i.length < 2)
      return [
        {
          time: t,
          pos: 0
        },
        {
          time: o,
          pos: 1
        }
      ];
    for (a = 0, l = i.length; a < l; ++a)
      d = i[a + 1], s = i[a - 1], u = i[a], Math.round((d + s) / 2) !== u && r.push({
        time: u,
        pos: a / (l - 1)
      });
    return r;
  }
  _generate() {
    const n = this.min, t = this.max;
    let o = super.getDataTimestamps();
    return (!o.includes(n) || !o.length) && o.splice(0, 0, n), (!o.includes(t) || o.length === 1) && o.push(t), o.sort((i, r) => i - r);
  }
  _getTimestampsForTable() {
    let n = this._cache.all || [];
    if (n.length)
      return n;
    const t = this.getDataTimestamps(), o = this.getLabelTimestamps();
    return t.length && o.length ? n = this.normalize(t.concat(o)) : n = t.length ? t : o, n = this._cache.all = n, n;
  }
  getDecimalForValue(n) {
    return (kr(this._table, n) - this._minPos) / this._tableRange;
  }
  getValueForPixel(n) {
    const t = this._offsets, o = this.getDecimalForPixel(n) / t.factor - t.end;
    return kr(this._table, o * this._tableRange + this._minPos, !0);
  }
}
Ee(Rc, "id", "timeseries"), Ee(Rc, "defaults", ia.defaults);
const sh = {
  data: {
    type: Object,
    required: !0
  },
  options: {
    type: Object,
    default: () => ({})
  },
  plugins: {
    type: Array,
    default: () => []
  },
  datasetIdKey: {
    type: String,
    default: "label"
  },
  updateMode: {
    type: String,
    default: void 0
  }
}, Sk = {
  ariaLabel: {
    type: String
  },
  ariaDescribedby: {
    type: String
  }
}, Ak = {
  type: {
    type: String,
    required: !0
  },
  destroyDelay: {
    type: Number,
    default: 0
    // No delay by default
  },
  ...sh,
  ...Sk
}, Tk = c0[0] === "2" ? (e, n) => Object.assign(e, {
  attrs: n
}) : (e, n) => Object.assign(e, n);
function Do(e) {
  return n1(e) ? je(e) : e;
}
function Pk(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e;
  return n1(n) ? new Proxy(e, {}) : e;
}
function Ik(e, n) {
  const t = e.options;
  t && n && Object.assign(t, n);
}
function uh(e, n) {
  e.labels = n;
}
function dh(e, n, t) {
  const o = [];
  e.datasets = n.map((i) => {
    const r = e.datasets.find((a) => a[t] === i[t]);
    return !r || !i.data || o.includes(r) ? {
      ...i
    } : (o.push(r), Object.assign(r, i), r);
  });
}
function Dk(e, n) {
  const t = {
    labels: [],
    datasets: []
  };
  return uh(t, e.labels), dh(t, e.datasets, n), t;
}
const Lk = re({
  props: Ak,
  setup(e, n) {
    let { expose: t, slots: o } = n;
    const i = X(null), r = ca(null);
    t({
      chart: r
    });
    const a = () => {
      if (!i.value)
        return;
      const { type: u, data: d, options: f, plugins: c, datasetIdKey: h } = e, m = Dk(d, h), g = Pk(m, d);
      r.value = new wa(i.value, {
        type: u,
        data: g,
        options: {
          ...f
        },
        plugins: c
      });
    }, l = () => {
      const u = je(r.value);
      u && (e.destroyDelay > 0 ? setTimeout(() => {
        u.destroy(), r.value = null;
      }, e.destroyDelay) : (u.destroy(), r.value = null));
    }, s = (u) => {
      u.update(e.updateMode);
    };
    return Ge(a), to(l), Ne([
      () => e.options,
      () => e.data
    ], (u, d) => {
      let [f, c] = u, [h, m] = d;
      const g = je(r.value);
      if (!g)
        return;
      let v = !1;
      if (f) {
        const p = Do(f), y = Do(h);
        p && p !== y && (Ik(g, p), v = !0);
      }
      if (c) {
        const p = Do(c.labels), y = Do(m.labels), C = Do(c.datasets), b = Do(m.datasets);
        p !== y && (uh(g.config.data, p), v = !0), C && C !== b && (dh(g.config.data, C, e.datasetIdKey), v = !0);
      }
      v && He(() => {
        s(g);
      });
    }, {
      deep: !0
    }), () => wt("canvas", {
      role: "img",
      ariaLabel: e.ariaLabel,
      ariaDescribedby: e.ariaDescribedby,
      ref: i
    }, [
      wt("p", {}, [
        o.default ? o.default() : ""
      ])
    ]);
  }
});
function Nk(e, n) {
  return wa.register(n), re({
    props: sh,
    setup(t, o) {
      let { expose: i } = o;
      const r = ca(null), a = (l) => {
        r.value = l == null ? void 0 : l.chart;
      };
      return i({
        chart: r
      }), () => wt(Lk, Tk({
        ref: a
      }, {
        type: e,
        ...t
      }));
    }
  });
}
const Fk = /* @__PURE__ */ Nk("doughnut", hi), Rk = { class: "flex items-center gap-5 flex-wrap justify-center" }, Bk = { class: "relative" }, Vk = { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" }, jk = { key: 0 }, Hk = { class: "text-mgm-txt-sm text-foreground-default w-20 truncate" }, zk = { class: "text-mgm-txt-sm text-foreground-emphasis font-medium" }, VA = /* @__PURE__ */ re({
  __name: "PieChart",
  props: {
    width: {},
    data: {},
    legend: { type: Boolean }
  },
  setup(e) {
    wa.register(
      J$,
      ak,
      Z$,
      Nr,
      Kl,
      Yl,
      mi
    );
    const n = e, t = {
      radius: n.width / 2,
      cutout: "70%",
      elements: {
        arc: {
          borderWidth: 2,
          offset: 0
        }
      },
      plugins: {
        legend: {
          display: !1
        },
        tooltip: {
          enabled: !1,
          external: function(i) {
            let r = document.getElementById("chartjs-tooltip");
            r || (r = document.createElement("section"), r.id = "chartjs-tooltip", document.body.appendChild(r));
            const a = i.tooltip;
            if (a.opacity === 0) {
              r.style.opacity = "0";
              return;
            }
            r.classList.remove("above", "below", "no-transform"), a.yAlign ? r.classList.add(a.yAlign) : r.classList.add("no-transform");
            function l(u) {
              return u.lines;
            }
            if (a.body) {
              const u = a.dataPoints.map((c) => c.label) || [], d = a.body.map(l);
              let f = "<div style='display: block; gap: 4px; margin: 0 4px;'></div>";
              d.forEach(function(c, h) {
                let g = "background:" + a.labelColors[h].backgroundColor;
                g += "; width: 10px; height: 10px; display: inline-block; margin-right: 4px; margin-left: 8px; border-radius: 999px";
                const v = '<span style="' + g + '"></span>' + u[h] + ": " + c;
                f += v;
              }), r && (r.innerHTML = f);
            }
            const s = i.chart.canvas.getBoundingClientRect();
            r.style.background = "#0E1014", r.style.padding = "12px 15px 12px 7px", r.style.borderRadius = "8px", r.style.fontSize = "14px", r.style.color = "white", r.style.opacity = "1", r.style.position = "absolute", r.style.left = s.left + window.pageXOffset + a.caretX + "px", r.style.top = s.top + window.pageYOffset + a.caretY + "px", r.style.padding = a.padding + "px " + a.padding + "px", r.style.pointerEvents = "none";
          }
        }
      }
    }, o = {
      labels: n.data.map((i) => i.legend),
      datasets: [
        {
          data: n.data.map((i) => i.value),
          backgroundColor: n.data.map((i) => i.color),
          hoverOffset: 20
        }
      ]
    };
    return (i, r) => (_(), P("div", Rk, [
      M("div", Bk, [
        ce(I(Fk), {
          id: "doughnut-chart",
          options: t,
          data: o,
          width: i.width + 20,
          height: i.width + 20
        }, null, 8, ["width", "height"]),
        M("span", Vk, [
          be(i.$slots, "default")
        ])
      ]),
      i.legend ? (_(), P("div", jk, [
        (_(!0), P(me, null, Fe(n.data, (a, l) => (_(), P("div", {
          key: l + a.color + a.legend + a.value,
          class: "flex items-center gap-2"
        }, [
          M("div", {
            class: "w-2 h-2 rounded-full",
            style: Ye({ backgroundColor: a.color })
          }, null, 4),
          M("span", Hk, de(a.legend), 1),
          M("span", zk, de(a.value), 1)
        ]))), 128))
      ])) : z("", !0)
    ]));
  }
}), qk = (e) => (ua("data-v-df523d7e"), e = e(), da(), e), Uk = { class: "progress-container relative" }, Wk = {
  viewBox: "0 0 200 100",
  class: "circular-chart"
}, Kk = /* @__PURE__ */ qk(() => /* @__PURE__ */ M("path", {
  class: "circle-bg",
  d: "M 20,90 A 80,80 0 0,1 180,90"
}, null, -1)), Yk = { class: "bottom-0 left-1/2 -translate-x-1/2 absolute" }, Gk = /* @__PURE__ */ re({
  __name: "ProgressArc",
  props: {
    value: {},
    max: {},
    displayText: { type: Boolean }
  },
  setup(e) {
    const n = e, t = ee(() => {
      const o = 2 * Math.PI * 80 / 2;
      return `${n.value / n.max * 100 / 100 * o} ${o}`;
    });
    return (o, i) => (_(), P("div", Uk, [
      (_(), P("svg", Wk, [
        Kk,
        M("path", {
          class: "circle",
          style: Ye({ strokeDasharray: t.value }),
          d: "M 20,90 A 80,80 0 0,1 180,90"
        }, null, 4)
      ])),
      M("div", Yk, [
        be(o.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
});
const jA = /* @__PURE__ */ no(Gk, [["__scopeId", "data-v-df523d7e"]]), Zk = { class: "h-4 w-full rounded flex gap-1 bg-white" }, Xk = ["title"], Jk = { class: "group-hover:opacity-100 opacity-0 py-3 px-4 bg-background-emphasis absolute bottom-5 left-1 rounded-lg transition-all duration-150 flex items-center text-white gap-2" }, Qk = { class: "text-mgm-txt-sm whitespace-nowrap" }, e_ = {
  key: 0,
  class: "flex gap-4 mt-2"
}, t_ = { class: "text-mgm-txt-sm whitespace-nowrap" }, n_ = /* @__PURE__ */ re({
  __name: "ProgressBar",
  props: {
    data: {},
    legends: { type: Boolean }
  },
  setup(e) {
    const n = e, t = ee(() => {
      const o = n.data.reduce((i, r) => i + r.value, 0);
      return n.data.map((i) => ({
        ...i,
        percentage: i.value / o * 100
      }));
    });
    return (o, i) => (_(), P("div", null, [
      M("div", Zk, [
        (_(!0), P(me, null, Fe(t.value, (r, a) => (_(), P("div", {
          key: r.legend,
          style: Ye({ width: `${r.percentage}%`, backgroundColor: r.color }),
          class: pe(`h-full relative group progress-bar-element ${a === 0 ? "rounded-l" : ""} ${a === t.value.length - 1 ? "rounded-r" : "rounded-none"}`),
          title: r.hoverText
        }, [
          M("div", Jk, [
            M("div", {
              class: "w-2.5 h-2.5 rounded-full",
              style: Ye({ backgroundColor: r.color })
            }, null, 4),
            M("p", Qk, de(r.hoverText), 1)
          ])
        ], 14, Xk))), 128))
      ]),
      o.legends ? (_(), P("div", e_, [
        (_(!0), P(me, null, Fe(t.value, (r) => (_(), P("div", {
          key: r.legend,
          class: "flex gap-2 items-center"
        }, [
          M("div", {
            class: "w-2.5 h-2.5 rounded-full",
            style: Ye({ backgroundColor: r.color })
          }, null, 4),
          M("p", t_, de(r.legend), 1)
        ]))), 128))
      ])) : z("", !0)
    ]));
  }
});
const HA = /* @__PURE__ */ no(n_, [["__scopeId", "data-v-a2b06079"]]), o_ = { class: "" }, i_ = {
  width: "221",
  height: "24",
  viewBox: "0 0 221 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, r_ = /* @__PURE__ */ Xo('<g data-v-61742fec><path d="M0.5 2C0.5 0.89543 1.39543 0 2.5 0C3.60457 0 4.5 0.895431 4.5 2V22C4.5 23.1046 3.60457 24 2.5 24C1.39543 24 0.5 23.1046 0.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M8.5 2C8.5 0.89543 9.39543 0 10.5 0C11.6046 0 12.5 0.895431 12.5 2V22C12.5 23.1046 11.6046 24 10.5 24C9.39543 24 8.5 23.1046 8.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M16.5 2C16.5 0.89543 17.3954 0 18.5 0C19.6046 0 20.5 0.895431 20.5 2V22C20.5 23.1046 19.6046 24 18.5 24C17.3954 24 16.5 23.1046 16.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M24.5 2C24.5 0.89543 25.3954 0 26.5 0C27.6046 0 28.5 0.895431 28.5 2V22C28.5 23.1046 27.6046 24 26.5 24C25.3954 24 24.5 23.1046 24.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M32.5 2C32.5 0.89543 33.3954 0 34.5 0C35.6046 0 36.5 0.895431 36.5 2V22C36.5 23.1046 35.6046 24 34.5 24C33.3954 24 32.5 23.1046 32.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M40.5 2C40.5 0.89543 41.3954 0 42.5 0C43.6046 0 44.5 0.895431 44.5 2V22C44.5 23.1046 43.6046 24 42.5 24C41.3954 24 40.5 23.1046 40.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M48.5 2C48.5 0.89543 49.3954 0 50.5 0C51.6046 0 52.5 0.895431 52.5 2V22C52.5 23.1046 51.6046 24 50.5 24C49.3954 24 48.5 23.1046 48.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M56.5 2C56.5 0.89543 57.3954 0 58.5 0C59.6046 0 60.5 0.895431 60.5 2V22C60.5 23.1046 59.6046 24 58.5 24C57.3954 24 56.5 23.1046 56.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M64.5 2C64.5 0.89543 65.3954 0 66.5 0C67.6046 0 68.5 0.895431 68.5 2V22C68.5 23.1046 67.6046 24 66.5 24C65.3954 24 64.5 23.1046 64.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M72.5 2C72.5 0.89543 73.3954 0 74.5 0C75.6046 0 76.5 0.895431 76.5 2V22C76.5 23.1046 75.6046 24 74.5 24C73.3954 24 72.5 23.1046 72.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M80.5 2C80.5 0.89543 81.3954 0 82.5 0C83.6046 0 84.5 0.895431 84.5 2V22C84.5 23.1046 83.6046 24 82.5 24C81.3954 24 80.5 23.1046 80.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M88.5 2C88.5 0.89543 89.3954 0 90.5 0C91.6046 0 92.5 0.895431 92.5 2V22C92.5 23.1046 91.6046 24 90.5 24C89.3954 24 88.5 23.1046 88.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M96.5 2C96.5 0.89543 97.3954 0 98.5 0C99.6046 0 100.5 0.895431 100.5 2V22C100.5 23.1046 99.6046 24 98.5 24C97.3954 24 96.5 23.1046 96.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M104.5 2C104.5 0.89543 105.395 0 106.5 0C107.605 0 108.5 0.895431 108.5 2V22C108.5 23.1046 107.605 24 106.5 24C105.395 24 104.5 23.1046 104.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M112.5 2C112.5 0.89543 113.395 0 114.5 0C115.605 0 116.5 0.895431 116.5 2V22C116.5 23.1046 115.605 24 114.5 24C113.395 24 112.5 23.1046 112.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M120.5 2C120.5 0.89543 121.395 0 122.5 0C123.605 0 124.5 0.895431 124.5 2V22C124.5 23.1046 123.605 24 122.5 24C121.395 24 120.5 23.1046 120.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M128.5 2C128.5 0.89543 129.395 0 130.5 0C131.605 0 132.5 0.895431 132.5 2V22C132.5 23.1046 131.605 24 130.5 24C129.395 24 128.5 23.1046 128.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M136.5 2C136.5 0.89543 137.395 0 138.5 0C139.605 0 140.5 0.895431 140.5 2V22C140.5 23.1046 139.605 24 138.5 24C137.395 24 136.5 23.1046 136.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M144.5 2C144.5 0.89543 145.395 0 146.5 0C147.605 0 148.5 0.895431 148.5 2V22C148.5 23.1046 147.605 24 146.5 24C145.395 24 144.5 23.1046 144.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M152.5 2C152.5 0.89543 153.395 0 154.5 0C155.605 0 156.5 0.895431 156.5 2V22C156.5 23.1046 155.605 24 154.5 24C153.395 24 152.5 23.1046 152.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M160.5 2C160.5 0.89543 161.395 0 162.5 0C163.605 0 164.5 0.895431 164.5 2V22C164.5 23.1046 163.605 24 162.5 24C161.395 24 160.5 23.1046 160.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M168.5 2C168.5 0.89543 169.395 0 170.5 0C171.605 0 172.5 0.895431 172.5 2V22C172.5 23.1046 171.605 24 170.5 24C169.395 24 168.5 23.1046 168.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M176.5 2C176.5 0.89543 177.395 0 178.5 0C179.605 0 180.5 0.895431 180.5 2V22C180.5 23.1046 179.605 24 178.5 24C177.395 24 176.5 23.1046 176.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M184.5 2C184.5 0.89543 185.395 0 186.5 0C187.605 0 188.5 0.895431 188.5 2V22C188.5 23.1046 187.605 24 186.5 24C185.395 24 184.5 23.1046 184.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M192.5 2C192.5 0.89543 193.395 0 194.5 0C195.605 0 196.5 0.895431 196.5 2V22C196.5 23.1046 195.605 24 194.5 24C193.395 24 192.5 23.1046 192.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M200.5 2C200.5 0.89543 201.395 0 202.5 0C203.605 0 204.5 0.895431 204.5 2V22C204.5 23.1046 203.605 24 202.5 24C201.395 24 200.5 23.1046 200.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M208.5 2C208.5 0.89543 209.395 0 210.5 0C211.605 0 212.5 0.895431 212.5 2V22C212.5 23.1046 211.605 24 210.5 24C209.395 24 208.5 23.1046 208.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M216.5 2C216.5 0.89543 217.395 0 218.5 0C219.605 0 220.5 0.895431 220.5 2V22C220.5 23.1046 219.605 24 218.5 24C217.395 24 216.5 23.1046 216.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path></g>', 1), a_ = { id: "progress-mask" }, l_ = ["width"], s_ = /* @__PURE__ */ Xo('<g mask="url(#progress-mask)" data-v-61742fec><mask id="bars-mask" data-v-61742fec><path d="M0.5 2C0.5 0.89543 1.39543 0 2.5 0C3.60457 0 4.5 0.895431 4.5 2V22C4.5 23.1046 3.60457 24 2.5 24C1.39543 24 0.5 23.1046 0.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M8.5 2C8.5 0.89543 9.39543 0 10.5 0C11.6046 0 12.5 0.895431 12.5 2V22C12.5 23.1046 11.6046 24 10.5 24C9.39543 24 8.5 23.1046 8.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M16.5 2C16.5 0.89543 17.3954 0 18.5 0C19.6046 0 20.5 0.895431 20.5 2V22C20.5 23.1046 19.6046 24 18.5 24C17.3954 24 16.5 23.1046 16.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M24.5 2C24.5 0.89543 25.3954 0 26.5 0C27.6046 0 28.5 0.895431 28.5 2V22C28.5 23.1046 27.6046 24 26.5 24C25.3954 24 24.5 23.1046 24.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M32.5 2C32.5 0.89543 33.3954 0 34.5 0C35.6046 0 36.5 0.895431 36.5 2V22C36.5 23.1046 35.6046 24 34.5 24C33.3954 24 32.5 23.1046 32.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M40.5 2C40.5 0.89543 41.3954 0 42.5 0C43.6046 0 44.5 0.895431 44.5 2V22C44.5 23.1046 43.6046 24 42.5 24C41.3954 24 40.5 23.1046 40.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M48.5 2C48.5 0.89543 49.3954 0 50.5 0C51.6046 0 52.5 0.895431 52.5 2V22C52.5 23.1046 51.6046 24 50.5 24C49.3954 24 48.5 23.1046 48.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M56.5 2C56.5 0.89543 57.3954 0 58.5 0C59.6046 0 60.5 0.895431 60.5 2V22C60.5 23.1046 59.6046 24 58.5 24C57.3954 24 56.5 23.1046 56.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M64.5 2C64.5 0.89543 65.3954 0 66.5 0C67.6046 0 68.5 0.895431 68.5 2V22C68.5 23.1046 67.6046 24 66.5 24C65.3954 24 64.5 23.1046 64.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M72.5 2C72.5 0.89543 73.3954 0 74.5 0C75.6046 0 76.5 0.895431 76.5 2V22C76.5 23.1046 75.6046 24 74.5 24C73.3954 24 72.5 23.1046 72.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M80.5 2C80.5 0.89543 81.3954 0 82.5 0C83.6046 0 84.5 0.895431 84.5 2V22C84.5 23.1046 83.6046 24 82.5 24C81.3954 24 80.5 23.1046 80.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M88.5 2C88.5 0.89543 89.3954 0 90.5 0C91.6046 0 92.5 0.895431 92.5 2V22C92.5 23.1046 91.6046 24 90.5 24C89.3954 24 88.5 23.1046 88.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M96.5 2C96.5 0.89543 97.3954 0 98.5 0C99.6046 0 100.5 0.895431 100.5 2V22C100.5 23.1046 99.6046 24 98.5 24C97.3954 24 96.5 23.1046 96.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M104.5 2C104.5 0.89543 105.395 0 106.5 0C107.605 0 108.5 0.895431 108.5 2V22C108.5 23.1046 107.605 24 106.5 24C105.395 24 104.5 23.1046 104.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M112.5 2C112.5 0.89543 113.395 0 114.5 0C115.605 0 116.5 0.895431 116.5 2V22C116.5 23.1046 115.605 24 114.5 24C113.395 24 112.5 23.1046 112.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M120.5 2C120.5 0.89543 121.395 0 122.5 0C123.605 0 124.5 0.895431 124.5 2V22C124.5 23.1046 123.605 24 122.5 24C121.395 24 120.5 23.1046 120.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M128.5 2C128.5 0.89543 129.395 0 130.5 0C131.605 0 132.5 0.895431 132.5 2V22C132.5 23.1046 131.605 24 130.5 24C129.395 24 128.5 23.1046 128.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M136.5 2C136.5 0.89543 137.395 0 138.5 0C139.605 0 140.5 0.895431 140.5 2V22C140.5 23.1046 139.605 24 138.5 24C137.395 24 136.5 23.1046 136.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M144.5 2C144.5 0.89543 145.395 0 146.5 0C147.605 0 148.5 0.895431 148.5 2V22C148.5 23.1046 147.605 24 146.5 24C145.395 24 144.5 23.1046 144.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M152.5 2C152.5 0.89543 153.395 0 154.5 0C155.605 0 156.5 0.895431 156.5 2V22C156.5 23.1046 155.605 24 154.5 24C153.395 24 152.5 23.1046 152.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M160.5 2C160.5 0.89543 161.395 0 162.5 0C163.605 0 164.5 0.895431 164.5 2V22C164.5 23.1046 163.605 24 162.5 24C161.395 24 160.5 23.1046 160.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M168.5 2C168.5 0.89543 169.395 0 170.5 0C171.605 0 172.5 0.895431 172.5 2V22C172.5 23.1046 171.605 24 170.5 24C169.395 24 168.5 23.1046 168.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M176.5 2C176.5 0.89543 177.395 0 178.5 0C179.605 0 180.5 0.895431 180.5 2V22C180.5 23.1046 179.605 24 178.5 24C177.395 24 176.5 23.1046 176.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M184.5 2C184.5 0.89543 185.395 0 186.5 0C187.605 0 188.5 0.895431 188.5 2V22C188.5 23.1046 187.605 24 186.5 24C185.395 24 184.5 23.1046 184.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M192.5 2C192.5 0.89543 193.395 0 194.5 0C195.605 0 196.5 0.895431 196.5 2V22C196.5 23.1046 195.605 24 194.5 24C193.395 24 192.5 23.1046 192.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M200.5 2C200.5 0.89543 201.395 0 202.5 0C203.605 0 204.5 0.895431 204.5 2V22C204.5 23.1046 203.605 24 202.5 24C201.395 24 200.5 23.1046 200.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M208.5 2C208.5 0.89543 209.395 0 210.5 0C211.605 0 212.5 0.895431 212.5 2V22C212.5 23.1046 211.605 24 210.5 24C209.395 24 208.5 23.1046 208.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path><path d="M216.5 2C216.5 0.89543 217.395 0 218.5 0C219.605 0 220.5 0.895431 220.5 2V22C220.5 23.1046 219.605 24 218.5 24C217.395 24 216.5 23.1046 216.5 22V2Z" fill="#EEF4FF" data-v-61742fec></path></mask><rect width="221" height="24" mask="url(#bars-mask)" fill="url(#gradient)" class="bg-gradient-to-r from-blue-500 to-red-500" data-v-61742fec></rect><linearGradient id="gradient" width="20" data-v-61742fec><stop offset="0%" stop-color="#9633E0" data-v-61742fec></stop><stop offset="25%" stop-color="#C42F5E" data-v-61742fec></stop><stop offset="50%" stop-color="#E8771B" data-v-61742fec></stop><stop offset="75%" stop-color="#A8B528" data-v-61742fec></stop><stop offset="100%" stop-color="#0D8A4A" data-v-61742fec></stop></linearGradient></g>', 1), u_ = {
  key: 0,
  class: "flex items-center justify-between w-full mt-2 text-mgm-txt-sm text-foreground-default"
}, d_ = /* @__PURE__ */ re({
  __name: "ProgressGradient",
  props: {
    progress: {},
    legends: {}
  },
  setup(e) {
    const n = e, t = ee(() => 221 * n.progress / 100);
    return (o, i) => {
      var r, a;
      return _(), P("div", o_, [
        (_(), P("svg", i_, [
          r_,
          M("mask", a_, [
            M("rect", {
              class: "progress-rect",
              width: t.value,
              height: "24",
              fill: "white"
            }, null, 8, l_)
          ]),
          s_
        ])),
        o.legends ? (_(), P("div", u_, [
          M("p", null, de((r = o.legends) == null ? void 0 : r.start), 1),
          M("p", null, de((a = o.legends) == null ? void 0 : a.end), 1)
        ])) : z("", !0)
      ]);
    };
  }
});
const zA = /* @__PURE__ */ no(d_, [["__scopeId", "data-v-61742fec"]]), c_ = { class: "mb-1 font-medium block" }, f_ = { class: "mt-1" }, qA = /* @__PURE__ */ re({
  __name: "TextAccordion",
  props: {
    content: {},
    title: {},
    seeMoreButton: {},
    seeLessButton: {}
  },
  setup(e) {
    const n = e, t = X(null), o = X(0), i = X(!1), r = X(!1), a = () => {
      t.value && (t.value.style.webkitLineClamp = "initial", t.value.style.overflow = "initial", t.value.style.textOverflow = "initial", t.value.style.display = "block", t.value.style.webkitBoxOrient = "initial", r.value = !0);
    }, l = () => {
      t.value && (setTimeout(() => {
        t.value && (t.value.style.webkitLineClamp = n.title ? "3" : "2", t.value.style.overflow = "hidden", t.value.style.textOverflow = "ellipsis", t.value.style.display = "-webkit-box", t.value.style.webkitBoxOrient = "vertical");
      }, 300), r.value = !1, t.value.scrollHeight > 40 && (i.value = !0), t.value.scrollHeight <= 40 && (i.value = !1));
    };
    ct(() => {
      if (t.value) {
        const u = t.value.scrollHeight;
        o.value = u, u > (n.title ? 70 : 40) && (t.value.style.webkitLineClamp = n.title ? "3" : "2", t.value.style.overflow = "hidden", t.value.style.textOverflow = "ellipsis", t.value.style.display = "-webkit-box", t.value.style.webkitBoxOrient = "vertical", i.value = !0);
      }
    });
    const s = ee(() => {
      if (r.value)
        return o.value + 28 + "px";
      if (!r.value && n.title && i.value)
        return "89px";
      if (!r.value && n.title && !i.value)
        return "auto";
      if (!r.value && !n.title && i.value)
        return "71px";
      if (!r.value && !n.title && !i.value)
        return "auto";
    });
    return (u, d) => (_(), P("div", {
      class: pe("transition-all duration-500 overflow-hidden box-content"),
      style: Ye(`height: ${s.value}`)
    }, [
      M("div", {
        ref_key: "container",
        ref: t,
        class: "text-sm"
      }, [
        M("p", c_, de(u.title), 1),
        M("p", null, de(u.content), 1)
      ], 512),
      M("div", f_, [
        i.value && !r.value ? (_(), P("button", {
          key: 0,
          onClick: a,
          class: "text-mgm-txt-sm text-foreground-brand-default font-medium flex items-center gap-1"
        }, [
          Ie(de(u.seeMoreButton || "Voir plus") + " ", 1),
          ce(Le, {
            icon: "chevron-down",
            color: "#444CE7",
            class: "w-3 h-3"
          })
        ])) : z("", !0),
        i.value && r.value ? (_(), P("button", {
          key: 1,
          onClick: l,
          class: "text-mgm-txt-sm text-foreground-brand-default font-medium flex items-center gap-1"
        }, [
          Ie(de(u.seeLessButton || "Voir moins") + " ", 1),
          ce(Le, {
            icon: "chevron-up",
            color: "#444CE7",
            class: "w-3 h-3"
          })
        ])) : z("", !0)
      ])
    ], 4));
  }
}), h_ = ["top", "right", "bottom", "left"], Xn = Math.min, Kt = Math.max, ra = Math.round, _r = Math.floor, vn = (e) => ({
  x: e,
  y: e
}), g_ = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, m_ = {
  start: "end",
  end: "start"
};
function Zl(e, n, t) {
  return Kt(e, Xn(n, t));
}
function In(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Dn(e) {
  return e.split("-")[0];
}
function ei(e) {
  return e.split("-")[1];
}
function zs(e) {
  return e === "x" ? "y" : "x";
}
function qs(e) {
  return e === "y" ? "height" : "width";
}
function Jn(e) {
  return ["top", "bottom"].includes(Dn(e)) ? "y" : "x";
}
function Us(e) {
  return zs(Jn(e));
}
function p_(e, n, t) {
  t === void 0 && (t = !1);
  const o = ei(e), i = Us(e), r = qs(i);
  let a = i === "x" ? o === (t ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return n.reference[r] > n.floating[r] && (a = aa(a)), [a, aa(a)];
}
function v_(e) {
  const n = aa(e);
  return [Xl(e), n, Xl(n)];
}
function Xl(e) {
  return e.replace(/start|end/g, (n) => m_[n]);
}
function b_(e, n, t) {
  const o = ["left", "right"], i = ["right", "left"], r = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? i : o : n ? o : i;
    case "left":
    case "right":
      return n ? r : a;
    default:
      return [];
  }
}
function y_(e, n, t, o) {
  const i = ei(e);
  let r = b_(Dn(e), t === "start", o);
  return i && (r = r.map((a) => a + "-" + i), n && (r = r.concat(r.map(Xl)))), r;
}
function aa(e) {
  return e.replace(/left|right|bottom|top/g, (n) => g_[n]);
}
function C_(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ch(e) {
  return typeof e != "number" ? C_(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function la(e) {
  const {
    x: n,
    y: t,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: t,
    left: n,
    right: n + o,
    bottom: t + i,
    x: n,
    y: t
  };
}
function Bc(e, n, t) {
  let {
    reference: o,
    floating: i
  } = e;
  const r = Jn(n), a = Us(n), l = qs(a), s = Dn(n), u = r === "y", d = o.x + o.width / 2 - i.width / 2, f = o.y + o.height / 2 - i.height / 2, c = o[l] / 2 - i[l] / 2;
  let h;
  switch (s) {
    case "top":
      h = {
        x: d,
        y: o.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: o.y + o.height
      };
      break;
    case "right":
      h = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: o.x - i.width,
        y: f
      };
      break;
    default:
      h = {
        x: o.x,
        y: o.y
      };
  }
  switch (ei(n)) {
    case "start":
      h[a] -= c * (t && u ? -1 : 1);
      break;
    case "end":
      h[a] += c * (t && u ? -1 : 1);
      break;
  }
  return h;
}
const x_ = async (e, n, t) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: r = [],
    platform: a
  } = t, l = r.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(n));
  let u = await a.getElementRects({
    reference: e,
    floating: n,
    strategy: i
  }), {
    x: d,
    y: f
  } = Bc(u, o, s), c = o, h = {}, m = 0;
  for (let g = 0; g < l.length; g++) {
    const {
      name: v,
      fn: p
    } = l[g], {
      x: y,
      y: C,
      data: b,
      reset: x
    } = await p({
      x: d,
      y: f,
      initialPlacement: o,
      placement: c,
      strategy: i,
      middlewareData: h,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: n
      }
    });
    d = y ?? d, f = C ?? f, h = {
      ...h,
      [v]: {
        ...h[v],
        ...b
      }
    }, x && m <= 50 && (m++, typeof x == "object" && (x.placement && (c = x.placement), x.rects && (u = x.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: n,
      strategy: i
    }) : x.rects), {
      x: d,
      y: f
    } = Bc(u, c, s)), g = -1);
  }
  return {
    x: d,
    y: f,
    placement: c,
    strategy: i,
    middlewareData: h
  };
};
async function Bi(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: o,
    y: i,
    platform: r,
    rects: a,
    elements: l,
    strategy: s
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: c = !1,
    padding: h = 0
  } = In(n, e), m = ch(h), v = l[c ? f === "floating" ? "reference" : "floating" : f], p = la(await r.getClippingRect({
    element: (t = await (r.isElement == null ? void 0 : r.isElement(v))) == null || t ? v : v.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: s
  })), y = f === "floating" ? {
    x: o,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(l.floating)), b = await (r.isElement == null ? void 0 : r.isElement(C)) ? await (r.getScale == null ? void 0 : r.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = la(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: y,
    offsetParent: C,
    strategy: s
  }) : y);
  return {
    top: (p.top - x.top + m.top) / b.y,
    bottom: (x.bottom - p.bottom + m.bottom) / b.y,
    left: (p.left - x.left + m.left) / b.x,
    right: (x.right - p.right + m.right) / b.x
  };
}
const w_ = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: o,
      placement: i,
      rects: r,
      platform: a,
      elements: l,
      middlewareData: s
    } = n, {
      element: u,
      padding: d = 0
    } = In(e, n) || {};
    if (u == null)
      return {};
    const f = ch(d), c = {
      x: t,
      y: o
    }, h = Us(i), m = qs(h), g = await a.getDimensions(u), v = h === "y", p = v ? "top" : "left", y = v ? "bottom" : "right", C = v ? "clientHeight" : "clientWidth", b = r.reference[m] + r.reference[h] - c[h] - r.floating[m], x = c[h] - r.reference[h], w = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let $ = w ? w[C] : 0;
    (!$ || !await (a.isElement == null ? void 0 : a.isElement(w))) && ($ = l.floating[C] || r.floating[m]);
    const E = b / 2 - x / 2, A = $ / 2 - g[m] / 2 - 1, O = Xn(f[p], A), k = Xn(f[y], A), S = O, T = $ - g[m] - k, L = $ / 2 - g[m] / 2 + E, F = Zl(S, L, T), U = !s.arrow && ei(i) != null && L !== F && r.reference[m] / 2 - (L < S ? O : k) - g[m] / 2 < 0, W = U ? L < S ? L - S : L - T : 0;
    return {
      [h]: c[h] + W,
      data: {
        [h]: F,
        centerOffset: L - F - W,
        ...U && {
          alignmentOffset: W
        }
      },
      reset: U
    };
  }
}), $_ = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, o;
      const {
        placement: i,
        middlewareData: r,
        rects: a,
        initialPlacement: l,
        platform: s,
        elements: u
      } = n, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: c,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...v
      } = In(e, n);
      if ((t = r.arrow) != null && t.alignmentOffset)
        return {};
      const p = Dn(i), y = Jn(l), C = Dn(l) === l, b = await (s.isRTL == null ? void 0 : s.isRTL(u.floating)), x = c || (C || !g ? [aa(l)] : v_(l)), w = m !== "none";
      !c && w && x.push(...y_(l, g, m, b));
      const $ = [l, ...x], E = await Bi(n, v), A = [];
      let O = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (d && A.push(E[p]), f) {
        const L = p_(i, a, b);
        A.push(E[L[0]], E[L[1]]);
      }
      if (O = [...O, {
        placement: i,
        overflows: A
      }], !A.every((L) => L <= 0)) {
        var k, S;
        const L = (((k = r.flip) == null ? void 0 : k.index) || 0) + 1, F = $[L];
        if (F)
          return {
            data: {
              index: L,
              overflows: O
            },
            reset: {
              placement: F
            }
          };
        let U = (S = O.filter((W) => W.overflows[0] <= 0).sort((W, oe) => W.overflows[1] - oe.overflows[1])[0]) == null ? void 0 : S.placement;
        if (!U)
          switch (h) {
            case "bestFit": {
              var T;
              const W = (T = O.filter((oe) => {
                if (w) {
                  const H = Jn(oe.placement);
                  return H === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  H === "y";
                }
                return !0;
              }).map((oe) => [oe.placement, oe.overflows.filter((H) => H > 0).reduce((H, B) => H + B, 0)]).sort((oe, H) => oe[1] - H[1])[0]) == null ? void 0 : T[0];
              W && (U = W);
              break;
            }
            case "initialPlacement":
              U = l;
              break;
          }
        if (i !== U)
          return {
            reset: {
              placement: U
            }
          };
      }
      return {};
    }
  };
};
function Vc(e, n) {
  return {
    top: e.top - n.height,
    right: e.right - n.width,
    bottom: e.bottom - n.height,
    left: e.left - n.width
  };
}
function jc(e) {
  return h_.some((n) => e[n] >= 0);
}
const k_ = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(n) {
      const {
        rects: t
      } = n, {
        strategy: o = "referenceHidden",
        ...i
      } = In(e, n);
      switch (o) {
        case "referenceHidden": {
          const r = await Bi(n, {
            ...i,
            elementContext: "reference"
          }), a = Vc(r, t.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: jc(a)
            }
          };
        }
        case "escaped": {
          const r = await Bi(n, {
            ...i,
            altBoundary: !0
          }), a = Vc(r, t.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: jc(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function __(e, n) {
  const {
    placement: t,
    platform: o,
    elements: i
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), a = Dn(t), l = ei(t), s = Jn(t) === "y", u = ["left", "top"].includes(a) ? -1 : 1, d = r && s ? -1 : 1, f = In(n, e);
  let {
    mainAxis: c,
    crossAxis: h,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof m == "number" && (h = l === "end" ? m * -1 : m), s ? {
    x: h * d,
    y: c * u
  } : {
    x: c * u,
    y: h * d
  };
}
const O_ = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, o;
      const {
        x: i,
        y: r,
        placement: a,
        middlewareData: l
      } = n, s = await __(n, e);
      return a === ((t = l.offset) == null ? void 0 : t.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: i + s.x,
        y: r + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, E_ = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: o,
        placement: i
      } = n, {
        mainAxis: r = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: p,
              y
            } = v;
            return {
              x: p,
              y
            };
          }
        },
        ...s
      } = In(e, n), u = {
        x: t,
        y: o
      }, d = await Bi(n, s), f = Jn(Dn(i)), c = zs(f);
      let h = u[c], m = u[f];
      if (r) {
        const v = c === "y" ? "top" : "left", p = c === "y" ? "bottom" : "right", y = h + d[v], C = h - d[p];
        h = Zl(y, h, C);
      }
      if (a) {
        const v = f === "y" ? "top" : "left", p = f === "y" ? "bottom" : "right", y = m + d[v], C = m - d[p];
        m = Zl(y, m, C);
      }
      const g = l.fn({
        ...n,
        [c]: h,
        [f]: m
      });
      return {
        ...g,
        data: {
          x: g.x - t,
          y: g.y - o,
          enabled: {
            [c]: r,
            [f]: a
          }
        }
      };
    }
  };
}, M_ = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(n) {
      const {
        x: t,
        y: o,
        placement: i,
        rects: r,
        middlewareData: a
      } = n, {
        offset: l = 0,
        mainAxis: s = !0,
        crossAxis: u = !0
      } = In(e, n), d = {
        x: t,
        y: o
      }, f = Jn(i), c = zs(f);
      let h = d[c], m = d[f];
      const g = In(l, n), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (s) {
        const C = c === "y" ? "height" : "width", b = r.reference[c] - r.floating[C] + v.mainAxis, x = r.reference[c] + r.reference[C] - v.mainAxis;
        h < b ? h = b : h > x && (h = x);
      }
      if (u) {
        var p, y;
        const C = c === "y" ? "width" : "height", b = ["top", "left"].includes(Dn(i)), x = r.reference[f] - r.floating[C] + (b && ((p = a.offset) == null ? void 0 : p[f]) || 0) + (b ? 0 : v.crossAxis), w = r.reference[f] + r.reference[C] + (b ? 0 : ((y = a.offset) == null ? void 0 : y[f]) || 0) - (b ? v.crossAxis : 0);
        m < x ? m = x : m > w && (m = w);
      }
      return {
        [c]: h,
        [f]: m
      };
    }
  };
}, S_ = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(n) {
      var t, o;
      const {
        placement: i,
        rects: r,
        platform: a,
        elements: l
      } = n, {
        apply: s = () => {
        },
        ...u
      } = In(e, n), d = await Bi(n, u), f = Dn(i), c = ei(i), h = Jn(i) === "y", {
        width: m,
        height: g
      } = r.floating;
      let v, p;
      f === "top" || f === "bottom" ? (v = f, p = c === (await (a.isRTL == null ? void 0 : a.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (p = f, v = c === "end" ? "top" : "bottom");
      const y = g - d.top - d.bottom, C = m - d.left - d.right, b = Xn(g - d[v], y), x = Xn(m - d[p], C), w = !n.middlewareData.shift;
      let $ = b, E = x;
      if ((t = n.middlewareData.shift) != null && t.enabled.x && (E = C), (o = n.middlewareData.shift) != null && o.enabled.y && ($ = y), w && !c) {
        const O = Kt(d.left, 0), k = Kt(d.right, 0), S = Kt(d.top, 0), T = Kt(d.bottom, 0);
        h ? E = m - 2 * (O !== 0 || k !== 0 ? O + k : Kt(d.left, d.right)) : $ = g - 2 * (S !== 0 || T !== 0 ? S + T : Kt(d.top, d.bottom));
      }
      await s({
        ...n,
        availableWidth: E,
        availableHeight: $
      });
      const A = await a.getDimensions(l.floating);
      return m !== A.width || g !== A.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ka() {
  return typeof window < "u";
}
function Eo(e) {
  return Ws(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Gt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function xn(e) {
  var n;
  return (n = (Ws(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function Ws(e) {
  return ka() ? e instanceof Node || e instanceof Gt(e).Node : !1;
}
function un(e) {
  return ka() ? e instanceof Element || e instanceof Gt(e).Element : !1;
}
function bn(e) {
  return ka() ? e instanceof HTMLElement || e instanceof Gt(e).HTMLElement : !1;
}
function Hc(e) {
  return !ka() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Gt(e).ShadowRoot;
}
function Xi(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: o,
    display: i
  } = dn(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + o + t) && !["inline", "contents"].includes(i);
}
function A_(e) {
  return ["table", "td", "th"].includes(Eo(e));
}
function _a(e) {
  return [":popover-open", ":modal"].some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function Ks(e) {
  const n = Ys(), t = un(e) ? dn(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => t[o] ? t[o] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (t.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (t.contain || "").includes(o));
}
function T_(e) {
  let n = Qn(e);
  for (; bn(n) && !Go(n); ) {
    if (Ks(n))
      return n;
    if (_a(n))
      return null;
    n = Qn(n);
  }
  return null;
}
function Ys() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Go(e) {
  return ["html", "body", "#document"].includes(Eo(e));
}
function dn(e) {
  return Gt(e).getComputedStyle(e);
}
function Oa(e) {
  return un(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Qn(e) {
  if (Eo(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Hc(e) && e.host || // Fallback.
    xn(e)
  );
  return Hc(n) ? n.host : n;
}
function fh(e) {
  const n = Qn(e);
  return Go(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : bn(n) && Xi(n) ? n : fh(n);
}
function Vi(e, n, t) {
  var o;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const i = fh(e), r = i === ((o = e.ownerDocument) == null ? void 0 : o.body), a = Gt(i);
  if (r) {
    const l = Jl(a);
    return n.concat(a, a.visualViewport || [], Xi(i) ? i : [], l && t ? Vi(l) : []);
  }
  return n.concat(i, Vi(i, [], t));
}
function Jl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function hh(e) {
  const n = dn(e);
  let t = parseFloat(n.width) || 0, o = parseFloat(n.height) || 0;
  const i = bn(e), r = i ? e.offsetWidth : t, a = i ? e.offsetHeight : o, l = ra(t) !== r || ra(o) !== a;
  return l && (t = r, o = a), {
    width: t,
    height: o,
    $: l
  };
}
function Gs(e) {
  return un(e) ? e : e.contextElement;
}
function qo(e) {
  const n = Gs(e);
  if (!bn(n))
    return vn(1);
  const t = n.getBoundingClientRect(), {
    width: o,
    height: i,
    $: r
  } = hh(n);
  let a = (r ? ra(t.width) : t.width) / o, l = (r ? ra(t.height) : t.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const P_ = /* @__PURE__ */ vn(0);
function gh(e) {
  const n = Gt(e);
  return !Ys() || !n.visualViewport ? P_ : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function I_(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== Gt(e) ? !1 : n;
}
function wo(e, n, t, o) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const i = e.getBoundingClientRect(), r = Gs(e);
  let a = vn(1);
  n && (o ? un(o) && (a = qo(o)) : a = qo(e));
  const l = I_(r, t, o) ? gh(r) : vn(0);
  let s = (i.left + l.x) / a.x, u = (i.top + l.y) / a.y, d = i.width / a.x, f = i.height / a.y;
  if (r) {
    const c = Gt(r), h = o && un(o) ? Gt(o) : o;
    let m = c, g = Jl(m);
    for (; g && o && h !== m; ) {
      const v = qo(g), p = g.getBoundingClientRect(), y = dn(g), C = p.left + (g.clientLeft + parseFloat(y.paddingLeft)) * v.x, b = p.top + (g.clientTop + parseFloat(y.paddingTop)) * v.y;
      s *= v.x, u *= v.y, d *= v.x, f *= v.y, s += C, u += b, m = Gt(g), g = Jl(m);
    }
  }
  return la({
    width: d,
    height: f,
    x: s,
    y: u
  });
}
function Zs(e, n) {
  const t = Oa(e).scrollLeft;
  return n ? n.left + t : wo(xn(e)).left + t;
}
function mh(e, n, t) {
  t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), i = o.left + n.scrollLeft - (t ? 0 : (
    // RTL <body> scrollbar.
    Zs(e, o)
  )), r = o.top + n.scrollTop;
  return {
    x: i,
    y: r
  };
}
function D_(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: o,
    strategy: i
  } = e;
  const r = i === "fixed", a = xn(o), l = n ? _a(n.floating) : !1;
  if (o === a || l && r)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = vn(1);
  const d = vn(0), f = bn(o);
  if ((f || !f && !r) && ((Eo(o) !== "body" || Xi(a)) && (s = Oa(o)), bn(o))) {
    const h = wo(o);
    u = qo(o), d.x = h.x + o.clientLeft, d.y = h.y + o.clientTop;
  }
  const c = a && !f && !r ? mh(a, s, !0) : vn(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - s.scrollLeft * u.x + d.x + c.x,
    y: t.y * u.y - s.scrollTop * u.y + d.y + c.y
  };
}
function L_(e) {
  return Array.from(e.getClientRects());
}
function N_(e) {
  const n = xn(e), t = Oa(e), o = e.ownerDocument.body, i = Kt(n.scrollWidth, n.clientWidth, o.scrollWidth, o.clientWidth), r = Kt(n.scrollHeight, n.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -t.scrollLeft + Zs(e);
  const l = -t.scrollTop;
  return dn(o).direction === "rtl" && (a += Kt(n.clientWidth, o.clientWidth) - i), {
    width: i,
    height: r,
    x: a,
    y: l
  };
}
function F_(e, n) {
  const t = Gt(e), o = xn(e), i = t.visualViewport;
  let r = o.clientWidth, a = o.clientHeight, l = 0, s = 0;
  if (i) {
    r = i.width, a = i.height;
    const u = Ys();
    (!u || u && n === "fixed") && (l = i.offsetLeft, s = i.offsetTop);
  }
  return {
    width: r,
    height: a,
    x: l,
    y: s
  };
}
function R_(e, n) {
  const t = wo(e, !0, n === "fixed"), o = t.top + e.clientTop, i = t.left + e.clientLeft, r = bn(e) ? qo(e) : vn(1), a = e.clientWidth * r.x, l = e.clientHeight * r.y, s = i * r.x, u = o * r.y;
  return {
    width: a,
    height: l,
    x: s,
    y: u
  };
}
function zc(e, n, t) {
  let o;
  if (n === "viewport")
    o = F_(e, t);
  else if (n === "document")
    o = N_(xn(e));
  else if (un(n))
    o = R_(n, t);
  else {
    const i = gh(e);
    o = {
      x: n.x - i.x,
      y: n.y - i.y,
      width: n.width,
      height: n.height
    };
  }
  return la(o);
}
function ph(e, n) {
  const t = Qn(e);
  return t === n || !un(t) || Go(t) ? !1 : dn(t).position === "fixed" || ph(t, n);
}
function B_(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let o = Vi(e, [], !1).filter((l) => un(l) && Eo(l) !== "body"), i = null;
  const r = dn(e).position === "fixed";
  let a = r ? Qn(e) : e;
  for (; un(a) && !Go(a); ) {
    const l = dn(a), s = Ks(a);
    !s && l.position === "fixed" && (i = null), (r ? !s && !i : !s && l.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Xi(a) && !s && ph(e, a)) ? o = o.filter((d) => d !== a) : i = l, a = Qn(a);
  }
  return n.set(e, o), o;
}
function V_(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: o,
    strategy: i
  } = e;
  const a = [...t === "clippingAncestors" ? _a(n) ? [] : B_(n, this._c) : [].concat(t), o], l = a[0], s = a.reduce((u, d) => {
    const f = zc(n, d, i);
    return u.top = Kt(f.top, u.top), u.right = Xn(f.right, u.right), u.bottom = Xn(f.bottom, u.bottom), u.left = Kt(f.left, u.left), u;
  }, zc(n, l, i));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function j_(e) {
  const {
    width: n,
    height: t
  } = hh(e);
  return {
    width: n,
    height: t
  };
}
function H_(e, n, t) {
  const o = bn(n), i = xn(n), r = t === "fixed", a = wo(e, !0, r, n);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = vn(0);
  if (o || !o && !r)
    if ((Eo(n) !== "body" || Xi(i)) && (l = Oa(n)), o) {
      const c = wo(n, !0, r, n);
      s.x = c.x + n.clientLeft, s.y = c.y + n.clientTop;
    } else
      i && (s.x = Zs(i));
  const u = i && !o && !r ? mh(i, l) : vn(0), d = a.left + l.scrollLeft - s.x - u.x, f = a.top + l.scrollTop - s.y - u.y;
  return {
    x: d,
    y: f,
    width: a.width,
    height: a.height
  };
}
function ul(e) {
  return dn(e).position === "static";
}
function qc(e, n) {
  if (!bn(e) || dn(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let t = e.offsetParent;
  return xn(e) === t && (t = t.ownerDocument.body), t;
}
function vh(e, n) {
  const t = Gt(e);
  if (_a(e))
    return t;
  if (!bn(e)) {
    let i = Qn(e);
    for (; i && !Go(i); ) {
      if (un(i) && !ul(i))
        return i;
      i = Qn(i);
    }
    return t;
  }
  let o = qc(e, n);
  for (; o && A_(o) && ul(o); )
    o = qc(o, n);
  return o && Go(o) && ul(o) && !Ks(o) ? t : o || T_(e) || t;
}
const z_ = async function(e) {
  const n = this.getOffsetParent || vh, t = this.getDimensions, o = await t(e.floating);
  return {
    reference: H_(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function q_(e) {
  return dn(e).direction === "rtl";
}
const U_ = {
  convertOffsetParentRelativeRectToViewportRelativeRect: D_,
  getDocumentElement: xn,
  getClippingRect: V_,
  getOffsetParent: vh,
  getElementRects: z_,
  getClientRects: L_,
  getDimensions: j_,
  getScale: qo,
  isElement: un,
  isRTL: q_
};
function bh(e, n) {
  return e.x === n.x && e.y === n.y && e.width === n.width && e.height === n.height;
}
function W_(e, n) {
  let t = null, o;
  const i = xn(e);
  function r() {
    var l;
    clearTimeout(o), (l = t) == null || l.disconnect(), t = null;
  }
  function a(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), r();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: c,
      height: h
    } = u;
    if (l || n(), !c || !h)
      return;
    const m = _r(f), g = _r(i.clientWidth - (d + c)), v = _r(i.clientHeight - (f + h)), p = _r(d), C = {
      rootMargin: -m + "px " + -g + "px " + -v + "px " + -p + "px",
      threshold: Kt(0, Xn(1, s)) || 1
    };
    let b = !0;
    function x(w) {
      const $ = w[0].intersectionRatio;
      if ($ !== s) {
        if (!b)
          return a();
        $ ? a(!1, $) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      $ === 1 && !bh(u, e.getBoundingClientRect()) && a(), b = !1;
    }
    try {
      t = new IntersectionObserver(x, {
        ...C,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(x, C);
    }
    t.observe(e);
  }
  return a(!0), r;
}
function K_(e, n, t, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: r = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = o, u = Gs(e), d = i || r ? [...u ? Vi(u) : [], ...Vi(n)] : [];
  d.forEach((p) => {
    i && p.addEventListener("scroll", t, {
      passive: !0
    }), r && p.addEventListener("resize", t);
  });
  const f = u && l ? W_(u, t) : null;
  let c = -1, h = null;
  a && (h = new ResizeObserver((p) => {
    let [y] = p;
    y && y.target === u && h && (h.unobserve(n), cancelAnimationFrame(c), c = requestAnimationFrame(() => {
      var C;
      (C = h) == null || C.observe(n);
    })), t();
  }), u && !s && h.observe(u), h.observe(n));
  let m, g = s ? wo(e) : null;
  s && v();
  function v() {
    const p = wo(e);
    g && !bh(g, p) && t(), g = p, m = requestAnimationFrame(v);
  }
  return t(), () => {
    var p;
    d.forEach((y) => {
      i && y.removeEventListener("scroll", t), r && y.removeEventListener("resize", t);
    }), f == null || f(), (p = h) == null || p.disconnect(), h = null, s && cancelAnimationFrame(m);
  };
}
const Y_ = O_, G_ = E_, Uc = $_, Z_ = S_, X_ = k_, J_ = w_, Q_ = M_, eO = (e, n, t) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: U_,
    ...t
  }, r = {
    ...i.platform,
    _c: o
  };
  return x_(e, n, {
    ...i,
    platform: r
  });
};
function tO(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Ql(e) {
  if (tO(e)) {
    const n = e.$el;
    return Ws(n) && Eo(n) === "#comment" ? null : n;
  }
  return e;
}
function No(e) {
  return typeof e == "function" ? e() : I(e);
}
function nO(e) {
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const t = Ql(No(e.element));
      return t == null ? {} : J_({
        element: t,
        padding: e.padding
      }).fn(n);
    }
  };
}
function yh(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Wc(e, n) {
  const t = yh(e);
  return Math.round(n * t) / t;
}
function oO(e, n, t) {
  t === void 0 && (t = {});
  const o = t.whileElementsMounted, i = ee(() => {
    var $;
    return ($ = No(t.open)) != null ? $ : !0;
  }), r = ee(() => No(t.middleware)), a = ee(() => {
    var $;
    return ($ = No(t.placement)) != null ? $ : "bottom";
  }), l = ee(() => {
    var $;
    return ($ = No(t.strategy)) != null ? $ : "absolute";
  }), s = ee(() => {
    var $;
    return ($ = No(t.transform)) != null ? $ : !0;
  }), u = ee(() => Ql(e.value)), d = ee(() => Ql(n.value)), f = X(0), c = X(0), h = X(l.value), m = X(a.value), g = ca({}), v = X(!1), p = ee(() => {
    const $ = {
      position: h.value,
      left: "0",
      top: "0"
    };
    if (!d.value)
      return $;
    const E = Wc(d.value, f.value), A = Wc(d.value, c.value);
    return s.value ? {
      ...$,
      transform: "translate(" + E + "px, " + A + "px)",
      ...yh(d.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: h.value,
      left: E + "px",
      top: A + "px"
    };
  });
  let y;
  function C() {
    if (u.value == null || d.value == null)
      return;
    const $ = i.value;
    eO(u.value, d.value, {
      middleware: r.value,
      placement: a.value,
      strategy: l.value
    }).then((E) => {
      f.value = E.x, c.value = E.y, h.value = E.strategy, m.value = E.placement, g.value = E.middlewareData, v.value = $ !== !1;
    });
  }
  function b() {
    typeof y == "function" && (y(), y = void 0);
  }
  function x() {
    if (b(), o === void 0) {
      C();
      return;
    }
    if (u.value != null && d.value != null) {
      y = o(u.value, d.value, C);
      return;
    }
  }
  function w() {
    i.value || (v.value = !1);
  }
  return Ne([r, a, l, i], C, {
    flush: "sync"
  }), Ne([u, d], x, {
    flush: "sync"
  }), Ne(i, w, {
    flush: "sync"
  }), os() && is(b), {
    x: Ao(f),
    y: Ao(c),
    strategy: Ao(h),
    placement: Ao(m),
    middlewareData: Ao(g),
    isPositioned: Ao(v),
    floatingStyles: p,
    update: C
  };
}
function Ot(e, n) {
  const t = typeof e == "string" && !n ? `${e}Context` : n, o = Symbol(t);
  return [(i) => {
    const r = eo(o, i);
    if (r || r === null)
      return r;
    throw new Error(
      `Injection \`${o.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(
        ", "
      )}` : `\`${e}\``}`
    );
  }, (i) => ($o(o, i), i)];
}
function Xs(e, n, t) {
  const o = t.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  n && o.addEventListener(e, n, { once: !0 }), o.dispatchEvent(i);
}
function iO(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var rO = function e(n, t) {
  if (n === t)
    return !0;
  if (n && t && typeof n == "object" && typeof t == "object") {
    if (n.constructor !== t.constructor)
      return !1;
    var o, i, r;
    if (Array.isArray(n)) {
      if (o = n.length, o != t.length)
        return !1;
      for (i = o; i-- !== 0; )
        if (!e(n[i], t[i]))
          return !1;
      return !0;
    }
    if (n.constructor === RegExp)
      return n.source === t.source && n.flags === t.flags;
    if (n.valueOf !== Object.prototype.valueOf)
      return n.valueOf() === t.valueOf();
    if (n.toString !== Object.prototype.toString)
      return n.toString() === t.toString();
    if (r = Object.keys(n), o = r.length, o !== Object.keys(t).length)
      return !1;
    for (i = o; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, r[i]))
        return !1;
    for (i = o; i-- !== 0; ) {
      var a = r[i];
      if (!e(n[a], t[a]))
        return !1;
    }
    return !0;
  }
  return n !== n && t !== t;
};
const ho = /* @__PURE__ */ iO(rO);
function dl(e) {
  return e == null;
}
function aO(e, n) {
  var t;
  const o = ca();
  return ct(() => {
    o.value = e();
  }, {
    ...n,
    flush: (t = void 0) != null ? t : "sync"
  }), a1(o);
}
function ti(e) {
  return os() ? (is(e), !0) : !1;
}
function lO() {
  const e = /* @__PURE__ */ new Set(), n = (t) => {
    e.delete(t);
  };
  return {
    on: (t) => {
      e.add(t);
      const o = () => n(t);
      return ti(o), {
        off: o
      };
    },
    off: n,
    trigger: (...t) => Promise.all(Array.from(e).map((o) => o(...t)))
  };
}
function sO(e) {
  let n = !1, t;
  const o = r1(!0);
  return (...i) => (n || (t = o.run(() => e(...i)), n = !0), t);
}
function uO(e) {
  let n = 0, t, o;
  const i = () => {
    n -= 1, o && n <= 0 && (o.stop(), t = void 0, o = void 0);
  };
  return (...r) => (n += 1, t || (o = r1(!0), t = o.run(() => e(...r))), ti(i), t);
}
function An(e) {
  return typeof e == "function" ? e() : I(e);
}
const Nn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const dO = (e) => typeof e < "u", cO = (e) => e != null, fO = Object.prototype.toString, hO = (e) => fO.call(e) === "[object Object]", gO = () => {
}, Kc = /* @__PURE__ */ mO();
function mO() {
  var e, n;
  return Nn && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((n = window == null ? void 0 : window.navigator) == null ? void 0 : n.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function pO(e) {
  return yn();
}
function vO(e, n = 1e4) {
  return x0((t, o) => {
    let i = An(e), r;
    const a = () => setTimeout(() => {
      i = An(e), o();
    }, An(n));
    return ti(() => {
      clearTimeout(r);
    }), {
      get() {
        return t(), i;
      },
      set(l) {
        i = l, o(), clearTimeout(r), r = a();
      }
    };
  });
}
function bO(e, n) {
  pO() && w0(e, n);
}
function Ch(e, n, t = {}) {
  const {
    immediate: o = !0
  } = t, i = X(!1);
  let r = null;
  function a() {
    r && (clearTimeout(r), r = null);
  }
  function l() {
    i.value = !1, a();
  }
  function s(...u) {
    a(), i.value = !0, r = setTimeout(() => {
      i.value = !1, r = null, e(...u);
    }, An(n));
  }
  return o && (i.value = !0, Nn && s()), ti(l), {
    isPending: a1(i),
    start: s,
    stop: l
  };
}
function Fn(e) {
  var n;
  const t = An(e);
  return (n = t == null ? void 0 : t.$el) != null ? n : t;
}
const Ji = Nn ? window : void 0;
function Zo(...e) {
  let n, t, o, i;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, o, i] = e, n = Ji) : [n, t, o, i] = e, !n)
    return gO;
  Array.isArray(t) || (t = [t]), Array.isArray(o) || (o = [o]);
  const r = [], a = () => {
    r.forEach((d) => d()), r.length = 0;
  }, l = (d, f, c, h) => (d.addEventListener(f, c, h), () => d.removeEventListener(f, c, h)), s = Ne(
    () => [Fn(n), An(i)],
    ([d, f]) => {
      if (a(), !d)
        return;
      const c = hO(f) ? { ...f } : f;
      r.push(
        ...t.flatMap((h) => o.map((m) => l(d, h, m, c)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    s(), a();
  };
  return ti(u), u;
}
function yO(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (n) => n.key === e : Array.isArray(e) ? (n) => e.includes(n.key) : () => !0;
}
function CO(...e) {
  let n, t, o = {};
  e.length === 3 ? (n = e[0], t = e[1], o = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (n = !0, t = e[0], o = e[1]) : (n = e[0], t = e[1]) : (n = !0, t = e[0]);
  const {
    target: i = Ji,
    eventName: r = "keydown",
    passive: a = !1,
    dedupe: l = !1
  } = o, s = yO(n);
  return Zo(i, r, (u) => {
    u.repeat && An(l) || s(u) && t(u);
  }, a);
}
function xh() {
  const e = X(!1), n = yn();
  return n && Ge(() => {
    e.value = !0;
  }, n), e;
}
function xO(e) {
  const n = xh();
  return ee(() => (n.value, !!e()));
}
function wh(e, n, t = {}) {
  const { window: o = Ji, ...i } = t;
  let r;
  const a = xO(() => o && "MutationObserver" in o), l = () => {
    r && (r.disconnect(), r = void 0);
  }, s = ee(() => {
    const c = An(e), h = (Array.isArray(c) ? c : [c]).map(Fn).filter(cO);
    return new Set(h);
  }), u = Ne(
    () => s.value,
    (c) => {
      l(), a.value && c.size && (r = new MutationObserver(n), c.forEach((h) => r.observe(h, i)));
    },
    { immediate: !0, flush: "post" }
  ), d = () => r == null ? void 0 : r.takeRecords(), f = () => {
    l(), u();
  };
  return ti(f), {
    isSupported: a,
    stop: f,
    takeRecords: d
  };
}
function wO(e = {}) {
  var n;
  const {
    window: t = Ji,
    deep: o = !0,
    triggerOnRemoval: i = !1
  } = e, r = (n = e.document) != null ? n : t == null ? void 0 : t.document, a = () => {
    var u;
    let d = r == null ? void 0 : r.activeElement;
    if (o)
      for (; d != null && d.shadowRoot; )
        d = (u = d == null ? void 0 : d.shadowRoot) == null ? void 0 : u.activeElement;
    return d;
  }, l = X(), s = () => {
    l.value = a();
  };
  return t && (Zo(t, "blur", (u) => {
    u.relatedTarget === null && s();
  }, !0), Zo(t, "focus", s, !0)), i && wh(r, (u) => {
    u.filter((d) => d.removedNodes.length).map((d) => Array.from(d.removedNodes)).flat().forEach((d) => {
      d === l.value && s();
    });
  }, {
    childList: !0,
    subtree: !0
  }), s(), l;
}
function $O(e) {
  return JSON.parse(JSON.stringify(e));
}
function kO(e, n = {}) {
  const t = wO(n), o = ee(() => Fn(e));
  return { focused: ee(() => o.value && t.value ? o.value.contains(t.value) : !1) };
}
function tn(e, n, t, o = {}) {
  var i, r, a;
  const {
    clone: l = !1,
    passive: s = !1,
    eventName: u,
    deep: d = !1,
    defaultValue: f,
    shouldEmit: c
  } = o, h = yn(), m = t || (h == null ? void 0 : h.emit) || ((i = h == null ? void 0 : h.$emit) == null ? void 0 : i.bind(h)) || ((a = (r = h == null ? void 0 : h.proxy) == null ? void 0 : r.$emit) == null ? void 0 : a.bind(h == null ? void 0 : h.proxy));
  let g = u;
  n || (n = "modelValue"), g = g || `update:${n.toString()}`;
  const v = (C) => l ? typeof l == "function" ? l(C) : $O(C) : C, p = () => dO(e[n]) ? v(e[n]) : f, y = (C) => {
    c ? c(C) && m(g, C) : m(g, C);
  };
  if (s) {
    const C = p(), b = X(C);
    let x = !1;
    return Ne(
      () => e[n],
      (w) => {
        x || (x = !0, b.value = v(w), He(() => x = !1));
      }
    ), Ne(
      b,
      (w) => {
        !x && (w !== e[n] || d) && y(w);
      },
      { deep: d }
    ), b;
  } else
    return ee({
      get() {
        return p();
      },
      set(C) {
        y(C);
      }
    });
}
function Js(e) {
  return e ? e.flatMap((n) => n.type === me ? Js(n.children) : [n]) : [];
}
function Kn() {
  let e = document.activeElement;
  if (e == null)
    return null;
  for (; e != null && e.shadowRoot != null && e.shadowRoot.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
const _O = ["INPUT", "TEXTAREA"];
function $h(e, n, t, o = {}) {
  if (!n || o.enableIgnoredElement && _O.includes(n.nodeName))
    return null;
  const {
    arrowKeyOptions: i = "both",
    attributeName: r = "[data-radix-vue-collection-item]",
    itemsArray: a = [],
    loop: l = !0,
    dir: s = "ltr",
    preventScroll: u = !0,
    focus: d = !1
  } = o, [f, c, h, m, g, v] = [
    e.key === "ArrowRight",
    e.key === "ArrowLeft",
    e.key === "ArrowUp",
    e.key === "ArrowDown",
    e.key === "Home",
    e.key === "End"
  ], p = h || m, y = f || c;
  if (!g && !v && (!p && !y || i === "vertical" && y || i === "horizontal" && p))
    return null;
  const C = t ? Array.from(t.querySelectorAll(r)) : a;
  if (!C.length)
    return null;
  u && e.preventDefault();
  let b = null;
  return y || p ? b = kh(C, n, {
    goForward: p ? m : s === "ltr" ? f : c,
    loop: l
  }) : g ? b = C.at(0) || null : v && (b = C.at(-1) || null), d && (b == null || b.focus()), b;
}
function kh(e, n, t, o = e.length) {
  if (--o === 0)
    return null;
  const i = e.indexOf(n), r = t.goForward ? i + 1 : i - 1;
  if (!t.loop && (r < 0 || r >= e.length))
    return null;
  const a = (r + e.length) % e.length, l = e[a];
  return l ? l.hasAttribute("disabled") && l.getAttribute("disabled") !== "false" ? kh(
    e,
    l,
    t,
    o
  ) : l : null;
}
function cl(e) {
  if (e === null || typeof e != "object")
    return !1;
  const n = Object.getPrototypeOf(e);
  return n !== null && n !== Object.prototype && Object.getPrototypeOf(n) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function es(e, n, t = ".", o) {
  if (!cl(n))
    return es(e, {}, t, o);
  const i = Object.assign({}, n);
  for (const r in e) {
    if (r === "__proto__" || r === "constructor")
      continue;
    const a = e[r];
    a != null && (o && o(i, r, a, t) || (Array.isArray(a) && Array.isArray(i[r]) ? i[r] = [...a, ...i[r]] : cl(a) && cl(i[r]) ? i[r] = es(
      a,
      i[r],
      (t ? `${t}.` : "") + r.toString(),
      o
    ) : i[r] = a));
  }
  return i;
}
function OO(e) {
  return (...n) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    n.reduce((t, o) => es(t, o, "", e), {})
  );
}
const EO = OO(), [Ea, UA] = Ot("ConfigProvider");
let MO = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", SO = (e = 21) => {
  let n = "", t = e;
  for (; t--; )
    n += MO[Math.random() * 64 | 0];
  return n;
};
const AO = uO(() => {
  const e = X(/* @__PURE__ */ new Map()), n = X(), t = ee(() => {
    for (const a of e.value.values())
      if (a)
        return !0;
    return !1;
  }), o = Ea({
    scrollBody: X(!0)
  });
  let i = null;
  const r = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = n.value ?? "", Kc && (i == null || i()), n.value = void 0;
  };
  return Ne(t, (a, l) => {
    var s;
    if (!Nn)
      return;
    if (!a) {
      l && r();
      return;
    }
    n.value === void 0 && (n.value = document.body.style.overflow);
    const u = window.innerWidth - document.documentElement.clientWidth, d = { padding: u, margin: 0 }, f = (s = o.scrollBody) != null && s.value ? typeof o.scrollBody.value == "object" ? EO({
      padding: o.scrollBody.value.padding === !0 ? u : o.scrollBody.value.padding,
      margin: o.scrollBody.value.margin === !0 ? u : o.scrollBody.value.margin
    }, d) : d : { padding: 0, margin: 0 };
    u > 0 && (document.body.style.paddingRight = typeof f.padding == "number" ? `${f.padding}px` : String(f.padding), document.body.style.marginRight = typeof f.margin == "number" ? `${f.margin}px` : String(f.margin), document.body.style.setProperty("--scrollbar-width", `${u}px`), document.body.style.overflow = "hidden"), Kc && (i = Zo(
      document,
      "touchmove",
      (c) => TO(c),
      { passive: !1 }
    )), He(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), e;
});
function Qs(e) {
  const n = SO(6), t = AO();
  t.value.set(n, e ?? !1);
  const o = ee({
    get: () => t.value.get(n) ?? !1,
    set: (i) => t.value.set(n, i)
  });
  return bO(() => {
    t.value.delete(n);
  }), o;
}
function _h(e) {
  const n = window.getComputedStyle(e);
  if (n.overflowX === "scroll" || n.overflowY === "scroll" || n.overflowX === "auto" && e.clientWidth < e.scrollWidth || n.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const t = e.parentNode;
    return !(t instanceof Element) || t.tagName === "BODY" ? !1 : _h(t);
  }
}
function TO(e) {
  const n = e || window.event, t = n.target;
  return t instanceof Element && _h(t) ? !1 : n.touches.length > 1 ? !0 : (n.preventDefault && n.cancelable && n.preventDefault(), !1);
}
function eu(e) {
  const n = Ea({
    dir: X("ltr")
  });
  return ee(() => {
    var t;
    return (e == null ? void 0 : e.value) || ((t = n.dir) == null ? void 0 : t.value) || "ltr";
  });
}
function Ma(e) {
  const n = yn(), t = n == null ? void 0 : n.type.emits, o = {};
  return t != null && t.length || console.warn(
    `No emitted event found. Please check component: ${n == null ? void 0 : n.type.__name}`
  ), t == null || t.forEach((i) => {
    o[m0(l1(i))] = (...r) => e(i, ...r);
  }), o;
}
let fl = 0;
function PO() {
  ct((e) => {
    if (!Nn)
      return;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      n[0] ?? Yc()
    ), document.body.insertAdjacentElement(
      "beforeend",
      n[1] ?? Yc()
    ), fl++, e(() => {
      fl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), fl--;
    });
  });
}
function Yc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
function Oh(e) {
  return ee(() => {
    var n;
    return An(e) ? !!((n = Fn(e)) != null && n.closest("form")) : !0;
  });
}
function Sa(e) {
  const n = yn(), t = Object.keys((n == null ? void 0 : n.type.props) ?? {}).reduce((i, r) => {
    const a = (n == null ? void 0 : n.type.props[r]).default;
    return a !== void 0 && (i[r] = a), i;
  }, {}), o = b0(e);
  return ee(() => {
    const i = {}, r = (n == null ? void 0 : n.vnode.props) ?? {};
    return Object.keys(r).forEach((a) => {
      i[l1(a)] = r[a];
    }), Object.keys({ ...t, ...i }).reduce((a, l) => (o.value[l] !== void 0 && (a[l] = o.value[l]), a), {});
  });
}
function Qi(e, n) {
  const t = Sa(e), o = n ? Ma(n) : {};
  return ee(() => ({
    ...t.value,
    ...o
  }));
}
function Me() {
  const e = yn(), n = X(), t = ee(() => {
    var a, l;
    return ["#text", "#comment"].includes((a = n.value) == null ? void 0 : a.$el.nodeName) ? (l = n.value) == null ? void 0 : l.$el.nextElementSibling : Fn(n);
  }), o = Object.assign({}, e.exposed), i = {};
  for (const a in e.props)
    Object.defineProperty(i, a, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[a]
    });
  if (Object.keys(o).length > 0)
    for (const a in o)
      Object.defineProperty(i, a, {
        enumerable: !0,
        configurable: !0,
        get: () => o[a]
      });
  Object.defineProperty(i, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => e.vnode.el
  }), e.exposed = i;
  function r(a) {
    n.value = a, a && (Object.defineProperty(i, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => a instanceof Element ? a : a.$el
    }), e.exposed = i);
  }
  return { forwardRef: r, currentRef: n, currentElement: t };
}
function IO(e, n) {
  const t = vO(!1, 300), o = X(null), i = lO();
  function r() {
    o.value = null, t.value = !1;
  }
  function a(l, s) {
    const u = l.currentTarget, d = { x: l.clientX, y: l.clientY }, f = DO(d, u.getBoundingClientRect()), c = LO(d, f), h = NO(s.getBoundingClientRect()), m = RO([...c, ...h]);
    o.value = m, t.value = !0;
  }
  return ct((l) => {
    if (e.value && n.value) {
      const s = (d) => a(d, n.value), u = (d) => a(d, e.value);
      e.value.addEventListener("pointerleave", s), n.value.addEventListener("pointerleave", u), l(() => {
        var d, f;
        (d = e.value) == null || d.removeEventListener("pointerleave", s), (f = n.value) == null || f.removeEventListener("pointerleave", u);
      });
    }
  }), ct((l) => {
    var s;
    if (o.value) {
      const u = (d) => {
        var f, c;
        if (!o.value)
          return;
        const h = d.target, m = { x: d.clientX, y: d.clientY }, g = ((f = e.value) == null ? void 0 : f.contains(h)) || ((c = n.value) == null ? void 0 : c.contains(h)), v = !FO(m, o.value), p = !!h.closest("[data-grace-area-trigger]");
        g ? r() : (v || p) && (r(), i.trigger());
      };
      (s = e.value) == null || s.ownerDocument.addEventListener("pointermove", u), l(() => {
        var d;
        return (d = e.value) == null ? void 0 : d.ownerDocument.removeEventListener("pointermove", u);
      });
    }
  }), {
    isPointerInTransit: t,
    onPointerExit: i.on
  };
}
function DO(e, n) {
  const t = Math.abs(n.top - e.y), o = Math.abs(n.bottom - e.y), i = Math.abs(n.right - e.x), r = Math.abs(n.left - e.x);
  switch (Math.min(t, o, i, r)) {
    case r:
      return "left";
    case i:
      return "right";
    case t:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function LO(e, n, t = 5) {
  const o = [];
  switch (n) {
    case "top":
      o.push(
        { x: e.x - t, y: e.y + t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "bottom":
      o.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x + t, y: e.y - t }
      );
      break;
    case "left":
      o.push(
        { x: e.x + t, y: e.y - t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "right":
      o.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x - t, y: e.y + t }
      );
      break;
  }
  return o;
}
function NO(e) {
  const { top: n, right: t, bottom: o, left: i } = e;
  return [
    { x: i, y: n },
    { x: t, y: n },
    { x: t, y: o },
    { x: i, y: o }
  ];
}
function FO(e, n) {
  const { x: t, y: o } = e;
  let i = !1;
  for (let r = 0, a = n.length - 1; r < n.length; a = r++) {
    const l = n[r].x, s = n[r].y, u = n[a].x, d = n[a].y;
    s > o != d > o && t < (u - l) * (o - s) / (d - s) + l && (i = !i);
  }
  return i;
}
function RO(e) {
  const n = e.slice();
  return n.sort((t, o) => t.x < o.x ? -1 : t.x > o.x ? 1 : t.y < o.y ? -1 : t.y > o.y ? 1 : 0), BO(n);
}
function BO(e) {
  if (e.length <= 1)
    return e.slice();
  const n = [];
  for (let o = 0; o < e.length; o++) {
    const i = e[o];
    for (; n.length >= 2; ) {
      const r = n[n.length - 1], a = n[n.length - 2];
      if ((r.x - a.x) * (i.y - a.y) >= (r.y - a.y) * (i.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(i);
  }
  n.pop();
  const t = [];
  for (let o = e.length - 1; o >= 0; o--) {
    const i = e[o];
    for (; t.length >= 2; ) {
      const r = t[t.length - 1], a = t[t.length - 2];
      if ((r.x - a.x) * (i.y - a.y) >= (r.y - a.y) * (i.x - a.x))
        t.pop();
      else
        break;
    }
    t.push(i);
  }
  return t.pop(), n.length === 1 && t.length === 1 && n[0].x === t[0].x && n[0].y === t[0].y ? n : n.concat(t);
}
var VO = function(e) {
  if (typeof document > "u")
    return null;
  var n = Array.isArray(e) ? e[0] : e;
  return n.ownerDocument.body;
}, Lo = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), Er = {}, hl = 0, Eh = function(e) {
  return e && (e.host || Eh(e.parentNode));
}, jO = function(e, n) {
  return n.map(function(t) {
    if (e.contains(t))
      return t;
    var o = Eh(t);
    return o && e.contains(o) ? o : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, HO = function(e, n, t, o) {
  var i = jO(n, Array.isArray(e) ? e : [e]);
  Er[t] || (Er[t] = /* @__PURE__ */ new WeakMap());
  var r = Er[t], a = [], l = /* @__PURE__ */ new Set(), s = new Set(i), u = function(f) {
    !f || l.has(f) || (l.add(f), u(f.parentNode));
  };
  i.forEach(u);
  var d = function(f) {
    !f || s.has(f) || Array.prototype.forEach.call(f.children, function(c) {
      if (l.has(c))
        d(c);
      else
        try {
          var h = c.getAttribute(o), m = h !== null && h !== "false", g = (Lo.get(c) || 0) + 1, v = (r.get(c) || 0) + 1;
          Lo.set(c, g), r.set(c, v), a.push(c), g === 1 && m && Or.set(c, !0), v === 1 && c.setAttribute(t, "true"), m || c.setAttribute(o, "true");
        } catch (p) {
          console.error("aria-hidden: cannot operate on ", c, p);
        }
    });
  };
  return d(n), l.clear(), hl++, function() {
    a.forEach(function(f) {
      var c = Lo.get(f) - 1, h = r.get(f) - 1;
      Lo.set(f, c), r.set(f, h), c || (Or.has(f) || f.removeAttribute(o), Or.delete(f)), h || f.removeAttribute(t);
    }), hl--, hl || (Lo = /* @__PURE__ */ new WeakMap(), Lo = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), Er = {});
  };
}, zO = function(e, n, t) {
  t === void 0 && (t = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), i = VO(e);
  return i ? (o.push.apply(o, Array.from(i.querySelectorAll("[aria-live]"))), HO(o, i, t, "aria-hidden")) : function() {
    return null;
  };
};
function tu(e) {
  let n;
  Ne(() => Fn(e), (t) => {
    t ? n = zO(t) : n && n();
  }), to(() => {
    n && n();
  });
}
let qO = 0;
function nn(e, n = "radix") {
  if (e)
    return e;
  const t = Ea({ useId: void 0 });
  return du.useId ? `${n}-${du.useId()}` : t.useId ? `${n}-${t.useId()}` : `${n}-${++qO}`;
}
function UO(e) {
  const n = X(), t = ee(() => {
    var i;
    return ((i = n.value) == null ? void 0 : i.width) ?? 0;
  }), o = ee(() => {
    var i;
    return ((i = n.value) == null ? void 0 : i.height) ?? 0;
  });
  return Ge(() => {
    const i = Fn(e);
    if (i) {
      n.value = { width: i.offsetWidth, height: i.offsetHeight };
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const l = a[0];
        let s, u;
        if ("borderBoxSize" in l) {
          const d = l.borderBoxSize, f = Array.isArray(d) ? d[0] : d;
          s = f.inlineSize, u = f.blockSize;
        } else
          s = i.offsetWidth, u = i.offsetHeight;
        n.value = { width: s, height: u };
      });
      return r.observe(i, { box: "border-box" }), () => r.unobserve(i);
    } else
      n.value = void 0;
  }), {
    width: t,
    height: o
  };
}
function WO(e, n) {
  const t = X(e);
  function o(i) {
    return n[t.value][i] ?? t.value;
  }
  return {
    state: t,
    dispatch: (i) => {
      t.value = o(i);
    }
  };
}
const nu = re({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(e, { attrs: n, slots: t }) {
    return () => {
      var o, i;
      if (!t.default)
        return null;
      const r = Js(t.default()), a = r.findIndex((d) => d.type !== o1);
      if (a === -1)
        return r;
      const l = r[a];
      (o = l.props) == null || delete o.ref;
      const s = l.props ? ze(n, l.props) : n;
      n.class && (i = l.props) != null && i.class && delete l.props.class;
      const u = t1(l, s);
      for (const d in s)
        d.startsWith("on") && (u.props || (u.props = {}), u.props[d] = s[d]);
      return r.length === 1 ? u : (r[a] = u, r);
    };
  }
}), Ve = re({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(e, { attrs: n, slots: t }) {
    const o = e.asChild ? "template" : e.as;
    return typeof o == "string" && ["area", "img", "input"].includes(o) ? () => wt(o, n) : o !== "template" ? () => wt(e.as, n, { default: t.default }) : () => wt(nu, n, { default: t.default });
  }
});
function Mh() {
  const e = X(), n = ee(() => {
    var t, o;
    return ["#text", "#comment"].includes((t = e.value) == null ? void 0 : t.$el.nodeName) ? (o = e.value) == null ? void 0 : o.$el.nextElementSibling : Fn(e);
  });
  return {
    primitiveElement: e,
    currentElement: n
  };
}
const [Sh, KO] = Ot("CollapsibleRoot"), YO = /* @__PURE__ */ re({
  __name: "CollapsibleRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:open"],
  setup(e, { expose: n, emit: t }) {
    const o = e, i = tn(o, "open", t, {
      defaultValue: o.defaultOpen,
      passive: o.open === void 0
    }), r = tn(o, "disabled");
    return KO({
      contentId: "",
      disabled: r,
      open: i,
      onOpenToggle: () => {
        i.value = !i.value;
      }
    }), n({ open: i }), Me(), (a, l) => (_(), ie(I(Ve), {
      as: a.as,
      "as-child": o.asChild,
      "data-state": I(i) ? "open" : "closed",
      "data-disabled": I(r) ? "" : void 0
    }, {
      default: J(() => [
        be(a.$slots, "default", { open: I(i) })
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state", "data-disabled"]));
  }
}), GO = /* @__PURE__ */ re({
  __name: "CollapsibleTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e;
    Me();
    const t = Sh();
    return (o, i) => {
      var r, a;
      return _(), ie(I(Ve), {
        type: o.as === "button" ? "button" : void 0,
        as: o.as,
        "as-child": n.asChild,
        "aria-controls": I(t).contentId,
        "aria-expanded": I(t).open.value,
        "data-state": I(t).open.value ? "open" : "closed",
        "data-disabled": (r = I(t).disabled) != null && r.value ? "" : void 0,
        disabled: (a = I(t).disabled) == null ? void 0 : a.value,
        onClick: I(t).onOpenToggle
      }, {
        default: J(() => [
          be(o.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "as", "as-child", "aria-controls", "aria-expanded", "data-state", "data-disabled", "disabled", "onClick"]);
    };
  }
});
function ZO(e, n) {
  var t;
  const o = X({}), i = X("none"), r = X(e), a = e.value ? "mounted" : "unmounted";
  let l;
  const s = ((t = n.value) == null ? void 0 : t.ownerDocument.defaultView) ?? Ji, { state: u, dispatch: d } = WO(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), f = (v) => {
    var p;
    if (Nn) {
      const y = new CustomEvent(v, { bubbles: !1, cancelable: !1 });
      (p = n.value) == null || p.dispatchEvent(y);
    }
  };
  Ne(
    e,
    async (v, p) => {
      var y;
      const C = p !== v;
      if (await He(), C) {
        const b = i.value, x = Mr(n.value);
        v ? (d("MOUNT"), f("enter"), x === "none" && f("after-enter")) : x === "none" || ((y = o.value) == null ? void 0 : y.display) === "none" ? (d("UNMOUNT"), f("leave"), f("after-leave")) : p && b !== x ? (d("ANIMATION_OUT"), f("leave")) : (d("UNMOUNT"), f("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const c = (v) => {
    const p = Mr(n.value), y = p.includes(
      v.animationName
    ), C = u.value === "mounted" ? "enter" : "leave";
    if (v.target === n.value && y && (f(`after-${C}`), d("ANIMATION_END"), !r.value)) {
      const b = n.value.style.animationFillMode;
      n.value.style.animationFillMode = "forwards", l = s == null ? void 0 : s.setTimeout(() => {
        var x;
        ((x = n.value) == null ? void 0 : x.style.animationFillMode) === "forwards" && (n.value.style.animationFillMode = b);
      });
    }
    v.target === n.value && p === "none" && d("ANIMATION_END");
  }, h = (v) => {
    v.target === n.value && (i.value = Mr(n.value));
  }, m = Ne(
    n,
    (v, p) => {
      v ? (o.value = getComputedStyle(v), v.addEventListener("animationstart", h), v.addEventListener("animationcancel", c), v.addEventListener("animationend", c)) : (d("ANIMATION_END"), l !== void 0 && (s == null || s.clearTimeout(l)), p == null || p.removeEventListener("animationstart", h), p == null || p.removeEventListener("animationcancel", c), p == null || p.removeEventListener("animationend", c));
    },
    { immediate: !0 }
  ), g = Ne(u, () => {
    const v = Mr(n.value);
    i.value = u.value === "mounted" ? v : "none";
  });
  return to(() => {
    m(), g();
  }), {
    isPresent: ee(
      () => ["mounted", "unmountSuspended"].includes(u.value)
    )
  };
}
function Mr(e) {
  return e && getComputedStyle(e).animationName || "none";
}
const ni = re({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(e, { slots: n, expose: t }) {
    var o;
    const { present: i, forceMount: r } = on(e), a = X(), { isPresent: l } = ZO(i, a);
    t({ present: l });
    let s = n.default({ present: l });
    s = Js(s || []);
    const u = yn();
    if (s && (s == null ? void 0 : s.length) > 1) {
      const d = (o = u == null ? void 0 : u.parent) != null && o.type.name ? `<${u.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${d}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((f) => `  - ${f}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => r.value || i.value || l.value ? wt(n.default({ present: l })[0], {
      ref: (d) => {
        const f = Fn(d);
        return typeof (f == null ? void 0 : f.hasAttribute) > "u" || (f != null && f.hasAttribute("data-radix-popper-content-wrapper") ? a.value = f.firstElementChild : a.value = f), f;
      }
    }) : null;
  }
}), XO = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "CollapsibleContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e, t = Sh();
    t.contentId || (t.contentId = nn(void 0, "radix-vue-collapsible-content"));
    const o = X(), { forwardRef: i, currentElement: r } = Me(), a = X(0), l = X(0), s = ee(() => t.open.value), u = X(s.value), d = X();
    return Ne(
      () => {
        var f;
        return [s.value, (f = o.value) == null ? void 0 : f.present];
      },
      async () => {
        await He();
        const f = r.value;
        if (!f)
          return;
        d.value = d.value || {
          transitionDuration: f.style.transitionDuration,
          animationName: f.style.animationName
        }, f.style.transitionDuration = "0s", f.style.animationName = "none";
        const c = f.getBoundingClientRect();
        l.value = c.height, a.value = c.width, u.value || (f.style.transitionDuration = d.value.transitionDuration, f.style.animationName = d.value.animationName);
      },
      {
        immediate: !0
      }
    ), Ge(() => {
      requestAnimationFrame(() => {
        u.value = !1;
      });
    }), (f, c) => (_(), ie(I(ni), {
      ref_key: "presentRef",
      ref: o,
      present: f.forceMount || I(t).open.value,
      "force-mount": !0
    }, {
      default: J(() => {
        var h, m;
        return [
          ce(I(Ve), ze(f.$attrs, {
            id: I(t).contentId,
            ref: I(i),
            "as-child": n.asChild,
            as: f.as,
            "data-state": I(t).open.value ? "open" : "closed",
            "data-disabled": (h = I(t).disabled) != null && h.value ? "" : void 0,
            hidden: !((m = o.value) != null && m.present),
            style: {
              "--radix-collapsible-content-height": `${l.value}px`,
              "--radix-collapsible-content-width": `${a.value}px`
            }
          }), {
            default: J(() => {
              var g;
              return [
                (g = o.value) != null && g.present ? be(f.$slots, "default", { key: 0 }) : z("", !0)
              ];
            }),
            _: 3
          }, 16, ["id", "as-child", "as", "data-state", "data-disabled", "hidden", "style"])
        ];
      }),
      _: 3
    }, 8, ["present"]));
  }
});
function Ah({ type: e, defaultValue: n, modelValue: t }) {
  const o = t || n;
  if (dl(e) && dl(t) && dl(n))
    throw new Error("Either the `type` or the `value` or `default-value` prop must be defined.");
  if (t !== void 0 && n !== void 0 && typeof t != typeof n)
    throw new Error(
      `Invalid prop \`value\` of value \`${t}\` supplied, should be the same type as the \`defaultValue\` prop, which is \`${n}\`. The \`value\` prop must be:
  ${e === "single" ? "- a string" : e === "multiple" ? "- an array of strings" : `- a string
- an array of strings`}
  - \`undefined\``
    );
  const i = t !== void 0 || n !== void 0;
  if (e && i) {
    const r = Array.isArray(t) || Array.isArray(n), a = t !== void 0 ? "modelValue" : "defaultValue", l = a === "modelValue" ? typeof t : typeof n;
    if (e === "single" && r)
      return console.error(`Invalid prop \`${a}\` of type ${l} supplied with type \`single\`. The \`modelValue\` prop must be a string or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${a} prop.`), "multiple";
    if (e === "multiple" && !r)
      return console.error(`Invalid prop \`${a}\` of type ${l} supplied with type \`multiple\`. The \`modelValue\` prop must be an array of strings or \`undefined\`.
    You can remove the \`type\` prop to let the component infer the type from the ${a} prop.`), "single";
  }
  return i ? Array.isArray(o) ? "multiple" : "single" : e;
}
function JO({ type: e, defaultValue: n, modelValue: t }) {
  return e || Ah({ type: e, defaultValue: n, modelValue: t });
}
function QO({ type: e, defaultValue: n }) {
  return n !== void 0 ? n : e === "single" ? void 0 : [];
}
function eE(e, n) {
  const t = X(JO(e)), o = tn(e, "modelValue", n, {
    defaultValue: QO(e),
    passive: e.modelValue === void 0,
    deep: !0
  });
  Ne(
    () => [e.type, e.modelValue, e.defaultValue],
    () => {
      const a = Ah(e);
      t.value !== a && (t.value = a);
    },
    { immediate: !0 }
  );
  function i(a) {
    if (t.value === "single")
      o.value = a === o.value ? void 0 : a;
    else {
      const l = [...o.value || []];
      if (l.includes(a)) {
        const s = l.findIndex((u) => u === a);
        l.splice(s, 1);
      } else
        l.push(a);
      o.value = l;
    }
  }
  const r = ee(() => t.value === "single");
  return {
    modelValue: o,
    type: t,
    changeModelValue: i,
    isSingle: r
  };
}
const [Aa, tE] = Ot("AccordionRoot"), nE = /* @__PURE__ */ re({
  __name: "AccordionRoot",
  props: {
    collapsible: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dir: {},
    orientation: { default: "vertical" },
    asChild: { type: Boolean },
    as: {},
    type: {},
    modelValue: {},
    defaultValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, { dir: i, disabled: r } = on(t), a = eu(i), { modelValue: l, changeModelValue: s, isSingle: u } = eE(t, o), { forwardRef: d, currentElement: f } = Me();
    return tE({
      disabled: r,
      direction: a,
      orientation: t.orientation,
      parentElement: f,
      isSingle: u,
      collapsible: t.collapsible,
      modelValue: l,
      changeModelValue: s
    }), (c, h) => (_(), ie(I(Ve), {
      ref: I(d),
      "as-child": c.asChild,
      as: c.as
    }, {
      default: J(() => [
        be(c.$slots, "default", { modelValue: I(l) })
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), [ou, oE] = Ot("AccordionItem"), iE = /* @__PURE__ */ re({
  __name: "AccordionItem",
  props: {
    disabled: { type: Boolean },
    value: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e, { expose: n }) {
    const t = e, o = Aa(), i = ee(
      () => o.isSingle.value ? t.value === o.modelValue.value : Array.isArray(o.modelValue.value) && o.modelValue.value.includes(t.value)
    ), r = ee(() => o.disabled.value || t.disabled), a = ee(() => r.value ? "" : void 0), l = ee(
      () => i.value ? "open" : "closed"
      /* Closed */
    );
    n({ open: i, dataDisabled: a });
    const { currentRef: s, currentElement: u } = Me();
    oE({
      open: i,
      dataState: l,
      disabled: r,
      dataDisabled: a,
      triggerId: "",
      currentRef: s,
      currentElement: u,
      value: ee(() => t.value)
    });
    function d(f) {
      var c;
      const h = f.target;
      if (Array.from(((c = o.parentElement.value) == null ? void 0 : c.querySelectorAll("[data-radix-vue-collection-item]")) ?? []).findIndex((m) => m === h) === -1)
        return null;
      $h(
        f,
        u.value,
        o.parentElement.value,
        {
          arrowKeyOptions: o.orientation,
          dir: o.direction.value,
          focus: !0
        }
      );
    }
    return (f, c) => (_(), ie(I(YO), {
      "data-orientation": I(o).orientation,
      "data-disabled": a.value,
      "data-state": l.value,
      disabled: r.value,
      open: i.value,
      as: t.as,
      "as-child": t.asChild,
      onKeydown: pn(d, ["up", "down", "left", "right", "home", "end"])
    }, {
      default: J(() => [
        be(f.$slots, "default", { open: i.value })
      ]),
      _: 3
    }, 8, ["data-orientation", "data-disabled", "data-state", "disabled", "open", "as", "as-child"]));
  }
}), rE = /* @__PURE__ */ re({
  __name: "AccordionContent",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e, t = Aa(), o = ou();
    return Me(), (i, r) => (_(), ie(I(XO), {
      role: "region",
      hidden: !I(o).open.value,
      "as-child": n.asChild,
      "force-mount": n.forceMount,
      "aria-labelledby": I(o).triggerId,
      "data-state": I(o).dataState.value,
      "data-disabled": I(o).dataDisabled.value,
      "data-orientation": I(t).orientation,
      style: { "--radix-accordion-content-width": "var(--radix-collapsible-content-width)", "--radix-accordion-content-height": "var(--radix-collapsible-content-height)" }
    }, {
      default: J(() => [
        be(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["hidden", "as-child", "force-mount", "aria-labelledby", "data-state", "data-disabled", "data-orientation"]));
  }
}), aE = /* @__PURE__ */ re({
  __name: "AccordionHeader",
  props: {
    asChild: { type: Boolean },
    as: { default: "h3" }
  },
  setup(e) {
    const n = e, t = Aa(), o = ou();
    return Me(), (i, r) => (_(), ie(I(Ve), {
      as: n.as,
      "as-child": n.asChild,
      "data-orientation": I(t).orientation,
      "data-state": I(o).dataState.value,
      "data-disabled": I(o).dataDisabled.value
    }, {
      default: J(() => [
        be(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-orientation", "data-state", "data-disabled"]));
  }
}), lE = /* @__PURE__ */ re({
  __name: "AccordionTrigger",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e, t = Aa(), o = ou();
    o.triggerId || (o.triggerId = nn(void 0, "radix-vue-accordion-trigger"));
    function i() {
      const r = t.isSingle.value && o.open.value && !t.collapsible;
      o.disabled.value || r || t.changeModelValue(o.value.value);
    }
    return (r, a) => (_(), ie(I(GO), {
      id: I(o).triggerId,
      ref: I(o).currentRef,
      "data-radix-vue-collection-item": "",
      as: n.as,
      "as-child": n.asChild,
      "aria-disabled": I(o).disabled.value || void 0,
      "aria-expanded": I(o).open.value || !1,
      "data-disabled": I(o).dataDisabled.value,
      "data-orientation": I(t).orientation,
      "data-state": I(o).dataState.value,
      disabled: I(o).disabled.value,
      onClick: i
    }, {
      default: J(() => [
        be(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "as", "as-child", "aria-disabled", "aria-expanded", "data-disabled", "data-orientation", "data-state", "disabled"]));
  }
}), [io, sE] = Ot("DialogRoot"), uE = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "DialogRoot",
  props: {
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean, default: !1 },
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(e, { emit: n }) {
    const t = e, o = tn(t, "open", n, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), i = X(), r = X(), { modal: a } = on(t);
    return sE({
      open: o,
      modal: a,
      openModal: () => {
        o.value = !0;
      },
      onOpenChange: (l) => {
        o.value = l;
      },
      onOpenToggle: () => {
        o.value = !o.value;
      },
      contentId: "",
      titleId: "",
      descriptionId: "",
      triggerElement: i,
      contentElement: r
    }), (l, s) => be(l.$slots, "default", { open: I(o) });
  }
}), dE = /* @__PURE__ */ re({
  __name: "DialogTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e, t = io(), { forwardRef: o, currentElement: i } = Me();
    return t.contentId || (t.contentId = nn(void 0, "radix-vue-dialog-content")), Ge(() => {
      t.triggerElement.value = i.value;
    }), (r, a) => (_(), ie(I(Ve), ze(n, {
      ref: I(o),
      type: r.as === "button" ? "button" : void 0,
      "aria-haspopup": "dialog",
      "aria-expanded": I(t).open.value || !1,
      "aria-controls": I(t).open.value ? I(t).contentId : void 0,
      "data-state": I(t).open.value ? "open" : "closed",
      onClick: I(t).onOpenToggle
    }), {
      default: J(() => [
        be(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "onClick"]));
  }
}), iu = /* @__PURE__ */ re({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const n = xh();
    return (t, o) => I(n) || t.forceMount ? (_(), ie(p0, {
      key: 0,
      to: t.to,
      disabled: t.disabled
    }, [
      be(t.$slots, "default")
    ], 8, ["to", "disabled"])) : z("", !0);
  }
}), cE = /* @__PURE__ */ re({
  __name: "DialogPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const n = e;
    return (t, o) => (_(), ie(I(iu), Ui(fa(n)), {
      default: J(() => [
        be(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), fE = "dismissableLayer.pointerDownOutside", hE = "dismissableLayer.focusOutside";
function Th(e, n) {
  const t = n.closest(
    "[data-dismissable-layer]"
  ), o = e.dataset.dismissableLayer === "" ? e : e.querySelector(
    "[data-dismissable-layer]"
  ), i = Array.from(
    e.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(t && o === t || i.indexOf(o) < i.indexOf(t));
}
function gE(e, n) {
  var t;
  const o = ((t = n == null ? void 0 : n.value) == null ? void 0 : t.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), i = X(!1), r = X(() => {
  });
  return ct((a) => {
    if (!Nn)
      return;
    const l = async (u) => {
      const d = u.target;
      if (n != null && n.value) {
        if (Th(n.value, d)) {
          i.value = !1;
          return;
        }
        if (u.target && !i.value) {
          let f = function() {
            Xs(
              fE,
              e,
              c
            );
          };
          const c = { originalEvent: u };
          u.pointerType === "touch" ? (o.removeEventListener("click", r.value), r.value = f, o.addEventListener("click", r.value, {
            once: !0
          })) : f();
        } else
          o.removeEventListener("click", r.value);
        i.value = !1;
      }
    }, s = window.setTimeout(() => {
      o.addEventListener("pointerdown", l);
    }, 0);
    a(() => {
      window.clearTimeout(s), o.removeEventListener("pointerdown", l), o.removeEventListener("click", r.value);
    });
  }), {
    onPointerDownCapture: () => i.value = !0
  };
}
function mE(e, n) {
  var t;
  const o = ((t = n == null ? void 0 : n.value) == null ? void 0 : t.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), i = X(!1);
  return ct((r) => {
    if (!Nn)
      return;
    const a = async (l) => {
      n != null && n.value && (await He(), !(!n.value || Th(n.value, l.target)) && l.target && !i.value && Xs(
        hE,
        e,
        { originalEvent: l }
      ));
    };
    o.addEventListener("focusin", a), r(() => o.removeEventListener("focusin", a));
  }), {
    onFocusCapture: () => i.value = !0,
    onBlurCapture: () => i.value = !1
  };
}
const _n = ki({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ta = /* @__PURE__ */ re({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(e, { emit: n }) {
    const t = e, o = n, { forwardRef: i, currentElement: r } = Me(), a = ee(
      () => {
        var m;
        return ((m = r.value) == null ? void 0 : m.ownerDocument) ?? globalThis.document;
      }
    ), l = ee(() => _n.layersRoot), s = ee(() => r.value ? Array.from(l.value).indexOf(r.value) : -1), u = ee(() => _n.layersWithOutsidePointerEventsDisabled.size > 0), d = ee(() => {
      const m = Array.from(l.value), [g] = [..._n.layersWithOutsidePointerEventsDisabled].slice(-1), v = m.indexOf(g);
      return s.value >= v;
    }), f = gE(async (m) => {
      const g = [..._n.branches].some(
        (v) => v == null ? void 0 : v.contains(m.target)
      );
      !d.value || g || (o("pointerDownOutside", m), o("interactOutside", m), await He(), m.defaultPrevented || o("dismiss"));
    }, r), c = mE((m) => {
      [..._n.branches].some(
        (g) => g == null ? void 0 : g.contains(m.target)
      ) || (o("focusOutside", m), o("interactOutside", m), m.defaultPrevented || o("dismiss"));
    }, r);
    CO("Escape", (m) => {
      s.value === l.value.size - 1 && (o("escapeKeyDown", m), m.defaultPrevented || o("dismiss"));
    });
    let h;
    return ct((m) => {
      r.value && (t.disableOutsidePointerEvents && (_n.layersWithOutsidePointerEventsDisabled.size === 0 && (h = a.value.body.style.pointerEvents, a.value.body.style.pointerEvents = "none"), _n.layersWithOutsidePointerEventsDisabled.add(r.value)), l.value.add(r.value), m(() => {
        t.disableOutsidePointerEvents && _n.layersWithOutsidePointerEventsDisabled.size === 1 && (a.value.body.style.pointerEvents = h);
      }));
    }), ct((m) => {
      m(() => {
        r.value && (l.value.delete(r.value), _n.layersWithOutsidePointerEventsDisabled.delete(r.value));
      });
    }), (m, g) => (_(), ie(I(Ve), {
      ref: I(i),
      "as-child": m.asChild,
      as: m.as,
      "data-dismissable-layer": "",
      style: Ye({
        pointerEvents: u.value ? d.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: I(c).onFocusCapture,
      onBlurCapture: I(c).onBlurCapture,
      onPointerdownCapture: I(f).onPointerDownCapture
    }, {
      default: J(() => [
        be(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), gl = "focusScope.autoFocusOnMount", ml = "focusScope.autoFocusOnUnmount", Gc = { bubbles: !1, cancelable: !0 };
function pE(e, { select: n = !1 } = {}) {
  const t = Kn();
  for (const o of e)
    if (jn(o, { select: n }), Kn() !== t)
      return !0;
}
function vE(e) {
  const n = Ph(e), t = Zc(n, e), o = Zc(n.reverse(), e);
  return [t, o];
}
function Ph(e) {
  const n = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const i = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || i ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); )
    n.push(t.currentNode);
  return n;
}
function Zc(e, n) {
  for (const t of e)
    if (!bE(t, { upTo: n }))
      return t;
}
function bE(e, { upTo: n }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (n !== void 0 && e === n)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function yE(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function jn(e, { select: n = !1 } = {}) {
  if (e && e.focus) {
    const t = Kn();
    e.focus({ preventScroll: !0 }), e !== t && yE(e) && n && e.select();
  }
}
const CE = sO(() => X([]));
function xE() {
  const e = CE();
  return {
    add(n) {
      const t = e.value[0];
      n !== t && (t == null || t.pause()), e.value = Xc(e.value, n), e.value.unshift(n);
    },
    remove(n) {
      var t;
      e.value = Xc(e.value, n), (t = e.value[0]) == null || t.resume();
    }
  };
}
function Xc(e, n) {
  const t = [...e], o = t.indexOf(n);
  return o !== -1 && t.splice(o, 1), t;
}
function wE(e) {
  return e.filter((n) => n.tagName !== "A");
}
const Ih = /* @__PURE__ */ re({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, { currentRef: i, currentElement: r } = Me(), a = X(null), l = xE(), s = ki({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    ct((d) => {
      if (!Nn)
        return;
      const f = r.value;
      if (!t.trapped)
        return;
      function c(v) {
        if (s.paused || !f)
          return;
        const p = v.target;
        f.contains(p) ? a.value = p : jn(a.value, { select: !0 });
      }
      function h(v) {
        if (s.paused || !f)
          return;
        const p = v.relatedTarget;
        p !== null && (f.contains(p) || jn(a.value, { select: !0 }));
      }
      function m(v) {
        f.contains(a.value) || jn(f);
      }
      document.addEventListener("focusin", c), document.addEventListener("focusout", h);
      const g = new MutationObserver(m);
      f && g.observe(f, { childList: !0, subtree: !0 }), d(() => {
        document.removeEventListener("focusin", c), document.removeEventListener("focusout", h), g.disconnect();
      });
    }), ct(async (d) => {
      const f = r.value;
      if (await He(), !f)
        return;
      l.add(s);
      const c = Kn();
      if (!f.contains(c)) {
        const h = new CustomEvent(gl, Gc);
        f.addEventListener(gl, (m) => o("mountAutoFocus", m)), f.dispatchEvent(h), h.defaultPrevented || (pE(wE(Ph(f)), {
          select: !0
        }), Kn() === c && jn(f));
      }
      d(() => {
        f.removeEventListener(gl, (g) => o("mountAutoFocus", g));
        const h = new CustomEvent(ml, Gc), m = (g) => {
          o("unmountAutoFocus", g);
        };
        f.addEventListener(ml, m), f.dispatchEvent(h), setTimeout(() => {
          h.defaultPrevented || jn(c ?? document.body, { select: !0 }), f.removeEventListener(ml, m), l.remove(s);
        }, 0);
      });
    });
    function u(d) {
      if (!t.loop && !t.trapped || s.paused)
        return;
      const f = d.key === "Tab" && !d.altKey && !d.ctrlKey && !d.metaKey, c = Kn();
      if (f && c) {
        const h = d.currentTarget, [m, g] = vE(h);
        m && g ? !d.shiftKey && c === g ? (d.preventDefault(), t.loop && jn(m, { select: !0 })) : d.shiftKey && c === m && (d.preventDefault(), t.loop && jn(g, { select: !0 })) : c === h && d.preventDefault();
      }
    }
    return (d, f) => (_(), ie(I(Ve), {
      ref_key: "currentRef",
      ref: i,
      tabindex: "-1",
      "as-child": d.asChild,
      as: d.as,
      onKeydown: u
    }, {
      default: J(() => [
        be(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
});
function $E(e) {
  return e ? "open" : "closed";
}
const kE = "DialogTitle", _E = "DialogContent";
function OE({
  titleName: e = kE,
  contentName: n = _E,
  componentLink: t = "dialog.html#title",
  titleId: o,
  descriptionId: i,
  contentElement: r
}) {
  const a = `Warning: \`${n}\` requires a \`${e}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://www.radix-vue.com/components/${t}`, l = `Warning: Missing \`Description\` or \`aria-describedby="undefined"\` for ${n}.`;
  Ge(() => {
    var s;
    document.getElementById(o) || console.warn(a);
    const u = (s = r.value) == null ? void 0 : s.getAttribute("aria-describedby");
    i && u && (document.getElementById(i) || console.warn(l));
  });
}
const Dh = /* @__PURE__ */ re({
  __name: "DialogContentImpl",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = io(), { forwardRef: r, currentElement: a } = Me();
    return i.titleId || (i.titleId = nn(void 0, "radix-vue-dialog-title")), i.descriptionId || (i.descriptionId = nn(void 0, "radix-vue-dialog-description")), Ge(() => {
      i.contentElement = a, Kn() !== document.body && (i.triggerElement.value = Kn());
    }), process.env.NODE_ENV !== "production" && OE({
      titleName: "DialogTitle",
      contentName: "DialogContent",
      componentLink: "dialog.html#title",
      titleId: i.titleId,
      descriptionId: i.descriptionId,
      contentElement: a
    }), (l, s) => (_(), ie(I(Ih), {
      "as-child": "",
      loop: "",
      trapped: t.trapFocus,
      onMountAutoFocus: s[5] || (s[5] = (u) => o("openAutoFocus", u)),
      onUnmountAutoFocus: s[6] || (s[6] = (u) => o("closeAutoFocus", u))
    }, {
      default: J(() => [
        ce(I(Ta), ze({
          id: I(i).contentId,
          ref: I(r),
          as: l.as,
          "as-child": l.asChild,
          "disable-outside-pointer-events": l.disableOutsidePointerEvents,
          role: "dialog",
          "aria-describedby": I(i).descriptionId,
          "aria-labelledby": I(i).titleId,
          "data-state": I($E)(I(i).open.value)
        }, l.$attrs, {
          onDismiss: s[0] || (s[0] = (u) => I(i).onOpenChange(!1)),
          onEscapeKeyDown: s[1] || (s[1] = (u) => o("escapeKeyDown", u)),
          onFocusOutside: s[2] || (s[2] = (u) => o("focusOutside", u)),
          onInteractOutside: s[3] || (s[3] = (u) => o("interactOutside", u)),
          onPointerDownOutside: s[4] || (s[4] = (u) => o("pointerDownOutside", u))
        }), {
          default: J(() => [
            be(l.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "as", "as-child", "disable-outside-pointer-events", "aria-describedby", "aria-labelledby", "data-state"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), EE = /* @__PURE__ */ re({
  __name: "DialogContentModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = io(), r = Ma(o), { forwardRef: a, currentElement: l } = Me();
    return tu(l), (s, u) => (_(), ie(Dh, ze({ ...t, ...I(r) }, {
      ref: I(a),
      "trap-focus": I(i).open.value,
      "disable-outside-pointer-events": !0,
      onCloseAutoFocus: u[0] || (u[0] = (d) => {
        var f;
        d.defaultPrevented || (d.preventDefault(), (f = I(i).triggerElement.value) == null || f.focus());
      }),
      onPointerDownOutside: u[1] || (u[1] = (d) => {
        const f = d.detail.originalEvent, c = f.button === 0 && f.ctrlKey === !0;
        (f.button === 2 || c) && d.preventDefault();
      }),
      onFocusOutside: u[2] || (u[2] = (d) => {
        d.preventDefault();
      })
    }), {
      default: J(() => [
        be(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), ME = /* @__PURE__ */ re({
  __name: "DialogContentNonModal",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = Ma(n);
    Me();
    const i = io(), r = X(!1), a = X(!1);
    return (l, s) => (_(), ie(Dh, ze({ ...t, ...I(o) }, {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: s[0] || (s[0] = (u) => {
        var d;
        u.defaultPrevented || (r.value || (d = I(i).triggerElement.value) == null || d.focus(), u.preventDefault()), r.value = !1, a.value = !1;
      }),
      onInteractOutside: s[1] || (s[1] = (u) => {
        var d;
        u.defaultPrevented || (r.value = !0, u.detail.originalEvent.type === "pointerdown" && (a.value = !0));
        const f = u.target;
        (d = I(i).triggerElement.value) != null && d.contains(f) && u.preventDefault(), u.detail.originalEvent.type === "focusin" && a.value && u.preventDefault();
      })
    }), {
      default: J(() => [
        be(l.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), SE = /* @__PURE__ */ re({
  __name: "DialogContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = io(), r = Ma(o), { forwardRef: a } = Me();
    return (l, s) => (_(), ie(I(ni), {
      present: l.forceMount || I(i).open.value
    }, {
      default: J(() => [
        I(i).modal.value ? (_(), ie(EE, ze({
          key: 0,
          ref: I(a)
        }, { ...t, ...I(r), ...l.$attrs }), {
          default: J(() => [
            be(l.$slots, "default")
          ]),
          _: 3
        }, 16)) : (_(), ie(ME, ze({
          key: 1,
          ref: I(a)
        }, { ...t, ...I(r), ...l.$attrs }), {
          default: J(() => [
            be(l.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), AE = /* @__PURE__ */ re({
  __name: "DialogOverlayImpl",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = io();
    return Qs(!0), Me(), (t, o) => (_(), ie(I(Ve), {
      as: t.as,
      "as-child": t.asChild,
      "data-state": I(n).open.value ? "open" : "closed",
      style: { "pointer-events": "auto" }
    }, {
      default: J(() => [
        be(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "data-state"]));
  }
}), TE = /* @__PURE__ */ re({
  __name: "DialogOverlay",
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = io(), { forwardRef: t } = Me();
    return (o, i) => {
      var r;
      return (r = I(n)) != null && r.modal.value ? (_(), ie(I(ni), {
        key: 0,
        present: o.forceMount || I(n).open.value
      }, {
        default: J(() => [
          ce(AE, ze(o.$attrs, {
            ref: I(t),
            as: o.as,
            "as-child": o.asChild
          }), {
            default: J(() => [
              be(o.$slots, "default")
            ]),
            _: 3
          }, 16, ["as", "as-child"])
        ]),
        _: 3
      }, 8, ["present"])) : z("", !0);
    };
  }
}), PE = /* @__PURE__ */ re({
  __name: "DialogClose",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e;
    Me();
    const t = io();
    return (o, i) => (_(), ie(I(Ve), ze(n, {
      type: o.as === "button" ? "button" : void 0,
      onClick: i[0] || (i[0] = (r) => I(t).onOpenChange(!1))
    }), {
      default: J(() => [
        be(o.$slots, "default")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), [Lh, IE] = Ot("PopperRoot"), ru = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "PopperRoot",
  setup(e) {
    const n = X();
    return IE({
      anchor: n,
      onAnchorChange: (t) => n.value = t
    }), (t, o) => be(t.$slots, "default");
  }
}), au = /* @__PURE__ */ re({
  __name: "PopperAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e, { forwardRef: t, currentElement: o } = Me(), i = Lh();
    return ct(() => {
      i.onAnchorChange(n.element ?? o.value);
    }), (r, a) => (_(), ie(I(Ve), {
      ref: I(t),
      as: r.as,
      "as-child": r.asChild
    }, {
      default: J(() => [
        be(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function DE(e) {
  return e !== null;
}
function LE(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn(n) {
      var t, o, i;
      const { placement: r, rects: a, middlewareData: l } = n, s = ((t = l.arrow) == null ? void 0 : t.centerOffset) !== 0, u = s ? 0 : e.arrowWidth, d = s ? 0 : e.arrowHeight, [f, c] = ts(r), h = { start: "0%", center: "50%", end: "100%" }[c], m = (((o = l.arrow) == null ? void 0 : o.x) ?? 0) + u / 2, g = (((i = l.arrow) == null ? void 0 : i.y) ?? 0) + d / 2;
      let v = "", p = "";
      return f === "bottom" ? (v = s ? h : `${m}px`, p = `${-d}px`) : f === "top" ? (v = s ? h : `${m}px`, p = `${a.floating.height + d}px`) : f === "right" ? (v = `${-d}px`, p = s ? h : `${g}px`) : f === "left" && (v = `${a.floating.width + d}px`, p = s ? h : `${g}px`), { data: { x: v, y: p } };
    }
  };
}
function ts(e) {
  const [n, t = "center"] = e.split("-");
  return [n, t];
}
const NE = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [WA, FE] = Ot("PopperContent"), sa = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: /* @__PURE__ */ y0({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...NE
  }),
  emits: ["placed"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = Lh(), { forwardRef: r, currentElement: a } = Me(), l = X(), s = X(), { width: u, height: d } = UO(s), f = ee(
      () => t.side + (t.align !== "center" ? `-${t.align}` : "")
    ), c = ee(() => typeof t.collisionPadding == "number" ? t.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...t.collisionPadding }), h = ee(() => Array.isArray(t.collisionBoundary) ? t.collisionBoundary : [t.collisionBoundary]), m = ee(() => ({
      padding: c.value,
      boundary: h.value.filter(DE),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: h.value.length > 0
    })), g = aO(() => [
      Y_({
        mainAxis: t.sideOffset + d.value,
        alignmentAxis: t.alignOffset
      }),
      t.prioritizePosition && t.avoidCollisions && Uc({
        ...m.value
      }),
      t.avoidCollisions && G_({
        mainAxis: !0,
        crossAxis: !!t.prioritizePosition,
        limiter: t.sticky === "partial" ? Q_() : void 0,
        ...m.value
      }),
      !t.prioritizePosition && t.avoidCollisions && Uc({
        ...m.value
      }),
      Z_({
        ...m.value,
        apply: ({ elements: O, rects: k, availableWidth: S, availableHeight: T }) => {
          const { width: L, height: F } = k.reference, U = O.floating.style;
          U.setProperty(
            "--radix-popper-available-width",
            `${S}px`
          ), U.setProperty(
            "--radix-popper-available-height",
            `${T}px`
          ), U.setProperty(
            "--radix-popper-anchor-width",
            `${L}px`
          ), U.setProperty(
            "--radix-popper-anchor-height",
            `${F}px`
          );
        }
      }),
      s.value && nO({ element: s.value, padding: t.arrowPadding }),
      LE({
        arrowWidth: u.value,
        arrowHeight: d.value
      }),
      t.hideWhenDetached && X_({ strategy: "referenceHidden", ...m.value })
    ]), { floatingStyles: v, placement: p, isPositioned: y, middlewareData: C } = oO(
      i.anchor,
      l,
      {
        strategy: "fixed",
        placement: f,
        whileElementsMounted: (...O) => K_(...O, {
          animationFrame: t.updatePositionStrategy === "always"
        }),
        middleware: g
      }
    ), b = ee(
      () => ts(p.value)[0]
    ), x = ee(
      () => ts(p.value)[1]
    );
    C0(() => {
      y.value && o("placed");
    });
    const w = ee(
      () => {
        var O;
        return ((O = C.value.arrow) == null ? void 0 : O.centerOffset) !== 0;
      }
    ), $ = X("");
    ct(() => {
      a.value && ($.value = window.getComputedStyle(a.value).zIndex);
    });
    const E = ee(() => {
      var O;
      return ((O = C.value.arrow) == null ? void 0 : O.x) ?? 0;
    }), A = ee(() => {
      var O;
      return ((O = C.value.arrow) == null ? void 0 : O.y) ?? 0;
    });
    return FE({
      placedSide: b,
      onArrowChange: (O) => s.value = O,
      arrowX: E,
      arrowY: A,
      shouldHideArrow: w
    }), (O, k) => {
      var S, T, L;
      return _(), P("div", {
        ref_key: "floatingRef",
        ref: l,
        "data-radix-popper-content-wrapper": "",
        style: Ye({
          ...I(v),
          transform: I(y) ? I(v).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: $.value,
          "--radix-popper-transform-origin": [
            (S = I(C).transformOrigin) == null ? void 0 : S.x,
            (T = I(C).transformOrigin) == null ? void 0 : T.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((L = I(C).hide) == null ? void 0 : L.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        })
      }, [
        ce(I(Ve), ze({ ref: I(r) }, O.$attrs, {
          "as-child": t.asChild,
          as: O.as,
          "data-side": b.value,
          "data-align": x.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: I(y) ? void 0 : "none"
          }
        }), {
          default: J(() => [
            be(O.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), Nh = /* @__PURE__ */ re({
  __name: "VisuallyHidden",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(e) {
    return Me(), (n, t) => (_(), ie(I(Ve), {
      as: n.as,
      "as-child": n.asChild,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: "1px",
        display: "inline-block",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }
    }, {
      default: J(() => [
        be(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), Fh = /* @__PURE__ */ re({
  __name: "VisuallyHiddenInput",
  props: {
    name: {},
    value: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(e) {
    const n = e, t = ee(() => typeof n.value == "string" || typeof n.value == "number" || typeof n.value == "boolean" ? [{ name: n.name, value: n.value }] : typeof n.value == "object" && Array.isArray(n.value) ? n.value.flatMap((o, i) => typeof o == "object" ? Object.entries(o).map(([r, a]) => ({ name: `[${i}][${n.name}][${r}]`, value: a })) : { name: `[${n.name}][${i}]`, value: o }) : n.value !== null && typeof n.value == "object" && !Array.isArray(n.value) ? Object.entries(n.value).map(([o, i]) => ({ name: `[${n.name}][${o}]`, value: i })) : []);
    return (o, i) => (_(!0), P(me, null, Fe(t.value, (r) => (_(), ie(Nh, {
      key: r.name,
      as: "input",
      type: "hidden",
      hidden: "",
      readonly: "",
      name: r.name,
      value: r.value,
      required: o.required,
      disabled: o.disabled
    }, null, 8, ["name", "value", "required", "disabled"]))), 128));
  }
}), RE = "data-radix-vue-collection-item", [lu, BE] = Ot("CollectionProvider");
function Rh(e = RE) {
  const n = X(/* @__PURE__ */ new Map()), t = X(), o = BE({
    collectionRef: t,
    itemMap: n,
    attrName: e
  }), { getItems: i } = VE(o), r = ee(() => Array.from(o.itemMap.value.values())), a = ee(() => o.itemMap.value.size);
  return { getItems: i, reactiveItems: r, itemMapSize: a };
}
const Bh = re({
  name: "CollectionSlot",
  setup(e, { slots: n }) {
    const t = lu(), { primitiveElement: o, currentElement: i } = Mh();
    return Ne(i, () => {
      t.collectionRef.value = i.value;
    }), () => wt(nu, { ref: o }, n);
  }
}), Vh = re({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(e, { slots: n, attrs: t }) {
    const o = lu(), { primitiveElement: i, currentElement: r } = Mh();
    return ct((a) => {
      if (r.value) {
        const l = f0(r.value);
        o.itemMap.value.set(l, { ref: r.value, value: e.value }), a(() => o.itemMap.value.delete(l));
      }
    }), () => wt(nu, { ...t, [o.attrName]: "", ref: i }, n);
  }
});
function VE(e) {
  const n = e ?? lu();
  return { getItems: () => {
    const t = n.collectionRef.value;
    if (!t)
      return [];
    const o = Array.from(t.querySelectorAll(`[${n.attrName}]`));
    return Array.from(n.itemMap.value.values()).sort(
      (i, r) => o.indexOf(i.ref) - o.indexOf(r.ref)
    );
  } };
}
const [Mo, jE] = Ot("ComboboxRoot"), HE = /* @__PURE__ */ re({
  __name: "ComboboxRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    resetSearchTermOnBlur: { type: Boolean, default: !0 },
    resetSearchTermOnSelect: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, { multiple: i, disabled: r, dir: a } = on(t), l = eu(a), s = tn(t, "searchTerm", o, {
      // @ts-expect-error ignore the type error here
      defaultValue: "",
      passive: t.searchTerm === void 0
    }), u = tn(t, "modelValue", o, {
      // @ts-expect-error ignore the type error here
      defaultValue: t.defaultValue ?? i.value ? [] : void 0,
      passive: t.modelValue === void 0,
      deep: !0
    }), d = tn(t, "open", o, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), f = tn(t, "selectedValue", o, {
      defaultValue: void 0,
      passive: t.selectedValue === void 0
    });
    async function c(H) {
      var B, D;
      d.value = H, await He(), H ? (u.value && (Array.isArray(u.value) && i.value ? f.value = (B = C().find((V) => {
        var q, Z;
        return ((Z = (q = V.ref) == null ? void 0 : q.dataset) == null ? void 0 : Z.state) === "checked";
      })) == null ? void 0 : B.value : f.value = u.value), await He(), (D = g.value) == null || D.focus(), T()) : (m.value = !1, t.resetSearchTermOnBlur && E("blur"));
    }
    function h(H) {
      if (Array.isArray(u.value) && i.value) {
        const B = u.value.findIndex((V) => ho(V, H)), D = [...u.value];
        B === -1 ? D.push(H) : D.splice(B, 1), u.value = D;
      } else
        u.value = H, c(!1);
    }
    const m = X(!1), g = X(), v = X(), { forwardRef: p, currentElement: y } = Me(), { getItems: C, reactiveItems: b, itemMapSize: x } = Rh("data-radix-vue-combobox-item"), w = X([]);
    Ne(() => x.value, () => {
      w.value = C().map((H) => H.value);
    }, {
      immediate: !0,
      flush: "post"
    });
    const $ = ee(() => {
      if (m.value) {
        if (t.filterFunction)
          return t.filterFunction(w.value, s.value);
        const H = w.value.filter((B) => typeof B == "string");
        if (H.length)
          return H.filter((B) => {
            var D;
            return B.toLowerCase().includes((D = s.value) == null ? void 0 : D.toLowerCase());
          });
      }
      return w.value;
    });
    function E(H) {
      const B = H === "blur" || H === "select" && t.resetSearchTermOnSelect;
      !i.value && u.value && !Array.isArray(u.value) ? t.displayValue ? s.value = t.displayValue(u.value) : typeof u.value != "object" ? s.value = u.value.toString() : B && (s.value = "") : B && (s.value = "");
    }
    const A = ee(() => $.value.findIndex((H) => ho(H, f.value))), O = ee(() => {
      var H;
      return (H = b.value.find((B) => ho(B.value, f.value))) == null ? void 0 : H.ref;
    }), k = ee(() => JSON.stringify(u.value));
    Ne(k, async () => {
      await He(), await He(), E("select");
    }, {
      // If searchTerm is provided with value during initialization, we don't reset it immediately
      immediate: !t.searchTerm
    }), Ne(() => [$.value.length, s.value.length], async ([H, B], [D, V]) => {
      await He(), await He(), H && (V > B || A.value === -1) && (f.value = $.value[0]);
    });
    const S = Oh(y);
    function T() {
      var H;
      O.value instanceof Element && ((H = O.value) == null || H.scrollIntoView({ block: "nearest" }));
    }
    function L() {
      O.value instanceof Element && O.value.focus && O.value.focus();
    }
    const F = X(!1);
    function U() {
      F.value = !0;
    }
    function W() {
      requestAnimationFrame(() => {
        F.value = !1;
      });
    }
    async function oe(H) {
      var B;
      $.value.length && f.value && O.value instanceof Element && (H.preventDefault(), H.stopPropagation(), F.value || (B = O.value) == null || B.click());
    }
    return jE({
      searchTerm: s,
      modelValue: u,
      // @ts-expect-error ignoring
      onValueChange: h,
      isUserInputted: m,
      multiple: i,
      disabled: r,
      open: d,
      onOpenChange: c,
      filteredOptions: $,
      contentId: "",
      inputElement: g,
      selectedElement: O,
      onInputElementChange: (H) => g.value = H,
      onInputNavigation: async (H) => {
        const B = A.value;
        B === 0 && H === "up" || B === $.value.length - 1 && H === "down" || (B === -1 && $.value.length || H === "home" ? f.value = $.value[0] : H === "end" ? f.value = $.value[$.value.length - 1] : f.value = $.value[H === "up" ? B - 1 : B + 1], await He(), T(), L(), He(() => {
          var D;
          return (D = g.value) == null ? void 0 : D.focus({ preventScroll: !0 });
        }));
      },
      onInputEnter: oe,
      onCompositionEnd: W,
      onCompositionStart: U,
      selectedValue: f,
      onSelectedValueChange: (H) => f.value = H,
      parentElement: y,
      contentElement: v,
      onContentElementChange: (H) => v.value = H
    }), (H, B) => (_(), ie(I(ru), null, {
      default: J(() => [
        ce(I(Ve), ze({
          ref: I(p),
          style: {
            pointerEvents: I(d) ? "auto" : void 0
          },
          as: H.as,
          "as-child": H.asChild,
          dir: I(l)
        }, H.$attrs), {
          default: J(() => [
            be(H.$slots, "default", {
              open: I(d),
              modelValue: I(u)
            }),
            I(S) && t.name ? (_(), ie(I(Fh), {
              key: 0,
              name: t.name,
              value: I(u)
            }, null, 8, ["name", "value"])) : z("", !0)
          ]),
          _: 3
        }, 16, ["style", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), zE = /* @__PURE__ */ re({
  __name: "ComboboxInput",
  props: {
    type: { default: "text" },
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(e) {
    const n = e, t = Mo(), { forwardRef: o, currentElement: i } = Me();
    Ge(() => {
      const d = i.value.nodeName === "INPUT" ? i.value : i.value.querySelector("input");
      d && (t.onInputElementChange(d), setTimeout(() => {
        n.autoFocus && (d == null || d.focus());
      }, 1));
    });
    const r = ee(() => n.disabled || t.disabled.value || !1), a = X();
    h0(() => {
      var d;
      return a.value = (d = t.selectedElement.value) == null ? void 0 : d.id;
    });
    function l(d) {
      t.open.value ? t.onInputNavigation(d.key === "ArrowUp" ? "up" : "down") : t.onOpenChange(!0);
    }
    function s(d) {
      t.open.value && t.onInputNavigation(d.key === "Home" ? "home" : "end");
    }
    function u(d) {
      var f;
      t.searchTerm.value = (f = d.target) == null ? void 0 : f.value, t.open.value || t.onOpenChange(!0), t.isUserInputted.value = !0;
    }
    return (d, f) => (_(), ie(I(Ve), {
      ref: I(o),
      as: d.as,
      "as-child": d.asChild,
      type: d.type,
      disabled: r.value,
      value: I(t).searchTerm.value,
      "aria-expanded": I(t).open.value,
      "aria-controls": I(t).contentId,
      "aria-disabled": r.value ?? void 0,
      "aria-activedescendant": a.value,
      "aria-autocomplete": "list",
      role: "combobox",
      autocomplete: "false",
      onInput: u,
      onKeydown: [
        pn(Yn(l, ["prevent"]), ["down", "up"]),
        pn(I(t).onInputEnter, ["enter"]),
        pn(Yn(s, ["prevent"]), ["home", "end"])
      ],
      onCompositionstart: I(t).onCompositionStart,
      onCompositionend: I(t).onCompositionEnd
    }, {
      default: J(() => [
        be(d.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "disabled", "value", "aria-expanded", "aria-controls", "aria-disabled", "aria-activedescendant", "onKeydown", "onCompositionstart", "onCompositionend"]));
  }
}), qE = /* @__PURE__ */ re({
  __name: "ComboboxAnchor",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const { forwardRef: n } = Me();
    return (t, o) => (_(), ie(I(au), { "as-child": "" }, {
      default: J(() => [
        ce(I(Ve), ze({
          ref: I(n),
          "as-child": t.asChild,
          as: t.as
        }, t.$attrs), {
          default: J(() => [
            be(t.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as"])
      ]),
      _: 3
    }));
  }
}), UE = /* @__PURE__ */ re({
  __name: "ComboboxTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e;
    Me();
    const t = Mo(), o = ee(() => n.disabled || t.disabled.value || !1);
    return (i, r) => (_(), ie(I(Ve), ze(n, {
      type: i.as === "button" ? "button" : void 0,
      tabindex: "-1",
      "aria-label": "Show popup",
      "aria-haspopup": "listbox",
      "aria-expanded": I(t).open.value,
      "aria-controls": I(t).contentId,
      "data-state": I(t).open.value ? "open" : "closed",
      disabled: o.value,
      "data-disabled": o.value ? "" : void 0,
      "aria-disabled": o.value ?? void 0,
      onClick: r[0] || (r[0] = (a) => I(t).onOpenChange(!I(t).open.value))
    }), {
      default: J(() => [
        be(i.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "aria-expanded", "aria-controls", "data-state", "disabled", "data-disabled", "aria-disabled"]));
  }
}), [WE, KE] = Ot("ComboboxGroup"), YE = /* @__PURE__ */ re({
  __name: "ComboboxGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e, { currentRef: t, currentElement: o } = Me(), i = nn(void 0, "radix-vue-combobox-group"), r = Mo(), a = X(!1);
    function l() {
      if (!o.value)
        return;
      const s = o.value.querySelectorAll("[data-radix-vue-combobox-item]:not([data-hidden])");
      a.value = !!s.length;
    }
    return wh(o, () => {
      He(() => {
        l();
      });
    }, { childList: !0 }), Ne(() => r.searchTerm.value, () => {
      He(() => {
        l();
      });
    }, { immediate: !0 }), KE({
      id: i
    }), (s, u) => po((_(), ie(I(Ve), ze(n, {
      ref_key: "currentRef",
      ref: t,
      role: "group",
      "aria-labelledby": I(i)
    }), {
      default: J(() => [
        be(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"])), [
      [i1, a.value]
    ]);
  }
}), [KA, GE] = Ot("ComboboxContent"), ZE = /* @__PURE__ */ re({
  __name: "ComboboxContentImpl",
  props: {
    position: { default: "inline" },
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean, default: !0 },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(e, { emit: n }) {
    const t = e, o = n, { position: i } = on(t), r = Mo();
    Qs(t.bodyLock);
    const { forwardRef: a, currentElement: l } = Me();
    tu(r.parentElement);
    const s = ee(() => t.position === "popper" ? t : {}), u = Sa(s.value);
    function d(c) {
      r.onSelectedValueChange("");
    }
    Ge(() => {
      r.onContentElementChange(l.value);
    });
    const f = {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-combobox-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-combobox-content-available-width": "var(--radix-popper-available-width)",
      "--radix-combobox-content-available-height": "var(--radix-popper-available-height)",
      "--radix-combobox-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-combobox-trigger-height": "var(--radix-popper-anchor-height)"
    };
    return GE({ position: i }), (c, h) => (_(), ie(I(Bh), null, {
      default: J(() => [
        c.dismissable ? (_(), ie(I(Ta), {
          key: 0,
          "as-child": "",
          "disable-outside-pointer-events": c.disableOutsidePointerEvents,
          onDismiss: h[0] || (h[0] = (m) => I(r).onOpenChange(!1)),
          onFocusOutside: h[1] || (h[1] = (m) => {
            var g;
            (g = I(r).parentElement.value) != null && g.contains(m.target) && m.preventDefault(), o("focusOutside", m);
          }),
          onInteractOutside: h[2] || (h[2] = (m) => o("interactOutside", m)),
          onEscapeKeyDown: h[3] || (h[3] = (m) => o("escapeKeyDown", m)),
          onPointerDownOutside: h[4] || (h[4] = (m) => {
            var g;
            (g = I(r).parentElement.value) != null && g.contains(m.target) && m.preventDefault(), o("pointerDownOutside", m);
          })
        }, {
          default: J(() => [
            (_(), ie(Uo(I(i) === "popper" ? I(sa) : I(Ve)), ze({ ...c.$attrs, ...I(u) }, {
              id: I(r).contentId,
              ref: I(a),
              role: "listbox",
              "data-state": I(r).open.value ? "open" : "closed",
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...I(i) === "popper" ? f : {}
              },
              onPointerleave: d
            }), {
              default: J(() => [
                be(c.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"]))
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])) : (_(), ie(Uo(I(i) === "popper" ? I(sa) : I(Ve)), ze({ key: 1 }, { ...c.$attrs, ...s.value }, {
          id: I(r).contentId,
          ref: I(a),
          role: "listbox",
          "data-state": I(r).open.value ? "open" : "closed",
          style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...I(i) === "popper" ? f : {}
          },
          onPointerleave: d
        }), {
          default: J(() => [
            be(c.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "data-state", "style"]))
      ]),
      _: 3
    }));
  }
}), XE = /* @__PURE__ */ re({
  __name: "ComboboxContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(e, { emit: n }) {
    const t = Qi(e, n), { forwardRef: o } = Me(), i = Mo();
    return i.contentId || (i.contentId = nn(void 0, "radix-vue-combobox-content")), (r, a) => (_(), ie(I(ni), {
      present: r.forceMount || I(i).open.value
    }, {
      default: J(() => [
        ce(ZE, ze({ ...I(t), ...r.$attrs }, { ref: I(o) }), {
          default: J(() => [
            be(r.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), JE = /* @__PURE__ */ re({
  __name: "ComboboxEmpty",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e;
    Me();
    const t = Mo(), o = ee(() => t.filteredOptions.value.length === 0);
    return (i, r) => o.value ? (_(), ie(I(Ve), Ui(ze({ key: 0 }, n)), {
      default: J(() => [
        be(i.$slots, "default", {}, () => [
          Ie("No options")
        ])
      ]),
      _: 3
    }, 16)) : z("", !0);
  }
});
function QE(e) {
  const n = Ea({
    nonce: X()
  });
  return ee(() => {
    var t;
    return (e == null ? void 0 : e.value) || ((t = n.nonce) == null ? void 0 : t.value);
  });
}
const eM = /* @__PURE__ */ re({
  __name: "ComboboxViewport",
  props: {
    nonce: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e, { forwardRef: t } = Me(), { nonce: o } = on(n), i = QE(o);
    return (r, a) => (_(), P(me, null, [
      ce(I(Ve), ze({ ...r.$attrs, ...n }, {
        ref: I(t),
        "data-radix-combobox-viewport": "",
        role: "presentation",
        style: {
          // we use position: 'relative' here on the `viewport` so that when we call
          // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
          // (independent of the scrollUpButton).
          position: "relative",
          flex: 1,
          overflow: "auto"
        }
      }), {
        default: J(() => [
          be(r.$slots, "default")
        ]),
        _: 3
      }, 16),
      ce(I(Ve), {
        as: "style",
        nonce: I(i)
      }, {
        default: J(() => [
          Ie(" /* Hide scrollbars cross-browser and enable momentum scroll for touch devices */ [data-radix-combobox-viewport] { scrollbar-width:none; -ms-overflow-style: none; -webkit-overflow-scrolling: touch; } [data-radix-combobox-viewport]::-webkit-scrollbar { display: none; } ")
        ]),
        _: 1
      }, 8, ["nonce"])
    ], 64));
  }
}), [YA, tM] = Ot("ComboboxItem"), nM = "combobox.select", Jc = /* @__PURE__ */ re({
  __name: "ComboboxItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(e, { emit: n }) {
    const t = e, o = n, { disabled: i } = on(t), r = Mo();
    WE({ id: "", options: X([]) });
    const { forwardRef: a } = Me(), l = ee(
      () => {
        var g, v;
        return r.multiple.value && Array.isArray(r.modelValue.value) ? (g = r.modelValue.value) == null ? void 0 : g.some((p) => ho(p, t.value)) : ho((v = r.modelValue) == null ? void 0 : v.value, t.value);
      }
    ), s = ee(() => ho(r.selectedValue.value, t.value)), u = nn(void 0, "radix-vue-combobox-item"), d = nn(void 0, "radix-vue-combobox-option"), f = ee(() => r.isUserInputted.value ? r.searchTerm.value === "" || !!r.filteredOptions.value.find((g) => ho(g, t.value)) : !0);
    async function c(g) {
      o("select", g), !(g != null && g.defaultPrevented) && !i.value && g && r.onValueChange(t.value);
    }
    function h(g) {
      if (!g)
        return;
      const v = { originalEvent: g, value: t.value };
      Xs(nM, c, v);
    }
    async function m(g) {
      await He(), !g.defaultPrevented && r.onSelectedValueChange(t.value);
    }
    if (t.value === "")
      throw new Error(
        "A <ComboboxItem /> must have a value prop that is not an empty string. This is because the Combobox value can be set to an empty string to clear the selection and show the placeholder."
      );
    return tM({
      isSelected: l
    }), (g, v) => (_(), ie(I(Vh), { value: g.value }, {
      default: J(() => [
        po(ce(I(Ve), {
          id: I(d),
          ref: I(a),
          role: "option",
          tabindex: "-1",
          "aria-labelledby": I(u),
          "data-highlighted": s.value ? "" : void 0,
          "aria-selected": l.value,
          "data-state": l.value ? "checked" : "unchecked",
          "aria-disabled": I(i) || void 0,
          "data-disabled": I(i) ? "" : void 0,
          as: g.as,
          "as-child": g.asChild,
          "data-hidden": f.value ? void 0 : !0,
          onClick: h,
          onPointermove: m
        }, {
          default: J(() => [
            be(g.$slots, "default", {}, () => [
              Ie(de(g.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["id", "aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "as", "as-child", "data-hidden"]), [
          [i1, f.value]
        ])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), [Pa, oM] = Ot("PaginationRoot"), iM = /* @__PURE__ */ re({
  __name: "PaginationRoot",
  props: {
    page: {},
    defaultPage: { default: 1 },
    itemsPerPage: { default: 10 },
    total: { default: 0 },
    siblingCount: { default: 2 },
    disabled: { type: Boolean },
    showEdges: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: { default: "nav" }
  },
  emits: ["update:page"],
  setup(e, { emit: n }) {
    const t = e, o = n, { siblingCount: i, disabled: r, showEdges: a } = on(t);
    Me();
    const l = tn(t, "page", o, {
      defaultValue: t.defaultPage,
      passive: t.page === void 0
    }), s = ee(() => Math.max(1, Math.ceil(t.total / t.itemsPerPage)));
    return oM({
      page: l,
      onPageChange(u) {
        l.value = u;
      },
      pageCount: s,
      siblingCount: i,
      disabled: r,
      showEdges: a
    }), (u, d) => (_(), ie(I(Ve), {
      as: u.as,
      "as-child": u.asChild
    }, {
      default: J(() => [
        be(u.$slots, "default", {
          page: I(l),
          pageCount: s.value
        })
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), rM = /* @__PURE__ */ re({
  __name: "PaginationEllipsis",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e;
    return Me(), (t, o) => (_(), ie(I(Ve), ze(n, { "data-type": "ellipsis" }), {
      default: J(() => [
        be(t.$slots, "default", {}, () => [
          Ie("…")
        ])
      ]),
      _: 3
    }, 16));
  }
});
function Bn(e, n) {
  const t = n - e + 1;
  return Array.from({ length: t }, (o, i) => i + e);
}
function aM(e) {
  return e.map((n) => typeof n == "number" ? { type: "page", value: n } : { type: "ellipsis" });
}
const Sr = "ellipsis";
function lM(e, n, t, o) {
  const i = n, r = Math.max(e - t, 1), a = Math.min(e + t, i);
  if (o) {
    const l = Math.min(2 * t + 5, n) - 2, s = r > 3 && Math.abs(i - l - 1 + 1) > 2 && Math.abs(r - 1) > 2, u = a < i - 2 && Math.abs(i - l) > 2 && Math.abs(i - a) > 2;
    if (!s && u)
      return [...Bn(1, l), Sr, i];
    if (s && !u) {
      const d = Bn(i - l + 1, i);
      return [1, Sr, ...d];
    }
    if (s && u) {
      const d = Bn(r, a);
      return [1, Sr, ...d, Sr, i];
    }
    return Bn(1, i);
  } else {
    const l = t * 2 + 1;
    return n < l ? Bn(1, i) : e <= t + 1 ? Bn(1, l) : n - e <= t ? Bn(n - l + 1, i) : Bn(r, a);
  }
}
const sM = /* @__PURE__ */ re({
  __name: "PaginationList",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e;
    Me();
    const t = Pa(), o = ee(() => aM(
      lM(
        t.page.value,
        t.pageCount.value,
        t.siblingCount.value,
        t.showEdges.value
      )
    ));
    return (i, r) => (_(), ie(I(Ve), Ui(fa(n)), {
      default: J(() => [
        be(i.$slots, "default", { items: o.value })
      ]),
      _: 3
    }, 16));
  }
}), uM = /* @__PURE__ */ re({
  __name: "PaginationListItem",
  props: {
    value: {},
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e;
    Me();
    const t = Pa(), o = ee(() => t.page.value === n.value), i = ee(() => t.disabled.value);
    return (r, a) => (_(), ie(I(Ve), ze(n, {
      "data-type": "page",
      "aria-label": `Page ${r.value}`,
      "aria-current": o.value ? "page" : void 0,
      "data-selected": o.value ? "true" : void 0,
      disabled: i.value,
      type: r.as === "button" ? "button" : void 0,
      onClick: a[0] || (a[0] = (l) => !i.value && I(t).onPageChange(r.value))
    }), {
      default: J(() => [
        be(r.$slots, "default", {}, () => [
          Ie(de(r.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["aria-label", "aria-current", "data-selected", "disabled", "type"]));
  }
}), dM = /* @__PURE__ */ re({
  __name: "PaginationNext",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e;
    Me();
    const t = Pa(), o = ee(() => t.page.value === t.pageCount.value || t.disabled.value);
    return (i, r) => (_(), ie(I(Ve), ze(n, {
      "aria-label": "Next Page",
      type: i.as === "button" ? "button" : void 0,
      disabled: o.value,
      onClick: r[0] || (r[0] = (a) => !o.value && I(t).onPageChange(I(t).page.value + 1))
    }), {
      default: J(() => [
        be(i.$slots, "default", {}, () => [
          Ie("Next page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), cM = /* @__PURE__ */ re({
  __name: "PaginationPrev",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e;
    Me();
    const t = Pa(), o = ee(() => t.page.value === 1 || t.disabled.value);
    return (i, r) => (_(), ie(I(Ve), ze(n, {
      "aria-label": "Previous Page",
      type: i.as === "button" ? "button" : void 0,
      disabled: o.value,
      onClick: r[0] || (r[0] = (a) => !o.value && I(t).onPageChange(I(t).page.value - 1))
    }), {
      default: J(() => [
        be(i.$slots, "default", {}, () => [
          Ie("Prev page")
        ])
      ]),
      _: 3
    }, 16, ["type", "disabled"]));
  }
}), [er, fM] = Ot("PopoverRoot"), ji = /* @__PURE__ */ re({
  __name: "PopoverRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    modal: { type: Boolean, default: !1 }
  },
  emits: ["update:open"],
  setup(e, { emit: n }) {
    const t = e, o = n, { modal: i } = on(t), r = tn(t, "open", o, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    }), a = X(), l = X(!1);
    return fM({
      contentId: "",
      modal: i,
      open: r,
      onOpenChange: (s) => {
        r.value = s;
      },
      onOpenToggle: () => {
        r.value = !r.value;
      },
      triggerElement: a,
      hasCustomAnchor: l
    }), (s, u) => (_(), ie(I(ru), null, {
      default: J(() => [
        be(s.$slots, "default", { open: I(r) })
      ]),
      _: 3
    }));
  }
}), Hi = /* @__PURE__ */ re({
  __name: "PopoverTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e, t = er(), { forwardRef: o, currentElement: i } = Me();
    return Ge(() => {
      t.triggerElement.value = i.value;
    }), (r, a) => (_(), ie(Uo(I(t).hasCustomAnchor.value ? I(Ve) : I(au)), { "as-child": "" }, {
      default: J(() => [
        ce(I(Ve), {
          ref: I(o),
          type: r.as === "button" ? "button" : void 0,
          "aria-haspopup": "dialog",
          "aria-expanded": I(t).open.value,
          "aria-controls": I(t).contentId,
          "data-state": I(t).open.value ? "open" : "closed",
          as: r.as,
          "as-child": n.asChild,
          onClick: I(t).onOpenToggle
        }, {
          default: J(() => [
            be(r.$slots, "default")
          ]),
          _: 3
        }, 8, ["type", "aria-expanded", "aria-controls", "data-state", "as", "as-child", "onClick"])
      ]),
      _: 3
    }));
  }
}), zi = /* @__PURE__ */ re({
  __name: "PopoverPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const n = e;
    return (t, o) => (_(), ie(I(iu), Ui(fa(n)), {
      default: J(() => [
        be(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), jh = /* @__PURE__ */ re({
  __name: "PopoverContentImpl",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = Sa(t), { forwardRef: r } = Me(), a = er();
    return PO(), (l, s) => (_(), ie(I(Ih), {
      "as-child": "",
      loop: "",
      trapped: l.trapFocus,
      onMountAutoFocus: s[5] || (s[5] = (u) => o("openAutoFocus", u)),
      onUnmountAutoFocus: s[6] || (s[6] = (u) => o("closeAutoFocus", u))
    }, {
      default: J(() => [
        ce(I(Ta), {
          "as-child": "",
          "disable-outside-pointer-events": l.disableOutsidePointerEvents,
          onPointerDownOutside: s[0] || (s[0] = (u) => o("pointerDownOutside", u)),
          onInteractOutside: s[1] || (s[1] = (u) => o("interactOutside", u)),
          onEscapeKeyDown: s[2] || (s[2] = (u) => o("escapeKeyDown", u)),
          onFocusOutside: s[3] || (s[3] = (u) => o("focusOutside", u)),
          onDismiss: s[4] || (s[4] = (u) => I(a).onOpenChange(!1))
        }, {
          default: J(() => [
            ce(I(sa), ze(I(i), {
              id: I(a).contentId,
              ref: I(r),
              "data-state": I(a).open.value ? "open" : "closed",
              role: "dialog",
              style: {
                "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
              }
            }), {
              default: J(() => [
                be(l.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), hM = /* @__PURE__ */ re({
  __name: "PopoverContentModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = er(), r = X(!1);
    Qs(!0);
    const a = Qi(t, o), { forwardRef: l, currentElement: s } = Me();
    return tu(s), (u, d) => (_(), ie(jh, ze(I(a), {
      ref: I(l),
      "trap-focus": I(i).open.value,
      "disable-outside-pointer-events": "",
      onCloseAutoFocus: d[0] || (d[0] = Yn(
        (f) => {
          var c;
          o("closeAutoFocus", f), r.value || (c = I(i).triggerElement.value) == null || c.focus();
        },
        ["prevent"]
      )),
      onPointerDownOutside: d[1] || (d[1] = (f) => {
        o("pointerDownOutside", f);
        const c = f.detail.originalEvent, h = c.button === 0 && c.ctrlKey === !0, m = c.button === 2 || h;
        r.value = m;
      }),
      onFocusOutside: d[2] || (d[2] = Yn(() => {
      }, ["prevent"]))
    }), {
      default: J(() => [
        be(u.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus"]));
  }
}), gM = /* @__PURE__ */ re({
  __name: "PopoverContentNonModal",
  props: {
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = er(), r = X(!1), a = X(!1), l = Qi(t, o);
    return (s, u) => (_(), ie(jh, ze(I(l), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      onCloseAutoFocus: u[0] || (u[0] = (d) => {
        var f;
        o("closeAutoFocus", d), d.defaultPrevented || (r.value || (f = I(i).triggerElement.value) == null || f.focus(), d.preventDefault()), r.value = !1, a.value = !1;
      }),
      onInteractOutside: u[1] || (u[1] = async (d) => {
        var f;
        o("interactOutside", d), d.defaultPrevented || (r.value = !0, d.detail.originalEvent.type === "pointerdown" && (a.value = !0));
        const c = d.target;
        (f = I(i).triggerElement.value) != null && f.contains(c) && d.preventDefault(), d.detail.originalEvent.type === "focusin" && a.value && d.preventDefault();
      })
    }), {
      default: J(() => [
        be(s.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), qi = /* @__PURE__ */ re({
  __name: "PopoverContent",
  props: {
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = er(), r = Qi(t, o), { forwardRef: a } = Me();
    return i.contentId || (i.contentId = nn(void 0, "radix-vue-popover-content")), (l, s) => (_(), ie(I(ni), {
      present: l.forceMount || I(i).open.value
    }, {
      default: J(() => [
        I(i).modal.value ? (_(), ie(hM, ze({ key: 0 }, I(r), { ref: I(a) }), {
          default: J(() => [
            be(l.$slots, "default")
          ]),
          _: 3
        }, 16)) : (_(), ie(gM, ze({ key: 1 }, I(r), { ref: I(a) }), {
          default: J(() => [
            be(l.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
});
function mM() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
mM();
const [su, pM] = Ot("TagsInputRoot"), vM = /* @__PURE__ */ re({
  __name: "TagsInputRoot",
  props: {
    modelValue: {},
    defaultValue: { default: () => [] },
    addOnPaste: { type: Boolean },
    addOnTab: { type: Boolean },
    addOnBlur: { type: Boolean },
    duplicate: { type: Boolean },
    disabled: { type: Boolean },
    delimiter: { default: "," },
    dir: {},
    max: { default: 0 },
    required: { type: Boolean },
    name: {},
    id: {},
    convertValue: {},
    displayValue: { type: Function, default: (e) => e.toString() },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "invalid"],
  setup(e, { emit: n }) {
    const t = e, o = n, { addOnPaste: i, disabled: r, delimiter: a, max: l, id: s, dir: u, addOnBlur: d, addOnTab: f } = on(t), c = eu(u), h = tn(t, "modelValue", o, {
      defaultValue: t.defaultValue,
      passive: !0,
      deep: !0
    }), { forwardRef: m, currentElement: g } = Me(), { focused: v } = kO(g), p = Oh(g), { getItems: y } = Rh(), C = X(), b = X(!1);
    return pM({
      modelValue: h,
      onAddValue: (x) => {
        const w = h.value.length > 0 && typeof h.value[0] == "object", $ = h.value.length > 0 && typeof t.defaultValue[0] == "object";
        if ((w || $) && typeof t.convertValue != "function")
          throw new Error("You must provide a `convertValue` function when using objects as values.");
        const E = t.convertValue ? t.convertValue(x) : x;
        if (h.value.length >= l.value && l.value)
          return o("invalid", E), !1;
        if (t.duplicate)
          return h.value = [...h.value, E], !0;
        if (h.value.includes(E))
          b.value = !0;
        else
          return h.value = [...h.value, E], !0;
        return o("invalid", E), !1;
      },
      onRemoveValue: (x) => {
        x !== -1 && (h.value = h.value.filter((w, $) => $ !== x));
      },
      onInputKeydown: (x) => {
        const w = x.target, $ = y().map((A) => A.ref).filter((A) => A.dataset.disabled !== "");
        if (!$.length)
          return;
        const E = $.at(-1);
        switch (x.key) {
          case "Delete":
          case "Backspace": {
            if (w.selectionStart !== 0 || w.selectionEnd !== 0)
              break;
            if (C.value) {
              const A = $.findIndex((O) => O === C.value);
              h.value = h.value.filter((O, k) => k !== A), C.value = C.value === E ? $.at(A - 1) : $.at(A + 1), x.preventDefault();
            } else
              x.key === "Backspace" && (C.value = E, x.preventDefault());
            break;
          }
          case "Home":
          case "End":
          case "ArrowRight":
          case "ArrowLeft": {
            const A = x.key === "ArrowRight" && c.value === "ltr" || x.key === "ArrowLeft" && c.value === "rtl", O = !A;
            if (w.selectionStart !== 0 || w.selectionEnd !== 0)
              break;
            if (O && !C.value)
              C.value = E, x.preventDefault();
            else if (A && E && C.value === E)
              C.value = void 0, x.preventDefault();
            else if (C.value) {
              const k = $h(x, C.value, void 0, {
                itemsArray: $,
                loop: !1,
                dir: c.value
              });
              k && (C.value = k), x.preventDefault();
            }
            break;
          }
          case "ArrowUp":
          case "ArrowDown": {
            C.value && x.preventDefault();
            break;
          }
          default:
            C.value = void 0;
        }
      },
      selectedElement: C,
      isInvalidInput: b,
      addOnPaste: i,
      addOnBlur: d,
      addOnTab: f,
      dir: c,
      disabled: r,
      delimiter: a,
      max: l,
      id: s,
      displayValue: t.displayValue
    }), (x, w) => (_(), ie(I(Bh), null, {
      default: J(() => [
        ce(I(Ve), {
          ref: I(m),
          dir: I(c),
          as: x.as,
          "as-child": x.asChild,
          "data-invalid": b.value ? "" : void 0,
          "data-disabled": I(r) ? "" : void 0,
          "data-focused": I(v) ? "" : void 0
        }, {
          default: J(() => [
            be(x.$slots, "default", { modelValue: I(h) }),
            I(p) && x.name ? (_(), ie(I(Fh), {
              key: 0,
              name: x.name,
              value: I(h),
              required: x.required,
              disabled: I(r)
            }, null, 8, ["name", "value", "required", "disabled"])) : z("", !0)
          ]),
          _: 3
        }, 8, ["dir", "as", "as-child", "data-invalid", "data-disabled", "data-focused"])
      ]),
      _: 3
    }));
  }
}), bM = /* @__PURE__ */ re({
  __name: "TagsInputInput",
  props: {
    placeholder: {},
    autoFocus: { type: Boolean },
    maxLength: {},
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(e) {
    const n = e, t = su(), { forwardRef: o, currentElement: i } = Me();
    function r(h) {
      if (!t.addOnBlur.value)
        return;
      const m = h.target;
      m.value && t.onAddValue(m.value) && (m.value = "");
    }
    function a(h) {
      t.addOnTab.value && d(h);
    }
    const l = X(!1);
    function s() {
      l.value = !0;
    }
    function u() {
      requestAnimationFrame(() => {
        l.value = !1;
      });
    }
    async function d(h) {
      if (l.value || (await He(), h.defaultPrevented))
        return;
      const m = h.target;
      m.value && (t.onAddValue(m.value) && (m.value = ""), h.preventDefault());
    }
    function f(h) {
      t.isInvalidInput.value = !1;
      const m = t.delimiter.value;
      if (m === h.data) {
        const g = h.target;
        g.value = g.value.replaceAll(m, ""), t.onAddValue(g.value) && (g.value = "");
      }
    }
    function c(h) {
      if (t.addOnPaste.value) {
        h.preventDefault();
        const m = h.clipboardData;
        if (!m)
          return;
        const g = m.getData("text");
        t.delimiter.value ? g.split(t.delimiter.value).forEach((v) => {
          t.onAddValue(v);
        }) : t.onAddValue(g);
      }
    }
    return Ge(() => {
      const h = i.value.nodeName === "INPUT" ? i.value : i.value.querySelector("input");
      h && setTimeout(() => {
        n.autoFocus && (h == null || h.focus());
      }, 1);
    }), (h, m) => {
      var g;
      return _(), ie(I(Ve), {
        id: (g = I(t).id) == null ? void 0 : g.value,
        ref: I(o),
        type: "text",
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        as: h.as,
        "as-child": h.asChild,
        maxlength: h.maxLength,
        placeholder: h.placeholder,
        disabled: I(t).disabled.value,
        "data-invalid": I(t).isInvalidInput.value ? "" : void 0,
        onInput: f,
        onKeydown: [
          pn(d, ["enter"]),
          pn(a, ["tab"]),
          I(t).onInputKeydown
        ],
        onBlur: r,
        onCompositionstart: s,
        onCompositionend: u,
        onPaste: c
      }, {
        default: J(() => [
          be(h.$slots, "default")
        ]),
        _: 3
      }, 8, ["id", "as", "as-child", "maxlength", "placeholder", "disabled", "data-invalid", "onKeydown"]);
    };
  }
}), [Hh, yM] = Ot("TagsInputItem"), CM = /* @__PURE__ */ re({
  __name: "TagsInputItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const n = e, { value: t } = on(n), o = su(), { forwardRef: i, currentElement: r } = Me(), a = ee(() => o.selectedElement.value === r.value), l = ee(() => n.disabled || o.disabled.value), s = yM({
      value: t,
      isSelected: a,
      disabled: l,
      textId: "",
      displayValue: ee(() => o.displayValue(t.value))
    });
    return (u, d) => (_(), ie(I(Vh), null, {
      default: J(() => [
        ce(I(Ve), {
          ref: I(i),
          as: u.as,
          "as-child": u.asChild,
          "aria-labelledby": I(s).textId,
          "aria-current": a.value,
          "data-disabled": l.value ? "" : void 0,
          "data-state": a.value ? "active" : "inactive"
        }, {
          default: J(() => [
            be(u.$slots, "default")
          ]),
          _: 3
        }, 8, ["as", "as-child", "aria-labelledby", "aria-current", "data-disabled", "data-state"])
      ]),
      _: 3
    }));
  }
}), xM = /* @__PURE__ */ re({
  __name: "TagsInputItemText",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(e) {
    const n = e, t = Hh();
    return Me(), t.textId || (t.textId = nn(void 0, "radix-vue-tags-input-item-text")), (o, i) => (_(), ie(I(Ve), ze(n, {
      id: I(t).textId
    }), {
      default: J(() => [
        be(o.$slots, "default", {}, () => [
          Ie(de(I(t).displayValue.value), 1)
        ])
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), wM = /* @__PURE__ */ re({
  __name: "TagsInputItemDelete",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e;
    Me();
    const t = su(), o = Hh(), i = ee(() => {
      var a;
      return ((a = o.disabled) == null ? void 0 : a.value) || t.disabled.value;
    });
    function r() {
      if (i.value)
        return;
      const a = t.modelValue.value.findIndex((l) => l === o.value.value);
      t.onRemoveValue(a);
    }
    return (a, l) => (_(), ie(I(Ve), ze({ tabindex: "-1" }, n, {
      "aria-labelledby": I(o).textId,
      "aria-current": I(o).isSelected.value,
      "data-state": I(o).isSelected.value ? "active" : "inactive",
      "data-disabled": i.value ? "" : void 0,
      type: a.as === "button" ? "button" : void 0,
      onClick: r
    }), {
      default: J(() => [
        be(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby", "aria-current", "data-state", "data-disabled", "type"]));
  }
}), zh = "tooltip.open", [uu, $M] = Ot("TooltipProvider"), kM = /* @__PURE__ */ re({
  inheritAttrs: !1,
  __name: "TooltipProvider",
  props: {
    delayDuration: { default: 700 },
    skipDelayDuration: { default: 300 },
    disableHoverableContent: { type: Boolean, default: !1 },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, { delayDuration: t, skipDelayDuration: o, disableHoverableContent: i, disableClosingTrigger: r, ignoreNonKeyboardFocus: a, disabled: l } = on(n);
    Me();
    const s = X(!0), u = X(!1), { start: d, stop: f } = Ch(() => {
      s.value = !0;
    }, o, { immediate: !1 });
    return $M({
      isOpenDelayed: s,
      delayDuration: t,
      onOpen() {
        f(), s.value = !1;
      },
      onClose() {
        d();
      },
      isPointerInTransitRef: u,
      disableHoverableContent: i,
      disableClosingTrigger: r,
      disabled: l,
      ignoreNonKeyboardFocus: a
    }), (c, h) => be(c.$slots, "default");
  }
}), [Ia, _M] = Ot("TooltipRoot"), OM = /* @__PURE__ */ re({
  __name: "TooltipRoot",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    open: { type: Boolean, default: void 0 },
    delayDuration: { default: void 0 },
    disableHoverableContent: { type: Boolean, default: void 0 },
    disableClosingTrigger: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: void 0 },
    ignoreNonKeyboardFocus: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(e, { emit: n }) {
    const t = e, o = n;
    Me();
    const i = uu(), r = ee(() => t.disableHoverableContent ?? i.disableHoverableContent.value), a = ee(() => t.disableClosingTrigger ?? i.disableClosingTrigger.value), l = ee(() => t.disabled ?? i.disabled.value), s = ee(() => t.delayDuration ?? i.delayDuration.value), u = ee(() => t.ignoreNonKeyboardFocus ?? i.ignoreNonKeyboardFocus.value), d = tn(t, "open", o, {
      defaultValue: t.defaultOpen,
      passive: t.open === void 0
    });
    Ne(d, (C) => {
      i.onClose && (C ? (i.onOpen(), document.dispatchEvent(new CustomEvent(zh))) : i.onClose());
    });
    const f = X(!1), c = X(), h = ee(() => d.value ? f.value ? "delayed-open" : "instant-open" : "closed"), { start: m, stop: g } = Ch(() => {
      f.value = !0, d.value = !0;
    }, s, { immediate: !1 });
    function v() {
      g(), f.value = !1, d.value = !0;
    }
    function p() {
      g(), d.value = !1;
    }
    function y() {
      m();
    }
    return _M({
      contentId: "",
      open: d,
      stateAttribute: h,
      trigger: c,
      onTriggerChange(C) {
        c.value = C;
      },
      onTriggerEnter() {
        i.isOpenDelayed.value ? y() : v();
      },
      onTriggerLeave() {
        r.value ? p() : g();
      },
      onOpen: v,
      onClose: p,
      disableHoverableContent: r,
      disableClosingTrigger: a,
      disabled: l,
      ignoreNonKeyboardFocus: u
    }), (C, b) => (_(), ie(I(ru), null, {
      default: J(() => [
        be(C.$slots, "default", { open: I(d) })
      ]),
      _: 3
    }));
  }
}), EM = /* @__PURE__ */ re({
  __name: "TooltipTrigger",
  props: {
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const n = e, t = Ia(), o = uu();
    t.contentId || (t.contentId = nn(void 0, "radix-vue-tooltip-content"));
    const { forwardRef: i, currentElement: r } = Me(), a = X(!1), l = X(!1), s = ee(() => t.disabled.value ? {} : {
      click: g,
      focus: h,
      pointermove: f,
      pointerleave: c,
      pointerdown: d,
      blur: m
    });
    Ge(() => {
      t.onTriggerChange(r.value);
    });
    function u() {
      setTimeout(() => {
        a.value = !1;
      }, 1);
    }
    function d() {
      a.value = !0, document.addEventListener("pointerup", u, { once: !0 });
    }
    function f(v) {
      v.pointerType !== "touch" && !l.value && !o.isPointerInTransitRef.value && (t.onTriggerEnter(), l.value = !0);
    }
    function c() {
      t.onTriggerLeave(), l.value = !1;
    }
    function h(v) {
      var p, y;
      a.value || t.ignoreNonKeyboardFocus.value && !((y = (p = v.target).matches) != null && y.call(p, ":focus-visible")) || t.onOpen();
    }
    function m() {
      t.onClose();
    }
    function g() {
      t.disableClosingTrigger.value || t.onClose();
    }
    return (v, p) => (_(), ie(I(au), { "as-child": "" }, {
      default: J(() => [
        ce(I(Ve), ze({
          ref: I(i),
          "aria-describedby": I(t).open.value ? I(t).contentId : void 0,
          "data-state": I(t).stateAttribute.value,
          as: v.as,
          "as-child": n.asChild,
          "data-grace-area-trigger": ""
        }, g0(s.value)), {
          default: J(() => [
            be(v.$slots, "default")
          ]),
          _: 3
        }, 16, ["aria-describedby", "data-state", "as", "as-child"])
      ]),
      _: 3
    }));
  }
}), qh = /* @__PURE__ */ re({
  __name: "TooltipContentImpl",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: { default: 0 },
    align: { default: "center" },
    alignOffset: {},
    avoidCollisions: { type: Boolean, default: !0 },
    collisionBoundary: { default: () => [] },
    collisionPadding: { default: 0 },
    arrowPadding: { default: 0 },
    sticky: { default: "partial" },
    hideWhenDetached: { type: Boolean, default: !1 }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = Ia(), { forwardRef: r } = Me(), a = v0(), l = ee(() => {
      var d;
      return (d = a.default) == null ? void 0 : d.call(a);
    }), s = ee(() => {
      var d;
      if (t.ariaLabel)
        return t.ariaLabel;
      let f = "";
      function c(h) {
        typeof h.children == "string" && h.type !== o1 ? f += h.children : Array.isArray(h.children) && h.children.forEach((m) => c(m));
      }
      return (d = l.value) == null || d.forEach((h) => c(h)), f;
    }), u = ee(() => {
      const { ariaLabel: d, ...f } = t;
      return f;
    });
    return Ge(() => {
      Zo(window, "scroll", (d) => {
        const f = d.target;
        f != null && f.contains(i.trigger.value) && i.onClose();
      }), Zo(window, zh, i.onClose);
    }), (d, f) => (_(), ie(I(Ta), {
      "as-child": "",
      "disable-outside-pointer-events": !1,
      onEscapeKeyDown: f[0] || (f[0] = (c) => o("escapeKeyDown", c)),
      onPointerDownOutside: f[1] || (f[1] = (c) => {
        var h;
        I(i).disableClosingTrigger.value && (h = I(i).trigger.value) != null && h.contains(c.target) && c.preventDefault(), o("pointerDownOutside", c);
      }),
      onFocusOutside: f[2] || (f[2] = Yn(() => {
      }, ["prevent"])),
      onDismiss: f[3] || (f[3] = (c) => I(i).onClose())
    }, {
      default: J(() => [
        ce(I(sa), ze({
          ref: I(r),
          "data-state": I(i).stateAttribute.value
        }, { ...d.$attrs, ...u.value }, { style: {
          "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
          "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
          "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        } }), {
          default: J(() => [
            be(d.$slots, "default"),
            ce(I(Nh), {
              id: I(i).contentId,
              role: "tooltip"
            }, {
              default: J(() => [
                Ie(de(s.value), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ]),
          _: 3
        }, 16, ["data-state"])
      ]),
      _: 3
    }));
  }
}), MM = /* @__PURE__ */ re({
  __name: "TooltipContentHoverable",
  props: {
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  setup(e) {
    const n = Sa(e), { forwardRef: t, currentElement: o } = Me(), { trigger: i, onClose: r } = Ia(), a = uu(), { isPointerInTransit: l, onPointerExit: s } = IO(i, o);
    return a.isPointerInTransitRef = l, s(() => {
      r();
    }), (u, d) => (_(), ie(qh, ze({ ref: I(t) }, I(n)), {
      default: J(() => [
        be(u.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), SM = /* @__PURE__ */ re({
  __name: "TooltipContent",
  props: {
    forceMount: { type: Boolean },
    ariaLabel: {},
    asChild: { type: Boolean },
    as: {},
    side: { default: "top" },
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = Ia(), r = Qi(t, o), { forwardRef: a } = Me();
    return (l, s) => (_(), ie(I(ni), {
      present: l.forceMount || I(i).open.value
    }, {
      default: J(() => [
        (_(), ie(Uo(I(i).disableHoverableContent.value ? qh : MM), ze({ ref: I(a) }, I(r)), {
          default: J(() => [
            be(l.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), AM = /* @__PURE__ */ re({
  __name: "TooltipPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const n = e;
    return (t, o) => (_(), ie(I(iu), Ui(fa(n)), {
      default: J(() => [
        be(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), TM = ["disabled", "onClick"], PM = ["disabled", "onClick"], IM = {
  key: 2,
  class: "border-none w-full h-[1px] bg-border-subtle mt-1 mb-1 block"
}, DM = /* @__PURE__ */ re({
  __name: "PopoverMenu",
  props: {
    items: {},
    noSeparators: { type: Boolean },
    open: { type: Boolean }
  },
  emits: ["openChange"],
  setup(e, { emit: n }) {
    const t = {
      normal: "text-foreground-emphasis hover:bg-background-subtle",
      danger: "text-foreground-danger-default hover:bg-background-danger-default"
    }, o = {
      normal: "#5F6C85",
      danger: "#D92D20"
    }, i = e, r = n, a = X(i.open || !1), l = (s) => {
      s.onClick && s.onClick(), setTimeout(() => {
        a.value = !1;
      }, 100);
    };
    return (s, u) => (_(), ie(I(ji), {
      open: a.value,
      "onUpdate:open": u[0] || (u[0] = (d) => {
        r("openChange", d), a.value = d;
      })
    }, {
      default: J(() => [
        ce(I(Hi), { asChild: "" }, {
          default: J(() => [
            be(s.$slots, "trigger")
          ]),
          _: 3
        }),
        ce(I(zi), null, {
          default: J(() => [
            ce(I(qi), {
              side: "bottom",
              "side-offset": 4,
              align: "end",
              class: "rounded-[5px] border border-border-default bg-white shadow-lg py-1 data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade"
            }, {
              default: J(() => [
                (_(!0), P(me, null, Fe(s.items, (d, f) => (_(), P("div", {
                  key: d.name
                }, [
                  d.tooltip ? (_(), ie(I(kM), { key: 0 }, {
                    default: J(() => [
                      ce(I(OM), { delayDuration: 0 }, {
                        default: J(() => [
                          ce(I(EM), { asChild: "" }, {
                            default: J(() => [
                              M("button", {
                                class: pe(`h-9 px-3 w-full text-sm font-medium flex items-center gap-2 transition-colors duration-150 ${t[d.type]} ${d.disabled ? "opacity-50" : ""}`),
                                disabled: d.disabled,
                                onClick: () => {
                                  l(d);
                                }
                              }, [
                                d.icon ? (_(), ie(Le, {
                                  key: 0,
                                  icon: d.icon,
                                  color: o[d.type]
                                }, null, 8, ["icon", "color"])) : z("", !0),
                                Ie(" " + de(d.name), 1)
                              ], 10, TM)
                            ]),
                            _: 2
                          }, 1024),
                          ce(I(AM), null, {
                            default: J(() => [
                              ce(I(SM), {
                                class: "data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade text-grass11 select-none rounded-lg bg-neutral-900 px-[15px] py-[10px] text-[15px] leading-none shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] text-mgm-txt-sm text-neutral-200",
                                "side-offset": 8,
                                side: "bottom"
                              }, {
                                default: J(() => [
                                  Ie(de(d.tooltip), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)) : (_(), P("button", {
                    key: 1,
                    class: pe(`h-9 px-3 w-full text-sm font-medium flex items-center gap-2 transition-colors duration-150 ${t[d.type]} ${d.disabled ? "opacity-50" : ""}`),
                    disabled: d.disabled,
                    onClick: () => {
                      l(d);
                    }
                  }, [
                    d.icon ? (_(), ie(Le, {
                      key: 0,
                      icon: d.icon,
                      color: o[d.type]
                    }, null, 8, ["icon", "color"])) : z("", !0),
                    Ie(" " + de(d.name), 1)
                  ], 10, PM)),
                  f !== s.items.length - 1 && !s.noSeparators ? (_(), P("hr", IM)) : z("", !0)
                ]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), GA = /* @__PURE__ */ re({
  __name: "Modal",
  props: {
    open: { type: Boolean },
    contentClass: {}
  },
  emits: ["openChange", "openFocus"],
  setup(e, { emit: n }) {
    const t = e, o = X(t.open ?? !1), i = n, r = (l) => {
      o.value = l, i("openChange", l);
    }, a = (l) => {
      i("openFocus", l);
    };
    return Ne(
      () => t.open,
      (l) => {
        o.value = l;
      }
    ), (l, s) => (_(), ie(I(uE), {
      open: o.value,
      "onUpdate:open": r
    }, {
      default: J(() => [
        ce(I(dE), { "as-child": !0 }, {
          default: J(() => [
            be(l.$slots, "trigger")
          ]),
          _: 3
        }),
        ce(I(cE), null, {
          default: J(() => [
            ce(I(TE), { class: "bg-black/70 data-[state=open]:animate-overlayShow fixed inset-0 z-30 backdrop-blur-md" }),
            ce(I(SE), {
              onOpenAutoFocus: (u) => a(u),
              class: pe(`data-[state=open]:animate-contentShow fixed top-1/2 left-1/2 max-h-[85vh] w-full max-w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white p-6 shadow-lg focus:outline-none z-[100] ${t.contentClass ? t.contentClass : ""}`)
            }, {
              default: J(() => [
                be(l.$slots, "content"),
                ce(I(PE), { class: "absolute top-6 right-6" }, {
                  default: J(() => [
                    ce(Le, {
                      icon: "close",
                      color: "#94A3B8"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 3
            }, 8, ["onOpenAutoFocus", "class"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), LM = { class: "p-4" }, NM = { class: "flex items-center gap-3 mb-3" }, FM = ["src", "alt"], RM = { class: "text-mgm-txt-md text-foreground-emphasis font-medium" }, BM = { class: "text-left text-mgm-txt-sm text-foreground-default" }, ZA = /* @__PURE__ */ re({
  __name: "IntegrationCard",
  props: {
    name: {},
    logo: {},
    description: {},
    integrationText: {},
    connected: { type: Boolean },
    connectedText: {}
  },
  setup(e) {
    const n = X(!1);
    return (t, o) => (_(), P("button", {
      class: "bg-white border border-subtle rounded w-full transition-shadow duration-200 hover:shadow-[0_4px_8px_-2px_rgba(28,31,39,0.1),0_2px_4px_-2px_rgba(28,31,39,0.06)] overflow-hidden group",
      onMouseenter: o[0] || (o[0] = (i) => n.value = !0),
      onMouseleave: o[1] || (o[1] = (i) => n.value = !1)
    }, [
      M("div", LM, [
        M("div", NM, [
          M("img", {
            src: t.logo,
            alt: t.name,
            class: "w-8 h-8 rounded-lg"
          }, null, 8, FM),
          M("h3", RM, de(t.name), 1)
        ]),
        M("p", BM, de(t.description), 1)
      ]),
      M("div", {
        class: pe(`w-full py-4 px-6 border-t border-border-subtle flex justify-start gap-2 ${t.connected ? "bg-background-success-default" : "bg-background-subtle"}`)
      }, [
        t.connected ? z("", !0) : (_(), ie(Le, {
          key: 0,
          icon: "clipboard",
          color: n.value ? "#1c1f27" : "#5f6c85"
        }, null, 8, ["color"])),
        M("p", {
          class: pe(`text-mgm-txt-sm  transition-colors duration-150 ${t.connected ? "text-foreground-success-default" : "text-foreground-default group-hover:text-foreground-emphasis"}`)
        }, de(t.connected ? t.connectedText : t.integrationText), 3)
      ], 2)
    ], 32));
  }
}), VM = { class: "relative w-fit" }, jM = { class: "flex gap-0.5" }, HM = /* @__PURE__ */ M("path", {
  d: "M10.0003 1.66666L12.5753 6.88332L18.3337 7.72499L14.167 11.7833L15.1503 17.5167L10.0003 14.8083L4.85033 17.5167L5.83366 11.7833L1.66699 7.72499L7.42533 6.88332L10.0003 1.66666Z",
  fill: "#FDB022"
}, null, -1), zM = [
  HM
], qM = { class: "" }, UM = { class: "flex gap-0.5" }, WM = /* @__PURE__ */ M("path", {
  d: "M10.0003 1.66666L12.5753 6.88332L18.3337 7.72499L14.167 11.7833L15.1503 17.5167L10.0003 14.8083L4.85033 17.5167L5.83366 11.7833L1.66699 7.72499L7.42533 6.88332L10.0003 1.66666Z",
  fill: "#CBD5E1"
}, null, -1), KM = [
  WM
], Uh = /* @__PURE__ */ re({
  __name: "Stars",
  props: {
    rating: {}
  },
  setup(e) {
    return (n, t) => (_(), P("div", VM, [
      M("div", {
        class: "absolute top-0 left-0 overflow-hidden flex w-full",
        style: Ye({ width: n.rating * 100 / 5 + "%" })
      }, [
        M("div", jM, [
          (_(), P(me, null, Fe(5, (o) => M("svg", {
            key: o,
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, zM)), 64))
        ])
      ], 4),
      M("div", qM, [
        M("div", UM, [
          (_(), P(me, null, Fe(5, (o) => M("svg", {
            key: o + "empty",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, KM)), 64))
        ])
      ])
    ]));
  }
}), YM = { class: "relative" }, GM = { class: "" }, ZM = { class: "flex" }, XM = ["onMouseenter", "onClick"], JM = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QM = /* @__PURE__ */ re({
  __name: "StarsSelector",
  props: {
    stars: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = X(null), r = X(t.stars || null), a = (u) => {
      i.value = u;
    }, l = () => {
      i.value = null;
    }, s = (u) => {
      t.disabled || (r.value = u, o("update:modelValue", u));
    };
    return (u, d) => (_(), P("div", YM, [
      M("div", GM, [
        M("div", ZM, [
          (_(), P(me, null, Fe(5, (f) => M("button", {
            key: f,
            class: "group hover:-translate-y-[2px] transition-all duration-150 px-0.5",
            onMouseenter: (c) => a(f),
            onMouseleave: l,
            onClick: (c) => s(f)
          }, [
            (_(), P("svg", JM, [
              M("path", {
                d: "M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                class: pe(`stroke-[#5F6C85] transition-all duration-150 ${i.value && i.value >= f || r.value && r.value >= f ? "stroke-[#FDB022] fill-[#FDB022]" : ""}`)
              }, null, 2)
            ]))
          ], 40, XM)), 64))
        ])
      ])
    ]));
  }
}), eS = { class: "sm:rounded-lg sm:border sm:border-border-subtle p-10 w-full sm:w-[480px] sm:shadow-lg bg-white h-full flex flex-col justify-between" }, tS = ["src"], nS = { class: "text-mgm-txt-lg text-foreground-emphasis mb-3 font-medium" }, oS = { class: "rounded bg-background-subtle px-4 py-3 mb-4" }, iS = { class: "text-mgm-txt-sm mb-2" }, rS = { class: "flex items-center gap-2" }, aS = ["src"], lS = { class: "text-mgm-txt-sm text-foreground-default" }, sS = { key: 0 }, uS = { class: "text-mgm-txt-sm text-foreground-emphasis mb-2 font-medium" }, XA = /* @__PURE__ */ re({
  __name: "ReviewCard",
  props: {
    customColor: {},
    customRGBColor: {},
    title: {},
    logoUrl: {},
    intro: {},
    rateTitle: {},
    commentLabel: {},
    submitLabel: {},
    stars: {},
    comment: {},
    disabled: { type: Boolean }
  },
  emits: ["submit"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = X(t.stars || void 0), r = X(t.comment || void 0), a = (u) => {
      i.value = u;
    }, l = (u) => {
      r.value = u;
    }, s = () => {
      o("submit", { rating: i.value, comment: r.value });
    };
    return (u, d) => (_(), P("div", eS, [
      M("div", null, [
        M("img", {
          src: u.logoUrl,
          alt: "Learnico",
          class: "w-10 h-10 rounded-full mb-4"
        }, null, 8, tS),
        M("h3", nS, de(u.title), 1),
        M("div", oS, [
          M("p", iS, de(u.intro.text), 1),
          M("div", rS, [
            M("img", {
              src: u.intro.avatarUrl,
              class: "w-5 h-5 rounded-full"
            }, null, 8, aS),
            M("p", lS, [
              Ie(de(u.intro.name) + " ", 1),
              u.intro.role ? (_(), P("i", sS, "— " + de(u.intro.role), 1)) : z("", !0)
            ])
          ])
        ]),
        M("h4", uS, de(u.rateTitle), 1),
        ce(QM, {
          stars: i.value,
          class: "mb-4",
          "onUpdate:modelValue": a,
          disabled: u.disabled
        }, null, 8, ["stars", "disabled"]),
        ce(Vy, {
          label: u.commentLabel,
          "onUpdate:modelValue": l,
          "model-value": r.value,
          class: "mb-4",
          disabled: u.disabled
        }, null, 8, ["label", "model-value", "disabled"])
      ]),
      ce(Fr, {
        class: "w-full",
        size: "lg",
        "custom-color": u.customColor,
        "custom-rgb-color": u.customRGBColor,
        disabled: !i.value || !r.value,
        onClick: s
      }, {
        default: J(() => [
          Ie(de(u.submitLabel), 1)
        ]),
        _: 1
      }, 8, ["custom-color", "custom-rgb-color", "disabled"])
    ]));
  }
}), dS = { class: "flex gap-3 lg:gap-10 w-full min-w-[700px] pb-4 border-b border-border-subtle items-start flex-col lg:flex-row" }, cS = { class: "flex gap-4 items-center shrink-0 w-72" }, fS = ["src", "alt"], hS = { class: "text-mgm-txt-sm font-medium" }, gS = { class: "text-mgm-txt-sm text-foreground-default" }, mS = { class: "text-mgm-txt-sm text-foreground-default" }, pS = {
  key: 0,
  class: "flex-1"
}, vS = { class: "flex gap-4 items-center mb-2" }, bS = { class: "text-mgm-txt-sm text-foreground-default" }, yS = { class: "text-mgm-txt-sm" }, CS = {
  key: 1,
  class: "flex items-center"
}, xS = { class: "bg-background-subtle text-mgm-txt-sm text-foreground-default rounded-full px-3 py-1" }, JA = /* @__PURE__ */ re({
  __name: "ReviewLine",
  props: {
    id: {},
    photo: {},
    name: {},
    mail: {},
    role: {},
    rating: {},
    date: {},
    comment: {},
    reviewText: {},
    menuItems: {}
  },
  setup(e) {
    const n = X(!1), t = X(!1);
    return (o, i) => (_(), P("div", dS, [
      M("div", cS, [
        M("img", {
          src: o.photo,
          alt: o.name,
          class: "w-10 h-10 rounded-full"
        }, null, 8, fS),
        M("div", null, [
          M("h4", hS, de(o.name), 1),
          M("p", gS, de(o.mail), 1),
          M("p", mS, de(o.role), 1)
        ])
      ]),
      o.rating ? (_(), P("div", pS, [
        M("div", vS, [
          ce(Uh, { rating: o.rating }, null, 8, ["rating"]),
          M("p", bS, de(o.date), 1)
        ]),
        M("p", yS, de(o.comment), 1)
      ])) : (_(), P("div", CS, [
        M("span", xS, de(o.reviewText), 1)
      ])),
      o.rating ? (_(), ie(DM, {
        key: 2,
        items: o.menuItems || [],
        onOpenChange: i[2] || (i[2] = (r) => t.value = r)
      }, {
        trigger: J(() => [
          M("button", {
            class: pe(`w-8 h-8 border border-border-subtle rounded self-center hover:border-border-default transition-colors duration-150 ${t.value ? "!border-border-default" : ""}`),
            onMouseenter: i[0] || (i[0] = (r) => n.value = !0),
            onMouseleave: i[1] || (i[1] = (r) => n.value = !1)
          }, [
            ce(Le, {
              icon: "share",
              color: n.value || t.value ? "#1C1F27" : "#5F6C85"
            }, null, 8, ["color"])
          ], 34)
        ]),
        _: 1
      }, 8, ["items"])) : z("", !0)
    ]));
  }
}), QA = /* @__PURE__ */ re({
  __name: "Pagination",
  props: {
    total: {},
    siblingCount: {},
    defaultPage: {},
    itemsPerPage: {},
    items: {}
  },
  emits: ["update:page"],
  setup(e, { emit: n }) {
    const t = n, o = (i) => {
      t("update:page", i);
    };
    return (i, r) => (_(), ie(I(iM), {
      total: i.total,
      "sibling-count": i.siblingCount,
      "show-edges": "",
      "default-page": i.defaultPage,
      "items-per-page": i.itemsPerPage,
      "onUpdate:page": o
    }, {
      default: J(() => [
        ce(I(sM), { class: "flex items-center gap-1 text-foreground-default" }, {
          default: J(({ items: a }) => [
            ce(I(cM), { class: "w-9 h-9 flex items-center justify-center mr-4 disabled:opacity-0 focus-within:outline focus-within:outline-1 focus-within:outline-offset-1 rounded-full" }, {
              default: J(() => [
                ce(Le, {
                  icon: "chevron-left",
                  color: "#5F6C85"
                })
              ]),
              _: 1
            }),
            (_(!0), P(me, null, Fe(a, (l, s) => (_(), P(me, null, [
              l.type === "page" ? (_(), ie(I(uM), {
                key: s,
                class: "w-8 h-8 rounded-full data-[selected]:bg-background-brand-default-hover data-[selected]:text-foreground-brand-default after:transition focus-within:outline focus-within:outline-1 focus-within:outline-offset-1 text-mgm-txt-sm",
                value: l.value
              }, {
                default: J(() => [
                  Ie(de(l.value), 1)
                ]),
                _: 2
              }, 1032, ["value"])) : (_(), ie(I(rM), {
                key: l.type,
                index: s,
                class: "w-9 h-9 flex items-center justify-center"
              }, {
                default: J(() => [
                  Ie(" … ")
                ]),
                _: 2
              }, 1032, ["index"]))
            ], 64))), 256)),
            ce(I(dM), { class: "w-9 h-9 flex items-center justify-center ml-4 disabled:opacity-0 focus-within:outline focus-within:outline-1 focus-within:outline-offset-1 rounded-full" }, {
              default: J(() => [
                ce(Le, {
                  icon: "chevron-right",
                  color: "#5F6C85"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["total", "sibling-count", "default-page", "items-per-page"]));
  }
}), wS = { class: "w-full h-10 bg-background-subtle border border-border-subtle rounded flex items-center justify-between pl-3 gap-10" }, $S = { class: "text-mgm-txt-sm text-foreground-default" }, eT = /* @__PURE__ */ re({
  __name: "CopyUrl",
  props: {
    url: {},
    buttonLabel: {},
    copyText: {}
  },
  setup(e) {
    const n = e, t = X(!1), o = () => {
      navigator.clipboard.writeText(n.url), t.value = !0, setTimeout(() => {
        t.value = !1;
      }, 2e3);
    };
    return (i, r) => (_(), P("div", wS, [
      M("span", $S, de(i.url), 1),
      M("button", {
        class: "outline-none bg-white h-full w-28 rounded-r text-mgm-txt-sm text-foreground-emphasis",
        onClick: o
      }, de(t.value ? i.copyText : i.buttonLabel), 1)
    ]));
  }
}), kS = { class: "flex justify-between items-center py-3 px-5" }, _S = { class: "text-mgm-txt-md text-foreground-emphasis font-medium" }, OS = { class: "px-5 py-1 bg-[#F8FAFC]" }, ES = ["slot"], tT = /* @__PURE__ */ re({
  __name: "PopoverFilter",
  props: {
    title: {},
    clearLabel: {},
    filters: {},
    disabledClear: { type: Boolean }
  },
  emits: ["openChange", "clearAll"],
  setup(e, { emit: n }) {
    const t = n;
    return (o, i) => (_(), ie(I(ji), {
      "onUpdate:open": i[1] || (i[1] = (r) => t("openChange", r))
    }, {
      default: J(() => [
        ce(I(Hi), { asChild: "" }, {
          default: J(() => [
            be(o.$slots, "trigger")
          ]),
          _: 3
        }),
        ce(I(zi), null, {
          default: J(() => [
            ce(I(qi), {
              side: "bottom",
              "side-offset": 4,
              align: "end",
              class: "w-[224px] rounded-[5px] border border-border-subtle bg-white data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade outline-none overflow-hidden"
            }, {
              default: J(() => {
                var r;
                return [
                  M("div", kS, [
                    M("p", _S, de(o.title), 1),
                    M("button", {
                      class: pe(`text-background-brand-emphasis text-mgm-txt-md ${o.disabledClear ? "opacity-50" : "opacity-100"}`),
                      onClick: i[0] || (i[0] = () => o.$emit("clearAll"))
                    }, de(o.clearLabel), 3)
                  ]),
                  ce(I(nE), {
                    class: "w-full",
                    type: "single",
                    "default-value": ((r = o.filters.find((a) => a.defaultOpen)) == null ? void 0 : r.name) || void 0,
                    collapsible: !0
                  }, {
                    default: J(() => [
                      (_(!0), P(me, null, Fe(o.filters, (a) => (_(), ie(I(iE), {
                        key: a.name,
                        value: a.name
                      }, {
                        default: J(() => [
                          ce(I(aE), { class: "flex" }, {
                            default: J(() => [
                              ce(I(lE), { class: "flex h-[40px] flex-1 items-center gap-1 bg-white px-5 text-[15px] leading-none outline-none group cursor-pointer" }, {
                                default: J(() => [
                                  ce(Le, {
                                    icon: "chevron-down",
                                    class: "group-data-[state=open]:rotate-180 transition-all duration-150"
                                  }),
                                  M("span", null, de(a.title), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          ce(I(rE), { class: "data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden" }, {
                            default: J(() => [
                              M("div", OS, [
                                M("div", {
                                  slot: ["filter", a.name].join("-")
                                }, [
                                  be(o.$slots, ["filter", a.name].join("-"))
                                ], 8, ES)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"]))), 128))
                    ]),
                    _: 3
                  }, 8, ["default-value"])
                ];
              }),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), MS = { class: "flex text-mgm-txt-sm divide-x divide-border-subtle h-7 bg-background-subtle text-foreground-default" }, SS = {
  key: 0,
  class: "w-10"
}, AS = { class: "flex text-mgm-txt-sm divide-x divide-border-subtle h-7 bg-white" }, TS = {
  key: 0,
  class: "flex justify-center items-center bg-background-subtle w-10"
}, PS = { key: 0 }, IS = {
  key: 1,
  class: "flex gap-1"
}, DS = { class: "text-mgm-txt-xs font-medium text-foreground-default bg-background-subtle rounded-full px-1.5 py-0.5" }, LS = {
  key: 0,
  class: "text-mgm-txt-xs font-medium text-foreground-default bg-background-subtle rounded-full px-1.5 py-0.5"
}, nT = /* @__PURE__ */ re({
  __name: "SimpleTable",
  props: {
    displayIndex: { type: Boolean },
    data: {},
    keys: {},
    accordion: { type: Boolean },
    seeMoreButton: {},
    seeLessButton: {}
  },
  setup(e) {
    const n = X(null), t = X(0), o = X(!1), i = X(!1), r = () => {
      n.value && (n.value.style.webkitLineClamp = "initial", n.value.style.overflow = "initial", n.value.style.textOverflow = "initial", n.value.style.display = "block", n.value.style.webkitBoxOrient = "initial", i.value = !0);
    }, a = () => {
      n.value && (setTimeout(() => {
        n.value && (n.value.style.overflow = "hidden", n.value.style.textOverflow = "ellipsis", n.value.style.display = "-webkit-box", n.value.style.webkitBoxOrient = "vertical");
      }, 300), i.value = !1, n.value.scrollHeight > 40 && (o.value = !0), n.value.scrollHeight <= 40 && (o.value = !1));
    };
    ct(() => {
      if (n.value) {
        const s = n.value.scrollHeight;
        t.value = s, s > 70 && (n.value.style.overflow = "hidden", n.value.style.textOverflow = "ellipsis", n.value.style.display = "-webkit-box", n.value.style.webkitBoxOrient = "vertical", o.value = !0);
      }
    });
    const l = ee(() => {
      if (i.value)
        return t.value + 28 + "px";
      if (!i.value && o.value && t.value > 192)
        return "192px";
      if (!i.value && !o.value && t.value < 192)
        return "auto";
    });
    return (s, u) => (_(), P("div", {
      class: pe("transition-all duration-500 overflow-hidden box-content relative border border-border-subtle rounded"),
      style: Ye(`height: ${s.accordion ? l.value : "auto"}`)
    }, [
      M("div", {
        ref_key: "container",
        ref: n,
        class: pe("overflow-hidden divide-y divide-border-subtle w-full")
      }, [
        M("div", MS, [
          s.displayIndex ? (_(), P("div", SS)) : z("", !0),
          (_(!0), P(me, null, Fe(s.keys, (d) => (_(), P("div", {
            key: "title-col-" + d.id,
            class: pe(`px-3 flex items-center flex-1 ${d.columnClass || ""}`)
          }, de(d.title), 3))), 128))
        ]),
        (_(!0), P(me, null, Fe(s.data, (d, f) => (_(), P("div", AS, [
          s.displayIndex ? (_(), P("div", TS, de(f + 1), 1)) : z("", !0),
          (_(!0), P(me, null, Fe(s.keys, (c) => (_(), P("div", {
            key: "data-col-" + c.id,
            class: "px-3 flex items-center truncate flex-1"
          }, [
            Array.isArray(d[c.id]) ? (_(), P("div", IS, [
              M("span", DS, de(d[c.id][0]), 1),
              d[c.id].length > 1 ? (_(), P("span", LS, "+" + de(d[c.id].length - 1), 1)) : z("", !0)
            ])) : (_(), P("span", PS, de(d[c.id]), 1))
          ]))), 128))
        ]))), 256))
      ], 512),
      s.accordion && t.value > 192 ? (_(), P("button", {
        key: 0,
        class: "absolute bottom-0 left-0 bg-white w-full border-t border-border-subtle text-mgm-txt-sm text-foreground-brand-default h-[27px] flex gap-1 justify-center items-center",
        onClick: u[0] || (u[0] = (d) => i.value ? a() : r())
      }, [
        Ie(de(i.value ? s.seeLessButton : s.seeMoreButton) + " ", 1),
        ce(Le, {
          icon: "chevron-down",
          color: "#444CE7",
          class: pe(`${i.value ? "rotate-180" : "rotate-0"} transition-all duration-150`)
        }, null, 8, ["class"])
      ])) : z("", !0)
    ], 4));
  }
});
const NS = { class: "flex gap-1 flex-wrap items-center" }, FS = { class: "text-foreground-emphasis" }, RS = {
  key: 0,
  class: "mx-2 text-mgm-txt-sm text-foreground-default"
}, BS = ["placeholder"], VS = { class: "p-3 flex flex-col gap-3 max-h-[35dvh] overflow-y-auto" }, jS = {
  key: 0,
  class: "text-mgm-txt-xs text-foreground-default mb-2 block"
}, HS = { class: "grid grid-cols-1 gap-3" }, zS = { class: "text-mgm-txt-sm font-medium text-foreground-emphasis -mt-1 block" }, qS = {
  key: 0,
  class: "font-normal text-foreground-default"
}, US = {
  key: 0,
  class: "text-mgm-txt-sm text-foreground-subtle text-center"
}, WS = { key: 0 }, KS = ["onClick"], YS = { key: 1 }, GS = ["placeholder"], ZS = { class: "p-3 grid grid-cols-1 gap-3 max-h-[35dvh] overflow-y-auto" }, XS = {
  key: 0,
  class: "text-mgm-txt-xs text-foreground-default mb-2 block"
}, JS = { class: "grid grid-cols-1 gap-3" }, QS = { class: "text-mgm-txt-sm font-medium text-foreground-emphasis -mt-1 block" }, eA = {
  key: 0,
  class: "font-normal text-foreground-default"
}, tA = {
  key: 0,
  class: "text-mgm-txt-sm text-foreground-subtle text-center"
}, oT = /* @__PURE__ */ re({
  __name: "Filter",
  props: {
    filter: {},
    currentFilters: {},
    modelValue: {},
    text: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = X(null), r = X(""), a = ki({}), l = X(
      t.modelValue || []
    ), s = ee(() => t.filter.find((c) => c.id === i.value) || null), u = (c) => {
      var m;
      return (((m = s.value) == null ? void 0 : m.options.flatMap((g) => g.items)) || []).filter(
        (g) => g.label.toLowerCase().includes(c.toLowerCase())
      );
    }, d = () => {
      if (i.value) {
        const c = a[s.value.id], h = Object.keys(c).filter((m) => c[m]);
        h.length > 0 ? l.value.push({
          id: s.value.id,
          selected: h
        }) : l.value = l.value.filter(
          (m) => m.id !== s.value.id
        );
      }
      o("update:modelValue", l.value), i.value = null, r.value = "";
    }, f = (c) => {
      const h = a[c], m = Object.keys(h).filter((g) => h[g]);
      if (m.length > 0) {
        const g = l.value.findIndex((v) => v.id === c);
        l.value[g] = { id: c, selected: m };
      } else
        l.value = l.value.filter((g) => g.id !== c);
      o("update:modelValue", l.value), r.value = "";
    };
    return $0(() => {
      l.value = t.modelValue || [], t.filter.forEach((c) => {
        a[c.id] = {};
        const h = l.value.find((m) => m.id === c.id);
        c.options.forEach((m) => {
          m.items.forEach((g) => {
            a[c.id][g.value] = h ? h.selected.includes(g.value) : !1;
          });
        });
      });
    }), (c, h) => (_(), P("div", NS, [
      (_(!0), P(me, null, Fe(l.value, (m, g) => (_(), ie(I(ji), {
        key: m.id,
        "onUpdate:open": (v) => {
          v || f(m.id);
        }
      }, {
        default: J(() => [
          ce(I(Hi), { asChild: "" }, {
            default: J(() => {
              var v;
              return [
                ce(Fr, {
                  state: "scdr",
                  icon: (v = c.filter.find((p) => p.id === m.id)) == null ? void 0 : v.icon,
                  iconPosition: "left"
                }, {
                  default: J(() => {
                    var p, y, C;
                    return [
                      Ie(de((p = c.filter.find((b) => b.id === m.id)) == null ? void 0 : p.name) + " " + de(c.text.is) + " ", 1),
                      M("span", FS, de(m.selected.length) + " " + de(m.selected.length > 1 ? (y = c.filter.find((b) => b.id === m.id)) == null ? void 0 : y.text.plural : (C = c.filter.find((b) => b.id === m.id)) == null ? void 0 : C.text.singular), 1)
                    ];
                  }),
                  _: 2
                }, 1032, ["icon"]),
                l.value.length > 1 && g !== l.value.length - 1 ? (_(), P("p", RS, de(c.text.and), 1)) : z("", !0)
              ];
            }),
            _: 2
          }, 1024),
          ce(I(zi), null, {
            default: J(() => [
              ce(I(qi), {
                side: "bottom",
                "side-offset": 4,
                align: "end",
                class: pe("rounded-[5px] w-full border border-border-subtle bg-white shadow-lg data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade overflow-hidden py-0")
              }, {
                default: J(() => {
                  var v, p, y;
                  return [
                    M("div", null, [
                      (v = c.filter.find((C) => C.id === m.id)) != null && v.searchable ? (_(), P("input", {
                        key: 0,
                        placeholder: (p = c.filter.find((C) => C.id === m.id)) == null ? void 0 : p.name,
                        type: "text",
                        class: "h-9 border-b border-border-subtle w-full px-3 text-mgm-txt-sm outline-none",
                        onInput: h[0] || (h[0] = (C) => {
                          r.value = C.target.value, u(r.value);
                        })
                      }, null, 40, BS)) : z("", !0),
                      M("div", VS, [
                        (_(!0), P(me, null, Fe((y = c.filter.find(
                          (C) => C.id === m.id
                        )) == null ? void 0 : y.options, (C, b) => {
                          var x;
                          return _(), P("div", {
                            key: b + "-title"
                          }, [
                            (x = c.filter.find((w) => w.id === m.id)) != null && x.groupable && r.value === "" ? (_(), P("span", jS, de(C.title), 1)) : z("", !0),
                            M("div", HS, [
                              (_(!0), P(me, null, Fe(r.value === "" ? C.items : u(r.value), (w) => (_(), P("div", {
                                key: w.value + w.label
                              }, [
                                ce(Ei, {
                                  modelValue: a[c.filter.find(($) => $.id === m.id).id][w.value],
                                  "onUpdate:modelValue": ($) => a[c.filter.find((E) => E.id === m.id).id][w.value] = $,
                                  id: w.value,
                                  label: "",
                                  value: w.value,
                                  name: w.label
                                }, {
                                  default: J(() => [
                                    M("p", zS, [
                                      Ie(de(w.label) + " ", 1),
                                      w.count ? (_(), P("span", qS, "(" + de(w.count) + ")", 1)) : z("", !0)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "id", "value", "name"])
                              ]))), 128)),
                              r.value !== "" && u(r.value).length === 0 ? (_(), P("p", US, de(c.text.noResult), 1)) : z("", !0)
                            ])
                          ]);
                        }), 128))
                      ])
                    ])
                  ];
                }),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["onUpdate:open"]))), 128)),
      c.filter.filter((m) => !l.value.find((g) => g.id === m.id)).length > 0 ? (_(), ie(I(ji), {
        key: 0,
        "onUpdate:open": h[2] || (h[2] = (m) => {
          m || d();
        })
      }, {
        default: J(() => [
          ce(I(Hi), { asChild: "" }, {
            default: J(() => [
              ce(Fr, {
                state: "trtr",
                icon: "plus",
                iconPosition: "right"
              }, {
                default: J(() => [
                  Ie(de(c.text.trigger), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          ce(I(zi), null, {
            default: J(() => [
              ce(I(qi), {
                side: "bottom",
                "side-offset": 4,
                align: "start",
                class: pe(`rounded-[5px] w-full border border-border-subtle bg-white shadow-lg data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade overflow-hidden ${i.value ? "py-0" : "py-1"}`)
              }, {
                default: J(() => [
                  i.value ? z("", !0) : (_(), P("div", WS, [
                    (_(!0), P(me, null, Fe(c.filter.filter((m) => !l.value.find((g) => g.id === m.id)).map((m) => ({
                      name: m.name,
                      type: "normal",
                      icon: m.icon,
                      onClick: () => {
                        i.value = m.id;
                      }
                    })), (m) => (_(), P("div", {
                      key: m.name + m.icon
                    }, [
                      M("button", {
                        class: pe("h-9 px-3 w-full text-sm font-medium flex items-center gap-2 hover:bg-background-subtle transition-colors duration-150"),
                        onClick: m.onClick
                      }, [
                        m.icon ? (_(), ie(Le, {
                          key: 0,
                          icon: m.icon,
                          color: "#5F6C85"
                        }, null, 8, ["icon"])) : z("", !0),
                        Ie(" " + de(m.name), 1)
                      ], 8, KS)
                    ]))), 128))
                  ])),
                  i.value && s.value ? (_(), P("div", YS, [
                    s.value.searchable ? (_(), P("input", {
                      key: 0,
                      placeholder: s.value.name,
                      type: "text",
                      class: "h-9 border-b border-border-subtle w-full px-3 text-mgm-txt-sm outline-none",
                      onInput: h[1] || (h[1] = (m) => {
                        r.value = m.target.value, u(r.value);
                      })
                    }, null, 40, GS)) : z("", !0),
                    M("div", ZS, [
                      (_(!0), P(me, null, Fe(s.value.options, (m, g) => (_(), P("div", {
                        key: g + "title-2"
                      }, [
                        s.value.groupable && r.value === "" ? (_(), P("span", XS, de(m.title), 1)) : z("", !0),
                        M("div", JS, [
                          (_(!0), P(me, null, Fe(r.value === "" ? m.items : u(r.value), (v) => (_(), P("div", {
                            key: v.value + v.label
                          }, [
                            ce(Ei, {
                              modelValue: a[s.value.id][v.value],
                              "onUpdate:modelValue": (p) => a[s.value.id][v.value] = p,
                              id: v.value,
                              label: "",
                              value: v.value,
                              name: v.label
                            }, {
                              default: J(() => [
                                M("p", QS, [
                                  Ie(de(v.label) + " ", 1),
                                  v.count ? (_(), P("span", eA, "(" + de(v.count) + ")", 1)) : z("", !0)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "id", "value", "name"])
                          ]))), 128)),
                          r.value !== "" && u(r.value).length === 0 ? (_(), P("p", tA, " No result ")) : z("", !0)
                        ])
                      ]))), 128))
                    ])
                  ])) : z("", !0)
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : z("", !0)
    ]));
  }
}), nA = { class: "flex items-center gap-4" }, iT = /* @__PURE__ */ re({
  __name: "ReviewCount",
  props: {
    rating: {},
    text: {},
    color: {}
  },
  setup(e) {
    return (n, t) => (_(), P("div", nA, [
      M("p", {
        class: pe(`text-mgm-dspl-md font-semibold ${n.color === "light" ? "text-foreground-on-emphasis" : "text-foreground-emphasis"}`)
      }, de(n.rating), 3),
      M("div", null, [
        ce(Uh, { rating: n.rating }, null, 8, ["rating"]),
        M("p", {
          class: pe(`text-mgm-txt-sm ${n.color === "light" ? "text-foreground-on-emphasis" : "text-foreground-default"}`)
        }, de(n.text), 3)
      ])
    ]));
  }
}), oA = (e) => (ua("data-v-da52cb10"), e = e(), da(), e), iA = {
  key: 0,
  class: "mb-1.5"
}, rA = {
  key: 0,
  class: "flex items-start"
}, aA = {
  key: 0,
  class: "absolute bottom-0 left-0 top-0 flex h-full items-center"
}, lA = ["src"], sA = { class: "font-regular" }, uA = /* @__PURE__ */ oA(() => /* @__PURE__ */ M("span", { class: "font-regular text-foreground-subtle" }, "Create", -1)), dA = {
  key: 2,
  class: "inline-flex items-center rounded-r-[4.16px] border border-l-0 border-border-default bg-background-subtle-hover px-3 text-foreground-default shadow-sm sm:text-mgm-txt-sm"
}, Wh = /* @__PURE__ */ re({
  __name: "FieldTagInput",
  props: {
    options: { default: () => [] },
    modelValue: { default: () => [] },
    role: { default: "default" },
    id: {},
    locale: { default: "en" },
    label: {},
    description: {},
    placeholder: {},
    autocomplete: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    validation: { default: null },
    validationDisabled: { type: Boolean, default: !1 },
    errorMessage: {},
    customColor: {},
    customRgbColor: {},
    icon: {},
    customIcon: {},
    suffix: {},
    noRoundedBottom: { type: Boolean }
  },
  emits: [
    "blur",
    "change",
    "focus",
    "submit",
    "update:modelValue"
  ],
  setup(e, { emit: n }) {
    const t = e;
    Cn();
    const o = X(), i = X(!1), r = X(!1), a = X(""), l = X([]), s = n, u = (c) => {
      const h = c.target;
      setTimeout(() => {
        r.value = !1;
      }, 100), l.value.length === 0 && (i.value = !1), s("blur", h.value, t.id);
    }, d = (c) => {
      const h = c.target;
      i.value = !0, r.value = !0, s("focus", h.value, t.id);
    }, f = () => {
      s("update:modelValue", "", t.id);
    };
    return Ne(
      l,
      () => {
        a.value = "", s("change", l.value, t.id), s("update:modelValue", l.value, t.id);
      },
      { deep: !0 }
    ), (c, h) => {
      var m, g, v, p, y, C, b;
      return _(), P("div", {
        ref_key: "root",
        ref: o
      }, [
        c.label || c.description ? (_(), P("div", iA, [
          c.label ? (_(), P("div", rA, [
            ce(Re, {
              id: `${c.id}`,
              label: c.label
            }, null, 8, ["id", "label"]),
            c.required ? (_(), P("span", {
              key: 0,
              class: pe([
                "ml-1 text-mgm-txt-sm font-medium",
                { "text-foreground-brand-default": !c.customColor }
              ]),
              style: Ye({ color: c.customColor })
            }, " * ", 6)) : z("", !0)
          ])) : z("", !0),
          c.description ? (_(), ie(Re, {
            key: 1,
            label: c.description,
            description: ""
          }, null, 8, ["label"])) : z("", !0)
        ])) : z("", !0),
        M("div", {
          class: pe([
            "box-border min-h-[40px] w-full rounded-[4.16px] py-[9px] text-mgm-txt-sm font-normal text-foreground-emphasis shadow-[0px_1px_2px_rgba(28,31,39,0.05)] outline-0 placeholder:text-foreground-subtle flex gap-2 items-center",
            c.disabled ? "bg-[rgba(239,239,239,0.3)]" : "",
            (g = (m = c.validation) == null ? void 0 : m.$errors) != null && g.length ? "border-[0.68px] border-border-danger-emphasis focus:border-border-danger-emphasis focus:shadow-[0px_1px_2px_rgba(28,31,39,0.05)] focus:ring-border-danger-emphasis" : "border-[0.83px] border-border-default",
            c.customIcon || c.icon ? "px-10" : "px-2.5",
            c.customIcon || c.role === "search" || c.icon ? "pl-10" : "pl-2.5",
            c.customIcon || c.icon ? "py-2 pr-10" : "py-2 pr-2.5",
            i.value ? "!border-border-brand-emphasis !shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE]" : "",
            {
              "focus:border-border-brand-emphasis focus:shadow-[0px_1px_2px_rgba(16,24,40,0.05),0px_0px_0px_2px_#C7D7FE] focus:ring-border-brand-emphasis": !c.customColor && !((p = (v = c.validation) == null ? void 0 : v.$errors) != null && p.length),
              "!rounded-l-none": c.role === "link",
              "!rounded-r-none": c.suffix,
              "!rounded-b-none": c.noRoundedBottom,
              invisible: c.role === "color-picker"
            }
          ])
        }, [
          c.customIcon ? (_(), P("div", aA, [
            M("img", {
              class: "ml-3 h-5 w-5",
              src: c.customIcon,
              alt: ""
            }, null, 8, lA)
          ])) : z("", !0),
          ce(I(HE), {
            modelValue: l.value,
            "onUpdate:modelValue": h[1] || (h[1] = (x) => l.value = x),
            "search-term": a.value,
            "onUpdate:searchTerm": h[2] || (h[2] = (x) => a.value = x),
            disabled: c.disabled,
            multiple: "",
            class: "mx-auto relative w-full",
            filterFunction: (x, w) => [...x.filter(
              (E) => E.toLowerCase().includes(w.toLowerCase())
            ), w]
          }, {
            default: J(() => [
              ce(I(UE), { class: "w-full" }, {
                default: J(() => [
                  ce(I(qE), { class: "w-full inline-flex items-center justify-between leading-none gap-[5px] hover:bg-mauve3 focus:shadow-black outline-none" }, {
                    default: J(() => [
                      ce(I(vM), {
                        "model-value": l.value,
                        class: "flex gap-2 items-center rounded-lg flex-wrap w-full",
                        "add-on-paste": "",
                        delimiter: ","
                      }, {
                        default: J(({ modelValue: x }) => [
                          (_(!0), P(me, null, Fe(x, (w) => (_(), ie(I(CM), {
                            key: w,
                            value: w,
                            class: "flex items-center justify-center gap-2 text-foreground-default rounded-full px-1.5 bg-background-subtle text-mgm-txt-xs"
                          }, {
                            default: J(() => [
                              ce(I(xM), { class: "text-sm" }),
                              ce(I(wM), null, {
                                default: J(() => [
                                  ce(Le, {
                                    icon: "close",
                                    class: "w-3"
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["value"]))), 128)),
                          ce(I(zE), {
                            "as-child": "",
                            class: "flex-1"
                          }, {
                            default: J(() => [
                              ce(I(bM), {
                                placeholder: c.placeholder,
                                class: pe(`w-full outline-none ${c.disabled ? "bg-transparent" : ""}`),
                                onKeydown: h[0] || (h[0] = pn(Yn(() => {
                                }, ["prevent"]), ["enter"])),
                                onBlur: u,
                                onFocus: d
                              }, null, 8, ["placeholder", "class"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model-value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              ce(I(XE), {
                class: pe("combobox-content absolute z-10 bg-white w-[calc(100%_+_20px)] -ml-2 mt-4 border border-border-subtle rounded-[5px] shadow-lg overflow-hidden")
              }, {
                default: J(() => [
                  ce(I(eM), null, {
                    default: J(() => [
                      ce(I(JE), { class: "text-gray-400 text-xs font-medium text-center py-2" }, {
                        default: J(() => [
                          Ie(" No options available ")
                        ]),
                        _: 1
                      }),
                      ce(I(YE), null, {
                        default: J(() => [
                          (_(!0), P(me, null, Fe(c.options, (x, w) => (_(), ie(I(Jc), {
                            key: w,
                            class: "flex h-9 items-center px-3 font-medium text-foreground-emphasis cursor-pointer hover:bg-foreground-brand-default hover:text-white data-[state=checked]:bg-background-subtle data-[state=checked]:hover:text-foreground-emphasis",
                            value: x
                          }, {
                            default: J(() => [
                              M("span", null, de(x), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))), 128)),
                          a.value.length ? (_(), ie(I(Jc), {
                            key: 0,
                            class: "flex h-9 items-center px-3 font-medium text-foreground-emphasis cursor-pointer hover:bg-foreground-brand-default hover:text-white data-[state=checked]:bg-background-subtle data-[state=checked]:hover:text-foreground-emphasis",
                            value: a.value
                          }, {
                            default: J(() => [
                              M("span", sA, [
                                uA,
                                Ie(" " + de(a.value), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["value"])) : z("", !0)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _: 1
          }, 8, ["modelValue", "search-term", "disabled", "filterFunction"]),
          c.role === "search" && i.value && ((y = c.modelValue) == null ? void 0 : y.length) > 0 ? (_(), ie(Le, {
            key: 1,
            class: "absolute bottom-0 right-4 top-0",
            color: "#444CE7",
            icon: "close",
            onClick: h[3] || (h[3] = (x) => f())
          })) : z("", !0),
          c.suffix ? (_(), P("span", dA, de(c.suffix), 1)) : z("", !0)
        ], 2),
        (c.validation && ((C = c.validation.$errors) == null ? void 0 : C.length) > 0 || c.errorMessage) && !c.validationDisabled ? (_(), ie(Re, {
          key: 1,
          class: "mt-[3px]",
          label: ((b = c.validation.$errors[0]) == null ? void 0 : b.$message) || c.errorMessage,
          error: ""
        }, null, 8, ["label"])) : z("", !0)
      ], 512);
    };
  }
});
function Qc(e) {
  const n = e;
  n.__i18n = n.__i18n || [], n.__i18n.push({
    locale: "",
    resource: {
      en: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Pick a color"]);
        }
      },
      fr: {
        color: (t) => {
          const { normalize: o } = t;
          return o(["Choisir une couleur"]);
        }
      }
    }
  });
}
typeof Qc == "function" && Qc(Wh);
const rT = /* @__PURE__ */ no(Wh, [["__scopeId", "data-v-da52cb10"]]), cA = ["placeholder"], fA = {
  key: 0,
  class: "p-3 grid grid-cols-1 gap-3 max-h-[40dvh] overflow-y-auto"
}, hA = ["for"], gA = { class: "text-foreground-default" }, mA = /* @__PURE__ */ re({
  __name: "AddTag",
  props: {
    open: { type: Boolean },
    tags: {},
    placeholder: {},
    createText: {}
  },
  emits: ["openChange", "tagChange", "tagCreate"],
  setup(e, { emit: n }) {
    const t = e, o = n, i = X(t.open || !1), r = X(""), a = ee(() => t.tags.filter(
      (u) => u.title.toLowerCase().includes(r.value.toLowerCase())
    )), l = (u, d) => {
      const f = t.tags.find((c) => c.id === u);
      f && (f.selected = d, o("tagChange", f));
    }, s = () => {
      o("tagCreate", r.value), i.value = !1;
    };
    return (u, d) => (_(), ie(I(ji), {
      open: i.value,
      "onUpdate:open": d[1] || (d[1] = (f) => {
        u.$emit("openChange", f), i.value = f;
      })
    }, {
      default: J(() => [
        ce(I(Hi), { asChild: "" }, {
          default: J(() => [
            be(u.$slots, "trigger", {}, void 0, !0)
          ]),
          _: 3
        }),
        ce(I(zi), null, {
          default: J(() => [
            ce(I(qi), {
              "side-offset": 4,
              "collision-padding": 8,
              class: "rounded outline-none border border-border-default bg-white shadow-lg data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=bottom]:animate-slideUpAndFade data-[state=open]:data-[side=left]:animate-slideRightAndFade w-[240px]"
            }, {
              default: J(() => [
                po(M("input", {
                  "onUpdate:modelValue": d[0] || (d[0] = (f) => r.value = f),
                  type: "text",
                  placeholder: t.placeholder || "Search tags...",
                  class: "h-10 rounded-t border-b border-border-subtle focus:border focus:border-border-brand-emphasis focus:ring-2 focus:ring-background-brand-default-hover outline-none text-mgm-txt-sm px-3 w-full transition-all duration-200",
                  onKeydown: pn(s, ["enter"])
                }, null, 40, cA), [
                  [k0, r.value]
                ]),
                a.value.length ? (_(), P("div", fA, [
                  (_(!0), P(me, null, Fe(a.value, (f) => (_(), P("div", {
                    key: f.id,
                    class: "flex items-center gap-0"
                  }, [
                    ce(Ei, {
                      id: f.id,
                      "model-value": f.selected || !1,
                      onChange: (c) => l(f.id, c)
                    }, null, 8, ["id", "model-value", "onChange"]),
                    M("label", {
                      for: f.id.toString(),
                      class: "text-mgm-txt-sm font-medium text-foreground-emphasis"
                    }, de(f.title), 9, hA)
                  ]))), 128))
                ])) : z("", !0),
                r.value.length ? (_(), P("button", {
                  key: 1,
                  onClick: s,
                  class: "h-10 border-t border-border-subtle w-full px-3 text-left text-mgm-txt-sm font-medium text-foreground-emphasis truncate"
                }, [
                  M("span", gA, de(u.createText), 1),
                  Ie(" " + de(r.value), 1)
                ])) : z("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["open"]));
  }
});
const aT = /* @__PURE__ */ no(mA, [["__scopeId", "data-v-69c0c255"]]);
export {
  aT as AddTag,
  FA as BarChart,
  bA as BaseAlert,
  yA as BaseAvatar,
  pl as BaseBadge,
  CA as BaseBreadcrumb,
  Fr as BaseButton,
  xA as BaseCard,
  wA as BaseEmptyState,
  $A as BaseHorizontalBarChart,
  Le as BaseIcon,
  kA as BaseLoader,
  _A as BasePieChart,
  OA as BaseProgressRing,
  eT as CopyUrl,
  EA as FieldAvatarUploader,
  Ei as FieldCheckbox,
  MA as FieldDatePicker,
  SA as FieldEditor,
  AA as FieldFileUploader,
  F1 as FieldInput,
  Re as FieldLabel,
  db as FieldPhoneNumber,
  TA as FieldRadio,
  PA as FieldRating,
  ky as FieldSearch,
  IA as FieldSelect,
  Dy as FieldSelector,
  DA as FieldTabs,
  rT as FieldTagInput,
  Vy as FieldTextarea,
  LA as FieldToggle,
  oT as Filter,
  ZA as IntegrationCard,
  GA as Modal,
  QA as Pagination,
  VA as PieChart,
  tT as PopoverFilter,
  DM as PopoverMenu,
  jA as ProgressArc,
  HA as ProgressBar,
  zA as ProgressGradient,
  XA as ReviewCard,
  iT as ReviewCount,
  JA as ReviewLine,
  nT as SimpleTable,
  Uh as Stars,
  QM as StarsSelector,
  qA as TextAccordion
};
